/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dashboard/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 926);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var core = __webpack_require__(48);
var hide = __webpack_require__(35);
var redefine = __webpack_require__(36);
var ctx = __webpack_require__(49);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

module.exports = __webpack_require__(99);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flux = __webpack_require__(14);

var dispatcher = new _flux.Dispatcher();
window.dispatcher = dispatcher;

exports.default = dispatcher;

/***/ },
/* 3 */
/***/ function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target, parent) {
  if (parent){
    return parent.querySelector(target);
  }
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target, parent) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target, parent);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(921);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertAt.before, target);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	if(options.attrs.nonce === undefined) {
		var nonce = getNonce();
		if (nonce) {
			options.attrs.nonce = nonce;
		}
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function getNonce() {
	if (typeof __webpack_nonce__ === 'undefined') {
		return null;
	}

	return __webpack_nonce__;
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ },
/* 5 */
/***/ function(module, exports) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	DATA_TYPE_54ac0f62f556ea16b4a31fd3: "Temperature",
	DATA_TYPE_56ae4600a9052b2d26abb364: "Engine coolant temperature",
	DATA_TYPE_56ae460ea9052b2d26abb365: "Ambient temperature",
	DATA_TYPE_54ac0f62f556ea16b4a31fd4: "Position",
	DATA_TYPE_54ac0f62f556ea16b4a31fd5: "Max Speed",
	DATA_TYPE_5575710b084bdd983f1fc776: "Average Speed",
	DATA_TYPE_54ac0f62f556ea16b4a31fd6: "RPM",
	DATA_TYPE_54ac0f62f556ea16b4a31fd7: "Main Battery",
	DATA_TYPE_54ac0f62f556ea16b4a31fd8: "Backup Battery",
	DATA_TYPE_54ac0f62f556ea16b4a31fda: "Mobile Network Code",
	DATA_TYPE_54ac0f62f556ea16b4a31fdb: "GSM signal",
	DATA_TYPE_54ac0f62f556ea16b4a31fdc: "ODO",
	DATA_TYPE_54ac0f62f556ea16b4a31fde: "Total hours of operation",
	DATA_TYPE_54ac0f62f556ea16b4a31fdf: "Fuel Level",
	DATA_TYPE_54ac0f62f556ea16b4a31fe0: "Total use of fuel",
	DATA_TYPE_54ac0f63f556ea16b4a31fe1: "Number of Axles",
	DATA_TYPE_54ac0f63f556ea16b4a31fe2: "Engine Load",
	DATA_TYPE_54ac0f63f556ea16b4a31fe3: "Accelerator Pedal Position",
	DATA_TYPE_54ac0f63f556ea16b4a31fe4: "Brake Force",
	DATA_TYPE_54ac0f63f556ea16b4a31fe5: "Fuel Consumption",
	DATA_TYPE_54cd8595dd975aff54a3f1b9: "Ignition",

	MONTH_0: "January",
	MONTH_1: "February",
	MONTH_2: "March",
	MONTH_3: "April",
	MONTH_4: "May",
	MONTH_5: "June",
	MONTH_6: "July",
	MONTH_7: "August",
	MONTH_8: "September",
	MONTH_9: "October",
	MONTH_10: "November",
	MONTH_11: "December",

	DASHBOARD: "Dashboard",
	SEAGAL: "Seagal",
	NAME: "Name",
	PLATE_NUMBER: "Plate number",
	VIN: "Vehicle Identification Number",
	MAKE: "Make",
	YEAR_OF_PRODUCTION: "Year of production",
	WEIGHT: "Weight",
	HEIGHT: "Height",
	LENGTH: "Length",
	WIDTH: "Width",
	COLOR: "Color",
	AXLE_NUMBER: "Number of axles",
	VOLTAGE: "Voltage",
	TIME: "Time",
	VOLUME: "Volume",
	ADDRESS: "Address",
	DISTANCE_TRAVELLED: "Distance travelled",
	TRAVEL_TIME: "Travel time",
	TOTAL_VEHICLE_DISTANCE: "ODO",
	START_TOTAL_VEHICLE_DISTANCE: "Start ODO",
	END_TOTAL_VEHICLE_DISTANCE: "End ODO",
	AVERAGE_SPEED: "Average speed",
	MAXIMUM_SPEED: "Maximum speed",
	START_TIME: "Start time",
	END_TIME: "End time",
	START_ADDRESS: "Start address",
	END_ADDRESS: "End address",
	ALL: "All",

	GETADDRESS: "Get address",
	IGNITION_ON: "Ignition ON",
	IGNITION_OFF: "Ignition OFF",
	MOVING: "Moving",
	LOGOUT: "Logout",
	LOGIN: "Login",
	RETRY: "Retry",
	SAVE: "Save",
	_SEARCH: "search",
	_USERNAME: "username",
	_PASSWORD: "password",
	NOTHING_FOUND: "Nothing found",
	BAD_REQUEST_DATA: "Bad request data",
	WRONG_USER_OR_PASSWORD: "Username / Password is incorrect",
	SOMETHING_WRONG: "Something wrong",
	PROPERTIES_UPDATED: "Properties successfully updated",
	GETTING_APPLICATION_DATA: "Getting application data",
	GETTING_VEHICLES: "Getting vehicles",
	ERROR_VIA_GETTING_DATA: "Oops, error via getting data",
	SETTINGS: "Settings",
	PROPERTIES: "Properties",
	REPORTS: "Reports",
	ACTIVITY: "Activity",
	SHARE: "Share",
	USER: "User",
	PRIVILEGE: "Privilege",
	HEATMAP: "Heatmap",
	TIME_BASED: "Time based",
	ROUTE_BASED: "Route based",
	OPERATION_FAILED: "Operation failed",
	SUCCESFUL_OPERATION: "Succesful operation",
	INVALID_FORMAT: "Invalid format",
	FROM: "From",
	TO: "To",
	TOO_LONG_INTERVAL: "Too long interval",
	SUBMIT: "Submit",
	EXPORT: "Export",
	CANCEL: "Cancel",
	CREATE: "Create",
	NO_RESULTS_FOUND: "No results found",
	UNKNOWN: "Unknown",
	DEPARTURE: "Departure",
	ARRIVAL: "Arrival",
	EN_ROUTE: "En route",
	MAP: "Map",
	USERS: "Users",
	AUTOZOOM: "Autozoom",
	TRAFFIC: "Traffic",
	RADIAL: "Radial",
	POLYGONAL: "Polygonal",
	ROUTES: "Routes",
	STOPS: "Stops",
	SECTION: "Section",
	POI_CROSSINGS: "POI crossings",
	TIMELINE: "Timeline",
	STAYS: "Stays",
	SUMMARIES: "Summaries",
	SUMMARY: "Summary",
	SUMMARY_FOR: "Summary for",
	POIS: "POIs",

	//VehicleReports
	EXPORTASPDF: "Export as PDF",
	EXPORTASHTML: "Export as HTML",
	EXPORTASCSV: "Export as CSV",

	NUMBER_OF_STARTS: "Number of starts",
	NUMBER_OF_STOPS: "Number of stops",
	NUMBER_OF_ARRIVALS: "Number of enter",
	NUMBER_OF_DEPARTURES: "Number of exit",
	IGNITION_TIME: "Ignition time",
	NON_IGNITION_TIME: "Non-ignition time",
	NUMBER_OF_SECTIONS: "Number of sections",
	STAY_TIME: "Stay time",
	DISTANCE_TRAVELED_WITHIN_POI: "Distance traveled within POI",
	SPEED: "Speed",
	STILL_IN_POI: "Still in POI",
	ALREADY_IN_POI: "Already in POI",
	SUM: "Sum",
	MIN: "Min",
	MAX: "Max",
	AVG: "Avg",

	NOW: "Now",
	DONE: "Done",

	PRIVILEGE_ERROR_DASHBOARD: "You do not have dashboard access",

	CREATE_POI: "Create POI",
	CREATE_POI_DIALOG_TITLE: "Create new POI",
	SHAPE: "Shape",
	CIRCLE_SHAPE: "Circle shape",
	POLYGON_SHAPE: "Polygon shape",
	EDIT_SHAPE: "Edit shape",
	RESTORE_SHAPE: "Restore shape",
	DISCARD: "Discard",
	OK: "Ok",
	DELETE: "Delete",
	ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_POI: "Are you sure you want to delete this POI",

	GETTING_COLLABORATORS: "Getting collaborators",
	ADD_COLLABORATOR: "Add collaborator",
	SHARE_POI: "Share POI",
	SHARE_WITH: "Share with",
	COLLABORATOR: "Collaborator",
	COLLABORATORS: "Collaborators",
	_GROUP: "group",

	CAN_VIEW: "Can view",
	CAN_SHARE: "Can share",
	CAN_EDIT: "Can edit",
	CAN_DELETE: "Can delete",

	YOU_CANNOT_REMOVE_COLLABORATOR: "You cannot remove collaborator",
	YOU_CANNOT_CHANGE_PRIVILEGE: "You cannot change privilege",
	DO_YOU_WANT_TO_SAVE_CHANGES: "Do you want to save changes?",
	YES: "Yes",
	NO: "No",

	_HOST_URL: "host url",
	SELECT_HOST: "Select host",
	CHECKING_INTERNET_CONNECTION: "Checking internet connection",

	CONSOLE: "Console",
	CONFIG: "Config",
	CARRIERS: "Carriers",
	GETTING_DEVICES: "Getting devices",
	PRIMARY: "PRIMARY",
	CLIENT_ACCESS: "CLIENT ACCESS",
	LOCAL: "LOCAL",
	REMOTE: "REMOTE",
	CONNECTING: "Connecting",
	SHOW_USER_INPUT: "Show user input",
	HIDE_USER_INPUT: "Hide user input",
	WORD_WRAP_ON: "Word wrap on",
	WORD_WRAP_OFF: "Word wrap off",
	SNAP_TO_END: "Snap to end",
	FIRMWARE_UPGRADE: "Firmware upgrade",
	FROM_FILE: "From file",
	BURN: "Burn",
	START: "Start",
	STOP: "Stop",
	CONTINUE: "Continue",
	CHECK: "Check",
	VERSION: "Version",
	SOURCE: "Source",
	BROWSE: "Browse",
	CURRENT_VERSION: "Current version",
	UPLOADED_VERSION: "Uploaded version",
	ERROR_INCOMPATIBLE_FILE: "ERROR: Incompatible file!",
	LOADING: "Loading",
	UPLOADING: "Uploading",
	LOADED: "Loaded",
	PARSING: "Parsing",
	INITIALIZATION_FAILED: "Initialization failed",
	STATE: "State",
	CHOOSE_CONFIG_TEMPLATE: "Choose config template!",
	CONFIG_UPDATE_FAILED: "Config update failed",
	ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_CONFIG: "Are you sure you want to remove this config?",
	RELOAD: "Reload",
	ENTITIES: "Entities",
	ENTITY_UPDATE_FAILED: "Entity update failed",
	ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_ENTITY: "Are you sure you want to remove this entity?",
	CHOOSE_ENTITY_TEMPLATE: "Choose entity template!",

	ADD_CARRIER: "Add carrier",
	CARRIER: "Carrier",
	PLACEMENT: "Placement",
	INTERVAL: "Interval",
	ARE_YOU_SURE_YOU_WANT_TO_UNBIND_CARRIER: "Are your sure you want to unbind this carrier",
	ADD: "Add",
	INPUTS: "Inputs",
	TYPE: "Type",
	CDID: "CDID",
	CREATED: "Created",
	HARDWARE_REVISION: "Hardware revision",
	FIRMWARE_VERSION: "Firmware version",
	PROTOCOL_TYPE: "Protocol type",

	INVALID_INTERVAL: "Invalid interval",
	CLICK_HERE_TO_FIX_IT: "Click here to fix it",
	PASSWORD: "Password",
	CONTACTS: "Contacts",
	NOTIFICATIONS: "Notifications",
	OLD_PASSWORD: "Old password",
	NEW_PASSWORD: "New password",
	CONFIRM_NEW_PASSWORD: "Confirm new password",
	CONFIRM_PASSWORD_ERROR_MESSAGE: "Error: Password mismatch!",
	EVERY_FIELD_IS_REQUIRED: "Every field is required",
	CHANGE_PASSWORD_SUCCESSFUL: "Password successfully changed",
	FNAME: "First Name",
	LNAME: "Last Name",
	EMAIL: "Email",
	PHONE: "Phone",
	WEB: "Web",
	TEXT_MESSAGE: "Text message",
	POI_CROSSING_NOTIFICATIONS: "POI crossing notifications",
	CRITICAL_VALUE_NOTIFICATIONS: "Critical value notifications",
	VEHICLES: "Vehicles",
	SEND_NOTIFICATIONS_VIA: "Send notifications via",
	SEND_NOTIFICATIONS_AT: "Send notifications at",
	SET_NOTIFICATION: "Set notification",
	ADD_NOTIFICATION_SETUP: "Add notification setup",
	DEPARTING: "Departing",
	ARRIVING: "Arriving",
	YOUR_MODIFICATIONS_WILL_TAKE_EFFECT_WITHIN_ONE_HOUR: "Your modifications will take effect within one hour",
	INVALID_CONFIGURATION: "Invalid configuration",
	CONDITION: "Condition",
	SEND_NOTIFICATION_IF_THE_CONDITION_IS_FULFILLED_FOR: "Send notification if the condition is fulfilled for",
	_BETWEEN: "between",
	_NOT_BETWEEN: "not between",
	_AND: "and",

	_SECOND: "second",
	_SECONDS: "seconds",
	_MINUTE: "minute",
	_MINUTES: "minutes",
	_HOUR: "hour",
	_HOURS: "hours",

	_OR_SELECT_ONE_BY_ONE: "or select one by one",
	SELECT_POIS: "Select pois",
	CHANGE_PASSWORD: "Change password",
	SET_CONTACTS: "Set contacts"
};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ },
/* 9 */
/***/ function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__(311);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Button2.default;

/***/ },
/* 11 */
/***/ function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Toast = __webpack_require__(342);

var _Toast2 = _interopRequireDefault(_Toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Toast2.default;

/***/ },
/* 13 */
/***/ function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.types = exports.Collection = exports.Singleton = exports.Dispatcher = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Dispatcher = __webpack_require__(344);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _Singleton = __webpack_require__(345);

var _Singleton2 = _interopRequireDefault(_Singleton);

var _Collection = __webpack_require__(343);

var _Collection2 = _interopRequireDefault(_Collection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Dispatcher = _Dispatcher2.default;
exports.Singleton = _Singleton2.default;
exports.Collection = _Collection2.default;
var types = exports.types = {
	Dispatcher: _react2.default.PropTypes.instanceOf(_Dispatcher2.default),
	Singleton: _react2.default.PropTypes.instanceOf(_Singleton2.default),
	Collection: _react2.default.PropTypes.instanceOf(_Collection2.default)
};

exports.default = { Dispatcher: _Dispatcher2.default, Singleton: _Singleton2.default, Collection: _Collection2.default, types: types };

/***/ },
/* 15 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
'use strict';

/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _querystring = __webpack_require__(275);

var _querystring2 = _interopRequireDefault(_querystring);

var _token = __webpack_require__(118);

var _token2 = _interopRequireDefault(_token);

var _host = __webpack_require__(209);

var _host2 = _interopRequireDefault(_host);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function call(method, endpoint) {
	var send = function () {
		var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(host) {
			var token;
			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:

							//host = "https://"+host+"/api/";
							host = "/api/";

							if (method.toUpperCase() == 'GET') {
								xhr.open(method, host + endpoint + (data ? "?" + _querystring2.default.stringify(data) : ""));
							} else {
								xhr.open(method, host + endpoint);
							}

							xhr.setRequestHeader("Content-type", "application/json");

							_context.next = 5;
							return _token2.default.get();

						case 5:
							token = _context.sent;


							if (token) {
								xhr.setRequestHeader("token", token);
							}

							if (method.toUpperCase() == 'GET') {
								xhr.send();
							} else {
								xhr.send(data ? JSON.stringify(data) : null);
							}

						case 8:
						case "end":
							return _context.stop();
					}
				}
			}, _callee, this);
		}));

		return function send(_x) {
			return _ref.apply(this, arguments);
		};
	}();

	var sendByHost = function () {
		var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							if (!host) {
								_context2.next = 4;
								break;
							}

							send(host);
							_context2.next = 8;
							break;

						case 4:
							_context2.next = 6;
							return _host2.default.get();

						case 6:
							host = _context2.sent;

							if (host) send(host);else send(window.location.host);

						case 8:
						case "end":
							return _context2.stop();
					}
				}
			}, _callee2, this);
		}));

		return function sendByHost() {
			return _ref2.apply(this, arguments);
		};
	}();

	var host = "";
	var data = null;
	var timeout = null;
	var callback = function callback(error, response) {};

	for (var _len = arguments.length, options = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
		options[_key - 2] = arguments[_key];
	}

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var option = _step.value;

			if (!option) {
				continue;
			}
			if (option.constructor == Object) {
				data = option;
			} else if (option.constructor == Function) {
				callback = option;
			} else if (option.constructor == String) {
				host = "/" + option;
			} else if (option.constructor == Number) {
				timeout = option;
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	var xhr = new XMLHttpRequest();

	if (timeout) xhr.timeout = timeout;

	sendByHost();

	return new Promise(function (resolve, reject) {

		xhr.onload = function () {

			if (xhr.responseText) {
				var response = JSON.parse(xhr.responseText);

				if (response.type == 'ErrorResponse') {
					callback(response);
					reject(response);
				} else {
					callback(null, response);
					resolve(response);
				}
			} else if (xhr.status != 200) {
				var _response = {
					type: 'ErrorResponse',
					id: 'UNKNOWN_ERROR',
					message: xhr.statusText + ": " + xhr.responseText,
					group: 'UNKNOWN_ERROR',
					code: xhr.status
				};

				callback(_response);
				reject(_response);
			}
		};

		xhr.ontimeout = function () {
			var response = {
				type: 'ErrorResponse',
				id: 'TIMEOUT_ERROR',
				message: "Timeout: " + xhr.timeout + " ms",
				group: 'UNKNOWN_ERROR',
				code: xhr.status
			};

			callback(response);
			reject(response);
		};

		xhr.onerror = function () {
			var response = {
				type: 'ErrorResponse',
				id: 'UNKNOWN_ERROR',
				message: "Something wrong",
				group: 'UNKNOWN_ERROR',
				code: null
			};

			callback(response);
			reject(response);
		};
	});
}

function get() {
	for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		args[_key2] = arguments[_key2];
	}

	args.unshift('get');
	return call.apply(undefined, args);
}

function post() {
	for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
		args[_key3] = arguments[_key3];
	}

	args.unshift('post');
	return call.apply(undefined, args);
}

function put() {
	for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
		args[_key4] = arguments[_key4];
	}

	args.unshift('put');
	return call.apply(undefined, args);
}

function delete_() {
	for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
		args[_key5] = arguments[_key5];
	}

	args.unshift('delete');
	return call.apply(undefined, args);
}

exports.default = {
	get: get,
	post: post,
	put: put,
	delete: delete_
};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var emptyFunction = __webpack_require__(59);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

var store = __webpack_require__(134)('wks');
var uid = __webpack_require__(85);
var Symbol = __webpack_require__(9).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ },
/* 19 */
/***/ function(module, exports) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

'use strict';
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getContacts = exports.getUserId = exports.getUser = exports.getUnitAssignment = undefined;

var _session = __webpack_require__(30);

var _session2 = _interopRequireDefault(_session);

var _services = __webpack_require__(120);

var _services2 = _interopRequireDefault(_services);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	getUser: getUser,
	getUserId: getUserId,
	getUnitAssignment: getUnitAssignment,
	getContacts: getContacts
};
exports.getUnitAssignment = getUnitAssignment;
exports.getUser = getUser;
exports.getUserId = getUserId;
exports.getContacts = getContacts;


function getUser() {
	var session = _session2.default.get();
	if (!session) return null;
	return session.user;
}

function getUserId() {
	var user = getUser();
	if (!user) return null;
	return user._id;
}

function getUnitAssignment() {

	var session = _session2.default.get();

	if (!session || !session.user) return null;

	var dashboardServices = session.user.services.filter(function (serviceSet) {
		return serviceSet.service == _services2.default.get("Dashboard")._id;
	});

	if (dashboardServices.length === 0) return _services2.default.get("Dashboard").default.units;else return dashboardServices[0].value.units;
}

function getContacts() {

	var session = _session2.default.get();

	if (!session || !session.user) return [];

	return session.user.contacts || [];
}

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Card = __webpack_require__(312);

var _Card2 = _interopRequireDefault(_Card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Card2.default;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(11)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var IE8_DOM_DEFINE = __webpack_require__(241);
var toPrimitive = __webpack_require__(58);
var dP = Object.defineProperty;

exports.f = __webpack_require__(22) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(57);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var DOMProperty = __webpack_require__(97);
var ReactDOMComponentFlags = __webpack_require__(279);

var invariant = __webpack_require__(7);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

module.exports = __webpack_require__(784);


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(55);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

var _pois = __webpack_require__(29);

var _pois2 = _interopRequireDefault(_pois);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var openedDetailsStore = new _flux.Collection({ keyNames: ["id"] });
exports.default = openedDetailsStore;


window.openedDetailsStore = openedDetailsStore;

var DEFAULT_SIZE = 4;
var DEFAULT_VEHICLE_TAB = "activity";
var DEFAULT_POI_TAB = "properties";

function getDefaultTab(type) {
	if (type == "VehicleDetails") return DEFAULT_VEHICLE_TAB;else if (type == "POIDetails") return DEFAULT_POI_TAB;else return null;
}

_dispatcher2.default.on('openDetails', function (type, id, pageId, size) {
	openedDetailsStore.insert([{
		type: type,
		id: id,
		activePage: pageId || getDefaultTab(type),
		size: size || DEFAULT_SIZE
	}]);
});

_dispatcher2.default.on('closeDetails', function (type, id) {
	openedDetailsStore.remove([id]);
});

_dispatcher2.default.on('switchDetailsPage', function (id, pageId) {

	var details = openedDetailsStore.get(id);
	if (!pageId || !id) return;

	openedDetailsStore.update(id, {
		type: details.type,
		id: id,
		activePage: pageId,
		size: details.size
	});
});

_dispatcher2.default.on("resizeDetails", function (id, size) {

	var details = openedDetailsStore.get(id);
	if (size === undefined || !id) return;

	openedDetailsStore.update(id, {
		type: details.type,
		id: id,
		activePage: details.activePage,
		size: size
	});
});

_dispatcher2.default.on("logout", function () {
	openedDetailsStore.set(null);
});

_pois2.default.on("remove", function (pois) {
	openedDetailsStore.remove(pois.map(function (p) {
		return p._id;
	}));
});

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var poiStore = new _flux.Collection({ keyNames: ["_id"] });
exports.default = poiStore;


window.poiStore = poiStore;

_dispatcher2.default.on('getPOIs', function (pois) {
  return poiStore.set(pois);
});
_dispatcher2.default.on('createPOI', function (poi) {
  return poiStore.insert([poi]);
});
_dispatcher2.default.on('updatePOI', function (poi) {
  return poiStore.update(poi._id, poi);
});
_dispatcher2.default.on('removePOI', function (poiId) {
  return poiStore.remove([poiId]);
});
_dispatcher2.default.on('logout', function () {
  return poiStore.set(null);
});

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

var _token = __webpack_require__(118);

var _token2 = _interopRequireDefault(_token);

var _services = __webpack_require__(120);

var _services2 = _interopRequireDefault(_services);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var sessionStore = new _flux.Singleton();
exports.default = sessionStore;


window.sessionStore = sessionStore;

_dispatcher2.default.on('login', function (token, user) {
	sessionStore.set({ token: token, user: user });
	_token2.default.set(token);
});

_dispatcher2.default.on('logout', function () {
	sessionStore.set(null);
	_token2.default.remove();
});

_dispatcher2.default.on('invalidToken', function () {
	sessionStore.set(null);
	_token2.default.remove();
});

_dispatcher2.default.on('createPOI', function (poi, collaboration) {
	return addServiceSetByCollaboration(poi, collaboration);
});

_dispatcher2.default.on('createNotificationConfig', function (notificationConfig) {
	return addServiceSetByNotificationSet(notificationConfig);
});

_dispatcher2.default.on('updateUser', function (user) {
	return updateUser(user);
});

function addServiceSetByNotificationSet(notificationConfig) {
	if (!notificationConfig) return;
	var serviceId = _services2.default.get("Notification")._id;
	if (!serviceId) return;
	var session = sessionStore.get();
	if (!session) return;

	var serviceSet = {
		accessInterval: { from: null, to: null },
		denied: false,
		service: serviceId,
		value: notificationConfig,
		type: "NotificationSet"
	};

	session.user.services = [].concat(_toConsumableArray(session.user.services), [serviceSet]);

	sessionStore.set(session);
}

function addServiceSetByCollaboration(poi, collaboration) {
	if (!poi || !collaboration) return;
	var serviceId = _services2.default.get("POI")._id;
	if (!serviceId) return;
	var session = sessionStore.get();
	if (!session) return;

	var serviceSet = {
		accessInterval: { from: null, to: null },
		denied: false,
		service: serviceId,
		type: "POISet",
		value: {
			poi: poi._id,
			privilege: collaboration.privilege
		}
	};

	session.user.services = [].concat(_toConsumableArray(session.user.services), [serviceSet]);

	sessionStore.set(session);
}

function updateUser(user) {
	if (!user) return;
	var session = sessionStore.get();
	if (!session) return;
	sessionStore.set({ token: session.token, user: user });
}

/***/ },
/* 31 */
/***/ function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ },
/* 32 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ },
/* 33 */
/***/ function(module, exports) {

"use strict";
"use strict";

function EEP() {
	this.listeners = [];
}

EEP.prototype.addListener = function (emitter, event, handler) {

	emitter.addListener(event, handler);

	this.listeners.push({
		emitter: emitter,
		event: event,
		handler: handler
	});
};

EEP.prototype.removeListener = function (emitter, event, handler) {

	for (var i in this.listeners) {
		if (this.listeners[i].emitter === emitter && this.listeners[i].event == event && this.listeners[i].handler == handler) {
			emitter.removeListener(event, handler);
		}
	}
};

EEP.prototype.on = function (emitter, event, handler) {
	this.addListener(emitter, event, handler);
};

EEP.prototype.once = function (emitter, event, handler) {

	emitter.once(event, handler);

	this.listeners.push({
		emitter: emitter,
		event: event,
		handler: handler
	});

	// nem töröljük a listenert, ha az esemény eltüzelt
};

EEP.prototype.close = function () {

	for (var i in this.listeners) {
		this.removeListener(this.listeners[i].emitter, this.listeners[i].event, this.listeners[i].handler);
	}

	this.listeners = [];
};

module.exports = EEP;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProgressBar = __webpack_require__(336);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ProgressBar2.default;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

var dP = __webpack_require__(23);
var createDesc = __webpack_require__(81);
module.exports = __webpack_require__(22) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var hide = __webpack_require__(35);
var has = __webpack_require__(39);
var SRC = __webpack_require__(85)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(48).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(11);
var defined = __webpack_require__(55);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Form = __webpack_require__(321);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Form2.default;

/***/ },
/* 39 */
/***/ function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(108);
var createDesc = __webpack_require__(81);
var toIObject = __webpack_require__(42);
var toPrimitive = __webpack_require__(58);
var has = __webpack_require__(39);
var IE8_DOM_DEFINE = __webpack_require__(241);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(22) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(39);
var toObject = __webpack_require__(27);
var IE_PROTO = __webpack_require__(175)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(107);
var defined = __webpack_require__(55);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = shouldComponentUpdate;

var _getModificationsByRef = __webpack_require__(101);

var _getModificationsByRef2 = _interopRequireDefault(_getModificationsByRef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function shouldComponentUpdate(context, nextProps, nextState) {
	var stateDiff = (0, _getModificationsByRef2.default)(context.state, nextState);
	var propsDiff = (0, _getModificationsByRef2.default)(context.props, nextProps);
	return !!stateDiff || !!propsDiff;
}

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

var _pois = __webpack_require__(29);

var _pois2 = _interopRequireDefault(_pois);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var displayedDetailsStore = new _flux.Singleton();
exports.default = displayedDetailsStore;


window.displayedDetailsStore = displayedDetailsStore;

_openedDetails2.default.on('insert', function (detailsDescriptors) {
	if (!detailsDescriptors[0]) return;
	displayedDetailsStore.set({
		type: detailsDescriptors[0].type,
		id: detailsDescriptors[0].id
	});
});

_openedDetails2.default.on('remove', function (detailsDescriptors) {
	var displayedDetails = displayedDetailsStore.get();
	if (!displayedDetails) return;
	detailsDescriptors.forEach(function (detailsDescriptor) {
		if (detailsDescriptor.id == displayedDetails.id) displayedDetailsStore.set(null);
	});
});

_dispatcher2.default.on("switchDetailsPage", function (vehicleId, tabId) {
	var displayedDetails = displayedDetailsStore.get();
	displayedDetails["id"] = vehicleId;
	displayedDetailsStore.set(displayedDetails);
});

_dispatcher2.default.on("logout", function () {
	displayedDetailsStore.set(null);
});

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vehicleStore = new _flux.Collection({ keyNames: ["_id"] });
exports.default = vehicleStore;


window.vehicleStore = vehicleStore;

_dispatcher2.default.on('getVehicles', function (vehicles) {
  return vehicleStore.set(vehicles);
});
_dispatcher2.default.on('updateVehicle', function (vehicle) {
  return vehicleStore.update(vehicle._id, vehicle);
});
_dispatcher2.default.on('logout', function () {
  return vehicleStore.set(null);
});

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getModificationsOfPOI = exports.getBoundsOfRadialPOI = exports.getBoundsOfPolygonPOI = exports.getBoundsOfPOI = exports.getColorOfPOI = exports.getRadiusOfPOI = exports.getCenterOfPOI = exports.getPathOfPOI = exports.getLocationOfPOI = exports.getNameOfPOI = exports.getTypeOfPOI = exports.getServiceSetOfPOI = exports.getPrivilegeOfPOI = undefined;

var _getServiceSet = __webpack_require__(145);

var _getServiceSet2 = _interopRequireDefault(_getServiceSet);

var _session = __webpack_require__(30);

var _session2 = _interopRequireDefault(_session);

var _pois = __webpack_require__(29);

var _pois2 = _interopRequireDefault(_pois);

var _poiModifications = __webpack_require__(119);

var _poiModifications2 = _interopRequireDefault(_poiModifications);

var _geo = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	getPrivilegeOfPOI: getPrivilegeOfPOI,
	getServiceSetOfPOI: getServiceSetOfPOI,
	getTypeOfPOI: getTypeOfPOI,
	getNameOfPOI: getNameOfPOI,
	getLocationOfPOI: getLocationOfPOI,
	getPathOfPOI: getPathOfPOI,
	getCenterOfPOI: getCenterOfPOI,
	getRadiusOfPOI: getRadiusOfPOI,
	getColorOfPOI: getColorOfPOI,
	getBoundsOfPOI: getBoundsOfPOI,
	getBoundsOfPolygonPOI: getBoundsOfPolygonPOI,
	getBoundsOfRadialPOI: getBoundsOfRadialPOI,
	getModificationsOfPOI: getModificationsOfPOI
};
exports.getPrivilegeOfPOI = getPrivilegeOfPOI;
exports.getServiceSetOfPOI = getServiceSetOfPOI;
exports.getTypeOfPOI = getTypeOfPOI;
exports.getNameOfPOI = getNameOfPOI;
exports.getLocationOfPOI = getLocationOfPOI;
exports.getPathOfPOI = getPathOfPOI;
exports.getCenterOfPOI = getCenterOfPOI;
exports.getRadiusOfPOI = getRadiusOfPOI;
exports.getColorOfPOI = getColorOfPOI;
exports.getBoundsOfPOI = getBoundsOfPOI;
exports.getBoundsOfPolygonPOI = getBoundsOfPolygonPOI;
exports.getBoundsOfRadialPOI = getBoundsOfRadialPOI;
exports.getModificationsOfPOI = getModificationsOfPOI;


function getServiceSetOfPOI(poiId) {
	var session = _session2.default.get();
	if (!session) return null;

	var poi = _pois2.default.get(poiId);
	if (!poi) return null;

	var pois = _pois2.default.getAll();
	if (!pois) return null;

	return (0, _getServiceSet2.default)("POISet", "poi", session.user, poi, pois);
}

function getPrivilegeOfPOI(vehicleId) {
	var serviceSet = getServiceSetOfPOI(vehicleId);
	if (serviceSet && serviceSet.value && serviceSet.value.privilege !== undefined) return serviceSet.value.privilege;
	return null;
}

function getTypeOfPOI(poiId) {
	var poi = _pois2.default.get(poiId);
	if (!poi) return null;
	return poi.type || null;
}

function getNameOfPOI(poiId) {
	var poi = _pois2.default.get(poiId);
	if (!poi) return null;
	return poi.name || "";
}

function getLocationOfPOI(poiId) {
	var poi = _pois2.default.get(poiId);
	if (!poi) return null;
	var modifications = getModificationsOfPOI(poiId);
	return modifications.location || poi.location;
}

function getPathOfPOI(poiId) {
	var location = getLocationOfPOI(poiId);

	if (!location || !location.coordinates || !location.coordinates[0] || !location.coordinates[0][0]) return null;

	// csak egyszeres poligonokkal, azok egyszeres nem ismétlődő gyűrűjével foglalkozunk
	var ring = location.coordinates[0][0];
	return ring.filter(function (_, i) {
		return i != ring.length - 1;
	}).map(function (point) {
		return new google.maps.LatLng(point[1], point[0]);
	});
}

function getCenterOfPOI(poiId) {
	var location = getLocationOfPOI(poiId);

	if (!location || !location.coordinates || location.coordinates.length != 2) return null;

	return (0, _geo.pointToLatLng)(location);
}

function getRadiusOfPOI(poiId) {
	var poi = _pois2.default.get(poiId);
	var modifications = getModificationsOfPOI(poiId);
	if (!poi || poi.type != "RadialPOI") return null;
	return modifications.radius || poi.radius;
}

function getColorOfPOI(poiId) {
	var poi = _pois2.default.get(poiId);
	if (!poi) return null;
	var modifications = getModificationsOfPOI(poiId);
	return modifications.color || poi.color || DEFAULT_COLOR;
}

function getBoundsOfPOI(poiId) {
	var type = getTypeOfPOI(poiId);
	if (type == "PolygonalPOI") return getBoundsOfPolygonPOI(poiId);else if (type == "RadialPOI") return getBoundsOfRadialPOI(poiId);else return null;
}

function getBoundsOfPolygonPOI(poiId) {
	var path = getPathOfPOI(poiId);
	if (!path) return;
	var bounds = new google.maps.LatLngBounds();
	path.forEach(function (edge) {
		return bounds.extend(edge);
	});
	return bounds;
}

function getBoundsOfRadialPOI(poiId) {
	var center = getCenterOfPOI(poiId);
	var radius = getRadiusOfPOI(poiId);
	if (!center || radius === null) return null;

	var offset = {
		lat: radius / 110540,
		lng: Math.abs(radius / 74213 / Math.cos(center.lat()))
	};

	var bounds = new google.maps.LatLngBounds();

	bounds.extend(new google.maps.LatLng(center.lat() + offset.lat, center.lng()));
	bounds.extend(new google.maps.LatLng(center.lat() - offset.lat, center.lng()));
	bounds.extend(new google.maps.LatLng(center.lat(), center.lng() + offset.lng));
	bounds.extend(new google.maps.LatLng(center.lat(), center.lng() - offset.lng));

	return bounds;
}

function getModificationsOfPOI(poiId) {
	return _poiModifications2.default.get(poiId) ? _poiModifications2.default.get(poiId).modifications : {};
}

/***/ },
/* 47 */
/***/ function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ },
/* 48 */
/***/ function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(31);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var fails = __webpack_require__(11);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Input = __webpack_require__(324);

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Input2.default;

/***/ },
/* 53 */
/***/ function(module, exports) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	latLngToPoint: latLngToPoint,
	coordinateToLatLng: coordinateToLatLng,
	pointToLatLng: pointToLatLng,
	positionToLatLng: positionToLatLng,
	areEqualPositions: areEqualPositions,
	boundsLiteralToBounds: boundsLiteralToBounds
};
exports.latLngToPoint = latLngToPoint;
exports.coordinateToLatLng = coordinateToLatLng;
exports.pointToLatLng = pointToLatLng;
exports.positionToLatLng = positionToLatLng;
exports.areEqualPositions = areEqualPositions;
exports.boundsLiteralToBounds = boundsLiteralToBounds;


function latLngToPoint(latLng) {
	return {
		type: "Point",
		coordinates: [latLng.lng(), latLng.lat()]
	};
}

function coordinateToLatLng(coord) {
	return new google.maps.LatLng(coord[1], coord[0]);
}

function pointToLatLng(point) {
	if (!point || !point.coordinates) return null;

	return coordinateToLatLng(point.coordinates);
}

function positionToLatLng(position) {
	if (!position || !position.point) return null;

	return pointToLatLng(position.point);
}

function areEqualPositions(p1, p2) {
	if (p1.lat() == p2.lat() && p1.lng() == p2.lng()) return true;else return false;
}

function boundsLiteralToBounds(literal) {
	var sw = new google.maps.LatLng(literal.south, literal.west);
	var ne = new google.maps.LatLng(literal.north, literal.east);
	return new google.maps.LatLngBounds(sw, ne);
}

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(49);
var IObject = __webpack_require__(107);
var toObject = __webpack_require__(27);
var toLength = __webpack_require__(24);
var asc = __webpack_require__(160);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ },
/* 55 */
/***/ function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(48);
var fails = __webpack_require__(11);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ },
/* 57 */
/***/ function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(13);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ },
/* 59 */
/***/ function(module, exports) {

"use strict";
"use strict";

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15),
    _assign = __webpack_require__(19);

var CallbackQueue = __webpack_require__(277);
var PooledClass = __webpack_require__(86);
var ReactFeatureFlags = __webpack_require__(282);
var ReactReconciler = __webpack_require__(98);
var Transaction = __webpack_require__(142);

var invariant = __webpack_require__(7);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pin = __webpack_require__(334);

var _Pin2 = _interopRequireDefault(_Pin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Pin2.default;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

var Map = __webpack_require__(262);
var $export = __webpack_require__(0);
var shared = __webpack_require__(134)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(265))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
if (__webpack_require__(22)) {
  var LIBRARY = __webpack_require__(71);
  var global = __webpack_require__(9);
  var fails = __webpack_require__(11);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(136);
  var $buffer = __webpack_require__(181);
  var ctx = __webpack_require__(49);
  var anInstance = __webpack_require__(76);
  var propertyDesc = __webpack_require__(81);
  var hide = __webpack_require__(35);
  var redefineAll = __webpack_require__(82);
  var toInteger = __webpack_require__(57);
  var toLength = __webpack_require__(24);
  var toIndex = __webpack_require__(260);
  var toAbsoluteIndex = __webpack_require__(84);
  var toPrimitive = __webpack_require__(58);
  var has = __webpack_require__(39);
  var classof = __webpack_require__(106);
  var isObject = __webpack_require__(13);
  var toObject = __webpack_require__(27);
  var isArrayIter = __webpack_require__(167);
  var create = __webpack_require__(78);
  var getPrototypeOf = __webpack_require__(41);
  var gOPN = __webpack_require__(79).f;
  var getIterFn = __webpack_require__(183);
  var uid = __webpack_require__(85);
  var wks = __webpack_require__(18);
  var createArrayMethod = __webpack_require__(54);
  var createArrayIncludes = __webpack_require__(123);
  var speciesConstructor = __webpack_require__(135);
  var ArrayIterators = __webpack_require__(184);
  var Iterators = __webpack_require__(92);
  var $iterDetect = __webpack_require__(129);
  var setSpecies = __webpack_require__(83);
  var arrayFill = __webpack_require__(159);
  var arrayCopyWithin = __webpack_require__(233);
  var $DP = __webpack_require__(23);
  var $GOPD = __webpack_require__(40);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _assign = __webpack_require__(19);

var PooledClass = __webpack_require__(86);

var emptyFunction = __webpack_require__(59);
var warning = __webpack_require__(17);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ },
/* 65 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = __webpack_require__(313);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Checkbox2.default;

/***/ },
/* 67 */
/***/ function(module, exports) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = filterGroups;
function filterGroups(items, groupName) {
	if (!items) return null;

	return items.filter(function (item) {
		return !/.Group$/.test(item.type);
	});
}

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataTypeStore = new _flux.Collection({ keyNames: ["_id", "name"] });
exports.default = dataTypeStore;


window.dataTypeStore = dataTypeStore;

_dispatcher2.default.on('getDataTypes', function (dataTypes) {
  return dataTypeStore.set(dataTypes);
});

/***/ },
/* 69 */
/***/ function(module, exports) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var order = ["POI", "ROUTE_DEFAULT_STROKE", "ROUTE_START_END_MARKER", "ROUTE_DEFAULT", "ROUTE_SECTION_SELECTED_STROKE", "ROUTE_SECTION_SELECTED", "ROUTE_SECTION_HIGHLIGHTED_STROKE", "ROUTE_SECTION_HIGHLIGHT", "HIGHLIGHTED_ROUTE_START_END_MARKER", "ROUTE_SECTION_TRANSPARENT", "ROUTE_POINTER", "IGNITION_OFF", "IGNITION_ON", "MOVING", "FOCUSED", "SELECTED", "POI_CROSSING_MARKER", "HIGHLIGHTED_POI_CROSSING_MARKER", "TOOLTIP", "CONTEXT_MENU"];

var zIndexMap = {};

order.forEach(function (layer, index) {
	return zIndexMap[layer] = index;
});

exports.default = zIndexMap;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(18)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(35)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ },
/* 71 */
/***/ function(module, exports) {

module.exports = false;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

var META = __webpack_require__(85)('meta');
var isObject = __webpack_require__(13);
var has = __webpack_require__(39);
var setDesc = __webpack_require__(23).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(11)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dialog = __webpack_require__(318);

var _Dialog2 = _interopRequireDefault(_Dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Dialog2.default;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Select = __webpack_require__(337);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Select2.default;

/***/ },
/* 75 */
/***/ function(module, exports) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = sleep;
function sleep(time) {
	return new Promise(function (resolve) {
		return setTimeout(resolve, time);
	});
}

/***/ },
/* 76 */
/***/ function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(49);
var call = __webpack_require__(244);
var isArrayIter = __webpack_require__(167);
var anObject = __webpack_require__(8);
var toLength = __webpack_require__(24);
var getIterFn = __webpack_require__(183);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(8);
var dPs = __webpack_require__(250);
var enumBugKeys = __webpack_require__(163);
var IE_PROTO = __webpack_require__(175)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(162)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(165).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(252);
var hiddenKeys = __webpack_require__(163).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(252);
var enumBugKeys = __webpack_require__(163);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ },
/* 81 */
/***/ function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(36);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var global = __webpack_require__(9);
var dP = __webpack_require__(23);
var DESCRIPTORS = __webpack_require__(22);
var SPECIES = __webpack_require__(18)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(57);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ },
/* 85 */
/***/ function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(7);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pager = __webpack_require__(332);

var _Pager2 = _interopRequireDefault(_Pager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Pager2.default;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = createWellQuantity;

var _round = __webpack_require__(213);

var _round2 = _interopRequireDefault(_round);

var _convertUnit = __webpack_require__(210);

var _convertUnit2 = _interopRequireDefault(_convertUnit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createWellQuantity(unitAssignment, application, value, originalUnit, representationType) {

	representationType = representationType || 'float';
	var prec = representationType.toLowerCase() === 'integer' ? 0 : 1;

	if (!application) {
		return {
			value: (0, _round2.default)(value, prec)
		};
	}

	var displayUnit = unitAssignment[application];

	return {
		value: (0, _round2.default)((0, _convertUnit2.default)(originalUnit, displayUnit, value), prec),
		unit: displayUnit
	};
}

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vehiclePOICrossingStore = new _flux.Collection({ keyNames: ["vehicle"] });
exports.default = vehiclePOICrossingStore;


window.vehiclePOICrossingStore = vehiclePOICrossingStore;

function createStoreItemFromActivity(report, from, to) {
	return {
		vehicle: report.options.carrier,
		options: report.options,
		result: report.result,
		pinnedCrossings: createPinnedCrossingsSet(report.result.summaries.pois),
		highlightedCrossing: null
	};
}

function createPinnedCrossingsSet(poiSummaries) {
	var pinnedCrossings = new Set();
	poiSummaries.forEach(function (poiSummary) {
		return pinnedCrossings.add(poiSummary.poi);
	});
	return pinnedCrossings;
}

_dispatcher2.default.on('clearVehiclePOICrossings', function (vehicleId) {
	vehiclePOICrossingStore.remove([vehicleId]);
});

_dispatcher2.default.on('getVehiclePOICrossings', function (report, from, to) {
	var prevActivity = vehiclePOICrossingStore.get(report.options.carrier);
	if (prevActivity) vehiclePOICrossingStore.update(report.options.carrier, createStoreItemFromActivity(report, from, to));else vehiclePOICrossingStore.insert([createStoreItemFromActivity(report, from, to)]);
});

_dispatcher2.default.on("highlightVehiclePOICrossing", function (vehicleId, time) {
	var poiCrossings = vehiclePOICrossingStore.get(vehicleId);
	poiCrossings.highlightedCrossing = time;
	vehiclePOICrossingStore.update(vehicleId, poiCrossings);
});

_dispatcher2.default.on("unhighlightVehiclePOICrossing", function (vehicleId) {
	var poiCrossings = vehiclePOICrossingStore.get(vehicleId);
	poiCrossings.highlightedCrossing = null;
	vehiclePOICrossingStore.update(vehicleId, poiCrossings);
});

_dispatcher2.default.on("pinVehiclePOICrossingsOfPOI", function (vehicleId, pois, value) {
	var poiCrossings = vehiclePOICrossingStore.get(vehicleId);
	pois.forEach(function (poi) {
		if (value) {
			poiCrossings.pinnedCrossings.add(poi);
		} else {
			poiCrossings.pinnedCrossings.delete(poi);
		}
	});
	vehiclePOICrossingStore.update(vehicleId, poiCrossings);
});

_openedDetails2.default.on('remove', function (descriptors) {
	vehiclePOICrossingStore.remove(descriptors.map(function (descriptor) {
		return descriptor.id;
	}));
});

_dispatcher2.default.on("logout", function () {
	vehiclePOICrossingStore.set(null);
});

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.isValidNotificationConfig = exports.isValidEventDescriptor = exports.getEventDescriptorFromNotificationConfig = undefined;

var _eventDescriptors = __webpack_require__(103);

var _eventDescriptors2 = _interopRequireDefault(_eventDescriptors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	getEventDescriptorFromNotificationConfig: getEventDescriptorFromNotificationConfig,
	isValidEventDescriptor: isValidEventDescriptor,
	isValidNotificationConfig: isValidNotificationConfig
};
exports.getEventDescriptorFromNotificationConfig = getEventDescriptorFromNotificationConfig;
exports.isValidEventDescriptor = isValidEventDescriptor;
exports.isValidNotificationConfig = isValidNotificationConfig;


function getEventDescriptorFromNotificationConfig(notificationConfig) {
	if (!notificationConfig) {
		return null;
	}

	return _eventDescriptors2.default.get(notificationConfig.descriptor);
}

function isValidCriticalScalarStateDescriptor(eventDescriptor) {
	var isValid = true;

	if (!eventDescriptor || !eventDescriptor.type || eventDescriptor.type != "CriticalScalarStateDescriptor" || !eventDescriptor.carriers || !eventDescriptor.dataType || !eventDescriptor.operator || !Number.isFinite(eventDescriptor.debounceTime) || !eventDescriptor.operands) {
		return false;
	}

	if (eventDescriptor.carriers.user) {
		isValid = isValid && eventDescriptor.carriers.carriers == null;
	} else {
		isValid = isValid && eventDescriptor.carriers.carriers.length != 0;
	}

	if (eventDescriptor.operator == "between" || eventDescriptor.operator == "notbetween") {
		isValid = isValid && eventDescriptor.operands.length == 2;
	} else {
		isValid = isValid && eventDescriptor.operands.length == 1;
	}

	isValid = isValid && eventDescriptor.operands.every(function (e) {
		return Number.isFinite(e);
	});
	isValid = isValid && Number.isFinite(eventDescriptor.debounceTime);

	return isValid;
}

function isValidPOICrossingDescriptor(eventDescriptor) {
	var isValid = true;

	if (!eventDescriptor || !eventDescriptor.type || eventDescriptor.type != "POICrossingDescriptor" || !eventDescriptor.carriers || !eventDescriptor.pois) {
		return false;
	}

	if (eventDescriptor.carriers.user) {
		isValid = isValid && eventDescriptor.carriers.carriers == null;
	} else {
		isValid = isValid && eventDescriptor.carriers.carriers.length != 0;
	}

	if (eventDescriptor.pois.user) {
		isValid = isValid && eventDescriptor.pois.pois == null;
	} else {
		isValid = isValid && eventDescriptor.pois.pois.length != 0;
	}

	isValid = isValid && (eventDescriptor.arriving || eventDescriptor.departing);

	return isValid;
}

function isValidEventDescriptor(eventDescriptor) {
	return isValidCriticalScalarStateDescriptor(eventDescriptor) || isValidPOICrossingDescriptor(eventDescriptor);
}

function isValidNotificationConfig(notificationConfig) {
	return notificationConfig && (notificationConfig.web || notificationConfig.email || notificationConfig.sms);
}

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getPrivilegeOfVehicle = getPrivilegeOfVehicle;
exports.getScalarVehicleStatesWithResolvedUnits = getScalarVehicleStatesWithResolvedUnits;
exports.getBoundsOfPinnedVehicles = getBoundsOfPinnedVehicles;
exports.getNumberOfPinnedVehicles = getNumberOfPinnedVehicles;
exports.getPositionOfVehicle = getPositionOfVehicle;
exports.getAddressOfVehicle = getAddressOfVehicle;
exports.getNameOfVehicle = getNameOfVehicle;
exports.getMovingStateOfVehicle = getMovingStateOfVehicle;
exports.hasStateOfVehicle = hasStateOfVehicle;
exports.getSelectionOfVehicle = getSelectionOfVehicle;
exports.getLastTimeOfVehicleState = getLastTimeOfVehicleState;

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _scalarToQuantity = __webpack_require__(347);

var _scalarToQuantity2 = _interopRequireDefault(_scalarToQuantity);

var _filterGroups = __webpack_require__(67);

var _filterGroups2 = _interopRequireDefault(_filterGroups);

var _getServiceSet = __webpack_require__(145);

var _getServiceSet2 = _interopRequireDefault(_getServiceSet);

var _session = __webpack_require__(30);

var _session2 = _interopRequireDefault(_session);

var _dataTypes = __webpack_require__(68);

var _dataTypes2 = _interopRequireDefault(_dataTypes);

var _vehicles = __webpack_require__(45);

var _vehicles2 = _interopRequireDefault(_vehicles);

var _vehicleStates = __webpack_require__(122);

var _vehicleStates2 = _interopRequireDefault(_vehicleStates);

var _pinnedVehicles = __webpack_require__(154);

var _pinnedVehicles2 = _interopRequireDefault(_pinnedVehicles);

var _user = __webpack_require__(20);

var _geo = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getServiceSetOfVehicle(vehicleId) {
	var session = _session2.default.get();
	if (!session) return null;

	var vehicle = _vehicles2.default.get(vehicleId);
	if (!vehicle) return null;

	var vehicles = _vehicles2.default.getAll();
	if (!vehicles) return null;

	return (0, _getServiceSet2.default)("CarrierSet", "carrier", session.user, vehicle, vehicles);
}

function getPrivilegeOfVehicle(vehicleId) {
	var serviceSet = getServiceSetOfVehicle(vehicleId);
	if (serviceSet && serviceSet.value && serviceSet.value.privilege !== undefined) return serviceSet.value.privilege;
	return null;
}

function getScalarVehicleStatesWithResolvedUnits(vehicleId) {
	var vehicleState = _vehicleStates2.default.get(vehicleId);
	if (!vehicleState) return [];

	var unitAssignment = (0, _user.getUnitAssignment)();

	return vehicleState.state.filter(function (data) {
		return data.type == "Scalar" || data.dataType == "54ac0f62f556ea16b4a31fd4";
	}).map(function (data) {

		var dataTypeName = _dataTypes2.default.get(data.dataType).name;
		var name = _lang2.default["DATA_TYPE_" + data.dataType];
		if (data.dataType == "54ac0f62f556ea16b4a31fd4") {
			//for LatLng coords
			var lat = data.point.coordinates[1];
			var lng = data.point.coordinates[0];
			return { dataTypeName: dataTypeName, name: name, lat: lat, lng: lng };
		}

		var quantity = (0, _scalarToQuantity2.default)(_dataTypes2.default, unitAssignment, data);
		var value = quantity.value;
		var unit = quantity.unit || "";
		return { dataTypeName: dataTypeName, name: name, value: value, unit: unit };
	});
}

function getVehicleStateByDataTypeName(vehicleId, dataTypeName) {
	var vehicleState = _vehicleStates2.default.get(vehicleId);
	if (!vehicleState) return null;

	var dataTypeId = _dataTypes2.default.get(dataTypeName)._id;
	return vehicleState.state.find(function (s) {
		return s.dataType == dataTypeId;
	}) || null;
}

function getBoundsOfPinnedVehicles() {
	var pinnedVehicles = _pinnedVehicles2.default.getAll();
	if (!pinnedVehicles) return null;
	var positions = pinnedVehicles.map(function (id) {
		return getPositionOfVehicle(id);
	}).filter(function (_) {
		return _;
	});

	var bounds = new google.maps.LatLngBounds();
	positions.forEach(function (position) {
		return bounds.extend(position);
	});
	return bounds;
}

function getNumberOfPinnedVehicles() {
	var pinnedVehicles = _pinnedVehicles2.default.getAll();
	if (!pinnedVehicles) return 0;
	return pinnedVehicles.length;
}

function getPositionOfVehicle(vehicleId) {
	var position = getVehicleStateByDataTypeName(vehicleId, "Position");

	if (position) return (0, _geo.positionToLatLng)(position);else return null;
}

function getAddressOfVehicle(vehicleId) {
	var position = getVehicleStateByDataTypeName(vehicleId, "Position");

	if (position) return position.address || "";else return "";
}

function getNameOfVehicle(vehicleId) {
	var vehicles = (0, _filterGroups2.default)(_vehicles2.default.getAll());
	if (!vehicles) return "";
	var vehicle = vehicles.find(function (v) {
		return v._id == vehicleId;
	});
	if (vehicle) return vehicle.name || vehicle.plateNumber;else return "";
}

function getMovingStateOfVehicle(vehicleId) {
	var ignitionData = getVehicleStateByDataTypeName(vehicleId, "Ignition");
	var maxSpeedData = getVehicleStateByDataTypeName(vehicleId, "MaxSpeed");
	var avgSpeedData = getVehicleStateByDataTypeName(vehicleId, "AvgSpeed");

	var ignition = ignitionData ? ignitionData.value : false;
	var speed = avgSpeedData ? avgSpeedData.value : maxSpeedData ? maxSpeedData.value : 0;

	if (ignition && speed) return "moving";else if (ignition) return "onIgnition";else return "";
}

function hasStateOfVehicle(vehicleId) {
	var vehicleState = _vehicleStates2.default.get(vehicleId);

	if (!vehicleState || vehicleState.state.length == 0) return false;
	return true;
}

function getSelectionOfVehicle(vehicleId) {
	return selectedVehicleStore.get() == vehicleId;
}

function getLastTimeOfVehicleState(vehicleId) {

	var vehicleState = _vehicleStates2.default.get(vehicleId);

	if (!vehicleState) return 0;

	return vehicleState.state.reduce(function (last, data) {
		return data.time > last ? data.time : last;
	}, 0);
}

/***/ },
/* 92 */
/***/ function(module, exports) {

module.exports = {};


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

var def = __webpack_require__(23).f;
var has = __webpack_require__(39);
var TAG = __webpack_require__(18)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(55);
var fails = __webpack_require__(11);
var spaces = __webpack_require__(179);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var DOMNamespaces = __webpack_require__(187);
var setInnerHTML = __webpack_require__(144);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(195);
var setTextContent = __webpack_require__(295);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(7);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ReactRef = __webpack_require__(807);
var ReactInstrumentation = __webpack_require__(51);

var warning = __webpack_require__(17);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _assign = __webpack_require__(19);

var ReactBaseClasses = __webpack_require__(297);
var ReactChildren = __webpack_require__(840);
var ReactDOMFactories = __webpack_require__(841);
var ReactElement = __webpack_require__(100);
var ReactPropTypes = __webpack_require__(842);
var ReactVersion = __webpack_require__(843);

var createReactClass = __webpack_require__(844);
var onlyChild = __webpack_require__(848);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _assign = __webpack_require__(19);

var ReactCurrentOwner = __webpack_require__(65);

var warning = __webpack_require__(17);
var canDefineProperty = __webpack_require__(301);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(299);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ },
/* 101 */
/***/ function(module, exports) {

"use strict";
"use strict";

module.exports = function getModificationsByRef(ref, target) {

	if (ref === undefined || target === undefined) {
		return target;
	}

	if (ref === null && target !== null || ref !== null && target === null) {
		return target;
	}

	if (ref === null && target === null) {
		return undefined;
	}

	if (ref.constructor != target.constructor) {
		return target;
	}

	var mod = undefined;

	if (ref.constructor === Object) {

		for (var key in target) {

			var nestedMod = getModificationsByRef(ref[key], target[key]);

			if (nestedMod !== undefined) {
				if (mod == undefined) {
					mod = {};
				}

				mod[key] = nestedMod;
			}
		}
	} else if (ref.constructor === Array) {

		if (ref.length != target.length) {

			mod = target;
		} else {

			var arrayModified = ref.some(function (refValue, ix) {
				return getModificationsByRef(refValue, target[ix]) != undefined;
			});

			if (arrayModified) {
				mod = target;
			}
		}
	} else if (ref.constructor === Function) {

		// függvények esetén nem vizsgálódunk

	} else {

		if (ref !== target) {
			mod = target;
		}
	}

	return mod;
};

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MultiSelector = __webpack_require__(331);

var _MultiSelector2 = _interopRequireDefault(_MultiSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MultiSelector2.default;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventDescriptorStore = new _flux.Collection({ keyNames: ["_id"] });
exports.default = eventDescriptorStore;


window.eventDescriptorStore = eventDescriptorStore;

_dispatcher2.default.on("getEventDescriptors", function (eventDescriptors) {
  return eventDescriptorStore.set(eventDescriptors);
});
_dispatcher2.default.on('createEventDescriptor', function (eventDescriptor) {
  return eventDescriptorStore.insert([eventDescriptor]);
});
_dispatcher2.default.on('updateEventDescriptor', function (eventDescriptor) {
  return eventDescriptorStore.update(eventDescriptor._id, eventDescriptor);
});
_dispatcher2.default.on('removeEventDescriptor', function (eventDescriptorId) {
  return eventDescriptorStore.remove([eventDescriptorId]);
});
_dispatcher2.default.on("logout", function () {
  return eventDescriptorStore.set(null);
});

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getActiveSectionNumberOfSectionIndex = exports.createRouteFromSection = exports.getSpeedBeforeIndex = exports.getResolvedVehicleActivity = exports.focusOnVehicleActivity = exports.getBoundsOfVehicleActivity = exports.createPathFromInterval = exports.getLatLngOfVehicleRoutesByTime = exports.getVisibilityOfActivity = exports.getPinStatusOfSection = undefined;

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _geo = __webpack_require__(53);

var _user = __webpack_require__(20);

var _createWellQuantity = __webpack_require__(88);

var _createWellQuantity2 = _interopRequireDefault(_createWellQuantity);

var _vehicleActivities = __webpack_require__(121);

var _vehicleActivities2 = _interopRequireDefault(_vehicleActivities);

var _displayedDetails = __webpack_require__(44);

var _displayedDetails2 = _interopRequireDefault(_displayedDetails);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	getPinStatusOfSection: getPinStatusOfSection,
	getVisibilityOfActivity: getVisibilityOfActivity,
	getLatLngOfVehicleRoutesByTime: getLatLngOfVehicleRoutesByTime,
	createPathFromInterval: createPathFromInterval,
	getBoundsOfVehicleActivity: getBoundsOfVehicleActivity,
	focusOnVehicleActivity: focusOnVehicleActivity,
	getResolvedVehicleActivity: getResolvedVehicleActivity,
	getSpeedBeforeIndex: getSpeedBeforeIndex,
	createRouteFromSection: createRouteFromSection,
	getActiveSectionNumberOfSectionIndex: getActiveSectionNumberOfSectionIndex
};
exports.getPinStatusOfSection = getPinStatusOfSection;
exports.getVisibilityOfActivity = getVisibilityOfActivity;
exports.getLatLngOfVehicleRoutesByTime = getLatLngOfVehicleRoutesByTime;
exports.createPathFromInterval = createPathFromInterval;
exports.getBoundsOfVehicleActivity = getBoundsOfVehicleActivity;
exports.focusOnVehicleActivity = focusOnVehicleActivity;
exports.getResolvedVehicleActivity = getResolvedVehicleActivity;
exports.getSpeedBeforeIndex = getSpeedBeforeIndex;
exports.createRouteFromSection = createRouteFromSection;
exports.getActiveSectionNumberOfSectionIndex = getActiveSectionNumberOfSectionIndex;


function getPinStatusOfSection(vehicleId, sectionIndex) {
	var descriptor = _vehicleActivities2.default.get(vehicleId);
	if (!descriptor) return false;
	if (descriptor.pinnedSections[sectionIndex] === undefined) return false;
	return descriptor.pinnedSections[sectionIndex] || false;
}

function getVisibilityOfActivity(vehicleId) {
	var displayedDetails = _displayedDetails2.default.get();
	var descriptor = _openedDetails2.default.get(vehicleId);
	if (!displayedDetails || !descriptor) return false;
	if (displayedDetails.id == vehicleId && descriptor.activePage == "activity") return true;
	return false;
}

function getLatLngOfVehicleRoutesByTime(vehicleId, time) {
	var activityDescriptor = _vehicleActivities2.default.get(vehicleId);
	if (!activityDescriptor || !activityDescriptor.routes) {
		return null;
	}

	var routes = activityDescriptor.routes;

	//route, amiben benne van az időpont
	var route = routes.find(function (route) {
		return route.length && route[0].time <= time && route[route.length - 1].time >= time;
	});

	if (!route) {
		return null;
	}

	var position = route.find(function (e) {
		return e.time == time;
	});

	if (!position) {
		return null;
	}

	return new google.maps.LatLng(position.point.coordinates[1], position.point.coordinates[0]);
}

function createPathFromInterval(vehicleId, from, to) {
	var descriptor = _vehicleActivities2.default.get(vehicleId);
	if (!descriptor) return null;

	var routes = descriptor.routes;

	var path = [];

	routes.forEach(function (route) {
		//csak akkor nézzük meg a szakasz koordinátáit, ha a szakasz valamely része benne van a from-to intervallumban
		if (route.length && (route[0].time >= from && route[0].time <= to || route[route.length - 1].time <= to || route[route.length - 1].time >= to)) {
			route.forEach(function (position) {
				if (position.time >= from && position.time <= to) {
					path.push((0, _geo.positionToLatLng)(position));
				}
			});
		}
	});

	return path;
}

function getBoundsOfVehicleActivity(vehicleId, from, to) {
	var path = createPathFromInterval(vehicleId, from, to);
	if (!path || path.length == 0) return null;
	var bounds = new google.maps.LatLngBounds();
	path.forEach(function (latLng) {
		return bounds.extend(latLng);
	});
	return bounds;
}

function focusOnVehicleActivity(vehicleId, from, to) {

	if (!getVisibilityOfActivity(vehicleId)) return;

	var descriptor = _vehicleActivities2.default.get(vehicleId);
	if (!descriptor) return;

	from = from || descriptor.from;
	to = to || descriptor.to;

	var bounds = getBoundsOfVehicleActivity(vehicleId, from, to);
	if (!bounds || bounds.isEmpty()) return;

	_dispatcher2.default.dispatch("setMap", {
		bounds: bounds.toJSON()
	});
}

function getFormatedTime(time) {
	var timeDiffHours = parseInt(time / 1000 / 60 / 60);
	var timeDiffMinutes = parseInt(time / 1000 / 60 % 60);
	return (timeDiffHours > 0 ? timeDiffHours + " h " : "") + timeDiffMinutes + " m";
}

function getDataString(data, application, representationType) {
	var wellQuantity = (0, _createWellQuantity2.default)((0, _user.getUnitAssignment)(), application, data.value, data.unit, representationType);
	return wellQuantity.value + " " + wellQuantity.unit;
}

function getResolvedSection(rawSection) {
	return {
		start: {
			address: rawSection.start.address || _lang2.default.UNKNOWN,
			time: new Date(rawSection.start.time.value),
			position: rawSection.start.position && rawSection.start.position.value ? (0, _geo.pointToLatLng)(rawSection.start.position.value).toJSON() : null,
			totalVehicleDistance: getDataString(rawSection.start.totalVehicleDistance, "distanceTraveled", "Float"),
			truncated: rawSection.start.truncated
		},
		end: {
			address: rawSection.end.address || _lang2.default.UNKNOWN,
			time: new Date(rawSection.end.time.value),
			position: rawSection.end.position && rawSection.end.position.value ? (0, _geo.pointToLatLng)(rawSection.end.position.value).toJSON() : null,
			totalVehicleDistance: getDataString(rawSection.end.totalVehicleDistance, "distanceTraveled", "Float"),
			truncated: rawSection.end.truncated
		},
		avgSpeed: getDataString(rawSection.avgSpeed, "vehicleSpeed", "Integer"),
		maxSpeed: getDataString(rawSection.maxSpeed, "vehicleSpeed", "Integer"),
		totalVehicleDistanceDiff: getDataString(rawSection.totalVehicleDistanceDiff, "distanceTraveled", "Float"),
		timeDiff: getFormatedTime(rawSection.timeDiff.value),
		active: rawSection.active || false,
		truncated: rawSection.truncated || false
	};
}

function getResolvedVehicleActivity(vehicleId) {
	var descriptor = _vehicleActivities2.default.get(vehicleId);
	if (!descriptor) return null;

	return {
		summary: getResolvedSection(descriptor.summary),
		sections: descriptor.sections.map(getResolvedSection)
	};
}

function getSpeedBeforeIndex(section, index) {
	var avgSpeedTypeId = dataTypeStore.get("AvgSpeed")._id;

	for (var i = index; i > 0; i--) {
		if (section.data[i].dataType == avgSpeedTypeId) {
			return section.data[i].value;
		}
	}

	return 0;
}

function iirFilterRoute(route, a) {

	var result = new Array(route.length);
	result[0] = {
		speed: route[0].speed,
		time: route[0].time,
		point: route[0].point
	};

	for (var i = 1; i < route.length; ++i) {

		var timeDiff = (route[i].time - route[i - 1].time) / 1000;
		if (timeDiff < 1) {
			timeDiff = 1;
		}
		var actualAParam = Math.pow(a, 1 / timeDiff);

		result[i] = {
			speed: actualAParam * route[i].speed + (1 - actualAParam) * result[i - 1].speed,
			time: route[i].time,
			point: route[i].point
		};
	}

	return result;
}

function createRouteFromSection(section) {
	var positionTypeId = dataTypeStore.get("Position")._id;

	var route = [];

	section.data.forEach(function (e, i) {
		if (e.dataType == positionTypeId) {
			route.push({ time: e.time, point: e.point, speed: getSpeedBeforeIndex(section, i) });
		}
	});

	if (route.length > 0) {
		for (var i = 0; i < 3; i++) {
			route = iirFilterRoute(route, 0.04);
		}
	}

	return route;
}

function getActiveSectionNumberOfSectionIndex(vehicleId, sectionIndex) {
	var sections = _vehicleActivities2.default.get(vehicleId).sections;

	if (!sections[sectionIndex].active) {
		return null;
	}

	var sectionNumber = 1;

	sections.forEach(function (section, index) {
		if (index < sectionIndex && section.active) {
			sectionNumber++;
		}
	});

	return sectionNumber;
}

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getResolvedSummaryOfSummaries = exports.getResolvedSummary = exports.getResolvedSection = exports.focusOnVehiclePOICrossing = exports.focusOnVehiclePOICrossings = exports.getBoundsOfPOICrossings = exports.getPOICrossingByTime = exports.getVisibilityOfPOICrossings = undefined;

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _createWellQuantity = __webpack_require__(88);

var _createWellQuantity2 = _interopRequireDefault(_createWellQuantity);

var _geo = __webpack_require__(53);

var _poi = __webpack_require__(46);

var _user = __webpack_require__(20);

var _vehiclePOICrossings = __webpack_require__(89);

var _vehiclePOICrossings2 = _interopRequireDefault(_vehiclePOICrossings);

var _displayedDetails = __webpack_require__(44);

var _displayedDetails2 = _interopRequireDefault(_displayedDetails);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	getVisibilityOfPOICrossings: getVisibilityOfPOICrossings,
	getPOICrossingByTime: getPOICrossingByTime,
	getBoundsOfPOICrossings: getBoundsOfPOICrossings,
	focusOnVehiclePOICrossings: focusOnVehiclePOICrossings,
	focusOnVehiclePOICrossing: focusOnVehiclePOICrossing,
	getResolvedSection: getResolvedSection,
	getResolvedSummary: getResolvedSummary,
	getResolvedSummaryOfSummaries: getResolvedSummaryOfSummaries
};
exports.getVisibilityOfPOICrossings = getVisibilityOfPOICrossings;
exports.getPOICrossingByTime = getPOICrossingByTime;
exports.getBoundsOfPOICrossings = getBoundsOfPOICrossings;
exports.focusOnVehiclePOICrossings = focusOnVehiclePOICrossings;
exports.focusOnVehiclePOICrossing = focusOnVehiclePOICrossing;
exports.getResolvedSection = getResolvedSection;
exports.getResolvedSummary = getResolvedSummary;
exports.getResolvedSummaryOfSummaries = getResolvedSummaryOfSummaries;


function getVisibilityOfPOICrossings(vehicleId) {
	var displayedDetails = _displayedDetails2.default.get();
	var descriptor = _openedDetails2.default.get(vehicleId);
	if (!displayedDetails || !descriptor) return false;
	if (displayedDetails.id == vehicleId && descriptor.activePage == "poiCrossings") return true;
	return false;
}

function getPOICrossingByTime(vehicleId, time) {
	return _vehiclePOICrossings2.default.get(vehicleId).result.crossings.find(function (e) {
		return e.time == time;
	});
}

function getBoundsOfPOICrossings(vehicleId) {
	var descriptor = _vehiclePOICrossings2.default.get(vehicleId);
	if (!descriptor) {
		return null;
	}

	var bounds = new google.maps.LatLngBounds();
	descriptor.result.crossings.forEach(function (crossing) {
		var latLng = (0, _geo.pointToLatLng)(crossing.location);
		bounds.extend(latLng);
	});

	return bounds;
}

function focusOnVehiclePOICrossings(vehicleId) {
	if (!getVisibilityOfPOICrossings(vehicleId)) {
		return;
	}

	var descriptor = _vehiclePOICrossings2.default.get(vehicleId);
	if (!descriptor) {
		return;
	}

	var bounds = getBoundsOfPOICrossings(vehicleId);
	if (!bounds || bounds.isEmpty()) {
		return;
	}

	_dispatcher2.default.dispatch("setMap", {
		bounds: bounds.toJSON()
	});
}

function focusOnVehiclePOICrossing(vehicleId, time) {
	if (!getVisibilityOfPOICrossings(vehicleId)) {
		return;
	}

	var descriptor = _vehiclePOICrossings2.default.get(vehicleId);
	if (!descriptor) {
		return;
	}

	var crossing = descriptor.result.crossings.find(function (crossing) {
		return crossing.time == time;
	});
	if (!crossing) {
		return;
	}

	_dispatcher2.default.dispatch("setMap", {
		center: (0, _geo.pointToLatLng)(crossing.location),
		zoom: 15
	});
}

function getFormattedTime(time) {
	var timeDiffHours = parseInt(time / 1000 / 60 / 60);
	var timeDiffMinutes = parseInt(time / 1000 / 60 % 60);
	if (timeDiffMinutes > 0) {
		return (timeDiffHours > 0 ? timeDiffHours + " h " : "") + timeDiffMinutes + " m";
	} else {
		var timeDiffSeconds = parseInt(time / 1000);
		return timeDiffSeconds + " s";
	}
}

function getDataString(data, application, representationType) {
	var wellQuantity = (0, _createWellQuantity2.default)((0, _user.getUnitAssignment)(), application, data.value, data.unit, representationType);
	return wellQuantity.value + " " + wellQuantity.unit;
}

function getResolvedAggregatedTimeObjects(data) {
	var formattedData = Object.assign({}, data);

	for (var key in formattedData) {
		if (key != "unit") {
			formattedData[key] = getFormattedTime(formattedData[key]);
		}
	}

	return formattedData;
}

function getResolvedAggregatedDataObjects(data, application, representationType) {
	var resolvedData = Object.assign({}, data);

	for (var key in resolvedData) {
		resolvedData[key] = getDataString({ value: data[key], unit: data.unit }, application, representationType);
	}

	return resolvedData;
}

function getResolvedSection(rawSection) {
	return {
		start: {
			address: rawSection.start.address || _lang2.default.UNKNOWN,
			time: new Date(rawSection.start.time.value),
			timeStamp: rawSection.start.time.value,
			position: rawSection.start.location && rawSection.start.location.value ? (0, _geo.pointToLatLng)(rawSection.start.location.value).toJSON() : null,
			totalVehicleDistance: getDataString(rawSection.start.totalVehicleDistance, "distanceTraveled", "Float"),
			truncated: rawSection.start.truncated
		},
		end: {
			address: rawSection.end.address || _lang2.default.UNKNOWN,
			time: new Date(rawSection.end.time.value),
			timeStamp: rawSection.end.time.value,
			position: rawSection.end.position && rawSection.end.position.value ? (0, _geo.pointToLatLng)(rawSection.end.position.value).toJSON() : null,
			totalVehicleDistance: getDataString(rawSection.end.totalVehicleDistance, "distanceTraveled", "Float"),
			truncated: rawSection.end.truncated
		},
		starts: rawSection.starts.value,
		stops: rawSection.stops.value,
		ignitionTime: getFormattedTime(rawSection.ignitionTime.value),
		nonIgnitionTime: getFormattedTime(rawSection.nonIgnitionTime.value),
		poi: (0, _poi.getNameOfPOI)(rawSection.poi),
		avgSpeed: getDataString(rawSection.avgSpeed, "vehicleSpeed", "Integer"),
		maxSpeed: getDataString(rawSection.maxSpeed, "vehicleSpeed", "Integer"),
		totalVehicleDistanceDiff: getDataString(rawSection.totalVehicleDistanceDiff, "distanceTraveled", "Float"),
		timeDiff: getFormattedTime(rawSection.timeDiff.value)
	};
}

function getResolvedSummary(rawSummary) {
	return {
		arrivals: rawSummary.arrivals.value,
		departures: rawSummary.departures.value,
		ignitionTime: getResolvedAggregatedTimeObjects(rawSummary.ignitionTime),
		speed: getResolvedAggregatedDataObjects(rawSummary.speed, "vehicleSpeed", "Integer"),
		nonIgnitionTime: getResolvedAggregatedTimeObjects(rawSummary.nonIgnitionTime),
		poi: (0, _poi.getNameOfPOI)(rawSummary.poi),
		sectionCount: rawSummary.sectionCount.value,
		starts: rawSummary.starts,
		stops: rawSummary.stops,
		timeDiff: getResolvedAggregatedTimeObjects(rawSummary.timeDiff),
		totalVehicleDistanceDiff: getResolvedAggregatedDataObjects(rawSummary.totalVehicleDistanceDiff, "distanceTraveled", "Float")
	};
}

function getResolvedSummaryOfSummaries(rawSummary) {
	return {
		arrivals: rawSummary.arrivals.value,
		departures: rawSummary.departures.value,
		ignitionTime: getFormattedTime(rawSummary.ignitionTime.value),
		nonIgnitionTime: getFormattedTime(rawSummary.nonIgnitionTime.value),
		poiCount: rawSummary.poiCount.value,
		starts: rawSummary.starts.value,
		stops: rawSummary.stops.value,
		timeDiff: getFormattedTime(rawSummary.timeDiff.value),
		totalVehicleDistanceDiff: getDataString(rawSummary.totalVehicleDistanceDiff, "distanceTraveled", "Float")
	};
}

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(47);
var TAG = __webpack_require__(18)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(47);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ },
/* 108 */
/***/ function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var EventPluginRegistry = __webpack_require__(188);
var EventPluginUtils = __webpack_require__(189);
var ReactErrorUtils = __webpack_require__(193);

var accumulateInto = __webpack_require__(288);
var forEachAccumulated = __webpack_require__(289);
var invariant = __webpack_require__(7);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var EventPluginHub = __webpack_require__(109);
var EventPluginUtils = __webpack_require__(189);

var accumulateInto = __webpack_require__(288);
var forEachAccumulated = __webpack_require__(289);
var warning = __webpack_require__(17);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ },
/* 111 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var SyntheticEvent = __webpack_require__(64);

var getEventTarget = __webpack_require__(198);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ },
/* 113 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
'use strict';

/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(322);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Icon2.default;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Picker = __webpack_require__(333);

var _Picker2 = _interopRequireDefault(_Picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Picker2.default;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tabs = __webpack_require__(340);

var _Tabs2 = _interopRequireDefault(_Tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Tabs2.default;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Nominatim = __webpack_require__(346);

var _Nominatim2 = _interopRequireDefault(_Nominatim);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {

	var geocoder = null;
	var nominatim = null;

	function initGeocoder() {
		if (!google || !google.maps || !google.maps.Geocoder) throw new Error("Missing requirement: google.maps.Geocoder");
		if (geocoder) return;
		geocoder = new google.maps.Geocoder();
	}

	function initNominatim() {
		if (!_Nominatim2.default) throw new Error("Missing requirement: Nominatim");
		if (nominatim) return;
		nominatim = new _Nominatim2.default();
	}

	function isGeoPoint(request) {
		if (request.constructor !== Object) return false;
		if (!request.type || request.type !== 'Point') return false;
		if (!request.coordinates || request.coordinates.constructor !== Array) return false;
		if (request.coordinates.length !== 2) return false;
		return true;
	}

	function latLngToPoint(latLng) {
		return {
			type: "Point",
			coordinates: [latLng.lng(), latLng.lat()]
		};
	}

	/**
 	@param {String} [engine=google]
 	@param {google.maps.LatLng | String} request In the case of string, this is the requested address
 	@param {geocoder~callback} [callback]
 */

	function geocode(engine, request, callback) {

		engine = engine || "google";
		callback = callback || function (err, result) {};

		if (!request) return;
		if (engine === 'google') initGeocoder();else if (engine === 'nominatim') initNominatim();
		if (request.constructor === String) {
			return geocodeAddress(request, callback);
		} else if (request.constructor === google.maps.LatLng) {
			return geocodePosition(engine, request, callback);
		} else if (isGeoPoint(request)) {
			return geocodePosition(engine, new google.maps.LatLng(request.coordinates[1], request.coordinates[0]), callback);
		}
	}

	/**
 	@callback geocoder~callback
 		@param {Error} error
 		@param {String|google.maps.LatLng} result
 */

	function geocodePosition(engine, position, callback) {

		callback = callback || function (error, address) {};

		return new Promise(function (resolve, reject) {
			if (engine === 'google') {
				geocoder.geocode({ location: position }, function (results, status) {
					if (status == google.maps.GeocoderStatus.OK && results.length) {
						try {
							_api2.default.storeAddress(latLngToPoint(position), results[0].formatted_address);
						} catch (error) {}
						callback(null, results[0].formatted_address);
						resolve(results[0].formatted_address);
					} else {
						var error = new Error(status);
						callback(error);
						reject(error);
					}
				});
			} else if (engine === 'nominatim') {
				nominatim.geocode(position, function (error, address) {
					if (error) {
						callback(error);
						return;
					}
					try {
						_api2.default.storeAddress(latLngToPoint(position), address);
					} catch (error) {}
					callback(null, address);
					resolve(address);
				});
			}
		});
	}

	function geocodeAddress(address, callback) {

		callback = callback || function (error, position) {};

		return new Promise(function (resolve, reject) {
			geocoder.geocode({ address: address }, function (results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					if (results.length) {
						callback(null, results[0].geometry.location);
						resolve(results[0].geometry.location);
					} else {
						var error = new Error("No results");
						callback(error, null);
						reject(error);
					}
				} else {
					var _error = new Error("GeocoderStatus: " + status);
					callback(_error, null);
					reject(_error);
				}
			});
		});
	}

	return geocode;
}();

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getContext = __webpack_require__(150);

var _getContext2 = _interopRequireDefault(_getContext);

var _cookie = __webpack_require__(208);

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {

	var isChromeApp = (0, _getContext2.default)() == "chromeapp";

	function get(callback) {

		callback = callback || function (t) {};

		return new Promise(function (resolve) {
			if (isChromeApp) {
				chrome.storage.local.get("token", function (result) {

					if (Object.keys(result).length != 0) {
						callback(result.token);
						resolve(result.token);
					} else {
						callback(null);
						resolve(null);
					}
				});
			} else {
				callback(_cookie2.default.get("token"));
				resolve(_cookie2.default.get("token"));
			}
		});
	}

	function set(token) {
		if (isChromeApp) {
			chrome.storage.local.set({ token: token });
		} else {
			_cookie2.default.set('token', token, { path: '/', expires: 30 });
		}
	}

	function remove() {
		if (isChromeApp) {
			chrome.storage.local.remove("token");
		} else {
			_cookie2.default.clear('token', { path: '/' });
		}
	}

	return {
		get: get,
		set: set,
		remove: remove
	};
}();

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

var _pois = __webpack_require__(29);

var _pois2 = _interopRequireDefault(_pois);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var poiModificationStore = new _flux.Collection({ keyNames: ["poi"] });
exports.default = poiModificationStore;


window.poiModificationStore = poiModificationStore;

function updateModifications(poiId, modifications) {
	var document = poiModificationStore.get(poiId);
	if (!document) return;
	Object.assign(document.modifications, modifications);
	poiModificationStore.update(poiId, document);
}

_dispatcher2.default.on('modifyPOI', function (poiId, modifications) {
	if (!poiModificationStore.get(poiId)) {
		poiModificationStore.insert([{
			poi: poiId,
			modifications: modifications || {}
		}]);
	} else {
		updateModifications(poiId, modifications);
	}
});

_dispatcher2.default.on("restorePOIShape", function (poiId) {
	var document = poiModificationStore.get(poiId);
	if (!document) return;
	delete document.modifications.location;
	delete document.modifications.radius;
	poiModificationStore.update(poiId, document);
});

_pois2.default.on("update", function (poi) {
	poiModificationStore.remove([poi._id]);
});

_pois2.default.on("remove", function (pois) {
	poiModificationStore.remove(pois.map(function (p) {
		return p._id;
	}));
});

_openedDetails2.default.on("remove", function (detailsDescriptors) {
	poiModificationStore.remove(detailsDescriptors.map(function (d) {
		return d.id;
	}));
});

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceStore = new _flux.Collection({ keyNames: ["_id", "name"] });
exports.default = serviceStore;


window.serviceStore = serviceStore;

_dispatcher2.default.on('getServices', function (services) {
  return serviceStore.set(services);
});

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

var _dataTypes = __webpack_require__(68);

var _dataTypes2 = _interopRequireDefault(_dataTypes);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

var _vehicleActivity = __webpack_require__(104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vehicleActivityStore = new _flux.Collection({ keyNames: ["vehicle"] });
exports.default = vehicleActivityStore;


window.vehicleActivityStore = vehicleActivityStore;

function createStoreItemFromActivity(report, from, to) {
	return {
		vehicle: report.options.carrier,
		from: from,
		to: to,
		summary: report.result.summary,
		sections: report.result.sections,
		routes: report.result.sections.map(_vehicleActivity.createRouteFromSection),
		selectedRoute: { from: null, to: null },
		selectedPosition: null,
		pinnedSections: report.result.sections.map(function (s) {
			return true;
		}),
		highlightedSections: report.result.sections.map(function (s) {
			return false;
		}),
		pending: false
	};
}

function createStoreItemForPendingActivity(vehicleId, from, to) {
	return {
		vehicle: vehicleId,
		from: from,
		to: to,
		summary: null,
		sections: [],
		routes: [],
		selectedRoute: null,
		selectedPosition: null,
		pinnedSections: null,
		highlightedSections: null,
		pending: true
	};
}

_dispatcher2.default.on('clearVehicleActivity', function (vehicleId) {
	vehicleActivityStore.remove([vehicleId]);
});

_dispatcher2.default.on('getVehicleActivity', function (report, from, to) {
	var prevActivity = vehicleActivityStore.get(report.options.carrier);
	if (prevActivity) vehicleActivityStore.update(report.options.carrier, createStoreItemFromActivity(report, from, to));else vehicleActivityStore.insert([createStoreItemFromActivity(report, from, to)]);
});

_dispatcher2.default.on("setPendingActivity", function (vehicleId, from, to) {
	var prevActivity = vehicleActivityStore.get(vehicleId);
	var storeItem = createStoreItemForPendingActivity(vehicleId, from, to);
	if (prevActivity) {
		vehicleActivityStore.update(vehicleId, storeItem);
	} else {
		vehicleActivityStore.insert([storeItem]);
	}
});

_dispatcher2.default.on("highlightVehicleActivitySection", function (vehicleId, sectionIndexes, value) {
	var descriptor = vehicleActivityStore.get(vehicleId);
	if (!descriptor) return;

	sectionIndexes.forEach(function (sectionIndex) {
		if (descriptor.highlightedSections[sectionIndex] === undefined) return;
		descriptor.highlightedSections[sectionIndex] = value;
	});
	vehicleActivityStore.update(vehicleId, descriptor);
});

_dispatcher2.default.on("pinVehicleActivitySection", function (vehicleId, sectionIndexes, value) {
	var descriptor = vehicleActivityStore.get(vehicleId);
	if (!descriptor) return;

	sectionIndexes.forEach(function (sectionIndex) {
		if (descriptor.pinnedSections[sectionIndex] === undefined) return;
		descriptor.pinnedSections[sectionIndex] = value;
	});
	vehicleActivityStore.update(vehicleId, descriptor);
});

_dispatcher2.default.on("selectVehicleActivityRoute", function (vehicleId) {
	var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	var to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	if (!vehicleId) return;
	var descriptor = vehicleActivityStore.get(vehicleId);
	if (!descriptor) {
		return;
	}
	descriptor.selectedRoute = { from: from, to: to };
	vehicleActivityStore.update(vehicleId, descriptor);
});

_dispatcher2.default.on("selectVehicleActivityPosition", function (vehicleId, time) {
	var descriptor = vehicleActivityStore.get(vehicleId);
	if (!descriptor) {
		return;
	}
	descriptor.selectedPosition = time;
	vehicleActivityStore.update(vehicleId, descriptor);
});

_openedDetails2.default.on('remove', function (descriptors) {
	vehicleActivityStore.remove(descriptors.map(function (descriptor) {
		return descriptor.id;
	}));
});

_dispatcher2.default.on("logout", function () {
	vehicleActivityStore.set(null);
});

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

var _session = __webpack_require__(30);

var _session2 = _interopRequireDefault(_session);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vehicleStateStore = new _flux.Collection({ keyNames: ["carrier"] });
exports.default = vehicleStateStore;


window.vehicleStateStore = vehicleStateStore;

_dispatcher2.default.on('getVehicleStates', function (vehicleStates) {
	return vehicleStateStore.set(vehicleStates);
});

_dispatcher2.default.on('logout', function () {
	return vehicleStateStore.set(null);
});

_dispatcher2.default.on('newCarrierState', function (carrierState) {
	vehicleStateStore.update(carrierState.carrier, carrierState);
});

/*// ÁTMENETI FÜGGVÉNY AZ ÁTÁLLÁS MIATT
function flatCarrierState(carrierState) {
	
	return {
		carrier: carrierState.carrier,
		state: Object.keys(carrierState.state).map(dataTypeId => {
			const data = carrierState.state[dataTypeId];
			if (data.type == "LogicalStateChange")
				data.type = "Logical";
			return data;
		})
	};
}*/

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(42);
var toLength = __webpack_require__(24);
var toAbsoluteIndex = __webpack_require__(84);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var global = __webpack_require__(9);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(36);
var redefineAll = __webpack_require__(82);
var meta = __webpack_require__(72);
var forOf = __webpack_require__(77);
var anInstance = __webpack_require__(76);
var isObject = __webpack_require__(13);
var fails = __webpack_require__(11);
var $iterDetect = __webpack_require__(129);
var setToStringTag = __webpack_require__(93);
var inheritIfRequired = __webpack_require__(166);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var hide = __webpack_require__(35);
var redefine = __webpack_require__(36);
var fails = __webpack_require__(11);
var defined = __webpack_require__(55);
var wks = __webpack_require__(18);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(8);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(47);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(13);
var cof = __webpack_require__(47);
var MATCH = __webpack_require__(18)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(18)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// Forced replacement prototype accessors methods
module.exports = __webpack_require__(71) || !__webpack_require__(11)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(9)[K];
});


/***/ },
/* 131 */
/***/ function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(31);
var ctx = __webpack_require__(49);
var forOf = __webpack_require__(77);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

var core = __webpack_require__(48);
var global = __webpack_require__(9);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(71) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(8);
var aFunction = __webpack_require__(31);
var SPECIES = __webpack_require__(18)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var hide = __webpack_require__(35);
var uid = __webpack_require__(85);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 138 */
/***/ function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _assign = __webpack_require__(19);

var EventPluginRegistry = __webpack_require__(188);
var ReactEventEmitterMixin = __webpack_require__(799);
var ViewportMetrics = __webpack_require__(287);

var getVendorPrefixedEventName = __webpack_require__(831);
var isEventSupported = __webpack_require__(199);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var SyntheticUIEvent = __webpack_require__(112);
var ViewportMetrics = __webpack_require__(287);

var getEventModifierState = __webpack_require__(197);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(7);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ },
/* 143 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */

'use strict';

// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(32);
var DOMNamespaces = __webpack_require__(187);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(195);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ },
/* 145 */
/***/ function(module, exports) {

"use strict";
"use strict";

module.exports = function getServiceSet(setType, entityName, user, entity, allItems) {

	// megnézzük, benne van-e services-ben
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = user.services[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var serviceSet = _step.value;

			if (serviceSet.type == setType && serviceSet.value[entityName] == entity._id) return serviceSet;
		}

		// ha nincs, keressük meg a groupját és vizsgáljunk arra
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	if (entity.groups.length == 0) return null;

	var _iteratorNormalCompletion2 = true;
	var _didIteratorError2 = false;
	var _iteratorError2 = undefined;

	try {
		for (var _iterator2 = allItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
			var item = _step2.value;

			if (entity.groups.indexOf(item._id) > -1) {
				var groupServiceSet = getServiceSet(setType, entityName, user, item, allItems);
				if (groupServiceSet) return groupServiceSet;
			}
		}
	} catch (err) {
		_didIteratorError2 = true;
		_iteratorError2 = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion2 && _iterator2.return) {
				_iterator2.return();
			}
		} finally {
			if (_didIteratorError2) {
				throw _iteratorError2;
			}
		}
	}

	return null;
};

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ConfirmDialog = __webpack_require__(315);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ConfirmDialog2.default;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DateTimePicker = __webpack_require__(316);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DateTimePicker2.default;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Details = __webpack_require__(317);

var _Details2 = _interopRequireDefault(_Details);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Details2.default;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IntervalEditor = __webpack_require__(325);

var _IntervalEditor2 = _interopRequireDefault(_IntervalEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _IntervalEditor2.default;

/***/ },
/* 150 */
/***/ function(module, exports) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getContext;
function getContext() {
    if (window.chrome && chrome.app && chrome.app.runtime) {
        return "chromeapp";
    } else {
        return "browser";
    }
}

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(poiId) {
		var response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return _api2.default.get("pois/collaborations", { _id: poiId });

					case 3:
						response = _context.sent;

						_dispatcher2.default.dispatch("getPOICollaborations", poiId, response.collaborations);
						_context.next = 14;
						break;

					case 7:
						_context.prev = 7;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0)) {
							_context.next = 13;
							break;
						}

						new _Toast2.default(_lang2.default.SOMETHING_WRONG, "orange");
						_context.next = 14;
						break;

					case 13:
						throw _context.t0;

					case 14:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 7]]);
	}));

	function getPOICollaborations(_x) {
		return _ref.apply(this, arguments);
	}

	return getPOICollaborations;
}();

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function getWellFormatedPosition(position) {
	if (!position) return null;

	if (position.type !== undefined && position.type == "Point" && position.coordinates) {
		return position;
	} else if (position.lat !== undefined && position.lng !== undefined) {
		return {
			type: "Point",
			coordinates: [position.lng, position.lat]
		};
	} else if (position instanceof google.maps.LatLng) {
		return {
			type: "Point",
			coordinates: [position.lng(), position.lat()]
		};
	} else return null;
}

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(position, address) {
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						if (!(!position || !address)) {
							_context.next = 2;
							break;
						}

						return _context.abrupt("return");

					case 2:
						_context.next = 4;
						return _api2.default.post('addresses', {
							addresses: [{
								position: getWellFormatedPosition(position),
								address: address
							}]
						});

					case 4:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	function storeAddress(_x, _x2) {
		return _ref.apply(this, arguments);
	}

	return storeAddress;
}();

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

var _pois = __webpack_require__(29);

var _pois2 = _interopRequireDefault(_pois);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var editedPOIStore = new _flux.Singleton();
exports.default = editedPOIStore;


window.editedPOIStore = editedPOIStore;

_dispatcher2.default.on('editPOI', function (poiId) {
	editedPOIStore.set(poiId || null);
});

_pois2.default.on("update", function (poi) {
	if (editedPOIStore.get() == poi._id) editedPOIStore.set(null);
});

_pois2.default.on("remove", function (pois) {
	pois.forEach(function (poi) {
		if (editedPOIStore.get() == poi._id) editedPOIStore.set(null);
	});
});

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

var _vehicles = __webpack_require__(45);

var _vehicles2 = _interopRequireDefault(_vehicles);

var _filterGroups = __webpack_require__(67);

var _filterGroups2 = _interopRequireDefault(_filterGroups);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pinnedVehicleStore = new _flux.Collection();
exports.default = pinnedVehicleStore;


window.pinnedVehicleStore = pinnedVehicleStore;

_vehicles2.default.on('set', function (vehicles) {
	if (!vehicles) pinnedVehicleStore.set(null);
});

_vehicles2.default.on('insert', function (vehicles) {

	// amennyiben az összes jármű fel van pinelve,
	// úgy feltételezzük, hogy ezt is fel akarjuk pinelni

	var numOfVehicles = (0, _filterGroups2.default)(_vehicles2.default.getAll()).length;
	var numOfPinnedVehicles = pinnedVehicleStore.getAll().length;

	if (numOfVehicles == numOfPinnedVehicles + vehicles.length) {
		pinnedVehicleStore.insert(vehicles.map(function (v) {
			return v._id;
		}));
	}
});

_vehicles2.default.on('remove', function (vehicles) {
	return pinnedVehicleStore.remove(vehicles.map(function (v) {
		return v._id;
	}));
});

_dispatcher2.default.on('pinVehicles', function (vehicleIds, value) {

	if (!vehicleIds) return;

	if (value == true) pinnedVehicleStore.insert(vehicleIds);else pinnedVehicleStore.remove(vehicleIds);
});

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

var _pois = __webpack_require__(29);

var _pois2 = _interopRequireDefault(_pois);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var poiCollaborationStore = new _flux.Collection({
	keyNames: ["poi"],
	multi: {
		keyNames: ["collaborator"]
	}
});
exports.default = poiCollaborationStore;


window.poiCollaborationStore = poiCollaborationStore;

_dispatcher2.default.on('getPOICollaborations', function (poiId, collaborations) {
	poiCollaborationStore.get(poiId).set(collaborations);
});

_dispatcher2.default.on("updateCollaboration", function (poiId, collaboration) {
	poiCollaborationStore.get(poiId).update(collaboration.collaborator, collaboration);
});

_dispatcher2.default.on("removeCollaboration", function (poiId, collaborator) {
	poiCollaborationStore.get(poiId).remove([collaborator]);
});

_dispatcher2.default.on("addCollaboration", function (poiId, collaboration) {
	poiCollaborationStore.get(poiId).insert([collaboration]);
});

_dispatcher2.default.on("logout", function () {
	poiCollaborationStore.set(null);
});

_pois2.default.on('remove', function (pois) {
	poiCollaborationStore.remove(pois.map(function (p) {
		return p._id;
	}));
});

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

var _pois = __webpack_require__(29);

var _pois2 = _interopRequireDefault(_pois);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectedPOIStore = new _flux.Singleton();
exports.default = selectedPOIStore;


window.selectedPOIStore = selectedPOIStore;

_dispatcher2.default.on('selectPOI', function (poiId) {
	return selectedPOIStore.set(poiId || null);
});

_pois2.default.on("remove", function (pois) {
	pois.forEach(function (poi) {
		if (selectedPOIStore.get() == poi._id) selectedPOIStore.set(null);
	});
});

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectedVehicleStore = new _flux.Singleton();
exports.default = selectedVehicleStore;


window.selectedVehicleStore = selectedVehicleStore;

_dispatcher2.default.on('selectVehicle', function (vehicleId) {
	return selectedVehicleStore.set(vehicleId || null);
});

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vehicleHeatmapStore = new _flux.Collection({ keyNames: ["vehicle"] });
exports.default = vehicleHeatmapStore;


window.vehicleHeatmapStore = vehicleHeatmapStore;

function createStoreItemFromHeatmap(report) {
	return {
		vehicle: report.options.carrier,
		sections: report.result.sections,
		show: { routes: true, stops: true }
	};
}

_dispatcher2.default.on('getVehicleHeatmap', function (report) {
	var prevHeatmap = vehicleHeatmapStore.get(report.options.carrier);
	if (prevHeatmap) vehicleHeatmapStore.update(report.options.carrier, createStoreItemFromHeatmap(report));else vehicleHeatmapStore.insert([createStoreItemFromHeatmap(report)]);
});

openedDetailsStore.on('remove', function (descriptors) {
	vehicleHeatmapStore.remove(descriptors.map(function (descriptor) {
		return descriptor.id;
	}));
});

_dispatcher2.default.on("showVehicleHeatmapElements", function (vehicle, showedElements) {
	var descriptor = vehicleHeatmapStore.get(vehicle);
	if (!descriptor) {
		return;
	}
	descriptor.show = showedElements;

	vehicleHeatmapStore.update(vehicle, descriptor);
});

_dispatcher2.default.on("logout", function () {
	vehicleHeatmapStore.set(null);
});

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';
var toObject = __webpack_require__(27);
var toAbsoluteIndex = __webpack_require__(84);
var toLength = __webpack_require__(24);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(476);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $defineProperty = __webpack_require__(23);
var createDesc = __webpack_require__(81);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
var document = __webpack_require__(9).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ },
/* 163 */
/***/ function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(18)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

var document = __webpack_require__(9).document;
module.exports = document && document.documentElement;


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
var setPrototypeOf = __webpack_require__(174).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(92);
var ITERATOR = __webpack_require__(18)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var create = __webpack_require__(78);
var descriptor = __webpack_require__(81);
var setToStringTag = __webpack_require__(93);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(35)(IteratorPrototype, __webpack_require__(18)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var LIBRARY = __webpack_require__(71);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(36);
var hide = __webpack_require__(35);
var Iterators = __webpack_require__(92);
var $iterCreate = __webpack_require__(168);
var setToStringTag = __webpack_require__(93);
var getPrototypeOf = __webpack_require__(41);
var ITERATOR = __webpack_require__(18)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ },
/* 170 */
/***/ function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ },
/* 171 */
/***/ function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var macrotask = __webpack_require__(180).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(47)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(31);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(13);
var anObject = __webpack_require__(8);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(49)(Function.call, __webpack_require__(40).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

var shared = __webpack_require__(134)('keys');
var uid = __webpack_require__(85);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(57);
var defined = __webpack_require__(55);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(128);
var defined = __webpack_require__(55);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var toInteger = __webpack_require__(57);
var defined = __webpack_require__(55);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ },
/* 179 */
/***/ function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(49);
var invoke = __webpack_require__(242);
var html = __webpack_require__(165);
var cel = __webpack_require__(162);
var global = __webpack_require__(9);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(47)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var global = __webpack_require__(9);
var DESCRIPTORS = __webpack_require__(22);
var LIBRARY = __webpack_require__(71);
var $typed = __webpack_require__(136);
var hide = __webpack_require__(35);
var redefineAll = __webpack_require__(82);
var fails = __webpack_require__(11);
var anInstance = __webpack_require__(76);
var toInteger = __webpack_require__(57);
var toLength = __webpack_require__(24);
var toIndex = __webpack_require__(260);
var gOPN = __webpack_require__(79).f;
var dP = __webpack_require__(23).f;
var arrayFill = __webpack_require__(159);
var setToStringTag = __webpack_require__(93);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var core = __webpack_require__(48);
var LIBRARY = __webpack_require__(71);
var wksExt = __webpack_require__(261);
var defineProperty = __webpack_require__(23).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

var classof = __webpack_require__(106);
var ITERATOR = __webpack_require__(18)('iterator');
var Iterators = __webpack_require__(92);
module.exports = __webpack_require__(48).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var addToUnscopables = __webpack_require__(70);
var step = __webpack_require__(245);
var Iterators = __webpack_require__(92);
var toIObject = __webpack_require__(42);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(169)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ },
/* 185 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */

'use strict';

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var DOMLazyTree = __webpack_require__(96);
var Danger = __webpack_require__(776);
var ReactDOMComponentTree = __webpack_require__(25);
var ReactInstrumentation = __webpack_require__(51);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(195);
var setInnerHTML = __webpack_require__(144);
var setTextContent = __webpack_require__(295);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ },
/* 187 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(7);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var ReactErrorUtils = __webpack_require__(193);

var invariant = __webpack_require__(7);
var warning = __webpack_require__(17);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ },
/* 190 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var ReactPropTypesSecret = __webpack_require__(805);
var propTypesFactory = __webpack_require__(272);

var React = __webpack_require__(99);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(7);
var warning = __webpack_require__(17);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(7);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = function () {
        func(a);
      };
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var ReactCurrentOwner = __webpack_require__(65);
var ReactInstanceMap = __webpack_require__(111);
var ReactInstrumentation = __webpack_require__(51);
var ReactUpdates = __webpack_require__(60);

var invariant = __webpack_require__(7);
var warning = __webpack_require__(17);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ },
/* 195 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals MSApp */

'use strict';

/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 196 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ },
/* 197 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ },
/* 198 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(32);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ },
/* 200 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _assign = __webpack_require__(19);

var emptyFunction = __webpack_require__(59);
var warning = __webpack_require__(17);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonGroup = __webpack_require__(310);

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ButtonGroup2.default;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ColorPicker = __webpack_require__(314);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ColorPicker2.default;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InputWithUnit = __webpack_require__(323);

var _InputWithUnit2 = _interopRequireDefault(_InputWithUnit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _InputWithUnit2.default;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _List = __webpack_require__(326);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _List2.default;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Popup = __webpack_require__(335);

var _Popup2 = _interopRequireDefault(_Popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Popup2.default;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextFilter = __webpack_require__(341);

var _TextFilter2 = _interopRequireDefault(_TextFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TextFilter2.default;

/***/ },
/* 208 */
/***/ function(module, exports) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var DEFAULT_EXPIRES = 30;

function set(name, value, options) {

	options = options || {};

	var s = "";
	var d = void 0;

	s += name + "=" + value;

	if (options.expires) {
		if (options.expires.constructor === Date) {
			d = options.expires;
		} else if (options.expires.constructor === Number) {
			d = new Date();
			d.setDate(d.getDate() + options.expires);
		}
	} else {
		d = new Date();
		d.setDate(d.getDate() + DEFAULT_EXPIRES);
	}

	s += "; expires=" + d.toGMTString();

	if (options.domain) s += "; domain=" + options.domain;
	if (options.path) s += "; path=" + options.path;

	document.cookie = s;
}

/** @method: Cookie.get
	
	@arguments:
		@name: String
*/

function get(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
	}
	return "";
}

/** @method: Cookie.clear
	
	@arguments:
		@name: String
		@options: {
			@path: String
			@domain: String
		}
*/

function clear(name, options) {
	if (!name || !get(name)) return;
	options = options || {};
	set(name, '', {
		expires: new Date(),
		path: options.path || null,
		domain: options.domain || null
	});
};

exports.default = {
	set: set,
	get: get,
	clear: clear
};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getContext = __webpack_require__(150);

var _getContext2 = _interopRequireDefault(_getContext);

var _cookie = __webpack_require__(208);

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hostProvider = function () {

	var isChromeApp = (0, _getContext2.default)() == "chromeapp";

	function get(callback) {

		callback = callback || function (host) {};

		return new Promise(function (resolve) {

			if (isChromeApp) {
				chrome.storage.local.get("host", function (result) {

					if (Object.keys(result).length != 0) {
						callback(result.host);
						resolve(result.host);
					} else {
						callback(null);
						resolve(null);
					}
				});
			} else {
				var host = _cookie2.default.get('host');
				callback(host || window.location.host);
				resolve(host || window.location.host);
			}
		});
	}

	function set(host) {
		return new Promise(function (resolve) {
			if (isChromeApp) {
				chrome.storage.local.set({ host: host }, resolve);
			} else {
				_cookie2.default.set('host', host, { path: '/', expires: 30 });
			}
		});
	}

	function remove() {
		if (isChromeApp) {
			chrome.storage.local.remove("host");
		} else {
			_cookie2.default.clear('host', { path: '/' });
		}
	}

	return {
		get: get,
		set: set,
		remove: remove
	};
}();

window.host = hostProvider;

exports.default = hostProvider;

/***/ },
/* 210 */
/***/ function(module, exports) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {

	function linear(a, b) {
		a = a !== undefined && a !== null ? a : 1;
		b = b || 0;

		return function (x) {
			return a * x + b;
		};
	}

	function factor(a) {
		return linear(a, 0);
	}

	function convert(from, to, value) {

		if (!from || !to) return value;

		return conversionTables[from][to](value);
	}

	var conversionTables = {
		mm: {
			mm: factor(1),
			cm: factor(1 / 10),
			m: factor(1 / 10 / 100),
			km: factor(1 / 10 / 100 / 1000),
			in: factor(0.0393700787),
			ft: factor(0.0032808399),
			yd: factor(0.0010936133),
			mi: factor(6.21371192e-7)
		},
		cm: {
			mm: factor(10),
			cm: factor(1),
			m: factor(1 / 100),
			km: factor(1 / 100 / 1000),
			in: factor(0.393700787),
			ft: factor(0.032808399),
			yd: factor(0.010936133),
			mi: factor(6.21371192e-6)
		},
		m: {
			mm: factor(1000),
			cm: factor(100),
			m: factor(1),
			km: factor(1 / 1000),
			in: factor(39.3700787),
			ft: factor(3.2808399),
			yd: factor(1.0936133),
			mi: factor(0.000621371192)
		},
		km: {
			mm: factor(1000000),
			cm: factor(100000),
			m: factor(1000),
			km: factor(1),
			in: factor(39370.0787),
			ft: factor(3280.8399),
			yd: factor(1093.6133),
			mi: factor(0.621371192)
		},
		in: {
			mm: factor(25.4),
			cm: factor(2.54),
			m: factor(0.0254),
			km: factor(2.54e-5),
			in: factor(1),
			ft: factor(0.0833333333),
			yd: factor(0.0277777778),
			mi: factor(1.57828283e-5)
		},
		ft: {
			mm: factor(304.8),
			cm: factor(30.48),
			m: factor(0.3048),
			km: factor(0.0003048),
			in: factor(12),
			ft: factor(1),
			yd: factor(0.333333333),
			mi: factor(0.000189393939)
		},
		yd: {
			mm: factor(914.4),
			cm: factor(91.44),
			m: factor(0.9144),
			km: factor(0.0009144),
			in: factor(36),
			ft: factor(3),
			yd: factor(1),
			mi: factor(0.000568181818)
		},
		mi: {
			mm: factor(1609344),
			cm: factor(160934.4),
			m: factor(1609.344),
			km: factor(1.609344),
			in: factor(63360),
			ft: factor(5280),
			yd: factor(1760),
			mi: factor(1)
		},
		ms: {
			ms: factor(1),
			s: factor(1 / 1000),
			min: factor(1 / 1000 / 60),
			h: factor(1 / 1000 / 60 / 60),
			d: factor(1 / 1000 / 60 / 60 / 24),
			y: factor(1 / 1000 / 60 / 60 / 24 / 365.25)
		},
		s: {
			ms: factor(1000),
			s: factor(1),
			min: factor(1 / 60),
			h: factor(1 / 60 / 60),
			d: factor(1 / 60 / 60 / 24),
			y: factor(1 / 60 / 60 / 24 / 365.25)
		},
		min: {
			ms: factor(1000 * 60),
			s: factor(60),
			min: factor(1),
			h: factor(1 / 60),
			d: factor(1 / 60 / 24),
			y: factor(1 / 60 / 24 / 365.25)
		},
		h: {
			ms: factor(1000 * 60 * 60),
			s: factor(60 * 60),
			min: factor(60),
			h: factor(1),
			d: factor(1 / 24),
			y: factor(1 / 24 / 365.25)
		},
		d: {
			ms: factor(1000 * 60 * 60 * 24),
			s: factor(60 * 60 * 24),
			min: factor(60 * 24),
			h: factor(24),
			d: factor(1),
			y: factor(1 / 365.25)
		},
		y: {
			ms: factor(1000 * 60 * 60 * 24 * 365.25),
			s: factor(60 * 60 * 24 * 365.25),
			min: factor(60 * 24 * 365.25),
			h: factor(24 * 365.25),
			d: factor(365.25),
			y: factor(1)
		},
		kg: {
			kg: factor(1),
			lb: factor(2.20462262)
		},
		lb: {
			kg: factor(0.45359237),
			lb: factor(1)
		},
		l: {
			l: factor(1),
			gal: factor(0.264172052)
		},
		gal: {
			l: factor(3.78541178),
			gal: factor(1)
		},
		"km/h": {
			"km/h": factor(1),
			mph: factor(0.621371192)
		},
		mph: {
			"km/h": factor(1.609344),
			mph: factor(1)
		},
		V: {
			V: factor(1)
		},
		"l/100km": {
			"l/100km": factor(1),
			mpg: function mpg(x) {
				var alfa = conversionTables['km']['mi'](1);
				var beta = conversionTables['l']['gal'](1);
				return 100 * alfa / beta / x;
			}
		},
		mpg: {
			"l/100km": function l100km(x) {
				var alfa = conversionTables['km']['mi'](1);
				var beta = conversionTables['l']['gal'](1);
				return 100 * alfa / beta / x;
			},
			mpg: factor(1)
		},
		rpm: {
			rpm: factor(1)
		},
		'%': {
			'%': factor(1)
		},
		'°C': {
			'°C': factor(1),
			'°F': linear(1.8, 32),
			'°K': linear(1, 273.15)
		},
		'°F': {
			'°C': linear(1 / 1.8, -32 / 1.8),
			'°F': factor(1),
			'°K': linear(5 / 9, 459.67 * 5 / 9)
		},
		'°K': {
			'°C': linear(1, -273.15),
			'°F': linear(1.8, 32 - 1.8 * 273.15),
			'°K': factor(1)
		}
	};

	return convert;
}();

/***/ },
/* 211 */
/***/ function(module, exports) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = format;
function format(value) {
	return isNaN(parseInt(value)) ? value.trim() === "" ? null : value : parseInt(value);
}

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getOriginalValueFromWellQuantity;

var _convertUnit = __webpack_require__(210);

var _convertUnit2 = _interopRequireDefault(_convertUnit);

var _format = __webpack_require__(211);

var _format2 = _interopRequireDefault(_format);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getOriginalValueFromWellQuantity(quantity, originalUnit, representationType) {

	representationType = representationType || 'Float';
	var wellParse = representationType.toLowerCase() === 'integer' ? _format2.default : function (x) {
		return x;
	};

	if (quantity.value === null || quantity.value === "") return null;

	if (!originalUnit) return wellParse(quantity.value);

	return wellParse((0, _convertUnit2.default)(quantity.unit, originalUnit, quantity.value));
}

/***/ },
/* 213 */
/***/ function(module, exports) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = round;
function round(x, prec) {
	prec = prec !== undefined && prec !== null ? prec : 1;
	var factor = Math.pow(10, prec);
	return Math.round(x * factor) / factor;
}

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var addEventDescriptor = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(eventDescriptor) {
		var response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						console.log("eventDescriptor", eventDescriptor);
						_context.prev = 1;
						_context.next = 4;
						return _api2.default.post("eventDescriptors", {
							eventDescriptors: [eventDescriptor]
						});

					case 4:
						response = _context.sent;

						_dispatcher2.default.dispatch("createEventDescriptor", response.eventDescriptors[0]);
						return _context.abrupt("return", response.eventDescriptors[0]._id);

					case 9:
						_context.prev = 9;
						_context.t0 = _context["catch"](1);

						if (!("id" in _context.t0)) {
							_context.next = 15;
							break;
						}

						new _Toast2.default(_lang2.default.SOMETHING_WRONG, "orange");
						_context.next = 16;
						break;

					case 15:
						throw _context.t0;

					case 16:
						return _context.abrupt("return", null);

					case 17:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[1, 9]]);
	}));

	return function addEventDescriptor(_x) {
		return _ref.apply(this, arguments);
	};
}();

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _user = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(eventDescriptor, notificationConfig) {
		var eventDescriptorId, userId, response;
		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return addEventDescriptor(eventDescriptor);

					case 2:
						eventDescriptorId = _context2.sent;

						if (eventDescriptorId) {
							_context2.next = 5;
							break;
						}

						return _context2.abrupt("return", false);

					case 5:
						_context2.prev = 5;
						userId = (0, _user.getUserId)();

						if (userId) {
							_context2.next = 9;
							break;
						}

						return _context2.abrupt("return");

					case 9:
						_context2.next = 11;
						return _api2.default.post("users/notifications", {
							_id: (0, _user.getUserId)(),
							notifications: [{
								descriptor: eventDescriptorId,
								web: notificationConfig.web,
								email: notificationConfig.email,
								sms: notificationConfig.sms
							}]
						});

					case 11:
						response = _context2.sent;

						_dispatcher2.default.dispatch("createNotificationConfig", response.notifications[0]);
						return _context2.abrupt("return", true);

					case 16:
						_context2.prev = 16;
						_context2.t0 = _context2["catch"](5);

						if (!("id" in _context2.t0)) {
							_context2.next = 22;
							break;
						}

						new _Toast2.default(_lang2.default.SOMETHING_WRONG, "orange");
						_context2.next = 23;
						break;

					case 22:
						throw _context2.t0;

					case 23:
						return _context2.abrupt("return", false);

					case 24:
					case "end":
						return _context2.stop();
				}
			}
		}, _callee2, this, [[5, 16]]);
	}));

	function addNotificationConfig(_x2, _x3) {
		return _ref2.apply(this, arguments);
	}

	return addNotificationConfig;
}();

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

// CÍMFELOLDÁS

var resolveAddresses = function () {
	var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(result) {
		var summary, activeSections, uniqPositionSet, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						summary = result.summary;
						activeSections = result.sections.filter(function (s) {
							return s.active;
						});
						uniqPositionSet = createUniqPositionSet(summary, activeSections);
						_iteratorNormalCompletion = true;
						_didIteratorError = false;
						_iteratorError = undefined;
						_context2.prev = 6;
						_iterator = uniqPositionSet[Symbol.iterator]();

					case 8:
						if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
							_context2.next = 25;
							break;
						}

						item = _step.value;

						if (!item.address) {
							_context2.next = 12;
							break;
						}

						return _context2.abrupt("continue", 22);

					case 12:
						_context2.prev = 12;
						_context2.next = 15;
						return (0, _geocode2.default)('nominatim', item.position);

					case 15:
						item.address = _context2.sent;
						_context2.next = 18;
						return (0, _storeAddress2.default)(item.position, item.address);

					case 18:
						_context2.next = 22;
						break;

					case 20:
						_context2.prev = 20;
						_context2.t0 = _context2["catch"](12);

					case 22:
						_iteratorNormalCompletion = true;
						_context2.next = 8;
						break;

					case 25:
						_context2.next = 31;
						break;

					case 27:
						_context2.prev = 27;
						_context2.t1 = _context2["catch"](6);
						_didIteratorError = true;
						_iteratorError = _context2.t1;

					case 31:
						_context2.prev = 31;
						_context2.prev = 32;

						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}

					case 34:
						_context2.prev = 34;

						if (!_didIteratorError) {
							_context2.next = 37;
							break;
						}

						throw _iteratorError;

					case 37:
						return _context2.finish(34);

					case 38:
						return _context2.finish(31);

					case 39:

						resolveUniqPositionSet(summary, activeSections, uniqPositionSet);

					case 40:
					case "end":
						return _context2.stop();
				}
			}
		}, _callee2, this, [[6, 27, 31, 39], [12, 20], [32,, 34, 38]]);
	}));

	return function resolveAddresses(_x5) {
		return _ref2.apply(this, arguments);
	};
}();

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _geocode = __webpack_require__(117);

var _geocode2 = _interopRequireDefault(_geocode);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _user = __webpack_require__(20);

var _storeAddress = __webpack_require__(152);

var _storeAddress2 = _interopRequireDefault(_storeAddress);

var _resolver = __webpack_require__(225);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(vehicleId, from, to) {
		var sectionLimit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.1;
		var reportResponse, details, report;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;

						_dispatcher2.default.dispatch("setPendingActivity", vehicleId, from, to);
						_context.next = 4;
						return _api2.default.get("reports", {
							carrier: vehicleId,
							from: from,
							to: to,
							type: "VehicleActivity",
							user: (0, _user.getUserId)(),
							sectionLimit: sectionLimit
						});

					case 4:
						reportResponse = _context.sent;
						details = _openedDetails2.default.get(vehicleId);

						if (details) {
							_context.next = 8;
							break;
						}

						return _context.abrupt("return");

					case 8:
						report = reportResponse.reports[0];
						_context.next = 11;
						return resolveAddresses(report.result);

					case 11:
						_dispatcher2.default.dispatch("getVehicleActivity", report, from, to);
						_context.next = 21;
						break;

					case 14:
						_context.prev = 14;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0)) {
							_context.next = 20;
							break;
						}

						new _Toast2.default(_lang2.default.OPERATION_FAILED, "orange");
						_context.next = 21;
						break;

					case 20:
						throw _context.t0;

					case 21:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 14]]);
	}));

	function getVehicleActivity(_x, _x2, _x3) {
		return _ref.apply(this, arguments);
	}

	return getVehicleActivity;
}();

function createUniqPositionSet(summary, activeSections) {

	var posAddMap = {};

	(0, _resolver.extendAddressPositionPairForUniqPositionMap)(posAddMap, summary.start.position ? summary.start.position.value : null, summary.start.address);
	(0, _resolver.extendAddressPositionPairForUniqPositionMap)(posAddMap, summary.end.position ? summary.end.position.value : null, summary.end.address);

	activeSections.forEach(function (section) {
		(0, _resolver.extendAddressPositionPairForUniqPositionMap)(posAddMap, section.start.position ? section.start.position.value : null, section.start.address);
		(0, _resolver.extendAddressPositionPairForUniqPositionMap)(posAddMap, section.end.position ? section.end.position.value : null, section.end.address);
	});

	// creating set from map
	return (0, _resolver.uniqPositionMapToUniqPositionSet)(posAddMap);
}

function resolveUniqPositionSet(summary, activeSections, uniqPositionSet) {

	var uniqPositionMap = (0, _resolver.uniqPositionSetToUniqPositionMap)(uniqPositionSet);

	summary.start.address = (0, _resolver.getAddressFromUniqPositionMapByPosition)(uniqPositionMap, summary.start.position ? summary.start.position.value : null);
	summary.end.address = (0, _resolver.getAddressFromUniqPositionMapByPosition)(uniqPositionMap, summary.end.position ? summary.end.position.value : null);

	activeSections.forEach(function (section) {
		section.start.address = (0, _resolver.getAddressFromUniqPositionMapByPosition)(uniqPositionMap, section.start.position ? section.start.position.value : null);
		section.end.address = (0, _resolver.getAddressFromUniqPositionMapByPosition)(uniqPositionMap, section.end.position ? section.end.position.value : null);
	});
}

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var removeEventDescriptor = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(eventDescriptorId) {
		var response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return _api2.default.delete("eventDescriptors", {
							eventDescriptors: [eventDescriptorId]
						});

					case 3:
						response = _context.sent;

						_dispatcher2.default.dispatch("removeEventDescriptor", eventDescriptorId);
						_context.next = 14;
						break;

					case 7:
						_context.prev = 7;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0)) {
							_context.next = 13;
							break;
						}

						new _Toast2.default(_lang2.default.SOMETHING_WRONG, "orange");
						_context.next = 14;
						break;

					case 13:
						throw _context.t0;

					case 14:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 7]]);
	}));

	return function removeEventDescriptor(_x) {
		return _ref.apply(this, arguments);
	};
}();

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _user = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(eventDescriptorId) {
		var userId, response;
		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return removeEventDescriptor(eventDescriptorId);

					case 2:
						_context2.prev = 2;
						userId = (0, _user.getUserId)();

						if (userId) {
							_context2.next = 6;
							break;
						}

						return _context2.abrupt("return");

					case 6:
						_context2.next = 8;
						return _api2.default.delete("users/notifications", {
							_id: (0, _user.getUserId)(),
							descriptors: [eventDescriptorId]
						});

					case 8:
						response = _context2.sent;

						_dispatcher2.default.dispatch("removeNotificationConfig");
						return _context2.abrupt("return", true);

					case 13:
						_context2.prev = 13;
						_context2.t0 = _context2["catch"](2);

						if (!("id" in _context2.t0)) {
							_context2.next = 19;
							break;
						}

						new _Toast2.default(_lang2.default.SOMETHING_WRONG, "orange");
						_context2.next = 20;
						break;

					case 19:
						throw _context2.t0;

					case 20:
						return _context2.abrupt("return", false);

					case 21:
					case "end":
						return _context2.stop();
				}
			}
		}, _callee2, this, [[2, 13]]);
	}));

	function removeNotificationConfig(_x2) {
		return _ref2.apply(this, arguments);
	}

	return removeNotificationConfig;
}();

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var resolve = function () {
	var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(point) {
		var address;
		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						if (point) {
							_context2.next = 2;
							break;
						}

						return _context2.abrupt("return");

					case 2:
						address = null;
						_context2.prev = 3;
						_context2.next = 6;
						return (0, _geocode2.default)('nominatim', point);

					case 6:
						address = _context2.sent;
						_context2.next = 19;
						break;

					case 9:
						_context2.prev = 9;
						_context2.t0 = _context2["catch"](3);
						_context2.prev = 11;
						_context2.next = 14;
						return (0, _geocode2.default)('google', point);

					case 14:
						address = _context2.sent;
						_context2.next = 19;
						break;

					case 17:
						_context2.prev = 17;
						_context2.t1 = _context2["catch"](11);

					case 19:
						return _context2.abrupt("return", address);

					case 20:
					case "end":
						return _context2.stop();
				}
			}
		}, _callee2, this, [[3, 9], [11, 17]]);
	}));

	return function resolve(_x2) {
		return _ref2.apply(this, arguments);
	};
}();

var _geocode = __webpack_require__(117);

var _geocode2 = _interopRequireDefault(_geocode);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _dataTypes = __webpack_require__(68);

var _dataTypes2 = _interopRequireDefault(_dataTypes);

var _storeAddress = __webpack_require__(152);

var _storeAddress2 = _interopRequireDefault(_storeAddress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(carrierState) {
		var state, positionId, position, address;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						state = carrierState.state;
						positionId = _dataTypes2.default.get("Position")._id;
						position = state.find(function (data) {
							return data.dataType == positionId;
						});

						if (position) {
							_context.next = 5;
							break;
						}

						return _context.abrupt("return");

					case 5:
						if (!position.address) {
							_context.next = 7;
							break;
						}

						return _context.abrupt("return");

					case 7:
						_context.next = 9;
						return resolve(position.point);

					case 9:
						address = _context.sent;

						position.address = address;
						(0, _storeAddress2.default)(position.point, address);

					case 12:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	function resolveCarrierState(_x) {
		return _ref.apply(this, arguments);
	}

	return resolveCarrierState;
}();

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _editedPOI = __webpack_require__(153);

var _editedPOI2 = _interopRequireDefault(_editedPOI);

var _poiModifications = __webpack_require__(119);

var _poiModifications2 = _interopRequireDefault(_poiModifications);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(poiId) {
		var modificationDoc, response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						modificationDoc = _poiModifications2.default.get(poiId);

						if (modificationDoc) {
							_context.next = 3;
							break;
						}

						return _context.abrupt("return");

					case 3:
						_context.prev = 3;
						_context.next = 6;
						return _api2.default.put("pois", {
							pois: [modificationDoc.poi],
							modifications: modificationDoc.modifications
						});

					case 6:
						response = _context.sent;

						_dispatcher2.default.dispatch("updatePOI", response.pois[0]);
						_context.next = 17;
						break;

					case 10:
						_context.prev = 10;
						_context.t0 = _context["catch"](3);

						if (!("id" in _context.t0)) {
							_context.next = 16;
							break;
						}

						new _Toast2.default(_lang2.default.SOMETHING_WRONG, "orange");
						_context.next = 17;
						break;

					case 16:
						throw _context.t0;

					case 17:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[3, 10]]);
	}));

	function savePOI(_x) {
		return _ref.apply(this, arguments);
	}

	return savePOI;
}();

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var updateEventDescriptor = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(eventDescriptor) {
		var oldEventDescriptor, modifications, response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						oldEventDescriptor = _eventDescriptors2.default.get(eventDescriptor._id);
						modifications = (0, _getModificationsByRef2.default)(oldEventDescriptor, eventDescriptor);

						if (modifications) {
							_context.next = 5;
							break;
						}

						return _context.abrupt("return");

					case 5:

						if (modifications.carriers) {
							modifications.carriers = eventDescriptor.carriers;
						}

						if (modifications.pois) {
							modifications.pois = eventDescriptor.pois;
						}

						_context.next = 9;
						return _api2.default.put("eventDescriptors", {
							eventDescriptors: [eventDescriptor._id],
							modifications: modifications
						});

					case 9:
						response = _context.sent;

						_dispatcher2.default.dispatch("updateEventDescriptor", response.eventDescriptors[0]);
						_context.next = 20;
						break;

					case 13:
						_context.prev = 13;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0)) {
							_context.next = 19;
							break;
						}

						new _Toast2.default(_lang2.default.SOMETHING_WRONG, "orange");
						_context.next = 20;
						break;

					case 19:
						throw _context.t0;

					case 20:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 13]]);
	}));

	return function updateEventDescriptor(_x) {
		return _ref.apply(this, arguments);
	};
}();

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _eventDescriptors = __webpack_require__(103);

var _eventDescriptors2 = _interopRequireDefault(_eventDescriptors);

var _session = __webpack_require__(30);

var _session2 = _interopRequireDefault(_session);

var _getModificationsByRef = __webpack_require__(101);

var _getModificationsByRef2 = _interopRequireDefault(_getModificationsByRef);

var _user = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(eventDescriptor, notificationConfig) {
		var userId, oldNotificationConfig, modifications, response;
		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return updateEventDescriptor(eventDescriptor);

					case 2:
						_context2.prev = 2;
						userId = (0, _user.getUserId)();

						if (userId) {
							_context2.next = 6;
							break;
						}

						return _context2.abrupt("return");

					case 6:

						//utilsba ki?
						oldNotificationConfig = _session2.default.get().user.services.find(function (e) {
							return e.type == "NotificationSet" && e.value.descriptor == eventDescriptor._id;
						}).value;
						modifications = (0, _getModificationsByRef2.default)(oldNotificationConfig, notificationConfig);

						if (modifications) {
							_context2.next = 10;
							break;
						}

						return _context2.abrupt("return");

					case 10:
						_context2.next = 12;
						return _api2.default.put("users/notifications", {
							_id: (0, _user.getUserId)(),
							descriptors: [eventDescriptor._id],
							modifications: modifications
						});

					case 12:
						response = _context2.sent;

						_dispatcher2.default.dispatch("updateNotificationConfig", response.notifications[0]);
						return _context2.abrupt("return", true);

					case 17:
						_context2.prev = 17;
						_context2.t0 = _context2["catch"](2);

						if (!("id" in _context2.t0)) {
							_context2.next = 23;
							break;
						}

						new _Toast2.default(_lang2.default.SOMETHING_WRONG, "orange");
						_context2.next = 24;
						break;

					case 23:
						throw _context2.t0;

					case 24:
						return _context2.abrupt("return", false);

					case 25:
					case "end":
						return _context2.stop();
				}
			}
		}, _callee2, this, [[2, 17]]);
	}));

	function updateNotificationConfig(_x2, _x3) {
		return _ref2.apply(this, arguments);
	}

	return updateNotificationConfig;
}();

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var autoZoomStore = new _flux.Singleton();
exports.default = autoZoomStore;


window.autoZoomStore = autoZoomStore;

autoZoomStore.set(false);

_dispatcher2.default.on('toggleAutoZoom', function () {
	autoZoomStore.set(!autoZoomStore.get());
});

_dispatcher2.default.on('turnOffAutoZoom', function () {
	autoZoomStore.set(false);
});

_dispatcher2.default.on('logout', function () {
	autoZoomStore.set(false);
});

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateStore = new _flux.Singleton();
exports.default = mapStateStore;


window.mapStateStore = mapStateStore;

_dispatcher2.default.on('setMap', function (mapStateDescriptor) {
	return mapStateStore.set(mapStateDescriptor);
});

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapTooltipStore = new _flux.Singleton();
exports.default = mapTooltipStore;


window.mapTooltipStore = mapTooltipStore;

_dispatcher2.default.on("createTooltip", function (id, position, label) {
	var icon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

	mapTooltipStore.set({
		id: id,
		position: position,
		icon: icon,
		label: label
	});
});

_dispatcher2.default.on("removeTooltip", function (id) {
	var descriptor = mapTooltipStore.get();
	if (descriptor && id == descriptor.id) {
		mapTooltipStore.set(null);
	}
});

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

var _pois = __webpack_require__(29);

var _pois2 = _interopRequireDefault(_pois);

var _filterGroups = __webpack_require__(67);

var _filterGroups2 = _interopRequireDefault(_filterGroups);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pinnedPOIStore = new _flux.Collection();
exports.default = pinnedPOIStore;


window.pinnedPOIStore = pinnedPOIStore;

_pois2.default.on('set', function (pois) {
	if (!pois) {
		pinnedPOIStore.set(null);
	} else {
		pinnedPOIStore.insert(pois.map(function (e) {
			return e._id;
		}));
	}
});

_pois2.default.on('insert', function (pois) {

	// amennyiben az �sszes poi fel van pinelve,
	// �gy felt�telezz�k, hogy ezt is fel akarjuk pinelni

	var numOfPOIs = (0, _filterGroups2.default)(_pois2.default.getAll()).length;
	var numOfPinnedPOIs = pinnedPOIStore.getAll().length;

	if (numOfPOIs == numOfPinnedPOIs + pois.length) {
		pinnedPOIStore.insert(pois.map(function (p) {
			return p._id;
		}));
	}
});

_pois2.default.on('remove', function (pois) {
	return pinnedPOIStore.remove(pois.map(function (p) {
		return p._id;
	}));
});

_dispatcher2.default.on('pinPOIs', function (poiIds, value) {

	if (!poiIds) return;

	if (value == true) pinnedPOIStore.insert(poiIds);else pinnedPOIStore.remove(poiIds);
});

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

var _vehicles = __webpack_require__(45);

var _vehicles2 = _interopRequireDefault(_vehicles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vehicleModificationStore = new _flux.Collection({ keyNames: ["vehicle"] });
exports.default = vehicleModificationStore;


window.vehicleModificationStore = vehicleModificationStore;

function updateModifications(vehicleId, modifications) {
	var document = vehicleModificationStore.get(vehicleId);
	if (!document) return;
	var newModificationDoc = {
		vehicle: document.vehicle,
		modifications: Object.assign({}, document.modifications, modifications)
	};
	vehicleModificationStore.update(vehicleId, newModificationDoc);
}

_dispatcher2.default.on('modifyVehicle', function (vehicleId, modifications) {
	if (!vehicleModificationStore.get(vehicleId)) {
		vehicleModificationStore.insert([{
			vehicle: vehicleId,
			modifications: modifications || {}
		}]);
	} else {
		updateModifications(vehicleId, modifications);
	}
});

_vehicles2.default.on("update", function (vehicle) {
	vehicleModificationStore.remove([vehicle._id]);
});

openedDetailsStore.on("remove", function (detailsDescriptors) {
	vehicleModificationStore.remove(detailsDescriptors.map(function (d) {
		return d.id;
	}));
});

/***/ },
/* 225 */
/***/ function(module, exports) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	getAddressFromUniqPositionMapByPosition: getAddressFromUniqPositionMapByPosition,
	uniqPositionMapToUniqPositionSet: uniqPositionMapToUniqPositionSet,
	uniqPositionSetToUniqPositionMap: uniqPositionSetToUniqPositionMap,
	extendAddressPositionPairForUniqPositionMap: extendAddressPositionPairForUniqPositionMap
};
exports.getAddressFromUniqPositionMapByPosition = getAddressFromUniqPositionMapByPosition;
exports.uniqPositionMapToUniqPositionSet = uniqPositionMapToUniqPositionSet;
exports.uniqPositionSetToUniqPositionMap = uniqPositionSetToUniqPositionMap;
exports.extendAddressPositionPairForUniqPositionMap = extendAddressPositionPairForUniqPositionMap;


function getAddressFromUniqPositionMapByPosition(uniqPositionMap, position) {
	if (!position) return null;
	var key = position.coordinates[0] + '&' + position.coordinates[1];
	return uniqPositionMap[key].address;
}

function uniqPositionMapToUniqPositionSet(uniqPositionMap) {
	return Object.keys(uniqPositionMap).map(function (posKey) {
		return uniqPositionMap[posKey];
	});
}

function uniqPositionSetToUniqPositionMap(uniqPositionSet) {
	var posAddMap = {};
	uniqPositionSet.forEach(function (item) {
		return posAddMap[item.key] = item;
	});
	return posAddMap;
}

function extendAddressPositionPairForUniqPositionMap(uniqPositionMap, position, address) {

	if (!position) return;

	var key = position.coordinates[0] + '&' + position.coordinates[1];

	uniqPositionMap[key] = {
		position: position,
		address: address,
		key: key
	};
}

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getHeatmapShapeOpacity = exports.getVisibilityOfHeatmap = undefined;

var _vehicleHeatmaps = __webpack_require__(158);

var _vehicleHeatmaps2 = _interopRequireDefault(_vehicleHeatmaps);

var _displayedDetails = __webpack_require__(44);

var _displayedDetails2 = _interopRequireDefault(_displayedDetails);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	getVisibilityOfHeatmap: getVisibilityOfHeatmap,
	getHeatmapShapeOpacity: getHeatmapShapeOpacity
};
exports.getVisibilityOfHeatmap = getVisibilityOfHeatmap;
exports.getHeatmapShapeOpacity = getHeatmapShapeOpacity;


function getVisibilityOfHeatmap(vehicleId) {
	var descriptor = _openedDetails2.default.get(vehicleId);
	if (!descriptor) return false;

	if (_displayedDetails2.default.get() && _displayedDetails2.default.get().id == vehicleId && descriptor.activePage == "heatmap") {
		return true;
	}

	return false;
}

function getHeatmapShapeOpacity(vehicleId) {
	var vehicleHeatmapDescriptors = _vehicleHeatmaps2.default.get(vehicleId);
	if (!vehicleHeatmapDescriptors) {
		return null;
	}

	var numOfSections = vehicleHeatmapDescriptors.sections.length;

	var A = 0.08528092937;
	var n = numOfSections || 0;
	if (n <= 1) {
		return 1;
	} else if (n >= 28) {
		return 0.1;
	} else {
		return Math.exp(A * (1 - n));
	}
}

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CriticalValueNotificationConfigForm = __webpack_require__(376);

var _CriticalValueNotificationConfigForm2 = _interopRequireDefault(_CriticalValueNotificationConfigForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CriticalValueNotificationConfigForm2.default;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Bubble = __webpack_require__(385);

var _Bubble2 = _interopRequireDefault(_Bubble);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Bubble2.default;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InfoBox = __webpack_require__(388);

var _InfoBox2 = _interopRequireDefault(_InfoBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _InfoBox2.default;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tooltip = __webpack_require__(393);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Tooltip2.default;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _POICrossingNotificationConfigForm = __webpack_require__(411);

var _POICrossingNotificationConfigForm2 = _interopRequireDefault(_POICrossingNotificationConfigForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _POICrossingNotificationConfigForm2.default;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

var cof = __webpack_require__(47);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
'use strict';
var toObject = __webpack_require__(27);
var toAbsoluteIndex = __webpack_require__(84);
var toLength = __webpack_require__(24);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(77);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(31);
var toObject = __webpack_require__(27);
var IObject = __webpack_require__(107);
var toLength = __webpack_require__(24);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var aFunction = __webpack_require__(31);
var isObject = __webpack_require__(13);
var invoke = __webpack_require__(242);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var dP = __webpack_require__(23).f;
var create = __webpack_require__(78);
var redefineAll = __webpack_require__(82);
var ctx = __webpack_require__(49);
var anInstance = __webpack_require__(76);
var forOf = __webpack_require__(77);
var $iterDefine = __webpack_require__(169);
var step = __webpack_require__(245);
var setSpecies = __webpack_require__(83);
var DESCRIPTORS = __webpack_require__(22);
var fastKey = __webpack_require__(72).fastKey;
var validate = __webpack_require__(95);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(106);
var from = __webpack_require__(234);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var redefineAll = __webpack_require__(82);
var getWeak = __webpack_require__(72).getWeak;
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(13);
var anInstance = __webpack_require__(76);
var forOf = __webpack_require__(77);
var createArrayMethod = __webpack_require__(54);
var $has = __webpack_require__(39);
var validate = __webpack_require__(95);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(127);
var isObject = __webpack_require__(13);
var toLength = __webpack_require__(24);
var ctx = __webpack_require__(49);
var IS_CONCAT_SPREADABLE = __webpack_require__(18)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(22) && !__webpack_require__(11)(function () {
  return Object.defineProperty(__webpack_require__(162)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ },
/* 242 */
/***/ function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(13);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(8);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ },
/* 245 */
/***/ function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(171);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ },
/* 247 */
/***/ function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ },
/* 248 */
/***/ function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(80);
var gOPS = __webpack_require__(131);
var pIE = __webpack_require__(108);
var toObject = __webpack_require__(27);
var IObject = __webpack_require__(107);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(11)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

var dP = __webpack_require__(23);
var anObject = __webpack_require__(8);
var getKeys = __webpack_require__(80);

module.exports = __webpack_require__(22) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(42);
var gOPN = __webpack_require__(79).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

var has = __webpack_require__(39);
var toIObject = __webpack_require__(42);
var arrayIndexOf = __webpack_require__(123)(false);
var IE_PROTO = __webpack_require__(175)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(80);
var toIObject = __webpack_require__(42);
var isEnum = __webpack_require__(108).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(79);
var gOPS = __webpack_require__(131);
var anObject = __webpack_require__(8);
var Reflect = __webpack_require__(9).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(9).parseFloat;
var $trim = __webpack_require__(94).trim;

module.exports = 1 / $parseFloat(__webpack_require__(179) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(9).parseInt;
var $trim = __webpack_require__(94).trim;
var ws = __webpack_require__(179);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ },
/* 257 */
/***/ function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var isObject = __webpack_require__(13);
var newPromiseCapability = __webpack_require__(173);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(24);
var repeat = __webpack_require__(178);
var defined = __webpack_require__(55);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(57);
var toLength = __webpack_require__(24);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(18);


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var strong = __webpack_require__(237);
var validate = __webpack_require__(95);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(124)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(22) && /./g.flags != 'g') __webpack_require__(23).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(126)
});


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var strong = __webpack_require__(237);
var validate = __webpack_require__(95);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(124)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var each = __webpack_require__(54)(0);
var redefine = __webpack_require__(36);
var meta = __webpack_require__(72);
var assign = __webpack_require__(249);
var weak = __webpack_require__(239);
var isObject = __webpack_require__(13);
var fails = __webpack_require__(11);
var validate = __webpack_require__(95);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(124)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ },
/* 266 */
/***/ function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(59);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ },
/* 268 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ },
/* 269 */
/***/ function(module, exports) {

"use strict";
'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

(function(){
  var crypt = __webpack_require__(677),
      utf8 = __webpack_require__(266).utf8,
      isBuffer = __webpack_require__(765),
      bin = __webpack_require__(266).bin,

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message))
      message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

})();


/***/ },
/* 271 */
/***/ function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(768);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(767)();
}


/***/ },
/* 274 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

exports.decode = exports.parse = __webpack_require__(769);
exports.encode = exports.stringify = __webpack_require__(770);


/***/ },
/* 276 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(86);

var invariant = __webpack_require__(7);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var DOMProperty = __webpack_require__(97);
var ReactDOMComponentTree = __webpack_require__(25);
var ReactInstrumentation = __webpack_require__(51);

var quoteAttributeValueForBrowser = __webpack_require__(832);
var warning = __webpack_require__(17);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ },
/* 279 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _assign = __webpack_require__(19);

var LinkedValueUtils = __webpack_require__(191);
var ReactDOMComponentTree = __webpack_require__(25);
var ReactUpdates = __webpack_require__(60);

var warning = __webpack_require__(17);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ },
/* 281 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ },
/* 282 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(7);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ReactDOMSelection = __webpack_require__(792);

var containsNode = __webpack_require__(752);
var focusNode = __webpack_require__(268);
var getActiveElement = __webpack_require__(269);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var DOMLazyTree = __webpack_require__(96);
var DOMProperty = __webpack_require__(97);
var React = __webpack_require__(99);
var ReactBrowserEventEmitter = __webpack_require__(140);
var ReactCurrentOwner = __webpack_require__(65);
var ReactDOMComponentTree = __webpack_require__(25);
var ReactDOMContainerInfo = __webpack_require__(786);
var ReactDOMFeatureFlags = __webpack_require__(788);
var ReactFeatureFlags = __webpack_require__(282);
var ReactInstanceMap = __webpack_require__(111);
var ReactInstrumentation = __webpack_require__(51);
var ReactMarkupChecksum = __webpack_require__(802);
var ReactReconciler = __webpack_require__(98);
var ReactUpdateQueue = __webpack_require__(194);
var ReactUpdates = __webpack_require__(60);

var emptyObject = __webpack_require__(139);
var instantiateReactComponent = __webpack_require__(293);
var invariant = __webpack_require__(7);
var setInnerHTML = __webpack_require__(144);
var shouldUpdateReactComponent = __webpack_require__(200);
var warning = __webpack_require__(17);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var React = __webpack_require__(99);

var invariant = __webpack_require__(7);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ },
/* 287 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(7);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ },
/* 289 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ReactNodeTypes = __webpack_require__(286);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(32);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ReactDOMComponentTree = __webpack_require__(25);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  inst._wrapperState.valueTracker = null;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15),
    _assign = __webpack_require__(19);

var ReactCompositeComponent = __webpack_require__(783);
var ReactEmptyComponent = __webpack_require__(281);
var ReactHostComponent = __webpack_require__(283);

var getNextDebugID = __webpack_require__(846);
var invariant = __webpack_require__(7);
var warning = __webpack_require__(17);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ },
/* 294 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(32);
var escapeTextContentForBrowser = __webpack_require__(143);
var setInnerHTML = __webpack_require__(144);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var ReactCurrentOwner = __webpack_require__(65);
var REACT_ELEMENT_TYPE = __webpack_require__(798);

var getIteratorFn = __webpack_require__(829);
var invariant = __webpack_require__(7);
var KeyEscapeUtils = __webpack_require__(190);
var warning = __webpack_require__(17);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(113),
    _assign = __webpack_require__(19);

var ReactNoopUpdateQueue = __webpack_require__(300);

var canDefineProperty = __webpack_require__(301);
var emptyObject = __webpack_require__(139);
var invariant = __webpack_require__(7);
var lowPriorityWarning = __webpack_require__(847);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(113);

var ReactCurrentOwner = __webpack_require__(65);

var invariant = __webpack_require__(7);
var warning = __webpack_require__(17);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ },
/* 299 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var warning = __webpack_require__(17);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);
var assign = __webpack_require__(19);


// DEPRECATED. Please use `svg-inline-react` package.
//
// <IconSVG src={require("svg-inline!icon.svg")} />
//
console.warn('<IconSVG />` React Component is DEPRECATED -> Use `svg-inline-react` package instead.');

var IconSVG = React.createClass({
    getDefaultProps: function getDefaultProps() {
        return {
            elementName: 'i',
            defaultClassName: 'icon-svg'
        };
    },
    propTypes: {
        src: React.PropTypes.string.isRequired,
        elementName: React.PropTypes.string
    },
    render: function render() {
        var props = assign({}, this.props,
            {
                src: null,
                dangerouslySetInnerHTML: { __html: this.props.src },
                className: (typeof this.props.className === 'string') ? this.props.className + ' ' + this.props.defaultClassName :
                                                                        this.props.defaultClassName
            }
        );

        return React.createElement(this.props.elementName, props);
    }
});

module.exports = IconSVG;


/***/ },
/* 303 */
/***/ function(module, exports) {

var g;

// This works in non-strict mode
g = (function() { return this; })();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dashboard = __webpack_require__(381);

var _Dashboard2 = _interopRequireDefault(_Dashboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Dashboard2.default;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {"use strict";

__webpack_require__(674);

__webpack_require__(675);

__webpack_require__(475);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(303)))

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(706);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../css-loader/index.js!../postcss-loader/index.js!./reset.css", function() {
		var newContent = require("!!../css-loader/index.js!../postcss-loader/index.js!./reset.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 307 */
/***/ function(module, exports) {

"use strict";
"use strict";

module.exports = ["1", "7", "20", "27", "30", "31", "32", "33", "34", "36", "39", "40", "41", "43", "44", "45", "46", "47", "48", "49", "51", "52", "53", "54", "55", "56", "57", "58", "60", "61", "62", "63", "64", "65", "66", "81", "82", "84", "86", "90", "91", "92", "93", "94", "95", "98", "212", "213", "216", "218", "220", "221", "222", "223", "224", "225", "226", "227", "228", "229", "230", "231", "232", "233", "234", "235", "236", "237", "238", "239", "240", "241", "242", "243", "244", "245", "248", "249", "250", "251", "252", "253", "254", "255", "256", "257", "258", "260", "261", "262", "263", "264", "265", "266", "267", "268", "269", "290", "291", "297", "298", "299", "350", "351", "352", "353", "354", "355", "356", "357", "358", "359", "370", "371", "372", "373", "374", "375", "376", "377", "378", "380", "381", "382", "385", "386", "387", "389", "420", "421", "423", "500", "501", "502", "503", "504", "505", "506", "507", "508", "509", "590", "591", "592", "593", "594", "595", "596", "597", "598", "599", "670", "672", "673", "674", "675", "676", "677", "678", "679", "680", "681", "682", "683", "684", "686", "687", "688", "689", "690", "691", "692", "809", "850", "852", "853", "855", "856", "880", "886", "960", "961", "962", "963", "964", "965", "966", "967", "968", "971", "972", "973", "974", "975", "976", "977", "992", "993", "994", "995", "996", "998"];

/***/ },
/* 308 */
/***/ function(module, exports) {

"use strict";
"use strict";

module.exports = {
	OBJECT_ID: /^[0-9a-fA-F]{24}$/,
	UUID: /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
	ACCESS_TOKEN: /^\d{13}.{64}$/,
	HOST: /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/,
	CONNECTABLE_DEVICE_ID: /^\d{15}$/,
	EXCEPTION_SOURCE: /^(TCP|SMS)$/,
	PROTOCOL_VERSION: /^PV[0-9]+$/,
	USERNAME: /^[a-zA-Z0-9_\-.@]{4,45}$/,
	PASSWORD: /^.{4,200}$/, // legalább 6 karakter
	EMAIL: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/,
	PHONE_COUNTRY_CODE: /^\d{1,4}$/,
	PHONE_AREA_CODE: /^\d+$/,
	PHONE_NUMBER: /^\d+$/,
	LANGUAGE: /^\w{2}$/,
	PACKET_TYPE: /^(Packet|LogPacket|TransactionPacket|FirmwarePacket|ProgPacket|DebugPacket|InfoPacket|GeneralException|DataException|FailureException|ControlException|AlertException)$/,
	CONFIG_TYPE: /^(GsmConfig|LogAppConfig|InputConfig|CANConfig|J1708Config)$/,
	ICN_FEATURED_PROTOCOL_TYPE: /^(NONE|J1939|J1708)$/,
	EMBEDDED_DATA_OPERATION: /^(LAST|MAX|MIN|AVG|SUM|COUNT|INT)$/,
	EMBEDDED_DATA_FILTER_TYPE: /^(NONE|LOWPASS|SR_LIMIT|PULSE)$/,
	CAN_DATA_ENDIANNESS: /^(LITTLE_ENDIAN|BIG_ENDIAN)$/,
	EVENT_TYPE: /^(ScalarStateChange)$/,
	OPERATOR: /^(eq|ne|gt|gte|lt|lte|in|notin|between|notbetween)$/,
	NOTIFICATION_TYPE: /^(WEB|EMAIL|SMS)$/,
	DRIVER_ID: /^\d{5}$/,
	BOOLEAN: /^(0|1|false|true)$/,
	CLIENT_TYPE: /^(WEB)|(ANDROID)|(IOS)$/,
	UTC_TIME: /^[0-9]+$/,
	FILE_KEY: /^0x1[0-9a-fA-F]{4}$/,
	LOG_MODE: /^(IGNITION_BASED|MOVEMENT_BASED)$/,
	INPUT_SOURCE: /^(TRIVIAL|VIRTUAL)$/,
	HEX_STRING: /0x[0-f0-F]{8}/,

	unit: {
		DISTANCE_TRAVELED: /^(km|mi)$/,
		TIME_TRAVELED: /^(min|h|d|y)$/,
		VEHICLE_LENGTH: /^(cm|m|inch|ft|yd)$/,
		VEHICLE_SPEED: /^(km\/h|mph)$/,
		FUEL_QUANTITY: /^(l|gal)$/,
		ENGINE_OPERATING_TIME: /^(h|d|y)$/,
		CONSUMPTION: /^(l\/100km|mpg)$/,
		WEIGHT: /^(kg|lb)$/,
		RPM: /^rpm$/,
		RATIO: /^%$/,
		TEMPERATURE: /^(°C|°F|°K)$/,
		VOLTAGE: /^V$/
	}

	/* get COMMA_SEPARATED_EMAIL(){
 	let e = this.EMAIL.source.replace('^', '').replace('$', '');
 	return new RegExp(`^(${e})(,${e})*$`);
 },
 
 get SENDER() {
 	let e = this.EMAIL.source.replace('^', '').replace('$', '');
 	return new RegExp(`^((.+\\s+<${e}>)|(${e}))$`);
 } */
};

/***/ },
/* 309 */
/***/ function(module, exports) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
	@class: TypingListener
	
	@param {HTMLInputElement|HTMLTextAreaElement} target
	@param {Number} [timeout=500] ms
	@param {TypingListener~callback} [callback]
*/

var TypingListener = function () {
	function TypingListener(target) {
		_classCallCheck(this, TypingListener);

		if (!target) throw new Error("TypingListener: target is required");

		this.target = target;
		this.timeout = TypingListener.DEFAULT_TIMEOUT;
		this.callback = function (value) {};

		for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
			options[_key - 1] = arguments[_key];
		}

		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var option = _step.value;

				if (option.constructor === Number) this.timeout = option;else if (option.constructor === Function) this.callback = option;
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		this.listener = this.target.addEventListener('keyup', function (evt) {
			if (this.typingTimeout) clearTimeout(this.typingTimeout);
			this.typingTimeout = setTimeout(function () {
				this.callback(this.target.value);
			}.bind(this), this.timeout);
		}.bind(this));
	}

	_createClass(TypingListener, [{
		key: 'abort',
		value: function abort() {
			if (this.listener) {
				this.target.removeEventListener('keyup', this.listener);
				delete this.listener;
			}
		}
	}]);

	return TypingListener;
}();

exports.default = TypingListener;


TypingListener.DEFAULT_TIMEOUT = 500;

/**
	@callback TypingListener~callback
	
	@param {String} value
*/

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(850);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonGroup = function (_React$Component) {
	_inherits(ButtonGroup, _React$Component);

	function ButtonGroup(props) {
		_classCallCheck(this, ButtonGroup);

		var _this = _possibleConstructorReturn(this, (ButtonGroup.__proto__ || Object.getPrototypeOf(ButtonGroup)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(ButtonGroup, [{
		key: "initState",
		value: function initState() {
			this.state = {
				selected: this.constructor.getSelectedValueByProps(this.props)
			};
		}
	}, {
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			var selectedValue = this.constructor.getSelectedValueByProps(this.props);
			var nextSelectedValue = this.constructor.getSelectedValueByProps(nextProps);

			if (this.props.multiSelect && !this.constructor.isTheSameSet(selectedValue, nextSelectedValue) || selectedValue != nextSelectedValue) {
				this.setState({
					selected: nextSelectedValue
				});
			}
		}
	}, {
		key: "emitChange",
		value: function emitChange() {
			if (this.props.multiSelect) this.props.onChange(this.constructor.createArrayFromSet(this.state.selected));else this.props.onChange(this.state.selected);
		}
	}, {
		key: "canRemoveSelected",
		value: function canRemoveSelected(id) {
			if (!this.props.required || this.props.required && this.state.selected.size > 1) return true;else return false;
		}
	}, {
		key: "multiSelect",
		value: function multiSelect(id) {
			if (this.state.selected.has(id)) {
				if (this.canRemoveSelected(id)) {
					this.state.selected.delete(id);
					this.emitChange();
				}
			} else {
				this.state.selected.add(id);
				this.emitChange();
			}
		}
	}, {
		key: "singleSelect",
		value: function singleSelect(id) {
			if (this.state.selected == id && this.props.required) return;

			if (this.state.selected == id) this.state.selected = null;else this.state.selected = id;

			this.emitChange();
		}
	}, {
		key: "select",
		value: function select(id) {
			if (this.props.multiSelect) this.multiSelect(id);else this.singleSelect(id);
			this.setState({});
		}
	}, {
		key: "isButtonSelected",
		value: function isButtonSelected(button) {
			if (this.props.multiSelect) return this.state.selected.has(button.props.id) ? true : false;else return this.state.selected == button.props.id ? true : false;
		}
	}, {
		key: "renderButton",
		value: function renderButton(button) {
			var _this2 = this;

			var className = (0, _classnames2.default)(button.props.className || "", { "Selected": this.isButtonSelected(button) });

			return _react2.default.createElement(
				_Button2.default,
				{
					key: button.props.id,
					className: className,
					onClick: function onClick() {
						return _this2.select(button.props.id);
					}
				},
				button.props.children
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this3 = this;

			return _react2.default.createElement(
				"div",
				{ className: (0, _classnames2.default)(this.props.className, "ButtonGroup") },
				_react2.default.createElement(
					"div",
					null,
					this.props.children.map(function (child) {
						return _this3.renderButton(child);
					})
				)
			);
		}
	}], [{
		key: "getSelectedValueByProps",
		value: function getSelectedValueByProps(props) {
			if (props.multiSelect) return new Set(props.selected || []);else return props.selected || null;
		}
	}, {
		key: "isTheSameSet",
		value: function isTheSameSet(set1, set2) {

			var comparisionSet = new Set();

			set1.forEach(function (e) {
				if (set2.has(e)) comparisionSet.add(e);
			});

			if (set1.size == comparisionSet.size) return true;
			return false;
		}
	}, {
		key: "createArrayFromSet",
		value: function createArrayFromSet(set) {
			var array = [];
			set.forEach(function (item) {
				return array.push(item);
			});
			return array;
		}
	}]);

	return ButtonGroup;
}(_react2.default.Component);

exports.default = ButtonGroup;


ButtonGroup.propTypes = {
	selected: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.array]),
	onChange: _react2.default.PropTypes.func,
	required: _react2.default.PropTypes.bool,
	multiSelect: _react2.default.PropTypes.bool
};

ButtonGroup.defaultProps = {
	onChange: function onChange(id) {},
	required: false,
	multiSelect: false
};

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(851);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = __webpack_require__(114);

var _Icon2 = _interopRequireDefault(_Icon);

var _component = __webpack_require__(302);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Button = function (_React$Component) {
	_inherits(Button, _React$Component);

	function Button() {
		_classCallCheck(this, Button);

		return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
	}

	_createClass(Button, [{
		key: "renderPicture",
		value: function renderPicture() {
			if (this.props.svg) {
				return _react2.default.createElement(_component2.default, { src: this.props.svg });
			} else if (this.props.icon) {
				return _react2.default.createElement(
					_Icon2.default,
					null,
					this.props.icon
				);
			}
		}
	}, {
		key: "renderChildren",
		value: function renderChildren() {
			if (this.props.children && this.props.children.constructor === String) return _react2.default.createElement(
				"span",
				null,
				this.props.children
			);else return this.props.children;
		}
	}, {
		key: "render",
		value: function render() {
			var className = (0, _classnames2.default)(this.props.className, "Button");
			return _react2.default.createElement(
				"button",
				_extends({}, this.props, { className: className }),
				this.renderPicture(),
				this.renderChildren()
			);
		}
	}]);

	return Button;
}(_react2.default.Component);

exports.default = Button;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(852);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Card = function (_React$Component) {
	_inherits(Card, _React$Component);

	function Card() {
		_classCallCheck(this, Card);

		return _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));
	}

	_createClass(Card, [{
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"div",
				_extends({}, this.props, { className: (0, _classnames2.default)(this.props.className, "Card") }),
				this.props.children
			);
		}
	}]);

	return Card;
}(_react2.default.Component);

exports.default = Card;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(853);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_React$Component) {
	_inherits(Checkbox, _React$Component);

	function Checkbox(props) {
		_classCallCheck(this, Checkbox);

		var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(Checkbox, [{
		key: "initState",
		value: function initState() {
			this.state = {
				value: this.constructor.getStateByProps(this.props)
			};
		}
	}, {
		key: "clickHandler",
		value: function clickHandler(evt) {
			evt.stopPropagation();

			var newValue = this.state.value > 0 ? 0 : 2;

			this.setState({
				value: newValue
			});

			this.props.onChange(newValue > 0, newValue == 1);
		}
	}, {
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.checked == this.props.checked && nextProps.indeterminate == this.props.indeterminate) return;

			this.setState({
				value: this.constructor.getStateByProps(nextProps)
			});
		}
	}, {
		key: "getIconDescriptor",
		value: function getIconDescriptor() {
			if (this.props.icon.constructor == String) {
				return this.props.icon;
			} else if (this.props.icon.constructor == Object) {
				if ("on" in this.props.icon || "off" in this.props.icon || "indeterminate" in this.props.icon) return this.props.icon[this.getValueDescriptor()];else if ("type" in this.props.icon && "src" in this.props.icon) return this.props.icon;
			}
		}
	}, {
		key: "getButtonIconProps",
		value: function getButtonIconProps() {
			var iconDescriptor = this.getIconDescriptor();
			var props = {};
			props[this.constructor.getIconType(iconDescriptor)] = this.constructor.getIconSource(iconDescriptor);
			return props;
		}
	}, {
		key: "getValueDescriptor",
		value: function getValueDescriptor() {
			switch (this.state.value) {
				case 0:
					return "off";
				case 1:
					return "indeterminate";
				case 2:
					return "on";
			}
		}
	}, {
		key: "render",
		value: function render() {
			var className = (0, _classnames2.default)(this.props.className, "Checkbox", { "Checked": this.state.value > 0 });

			return _react2.default.createElement(
				"div",
				{
					className: className,
					onClick: this.clickHandler.bind(this),
					onDoubleClick: function onDoubleClick(evt) {
						return evt.stopPropagation();
					}
				},
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(_Button2.default, this.getButtonIconProps()),
					_react2.default.createElement(
						"label",
						null,
						this.props.children
					)
				)
			);
		}
	}], [{
		key: "getStateByProps",
		value: function getStateByProps(props) {
			if (props.checked && props.indeterminate) return 1;else if (props.checked && !props.indeterminate) return 2;else return 0;
		}
	}, {
		key: "getIconType",
		value: function getIconType(iconDescriptor) {
			if (iconDescriptor.constructor == String) return "icon";else if (iconDescriptor.constructor == Object) return iconDescriptor.type;
		}
	}, {
		key: "getIconSource",
		value: function getIconSource(iconDescriptor) {
			if (iconDescriptor.constructor == String) return iconDescriptor;else if (iconDescriptor.constructor == Object) return iconDescriptor.src;
		}
	}]);

	return Checkbox;
}(_react2.default.Component);

exports.default = Checkbox;


Checkbox.iconSchema = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.shape({
	type: _react2.default.PropTypes.string,
	src: _react2.default.PropTypes.string
})]);

Checkbox.propTypes = {
	icon: _react2.default.PropTypes.oneOfType([Checkbox.iconSchema, _react2.default.PropTypes.shape({
		on: Checkbox.iconSchema,
		indeterminate: Checkbox.iconSchema,
		off: Checkbox.iconSchema
	})]),
	checked: _react2.default.PropTypes.bool,
	indeterminate: _react2.default.PropTypes.bool,
	onChange: _react2.default.PropTypes.func
};

Checkbox.defaultProps = {
	icon: {
		off: "checkbox-blank-outline",
		indeterminate: "checkbox-marked",
		on: "checkbox-marked"
	},
	checked: false,
	indeterminate: false,
	onChange: function onChange(value) {}
};

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(854);

var _Picker = __webpack_require__(115);

var _Picker2 = _interopRequireDefault(_Picker);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorPicker = function (_React$Component) {
	_inherits(ColorPicker, _React$Component);

	function ColorPicker(props) {
		_classCallCheck(this, ColorPicker);

		var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(ColorPicker, [{
		key: "initState",
		value: function initState() {
			this.state = {
				color: this.props.color,
				picker: false
			};
		}
	}, {
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			if ("color" in nextProps) this.setState({ color: nextProps.color });
		}
	}, {
		key: "renderColorButton",
		value: function renderColorButton(color) {
			var _this2 = this;

			var ButtonStyle = {
				backgroundColor: color
			};
			return _react2.default.createElement(
				"td",
				{ key: color },
				_react2.default.createElement(_Button2.default, {
					className: "ColorPicker",
					style: ButtonStyle,
					onClick: function onClick() {
						_this2.setState({ color: color, picker: false });
						_this2.props.onChange(color);
					}
				})
			);
		}
	}, {
		key: "renderColorRow",
		value: function renderColorRow(colorRow) {
			var _this3 = this;

			return _react2.default.createElement(
				"tr",
				{ key: colorRow[0] },
				colorRow.map(function (color) {
					return _this3.renderColorButton(color);
				})
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this4 = this;

			var mainButtonStyle = {
				backgroundColor: this.state.color
			};

			return _react2.default.createElement(
				_Button2.default,
				{ disabled: this.props.disabled, className: "ColorPicker ColorInput", style: mainButtonStyle, onClick: function onClick(_) {
						_this4.setState({ picker: !_this4.state.picker });
					} },
				_react2.default.createElement(
					_Picker2.default,
					{ className: "ColorPicker", shown: this.state.picker, onWindowClick: function onWindowClick() {
							return _this4.setState({ picker: false });
						} },
					_react2.default.createElement(
						"table",
						null,
						_react2.default.createElement(
							"tbody",
							null,
							this.constructor.COLORS.map(function (colorRow) {
								return _this4.renderColorRow(colorRow);
							})
						)
					)
				)
			);
		}
	}]);

	return ColorPicker;
}(_react2.default.Component);

exports.default = ColorPicker;


ColorPicker.propTypes = {
	color: _react2.default.PropTypes.string,
	onChange: _react2.default.PropTypes.func,
	disabled: _react2.default.PropTypes.bool
};

ColorPicker.defaultProps = {
	color: "#000000",
	onChange: function onChange(color) {},
	disabled: false
};

ColorPicker.COLORS = [["#F34235", "#FE5621", "#9B26AF", "#6639B6"], ["#3E50B4", "#2095F2", "#00BBD3", "#009587"], ["#4BAE4F", "#8AC249", "#CCDB38", "#FEEA3A"], ["#FEC006", "#FE9700", "#785447", "#5F7C8A"], ["#FFFFFF", "#F0F0F0", "#808080", "#000000"]];

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Dialog = __webpack_require__(73);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmDialog = function (_React$Component) {
	_inherits(ConfirmDialog, _React$Component);

	function ConfirmDialog() {
		_classCallCheck(this, ConfirmDialog);

		return _possibleConstructorReturn(this, (ConfirmDialog.__proto__ || Object.getPrototypeOf(ConfirmDialog)).apply(this, arguments));
	}

	_createClass(ConfirmDialog, [{
		key: "render",
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_Dialog2.default,
				{ className: "ConfirmDialog", shown: this.props.shown },
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(
						"label",
						null,
						this.props.text
					)
				),
				_react2.default.createElement(
					"footer",
					null,
					_react2.default.createElement(
						_Button2.default,
						{ onClick: function onClick() {
								return _this2.props.onCancel();
							}, className: this.props.cancelable ? "" : "Hidden" },
						_lang2.default.CANCEL
					),
					_react2.default.createElement(
						_Button2.default,
						{ onClick: function onClick() {
								return _this2.props.onDiscard();
							} },
						_lang2.default.NO
					),
					_react2.default.createElement(
						_Button2.default,
						{ onClick: function onClick() {
								return _this2.props.onConfirm();
							}, className: "Red" },
						_lang2.default.YES
					)
				)
			);
		}
	}], [{
		key: "open",
		value: function open(props) {
			var dialog = _Dialog2.default.open(this, {
				text: props.text || "",
				cancelable: props.cancelable || false,
				onCancel: function onCancel() {
					dialog.close();
					if (props.onCancel) props.onCancel();
				},
				onDiscard: function onDiscard() {
					dialog.close();
					if (props.onDiscard) props.onDiscard();
				},
				onConfirm: function onConfirm() {
					dialog.close();
					if (props.onConfirm) props.onConfirm();
				}
			});
		}
	}]);

	return ConfirmDialog;
}(_react2.default.Component);

exports.default = ConfirmDialog;


ConfirmDialog.propTypes = {
	shown: _react2.default.PropTypes.bool,
	text: _react2.default.PropTypes.string,
	cancelable: _react2.default.PropTypes.bool,
	onConfirm: _react2.default.PropTypes.func,
	onDiscard: _react2.default.PropTypes.func,
	onCancel: _react2.default.PropTypes.func
};

ConfirmDialog.defaultProps = {
	shown: false,
	text: "",
	cancelable: false,
	onConfirm: function onConfirm() {},
	onDiscard: function onDiscard() {},
	onCancel: function onCancel() {}
};

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

//todo: First day of week
//todo: Date & Time format
//todo: formatter functions to separated object
//todo: leading zeroes function
//todo: p->label?

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(855);

var _Picker = __webpack_require__(115);

var _Picker2 = _interopRequireDefault(_Picker);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Select = __webpack_require__(74);

var _Select2 = _interopRequireDefault(_Select);

var _Input = __webpack_require__(52);

var _Input2 = _interopRequireDefault(_Input);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateTimePicker = function (_React$Component) {
	_inherits(DateTimePicker, _React$Component);

	function DateTimePicker(props) {
		_classCallCheck(this, DateTimePicker);

		var _this = _possibleConstructorReturn(this, (DateTimePicker.__proto__ || Object.getPrototypeOf(DateTimePicker)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(DateTimePicker, [{
		key: "initState",
		value: function initState() {
			var dt = {};
			if (!this.getDateAvailability(this.props.dateTime)) {
				dt = new Date(this.props.minDate);
			} else {
				dt = new Date(this.props.dateTime);
			}

			dt.setSeconds(0);

			this.state = {
				timeFormat: this.props.timeFormat || this.determineTimeFormat(), // 12H vagy 24H
				dateTime: dt,
				currentYearAndMonth: dt,
				textInputValue: this.formatDate(dt)
			};
		}
	}, {
		key: "determineTimeFormat",
		value: function determineTimeFormat() {
			if (/(am|pm)/.test(new Date().toLocaleTimeString().toLowerCase())) {
				return "12H";
			}

			return "24H";
		}
	}, {
		key: "getFormattedMonth",
		value: function getFormattedMonth(datetime) {
			return ('0' + (datetime.getMonth() + 1)).slice(-2);
		}
	}, {
		key: "getFormattedDays",
		value: function getFormattedDays(datetime) {
			return ('0' + datetime.getDate()).slice(-2);
		}
	}, {
		key: "get12HFormattedHours",
		value: function get12HFormattedHours(datetime) {
			var hour = datetime.getHours() % 12;
			if (hour == 0) {
				return 12;
			} else {
				return hour;
			}
		}
	}, {
		key: "getFormattedMinutes",
		value: function getFormattedMinutes(datetime) {
			return ('0' + datetime.getMinutes()).slice(-2);
		}
	}, {
		key: "getAMPM",
		value: function getAMPM(datetime) {
			return datetime.getHours() >= 12 ? "PM" : "AM";
		}
	}, {
		key: "formatDate",
		value: function formatDate(datetime) {
			var s = void 0;

			if (this.state && this.state.timeFormat == "12H") {
				s = datetime.getFullYear() + "/" + this.getFormattedMonth(datetime) + "/" + this.getFormattedDays(datetime) + " " + this.get12HFormattedHours(datetime) + ":" + this.getFormattedMinutes(datetime) + " " + this.getAMPM(datetime);
			} else {
				s = datetime.getFullYear() + "/" + this.getFormattedMonth(datetime) + "/" + this.getFormattedDays(datetime) + " " + datetime.getHours() + ":" + this.getFormattedMinutes(datetime);
			}

			return s;
		}
	}, {
		key: "shiftCurrentMonth",
		value: function shiftCurrentMonth(val) {
			var dt = this.state.currentYearAndMonth;
			dt.setMonth(dt.getMonth() + val);
			this.setState({ currentYearAndMonth: dt });
		}
	}, {
		key: "shiftCurrentYear",
		value: function shiftCurrentYear(val) {
			var dt = this.state.currentYearAndMonth;
			dt.setFullYear(dt.getFullYear() + val);
			this.setState({ currentYearAndMonth: dt });
		}
	}, {
		key: "getCalendarRowsArray",
		value: function getCalendarRowsArray() {
			var calendarRowsArray = [];
			var firstDay = new Date(this.state.currentYearAndMonth.getFullYear(), this.state.currentYearAndMonth.getMonth(), 1).getDay();
			var numberOfDaysInCurrentMonth = new Date(this.state.currentYearAndMonth.getFullYear(), this.state.currentYearAndMonth.getMonth() + 1, 0).getDate();
			var weekDayCount = 0;
			var calendarRow = [];

			for (var i = 0; i < firstDay; i++) {
				calendarRow[i] = 0;
				weekDayCount++;
			}

			for (var _i = 1; _i <= numberOfDaysInCurrentMonth; _i++) {
				if (weekDayCount == 7) {
					calendarRowsArray.push(calendarRow);
					calendarRow = [];
					weekDayCount = 0;
				}
				calendarRow.push(_i);
				weekDayCount++;
			}
			if (calendarRow.length != 0) {
				calendarRowsArray.push(calendarRow);
			}

			return calendarRowsArray;
		}
	}, {
		key: "getDateAvailability",
		value: function getDateAvailability(date) {
			if ((this.props.minDate == null || this.props.minDate.getTime() < date.getTime()) && (this.props.maxDate == null || this.props.maxDate.getTime() > date.getTime())) {
				return true;
			}
			return false;
		}
	}, {
		key: "setDate",
		value: function setDate(day) {
			var year = this.state.currentYearAndMonth.getFullYear();
			var month = this.state.currentYearAndMonth.getMonth();
			var dt = new Date(year, month, day);
			dt.setHours(this.state.dateTime.getHours());
			dt.setMinutes(this.state.dateTime.getMinutes());
			this.setState({ dateTime: dt, textInputValue: this.formatDate(dt) });
			this.props.onChange(dt);
		}
	}, {
		key: "setTime",
		value: function setTime(params) {

			params = params || {};

			var hours = params.hours || (this.state.timeFormat == "12H" ? this.get12HFormattedHours(this.state.dateTime) : this.state.dateTime.getHours());
			var minutes = params.minutes || this.state.dateTime.getMinutes();

			var ampm = params.ampm || this.getAMPM(this.state.dateTime);

			var newDateTimeString = this.state.dateTime.getFullYear() + " " + (this.state.dateTime.getMonth() + 1) + " " + this.state.dateTime.getDate() + " " + hours + ":" + minutes + (this.state.timeFormat == "12H" ? " " + ampm : "");
			var dt = new Date(newDateTimeString);

			this.setState({ dateTime: dt, textInputValue: this.formatDate(dt) });
			this.props.onChange(dt);
		}
	}, {
		key: "handleInputChange",
		value: function handleInputChange(value) {

			var dt = new Date(value);

			this.setState({ textInputValue: value });

			if (isNaN(dt.getTime()) || !this.getDateAvailability(dt)) {
				return;
			} else {
				this.setState({ dateTime: dt, currentYearAndMonth: dt });
				this.props.onChange(dt);
			}
		}
	}, {
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			this.setState({ textInputValue: this.formatDate(nextProps.dateTime) });
			this.setState({ dateTime: nextProps.dateTime });
		}
	}, {
		key: "renderHeader",
		value: function renderHeader() {
			var _this2 = this;

			return _react2.default.createElement(
				"header",
				null,
				_react2.default.createElement(_Button2.default, { icon: "menu-left", onClick: function onClick() {
						_this2.shiftCurrentYear(-1);
					} }),
				_react2.default.createElement(
					"label",
					{ className: "Year" },
					this.state.currentYearAndMonth.getFullYear()
				),
				_react2.default.createElement(_Button2.default, { icon: "menu-right", onClick: function onClick() {
						_this2.shiftCurrentYear(+1);
					} }),
				_react2.default.createElement(_Button2.default, { icon: "menu-left", onClick: function onClick() {
						_this2.shiftCurrentMonth(-1);
					} }),
				_react2.default.createElement(
					"label",
					{ className: "Month" },
					_lang2.default["MONTH_" + this.state.currentYearAndMonth.getMonth()]
				),
				_react2.default.createElement(_Button2.default, { icon: "menu-right", onClick: function onClick() {
						_this2.shiftCurrentMonth(+1);
					} })
			);
		}
	}, {
		key: "renderDay",
		value: function renderDay(day) {
			var _this3 = this;

			var today = new Date();
			var date = new Date(this.state.currentYearAndMonth);
			date.setDate(day);

			var className = "";

			if (date.getFullYear() == this.state.dateTime.getFullYear() && date.getMonth() == this.state.dateTime.getMonth() && date.getDate() == this.state.dateTime.getDate()) {
				className = "Selected";
			} else if (date.getFullYear() == today.getFullYear() && date.getMonth() == today.getMonth() && date.getDate() == today.getDate()) {
				className = "Today";
			}

			if (day != 0) {
				return _react2.default.createElement(
					"td",
					{ key: day },
					_react2.default.createElement(
						_Button2.default,
						{ disabled: !this.getDateAvailability(date), key: day, className: className, onClick: function onClick() {
								_this3.setDate(day);
							} },
						day
					)
				);
			} else {
				return _react2.default.createElement("td", { key: Math.random() });
			}
		}
	}, {
		key: "renderCalendarRow",
		value: function renderCalendarRow(week) {
			var _this4 = this;

			return _react2.default.createElement(
				"tr",
				{ key: week[0] },
				week.map(function (day) {
					return _this4.renderDay(day);
				})
			);
		}
	}, {
		key: "renderCalendar",
		value: function renderCalendar() {
			var _this5 = this;

			var calendarRowsArray = this.getCalendarRowsArray();

			return _react2.default.createElement(
				"table",
				null,
				_react2.default.createElement(
					"thead",
					null,
					_react2.default.createElement(
						"tr",
						null,
						_react2.default.createElement(
							"th",
							null,
							"S"
						),
						_react2.default.createElement(
							"th",
							null,
							"M"
						),
						_react2.default.createElement(
							"th",
							null,
							"T"
						),
						_react2.default.createElement(
							"th",
							null,
							"W"
						),
						_react2.default.createElement(
							"th",
							null,
							"T"
						),
						_react2.default.createElement(
							"th",
							null,
							"F"
						),
						_react2.default.createElement(
							"th",
							null,
							"S"
						)
					)
				),
				_react2.default.createElement(
					"tbody",
					null,
					calendarRowsArray.map(function (week) {
						return _this5.renderCalendarRow(week);
					})
				)
			);
		}
	}, {
		key: "renderAMPMSelector",
		value: function renderAMPMSelector() {
			var _this6 = this;

			if (this.state.timeFormat == "12H") {
				return _react2.default.createElement(
					_Select2.default,
					{
						required: true,
						value: this.getAMPM(this.state.dateTime),
						onChange: function onChange(evt) {
							return _this6.setTime({ ampm: evt.target.value });
						}
					},
					_react2.default.createElement(
						"option",
						{ value: "AM" },
						"AM"
					),
					_react2.default.createElement(
						"option",
						{ value: "PM" },
						"PM"
					)
				);
			} else {
				return null;
			}
		}
	}, {
		key: "renderFooter",
		value: function renderFooter() {
			var _this7 = this;

			var hoursInputProps = {
				type: "number",
				min: this.state.timeFormat == "12H" ? "1" : "0",
				max: this.state.timeFormat == "12H" ? "12" : "23",
				value: this.state.timeFormat == "12H" ? this.get12HFormattedHours(this.state.dateTime) : this.state.dateTime.getHours(),
				onChange: function onChange(evt) {
					return _this7.setTime({ hours: evt.target.value });
				}
			};

			var minutesInputProps = {
				type: "number",
				min: "0",
				max: "59",
				value: this.getFormattedMinutes(this.state.dateTime),
				onChange: function onChange(evt) {
					return _this7.setTime({ minutes: evt.target.value });
				}
			};

			return _react2.default.createElement(
				"footer",
				null,
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(
						"label",
						null,
						"Time:"
					),
					_react2.default.createElement(_Input2.default, hoursInputProps),
					_react2.default.createElement(
						"label",
						null,
						":"
					),
					_react2.default.createElement(_Input2.default, minutesInputProps),
					this.renderAMPMSelector()
				),
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(
						_Button2.default,
						{ onClick: function onClick() {
								var dt = new Date();
								_this7.setState({
									dateTime: dt,
									currentYearAndMonth: dt,
									textInputValue: _this7.formatDate(dt)
								});
								_this7.props.onChange(dt);
							} },
						_lang2.default.NOW
					),
					_react2.default.createElement(
						_Button2.default,
						{ onClick: function onClick() {
								_this7.setState({ picker: false });
							} },
						_lang2.default.DONE
					)
				)
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this8 = this;

			var inputProps = {
				ref: "input",
				onClick: function onClick() {
					return _this8.setState({ picker: !_this8.state.picker && !_this8.state.disabled });
				},
				value: this.state.textInputValue,
				onChange: function onChange(evt) {
					_this8.handleInputChange(evt.target.value);
				},
				onBlur: function onBlur() {
					_this8.setState({ textInputValue: _this8.formatDate(_this8.state.dateTime) });
				},
				disabled: this.state.disabled,
				className: "DateTimePicker"
			};

			var pickerProps = {
				shown: this.state.picker,
				onWindowClick: function onWindowClick() {
					return _this8.setState({ picker: false });
				},
				className: "DateTimePicker"
			};

			return _react2.default.createElement(
				"div",
				{ className: "DateTimePicker" },
				_react2.default.createElement(_Input2.default, inputProps),
				_react2.default.createElement(
					_Picker2.default,
					pickerProps,
					this.renderHeader(),
					this.renderCalendar(),
					this.renderFooter()
				)
			);
		}
	}]);

	return DateTimePicker;
}(_react2.default.Component);

exports.default = DateTimePicker;


DateTimePicker.propType = {
	timeFormat: _react2.default.PropTypes.string,
	dateTime: _react2.default.PropTypes.object,
	onChange: _react2.default.PropTypes.func,
	minDate: _react2.default.PropTypes.object,
	maxDate: _react2.default.PropTypes.object,
	disabled: _react2.default.PropTypes.boolean
};

DateTimePicker.defaultProps = {
	timeFormat: null,
	dateTime: new Date(),
	onChange: function onChange(dateTime) {},
	minDate: null,
	maxDate: null,
	disabled: false
};

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(856);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Tabs = __webpack_require__(116);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Details = function (_React$Component) {
	_inherits(Details, _React$Component);

	function Details(props) {
		_classCallCheck(this, Details);

		var _this = _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(Details, [{
		key: "initState",
		value: function initState() {
			this.state = {
				title: this.props.title,
				activeTab: this.props.activeTab || (this.props.tabs ? this.props.tabs[0].id : null)
			};
		}
	}, {
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			this.setState({
				title: nextProps.title,
				tabs: nextProps.tabs,
				activeTab: nextProps.activeTab
			});
		}
	}, {
		key: "renderTabs",
		value: function renderTabs() {
			var tabItems = this.props.tabs.map(function (tabs) {
				return _react2.default.createElement(
					"li",
					{ id: tabs.id, key: tabs.id },
					tabs.label
				);
			});

			return _react2.default.createElement(
				_Tabs2.default,
				{ onChange: this.props.onTabChange, className: "Light", selected: this.state.activeTab },
				tabItems
			);
		}
	}, {
		key: "handleDragEvent",
		value: function handleDragEvent(evt) {
			this.props.ondrag(evt);
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			var _this2 = this;

			if (this.props.dragable) {
				var dragButton = _reactDom2.default.findDOMNode(this.refs.dragButton);
				dragButton.addEventListener("drag", function (evt) {
					return _this2.handleDragEvent(evt);
				});
			}
		}
	}, {
		key: "renderDragButton",
		value: function renderDragButton() {
			if (this.props.dragable) {
				return _react2.default.createElement(_Button2.default, { icon: "unfold-more", draggable: "true", ref: "dragButton" });
			}
		}
	}, {
		key: "renderCloseButton",
		value: function renderCloseButton() {
			if (this.props.closable) {
				return _react2.default.createElement(_Button2.default, { icon: "close", onClick: this.props.onClose });
			}
		}
	}, {
		key: "renderControlButtons",
		value: function renderControlButtons() {
			return _react2.default.createElement(
				"div",
				{ className: "ButtonContainer" },
				this.renderDragButton(),
				this.renderCloseButton()
			);
		}
	}, {
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"div",
				{ className: (0, _classnames2.default)(this.props.className, "Details") },
				_react2.default.createElement(
					"header",
					null,
					_react2.default.createElement(
						"h1",
						null,
						this.state.title
					),
					this.renderTabs(),
					this.renderControlButtons()
				),
				_react2.default.createElement(
					"div",
					{ className: "Content" },
					this.props.children
				)
			);
		}
	}]);

	return Details;
}(_react2.default.Component);

exports.default = Details;


Details.propTypes = {
	title: _react2.default.PropTypes.string,
	closable: _react2.default.PropTypes.bool,
	onClose: _react2.default.PropTypes.func,
	tabs: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({ label: _react2.default.PropTypes.string, id: _react2.default.PropTypes.string })),
	onTabChange: _react2.default.PropTypes.func,
	activeTab: _react2.default.PropTypes.string,
	dragable: _react2.default.PropTypes.bool,
	ondrag: _react2.default.PropTypes.func
};

Details.defaultProps = {
	title: "",
	closable: true,
	onClose: function onClose() {},
	onTabChange: function onTabChange(page) {},
	dragable: false,
	ondrag: function ondrag(evt) {}
};

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(857);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Popup = __webpack_require__(206);

var _Popup2 = _interopRequireDefault(_Popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ANIMATION_DURATION = 200; // ms

var Dialog = function (_React$Component) {
	_inherits(Dialog, _React$Component);

	function Dialog(props) {
		_classCallCheck(this, Dialog);

		var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(Dialog, [{
		key: "initState",
		value: function initState() {
			this.state = {
				shown: this.props.shown
			};
		}
	}, {
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.shown != this.props.shown) {
				this.setState({
					shown: nextProps.shown
				});
			}
		}
	}, {
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				_Popup2.default,
				{ shown: this.state.shown, className: "Overlay DialogOverlay" },
				_react2.default.createElement(
					"div",
					{ className: (0, _classnames2.default)(this.props.className, "Dialog") },
					this.props.children
				)
			);
		}
	}], [{
		key: "createContainer",
		value: function createContainer() {
			var container = document.createElement("div");
			container.id = "dialogContainer";
			document.body.appendChild(container);
			return container;
		}

		// HAX VESZÉLY :((((((((((((((((((

	}, {
		key: "open",
		value: function open(type, props) {

			var dialog = void 0;

			var update = function update(callback) {
				dialog = _reactDom2.default.render(_react2.default.createElement(type, props), container, callback);

				dialog.close = function () {
					props.shown = false;
					update(function () {
						setTimeout(function () {
							_reactDom2.default.unmountComponentAtNode(container);
							document.body.removeChild(container);
						}, ANIMATION_DURATION);
					});
				};
				return dialog;
			};

			var container = this.createContainer();
			props.shown = false;

			return update(function () {
				setTimeout(function () {
					props.shown = true;
					update();
				});
			});
		}
	}]);

	return Dialog;
}(_react2.default.Component);

exports.default = Dialog;


Dialog.propTypes = {
	shown: _react2.default.PropTypes.bool
};

Dialog.defaultProps = {
	shown: false
};

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Separator = exports.Item = exports.DropdownMenu = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(858);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Picker = __webpack_require__(115);

var _Picker2 = _interopRequireDefault(_Picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownMenu = function (_React$Component) {
	_inherits(DropdownMenu, _React$Component);

	function DropdownMenu(props) {
		_classCallCheck(this, DropdownMenu);

		var _this = _possibleConstructorReturn(this, (DropdownMenu.__proto__ || Object.getPrototypeOf(DropdownMenu)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(DropdownMenu, [{
		key: "initState",
		value: function initState() {
			this.state = {
				shown: false
			};
		}
	}, {
		key: "toggle",
		value: function toggle() {
			this.setState({
				shown: !this.state.shown
			});
		}
	}, {
		key: "prepareChildren",
		value: function prepareChildren() {
			var _this2 = this;

			var children = this.props.children.constructor == Array ? this.props.children : [this.props.children];
			return children.map(function (child, i) {
				return child.type === Separator ? _react2.default.createElement(Separator, { key: i }) : _react2.default.createElement(Item, _extends({ key: i }, child.props, { onFire: function onFire() {
						return _this2.setState({ shown: false });
					} }));
			});
		}
	}, {
		key: "renderMenu",
		value: function renderMenu() {
			var _this3 = this;

			return _react2.default.createElement(
				_Picker2.default,
				{
					className: "DropdownMenu",
					shown: this.state.shown,
					onWindowClick: function onWindowClick() {
						return _this3.setState({ shown: false });
					}
				},
				_react2.default.createElement(
					"ul",
					null,
					this.prepareChildren()
				)
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this4 = this;

			return _react2.default.createElement(
				_Button2.default,
				{
					icon: "dots-vertical",
					className: this.props.className,
					onClick: function onClick() {
						return _this4.toggle();
					}
				},
				this.renderMenu()
			);
		}
	}]);

	return DropdownMenu;
}(_react2.default.Component);

DropdownMenu.propTypes = {
	className: _react2.default.PropTypes.string
};

var Item = function (_React$Component2) {
	_inherits(Item, _React$Component2);

	function Item() {
		_classCallCheck(this, Item);

		return _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
	}

	_createClass(Item, [{
		key: "render",
		value: function render() {
			var _this6 = this;

			return _react2.default.createElement(
				"li",
				{
					className: (0, _classnames2.default)("Item", { "Disabled": this.props.disabled }),
					onClick: function onClick() {
						if (!_this6.props.disabled) {
							_this6.props.onFire();
							_this6.props.onClick();
						}
					}
				},
				this.props.children
			);
		}
	}]);

	return Item;
}(_react2.default.Component);

Item.propTypes = {
	disabled: _react2.default.PropTypes.bool,
	onClick: _react2.default.PropTypes.func,
	onFire: _react2.default.PropTypes.func
};

Item.defaultProps = {
	disabled: false,
	onClick: function onClick() {},
	onFire: function onFire() {}
};

var Separator = function (_React$Component3) {
	_inherits(Separator, _React$Component3);

	function Separator() {
		_classCallCheck(this, Separator);

		return _possibleConstructorReturn(this, (Separator.__proto__ || Object.getPrototypeOf(Separator)).apply(this, arguments));
	}

	_createClass(Separator, [{
		key: "render",
		value: function render() {
			return _react2.default.createElement("li", { className: "Separator" });
		}
	}]);

	return Separator;
}(_react2.default.Component);

exports.DropdownMenu = DropdownMenu;
exports.Item = Item;
exports.Separator = Separator;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = exports.Item = exports.DropdownMenu = undefined;

var _DropdownMenu = __webpack_require__(319);

exports.DropdownMenu = _DropdownMenu.DropdownMenu;
exports.Item = _DropdownMenu.Item;
exports.Separator = _DropdownMenu.Separator;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(859);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Form = function (_React$Component) {
	_inherits(Form, _React$Component);

	function Form() {
		_classCallCheck(this, Form);

		return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
	}

	_createClass(Form, [{
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"div",
				_extends({}, this.props, { className: (0, _classnames2.default)(this.props.className, "Form") }),
				this.props.children
			);
		}
	}]);

	return Form;
}(_react2.default.Component);

exports.default = Form;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(860);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Icon = function (_React$Component) {
	_inherits(Icon, _React$Component);

	function Icon() {
		_classCallCheck(this, Icon);

		return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	}

	_createClass(Icon, [{
		key: "render",
		value: function render() {
			var className = (0, _classnames2.default)(this.props.className, "mdi mdi-" + this.props.children);

			return _react2.default.createElement("i", { className: className });
		}
	}]);

	return Icon;
}(_react2.default.Component);

exports.default = Icon;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(861);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Input = __webpack_require__(52);

var _Input2 = _interopRequireDefault(_Input);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputWithUnit = function (_React$Component) {
	_inherits(InputWithUnit, _React$Component);

	function InputWithUnit() {
		_classCallCheck(this, InputWithUnit);

		return _possibleConstructorReturn(this, (InputWithUnit.__proto__ || Object.getPrototypeOf(InputWithUnit)).apply(this, arguments));
	}

	_createClass(InputWithUnit, [{
		key: "getInputProps",
		value: function getInputProps() {
			var inputProps = {};
			for (var key in this.props) {
				if (key == "className") continue;
				inputProps[key] = this.props[key];
			}
			return inputProps;
		}
	}, {
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"div",
				{ className: (0, _classnames2.default)(this.props.className, "InputWithUnit") },
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(_Input2.default, _extends({}, this.getInputProps(), {
						type: "number"
					})),
					_react2.default.createElement(
						"label",
						null,
						this.props.label
					)
				)
			);
		}
	}]);

	return InputWithUnit;
}(_react2.default.Component);

exports.default = InputWithUnit;


InputWithUnit.propTypes = {
	label: _react2.default.PropTypes.string,
	typingTimeout: _react2.default.PropTypes.number,
	onTypeEnd: _react2.default.PropTypes.func
};

InputWithUnit.defaultProps = {
	label: "",
	typingTimeout: 1000
};

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(862);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _TypingListener = __webpack_require__(309);

var _TypingListener2 = _interopRequireDefault(_TypingListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Input = function (_React$Component) {
	_inherits(Input, _React$Component);

	function Input() {
		_classCallCheck(this, Input);

		return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
	}

	_createClass(Input, [{
		key: "componentDidMount",
		value: function componentDidMount() {
			var _this2 = this;

			if (this.props.onTypeEnd) {
				this.typingListener = new _TypingListener2.default(this.refs.input, this.props.typingTimeout, function (value) {
					return _this2.props.onTypeEnd(value);
				});
			}
		}
	}, {
		key: "getInputProps",
		value: function getInputProps() {
			var inputProps = {};
			for (var key in this.props) {
				if (key == "ref") continue;
				inputProps[key] = this.props[key];
			}
			return inputProps;
		}
	}, {
		key: "render",
		value: function render() {

			var type = /^(text|password|number)$/.test(this.props.type) ? this.props.type : "text";

			return _react2.default.createElement("input", _extends({
				ref: "input"
			}, this.getInputProps(), {
				type: type,
				className: (0, _classnames2.default)(this.props.className, "Input")
			}));
		}
	}]);

	return Input;
}(_react2.default.Component);

exports.default = Input;


Input.propTypes = {
	typingTimeout: _react2.default.PropTypes.number,
	onTypeEnd: _react2.default.PropTypes.func
};

Input.defaultProps = {
	typingTimeout: 1000
};

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(863);

var _DateTimePicker = __webpack_require__(147);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

var _Checkbox = __webpack_require__(66);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IntervalEditor = function (_React$Component) {
	_inherits(IntervalEditor, _React$Component);

	function IntervalEditor(props) {
		_classCallCheck(this, IntervalEditor);

		var _this = _possibleConstructorReturn(this, (IntervalEditor.__proto__ || Object.getPrototypeOf(IntervalEditor)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(IntervalEditor, [{
		key: "initState",
		value: function initState() {
			var from = this.props.interval.from;
			var to = this.props.interval.to;

			if (!this.props.nullable) {
				from = from || Date.now(), to = to || Date.now();
			}

			this.state = {
				from: this.props.interval.from,
				to: this.props.interval.to,
				backupFrom: this.props.interval.from || Date.now(),
				backupTo: this.props.interval.to || Date.now()
			};
		}
	}, {
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.interval.from != this.props.interval.from || nextProps.interval.to != this.props.interval.to) {
				this.setState({
					from: nextProps.interval.from,
					to: nextProps.interval.to,
					backupFrom: nextProps.interval.from || Date.now(),
					backupTo: nextProps.interval.to || Date.now()
				});
			}
		}
	}, {
		key: "componentDidUpdate",
		value: function componentDidUpdate(_, prevState) {
			if (prevState.from !== null && this.state.from === null) {
				this.setState({ backupFrom: prevState.from });
			} else if (prevState.to !== null && this.state.to === null) {
				this.setState({ backupTo: prevState.to });
			}
		}
	}, {
		key: "isValidInterval",
		value: function isValidInterval(from, to) {
			if (from === null || to === null) {
				return true;
			}
			if (from > to) {
				new _Toast2.default(_lang2.default.INVALID_INTERVAL, "orange");
				return false;
			}
			return true;
		}
	}, {
		key: "handleChange",
		value: function handleChange() {
			if (this.isValidInterval(this.state.from, this.state.to)) {
				this.props.onChange({
					from: this.state.from,
					to: this.state.to
				});
			}
		}
	}, {
		key: "renderFromCheckbox",
		value: function renderFromCheckbox() {
			var _this2 = this;

			if (this.props.nullable) {
				var fromCheckboxProps = {
					checked: this.state.from !== null,
					onChange: function onChange(value) {
						_this2.setState({ from: value ? _this2.state.backupFrom : null }, function () {
							return _this2.handleChange();
						});
					}
				};

				return _react2.default.createElement(_Checkbox2.default, fromCheckboxProps);
			}
		}
	}, {
		key: "renderToCheckbox",
		value: function renderToCheckbox() {
			var _this3 = this;

			if (this.props.nullable) {
				var toCheckboxProps = {
					checked: this.state.to !== null,
					onChange: function onChange(value) {
						_this3.setState({ to: value ? _this3.state.backupTo : null }, function () {
							return _this3.handleChange();
						});
					}
				};

				return _react2.default.createElement(_Checkbox2.default, toCheckboxProps);
			}
		}
	}, {
		key: "render",
		value: function render() {
			var _this4 = this;

			var fromDateTimePickerProps = {
				dateTime: this.state.from ? new Date(this.state.from) : new Date(this.state.backupFrom),
				disabled: this.state.from === null,
				onChange: function onChange(dateTime) {
					_this4.setState({ from: dateTime.getTime() }, function () {
						return _this4.handleChange();
					});
				}
			};

			var toDateTimePickerProps = {
				dateTime: this.state.to ? new Date(this.state.to) : new Date(this.state.backupTo),
				disabled: this.state.to === null,
				onChange: function onChange(dateTime) {
					_this4.setState({ to: dateTime.getTime() }, function () {
						return _this4.handleChange();
					});
				}
			};

			return _react2.default.createElement(
				"div",
				{ className: "IntervalEditor" },
				_react2.default.createElement(
					"div",
					null,
					this.renderFromCheckbox(),
					_react2.default.createElement(_DateTimePicker2.default, fromDateTimePickerProps),
					_react2.default.createElement(
						"div",
						{ id: "hyphen" },
						"-"
					),
					this.renderToCheckbox(),
					_react2.default.createElement(_DateTimePicker2.default, toDateTimePickerProps)
				)
			);
		}
	}]);

	return IntervalEditor;
}(_react2.default.Component);

exports.default = IntervalEditor;


IntervalEditor.propType = {
	interval: _react2.default.PropTypes.shape({
		from: _react2.default.PropTypes.number,
		to: _react2.default.PropTypes.number
	}),
	nulllable: _react2.default.PropTypes.bool,
	onChange: _react2.default.PropTypes.func
};

IntervalEditor.defaultProps = {
	interval: { from: null, to: null },
	nullable: true,
	onChange: function onChange(interval) {}
};

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(864);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_DISPLAYED_ITEMS = 50;

var List = function (_React$Component) {
	_inherits(List, _React$Component);

	function List(props) {
		_classCallCheck(this, List);

		var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(List, [{
		key: "initState",
		value: function initState() {
			this.state = {
				displayedItems: this.props.displayedItems
			};
		}
	}, {
		key: "handleScroll",
		value: function handleScroll() {
			var cont = this.refs.container;
			if (cont.scrollTop >= cont.scrollHeight - cont.clientHeight) {
				this.setState({
					displayedItems: this.state.displayedItems + DEFAULT_DISPLAYED_ITEMS
				});
			}
		}
	}, {
		key: "renderDisplayedItems",
		value: function renderDisplayedItems() {
			var _this2 = this;

			if (!this.props.children) return null;

			if (this.props.children.constructor == Array) return this.props.children.filter(function (_, i) {
				return i < _this2.state.displayedItems;
			});else return this.props.children;
		}
	}, {
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"div",
				{ ref: "container", className: "List", onScroll: this.handleScroll.bind(this) },
				this.renderDisplayedItems()
			);
		}
	}]);

	return List;
}(_react2.default.Component);

exports.default = List;


List.propTypes = {
	displayedItems: _react2.default.PropTypes.number
};

List.defaultProps = {
	displayedItems: DEFAULT_DISPLAYED_ITEMS
};

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _Dialog = __webpack_require__(73);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Input = __webpack_require__(52);

var _Input2 = _interopRequireDefault(_Input);

var _ProgressBar = __webpack_require__(34);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

__webpack_require__(865);

var _flux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginDialog = function (_React$Component) {
	_inherits(LoginDialog, _React$Component);

	function LoginDialog(props) {
		_classCallCheck(this, LoginDialog);

		var _this = _possibleConstructorReturn(this, (LoginDialog.__proto__ || Object.getPrototypeOf(LoginDialog)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(LoginDialog, [{
		key: "initState",
		value: function initState() {
			this.state = {
				error: ""
			};
		}
	}, {
		key: "setError",
		value: function setError(error) {
			this.setState({ error: error });
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			this.focusToUsernameInput();
		}
	}, {
		key: "componentDidUpdate",
		value: function componentDidUpdate(nextProps) {
			this.focusToUsernameInput();
		}
	}, {
		key: "clearInputs",
		value: function clearInputs() {
			var usernameInput = _reactDom2.default.findDOMNode(this.refs.username);
			var passwordInput = _reactDom2.default.findDOMNode(this.refs.password);
			usernameInput.value = "";
			passwordInput.value = "";
		}
	}, {
		key: "focusToUsernameInput",
		value: function focusToUsernameInput() {
			var usernameInput = _reactDom2.default.findDOMNode(this.refs.username);
			setTimeout(function () {
				return usernameInput.focus();
			}, 100);
		}
	}, {
		key: "isValid",
		value: function isValid() {
			var usernameInput = _reactDom2.default.findDOMNode(this.refs.username);
			var passwordInput = _reactDom2.default.findDOMNode(this.refs.password);

			if (usernameInput.value && passwordInput.value) return true;
			return false;
		}
	}, {
		key: "keyUpHandler",
		value: function keyUpHandler(evt) {
			if (evt.keyCode == 13) {
				this.submit();
			}
		}
	}, {
		key: "submit",
		value: function submit() {
			if (this.isValid()) {
				var usernameInput = _reactDom2.default.findDOMNode(this.refs.username);
				var passwordInput = _reactDom2.default.findDOMNode(this.refs.password);

				this.props.onSubmit(usernameInput.value, passwordInput.value);
			}
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_Dialog2.default,
				{ shown: this.props.shown, className: "LoginDialog" },
				_react2.default.createElement(
					"header",
					null,
					_react2.default.createElement(
						"h1",
						null,
						_lang2.default.LOGIN
					)
				),
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(
						"div",
						null,
						_react2.default.createElement(
							"label",
							{ id: "errorMsg" },
							this.state.error
						),
						_react2.default.createElement(_Input2.default, {
							ref: "username",
							placeholder: _lang2.default._USERNAME,
							onKeyUp: function onKeyUp(evt) {
								return _this2.keyUpHandler(evt);
							}
						}),
						_react2.default.createElement(_Input2.default, {
							ref: "password",
							type: "password",
							placeholder: _lang2.default._PASSWORD,
							onKeyUp: function onKeyUp(evt) {
								return _this2.keyUpHandler(evt);
							}
						})
					)
				),
				_react2.default.createElement(
					"footer",
					null,
					_react2.default.createElement(
						_Button2.default,
						{
							className: "Red",
							onClick: function onClick(_) {
								return _this2.submit();
							}
						},
						_lang2.default.LOGIN
					)
				)
			);
		}
	}]);

	return LoginDialog;
}(_react2.default.Component);

exports.default = LoginDialog;


LoginDialog.propTypes = {
	shown: _react2.default.PropTypes.bool,
	errorMsg: _react2.default.PropTypes.string,
	onSubmit: _react2.default.PropTypes.func
};

LoginDialog.defaultProps = {
	shown: false,
	errorMsg: "",
	onSubmit: function onSubmit(username, password) {}
};

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LoginDialog = __webpack_require__(327);

var _LoginDialog2 = _interopRequireDefault(_LoginDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LoginDialog2.default;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(866);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(837);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultiSelect = function (_React$Component) {
	_inherits(MultiSelect, _React$Component);

	function MultiSelect(props) {
		_classCallCheck(this, MultiSelect);

		var _this = _possibleConstructorReturn(this, (MultiSelect.__proto__ || Object.getPrototypeOf(MultiSelect)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(MultiSelect, [{
		key: "initState",
		value: function initState() {
			this.state = {
				value: valueToOptions(this.props.options, this.props.defaultValue)
			};
		}
	}, {
		key: "setStateFromValue",
		value: function setStateFromValue(value) {
			var _this2 = this;

			this.setState({
				value: value ? value : []
			}, function () {
				return _this2.props.onChange(optionsToValue(_this2.state.value));
			});
		}
	}, {
		key: "clear",
		value: function clear() {
			this.setStateFromValue([]);
		}
	}, {
		key: "render",
		value: function render() {
			var _this3 = this;

			var className = (0, _classnames2.default)("MultiSelect", this.props.className);

			return _react2.default.createElement(
				"div",
				{ className: className, onClick: function onClick() {
						return _this3.props.onClick();
					} },
				_react2.default.createElement(_reactSelect2.default, {
					multi: true,
					value: this.state.value,
					placeholder: this.props.placeholder,
					options: this.props.options,
					disabled: this.props.disabled,
					onChange: function onChange(value) {
						return _this3.setStateFromValue(value);
					},
					matchProp: "label"
				})
			);
		}
	}]);

	return MultiSelect;
}(_react2.default.Component);

exports.default = MultiSelect;


function optionsToValue(options) {
	options = options || [];
	return options.map(function (o) {
		return o.value;
	});
}

function valueToOptions(options, value) {
	options = options || [];
	value = value || [];
	return options.filter(function (o) {
		return value.includes(o.value);
	});
}

MultiSelect.Option = _react2.default.PropTypes.shape({
	defaultValue: _react2.default.PropTypes.string,
	label: _react2.default.PropTypes.string
});

MultiSelect.propTypes = {
	options: _react2.default.PropTypes.arrayOf(MultiSelect.Option),
	defaultValue: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string),
	disabled: _react2.default.PropTypes.bool,
	onChange: _react2.default.PropTypes.func,
	onClick: _react2.default.PropTypes.func,
	placeholder: _react2.default.PropTypes.string
};

MultiSelect.defaultProps = {
	options: [],
	defaultValue: [],
	disabled: false,
	onChange: function onChange(value) {},
	onClick: function onClick() {}
};

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MultiSelect = __webpack_require__(329);

var _MultiSelect2 = _interopRequireDefault(_MultiSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MultiSelect2.default;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(867);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Form = __webpack_require__(38);

var _Form2 = _interopRequireDefault(_Form);

var _Checkbox = __webpack_require__(66);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _MultiSelect = __webpack_require__(330);

var _MultiSelect2 = _interopRequireDefault(_MultiSelect);

var _getModificationsByRef = __webpack_require__(101);

var _getModificationsByRef2 = _interopRequireDefault(_getModificationsByRef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultiSelector = function (_React$Component) {
	_inherits(MultiSelector, _React$Component);

	function MultiSelector(props) {
		_classCallCheck(this, MultiSelector);

		var _this = _possibleConstructorReturn(this, (MultiSelector.__proto__ || Object.getPrototypeOf(MultiSelector)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(MultiSelector, [{
		key: "initState",
		value: function initState() {
			this.state = this.getDefaultState();
		}
	}, {
		key: "handleCheckboxChange",
		value: function handleCheckboxChange(value) {
			var _this2 = this;

			this.setState({ all: value }, function () {
				return _this2.handleChange();
			});
		}
	}, {
		key: "handleSelectChange",
		value: function handleSelectChange(value) {
			var _this3 = this;

			this.setState({ value: value }, function () {
				return _this3.handleChange();
			});
		}
	}, {
		key: "componentDidUpdate",
		value: function componentDidUpdate(prevProps) {
			if (this.state.all && (0, _getModificationsByRef2.default)(prevProps.options, this.props.options)) this.handleChange();
		}
	}, {
		key: "handleChange",
		value: function handleChange() {
			this.props.onChange(this.state.all ? this.props.options.map(function (o) {
				return o.value;
			}) : this.state.value, this.state.all);
		}
	}, {
		key: "clear",
		value: function clear() {
			if (this.refs.multiSelect) {
				this.refs.multiSelect.clear();
				this.setState({ all: true });
			}
		}
	}, {
		key: "defaultIsAll",
		value: function defaultIsAll() {
			if (this.props.defaultValue) return this.props.defaultValue.length === this.props.options.length;else return true;
		}
	}, {
		key: "getDefaultState",
		value: function getDefaultState() {
			return {
				all: this.defaultIsAll(),
				value: this.defaultIsAll() ? [] : this.props.defaultValue
			};
		}
	}, {
		key: "render",
		value: function render() {
			var _this4 = this;

			var className = (0, _classnames2.default)("MultiSelector", this.props.className);

			return _react2.default.createElement(
				_Form2.default,
				{ className: className },
				_react2.default.createElement(
					"label",
					null,
					this.props.title
				),
				_react2.default.createElement(
					"div",
					{ className: "Container" },
					_react2.default.createElement(
						"div",
						{ className: "All" },
						_react2.default.createElement(_Checkbox2.default, { checked: this.state.all, onChange: function onChange(value) {
								return _this4.handleCheckboxChange(value);
							} }),
						_react2.default.createElement(
							"label",
							null,
							_lang2.default.ALL
						)
					),
					_react2.default.createElement(_MultiSelect2.default, {
						ref: "multiSelect",
						disabled: this.state.all && this.state.value.length > 0,
						options: this.props.options,
						defaultValue: this.state.value,
						onChange: function onChange(value) {
							return _this4.handleSelectChange(value);
						},
						onClick: function onClick() {
							return _this4.setState({ all: false }, function () {
								return _this4.handleChange();
							});
						},
						placeholder: "" + _lang2.default._OR_SELECT_ONE_BY_ONE
					})
				)
			);
		}
	}]);

	return MultiSelector;
}(_react2.default.Component);

exports.default = MultiSelector;


MultiSelector.propTypes = {
	title: _react2.default.PropTypes.string,
	options: _react2.default.PropTypes.arrayOf(_MultiSelect2.default.Option),
	// ha nem adunk meg defaultValue-t, akkor
	// default az összeset adja
	defaultValue: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string),
	onChange: _react2.default.PropTypes.func
};

MultiSelector.defaultProps = {
	title: "",
	options: [],
	onChange: function onChange(value, all) {}
};

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(868);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pager = function (_React$Component) {
	_inherits(Pager, _React$Component);

	function Pager() {
		_classCallCheck(this, Pager);

		return _possibleConstructorReturn(this, (Pager.__proto__ || Object.getPrototypeOf(Pager)).apply(this, arguments));
	}

	_createClass(Pager, [{
		key: "renderPage",
		value: function renderPage(page, active) {
			return _react2.default.createElement(
				"div",
				{ key: page.props.id, className: (0, _classnames2.default)({ "Hidden": !active }, page.props.className) },
				page.props.children
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				"div",
				{ className: "Pager" },
				forceArray(this.props.children).map(function (page, index) {
					var active = "active" in _this2.props ? _this2.props.active == page.props.id : index == 0;
					return _this2.renderPage(page, active);
				})
			);
		}
	}]);

	return Pager;
}(_react2.default.Component);

exports.default = Pager;


Pager.propTypes = {
	active: _react2.default.PropTypes.string
};

function forceArray(_) {
	return _.constructor === Array ? _ : [_];
}

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(869);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Popup = __webpack_require__(206);

var _Popup2 = _interopRequireDefault(_Popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Picker = function (_React$Component) {
	_inherits(Picker, _React$Component);

	function Picker(props) {
		_classCallCheck(this, Picker);

		var _this = _possibleConstructorReturn(this, (Picker.__proto__ || Object.getPrototypeOf(Picker)).call(this, props));

		_this.initState();
		_this.createWindowHandlers();
		return _this;
	}

	_createClass(Picker, [{
		key: "initState",
		value: function initState() {
			this.state = {
				ready: false,
				x: 0,
				y: 0
			};
		}
	}, {
		key: "createWindowHandlers",
		value: function createWindowHandlers() {
			this.onWindowResize = this.setPosition.bind(this);
			this.onWindowClick = this.handleClick.bind(this);
		}
	}, {
		key: "componentDidUpdate",
		value: function componentDidUpdate(prevProps) {
			if (prevProps.shown !== this.props.shown) {
				this.setPosition();
			}
		}
	}, {
		key: "getAnchorElement",
		value: function getAnchorElement() {
			return _reactDom2.default.findDOMNode(this.refs.popup).parentNode || null;
		}
	}, {
		key: "getAnchorRect",
		value: function getAnchorRect() {
			if (this.getAnchorElement()) return this.getAnchorElement().getBoundingClientRect();
			return null;
		}
	}, {
		key: "getSelfElement",
		value: function getSelfElement() {
			return _reactDom2.default.findDOMNode(this.refs.self);
		}
	}, {
		key: "getSelftRect",
		value: function getSelftRect() {
			return this.getSelfElement().getBoundingClientRect();
		}
	}, {
		key: "setPosition",
		value: function setPosition() {
			var anchorY = this.getAnchorRect().top;
			var anchorX = this.getAnchorRect().left;
			var anchorWidth = this.getAnchorRect().width;
			var anchorHeight = this.getAnchorRect().height;
			var selfWidth = this.getSelftRect().width;
			var selfHeight = this.getSelftRect().height;
			var windowHeight = window.innerHeight;
			var windowWidth = window.innerWidth;

			var x = void 0,
			    y = void 0;

			if (this.props.vertical) {
				x = anchorX + anchorWidth;
				y = anchorY;

				if (anchorX + anchorWidth + selfWidth > windowWidth) x = anchorX - selfWidth;
				if (anchorY + selfHeight > windowHeight) y = anchorY + anchorHeight - selfHeight;
			} else {
				x = anchorX;
				y = anchorY + anchorHeight;

				if (anchorY + anchorHeight + selfHeight > windowHeight) y = anchorY - selfHeight;
				if (anchorX + selfWidth > windowWidth) x = anchorX + anchorWidth - selfWidth;
			}

			this.setState({ x: x, y: y, ready: true });
		}
	}, {
		key: "handleClick",
		value: function handleClick(evt) {
			if (!this.props.shown) return;

			if (!isTargetInElement(evt.target, this.getSelfElement()) && !isTargetInElement(evt.target, this.getAnchorElement())) {
				this.props.onWindowClick();
			}
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			window.addEventListener("click", this.onWindowClick);
			window.addEventListener("resize", this.onWindowResize);
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			window.removeEventListener("click", this.onWindowClick);
			window.removeEventListener("resize", this.onWindowResize);
		}
	}, {
		key: "render",
		value: function render() {

			var popupClassName = (0, _classnames2.default)({ "Invisible": !this.state.ready });
			var className = (0, _classnames2.default)("Picker", this.props.className);

			var style = {
				top: this.state.y + "px",
				left: this.state.x + "px"
			};

			return _react2.default.createElement(
				_Popup2.default,
				{ ref: "popup", shown: this.props.shown, className: popupClassName },
				_react2.default.createElement(
					"div",
					{ ref: "self", className: className, style: style, onClick: function onClick(evt) {
							return evt.stopPropagation();
						} },
					this.props.children
				)
			);
		}
	}]);

	return Picker;
}(_react2.default.Component);

exports.default = Picker;


Picker.propTypes = {
	shown: _react2.default.PropTypes.bool,
	onWindowClick: _react2.default.PropTypes.func,
	vertical: _react2.default.PropTypes.bool
};

Picker.defaultProps = {
	shown: false,
	onWindowClick: function onWindowClick() {},
	vertical: false
};

function isTargetInElement(target, element) {
	var node = target;
	while (node !== null) {
		if (node === element) return true;
		node = node.parentNode;
	}
	return false;
}

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(870);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Checkbox = __webpack_require__(66);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _pinall = __webpack_require__(922);

var _pinall2 = _interopRequireDefault(_pinall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pin = function (_React$Component) {
	_inherits(Pin, _React$Component);

	function Pin() {
		_classCallCheck(this, Pin);

		return _possibleConstructorReturn(this, (Pin.__proto__ || Object.getPrototypeOf(Pin)).apply(this, arguments));
	}

	_createClass(Pin, [{
		key: "render",
		value: function render() {
			return _react2.default.createElement(_Checkbox2.default, {
				checked: this.props.checked,
				indeterminate: this.props.indeterminate,
				onChange: this.props.onChange,
				className: (0, _classnames2.default)(this.props.className, "Pin"),
				icon: {
					on: this.props.useForAll ? { type: "svg", src: _pinall2.default } : "pin",
					off: "pin",
					indeterminate: "pin"
				}
			});
		}
	}]);

	return Pin;
}(_react2.default.Component);

exports.default = Pin;


Pin.propTypes = {
	checked: _react2.default.PropTypes.bool,
	indeterminate: _react2.default.PropTypes.bool,
	onChange: _react2.default.PropTypes.func,
	useForAll: _react2.default.PropTypes.bool
};

Pin.defaultProps = {
	checked: false,
	indeterminate: false,
	onChange: function onChange(value) {},
	useForAll: false
};

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(871);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popup = function (_React$Component) {
	_inherits(Popup, _React$Component);

	function Popup(props) {
		_classCallCheck(this, Popup);

		var _this = _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(Popup, [{
		key: "initState",
		value: function initState() {
			this.state = {
				shown: this.props.shown
			};
		}
	}, {
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.shown != this.props.shown) {
				this.setState({
					shown: nextProps.shown
				});
			}
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			this.popup = document.createElement("div");
			document.body.appendChild(this.popup);
			this.renderLayer();
		}
	}, {
		key: "componentDidUpdate",
		value: function componentDidUpdate() {
			this.renderLayer();
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			_reactDom2.default.unmountComponentAtNode(this.popup);
			document.body.removeChild(this.popup);
		}
	}, {
		key: "renderLayer",
		value: function renderLayer() {
			var className = (0, _classnames2.default)("Popup", this.props.className, { "Shown": this.state.shown });
			if (className !== this.popup.className) {
				this.popup.className = className;
				//this.popup.classList.add(...className.split(" ")); //bugos ie11 alatt
			}

			if (this.props.children) _reactDom2.default.render(this.props.children, this.popup);
		}
	}, {
		key: "render",
		value: function render() {
			// Render a placeholder
			return _react2.default.createElement("div", null);
		}
	}]);

	return Popup;
}(_react2.default.Component);

exports.default = Popup;


Popup.propTypes = {
	shown: _react2.default.PropTypes.bool
};

Popup.defaultProps = {
	shown: false
};

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(872);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Spinner = __webpack_require__(339);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressBar = function (_React$Component) {
	_inherits(ProgressBar, _React$Component);

	function ProgressBar() {
		_classCallCheck(this, ProgressBar);

		return _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).apply(this, arguments));
	}

	_createClass(ProgressBar, [{
		key: "renderIndeterminate",
		value: function renderIndeterminate() {
			return _react2.default.createElement(
				"div",
				{ className: (0, _classnames2.default)("ProgressBar Indeterminate", { "Hidden": !this.props.shown }) },
				_react2.default.createElement(
					"label",
					null,
					this.props.label
				),
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(_Spinner2.default, null)
				)
			);
		}
	}, {
		key: "renderDeterminate",
		value: function renderDeterminate() {

			var progress = this.props.progress > 100 ? 100 : this.props.progress < 0 ? 0 : this.props.progress;

			return _react2.default.createElement(
				"div",
				{ className: (0, _classnames2.default)("ProgressBar Determinate", { "Hidden": !this.props.shown }) },
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(
						"label",
						null,
						this.props.label
					),
					_react2.default.createElement(
						"span",
						{ className: !this.props.showProgress ? "Hidden" : "", style: { fontSize: this.props.fontSize + "px" } },
						progress,
						" %"
					)
				),
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement("div", { style: {
							height: this.props.height + "px",
							backgroundColor: this.props.color,
							width: progress + "%"
						} })
				)
			);
		}
	}, {
		key: "render",
		value: function render() {
			if (this.props.indeterminate) return this.renderIndeterminate();else return this.renderDeterminate();
		}
	}]);

	return ProgressBar;
}(_react2.default.Component);

exports.default = ProgressBar;


ProgressBar.propTypes = {
	indeterminate: _react2.default.PropTypes.bool,
	label: _react2.default.PropTypes.string,
	color: _react2.default.PropTypes.string,
	height: _react2.default.PropTypes.number,
	fontSize: _react2.default.PropTypes.number,
	showProgress: _react2.default.PropTypes.bool,
	progress: _react2.default.PropTypes.number,
	shown: _react2.default.PropTypes.bool
};

ProgressBar.defaultProps = {
	indeterminate: false,
	label: "",
	color: "#444",
	height: 5,
	fontSize: 16,
	showProgress: true,
	progress: 0,
	shown: true
};

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(873);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Select = function (_React$Component) {
	_inherits(Select, _React$Component);

	function Select() {
		_classCallCheck(this, Select);

		return _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).apply(this, arguments));
	}

	_createClass(Select, [{
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"select",
				_extends({}, this.props, {
					className: (0, _classnames2.default)(this.props.className, "Select")
				}),
				this.props.children
			);
		}
	}]);

	return Select;
}(_react2.default.Component);

exports.default = Select;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(874);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Spinner = function (_React$Component) {
	_inherits(Spinner, _React$Component);

	function Spinner() {
		_classCallCheck(this, Spinner);

		return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
	}

	_createClass(Spinner, [{
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"div",
				{ className: "Spinner" },
				_react2.default.createElement(
					"svg",
					{ className: "circular", viewBox: "25 25 50 50" },
					_react2.default.createElement("circle", { className: "path", cx: "50", cy: "50", r: "20", fill: "none", strokeWidth: "2", "stroke-miterlimit": "10" })
				)
			);
		}
	}]);

	return Spinner;
}(_react2.default.Component);

exports.default = Spinner;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Spinner = __webpack_require__(338);

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Spinner2.default;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(875);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tabs = function (_React$Component) {
	_inherits(Tabs, _React$Component);

	function Tabs(props) {
		_classCallCheck(this, Tabs);

		var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(Tabs, [{
		key: "initState",
		value: function initState() {

			var defaultTabId = this.props.children.length > 0 ? this.props.children[0].props.id : null;

			this.state = {
				selected: "selected" in this.props ? this.props.selected : defaultTabId
			};
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate(nextProps, nextState) {
			if ("selected" in nextState) return true;
			return "selected" in nextProps;
		}
	}, {
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.selected != this.props.selected) {
				this.setState({
					selected: nextProps.selected
				});
			}
		}
	}, {
		key: "select",
		value: function select(id) {
			if (id == this.state.selected) return;

			this.setState({
				selected: id
			});

			this.props.onChange(id);
		}
	}, {
		key: "renderTab",
		value: function renderTab(tab) {
			var _this2 = this;

			var className = this.state.selected == tab.props.id ? "Selected" : "";

			return _react2.default.createElement(
				"li",
				{ key: tab.props.id, className: className, onClick: function onClick() {
						return _this2.select(tab.props.id);
					} },
				tab.props.children
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this3 = this;

			return _react2.default.createElement(
				"ul",
				{ className: (0, _classnames2.default)(this.props.className, "Tabs") },
				this.props.children.map(function (tab) {
					return _this3.renderTab(tab);
				})
			);
		}
	}]);

	return Tabs;
}(_react2.default.Component);

exports.default = Tabs;


Tabs.propTypes = {
	onChange: _react2.default.PropTypes.func,
	selected: _react2.default.PropTypes.string
};

Tabs.defaultProps = {
	onChange: function onChange(id) {}
};

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(876);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Input = __webpack_require__(52);

var _Input2 = _interopRequireDefault(_Input);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextFilter = function (_React$Component) {
	_inherits(TextFilter, _React$Component);

	function TextFilter(props) {
		_classCallCheck(this, TextFilter);

		var _this = _possibleConstructorReturn(this, (TextFilter.__proto__ || Object.getPrototypeOf(TextFilter)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(TextFilter, [{
		key: "initState",
		value: function initState() {
			this.state = {
				value: this.props.value
			};
		}
	}, {
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.value != this.props.value) {
				this.setState({
					value: nextProps.value
				});
			}
		}
	}, {
		key: "submit",
		value: function submit() {
			var input = _reactDom2.default.findDOMNode(this.refs.input);
			this.props.onSubmit(input.value);
		}
	}, {
		key: "handleKeyUp",
		value: function handleKeyUp(evt) {
			if (evt.keyCode == 13) {
				this.submit();
			}
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				"div",
				{ className: "TextFilter" },
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(_Input2.default, {
						ref: "input",
						value: this.state.value,
						onChange: function onChange(evt) {
							return _this2.setState({ value: evt.target.value });
						},
						placeholder: _lang2.default._SEARCH,
						onKeyUp: function onKeyUp(evt) {
							return _this2.handleKeyUp(evt);
						}
					}),
					_react2.default.createElement(_Button2.default, {
						icon: "magnify",
						onClick: function onClick(_) {
							return _this2.submit();
						}
					})
				)
			);
		}
	}]);

	return TextFilter;
}(_react2.default.Component);

exports.default = TextFilter;


TextFilter.propTypes = {
	onSubmit: _react2.default.PropTypes.func,
	value: _react2.default.PropTypes.string
};

TextFilter.defaultProps = {
	onSubmit: function onSubmit(value) {},
	value: ""
};

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

__webpack_require__(877);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Toast = function Toast(content, color) {
	var _this = this;

	_classCallCheck(this, Toast);

	if (!content) throw new Error("Missing content");

	this.wrapper = document.createElement("div");
	this.wrapper.classList.add("Toast");
	document.body.appendChild(this.wrapper);

	if (color) {
		if (color.toLowerCase() == 'orange') this.wrapper.classList.add('Orange');
		if (color.toLowerCase() == 'green') this.wrapper.classList.add('Green');
		if (color.toLowerCase() == 'red') this.wrapper.classList.add('Red');
	}

	if (content.constructor === String) {
		this.wrapper.textContent = content;
	} else if (content instanceof Element) {
		this.wrapper.appendChild(content);
	}

	setTimeout(function () {
		return document.body.removeChild(_this.wrapper);
	}, Toast.TIMEOUT);
};

exports.default = Toast;


Toast.TIMEOUT = 5000;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

/**
	@typedef InnerCollectionDescriptor
	@property {String[]} [keyNames=[]] The keynames of inner collection
*/

/**
	@param {String[]} [keyNames=[]]
	@param {InnerCollectionDescriptor} [multi]
	@param {Object} [key] Egy-egy belső collection számára fenntartott paraméter (példányonként).
	
	Ha nem nevezünk meg kulcsokat,
	akkor feltételezzük, hogy
	az elemek maguk a kulcsok,
	azaz: primitívek .
*/

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(138);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Collection = function (_EventEmitter) {
	_inherits(Collection, _EventEmitter);

	function Collection() {
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		_classCallCheck(this, Collection);

		var _this = _possibleConstructorReturn(this, (Collection.__proto__ || Object.getPrototypeOf(Collection)).call(this));

		_this.setMaxListeners(Infinity);

		_this.keyNames = options.keyNames || [];

		if (options.key) _this.key = options.key;

		if (options.multi) _this.setMultiDimensional(options.multi);

		_this.items = null;
		_this.map = {};
		return _this;
	}

	// PUBLIC METHODS

	_createClass(Collection, [{
		key: "get",
		value: function get(key) {
			var index = this.resolveKey(key);
			if (index === null) {
				if (this.multi) {
					return this.createInnerCollection(key);
				} else {
					return null;
				}
			}
			return this.items[index];
		}
	}, {
		key: "getAll",
		value: function getAll() {
			return this.items;
		}

		// PRIVATE METHODS

	}, {
		key: "setMultiDimensional",
		value: function setMultiDimensional(innerCollectionDescriptor) {
			this.multi = true;
			this.innerCollectionDescriptor = innerCollectionDescriptor;
		}
	}, {
		key: "createInnerCollection",
		value: function createInnerCollection(key) {
			var innerCollection = new Collection({
				keyNames: this.innerCollectionDescriptor.keyNames || [],
				key: key
			});
			// nem emittálunk ilyenkor
			this.items = this.items || [];
			this.items.push(innerCollection);
			this.createMap();

			return innerCollection;
		}

		// Több dimmenziós collection-ök esetében
		// a belső collection-ök kulccsal rendelkeznek.
		// Ezek elérésére van a getKey függvény.

	}, {
		key: "getKey",
		value: function getKey() {
			return this.key || null;
		}
	}, {
		key: "createMap",
		value: function createMap() {
			var _this2 = this;

			this.map = {};

			if (!this.items) return;

			this.items.forEach(function (item, index) {
				if (_this2.multi) _this2.map[item.getKey()] = index;else if (_this2.keyNames.length) _this2.keyNames.forEach(function (keyName, keyNameIndex) {
					return _this2.map[item[keyName]] = index;
				});else _this2.map[item] = index;
			});
		}
	}, {
		key: "resolveKey",
		value: function resolveKey(key) {

			if (!key) throw new Error("Missing key");

			var index = this.map[key];

			if (index === undefined) return null;

			return index;
		}
	}, {
		key: "getDefaultKey",
		value: function getDefaultKey() {
			if (this.keyNames && this.keyNames.length) return this.keyNames[0];else return null;
		}
	}, {
		key: "contains",
		value: function contains(item) {
			var defaultKey = this.getDefaultKey();
			if (!defaultKey) {
				return this.get(item) ? true : false;
			} else {
				return this.get(item[defaultKey]) ? true : false;
			}
		}
	}, {
		key: "set",
		value: function set(items) {
			this.items = items;
			this.createMap();
			this.emit('change', this.items);
			this.emit('set', items);
		}
	}, {
		key: "insert",
		value: function insert(items) {
			var _this3 = this;

			this.items = this.items || [];

			items.forEach(function (item) {
				if (_this3.contains(item)) return;
				_this3.items.push(item);
			});

			this.createMap();
			this.emit('change', this.items);
			this.emit('insert', items);
		}
	}, {
		key: "update",
		value: function update(key, item) {
			var index = this.resolveKey(key);
			if (index === null) return;

			this.items[index] = item;
			this.createMap();
			this.emit('change', this.items);
			this.emit('update', item);
		}
	}, {
		key: "remove",
		value: function remove(keys) {
			var _this4 = this;

			if (!keys) return;

			if (!this.items || this.items.length == 0) return;

			var items = [];

			keys.forEach(function (key) {
				var index = _this4.resolveKey(key);
				if (index === null) return;

				items.push(_this4.items.splice(index, 1)[0]);
				_this4.createMap();
			});

			this.emit('change', this.items);
			this.emit('remove', items);
		}
	}]);

	return Collection;
}(_events.EventEmitter);

exports.default = Collection;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(138);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dispatcher = function (_EventEmitter) {
	_inherits(Dispatcher, _EventEmitter);

	function Dispatcher() {
		_classCallCheck(this, Dispatcher);

		var _this = _possibleConstructorReturn(this, (Dispatcher.__proto__ || Object.getPrototypeOf(Dispatcher)).call(this));

		_this.setMaxListeners(Infinity);
		return _this;
	}

	_createClass(Dispatcher, [{
		key: "dispatch",
		value: function dispatch(eventName) {
			for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
				args[_key - 1] = arguments[_key];
			}

			return this.emit.apply(this, [eventName].concat(args));
		}
	}]);

	return Dispatcher;
}(_events.EventEmitter);

exports.default = Dispatcher;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(138);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Singleton = function (_EventEmitter) {
	_inherits(Singleton, _EventEmitter);

	function Singleton() {
		_classCallCheck(this, Singleton);

		var _this = _possibleConstructorReturn(this, (Singleton.__proto__ || Object.getPrototypeOf(Singleton)).call(this));

		_this.setMaxListeners(Infinity);
		_this.item = null;
		return _this;
	}

	// PUBLIC METHODS

	_createClass(Singleton, [{
		key: "get",
		value: function get() {
			return this.item;
		}

		// PRIVATE METHODS

	}, {
		key: "set",
		value: function set(item) {
			this.item = item;
			this.emit('change', item);
		}
	}]);

	return Singleton;
}(_events.EventEmitter);

exports.default = Singleton;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _querystring = __webpack_require__(275);

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Nominatim = function () {
	function Nominatim() {
		_classCallCheck(this, Nominatim);

		this.xhr = new XMLHttpRequest();
		this.queue = [];
	}

	_createClass(Nominatim, [{
		key: "pushQueue",
		value: function pushQueue(position, callback) {
			this.queue.push({
				position: position,
				callback: callback || function (error, address) {}
			});
		}
	}, {
		key: "next",
		value: function next() {
			var _this = this;

			if (!this.queue[0]) return;

			var position = this.queue[0].position;
			var callback = this.queue[0].callback;

			this.xhr.onreadystatechange = function () {
				if (_this.xhr.readyState != 4) return;

				if (_this.xhr.responseText) {
					var response = JSON.parse(_this.xhr.responseText);
					callback(null, _this.constructor.getFullAddressFromOSMResponse(response));
				} else if (_this.xhr.status != 200 && _this.xhr.status != 307 && _this.xhr.status != 302) {
					callback(new Error());
					return;
				}

				_this.queue.splice(0, 1);
				_this.next();
			};

			this.xhr.open('GET', this.constructor.URL + this.constructor.getURLQuery(position));
			this.xhr.setRequestHeader("Content-type", "application/json");
			this.xhr.send();
		}
	}, {
		key: "geocode",
		value: function geocode(position, callback) {
			this.pushQueue(position, callback);
			this.next();
		}
	}], [{
		key: "getFullAddressFromOSMResponse",
		value: function getFullAddressFromOSMResponse(response) {

			var addressParts = [[], [], []];

			// irányítószám és város
			if (response.address.postcode) addressParts[0].push(response.address.postcode);

			if (response.address.city) addressParts[0].push(response.address.city);else if (response.address.town) addressParts[0].push(response.address.town);else if (response.address.village) addressParts[0].push(response.address.village);

			if (response.address.city_district) addressParts[0].push(response.address.city_district);

			// cím
			if (response.address.road) addressParts[1].push(response.address.road);

			if (response.address.house_number) addressParts[1].push(response.address.house_number);

			// ország
			if (response.address.country) addressParts[2].push(response.address.country);

			return addressParts.map(function (mainPart) {
				return mainPart.filter(function (subPart) {
					return subPart;
				}).join(' ');
			}).filter(function (mainPartString) {
				return mainPartString;
			}).join(', ');
		}

		// ezt majd bővíteni kell geopoint-ra

	}, {
		key: "positionToLatLng",
		value: function positionToLatLng(position) {
			return { lat: position.lat(), lng: position.lng() };
		}
	}, {
		key: "getURLQuery",
		value: function getURLQuery(position) {
			var latLng = this.positionToLatLng(position);
			var request = {
				lat: latLng.lat,
				lon: latLng.lng,
				format: 'json',
				addressdetails: 1
			};
			return '?' + _querystring2.default.stringify(request);
		}
	}]);

	return Nominatim;
}();

exports.default = Nominatim;


Nominatim.URL = "https://nominatim.openstreetmap.org/reverse";

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = scalarToQuantity;

var _createWellQuantity = __webpack_require__(88);

var _createWellQuantity2 = _interopRequireDefault(_createWellQuantity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scalarToQuantity(dataTypeStore, unitAssignment, scalar) {

	var application = dataTypeStore.get(scalar.dataType).applicationType;
	var representationType = dataTypeStore.get(scalar.dataType).representationType;
	var originalUnit = dataTypeStore.get(scalar.dataType).unit;

	return (0, _createWellQuantity2.default)(unitAssignment, application, scalar.value, originalUnit, representationType);
}

/***/ },
/* 348 */
/***/ function(module, exports) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = listenResize;
function listenResize(target) {
	var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (w, h) {};
	var schedule = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;


	if (!target) return;

	var width = target.clientWidth;
	var height = target.clientHeight;

	setInterval(function () {
		if (width !== target.clientWidth || height !== target.clientHeight) {
			width = target.clientWidth;
			height = target.clientHeight;
			handler(width, height);
		}
	}, schedule);
}

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(138);

var _host = __webpack_require__(209);

var _host2 = _interopRequireDefault(_host);

var _token = __webpack_require__(118);

var _token2 = _interopRequireDefault(_token);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_PORT = 8000;
var DEFAULT_TIMEOUT = 10000;

var Connection = function (_EventEmitter) {
	_inherits(Connection, _EventEmitter);

	function Connection() {
		_classCallCheck(this, Connection);

		var _this = _possibleConstructorReturn(this, (Connection.__proto__ || Object.getPrototypeOf(Connection)).call(this));

		_this.retryTimer = null;
		_this.ws = null;
		_this.authenticated = false;

		_this.requestQueue = [];
		return _this;
	}

	_createClass(Connection, [{
		key: "connect",
		value: function connect() {
			var _this2 = this;

			return new Promise(function (resolve, reject) {

				if (_this2.authenticated) return resolve(_this2);

				_host2.default.get(function (fullHost) {
					var host = fullHost.split(":")[0];
					_this2.ws = new WebSocket("ws://" + host + ':' + DEFAULT_PORT);
					_this2.ws.onopen = _this2.openHandler.bind(_this2);
					_this2.ws.onclose = _this2.closeHandler.bind(_this2);
					_this2.ws.onerror = _this2.errorHandler.bind(_this2);
					_this2.ws.onmessage = _this2.messageHandler.bind(_this2);

					_this2.once("auth", function (_) {
						return resolve(_this2);
					});
					_this2.once("error", function (error) {
						return reject(error);
					});
				});
			});
		}
	}, {
		key: "close",
		value: function close() {
			this.removeAllListeners();
			this.ws.close();
			this.closeHandler();
		}
	}, {
		key: "push",
		value: function push(request, params, callback) {

			this.requestQueue.push({
				request: request,
				params: params,
				callback: callback,
				state: 0
			});
		}
	}, {
		key: "iterateQueue",
		value: function iterateQueue() {

			var current = this.getFirstFromQueue();

			if (!current || current.state == 1) return;

			if (current.state == 2) {
				this.requestQueue.shift();
				this.iterateQueue();
				return;
			}

			current.state = 1;

			setTimeout(function () {
				if (current.state > 1) return;
				current.state = 2;
				current.callback({
					id: "TIMEOUT",
					message: "TIMEOUT"
				});
			}.bind(this), DEFAULT_TIMEOUT);

			this.send({
				request: current.request,
				params: current.params
			});
		}
	}, {
		key: "send",
		value: function send(message) {

			if (this.ws.readyState !== 1) return;

			this.ws.send(JSON.stringify(message));
		}
	}, {
		key: "getFirstFromQueue",
		value: function getFirstFromQueue() {
			return this.requestQueue.length > 0 ? this.requestQueue[0] : null;
		}
	}, {
		key: "openHandler",
		value: function openHandler() {
			if (this.retryTimer) clearTimeout(this.retryTimer);

			this.auth();
			//this.iterateQueue();
		}
	}, {
		key: "messageHandler",
		value: function messageHandler(evt) {
			var message = JSON.parse(evt.data);

			if (message.response) {

				var current = this.getFirstFromQueue();

				if (!current) return;

				if (current.state == 1) {
					if (message.response == 'ErrorResponse') {
						console.error(message.response);
						if (current && current.callback) current.callback(message);
						current.state = 2;
					} else {
						if (current && current.callback) current.callback(null, message.payload);
						current.state = 2;
					}
				}

				this.iterateQueue();
			} else if (message.event) {
				this.emit(message.event, message.payload);
			}
		}
	}, {
		key: "closeHandler",
		value: function closeHandler(evt) {

			this.authenticated = false;

			if (evt && evt.code > 1000) console.error(evt.code, evt.reason);
			if (evt && [1000, 1002, 1003, 1007, 4001].indexOf(evt.code) === -1) this.retry();

			this.emit('close');
		}
	}, {
		key: "errorHandler",
		value: function errorHandler(evt) {
			this.emit('error');
			console.log(evt);
			this.retry();
		}
	}, {
		key: "retry",
		value: function retry() {
			var _this3 = this;

			if (this.retryTimer) clearTimeout(this.retryTimer);

			this.retryTimer = setTimeout(function () {
				return _this3.connect();
			}, DEFAULT_TIMEOUT);
		}
	}, {
		key: "auth",
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				var _this4 = this;

				var token;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return _token2.default.get();

							case 2:
								token = _context.sent;

								this.require('auth', { token: token }, function (error) {
									if (error) {
										console.error(error);
										_this4.emit('error', error);
										return;
									}
									_this4.authenticated = true;
									_this4.emit('auth', _this4);
								});

							case 4:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function auth() {
				return _ref.apply(this, arguments);
			}

			return auth;
		}()
	}, {
		key: "require",
		value: function require() {
			var _this5 = this;

			if (this.ws.readyState !== 1) {
				var error = new Error("websocket is not ready yet");
				callback(error);
				return Promise.reject(error);
			}

			var args = this.constructor.getRequestArguments.apply(null, arguments);

			if (!args.request) {
				var _error = new Error("request is required");
				callback(_error);
				return Promise.reject(_error);
			}

			if (args.request !== 'auth' && !this.authenticated) {
				var _error2 = new Error("wsi connection is not authenticated");
				callback(_error2);
				return Promise.reject(_error2);
			}

			return new Promise(function (resolve, reject) {
				_this5.push(args.request, args.params, function (error, response) {
					args.callback(error, response);
					if (error) reject(error);else resolve(response || undefined);
				});
				_this5.iterateQueue();
			});
		}
	}, {
		key: "on",
		value: function on() {

			var args = this.constructor.getListenerArguments.apply(null, arguments);

			this.constructor.__proto__.prototype.on.call(this, args.event, args.handler);

			if (['auth', 'error', 'close', 'connect'].indexOf(args.event) > -1) return this;

			this.send({
				event: args.event,
				filter: args.filter || {}
			});

			return this;
		}
	}, {
		key: "once",
		value: function once() {

			var args = this.constructor.getListenerArguments.apply(null, arguments);

			this.constructor.__proto__.prototype.once.call(this, args.event, args.handler);

			if (['auth', 'error', 'close', 'connect'].indexOf(args.event) > -1) return this;

			this.send({
				event: args.event,
				filter: args.filter || {},
				once: true
			});

			return this;
		}
	}, {
		key: "getState",
		value: function getState() {
			return this.ws.readyState;
		}
	}, {
		key: "isOpened",
		value: function isOpened() {
			return this.ws.readyState == 1 ? true : false;
		}
	}, {
		key: "isAuthenticated",
		value: function isAuthenticated() {
			return this.authenticated;
		}
	}], [{
		key: "getRequestArguments",
		value: function getRequestArguments() {

			var args = Array.prototype.slice.call(arguments);
			var request = null;
			var params = {};
			var callback = function callback(error, responseData) {};

			for (var i in args) {
				if (args[i].constructor === String) request = args[i];else if (args[i].constructor === Object) params = args[i];else if (args[i].constructor === Function) callback = args[i];
			}

			return {
				request: request,
				params: params,
				callback: callback
			};
		}
	}, {
		key: "getListenerArguments",
		value: function getListenerArguments() {

			var args = Array.prototype.slice.call(arguments);
			var event = null;
			var filter = {};
			var handler = function handler(error, responseData) {};

			for (var i in args) {
				if (args[i].constructor === String) event = args[i];else if (args[i].constructor === Object) filter = args[i];else if (args[i].constructor === Function) handler = args[i];
			}

			return {
				event: event,
				filter: filter,
				handler: handler
			};
		}
	}, {
		key: "bufferToArray",
		value: function bufferToArray(buffer) {
			var view = new DataView(buffer);
			var array = [];
			for (var i = 0; i < view.byteLength; ++i) {
				array.push(view.getUint8(i));
			}return array;
		}
	}]);

	return Connection;
}(_events.EventEmitter);

exports.default = Connection;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(poiId, collaboration) {
		var response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return _api2.default.post("pois/collaborations", {
							_id: poiId,
							collaborations: [collaboration]
						});

					case 3:
						response = _context.sent;

						_dispatcher2.default.dispatch("addCollaboration", poiId, response.collaborations[0]);
						return _context.abrupt("return", true);

					case 8:
						_context.prev = 8;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0)) {
							_context.next = 14;
							break;
						}

						new _Toast2.default(_lang2.default.SOMETHING_WRONG, "orange");
						_context.next = 15;
						break;

					case 14:
						throw _context.t0;

					case 15:
						return _context.abrupt("return", false);

					case 16:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 8]]);
	}));

	function addPOICollaboration(_x, _x2) {
		return _ref.apply(this, arguments);
	}

	return addPOICollaboration;
}();

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _user = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(oldPassword, newPassword) {
		var userId, md5, response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						userId = (0, _user.getUserId)();

						if (userId) {
							_context.next = 4;
							break;
						}

						return _context.abrupt("return");

					case 4:
						md5 = __webpack_require__(270);
						_context.next = 7;
						return _api2.default.put("users", {
							users: [userId],
							oldPassword: md5(oldPassword),
							modifications: {
								password: md5(newPassword)
							}
						});

					case 7:
						response = _context.sent;
						_context.next = 17;
						break;

					case 10:
						_context.prev = 10;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0 && (!_context.t0.group || _context.t0.group != "REQUEST_ERROR"))) {
							_context.next = 16;
							break;
						}

						new _Toast2.default(_lang2.default.SOMETHING_WRONG, "orange");
						_context.next = 17;
						break;

					case 16:
						throw _context.t0;

					case 17:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 10]]);
	}));

	function changePassword(_x, _x2) {
		return _ref.apply(this, arguments);
	}

	return changePassword;
}();

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(poiId, collaboratorId) {
		var response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return _api2.default.delete("pois/collaborations", {
							_id: poiId,
							collaborators: [collaboratorId]
						});

					case 3:
						response = _context.sent;

						_dispatcher2.default.dispatch("removeCollaboration", poiId, response.collaborations[0].collaborator);
						_context.next = 14;
						break;

					case 7:
						_context.prev = 7;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0)) {
							_context.next = 13;
							break;
						}

						new _Toast2.default(_lang2.default.SOMETHING_WRONG, "orange");
						_context.next = 14;
						break;

					case 13:
						throw _context.t0;

					case 14:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 7]]);
	}));

	function clearPOICollaboration(_x, _x2) {
		return _ref.apply(this, arguments);
	}

	return clearPOICollaboration;
}();

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var getCollaborations = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(poiId) {
		var collaborations;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						collaborations = _poiCollaborations2.default.get(poiId).getAll();

						if (collaborations) {
							_context.next = 7;
							break;
						}

						_context.next = 4;
						return (0, _getPOICollaborations2.default)(poiId);

					case 4:
						collaborations = _poiCollaborations2.default.get(poiId).getAll();

						if (collaborations) {
							_context.next = 7;
							break;
						}

						return _context.abrupt("return", []);

					case 7:
						return _context.abrupt("return", collaborations);

					case 8:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function getCollaborations(_x) {
		return _ref.apply(this, arguments);
	};
}();

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _poiCollaborations = __webpack_require__(155);

var _poiCollaborations2 = _interopRequireDefault(_poiCollaborations);

var _getPOICollaborations = __webpack_require__(151);

var _getPOICollaborations2 = _interopRequireDefault(_getPOICollaborations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(poiId) {
		var response, collaborations;
		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.prev = 0;
						_context2.next = 3;
						return _api2.default.delete("pois", { pois: [poiId] });

					case 3:
						response = _context2.sent;
						_context2.next = 6;
						return getCollaborations(poiId);

					case 6:
						collaborations = _context2.sent;
						_context2.next = 9;
						return _api2.default.delete("pois/collaborations", {
							_id: poiId,
							collaborators: collaborations.map(function (c) {
								return c.collaborator;
							})
						});

					case 9:
						_dispatcher2.default.dispatch("removePOI", poiId);
						_context2.next = 19;
						break;

					case 12:
						_context2.prev = 12;
						_context2.t0 = _context2["catch"](0);

						if (!("id" in _context2.t0)) {
							_context2.next = 18;
							break;
						}

						new _Toast2.default(_lang2.default.SOMETHING_WRONG, "orange");
						_context2.next = 19;
						break;

					case 18:
						throw _context2.t0;

					case 19:
					case "end":
						return _context2.stop();
				}
			}
		}, _callee2, this, [[0, 12]]);
	}));

	function deletePOI(_x2) {
		return _ref2.apply(this, arguments);
	}

	return deletePOI;
}();

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _sleep = __webpack_require__(75);

var _sleep2 = _interopRequireDefault(_sleep);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var SLEEP_TIME = 5000;

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
		var response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return _api2.default.get('dataTypes');

					case 3:
						response = _context.sent;

						_dispatcher2.default.dispatch('getDataTypes', response.dataTypes);
						_context.next = 16;
						break;

					case 7:
						_context.prev = 7;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0)) {
							_context.next = 15;
							break;
						}

						_context.next = 12;
						return (0, _sleep2.default)(SLEEP_TIME);

					case 12:
						getDataTypes();
						_context.next = 16;
						break;

					case 15:
						throw _context.t0;

					case 16:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 7]]);
	}));

	function getDataTypes() {
		return _ref.apply(this, arguments);
	}

	return getDataTypes;
}();

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _sleep = __webpack_require__(75);

var _sleep2 = _interopRequireDefault(_sleep);

var _user = __webpack_require__(20);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var SLEEP_TIME = 5000;

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
		var response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return _api2.default.get('eventDescriptors', {
							user: (0, _user.getUserId)()
						});

					case 3:
						response = _context.sent;

						_dispatcher2.default.dispatch('getEventDescriptors', response.eventDescriptors);
						_context.next = 16;
						break;

					case 7:
						_context.prev = 7;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0)) {
							_context.next = 15;
							break;
						}

						_context.next = 12;
						return (0, _sleep2.default)(SLEEP_TIME);

					case 12:
						getEventDescriptors();
						_context.next = 16;
						break;

					case 15:
						throw _context.t0;

					case 16:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 7]]);
	}));

	function getEventDescriptors() {
		return _ref.apply(this, arguments);
	}

	return getEventDescriptors;
}();

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _sleep = __webpack_require__(75);

var _sleep2 = _interopRequireDefault(_sleep);

var _user = __webpack_require__(20);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var SLEEP_TIME = 5000;

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
		var response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return _api2.default.get('pois', {
							user: (0, _user.getUserId)(),
							resolveGroups: true
						});

					case 3:
						response = _context.sent;

						_dispatcher2.default.dispatch('getPOIs', response.pois);
						_context.next = 16;
						break;

					case 7:
						_context.prev = 7;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0)) {
							_context.next = 15;
							break;
						}

						_context.next = 12;
						return (0, _sleep2.default)(SLEEP_TIME);

					case 12:
						getPOIs();
						_context.next = 16;
						break;

					case 15:
						throw _context.t0;

					case 16:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 7]]);
	}));

	function getPOIs() {
		return _ref.apply(this, arguments);
	}

	return getPOIs;
}();

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _sleep = __webpack_require__(75);

var _sleep2 = _interopRequireDefault(_sleep);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var SLEEP_TIME = 5000;

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
		var response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return _api2.default.get('services');

					case 3:
						response = _context.sent;

						_dispatcher2.default.dispatch('getServices', response.services);
						_context.next = 16;
						break;

					case 7:
						_context.prev = 7;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0)) {
							_context.next = 15;
							break;
						}

						_context.next = 12;
						return (0, _sleep2.default)(SLEEP_TIME);

					case 12:
						getServices();
						_context.next = 16;
						break;

					case 15:
						throw _context.t0;

					case 16:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 7]]);
	}));

	function getServices() {
		return _ref.apply(this, arguments);
	}

	return getServices;
}();

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _sleep = __webpack_require__(75);

var _sleep2 = _interopRequireDefault(_sleep);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _user = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var SLEEP_TIME = 5000;

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
		var user, response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						user = (0, _user.getUser)();

						if (!(!user || !user.groups || user.groups.length === 0)) {
							_context.next = 4;
							break;
						}

						_dispatcher2.default.dispatch('getUsers', [user]);
						return _context.abrupt("return");

					case 4:
						_context.prev = 4;
						_context.next = 7;
						return _api2.default.get('users', {
							_id: user.groups,
							resolveGroups: true
						});

					case 7:
						response = _context.sent;

						_dispatcher2.default.dispatch('getUsers', response.users);
						_context.next = 20;
						break;

					case 11:
						_context.prev = 11;
						_context.t0 = _context["catch"](4);

						if (!("id" in _context.t0)) {
							_context.next = 19;
							break;
						}

						_context.next = 16;
						return (0, _sleep2.default)(SLEEP_TIME);

					case 16:
						getUsers();
						_context.next = 20;
						break;

					case 19:
						throw _context.t0;

					case 20:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[4, 11]]);
	}));

	function getUsers() {
		return _ref.apply(this, arguments);
	}

	return getUsers;
}();

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _user = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(vehicleId, from, to) {
		var reportResponse, details, report;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return _api2.default.get("reports", {
							carrier: vehicleId,
							from: from,
							to: to,
							type: "VehicleHeatmap",
							user: (0, _user.getUserId)()
						});

					case 3:
						reportResponse = _context.sent;
						details = _openedDetails2.default.get(vehicleId);

						if (details) {
							_context.next = 7;
							break;
						}

						return _context.abrupt("return");

					case 7:
						report = reportResponse.reports[0];

						_dispatcher2.default.dispatch("getVehicleHeatmap", report);
						_context.next = 18;
						break;

					case 11:
						_context.prev = 11;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0)) {
							_context.next = 17;
							break;
						}

						new _Toast2.default(_lang2.default.OPERATION_FAILED, "orange");
						_context.next = 18;
						break;

					case 17:
						throw _context.t0;

					case 18:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 11]]);
	}));

	function getVehicleHeatmap(_x, _x2, _x3) {
		return _ref.apply(this, arguments);
	}

	return getVehicleHeatmap;
}();

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var resolveAddresses = function () {
	var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(result) {
		var uniqPositionSet, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						uniqPositionSet = createUniqPositionSet(result.sections);
						_iteratorNormalCompletion = true;
						_didIteratorError = false;
						_iteratorError = undefined;
						_context2.prev = 4;
						_iterator = uniqPositionSet[Symbol.iterator]();

					case 6:
						if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
							_context2.next = 23;
							break;
						}

						item = _step.value;

						if (!item.address) {
							_context2.next = 10;
							break;
						}

						return _context2.abrupt("continue", 20);

					case 10:
						_context2.prev = 10;
						_context2.next = 13;
						return (0, _geocode2.default)('nominatim', item.position);

					case 13:
						item.address = _context2.sent;
						_context2.next = 16;
						return (0, _storeAddress2.default)(item.position, item.address);

					case 16:
						_context2.next = 20;
						break;

					case 18:
						_context2.prev = 18;
						_context2.t0 = _context2["catch"](10);

					case 20:
						_iteratorNormalCompletion = true;
						_context2.next = 6;
						break;

					case 23:
						_context2.next = 29;
						break;

					case 25:
						_context2.prev = 25;
						_context2.t1 = _context2["catch"](4);
						_didIteratorError = true;
						_iteratorError = _context2.t1;

					case 29:
						_context2.prev = 29;
						_context2.prev = 30;

						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}

					case 32:
						_context2.prev = 32;

						if (!_didIteratorError) {
							_context2.next = 35;
							break;
						}

						throw _iteratorError;

					case 35:
						return _context2.finish(32);

					case 36:
						return _context2.finish(29);

					case 37:

						resolveUniqPositionSet(result.sections, uniqPositionSet);

					case 38:
					case "end":
						return _context2.stop();
				}
			}
		}, _callee2, this, [[4, 25, 29, 37], [10, 18], [30,, 32, 36]]);
	}));

	return function resolveAddresses(_x2) {
		return _ref2.apply(this, arguments);
	};
}();

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _geocode = __webpack_require__(117);

var _geocode2 = _interopRequireDefault(_geocode);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _storeAddress = __webpack_require__(152);

var _storeAddress2 = _interopRequireDefault(_storeAddress);

var _user = __webpack_require__(20);

var _resolver = __webpack_require__(225);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
		var payload, reportResponse, details, report;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						payload = {
							carrier: params.vehicleId,
							from: params.from,
							to: params.to,
							type: "POICrossings"
						};


						if (params.poi) {
							payload.poi = params.poi;
						}

						_context.next = 5;
						return _api2.default.get("reports", payload);

					case 5:
						reportResponse = _context.sent;
						details = _openedDetails2.default.get(params.vehicleId);

						if (details) {
							_context.next = 9;
							break;
						}

						return _context.abrupt("return");

					case 9:
						report = reportResponse.reports[0];
						_context.next = 12;
						return resolveAddresses(report.result);

					case 12:
						_dispatcher2.default.dispatch("getVehiclePOICrossings", report, params.from, params.to);
						_context.next = 22;
						break;

					case 15:
						_context.prev = 15;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0)) {
							_context.next = 21;
							break;
						}

						new _Toast2.default(_lang2.default.OPERATION_FAILED, "orange");
						_context.next = 22;
						break;

					case 21:
						throw _context.t0;

					case 22:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 15]]);
	}));

	function getVehiclePOICrossings(_x) {
		return _ref.apply(this, arguments);
	}

	return getVehiclePOICrossings;
}();

function createUniqPositionSet(sections) {

	var posAddMap = {};

	sections.forEach(function (section) {
		(0, _resolver.extendAddressPositionPairForUniqPositionMap)(posAddMap, section.start.location ? section.start.location.value : null, section.start.address);
		(0, _resolver.extendAddressPositionPairForUniqPositionMap)(posAddMap, section.end.location ? section.end.location.value : null, section.end.address);
	});

	// creating set from map
	return (0, _resolver.uniqPositionMapToUniqPositionSet)(posAddMap);
}

function resolveUniqPositionSet(sections, uniqPositionSet) {

	var uniqPositionMap = (0, _resolver.uniqPositionSetToUniqPositionMap)(uniqPositionSet);

	sections.forEach(function (section) {
		section.start.address = (0, _resolver.getAddressFromUniqPositionMapByPosition)(uniqPositionMap, section.start.location ? section.start.location.value : null);
		section.end.address = (0, _resolver.getAddressFromUniqPositionMapByPosition)(uniqPositionMap, section.end.location ? section.end.location.value : null);
	});
}

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _sleep = __webpack_require__(75);

var _sleep2 = _interopRequireDefault(_sleep);

var _filterGroups = __webpack_require__(67);

var _filterGroups2 = _interopRequireDefault(_filterGroups);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _user = __webpack_require__(20);

var _vehicles = __webpack_require__(45);

var _vehicles2 = _interopRequireDefault(_vehicles);

var _resolveCarrierState = __webpack_require__(217);

var _resolveCarrierState2 = _interopRequireDefault(_resolveCarrierState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var SLEEP_TIME = 5000;

function getVehicleIds() {
	return (0, _filterGroups2.default)(_vehicles2.default.getAll()).map(function (v) {
		return v._id;
	});
}

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
		var response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return _api2.default.get('carriers/states', {
							carrier: getVehicleIds(),
							user: (0, _user.getUserId)()
						});

					case 3:
						response = _context.sent;
						_context.next = 6;
						return Promise.all(response.states.map(_resolveCarrierState2.default));

					case 6:
						_dispatcher2.default.dispatch('getVehicleStates', response.states);
						_context.next = 18;
						break;

					case 9:
						_context.prev = 9;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0)) {
							_context.next = 17;
							break;
						}

						_context.next = 14;
						return (0, _sleep2.default)(SLEEP_TIME);

					case 14:
						getVehicleStates();
						_context.next = 18;
						break;

					case 17:
						throw _context.t0;

					case 18:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 9]]);
	}));

	function getVehicleStates() {
		return _ref.apply(this, arguments);
	}

	return getVehicleStates;
}();

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _sleep = __webpack_require__(75);

var _sleep2 = _interopRequireDefault(_sleep);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _user = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var SLEEP_TIME = 5000;

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
		var response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return _api2.default.get('carriers', {
							user: (0, _user.getUserId)(),
							resolveGroups: true
						});

					case 3:
						response = _context.sent;

						_dispatcher2.default.dispatch('getVehicles', response.carriers);
						_context.next = 16;
						break;

					case 7:
						_context.prev = 7;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0)) {
							_context.next = 15;
							break;
						}

						_context.next = 12;
						return (0, _sleep2.default)(SLEEP_TIME);

					case 12:
						getVehicles();
						_context.next = 16;
						break;

					case 15:
						throw _context.t0;

					case 16:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 7]]);
	}));

	function getVehicles() {
		return _ref.apply(this, arguments);
	}

	return getVehicles;
}();

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _getContext = __webpack_require__(150);

var _getContext2 = _interopRequireDefault(_getContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(token, username, password) {
		var requestData, md5;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						requestData = void 0;


						if (token) {
							requestData = {
								token: token,
								clientDevice: (0, _getContext2.default)() == "chromeapp" ? "Seagal" : window.navigator.userAgent || "unknown"
							};
						} else {
							md5 = __webpack_require__(270);

							requestData = {
								username: username,
								password: md5(password),
								clientDeviceId: "unknown",
								clientType: "WEB",
								clientDevice: (0, _getContext2.default)() == "chromeapp" ? "Seagal" : window.navigator.userAgent || "unknown"
							};
						}

						_context.next = 4;
						return _api2.default[token ? "put" : "post"]('users/login', requestData);

					case 4:
						return _context.abrupt("return", _context.sent);

					case 5:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	function login(_x, _x2, _x3) {
		return _ref.apply(this, arguments);
	}

	return login;
}();

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _user = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(contacts) {
		var userId, _ref2, _ref2$users, user;

		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						userId = (0, _user.getUserId)();

						if (userId) {
							_context.next = 4;
							break;
						}

						return _context.abrupt("return");

					case 4:
						_context.next = 6;
						return _api2.default.put("users", {
							users: [userId],
							modifications: { contacts: contacts }
						});

					case 6:
						_ref2 = _context.sent;
						_ref2$users = _slicedToArray(_ref2.users, 1);
						user = _ref2$users[0];


						if (user) _dispatcher2.default.dispatch("updateUser", user);
						_context.next = 19;
						break;

					case 12:
						_context.prev = 12;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0 && (!_context.t0.group || _context.t0.group != "REQUEST_ERROR"))) {
							_context.next = 18;
							break;
						}

						new _Toast2.default(_lang2.default.SOMETHING_WRONG, "orange");
						_context.next = 19;
						break;

					case 18:
						throw _context.t0;

					case 19:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 12]]);
	}));

	function saveContacts(_x) {
		return _ref.apply(this, arguments);
	}

	return saveContacts;
}();

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _vehicleModifications = __webpack_require__(224);

var _vehicleModifications2 = _interopRequireDefault(_vehicleModifications);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(vehicleId) {
		var modificationDoc, response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						modificationDoc = _vehicleModifications2.default.get(vehicleId);

						if (modificationDoc) {
							_context.next = 3;
							break;
						}

						return _context.abrupt("return");

					case 3:
						_context.prev = 3;
						_context.next = 6;
						return _api2.default.put("carriers", {
							carriers: [modificationDoc.vehicle],
							modifications: modificationDoc.modifications
						});

					case 6:
						response = _context.sent;

						_dispatcher2.default.dispatch("updateVehicle", response.carriers[0]);
						new _Toast2.default(_lang2.default.PROPERTIES_UPDATED, "green");
						_context.next = 18;
						break;

					case 11:
						_context.prev = 11;
						_context.t0 = _context["catch"](3);

						if (!("id" in _context.t0)) {
							_context.next = 17;
							break;
						}

						new _Toast2.default(_lang2.default.SOMETHING_WRONG, "orange");
						_context.next = 18;
						break;

					case 17:
						throw _context.t0;

					case 18:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[3, 11]]);
	}));

	function saveVehicle(_x) {
		return _ref.apply(this, arguments);
	}

	return saveVehicle;
}();

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(poiId, collaboratorId, privilege) {
		var response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return _api2.default.put("pois/collaborations", {
							_id: poiId,
							collaborators: [collaboratorId],
							modifications: { privilege: privilege }
						});

					case 3:
						response = _context.sent;

						_dispatcher2.default.dispatch("updateCollaboration", poiId, response.collaborations[0]);
						_context.next = 14;
						break;

					case 7:
						_context.prev = 7;
						_context.t0 = _context["catch"](0);

						if (!("id" in _context.t0)) {
							_context.next = 13;
							break;
						}

						new _Toast2.default(_lang2.default.SOMETHING_WRONG, "orange");
						_context.next = 14;
						break;

					case 13:
						throw _context.t0;

					case 14:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 7]]);
	}));

	function updatePOICollaboration(_x, _x2, _x3) {
		return _ref.apply(this, arguments);
	}

	return updatePOICollaboration;
}();

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var setOwner = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(poiId) {
		var userId, response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						if (poiId) {
							_context.next = 2;
							break;
						}

						return _context.abrupt("return");

					case 2:
						userId = (0, _user.getUserId)();

						if (userId) {
							_context.next = 5;
							break;
						}

						return _context.abrupt("return");

					case 5:
						_context.next = 7;
						return _api2.default.post("pois/collaborations", {
							_id: poiId,
							collaborations: [{ collaborator: userId, privilege: 4 }]
						});

					case 7:
						response = _context.sent;
						return _context.abrupt("return", response.collaborations[0]);

					case 9:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function setOwner(_x) {
		return _ref.apply(this, arguments);
	};
}();

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _user = __webpack_require__(20);

var _poi = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function () {
	var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(poi) {
		var response, collaboration;
		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.prev = 0;
						_context2.next = 3;
						return _api2.default.post("pois", { pois: [poi] });

					case 3:
						response = _context2.sent;
						_context2.next = 6;
						return setOwner(response.pois[0]._id);

					case 6:
						collaboration = _context2.sent;

						_dispatcher2.default.dispatch('createPOI', response.pois[0], collaboration);
						_dispatcher2.default.dispatch('setMap', {
							bounds: (0, _poi.getBoundsOfPOI)(response.pois[0]._id).toJSON()
						});
						_dispatcher2.default.dispatch('selectPOI', response.pois[0]._id);
						_context2.next = 19;
						break;

					case 12:
						_context2.prev = 12;
						_context2.t0 = _context2["catch"](0);

						if (!("id" in _context2.t0)) {
							_context2.next = 18;
							break;
						}

						new _Toast2.default(_lang2.default.SOMETHING_WRONG, "orange");
						_context2.next = 19;
						break;

					case 18:
						throw _context2.t0;

					case 19:
					case "end":
						return _context2.stop();
				}
			}
		}, _callee2, this, [[0, 12]]);
	}));

	function uploadPOI(_x2) {
		return _ref2.apply(this, arguments);
	}

	return uploadPOI;
}();

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusedVehicleStore = new _flux.Singleton();
exports.default = focusedVehicleStore;


window.focusedVehicleStore = focusedVehicleStore;

_dispatcher2.default.on('focusVehicle', function (vehicleId) {
	return focusedVehicleStore.set(vehicleId || null);
});

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var poiFilterExpressionStore = new _flux.Singleton();
exports.default = poiFilterExpressionStore;


window.poiFilterExpressionStore = poiFilterExpressionStore;

var defaultExpression = {
	text: "",
	type: null
};

poiFilterExpressionStore.set(defaultExpression);

_dispatcher2.default.on('filterPOIs', function (expression) {
	poiFilterExpressionStore.set(expression ? {
		text: expression.text === undefined ? poiFilterExpressionStore.get().text : expression.text,
		type: expression.type === undefined ? poiFilterExpressionStore.get().type : expression.type
	} : defaultExpression);
});

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _flux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userStore = new _flux.Collection({ keyNames: ["_id"] });
exports.default = userStore;


window.userStore = userStore;

_dispatcher2.default.on('getUsers', function (users) {
  return userStore.set(users);
});
_dispatcher2.default.on('updateUser', function (user) {
  return userStore.update(user._id, user);
});
_dispatcher2.default.on('logout', function () {
  return userStore.set(null);
});

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _session = __webpack_require__(30);

var _session2 = _interopRequireDefault(_session);

var _flux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vehicleFilterExpressionStore = new _flux.Singleton();
exports.default = vehicleFilterExpressionStore;


window.vehicleFilterExpressionStore = vehicleFilterExpressionStore;

var defaultExpression = {
	text: "",
	movement: null
};

vehicleFilterExpressionStore.set(defaultExpression);

_dispatcher2.default.on('filterVehicles', function (expression) {
	vehicleFilterExpressionStore.set(expression ? {
		text: expression.text === undefined ? vehicleFilterExpressionStore.get().text : expression.text,
		movement: expression.movement === undefined ? vehicleFilterExpressionStore.get().movement : expression.movement
	} : defaultExpression);
});

_session2.default.on('change', function (session) {
	return vehicleFilterExpressionStore.set(defaultExpression);
});

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(878);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _session = __webpack_require__(30);

var _session2 = _interopRequireDefault(_session);

var _uploadPOI = __webpack_require__(367);

var _uploadPOI2 = _interopRequireDefault(_uploadPOI);

var _component = __webpack_require__(302);

var _component2 = _interopRequireDefault(_component);

var _geocode = __webpack_require__(117);

var _geocode2 = _interopRequireDefault(_geocode);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Form = __webpack_require__(38);

var _Form2 = _interopRequireDefault(_Form);

var _Dialog = __webpack_require__(73);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _ProgressBar = __webpack_require__(34);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Input = __webpack_require__(52);

var _Input2 = _interopRequireDefault(_Input);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _polygon = __webpack_require__(924);

var _polygon2 = _interopRequireDefault(_polygon);

var _circle = __webpack_require__(923);

var _circle2 = _interopRequireDefault(_circle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POLYGON = "PolygonalPOI";
var RADIAL = "RadialPOI";

var CreatePOIDialog = function (_React$Component) {
	_inherits(CreatePOIDialog, _React$Component);

	function CreatePOIDialog(props) {
		_classCallCheck(this, CreatePOIDialog);

		var _this = _possibleConstructorReturn(this, (CreatePOIDialog.__proto__ || Object.getPrototypeOf(CreatePOIDialog)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(CreatePOIDialog, [{
		key: "initState",
		value: function initState() {
			this.state = {
				shown: false,
				inProgress: false,
				fixLocation: false,
				poi: this.getInitialPOI()
			};
		}
	}, {
		key: "getInitialPOI",
		value: function getInitialPOI() {
			return {
				type: "",
				name: "",
				address: "",
				location: null
			};
		}
	}, {
		key: "setPOIState",
		value: function setPOIState(modifications) {
			Object.assign(this.state.poi, modifications);
			this.forceUpdate();
		}
	}, {
		key: "show",
		value: function show(location) {
			this.setState({ shown: true });
			if (location) {
				this.setState({ fixLocation: true });
				this.setPOIState({ location: latLngToPoint(location) });
			} else {
				this.setState({ fixLocation: false });
			}
			this.geocodeLocation(location);
		}
	}, {
		key: "hide",
		value: function hide() {
			this.setState({ shown: false });
		}
	}, {
		key: "clear",
		value: function clear() {
			this.setState({
				poi: this.getInitialPOI()
			});
		}
	}, {
		key: "geocodeLocation",
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(location) {
				var address;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (location) {
									_context.next = 2;
									break;
								}

								return _context.abrupt("return");

							case 2:

								this.setState({ inProgress: true });
								_context.prev = 3;
								_context.next = 6;
								return (0, _geocode2.default)('google', location);

							case 6:
								address = _context.sent;

								if (address) this.setPOIState({ address: address });
								_context.next = 12;
								break;

							case 10:
								_context.prev = 10;
								_context.t0 = _context["catch"](3);

							case 12:
								_context.prev = 12;

								this.setState({ inProgress: false });
								return _context.finish(12);

							case 15:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this, [[3, 10, 12, 15]]);
			}));

			function geocodeLocation(_x) {
				return _ref.apply(this, arguments);
			}

			return geocodeLocation;
		}()
	}, {
		key: "geocodeAddress",
		value: function () {
			var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(address) {
				var location;
				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								if (address) {
									_context2.next = 2;
									break;
								}

								return _context2.abrupt("return");

							case 2:
								_context2.prev = 2;
								_context2.next = 5;
								return (0, _geocode2.default)('google', address);

							case 5:
								location = _context2.sent;

								if (location) this.setPOIState({ location: latLngToPoint(location) });
								_context2.next = 11;
								break;

							case 9:
								_context2.prev = 9;
								_context2.t0 = _context2["catch"](2);

							case 11:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, this, [[2, 9]]);
			}));

			function geocodeAddress(_x2) {
				return _ref2.apply(this, arguments);
			}

			return geocodeAddress;
		}()
	}, {
		key: "handleAddressTypeEnd",
		value: function handleAddressTypeEnd(address) {
			if (this.state.fixLocation) return;
			this.geocodeAddress(address);
		}
	}, {
		key: "handleCancel",
		value: function handleCancel() {
			this.clear();
			this.hide();
		}
	}, {
		key: "handleSubmit",
		value: function () {
			var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
				return regeneratorRuntime.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.prev = 0;
								_context3.next = 3;
								return this.upload();

							case 3:
								this.clear();
								this.hide();
								_context3.next = 9;
								break;

							case 7:
								_context3.prev = 7;
								_context3.t0 = _context3["catch"](0);

							case 9:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, this, [[0, 7]]);
			}));

			function handleSubmit() {
				return _ref3.apply(this, arguments);
			}

			return handleSubmit;
		}()
	}, {
		key: "getSubmitButtonDisabled",
		value: function getSubmitButtonDisabled() {
			return !this.state.poi.location || !this.state.poi.name || !this.state.poi.address || !this.state.poi.type || this.state.inProgress;
		}
	}, {
		key: "getCancelButtonDisabled",
		value: function getCancelButtonDisabled() {
			return this.state.inProgress;
		}
	}, {
		key: "getPOIFromState",
		value: function getPOIFromState() {
			var poi = {
				type: this.state.poi.type,
				name: this.state.poi.name,
				address: this.state.poi.address,
				location: this.state.poi.type == RADIAL ? this.state.poi.location : createInitialPolygon(this.state.poi.location)
			};

			if (this.state.poi.type == RADIAL) poi.radius = 100;

			return poi;
		}
	}, {
		key: "upload",
		value: function () {
			var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
				return regeneratorRuntime.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								this.setState({ inProgress: true });
								_context4.next = 3;
								return (0, _uploadPOI2.default)(this.getPOIFromState());

							case 3:
								this.setState({ inProgress: false });

							case 4:
							case "end":
								return _context4.stop();
						}
					}
				}, _callee4, this);
			}));

			function upload() {
				return _ref4.apply(this, arguments);
			}

			return upload;
		}()
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			var className = (0, _classnames2.default)("CreatePOIDialog", { "InProgress": this.state.inProgress });

			return _react2.default.createElement(
				_Dialog2.default,
				{ className: className, shown: this.state.shown },
				_react2.default.createElement(
					"header",
					null,
					_react2.default.createElement(
						"h1",
						null,
						_lang2.default.CREATE_POI_DIALOG_TITLE
					)
				),
				_react2.default.createElement(
					_Form2.default,
					null,
					_react2.default.createElement(
						"div",
						{ id: "progressBarContainer" },
						_react2.default.createElement(_ProgressBar2.default, { indeterminate: true })
					),
					_react2.default.createElement(
						"label",
						null,
						_lang2.default.NAME
					),
					_react2.default.createElement(_Input2.default, { value: this.state.poi.name, onChange: function onChange(evt) {
							return _this2.setPOIState({ name: evt.target.value });
						} }),
					_react2.default.createElement(
						"label",
						null,
						_lang2.default.ADDRESS
					),
					_react2.default.createElement(_Input2.default, { value: this.state.poi.address, onChange: function onChange(evt) {
							return _this2.setPOIState({ address: evt.target.value });
						}, onTypeEnd: function onTypeEnd(value) {
							return _this2.handleAddressTypeEnd(value);
						} }),
					_react2.default.createElement(
						"label",
						null,
						_lang2.default.SHAPE
					),
					_react2.default.createElement(
						"div",
						{ id: "shapeSelector" },
						_react2.default.createElement(
							"div",
							{ className: this.state.poi.type == POLYGON ? "Selected" : "", onClick: function onClick(_) {
									return _this2.setPOIState({ type: POLYGON });
								} },
							_react2.default.createElement(_component2.default, { src: _polygon2.default }),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.POLYGON_SHAPE
							)
						),
						_react2.default.createElement(
							"div",
							{ className: this.state.poi.type == RADIAL ? "Selected" : "", onClick: function onClick(_) {
									return _this2.setPOIState({ type: RADIAL });
								} },
							_react2.default.createElement(_component2.default, { src: _circle2.default }),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.CIRCLE_SHAPE
							)
						)
					)
				),
				_react2.default.createElement(
					"footer",
					null,
					_react2.default.createElement(
						_Button2.default,
						{ onClick: function onClick(_) {
								return _this2.handleCancel();
							}, disabled: this.getCancelButtonDisabled() },
						_lang2.default.CANCEL
					),
					_react2.default.createElement(
						_Button2.default,
						{ onClick: function onClick(_) {
								return _this2.handleSubmit();
							}, className: "Red", disabled: this.getSubmitButtonDisabled() },
						_lang2.default.CREATE
					)
				)
			);
		}
	}]);

	return CreatePOIDialog;
}(_react2.default.Component);

exports.default = CreatePOIDialog;


CreatePOIDialog.propTypes = {};

CreatePOIDialog.defaultProps = {};

function latLngToPoint(latLng) {
	if (!latLng) return null;
	return {
		type: "Point",
		coordinates: [latLng.lng(), latLng.lat()]
	};
}

function createInitialPolygon(location) {
	if (!location) return null;
	var lat = location.coordinates[1];
	var lng = location.coordinates[0];
	return {
		type: "MultiPolygon",
		coordinates: [[[[lng - 0.001, lat - 0.001], [lng - 0.001, lat + 0.001], [lng + 0.001, lat + 0.001], [lng + 0.001, lat - 0.001], [lng - 0.001, lat - 0.001]]]]
	};
}

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CreatePOIDialog = __webpack_require__(372);

var _CreatePOIDialog2 = _interopRequireDefault(_CreatePOIDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CreatePOIDialog2.default;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Dialog = __webpack_require__(73);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Select = __webpack_require__(74);

var _Select2 = _interopRequireDefault(_Select);

var _Form = __webpack_require__(38);

var _Form2 = _interopRequireDefault(_Form);

var _MultiSelector = __webpack_require__(102);

var _MultiSelector2 = _interopRequireDefault(_MultiSelector);

var _Checkbox = __webpack_require__(66);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _notification = __webpack_require__(90);

var _CriticalValueNotificationConfigForm = __webpack_require__(227);

var _CriticalValueNotificationConfigForm2 = _interopRequireDefault(_CriticalValueNotificationConfigForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddDialog = function (_React$Component) {
	_inherits(AddDialog, _React$Component);

	function AddDialog(props) {
		_classCallCheck(this, AddDialog);

		var _this = _possibleConstructorReturn(this, (AddDialog.__proto__ || Object.getPrototypeOf(AddDialog)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(AddDialog, [{
		key: "initState",
		value: function initState() {
			this.state = {
				eventDescriptor: null,
				notificationConfig: null
			};
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			this.setState({
				eventDescriptor: this.refs.criticalValueNotificationConfigForm.getEventDescriptor(),
				notificationConfig: this.refs.criticalValueNotificationConfigForm.getNotificationConfig()
			});
		}
	}, {
		key: "clear",
		value: function clear() {
			this.refs.criticalValueNotificationConfigForm.clear();
		}
	}, {
		key: "handleCancel",
		value: function handleCancel() {
			this.refs.criticalValueNotificationConfigForm.clear();
			this.props.onCancel();
		}
	}, {
		key: "getSaveButtonDisabled",
		value: function getSaveButtonDisabled() {
			return !(0, _notification.isValidNotificationConfig)(this.state.notificationConfig) || !(0, _notification.isValidEventDescriptor)(this.state.eventDescriptor);
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_Dialog2.default,
				{ shown: this.props.shown, className: "AddDialog" },
				_react2.default.createElement(
					"header",
					null,
					_react2.default.createElement(
						"h1",
						null,
						_lang2.default.SET_NOTIFICATION
					)
				),
				_react2.default.createElement(_CriticalValueNotificationConfigForm2.default, {
					ref: "criticalValueNotificationConfigForm",
					dataTypes: this.props.dataTypes,
					vehicles: this.props.vehicles,
					onChange: function onChange(eventDescriptor, notificationConfig) {
						return _this2.setState({ eventDescriptor: eventDescriptor, notificationConfig: notificationConfig });
					}
				}),
				_react2.default.createElement(
					"footer",
					null,
					_react2.default.createElement(
						_Button2.default,
						{ onClick: function onClick() {
								return _this2.handleCancel();
							} },
						_lang2.default.CANCEL
					),
					_react2.default.createElement(
						_Button2.default,
						{ disabled: this.getSaveButtonDisabled(), onClick: function onClick() {
								return _this2.props.onAdd(_this2.state.eventDescriptor, _this2.state.notificationConfig);
							}, className: "Red" },
						_lang2.default.SAVE
					)
				)
			);
		}
	}]);

	return AddDialog;
}(_react2.default.Component);

exports.default = AddDialog;


AddDialog.propTypes = {
	shown: _react2.default.PropTypes.bool,
	onCancel: _react2.default.PropTypes.func,
	onAdd: _react2.default.PropTypes.func,
	dataTypes: _react2.default.PropTypes.array,
	vehicles: _react2.default.PropTypes.array
};

AddDialog.defaultProps = {
	shown: false,
	onCancel: function onCancel() {},
	onAdd: function onAdd(eventDescriptor, notificationConfig) {},
	dataTypes: [],
	vehicles: []
};

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AddDialog = __webpack_require__(374);

var _AddDialog2 = _interopRequireDefault(_AddDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AddDialog2.default;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(879);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Form = __webpack_require__(38);

var _Form2 = _interopRequireDefault(_Form);

var _MultiSelector = __webpack_require__(102);

var _MultiSelector2 = _interopRequireDefault(_MultiSelector);

var _Checkbox = __webpack_require__(66);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Select = __webpack_require__(74);

var _Select2 = _interopRequireDefault(_Select);

var _InputWithUnit = __webpack_require__(204);

var _InputWithUnit2 = _interopRequireDefault(_InputWithUnit);

var _Input = __webpack_require__(52);

var _Input2 = _interopRequireDefault(_Input);

var _getModificationsByRef = __webpack_require__(101);

var _getModificationsByRef2 = _interopRequireDefault(_getModificationsByRef);

var _createWellQuantity = __webpack_require__(88);

var _createWellQuantity2 = _interopRequireDefault(_createWellQuantity);

var _getOriginalValueFromWellQuantity = __webpack_require__(212);

var _getOriginalValueFromWellQuantity2 = _interopRequireDefault(_getOriginalValueFromWellQuantity);

var _user = __webpack_require__(20);

var _notification = __webpack_require__(90);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CriticalValueNotificationConfigForm = function (_React$Component) {
	_inherits(CriticalValueNotificationConfigForm, _React$Component);

	function CriticalValueNotificationConfigForm(props) {
		_classCallCheck(this, CriticalValueNotificationConfigForm);

		var _this = _possibleConstructorReturn(this, (CriticalValueNotificationConfigForm.__proto__ || Object.getPrototypeOf(CriticalValueNotificationConfigForm)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(CriticalValueNotificationConfigForm, [{
		key: "initState",
		value: function initState() {
			this.state = this.getDefaultState();
		}
	}, {
		key: "componentDidUpdate",
		value: function componentDidUpdate(_, prevState) {
			var modifications = (0, _getModificationsByRef2.default)(prevState, this.state);

			if (!modifications) {
				return;
			}

			this.props.onChange(this.getEventDescriptor(), this.getNotificationConfig());
		}
	}, {
		key: "clear",
		value: function clear() {
			this.setState(this.getDefaultState());
			this.refs.vehicleSelector.clear();
		}
	}, {
		key: "getConvertedTime",
		value: function getConvertedTime(timestamp) {
			var value = timestamp / 1000;
			var unit = "sec";

			if (value != 0) {
				if (parseInt(value / 60, 10) == value / 60) {
					value = value / 60;
					unit = "min";
				}

				if (parseInt(value / 60, 10) == value / 60) {
					value = value / 60;
					unit = "hour";
				}
			}

			return { value: value, unit: unit };
		}
	}, {
		key: "getTimeInMilisecsFromConvertedTime",
		value: function getTimeInMilisecsFromConvertedTime(convertedTime) {
			if (convertedTime.unit == "sec") {
				return convertedTime.value * 1000;
			}
			if (convertedTime.unit == "min") {
				return convertedTime.value * 1000 * 60;
			}
			if (convertedTime.unit == "hour") {
				return convertedTime.value * 1000 * 60 * 60;
			}
			return null;
		}
	}, {
		key: "getParsedOperands",
		value: function getParsedOperands() {
			var _this2 = this;

			var unitAssignment = (0, _user.getUnitAssignment)();

			var parsedOperands = [];
			if (this.state.dataType.representationType == "Integer") {
				parsedOperands = this.state.operands.map(function (e) {
					return !!e ? (0, _getOriginalValueFromWellQuantity2.default)({ value: parseInt(e, 10), unit: unitAssignment[_this2.state.dataType.applicationType] }, _this2.state.dataType.unit, _this2.state.dataType.representationType) : "";
				});
			}
			if (this.state.dataType.representationType == "Float") {
				parsedOperands = this.state.operands.map(function (e) {
					return !!e ? (0, _getOriginalValueFromWellQuantity2.default)({ value: parseFloat(e), unit: unitAssignment[_this2.state.dataType.applicationType] }, _this2.state.dataType.unit, _this2.state.dataType.representationType) : "";
				});
			}

			if (parsedOperands.some(function (e) {
				return !Number.isFinite(e);
			})) {
				return null;
			}

			if (this.state.operator != "between" && this.state.operator != "notbetween") {
				parsedOperands = [parsedOperands[0]];
			}

			return parsedOperands;
		}
	}, {
		key: "getWellQuantifiedOperands",
		value: function getWellQuantifiedOperands(operands, dataType) {
			return operands.map(function (operand) {
				return (0, _createWellQuantity2.default)((0, _user.getUnitAssignment)(), dataType.applicationType, operand, dataType.unit, dataType.representationType).value;
			});
		}
	}, {
		key: "getDefaultVehiclesFromAssignmentDescriptor",
		value: function getDefaultVehiclesFromAssignmentDescriptor(assignmentDescriptor) {
			if (assignmentDescriptor.user) {
				return null;
			} else {
				return assignmentDescriptor.carriers;
			}
		}
	}, {
		key: "getDefaultState",
		value: function getDefaultState() {
			var eventDescriptor = this.props.notificationConfig ? (0, _notification.getEventDescriptorFromNotificationConfig)(this.props.notificationConfig) : null;

			var dataTypeId = this.props.notificationConfig ? eventDescriptor.dataType : this.props.dataTypes[0]._id;
			var dataType = this.props.dataTypes.find(function (dt) {
				return dt._id == dataTypeId;
			});

			return {
				dataType: dataType,
				vehicles: this.props.notificationConfig ? this.getDefaultVehiclesFromAssignmentDescriptor(eventDescriptor.carriers) : null,
				debounceTimeActive: this.props.notificationConfig ? eventDescriptor.debounceTime > 0 : false,
				debounceTimeValue: this.props.notificationConfig ? this.getConvertedTime(eventDescriptor.debounceTime).value : 0,
				debounceTimeUnit: this.props.notificationConfig ? this.getConvertedTime(eventDescriptor.debounceTime).unit : "sec",
				operands: this.props.notificationConfig ? this.getWellQuantifiedOperands(eventDescriptor.operands, dataType) : [0],
				operator: this.props.notificationConfig ? eventDescriptor.operator : "eq",
				web: this.props.notificationConfig ? this.props.notificationConfig.web : true,
				email: this.props.notificationConfig ? this.props.notificationConfig.email : false,
				sms: this.props.notificationConfig ? this.props.notificationConfig.sms : false
			};
		}
	}, {
		key: "getVehicleOptions",
		value: function getVehicleOptions() {
			if (this.props.vehicles) {
				return this.props.vehicles.map(function (vehicle) {
					return {
						value: vehicle._id,
						label: vehicle.name
					};
				});
			} else {
				return [];
			}
		}
	}, {
		key: "getVehiclesAssignmentDescriptor",
		value: function getVehiclesAssignmentDescriptor() {
			return {
				user: this.state.vehicles ? null : (0, _user.getUserId)(),
				type: "CarrierAssignmentDescriptor",
				carriers: this.state.vehicles ? this.state.vehicles : null
			};
		}
	}, {
		key: "getEventDescriptor",
		value: function getEventDescriptor() {
			var eventDescriptor = {
				carriers: this.getVehiclesAssignmentDescriptor(),
				dataType: this.state.dataType._id,
				operator: this.state.operator,
				debounceTime: this.state.debounceTimeActive ? this.getTimeInMilisecsFromConvertedTime({ value: this.state.debounceTimeValue, unit: this.state.debounceTimeUnit }) : 0,
				operands: this.getParsedOperands(),
				type: "CriticalScalarStateDescriptor"
			};

			if (this.props.notificationConfig) {
				eventDescriptor = Object.assign(eventDescriptor, { _id: this.props.notificationConfig.descriptor });
			}

			return eventDescriptor;
		}
	}, {
		key: "getNotificationConfig",
		value: function getNotificationConfig() {
			return {
				web: this.state.web,
				email: this.state.email,
				sms: this.state.sms
			};
		}
	}, {
		key: "renderOperandsInput",
		value: function renderOperandsInput() {
			var _this3 = this;

			var unitAssignment = (0, _user.getUnitAssignment)();
			var conditionUnit = unitAssignment[this.state.dataType.applicationType];

			if (this.state.operator == "between" || this.state.operator == "notbetween") {
				return _react2.default.createElement(
					"div",
					{ className: "OperandInputContainer" },
					_react2.default.createElement(_Input2.default, {
						id: "firstOperandInput",
						type: "number",
						value: this.state.operands[0],
						onChange: function onChange(evt) {
							return _this3.setState({ operands: [evt.target.value, _this3.state.operands[1]] });
						},
						typingTimeout: 3000
					}),
					_react2.default.createElement(
						"label",
						null,
						_lang2.default._AND
					),
					_react2.default.createElement(_InputWithUnit2.default, {
						id: "secondOperandInput",
						label: conditionUnit,
						value: this.state.operands[1],
						onChange: function onChange(evt) {
							return _this3.setState({ operands: [_this3.state.operands[0], evt.target.value] });
						},
						typingTimeout: 3000
					})
				);
			} else {
				return _react2.default.createElement(
					"div",
					{ className: "OperandInputContainer" },
					_react2.default.createElement(_InputWithUnit2.default, {
						id: "singleOperandInput",
						label: conditionUnit,
						value: this.state.operands[0],
						onChange: function onChange(evt) {
							return _this3.setState({ operands: [evt.target.value] });
						},
						typingTimeout: 3000
					})
				);
			}
		}
	}, {
		key: "render",
		value: function render() {
			var _this4 = this;

			return _react2.default.createElement(
				_Form2.default,
				{ className: "CriticalValueNotificationConfigForm" },
				_react2.default.createElement(_MultiSelector2.default, {
					title: _lang2.default.VEHICLES,
					ref: "vehicleSelector",
					options: this.getVehicleOptions(),
					onChange: function onChange(vehicles, all) {
						return _this4.setState({ vehicles: all ? null : vehicles });
					},
					defaultValue: this.state.vehicles
				}),
				_react2.default.createElement(
					"div",
					{ className: "ConditionContainer" },
					_react2.default.createElement(
						"label",
						{ className: "Title" },
						_lang2.default.CONDITION
					),
					_react2.default.createElement(
						"div",
						null,
						_react2.default.createElement(
							_Select2.default,
							{
								id: "dataTypeSelect",
								value: this.state.dataType._id,
								onChange: function onChange(evt) {
									return _this4.setState({ dataType: _this4.props.dataTypes.find(function (dt) {
											return dt._id == evt.target.value;
										}) });
								}
							},
							this.props.dataTypes.map(function (dataType) {
								return _react2.default.createElement(
									"option",
									{ key: dataType._id, value: dataType._id },
									_lang2.default["DATA_TYPE_" + dataType._id]
								);
							})
						),
						_react2.default.createElement(
							_Select2.default,
							{
								id: "relationSelect",
								value: this.state.operator,
								onChange: function onChange(evt) {
									return _this4.setState({ operator: evt.target.value });
								},
								required: true
							},
							_react2.default.createElement(
								"option",
								{ value: "eq" },
								"="
							),
							_react2.default.createElement(
								"option",
								{ value: "ne" },
								"\u2260"
							),
							_react2.default.createElement(
								"option",
								{ value: "gt" },
								">"
							),
							_react2.default.createElement(
								"option",
								{ value: "gte" },
								"\u2265"
							),
							_react2.default.createElement(
								"option",
								{ value: "lt" },
								"<"
							),
							_react2.default.createElement(
								"option",
								{ value: "lte" },
								"\u2264"
							),
							_react2.default.createElement(
								"option",
								{ value: "between" },
								_lang2.default._BETWEEN
							),
							_react2.default.createElement(
								"option",
								{ value: "notbetween" },
								_lang2.default._NOT_BETWEEN
							)
						),
						this.renderOperandsInput()
					),
					_react2.default.createElement(
						"div",
						null,
						_react2.default.createElement(_Checkbox2.default, {
							checked: this.state.debounceTimeActive,
							onChange: function onChange(value) {
								return _this4.setState({ debounceTimeActive: value });
							}
						}),
						_react2.default.createElement(
							"label",
							{ className: !this.state.debounceTimeActive ? "Inactive" : "" },
							_lang2.default.SEND_NOTIFICATION_IF_THE_CONDITION_IS_FULFILLED_FOR
						),
						_react2.default.createElement(_Input2.default, {
							id: "debounceTimeInput",
							disabled: !this.state.debounceTimeActive,
							onChange: function onChange(evt) {
								return _this4.setState({ debounceTimeValue: evt.target.value });
							},
							type: "number",
							value: this.state.debounceTimeValue,
							typingTimeout: 3000
						}),
						_react2.default.createElement(
							_Select2.default,
							{
								id: "timeUnitSelect",
								disabled: !this.state.debounceTimeActive,
								value: this.state.debounceTimeUnit,
								onChange: function onChange(evt) {
									return _this4.setState({ debounceTimeUnit: evt.target.value });
								},
								required: true
							},
							_react2.default.createElement(
								"option",
								{ value: "sec" },
								this.state.debounceTimeValue == 1 ? _lang2.default._SECOND : _lang2.default._SECONDS
							),
							_react2.default.createElement(
								"option",
								{ value: "min" },
								this.state.debounceTimeValue == 1 ? _lang2.default._MINUTE : _lang2.default._MINUTES
							),
							_react2.default.createElement(
								"option",
								{ value: "hour" },
								this.state.debounceTimeValue == 1 ? _lang2.default._HOUR : _lang2.default._HOURS
							)
						)
					)
				),
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(
						"label",
						{ className: "Title" },
						_lang2.default.SEND_NOTIFICATIONS_VIA
					),
					_react2.default.createElement(
						"div",
						{ className: "CheckboxContainer" },
						_react2.default.createElement(_Checkbox2.default, {
							checked: this.state.web,
							onChange: function onChange(value) {
								return _this4.setState({ web: value });
							}
						}),
						_react2.default.createElement(
							"label",
							null,
							_lang2.default.WEB
						),
						_react2.default.createElement(_Checkbox2.default, {
							checked: this.state.email,
							onChange: function onChange(value) {
								return _this4.setState({ email: value });
							}
						}),
						_react2.default.createElement(
							"label",
							null,
							_lang2.default.EMAIL
						),
						_react2.default.createElement(_Checkbox2.default, {
							checked: this.state.sms,
							onChange: function onChange(value) {
								return _this4.setState({ sms: value });
							}
						}),
						_react2.default.createElement(
							"label",
							null,
							_lang2.default.TEXT_MESSAGE
						)
					)
				)
			);
		}
	}]);

	return CriticalValueNotificationConfigForm;
}(_react2.default.Component);

exports.default = CriticalValueNotificationConfigForm;


CriticalValueNotificationConfigForm.propTypes = {
	dataTypes: _react2.default.PropTypes.array,
	vehicles: _react2.default.PropTypes.array,
	onChange: _react2.default.PropTypes.func,
	notificationConfig: _react2.default.PropTypes.object
};

CriticalValueNotificationConfigForm.defaultProps = {
	dataTypes: [],
	vehicles: [],
	onChange: function onChange(getEventDescriptor, NotificationConfig) {},
	notificationConfig: null
};

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(880);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _ProgressBar = __webpack_require__(34);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _session = __webpack_require__(30);

var _session2 = _interopRequireDefault(_session);

var _vehicles = __webpack_require__(45);

var _vehicles2 = _interopRequireDefault(_vehicles);

var _eventDescriptors = __webpack_require__(103);

var _eventDescriptors2 = _interopRequireDefault(_eventDescriptors);

var _dataTypes = __webpack_require__(68);

var _dataTypes2 = _interopRequireDefault(_dataTypes);

var _NotificationConfigCard = __webpack_require__(379);

var _NotificationConfigCard2 = _interopRequireDefault(_NotificationConfigCard);

var _addNotificationConfig2 = __webpack_require__(214);

var _addNotificationConfig3 = _interopRequireDefault(_addNotificationConfig2);

var _updateNotificationConfig2 = __webpack_require__(219);

var _updateNotificationConfig3 = _interopRequireDefault(_updateNotificationConfig2);

var _removeNotificationConfig2 = __webpack_require__(216);

var _removeNotificationConfig3 = _interopRequireDefault(_removeNotificationConfig2);

var _shouldComponentUpdate2 = __webpack_require__(43);

var _shouldComponentUpdate3 = _interopRequireDefault(_shouldComponentUpdate2);

var _AddDialog = __webpack_require__(375);

var _AddDialog2 = _interopRequireDefault(_AddDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CriticalValueNotifications = function (_React$Component) {
	_inherits(CriticalValueNotifications, _React$Component);

	function CriticalValueNotifications(props) {
		_classCallCheck(this, CriticalValueNotifications);

		var _this = _possibleConstructorReturn(this, (CriticalValueNotifications.__proto__ || Object.getPrototypeOf(CriticalValueNotifications)).call(this, props));

		_this.initState();
		_this.initStoreListeners();
		return _this;
	}

	_createClass(CriticalValueNotifications, [{
		key: "initState",
		value: function initState() {
			this.state = {
				inAddition: false,
				inProgress: false,
				displayButton: true,
				notificationConfigs: null
			};
		}
	}, {
		key: "initStoreListeners",
		value: function initStoreListeners() {
			var _this2 = this;

			_eventDescriptors2.default.on("change", function (eventDescriptors) {
				return _this2.updateCriticalValueNotificationConfigsFromStore();
			});
			_session2.default.on("change", function (_) {
				return _this2.updateCriticalValueNotificationConfigsFromStore();
			});
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			this.createScrollHandler();
			this.updateCriticalValueNotificationConfigsFromStore();
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate() {
			for (var _len = arguments.length, nexts = Array(_len), _key = 0; _key < _len; _key++) {
				nexts[_key] = arguments[_key];
			}

			return _shouldComponentUpdate3.default.apply(undefined, [this].concat(nexts));
		}
	}, {
		key: "createScrollHandler",
		value: function createScrollHandler() {
			var _this3 = this;

			var lastScrollTop = 0;

			this.handleScroll = function () {
				if (_this3.refs.content.scrollTop <= 30) {
					_this3.setState({ displayButton: true });
				} else {
					if (_this3.refs.content.scrollTop > lastScrollTop) _this3.setState({ displayButton: false });else _this3.setState({ displayButton: true });
				}
				lastScrollTop = _this3.refs.content.scrollTop;
			};
		}
	}, {
		key: "updateNotificationConfig",
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(eventDescriptor, notificationConfig) {
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								this.setState({ inProgress: true });
								_context.next = 3;
								return (0, _updateNotificationConfig3.default)(eventDescriptor, notificationConfig);

							case 3:
								this.setState({ inProgress: false });
								new _Toast2.default(_lang2.default.YOUR_MODIFICATIONS_WILL_TAKE_EFFECT_WITHIN_ONE_HOUR, "green");

							case 5:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function updateNotificationConfig(_x, _x2) {
				return _ref.apply(this, arguments);
			}

			return updateNotificationConfig;
		}()
	}, {
		key: "addNotificationConfig",
		value: function () {
			var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(eventDescriptor, notificationConfig) {
				var _this4 = this;

				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								this.setState({ inProgress: true });
								_context2.next = 3;
								return (0, _addNotificationConfig3.default)(eventDescriptor, notificationConfig);

							case 3:
								if (!_context2.sent) {
									_context2.next = 6;
									break;
								}

								this.setState({ inAddition: false });
								this.refs.addDialog.clear();

							case 6:
								setTimeout(function (_) {
									return _this4.updateCriticalValueNotificationConfigsFromStore();
								});
								this.setState({ inProgress: false });
								new _Toast2.default(_lang2.default.YOUR_MODIFICATIONS_WILL_TAKE_EFFECT_WITHIN_ONE_HOUR, "green");

							case 9:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, this);
			}));

			function addNotificationConfig(_x3, _x4) {
				return _ref2.apply(this, arguments);
			}

			return addNotificationConfig;
		}()
	}, {
		key: "removeNotificationConfig",
		value: function () {
			var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(eventDescriptorId) {
				return regeneratorRuntime.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								this.setState({ inProgress: true });
								_context3.next = 3;
								return (0, _removeNotificationConfig3.default)(eventDescriptorId);

							case 3:
								this.setState({ inProgress: false });
								new _Toast2.default(_lang2.default.YOUR_MODIFICATIONS_WILL_TAKE_EFFECT_WITHIN_ONE_HOUR, "green");

							case 5:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, this);
			}));

			function removeNotificationConfig(_x5) {
				return _ref3.apply(this, arguments);
			}

			return removeNotificationConfig;
		}()
	}, {
		key: "updateCriticalValueNotificationConfigsFromStore",
		value: function updateCriticalValueNotificationConfigsFromStore() {
			var session = _session2.default.get();

			if (!session) {
				return null;
			}

			var notificationSets = session.user.services.filter(function (service) {
				return service.type == "NotificationSet";
			});

			var eventDescriptors = _eventDescriptors2.default.getAll();
			if (!eventDescriptors) {
				return null;
			}

			var notificationConfigs = eventDescriptors.filter(function (eventDescriptor) {
				return eventDescriptor.type == "CriticalScalarStateDescriptor";
			}).map(function (eventDescriptor) {
				var notificationSet = notificationSets.find(function (e) {
					return e.value.descriptor == eventDescriptor._id;
				});
				if (notificationSet) {
					return notificationSet.value;
				} else {
					return null;
				}
			});

			this.setState({ notificationConfigs: notificationConfigs });
		}
	}, {
		key: "isButtonHidden",
		value: function isButtonHidden() {
			return !this.state.displayButton || this.state.inProgress;
		}
	}, {
		key: "getNotificationDataTypes",
		value: function getNotificationDataTypes() {
			var dataTypes = _dataTypes2.default.getAll();
			return dataTypes.filter(function (dataType) {
				return (dataType.representationType == "Integer" || dataType.representationType == "Float") && dataType.name != "MobileNetworkCode" && dataType.name != "SignalStrength";
			});
		}
	}, {
		key: "renderCard",
		value: function renderCard(notificationConfig) {
			var _this5 = this;

			if (notificationConfig) {
				return _react2.default.createElement(_NotificationConfigCard2.default, {
					key: notificationConfig.descriptor,
					notificationConfig: notificationConfig,
					onSave: function onSave(eventDescriptor, notificationConfig) {
						return _this5.updateNotificationConfig(eventDescriptor, notificationConfig);
					},
					vehicles: _vehicles2.default.getAll(),
					dataTypes: this.getNotificationDataTypes(),
					onRemove: function onRemove() {
						return _this5.removeNotificationConfig(notificationConfig.descriptor);
					}
				});
			}
			return null;
		}
	}, {
		key: "renderCards",
		value: function renderCards() {
			var _this6 = this;

			return this.state.notificationConfigs ? this.state.notificationConfigs.map(function (e) {
				return _this6.renderCard(e);
			}) : null;
		}
	}, {
		key: "render",
		value: function render() {
			var _this7 = this;

			return _react2.default.createElement(
				"div",
				{ className: "CriticalValueNotifications" },
				_react2.default.createElement(_Button2.default, {
					icon: "plus",
					className: (0, _classnames2.default)("Floating", "Red", { "Hidden": this.isButtonHidden() }),
					title: _lang2.default.ADD_NOTIFICATION_SETUP,
					onClick: function onClick(_) {
						return _this7.setState({ inAddition: true });
					}
				}),
				_react2.default.createElement(_ProgressBar2.default, {
					indeterminate: true,
					shown: this.state.inProgress
				}),
				_react2.default.createElement(
					"div",
					{
						ref: "content",
						onScroll: function onScroll() {
							return _this7.handleScroll();
						},
						className: (0, _classnames2.default)("Content", { "Hidden": this.state.inProgress })
					},
					this.renderCards()
				),
				_react2.default.createElement(_AddDialog2.default, {
					ref: "addDialog",
					shown: this.state.inAddition && !this.state.inProgress,
					dataTypes: this.getNotificationDataTypes(),
					vehicles: _vehicles2.default.getAll(),
					onCancel: function onCancel() {
						return _this7.setState({ inAddition: false });
					},
					onAdd: function onAdd(eventDescriptor, notificationConfig) {
						return _this7.addNotificationConfig(eventDescriptor, notificationConfig);
					}
				})
			);
		}
	}]);

	return CriticalValueNotifications;
}(_react2.default.Component);

exports.default = CriticalValueNotifications;


CriticalValueNotifications.propTypes = {};

CriticalValueNotifications.defaultProps = {};

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(881);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _notification = __webpack_require__(90);

var _CriticalValueNotificationConfigForm = __webpack_require__(227);

var _CriticalValueNotificationConfigForm2 = _interopRequireDefault(_CriticalValueNotificationConfigForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotificationConfigCard = function (_React$Component) {
	_inherits(NotificationConfigCard, _React$Component);

	function NotificationConfigCard(props) {
		_classCallCheck(this, NotificationConfigCard);

		var _this = _possibleConstructorReturn(this, (NotificationConfigCard.__proto__ || Object.getPrototypeOf(NotificationConfigCard)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(NotificationConfigCard, [{
		key: "initState",
		value: function initState() {
			this.state = { //formban módosított, de apiba még nem küldött adatok
				eventDescriptor: null,
				notificationConfig: null
			};
		}
	}, {
		key: "handleChange",
		value: function handleChange(eventDescriptor, notificationConfig) {
			var _this2 = this;

			this.setState({
				eventDescriptor: eventDescriptor,
				notificationConfig: notificationConfig
			}, function (_) {
				if (_this2.getSaveButtonDisabled()) {
					new _Toast2.default(_lang2.default.INVALID_CONFIGURATION, "orange");
				}
			});
		}
	}, {
		key: "save",
		value: function save() {
			this.props.onSave(this.state.eventDescriptor, this.state.notificationConfig);
			this.setState({
				eventDescriptor: null,
				notificationConfig: null
			});
		}
	}, {
		key: "getSaveButtonDisabled",
		value: function getSaveButtonDisabled() {
			return !(0, _notification.isValidEventDescriptor)(this.state.eventDescriptor) || !(0, _notification.isValidNotificationConfig)(this.state.notificationConfig);
		}
	}, {
		key: "render",
		value: function render() {
			var _this3 = this;

			return _react2.default.createElement(
				_Card2.default,
				{ className: "NotificationConfigCard" },
				_react2.default.createElement(
					"header",
					null,
					_react2.default.createElement(_Button2.default, {
						icon: "close",
						onClick: function onClick(_) {
							return _this3.props.onRemove();
						}
					}),
					_react2.default.createElement(_Button2.default, {
						icon: "check",
						disabled: this.getSaveButtonDisabled(),
						onClick: function onClick(_) {
							return _this3.save();
						}
					})
				),
				_react2.default.createElement(_CriticalValueNotificationConfigForm2.default, {
					dataTypes: this.props.dataTypes,
					vehicles: this.props.vehicles,
					onChange: function onChange(eventDescriptor, notificationConfig) {
						return _this3.handleChange(eventDescriptor, notificationConfig);
					},
					notificationConfig: this.props.notificationConfig
				})
			);
		}
	}]);

	return NotificationConfigCard;
}(_react2.default.Component);

exports.default = NotificationConfigCard;


NotificationConfigCard.propTypes = {
	onSave: _react2.default.PropTypes.func,
	onRemove: _react2.default.PropTypes.func,
	dataTypes: _react2.default.PropTypes.array,
	vehicles: _react2.default.PropTypes.array,
	notificationConfig: _react2.default.PropTypes.object,
	eventDescriptor: _react2.default.PropTypes.object
};

NotificationConfigCard.defaultProps = {
	onSave: function onSave(eventDescriptor, notificationConfig) {},
	onRemove: function onRemove() {},
	dataTypes: [],
	vehicles: [],
	notificationConfig: null,
	eventDescriptor: null
};

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NotificationConfigCard = __webpack_require__(378);

var _NotificationConfigCard2 = _interopRequireDefault(_NotificationConfigCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NotificationConfigCard2.default;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CriticalValueNotifications = __webpack_require__(377);

var _CriticalValueNotifications2 = _interopRequireDefault(_CriticalValueNotifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CriticalValueNotifications2.default;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(882);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _session = __webpack_require__(30);

var _session2 = _interopRequireDefault(_session);

var _dataTypes = __webpack_require__(68);

var _dataTypes2 = _interopRequireDefault(_dataTypes);

var _services = __webpack_require__(120);

var _services2 = _interopRequireDefault(_services);

var _vehicles = __webpack_require__(45);

var _vehicles2 = _interopRequireDefault(_vehicles);

var _vehicleStates = __webpack_require__(122);

var _vehicleStates2 = _interopRequireDefault(_vehicleStates);

var _pois = __webpack_require__(29);

var _pois2 = _interopRequireDefault(_pois);

var _selectedVehicle = __webpack_require__(157);

var _selectedVehicle2 = _interopRequireDefault(_selectedVehicle);

var _selectedPOI = __webpack_require__(156);

var _selectedPOI2 = _interopRequireDefault(_selectedPOI);

var _mapState = __webpack_require__(221);

var _mapState2 = _interopRequireDefault(_mapState);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _wsi = __webpack_require__(474);

var _wsi2 = _interopRequireDefault(_wsi);

var _filterGroups = __webpack_require__(67);

var _filterGroups2 = _interopRequireDefault(_filterGroups);

var _getDataTypes = __webpack_require__(354);

var _getDataTypes2 = _interopRequireDefault(_getDataTypes);

var _getServices = __webpack_require__(357);

var _getServices2 = _interopRequireDefault(_getServices);

var _login2 = __webpack_require__(363);

var _login3 = _interopRequireDefault(_login2);

var _getVehicles = __webpack_require__(362);

var _getVehicles2 = _interopRequireDefault(_getVehicles);

var _getVehicleStates = __webpack_require__(361);

var _getVehicleStates2 = _interopRequireDefault(_getVehicleStates);

var _getPOIs = __webpack_require__(356);

var _getPOIs2 = _interopRequireDefault(_getPOIs);

var _getUsers = __webpack_require__(358);

var _getUsers2 = _interopRequireDefault(_getUsers);

var _getEventDescriptors = __webpack_require__(355);

var _getEventDescriptors2 = _interopRequireDefault(_getEventDescriptors);

var _resolveCarrierState = __webpack_require__(217);

var _resolveCarrierState2 = _interopRequireDefault(_resolveCarrierState);

var _token = __webpack_require__(118);

var _token2 = _interopRequireDefault(_token);

var _poi = __webpack_require__(46);

var _LoginDialog = __webpack_require__(328);

var _LoginDialog2 = _interopRequireDefault(_LoginDialog);

var _CreatePOIDialog = __webpack_require__(373);

var _CreatePOIDialog2 = _interopRequireDefault(_CreatePOIDialog);

var _ConfirmDialog = __webpack_require__(146);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _ProgressBar = __webpack_require__(34);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Icon = __webpack_require__(114);

var _Icon2 = _interopRequireDefault(_Icon);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Tabs = __webpack_require__(116);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Pager = __webpack_require__(87);

var _Pager2 = _interopRequireDefault(_Pager);

var _DropdownMenu = __webpack_require__(320);

var _shouldComponentUpdate2 = __webpack_require__(43);

var _shouldComponentUpdate3 = _interopRequireDefault(_shouldComponentUpdate2);

var _VehicleList = __webpack_require__(455);

var _VehicleList2 = _interopRequireDefault(_VehicleList);

var _POIList = __webpack_require__(422);

var _POIList2 = _interopRequireDefault(_POIList);

var _RightContainer = __webpack_require__(383);

var _RightContainer2 = _interopRequireDefault(_RightContainer);

var _only_logo = __webpack_require__(925);

var _only_logo2 = _interopRequireDefault(_only_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DETAILS_DIVIDING_DENOMINATOR = 7;
var DETAILS_DEFAULT_HEIGHT_RATIO = 4;
var DETAILS_ANIMATION_DURATION = 500; // ms

var Dashboard = function (_React$Component) {
	_inherits(Dashboard, _React$Component);

	function Dashboard(props) {
		_classCallCheck(this, Dashboard);

		var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));

		_this.initState();
		_this.setStoreListeners();

		// This binding is necessary to make `this` work in the callback
		_this.toggleLeftContainer = _this.toggleLeftContainer.bind(_this);
		return _this;
	}

	_createClass(Dashboard, [{
		key: "initState",
		value: function initState() {
			this.state = {
				session: _session2.default.get(),
				hasInitData: false,
				hasApplicationData: false,
				progress: _lang2.default.GETTING_APPLICATION_DATA,
				page: "vehicles",
				isLeftContainerHidden: false
			};
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			_session2.default.on('change', function (session) {
				return _this2.handleSessionChange(session);
			});
			_dataTypes2.default.on('change', function (_) {
				return _this2.checkInitData();
			});
			_services2.default.on('change', function (_) {
				return _this2.checkInitData();
			});
			_vehicles2.default.on('change', function (_) {
				return _this2.checkApplicationData();
			});
			_pois2.default.on('change', function (_) {
				return _this2.checkApplicationData();
			});
			_vehicleStates2.default.on('change', function (_) {
				return _this2.checkApplicationData();
			});
			_vehicleStates2.default.on('set', function (vehicleStates) {
				return _this2.handleVehicleStateInitialization(vehicleStates);
			});
			_selectedVehicle2.default.on('change', function (vehicleId) {
				return _this2.shouldSwitchPage(vehicleId, 'vehicles');
			});
			_selectedPOI2.default.on('change', function (poiId) {
				return _this2.shouldSwitchPage(poiId, 'pois');
			});
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate() {
			for (var _len = arguments.length, nexts = Array(_len), _key = 0; _key < _len; _key++) {
				nexts[_key] = arguments[_key];
			}

			return _shouldComponentUpdate3.default.apply(undefined, [this].concat(nexts));
		}
	}, {
		key: "handleSessionChange",
		value: function handleSessionChange(session) {
			this.setState({ session: session });
			if (!session) {
				this.closeWSIConnection();
			};
		}
	}, {
		key: "checkInitData",
		value: function checkInitData() {
			this.setState({
				hasInitData: !!(_dataTypes2.default.getAll() && _services2.default.getAll())
			});
		}
	}, {
		key: "shouldSwitchPage",
		value: function shouldSwitchPage(someSelectedId, page) {
			if (!someSelectedId) return;
			this.clearSelections(page);
			this.setState({ page: page });
		}
	}, {
		key: "handlePOICreate",
		value: function handlePOICreate(location) {
			if (this.refs.createPOIDialog) this.refs.createPOIDialog.show(location);
		}
	}, {
		key: "checkApplicationData",
		value: function checkApplicationData() {
			this.setState({
				hasApplicationData: !!(_vehicles2.default.getAll() && _vehicleStates2.default.getAll() && _pois2.default.getAll())
			});
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			this.getInitData();
		}
	}, {
		key: "handleTabChange",
		value: function handleTabChange(page) {
			if (page != this.state.page) {
				this.clearSelections(null);
				this.setState({ page: page });
			}
		}
	}, {
		key: "getInitData",
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				var storedToken;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _getDataTypes2.default)();

							case 2:
								_context.next = 4;
								return (0, _getServices2.default)();

							case 4:
								_context.next = 6;
								return _token2.default.get();

							case 6:
								storedToken = _context.sent;

								if (storedToken) {
									this.login(storedToken);
								} else {
									this.setState({ progress: "" });
								}

							case 8:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function getInitData() {
				return _ref.apply(this, arguments);
			}

			return getInitData;
		}()
	}, {
		key: "login",
		value: function () {
			var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
				var session,
				    _args2 = arguments;
				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:

								this.refs.loginDialog.setError("");

								this.setState({ progress: _lang2.default.LOGIN + "..." });

								_context2.prev = 2;
								_context2.next = 5;
								return _login3.default.apply(undefined, _args2);

							case 5:
								session = _context2.sent;

								this.refs.loginDialog.setError("");
								this.refs.loginDialog.clearInputs();
								_dispatcher2.default.dispatch('login', session.token, session.user);
								_context2.next = 11;
								return this.getApplicationData();

							case 11:
								_context2.next = 24;
								break;

							case 13:
								_context2.prev = 13;
								_context2.t0 = _context2["catch"](2);

								if (_args2.length <= 0 ? undefined : _args2[0]) {
									_context2.next = 23;
									break;
								}

								if (!_context2.t0.id) {
									_context2.next = 20;
									break;
								}

								this.refs.loginDialog.setError(_context2.t0.id == "WRONG_USER_OR_PASSWORD" ? /* error.message */_lang2.default.WRONG_USER_OR_PASSWORD : _lang2.default.SOMETHING_WRONG);
								_context2.next = 21;
								break;

							case 20:
								throw _context2.t0;

							case 21:
								_context2.next = 24;
								break;

							case 23:
								throw _context2.t0;

							case 24:
								_context2.prev = 24;

								this.setState({ progress: "" });
								return _context2.finish(24);

							case 27:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, this, [[2, 13, 24, 27]]);
			}));

			function login() {
				return _ref2.apply(this, arguments);
			}

			return login;
		}()
	}, {
		key: "getApplicationData",
		value: function () {
			var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
				return regeneratorRuntime.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								this.setState({ progress: _lang2.default.GETTING_APPLICATION_DATA });
								_context3.next = 3;
								return (0, _getVehicles2.default)();

							case 3:
								_context3.next = 5;
								return (0, _getPOIs2.default)();

							case 5:
								_context3.next = 7;
								return (0, _getUsers2.default)();

							case 7:
								_context3.next = 9;
								return (0, _getVehicleStates2.default)();

							case 9:
								_context3.next = 11;
								return (0, _getEventDescriptors2.default)();

							case 11:
								this.setState({ progress: "" });

							case 12:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, this);
			}));

			function getApplicationData() {
				return _ref3.apply(this, arguments);
			}

			return getApplicationData;
		}()
	}, {
		key: "handleVehicleStateInitialization",
		value: function handleVehicleStateInitialization(vehicleStates) {
			if (vehicleStates) {
				this.listenVehicleStates();
				_dispatcher2.default.dispatch('pinVehicles', vehicleStates.map(function (vs) {
					return vs.carrier;
				}), true);
			}
		}
	}, {
		key: "listenVehicleStates",
		value: function listenVehicleStates() {
			var _this3 = this;

			var vehiclesWithoutGroups = (0, _filterGroups2.default)(_vehicles2.default.getAll());

			_wsi2.default.on("auth", function (_) {
				_wsi2.default.on('newCarrierState', {
					timeLimit: Date.now(),
					carriers: vehiclesWithoutGroups.map(function (carrier) {
						return carrier._id;
					})
				}, function () {
					var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(carrierState) {
						return regeneratorRuntime.wrap(function _callee4$(_context4) {
							while (1) {
								switch (_context4.prev = _context4.next) {
									case 0:
										_context4.next = 2;
										return (0, _resolveCarrierState2.default)(carrierState);

									case 2:
										_dispatcher2.default.dispatch('newCarrierState', carrierState);

									case 3:
									case "end":
										return _context4.stop();
								}
							}
						}, _callee4, _this3);
					}));

					return function (_x) {
						return _ref4.apply(this, arguments);
					};
				}());
			});
			_wsi2.default.connect();
		}
	}, {
		key: "closeWSIConnection",
		value: function closeWSIConnection() {
			_wsi2.default.close();
		}

		/**
  	@param {String} whichType Lehet "vehicles" vagy "pois"
  */

	}, {
		key: "clearSelections",
		value: function clearSelections(whichType) {
			if (whichType == "vehicles") _dispatcher2.default.dispatch('selectPOI', null);else if (whichType == "pois") _dispatcher2.default.dispatch('selectVehicle', null);else {
				_dispatcher2.default.dispatch('selectVehicle', null);
				_dispatcher2.default.dispatch('selectPOI', null);
			}
		}

		/*Toggle X button to hide left container*/

	}, {
		key: "toggleLeftContainer",
		value: function toggleLeftContainer() {
			var leftContainer = document.getElementById('leftContainer');
			if (!this.state.isLeftContainerHidden) {
				leftContainer.style.width = "0px";
				/*	leftContainer.style.display = "none";*/
				this.setState({ isLeftContainerHidden: true });
			} else {
				var rightContainer = document.getElementById('');
				/*	leftContainer.style.display = "flex"; */
				leftContainer.style.width = "400px";
				this.setState({ isLeftContainerHidden: false });
			}
		}
	}, {
		key: "renderHeader",
		value: function renderHeader() {
			var _this4 = this;

			return _react2.default.createElement(
				"header",
				null,
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(
						_DropdownMenu.DropdownMenu,
						{ className: "Red" },
						_react2.default.createElement(
							_DropdownMenu.Item,
							{ onClick: function onClick() {
									return _this4.setState({ showSettings: true });
								} },
							_lang2.default.SETTINGS
						),
						_react2.default.createElement(_DropdownMenu.Separator, null),
						_react2.default.createElement(
							_DropdownMenu.Item,
							{ onClick: function onClick() {
									return _dispatcher2.default.dispatch("logout");
								} },
							_lang2.default.LOGOUT
						)
					)
				),
				_react2.default.createElement(
					_Tabs2.default,
					{ className: "Light", onChange: function onChange(page) {
							return _this4.handleTabChange(page);
						}, selected: this.state.page },
					_react2.default.createElement(
						"li",
						{ id: "vehicles" },
						_react2.default.createElement(
							_Icon2.default,
							null,
							"car"
						)
					),
					_react2.default.createElement(
						"li",
						{ id: "pois" },
						_react2.default.createElement(
							_Icon2.default,
							null,
							"map-marker-radius"
						)
					),
					_react2.default.createElement(
						"li",
						{ id: "alerts" },
						_react2.default.createElement(
							_Icon2.default,
							null,
							"bell"
						)
					)
				),
				_react2.default.createElement(
					"span",
					{ id: "toggleLeftContainerBtn", onClick: this.toggleLeftContainer },
					_react2.default.createElement(
						_Icon2.default,
						null,
						"close"
					)
				)
			);
		}
	}, {
		key: "renderLeftContainer",
		value: function renderLeftContainer() {
			var _this5 = this;

			var header = this.renderHeader();

			return _react2.default.createElement(
				"div",
				{ id: "leftContainer" },
				header,
				_react2.default.createElement(
					_Pager2.default,
					{ active: this.state.page },
					_react2.default.createElement(
						"div",
						{ id: "vehicles" },
						_react2.default.createElement(_VehicleList2.default, null)
					),
					_react2.default.createElement(
						"div",
						{ id: "pois" },
						_react2.default.createElement(_POIList2.default, { onCreatePOI: function onCreatePOI(_) {
								return _this5.handlePOICreate();
							} })
					)
				)
			);
		}
	}, {
		key: "renderProgressBar",
		value: function renderProgressBar() {
			return _react2.default.createElement(_ProgressBar2.default, {
				indeterminate: true,
				label: this.state.progress,
				color: "#B02234",
				shown: !!this.state.progress
			});
		}
	}, {
		key: "renderRightContainer",
		value: function renderRightContainer() {
			var _this6 = this;

			return _react2.default.createElement(_RightContainer2.default, {
				id: "rightContainer",
				showLeftContainerBtn: !this.state.isLeftContainerHidden,
				showSettings: this.state.showSettings,
				onUserSettingsClose: function onUserSettingsClose() {
					return _this6.setState({ showSettings: false });
				},
				onCreatePOI: function onCreatePOI(location) {
					return _this6.handlePOICreate(location);
				}
			});
		}
	}, {
		key: "renderContent",
		value: function renderContent() {

			var shown = !this.state.progress && this.state.session && this.state.hasInitData && this.state.hasApplicationData;
			var contentClassName = shown ? "" : "Hidden";
			var leftContainer = this.renderLeftContainer();

			return _react2.default.createElement(
				"div",
				{ id: "content", className: contentClassName },
				leftContainer,
				this.renderRightContainer()
			);
		}
	}, {
		key: "renderDialogs",
		value: function renderDialogs() {
			var _this7 = this;

			return _react2.default.createElement(
				"section",
				null,
				_react2.default.createElement(_LoginDialog2.default, {
					ref: "loginDialog",
					shown: !this.state.progress && !this.state.session && this.state.hasInitData && !this.state.hasApplicationData,
					errorMsg: this.state.loginError,
					onSubmit: function onSubmit(username, password) {
						return _this7.login(null, username, password);
					}
				}),
				_react2.default.createElement(_CreatePOIDialog2.default, { ref: "createPOIDialog" })
			);
		}
	}, {
		key: "render",
		value: function render() {

			var dialogs = this.renderDialogs();
			var progressBar = this.renderProgressBar();
			var content = this.renderContent();

			return _react2.default.createElement(
				"div",
				{ className: "Dashboard" },
				dialogs,
				progressBar,
				content,
				this.state.isLeftContainerHidden && _react2.default.createElement(
					"button",
					{ id: "toggleLeftContainerBtn2", onClick: this.toggleLeftContainer },
					_react2.default.createElement(
						_Icon2.default,
						null,
						"chevron-double-right"
					)
				)
			);
		}
	}]);

	return Dashboard;
}(_react2.default.Component);

exports.default = Dashboard;


function getDetailsSize() {
	if (!displayedDetailsStore.get()) return null;
	if (!openedDetailsStore.get(displayedDetailsStore.get().id)) return null;
	return openedDetailsStore.get(displayedDetailsStore.get().id).size;
}

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(883);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

var _displayedDetails = __webpack_require__(44);

var _displayedDetails2 = _interopRequireDefault(_displayedDetails);

var _geo = __webpack_require__(53);

var _shouldComponentUpdate2 = __webpack_require__(43);

var _shouldComponentUpdate3 = _interopRequireDefault(_shouldComponentUpdate2);

var _Map = __webpack_require__(399);

var _Map2 = _interopRequireDefault(_Map);

var _VehicleDetails = __webpack_require__(444);

var _VehicleDetails2 = _interopRequireDefault(_VehicleDetails);

var _POIDetails = __webpack_require__(415);

var _POIDetails2 = _interopRequireDefault(_POIDetails);

var _UserSettings = __webpack_require__(432);

var _UserSettings2 = _interopRequireDefault(_UserSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DETAILS_DIVIDING_DENOMINATOR = 7;
var DETAILS_DEFAULT_HEIGHT_RATIO = 4;
var DETAILS_ANIMATION_DURATION = 300; // ms

var RightContainer = function (_React$Component) {
	_inherits(RightContainer, _React$Component);

	function RightContainer(props) {
		_classCallCheck(this, RightContainer);

		var _this = _possibleConstructorReturn(this, (RightContainer.__proto__ || Object.getPrototypeOf(RightContainer)).call(this, props));

		_this.initState();
		_this.setStoreListeners();
		return _this;
	}

	_createClass(RightContainer, [{
		key: "initState",
		value: function initState() {
			this.state = {
				showSettings: false,
				cat: false,
				readyForMap: false,
				openedDetails: _openedDetails2.default.getAll(),
				displayedDetails: _displayedDetails2.default.get(),
				detailsSize: 0
			};
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			_openedDetails2.default.on('change', function (openedDetails) {
				return _this2.setState({ openedDetails: openedDetails, detailsSize: getDetailsSize() });
			});
			_displayedDetails2.default.on('change', function (displayedDetails) {
				return _this2.setState({ displayedDetails: displayedDetails });
			});
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate() {
			for (var _len = arguments.length, nexts = Array(_len), _key = 0; _key < _len; _key++) {
				nexts[_key] = arguments[_key];
			}

			return _shouldComponentUpdate3.default.apply(undefined, [this].concat(nexts));
		}
	}, {
		key: "handleDisplayedDetailsSizeChange",
		value: function handleDisplayedDetailsSizeChange() {
			var _this3 = this;

			this.mapCenterAfterResize = this.mapCenterAfterResize || getCenterOfMap();
			if (!this.mapCenterAfterResize) return;

			if (this.mapSetterTimer) {
				clearTimeout(this.mapSetterTimer);
			}

			this.mapSetterTimer = setTimeout(function () {
				dispatcher.dispatch('setMap', { center: _this3.mapCenterAfterResize });
				_this3.mapSetterTimer = null;
				_this3.mapCenterAfterResize = null;
			}, DETAILS_ANIMATION_DURATION);
		}
	}, {
		key: "componentWillUpdate",
		value: function componentWillUpdate(_, nextState) {
			if (nextState.detailsSize != this.state.detailsSize) {
				this.handleDisplayedDetailsSizeChange();
			}
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			this.setState({
				readyForMap: true
			});
		}
	}, {
		key: "onDragDetails",
		value: function onDragDetails(id, evt) {
			if (evt.clientY == 0) {
				return;
			}

			var bounds = this.refs.rightContainer.getBoundingClientRect();
			var value = evt.y == 0 ? 0 : 1 - (evt.clientY - bounds.top) / bounds.height;
			var displayedDetailsSize = this.getDisplayedDetailsSize();

			if (value < 0) {
				if (displayedDetailsSize != 0) {
					dispatcher.dispatch("resizeDetails", id, 0);
				}
			} else if (value > 1) {
				if (displayedDetailsSize != DETAILS_DIVIDING_DENOMINATOR) {
					dispatcher.dispatch("resizeDetails", id, DETAILS_DIVIDING_DENOMINATOR);
				}
			} else {
				if (displayedDetailsSize != Math.round(value * DETAILS_DIVIDING_DENOMINATOR)) {
					dispatcher.dispatch("resizeDetails", id, Math.round(value * DETAILS_DIVIDING_DENOMINATOR));
				}
			}
		}
	}, {
		key: "getDetailsHeightFromRatio",
		value: function getDetailsHeightFromRatio(ratio) {
			return ratio * 100 / DETAILS_DIVIDING_DENOMINATOR;
		}
	}, {
		key: "getDisplayedDetailsSize",
		value: function getDisplayedDetailsSize() {
			var _this4 = this;

			if (!this.state.displayedDetails || !this.state.openedDetails) return 0;
			var displayedDetailsDescriptor = this.state.openedDetails.find(function (od) {
				return od.id == _this4.state.displayedDetails.id;
			});
			if (!displayedDetailsDescriptor) return 0;
			return displayedDetailsDescriptor.size || 0;
		}
	}, {
		key: "renderDetails",
		value: function renderDetails(detailsDescriptor) {
			var _this5 = this;

			var className = !this.state.displayedDetails || this.state.displayedDetails.id != detailsDescriptor.id ? "Hidden" : "";

			if (detailsDescriptor.type == "VehicleDetails") {
				return _react2.default.createElement(_VehicleDetails2.default, {
					vehicleId: detailsDescriptor.id,
					key: detailsDescriptor.id,
					className: className,
					ondrag: function ondrag(evt) {
						return _this5.onDragDetails(detailsDescriptor.id, evt);
					}
				});
			} else if (detailsDescriptor.type == "POIDetails") {
				return _react2.default.createElement(_POIDetails2.default, {
					poiId: detailsDescriptor.id,
					key: detailsDescriptor.id,
					className: className,
					ondrag: function ondrag(evt) {
						return _this5.onDragDetails(detailsDescriptor.id, evt);
					}
				});
			} else null;
		}
	}, {
		key: "renderEveryDetails",
		value: function renderEveryDetails() {
			var _this6 = this;

			return this.state.openedDetails ? this.state.openedDetails.map(function (detailsDescriptor) {
				return _this6.renderDetails(detailsDescriptor);
			}) : null;
		}
	}, {
		key: "renderUserSettings",
		value: function renderUserSettings() {
			if (this.props.showSettings) {
				return _react2.default.createElement(_UserSettings2.default, { onClose: this.props.onUserSettingsClose });
			}
			return null;
		}
	}, {
		key: "render",
		value: function render() {
			var _this7 = this;

			var mapContainerStyle = {
				display: this.props.showSettings ? "none" : "flex",
				height: this.state.displayedDetails ? 100 - this.getDetailsHeightFromRatio(this.getDisplayedDetailsSize()) + "%" : "100%"
			};

			var detailsContainerStyle = {
				display: this.state.displayedDetails && !this.props.showSettings ? "flex" : "none",
				height: this.getDetailsHeightFromRatio(this.getDisplayedDetailsSize()) + "%"
			};

			return _react2.default.createElement(
				"div",
				{ className: "RightContainer", ref: "rightContainer" },
				_react2.default.createElement(
					"div",
					{ id: "mapContainer", style: mapContainerStyle, ref: "mapContainer" },
					_react2.default.createElement(_Map2.default, { ref: "map", ready: this.state.readyForMap, onCreatePOI: function onCreatePOI(location) {
							return _this7.props.onCreatePOI(location);
						} })
				),
				_react2.default.createElement(
					"div",
					{ id: "detailsContainer", style: detailsContainerStyle },
					this.renderEveryDetails()
				),
				_react2.default.createElement(
					"div",
					{ id: "settingsContainer", className: !this.props.showSettings ? "Hidden" : "" },
					this.renderUserSettings()
				)
			);
		}
	}]);

	return RightContainer;
}(_react2.default.Component);

exports.default = RightContainer;


function getDetailsSize() {
	if (!_displayedDetails2.default.get()) return null;
	if (!_openedDetails2.default.get(_displayedDetails2.default.get().id)) return null;
	return _openedDetails2.default.get(_displayedDetails2.default.get().id).size;
}

function getCenterOfMap() {
	var mapState = mapStateStore.get();
	if (!mapState) return null;

	if ("center" in mapState) return mapState.center;else if ("bounds" in mapState) return (0, _geo.boundsLiteralToBounds)(mapState.bounds).getCenter().toJSON();else return null;
}

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RightContainer = __webpack_require__(382);

var _RightContainer2 = _interopRequireDefault(_RightContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RightContainer2.default;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _session = __webpack_require__(30);

var _session2 = _interopRequireDefault(_session);

var _dataTypes = __webpack_require__(68);

var _dataTypes2 = _interopRequireDefault(_dataTypes);

var _vehicles = __webpack_require__(45);

var _vehicles2 = _interopRequireDefault(_vehicles);

var _selectedVehicle = __webpack_require__(157);

var _selectedVehicle2 = _interopRequireDefault(_selectedVehicle);

var _vehicleStates = __webpack_require__(122);

var _vehicleStates2 = _interopRequireDefault(_vehicleStates);

var _pinnedVehicles = __webpack_require__(154);

var _pinnedVehicles2 = _interopRequireDefault(_pinnedVehicles);

var _focusedVehicle = __webpack_require__(368);

var _focusedVehicle2 = _interopRequireDefault(_focusedVehicle);

var _autoZoom = __webpack_require__(220);

var _autoZoom2 = _interopRequireDefault(_autoZoom);

var _zIndex = __webpack_require__(69);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _VehicleBubble = __webpack_require__(396);

var _VehicleBubble2 = _interopRequireDefault(_VehicleBubble);

var _geo = __webpack_require__(53);

var _vehicle = __webpack_require__(91);

var vehicleUtils = _interopRequireWildcard(_vehicle);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FOCUS_ZOOM = 16;

var BubbleController = function () {
	function BubbleController(map) {
		_classCallCheck(this, BubbleController);

		this.map = map;
		this.initBubbles();
		this.setListeners();
		this.canTurnOffAutoZoom = true;
	}

	_createClass(BubbleController, [{
		key: "initBubbles",
		value: function initBubbles() {
			this.bubbles = {};
			this.removeAllBubbles();
			this.addBubbles(_pinnedVehicles2.default.getAll());
		}
	}, {
		key: "setListeners",
		value: function setListeners() {
			var _this = this;

			google.maps.event.addListenerOnce(this.map, 'tilesloaded', function () {
				return _dispatcher2.default.dispatch('toggleAutoZoom');
			});

			google.maps.event.addListener(this.map, 'drag', function () {
				return _dispatcher2.default.dispatch('turnOffAutoZoom');
			});
			google.maps.event.addListener(this.map, 'zoom_changed', function () {
				if (_this.canTurnOffAutoZoom) _dispatcher2.default.dispatch('turnOffAutoZoom');
			});
			google.maps.event.addListener(this.map, 'bounds_changed', function () {
				return _this.updateVisibilities();
			});
			google.maps.event.addListener(this.map, 'click', function () {
				return _dispatcher2.default.dispatch('selectVehicle', null);
			});

			_pinnedVehicles2.default.on('set', function (vehicleIds) {
				return _this.addBubbles(vehicleIds);
			});
			_pinnedVehicles2.default.on('insert', function (vehicleIds) {
				return _this.addBubbles(vehicleIds);
			});
			_pinnedVehicles2.default.on('remove', function (vehicleIds) {
				return _this.removeBubbles(vehicleIds);
			});
			_vehicleStates2.default.on('update', function (vehicleState) {
				_this.updateMovingState(vehicleState);
				_this.updateAutoZoom();
			});
			_focusedVehicle2.default.on('change', function (vehicleId) {
				return _this.updateFocus(vehicleId);
			});
			_selectedVehicle2.default.on('change', function (vehicleId) {
				return _this.updateSelections(vehicleId);
			});
			_autoZoom2.default.on('change', function (value) {
				return _this.updateAutoZoom();
			});

			_vehicles2.default.on('update', function (vehicle) {
				return _this.updateName(vehicle._id);
			});
		}
	}, {
		key: "addBubbles",
		value: function addBubbles(vehicleIds) {
			var _this2 = this;

			if (!vehicleIds) return;

			vehicleIds.forEach(function (vehicleId) {
				if (vehicleId in _this2.bubbles) return;

				var position = vehicleUtils.getPositionOfVehicle(vehicleId);

				if (!position) {
					return;
				}

				_this2.bubbles[vehicleId] = new _VehicleBubble2.default({
					map: _this2.map,
					position: position,
					visible: _this2.getVisibilityOfVehicle(vehicleId),
					selected: vehicleUtils.getSelectionOfVehicle(vehicleId),
					name: vehicleUtils.getNameOfVehicle(vehicleId),
					zIndex: getZIndexOfVehicle(vehicleId),
					movingState: vehicleUtils.getMovingStateOfVehicle(vehicleId),
					onClick: function onClick() {
						return _dispatcher2.default.dispatch('selectVehicle', vehicleId);
					}
				});
			});

			this.updateAutoZoom();
		}
	}, {
		key: "removeBubbles",
		value: function removeBubbles(vehicleIds) {
			var _this3 = this;

			if (!vehicleIds) return;

			vehicleIds.forEach(function (vehicleId) {
				if (!_this3.bubbles[vehicleId]) return;

				_this3.bubbles[vehicleId].close();
				delete _this3.bubbles[vehicleId];
			});

			this.updateAutoZoom();
		}
	}, {
		key: "removeAllBubbles",
		value: function removeAllBubbles() {
			this.removeBubbles(Object.keys(this.bubbles));
		}
	}, {
		key: "getVisibilityOfVehicle",
		value: function getVisibilityOfVehicle(vehicleId) {
			var position = vehicleUtils.getPositionOfVehicle(vehicleId);
			if (!position) return false;
			var bounds = this.map.getBounds();
			if (!bounds) return false;
			return bounds.contains(position);
		}
	}, {
		key: "updateVisibilities",
		value: function updateVisibilities() {
			for (var vehicleId in this.bubbles) {
				this.bubbles[vehicleId].update({ visible: this.getVisibilityOfVehicle(vehicleId) });
			}
		}
	}, {
		key: "updateSelections",
		value: function updateSelections(vehicleId) {
			for (var _vehicleId in this.bubbles) {
				this.bubbles[_vehicleId].update({ selected: _selectedVehicle2.default.get() == _vehicleId });
			}
			this.updateZIndexes();
		}
	}, {
		key: "updateZIndexes",
		value: function updateZIndexes() {
			for (var vehicleId in this.bubbles) {
				this.bubbles[vehicleId].update({ zIndex: getZIndexOfVehicle(vehicleId) });
			}
		}
	}, {
		key: "updateName",
		value: function updateName(vehicleId) {
			if (!vehicleId || !this.bubbles[vehicleId]) return;
			this.bubbles[vehicleId].update({ name: vehicleUtils.getNameOfVehicle(vehicleId) });
		}
	}, {
		key: "updateMovingState",
		value: function updateMovingState(vehicleState) {
			var vehicleId = vehicleState.carrier;
			if (!this.bubbles[vehicleId]) return;
			this.bubbles[vehicleId].update({
				position: vehicleUtils.getPositionOfVehicle(vehicleId),
				movingState: vehicleUtils.getMovingStateOfVehicle(vehicleId),
				zIndex: getZIndexOfVehicle(vehicleId),
				selected: _selectedVehicle2.default.get() == vehicleId
			});
		}
	}, {
		key: "updateFocus",
		value: function updateFocus(vehicleId) {
			if (!vehicleId) return;
			var position = vehicleUtils.getPositionOfVehicle(vehicleId);
			if (!position) return;
			_dispatcher2.default.dispatch('setMap', {
				center: position.toJSON(),
				zoom: FOCUS_ZOOM
			});

			this.updateZIndexes();
		}
	}, {
		key: "updateAutoZoom",
		value: function updateAutoZoom() {
			var _this4 = this;

			if (!_autoZoom2.default.get()) return;

			var bounds = vehicleUtils.getBoundsOfPinnedVehicles();
			if (!bounds || bounds.isEmpty()) return;

			this.canTurnOffAutoZoom = false;

			_dispatcher2.default.dispatch('setMap', { bounds: bounds.toJSON() });

			if (this.map.getZoom() > FOCUS_ZOOM) {
				_dispatcher2.default.dispatch('setMap', {
					center: bounds.getCenter().toJSON(),
					zoom: FOCUS_ZOOM
				});
			}
			setTimeout(function () {
				return _this4.canTurnOffAutoZoom = true;
			});
		}
	}, {
		key: "refreshAllBubbles",
		value: function refreshAllBubbles() {
			var _this5 = this;

			Object.keys(this.bubbles).forEach(function (vehicleId) {
				return _this5.bubbles[vehicleId].refresh();
			});
		}
	}]);

	return BubbleController;
}();

exports.default = BubbleController;


function getZIndexOfVehicle(vehicleId) {
	var movingState = vehicleUtils.getMovingStateOfVehicle(vehicleId);
	var selectedVehicle = _selectedVehicle2.default.get();
	var focusedVehicle = _focusedVehicle2.default.get();

	if (selectedVehicle == vehicleId) return _zIndex2.default.SELECTED;else if (focusedVehicle == vehicleId) return _zIndex2.default.FOCUSED;else if (movingState == "onIgnition") return _zIndex2.default.IGNITION_ON;else if (movingState == "moving") return _zIndex2.default.MOVING;else return _zIndex2.default.IGNITION_OFF;
}

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(884);

var _InfoBox2 = __webpack_require__(229);

var _InfoBox3 = _interopRequireDefault(_InfoBox2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @class: Bubble
	
	@param {Object} params
		@param {google.maps.Map} params.map
		@param {google.maps.LatLng} params.position
		@param {HTMLElement} params.content
		@param {Number} [params.verticalOffset=2]
		@param {Number} [params.zIndex]
*/

var DEFAULT_BG_COLOR = "white";
var DEFAULT_TEXT_COLOR = "#444";
var DEFAULT_VERTICAL_OFFSET = 2;

var Bubble = function (_InfoBox) {
	_inherits(Bubble, _InfoBox);

	function Bubble(params) {
		_classCallCheck(this, Bubble);

		params = params || {};

		if (!params.map || !params.position || !params.content) throw new Error("Missing parameter...");

		var wrapper = document.createElement("div");
		wrapper.className = "Bubble";

		var _this = _possibleConstructorReturn(this, (Bubble.__proto__ || Object.getPrototypeOf(Bubble)).call(this, {
			content: wrapper,
			position: params.position,
			alignBottom: true,
			visible: false,
			closeBoxURL: "",
			zIndex: params.zIndex || null,
			maxWidth: params.maxWidth || null
		}));

		_this.map = params.map;
		_this.wrapper = wrapper;
		_this.verticalOffset = params.verticalOffset || DEFAULT_VERTICAL_OFFSET;

		_this.createBody(params.content);
		_this.createTriangleContainer();
		_this.setColor();

		google.maps.event.addListener(_this, 'domready', _this.updatePixelOffset);

		_this.open(_this.map);
		return _this;
	}

	_createClass(Bubble, [{
		key: "updatePixelOffset",
		value: function updatePixelOffset() {
			this.setOptions({
				pixelOffset: new google.maps.Size(-(this.wrapper.getBoundingClientRect().width / 2), this.verticalOffset),
				visible: true
			});
		}
	}, {
		key: "refresh",
		value: function refresh() {
			this.open(this.map);
		}
	}, {
		key: "createBody",
		value: function createBody(content) {
			this.body = document.createElement("div");
			this.wrapper.appendChild(this.body);
			this.body.className = "Body";
			this.body.appendChild(content);
		}
	}, {
		key: "createTriangleContainer",
		value: function createTriangleContainer() {
			this.triangleContainer = document.createElement("div");
			this.wrapper.appendChild(this.triangleContainer);
			this.triangleContainer.className = "TriangleContainer";

			this.triangleMask = document.createElement("div");
			this.triangleContainer.appendChild(this.triangleMask);

			this.triangle = document.createElement("div");
			this.triangleContainer.appendChild(this.triangle);
		}
	}, {
		key: "setColor",
		value: function setColor(backgroundColor, textColor) {
			backgroundColor = backgroundColor || DEFAULT_BG_COLOR;
			textColor = textColor || DEFAULT_TEXT_COLOR;
			this.body.style.backgroundColor = backgroundColor;
			this.body.style.color = textColor;
			this.triangle.style.borderColor = backgroundColor + " transparent transparent transparent";
		}
	}]);

	return Bubble;
}(_InfoBox3.default);

exports.default = Bubble;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(885);

var _Bubble2 = __webpack_require__(228);

var _Bubble3 = _interopRequireDefault(_Bubble2);

var _zIndex = __webpack_require__(69);

var _zIndex2 = _interopRequireDefault(_zIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_WIDTH = 200;

/**
	@param {Object} params
		@param {google.maps.Map} params.map
		@param {google.maps.LatLng} params.position
		@param {Object[]} params.items
			@param {String} params.items.label
			@param {Function} onClick
*/

var ContextMenu = function (_Bubble) {
	_inherits(ContextMenu, _Bubble);

	function ContextMenu() {
		var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		_classCallCheck(this, ContextMenu);

		if (!params.map) throw new Error("Missing map");

		if (!params.position) throw new Error("Missing position");

		var menu = document.createElement("ul");
		menu.classList.add("Map", "ContextMenu");

		var _this = _possibleConstructorReturn(this, (ContextMenu.__proto__ || Object.getPrototypeOf(ContextMenu)).call(this, {
			map: params.map,
			position: params.position,
			content: menu,
			maxWidth: ContextMenu.MAX_WIDTH,
			zIndex: _zIndex2.default.CONTEXT_MENU
		}));

		_this.menu = menu;
		_this.setItems(params.items);

		google.maps.event.addListenerOnce(params.map, 'click', _this.close.bind(_this));
		google.maps.event.addListenerOnce(params.map, 'rightclick', _this.close.bind(_this));
		return _this;
	}

	_createClass(ContextMenu, [{
		key: "setItems",
		value: function setItems(items) {
			var _this2 = this;

			this.items = items.map(function (item) {
				return _this2.createItem(item);
			});
		}
	}, {
		key: "createItem",
		value: function createItem(item) {
			var _this3 = this;

			var li = document.createElement("li");
			li.textContent = item.label;
			li.onclick = function (_) {
				item.onClick();
				_this3.close();
			};
			this.menu.appendChild(li);
			return li;
		}
	}]);

	return ContextMenu;
}(_Bubble3.default);

exports.default = ContextMenu;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ContextMenu = __webpack_require__(386);

var _ContextMenu2 = _interopRequireDefault(_ContextMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ContextMenu2.default;

/***/ },
/* 388 */
/***/ function(module, exports) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InfoBox;
/**
 * @name InfoBox
 * @version 1.1.13 [March 19, 2014]
 * @author Gary Little (inspired by proof-of-concept code from Pamela Fox of Google)
 * @copyright Copyright 2010 Gary Little [gary at luxcentral.com]
 * @fileoverview InfoBox extends the Google Maps JavaScript API V3 <tt>OverlayView</tt> class.
 *  <p>
 *  An InfoBox behaves like a <tt>google.maps.InfoWindow</tt>, but it supports several
 *  additional properties for advanced styling. An InfoBox can also be used as a map label.
 *  <p>
 *  An InfoBox also fires the same events as a <tt>google.maps.InfoWindow</tt>.
 */

/*!
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*jslint browser:true */
/*global google */

/**
 * @name InfoBoxOptions
 * @class This class represents the optional parameter passed to the {@link InfoBox} constructor.
 * @property {string|Node} content The content of the InfoBox (plain text or an HTML DOM node).
 * @property {boolean} [disableAutoPan=false] Disable auto-pan on <tt>open</tt>.
 * @property {number} maxWidth The maximum width (in pixels) of the InfoBox. Set to 0 if no maximum.
 * @property {Size} pixelOffset The offset (in pixels) from the top left corner of the InfoBox
 *  (or the bottom left corner if the <code>alignBottom</code> property is <code>true</code>)
 *  to the map pixel corresponding to <tt>position</tt>.
 * @property {LatLng} position The geographic location at which to display the InfoBox.
 * @property {number} zIndex The CSS z-index style value for the InfoBox.
 *  Note: This value overrides a zIndex setting specified in the <tt>boxStyle</tt> property.
 * @property {string} [boxClass="infoBox"] The name of the CSS class defining the styles for the InfoBox container.
 * @property {Object} [boxStyle] An object literal whose properties define specific CSS
 *  style values to be applied to the InfoBox. Style values defined here override those that may
 *  be defined in the <code>boxClass</code> style sheet. If this property is changed after the
 *  InfoBox has been created, all previously set styles (except those defined in the style sheet)
 *  are removed from the InfoBox before the new style values are applied.
 * @property {string} closeBoxMargin The CSS margin style value for the close box.
 *  The default is "2px" (a 2-pixel margin on all sides).
 * @property {string} closeBoxURL The URL of the image representing the close box.
 *  Note: The default is the URL for Google's standard close box.
 *  Set this property to "" if no close box is required.
 * @property {Size} infoBoxClearance Minimum offset (in pixels) from the InfoBox to the
 *  map edge after an auto-pan.
 * @property {boolean} [isHidden=false] Hide the InfoBox on <tt>open</tt>.
 *  [Deprecated in favor of the <tt>visible</tt> property.]
 * @property {boolean} [visible=true] Show the InfoBox on <tt>open</tt>.
 * @property {boolean} alignBottom Align the bottom left corner of the InfoBox to the <code>position</code>
 *  location (default is <tt>false</tt> which means that the top left corner of the InfoBox is aligned).
 * @property {string} pane The pane where the InfoBox is to appear (default is "floatPane").
 *  Set the pane to "mapPane" if the InfoBox is being used as a map label.
 *  Valid pane names are the property names for the <tt>google.maps.MapPanes</tt> object.
 * @property {boolean} enableEventPropagation Propagate mousedown, mousemove, mouseover, mouseout,
 *  mouseup, click, dblclick, touchstart, touchend, touchmove, and contextmenu events in the InfoBox
 *  (default is <tt>false</tt> to mimic the behavior of a <tt>google.maps.InfoWindow</tt>). Set
 *  this property to <tt>true</tt> if the InfoBox is being used as a map label.
 */

/**
 * Creates an InfoBox with the options specified in {@link InfoBoxOptions}.
 *  Call <tt>InfoBox.open</tt> to add the box to the map.
 * @constructor
 * @param {InfoBoxOptions} [opt_opts]
 */
function InfoBox(opt_opts) {

  opt_opts = opt_opts || {};

  google.maps.OverlayView.apply(this, arguments);

  // Standard options (in common with google.maps.InfoWindow):
  //
  this.content_ = opt_opts.content || "";
  this.disableAutoPan_ = opt_opts.disableAutoPan || false;
  this.maxWidth_ = opt_opts.maxWidth || 0;
  this.pixelOffset_ = opt_opts.pixelOffset || new google.maps.Size(0, 0);
  this.position_ = opt_opts.position || new google.maps.LatLng(0, 0);
  this.zIndex_ = opt_opts.zIndex || null;

  // Additional options (unique to InfoBox):
  //
  this.boxClass_ = opt_opts.boxClass || "infoBox";
  this.boxStyle_ = opt_opts.boxStyle || {};
  this.closeBoxMargin_ = opt_opts.closeBoxMargin || "2px";
  this.closeBoxURL_ = opt_opts.closeBoxURL || "http://www.google.com/intl/en_us/mapfiles/close.gif";
  if (opt_opts.closeBoxURL === "") {
    this.closeBoxURL_ = "";
  }
  this.infoBoxClearance_ = opt_opts.infoBoxClearance || new google.maps.Size(1, 1);

  if (typeof opt_opts.visible === "undefined") {
    if (typeof opt_opts.isHidden === "undefined") {
      opt_opts.visible = true;
    } else {
      opt_opts.visible = !opt_opts.isHidden;
    }
  }
  this.isHidden_ = !opt_opts.visible;

  this.alignBottom_ = opt_opts.alignBottom || false;
  this.pane_ = opt_opts.pane || "floatPane";
  this.enableEventPropagation_ = opt_opts.enableEventPropagation || false;

  this.div_ = null;
  this.closeListener_ = null;
  this.moveListener_ = null;
  this.contextListener_ = null;
  this.eventListeners_ = null;
  this.fixedWidthSet_ = null;
}

/* InfoBox extends OverlayView in the Google Maps API v3.
 */
InfoBox.prototype = new google.maps.OverlayView();

/**
 * Creates the DIV representing the InfoBox.
 * @private
 */
InfoBox.prototype.createInfoBoxDiv_ = function () {

  var i;
  var events;
  var bw;
  var me = this;

  // This handler prevents an event in the InfoBox from being passed on to the map.
  //
  var cancelHandler = function cancelHandler(e) {
    e.cancelBubble = true;
    if (e.stopPropagation) {
      e.stopPropagation();
    }
  };

  // This handler ignores the current event in the InfoBox and conditionally prevents
  // the event from being passed on to the map. It is used for the contextmenu event.
  //
  var ignoreHandler = function ignoreHandler(e) {

    e.returnValue = false;

    if (e.preventDefault) {

      e.preventDefault();
    }

    if (!me.enableEventPropagation_) {

      cancelHandler(e);
    }
  };

  if (!this.div_) {

    this.div_ = document.createElement("div");

    this.setBoxStyle_();

    if (typeof this.content_.nodeType === "undefined") {
      this.div_.innerHTML = this.getCloseBoxImg_() + this.content_;
    } else {
      this.div_.innerHTML = this.getCloseBoxImg_();
      this.div_.appendChild(this.content_);
    }

    // Add the InfoBox DIV to the DOM
    this.getPanes()[this.pane_].appendChild(this.div_);

    this.addClickHandler_();

    if (this.div_.style.width) {

      this.fixedWidthSet_ = true;
    } else {

      if (this.maxWidth_ !== 0 && this.div_.offsetWidth > this.maxWidth_) {

        this.div_.style.width = this.maxWidth_;
        this.div_.style.overflow = "auto";
        this.fixedWidthSet_ = true;
      } else {
        // The following code is needed to overcome problems with MSIE

        bw = this.getBoxWidths_();

        this.div_.style.width = this.div_.offsetWidth - bw.left - bw.right + "px";
        this.fixedWidthSet_ = false;
      }
    }

    this.panBox_(this.disableAutoPan_);

    if (!this.enableEventPropagation_) {

      this.eventListeners_ = [];

      // Cancel event propagation.
      //
      // Note: mousemove not included (to resolve Issue 152)
      events = ["mousedown", "mouseover", "mouseout", "mouseup", "click", "dblclick", "touchstart", "touchend", "touchmove"];

      for (i = 0; i < events.length; i++) {

        this.eventListeners_.push(google.maps.event.addDomListener(this.div_, events[i], cancelHandler));
      }

      // Workaround for Google bug that causes the cursor to change to a pointer
      // when the mouse moves over a marker underneath InfoBox.
      this.eventListeners_.push(google.maps.event.addDomListener(this.div_, "mouseover", function (e) {
        this.style.cursor = "default";
      }));
    }

    this.contextListener_ = google.maps.event.addDomListener(this.div_, "contextmenu", ignoreHandler);

    /**
     * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
     * @name InfoBox#domready
     * @event
     */
    google.maps.event.trigger(this, "domready");
  }
};

/**
 * Returns the HTML <IMG> tag for the close box.
 * @private
 */
InfoBox.prototype.getCloseBoxImg_ = function () {

  var img = "";

  if (this.closeBoxURL_ !== "") {

    img = "<img";
    img += " src='" + this.closeBoxURL_ + "'";
    img += " align=right"; // Do this because Opera chokes on style='float: right;'
    img += " style='";
    img += " position: relative;"; // Required by MSIE
    img += " cursor: pointer;";
    img += " margin: " + this.closeBoxMargin_ + ";";
    img += "'>";
  }

  return img;
};

/**
 * Adds the click handler to the InfoBox close box.
 * @private
 */
InfoBox.prototype.addClickHandler_ = function () {

  var closeBox;

  if (this.closeBoxURL_ !== "") {

    closeBox = this.div_.firstChild;
    this.closeListener_ = google.maps.event.addDomListener(closeBox, "click", this.getCloseClickHandler_());
  } else {

    this.closeListener_ = null;
  }
};

/**
 * Returns the function to call when the user clicks the close box of an InfoBox.
 * @private
 */
InfoBox.prototype.getCloseClickHandler_ = function () {

  var me = this;

  return function (e) {

    // 1.0.3 fix: Always prevent propagation of a close box click to the map:
    e.cancelBubble = true;

    if (e.stopPropagation) {

      e.stopPropagation();
    }

    /**
     * This event is fired when the InfoBox's close box is clicked.
     * @name InfoBox#closeclick
     * @event
     */
    google.maps.event.trigger(me, "closeclick");

    me.close();
  };
};

/**
 * Pans the map so that the InfoBox appears entirely within the map's visible area.
 * @private
 */
InfoBox.prototype.panBox_ = function (disablePan) {

  var map;
  var bounds;
  var xOffset = 0,
      yOffset = 0;

  if (!disablePan) {

    map = this.getMap();

    if (map instanceof google.maps.Map) {
      // Only pan if attached to map, not panorama

      if (!map.getBounds().contains(this.position_)) {
        // Marker not in visible area of map, so set center
        // of map to the marker position first.
        map.setCenter(this.position_);
      }

      bounds = map.getBounds();

      var mapDiv = map.getDiv();
      var mapWidth = mapDiv.offsetWidth;
      var mapHeight = mapDiv.offsetHeight;
      var iwOffsetX = this.pixelOffset_.width;
      var iwOffsetY = this.pixelOffset_.height;
      var iwWidth = this.div_.offsetWidth;
      var iwHeight = this.div_.offsetHeight;
      var padX = this.infoBoxClearance_.width;
      var padY = this.infoBoxClearance_.height;
      var pixPosition = this.getProjection().fromLatLngToContainerPixel(this.position_);

      if (pixPosition.x < -iwOffsetX + padX) {
        xOffset = pixPosition.x + iwOffsetX - padX;
      } else if (pixPosition.x + iwWidth + iwOffsetX + padX > mapWidth) {
        xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
      }
      if (this.alignBottom_) {
        if (pixPosition.y < -iwOffsetY + padY + iwHeight) {
          yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
        } else if (pixPosition.y + iwOffsetY + padY > mapHeight) {
          yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
        }
      } else {
        if (pixPosition.y < -iwOffsetY + padY) {
          yOffset = pixPosition.y + iwOffsetY - padY;
        } else if (pixPosition.y + iwHeight + iwOffsetY + padY > mapHeight) {
          yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
        }
      }

      if (!(xOffset === 0 && yOffset === 0)) {

        // Move the map to the shifted center.
        //
        var c = map.getCenter();
        map.panBy(xOffset, yOffset);
      }
    }
  }
};

/**
 * Sets the style of the InfoBox by setting the style sheet and applying
 * other specific styles requested.
 * @private
 */
InfoBox.prototype.setBoxStyle_ = function () {

  var i, boxStyle;

  if (this.div_) {

    // Apply style values from the style sheet defined in the boxClass parameter:
    this.div_.className = this.boxClass_;

    // Clear existing inline style values:
    this.div_.style.cssText = "";

    // Apply style values defined in the boxStyle parameter:
    boxStyle = this.boxStyle_;
    for (i in boxStyle) {

      if (boxStyle.hasOwnProperty(i)) {

        this.div_.style[i] = boxStyle[i];
      }
    }

    // Fix for iOS disappearing InfoBox problem.
    // See http://stackoverflow.com/questions/9229535/google-maps-markers-disappear-at-certain-zoom-level-only-on-iphone-ipad
    this.div_.style.WebkitTransform = "translateZ(0)";

    // Fix up opacity style for benefit of MSIE:
    //
    if (typeof this.div_.style.opacity !== "undefined" && this.div_.style.opacity !== "") {
      // See http://www.quirksmode.org/css/opacity.html
      this.div_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(Opacity=" + this.div_.style.opacity * 100 + ")\"";
      this.div_.style.filter = "alpha(opacity=" + this.div_.style.opacity * 100 + ")";
    }

    // Apply required styles:
    //
    this.div_.style.position = "absolute";
    this.div_.style.visibility = 'hidden';
    if (this.zIndex_ !== null) {

      this.div_.style.zIndex = this.zIndex_;
    }
  }
};

/**
 * Get the widths of the borders of the InfoBox.
 * @private
 * @return {Object} widths object (top, bottom left, right)
 */
InfoBox.prototype.getBoxWidths_ = function () {

  var computedStyle;
  var bw = { top: 0, bottom: 0, left: 0, right: 0 };
  var box = this.div_;

  if (document.defaultView && document.defaultView.getComputedStyle) {

    computedStyle = box.ownerDocument.defaultView.getComputedStyle(box, "");

    if (computedStyle) {

      // The computed styles are always in pixel units (good!)
      bw.top = parseInt(computedStyle.borderTopWidth, 10) || 0;
      bw.bottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
      bw.left = parseInt(computedStyle.borderLeftWidth, 10) || 0;
      bw.right = parseInt(computedStyle.borderRightWidth, 10) || 0;
    }
  } else if (document.documentElement.currentStyle) {
    // MSIE

    if (box.currentStyle) {

      // The current styles may not be in pixel units, but assume they are (bad!)
      bw.top = parseInt(box.currentStyle.borderTopWidth, 10) || 0;
      bw.bottom = parseInt(box.currentStyle.borderBottomWidth, 10) || 0;
      bw.left = parseInt(box.currentStyle.borderLeftWidth, 10) || 0;
      bw.right = parseInt(box.currentStyle.borderRightWidth, 10) || 0;
    }
  }

  return bw;
};

/**
 * Invoked when <tt>close</tt> is called. Do not call it directly.
 */
InfoBox.prototype.onRemove = function () {

  if (this.div_) {

    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
  }
};

/**
 * Draws the InfoBox based on the current map projection and zoom level.
 */
InfoBox.prototype.draw = function () {

  this.createInfoBoxDiv_();

  var pixPosition = this.getProjection().fromLatLngToDivPixel(this.position_);

  this.div_.style.left = pixPosition.x + this.pixelOffset_.width + "px";

  if (this.alignBottom_) {
    this.div_.style.bottom = -(pixPosition.y + this.pixelOffset_.height) + "px";
  } else {
    this.div_.style.top = pixPosition.y + this.pixelOffset_.height + "px";
  }

  if (this.isHidden_) {

    this.div_.style.visibility = "hidden";
  } else {

    this.div_.style.visibility = "visible";
  }
};

/**
 * Sets the options for the InfoBox. Note that changes to the <tt>maxWidth</tt>,
 *  <tt>closeBoxMargin</tt>, <tt>closeBoxURL</tt>, and <tt>enableEventPropagation</tt>
 *  properties have no affect until the current InfoBox is <tt>close</tt>d and a new one
 *  is <tt>open</tt>ed.
 * @param {InfoBoxOptions} opt_opts
 */
InfoBox.prototype.setOptions = function (opt_opts) {
  if (typeof opt_opts.boxClass !== "undefined") {
    // Must be first

    this.boxClass_ = opt_opts.boxClass;
    this.setBoxStyle_();
  }
  if (typeof opt_opts.boxStyle !== "undefined") {
    // Must be second

    this.boxStyle_ = opt_opts.boxStyle;
    this.setBoxStyle_();
  }
  if (typeof opt_opts.content !== "undefined") {

    this.setContent(opt_opts.content);
  }
  if (typeof opt_opts.disableAutoPan !== "undefined") {

    this.disableAutoPan_ = opt_opts.disableAutoPan;
  }
  if (typeof opt_opts.maxWidth !== "undefined") {

    this.maxWidth_ = opt_opts.maxWidth;
  }
  if (typeof opt_opts.pixelOffset !== "undefined") {

    this.pixelOffset_ = opt_opts.pixelOffset;
  }
  if (typeof opt_opts.alignBottom !== "undefined") {

    this.alignBottom_ = opt_opts.alignBottom;
  }
  if (typeof opt_opts.position !== "undefined") {

    this.setPosition(opt_opts.position);
  }
  if (typeof opt_opts.zIndex !== "undefined") {

    this.setZIndex(opt_opts.zIndex);
  }
  if (typeof opt_opts.closeBoxMargin !== "undefined") {

    this.closeBoxMargin_ = opt_opts.closeBoxMargin;
  }
  if (typeof opt_opts.closeBoxURL !== "undefined") {

    this.closeBoxURL_ = opt_opts.closeBoxURL;
  }
  if (typeof opt_opts.infoBoxClearance !== "undefined") {

    this.infoBoxClearance_ = opt_opts.infoBoxClearance;
  }
  if (typeof opt_opts.isHidden !== "undefined") {

    this.isHidden_ = opt_opts.isHidden;
  }
  if (typeof opt_opts.visible !== "undefined") {

    this.isHidden_ = !opt_opts.visible;
  }
  if (typeof opt_opts.enableEventPropagation !== "undefined") {

    this.enableEventPropagation_ = opt_opts.enableEventPropagation;
  }

  if (this.div_) {

    this.draw();
  }
};

/**
 * Sets the content of the InfoBox.
 *  The content can be plain text or an HTML DOM node.
 * @param {string|Node} content
 */
InfoBox.prototype.setContent = function (content) {
  this.content_ = content;

  if (this.div_) {

    if (this.closeListener_) {

      google.maps.event.removeListener(this.closeListener_);
      this.closeListener_ = null;
    }

    // Odd code required to make things work with MSIE.
    //
    if (!this.fixedWidthSet_) {

      this.div_.style.width = "";
    }

    if (typeof content.nodeType === "undefined") {
      this.div_.innerHTML = this.getCloseBoxImg_() + content;
    } else {
      this.div_.innerHTML = this.getCloseBoxImg_();
      this.div_.appendChild(content);
    }

    // Perverse code required to make things work with MSIE.
    // (Ensures the close box does, in fact, float to the right.)
    //
    if (!this.fixedWidthSet_) {
      this.div_.style.width = this.div_.offsetWidth + "px";
      if (typeof content.nodeType === "undefined") {
        this.div_.innerHTML = this.getCloseBoxImg_() + content;
      } else {
        this.div_.innerHTML = this.getCloseBoxImg_();
        this.div_.appendChild(content);
      }
    }

    this.addClickHandler_();
  }

  /**
   * This event is fired when the content of the InfoBox changes.
   * @name InfoBox#content_changed
   * @event
   */
  google.maps.event.trigger(this, "content_changed");
};

/**
 * Sets the geographic location of the InfoBox.
 * @param {LatLng} latlng
 */
InfoBox.prototype.setPosition = function (latlng) {

  this.position_ = latlng;

  if (this.div_) {

    this.draw();
  }

  /**
   * This event is fired when the position of the InfoBox changes.
   * @name InfoBox#position_changed
   * @event
   */
  google.maps.event.trigger(this, "position_changed");
};

/**
 * Sets the zIndex style for the InfoBox.
 * @param {number} index
 */
InfoBox.prototype.setZIndex = function (index) {

  this.zIndex_ = index;

  if (this.div_) {

    this.div_.style.zIndex = index;
  }

  /**
   * This event is fired when the zIndex of the InfoBox changes.
   * @name InfoBox#zindex_changed
   * @event
   */
  google.maps.event.trigger(this, "zindex_changed");
};

/**
 * Sets the visibility of the InfoBox.
 * @param {boolean} isVisible
 */
InfoBox.prototype.setVisible = function (isVisible) {

  this.isHidden_ = !isVisible;
  if (this.div_) {
    this.div_.style.visibility = this.isHidden_ ? "hidden" : "visible";
  }
};

/**
 * Returns the content of the InfoBox.
 * @returns {string}
 */
InfoBox.prototype.getContent = function () {

  return this.content_;
};

/**
 * Returns the geographic location of the InfoBox.
 * @returns {LatLng}
 */
InfoBox.prototype.getPosition = function () {

  return this.position_;
};

/**
 * Returns the zIndex for the InfoBox.
 * @returns {number}
 */
InfoBox.prototype.getZIndex = function () {

  return this.zIndex_;
};

/**
 * Returns a flag indicating whether the InfoBox is visible.
 * @returns {boolean}
 */
InfoBox.prototype.getVisible = function () {

  var isVisible;

  if (typeof this.getMap() === "undefined" || this.getMap() === null) {
    isVisible = false;
  } else {
    isVisible = !this.isHidden_;
  }
  return isVisible;
};

/**
 * Shows the InfoBox. [Deprecated; use <tt>setVisible</tt> instead.]
 */
InfoBox.prototype.show = function () {

  this.isHidden_ = false;
  if (this.div_) {
    this.div_.style.visibility = "visible";
  }
};

/**
 * Hides the InfoBox. [Deprecated; use <tt>setVisible</tt> instead.]
 */
InfoBox.prototype.hide = function () {

  this.isHidden_ = true;
  if (this.div_) {
    this.div_.style.visibility = "hidden";
  }
};

/**
 * Adds the InfoBox to the specified map or Street View panorama. If <tt>anchor</tt>
 *  (usually a <tt>google.maps.Marker</tt>) is specified, the position
 *  of the InfoBox is set to the position of the <tt>anchor</tt>. If the
 *  anchor is dragged to a new location, the InfoBox moves as well.
 * @param {Map|StreetViewPanorama} map
 * @param {MVCObject} [anchor]
 */
InfoBox.prototype.open = function (map, anchor) {

  var me = this;

  if (anchor) {

    this.position_ = anchor.getPosition();
    this.moveListener_ = google.maps.event.addListener(anchor, "position_changed", function () {
      me.setPosition(this.getPosition());
    });
  }

  this.setMap(map);

  if (this.div_) {

    this.panBox_();
  }
};

/**
 * Removes the InfoBox from the map.
 */
InfoBox.prototype.close = function () {

  var i;

  if (this.closeListener_) {

    google.maps.event.removeListener(this.closeListener_);
    this.closeListener_ = null;
  }

  if (this.eventListeners_) {

    for (i = 0; i < this.eventListeners_.length; i++) {

      google.maps.event.removeListener(this.eventListeners_[i]);
    }
    this.eventListeners_ = null;
  }

  if (this.moveListener_) {

    google.maps.event.removeListener(this.moveListener_);
    this.moveListener_ = null;
  }

  if (this.contextListener_) {

    google.maps.event.removeListener(this.contextListener_);
    this.contextListener_ = null;
  }

  this.setMap(null);
};

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(390);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _listenResize = __webpack_require__(348);

var _listenResize2 = _interopRequireDefault(_listenResize);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _autoZoom = __webpack_require__(220);

var _autoZoom2 = _interopRequireDefault(_autoZoom);

var _mapState = __webpack_require__(221);

var _mapState2 = _interopRequireDefault(_mapState);

var _mapTooltip = __webpack_require__(222);

var _mapTooltip2 = _interopRequireDefault(_mapTooltip);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _BubbleController = __webpack_require__(384);

var _BubbleController2 = _interopRequireDefault(_BubbleController);

var _POIController = __webpack_require__(391);

var _POIController2 = _interopRequireDefault(_POIController);

var _VehicleActivityController = __webpack_require__(394);

var _VehicleActivityController2 = _interopRequireDefault(_VehicleActivityController);

var _VehicleHeatmapController = __webpack_require__(397);

var _VehicleHeatmapController2 = _interopRequireDefault(_VehicleHeatmapController);

var _VehiclePOICrossingsController = __webpack_require__(398);

var _VehiclePOICrossingsController2 = _interopRequireDefault(_VehiclePOICrossingsController);

var _TooltipController = __webpack_require__(392);

var _TooltipController2 = _interopRequireDefault(_TooltipController);

var _ContextMenu = __webpack_require__(387);

var _ContextMenu2 = _interopRequireDefault(_ContextMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_CENTER = { lat: 47, lng: 19 };
var DEFAULT_ZOOM = 7;

var Map = function (_React$Component) {
	_inherits(Map, _React$Component);

	function Map(props) {
		_classCallCheck(this, Map);

		var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(Map, [{
		key: "initState",
		value: function initState() {
			this.state = {
				traffic: false
			};
		}
	}, {
		key: "render",
		value: function render() {
			return _react2.default.createElement("div", { ref: "container", className: this.props.cat ? "Cat" : "" });
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			var _this2 = this;

			var prevW = 0;
			var prevH = 0;

			(0, _listenResize2.default)(this.refs.container, function (w, h) {
				_this2.resize();
				if (prevW == 0 && w > 0 && prevH == 0 && h > 0) {
					prevH = h;
					prevW = w;
					_this2.bubbleController.refreshAllBubbles();
				}
			});
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate(nextProps, nextState) {
			if (nextState.traffic !== this.state.traffic) return false;
			return true;
		}
	}, {
		key: "componentDidUpdate",
		value: function componentDidUpdate() {
			if (this.props.ready) this.createMap();
		}
	}, {
		key: "createMap",
		value: function createMap() {
			if (this.gmap) return;
			this.gmap = new google.maps.Map(this.refs.container, this.getOptions());
			window.gmap = this.gmap;
			this.trafficLayer = new google.maps.TrafficLayer();
			this.createControllers();
			this.createAutoZoomButton();
			this.createTrafficButton();
			this.listendBoundsChange = true;
			this.setListeners();
			this.setStoreListeners();
		}
	}, {
		key: "getOptions",
		value: function getOptions() {
			return {
				center: DEFAULT_CENTER,
				zoom: DEFAULT_ZOOM,
				streetViewControl: false,
				panControl: false,
				zoomControlOptions: { style: google.maps.ZoomControlStyle.SMALL },
				mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'usroadatlas']
			};
		}
	}, {
		key: "setListeners",
		value: function setListeners() {
			var _this3 = this;

			google.maps.event.addListener(this.gmap, 'bounds_changed', function (_) {
				if (_this3.listendBoundsChange) _this3.handleBoundsChanged();
			});
			google.maps.event.addListener(this.gmap, 'rightclick', function (evt) {
				return _this3.createContextMenu(evt.latLng);
			});
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this4 = this;

			_mapState2.default.on("change", function (descriptor) {
				_this4.listendBoundsChange = false;
				var currentCenter = _this4.gmap.getCenter().toJSON();
				if ("center" in descriptor) {
					if (descriptor.center.lat != currentCenter.lat || descriptor.lng != currentCenter.lng) _this4.gmap.setCenter(descriptor.center);
				}
				if ("zoom" in descriptor) {
					if (descriptor.zoom != _this4.gmap.getZoom()) _this4.gmap.setZoom(descriptor.zoom);
				}
				if ("bounds" in descriptor) _this4.gmap.fitBounds(descriptor.bounds);
				setTimeout(function () {
					return _this4.listendBoundsChange = true;
				});
			});
		}
	}, {
		key: "handleBoundsChanged",
		value: function handleBoundsChanged() {
			if (!this.gmap) return;
			_dispatcher2.default.dispatch('setMap', {
				center: this.gmap.getCenter().toJSON(),
				zoom: this.gmap.getZoom()
			});
		}
	}, {
		key: "createControllers",
		value: function createControllers() {
			this.bubbleController = new _BubbleController2.default(this.gmap);
			window.bubbleController = this.bubbleController;
			this.poiController = new _POIController2.default(this.gmap);
			window.poiController = this.poiController;
			this.vehicleActivityController = new _VehicleActivityController2.default(this.gmap);
			window.vehicleActivityController = this.vehicleActivityController;
			this.vehicleHeatmapController = new _VehicleHeatmapController2.default(this.gmap);
			window.vehicleHeatmapController = this.vehicleHeatmapController;
			this.vehiclePOICrossingsController = new _VehiclePOICrossingsController2.default(this.gmap);
			window.vehiclePOICrossingsController = this.vehiclePOICrossingsController;
			this.tooltipController = new _TooltipController2.default(this.gmap);
			window.tooltipController = this.tooltipController;
		}
	}, {
		key: "createAutoZoomButton",
		value: function createAutoZoomButton() {
			var autoZoomButton = document.createElement("div");
			autoZoomButton.className = "MapButton";
			autoZoomButton.title = _lang2.default.AUTOZOOM;
			var icon = document.createElement("i");
			autoZoomButton.appendChild(icon);
			icon.className = "mdi mdi-eye" + (_autoZoom2.default.get() ? "" : "-off");

			this.gmap.controls[google.maps.ControlPosition.RIGHT_TOP].push(autoZoomButton);

			autoZoomButton.onclick = function () {
				return _dispatcher2.default.dispatch('toggleAutoZoom');
			};
			_autoZoom2.default.on('change', function (value) {
				return icon.className = "mdi mdi-eye" + (value ? "" : "-off");
			});
		}
	}, {
		key: "toggleTraffic",
		value: function toggleTraffic() {
			var _this5 = this;

			this.setState({
				traffic: !this.state.traffic
			}, function () {
				_this5.trafficLayer.setMap(_this5.state.traffic ? _this5.gmap : null);
				_this5.updateTrafficButton();
			});
		}
	}, {
		key: "createTrafficButton",
		value: function createTrafficButton() {
			var _this6 = this;

			this.refs.trafficButton = document.createElement("div");
			this.refs.trafficButton.className = "MapButton";
			this.refs.trafficButton.title = _lang2.default.TRAFFIC;
			var icon = document.createElement("i");
			this.refs.trafficButton.appendChild(icon);
			icon.className = "mdi mdi-traffic-light";

			this.gmap.controls[google.maps.ControlPosition.LEFT_TOP].push(this.refs.trafficButton);

			this.refs.trafficButton.onclick = function () {
				return _this6.toggleTraffic();
			};

			this.updateTrafficButton();
		}
	}, {
		key: "createContextMenu",
		value: function createContextMenu(position) {
			var _this7 = this;

			var contextMenu = new _ContextMenu2.default({
				map: this.gmap,
				position: position,
				items: [{
					label: _lang2.default.CREATE_POI,
					onClick: function onClick() {
						return _this7.props.onCreatePOI(position);
					}
				}]
			});
		}
	}, {
		key: "updateTrafficButton",
		value: function updateTrafficButton() {
			if (this.state.traffic) this.refs.trafficButton.classList.remove("Inactive");else this.refs.trafficButton.classList.add("Inactive");
		}
	}, {
		key: "resize",
		value: function resize() {
			if (this.gmap) google.maps.event.trigger(this.gmap, "resize");
		}
	}]);

	return Map;
}(_react2.default.Component);

exports.default = Map;


Map.propTypes = {
	ready: _react2.default.PropTypes.bool,
	onCreatePOI: _react2.default.PropTypes.func
};

Map.defaultProps = {
	ready: false,
	onCreatePOI: function onCreatePOI(location) {}
};

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

__webpack_require__(886);

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filterGroups = __webpack_require__(67);

var _filterGroups2 = _interopRequireDefault(_filterGroups);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _pois = __webpack_require__(29);

var _pois2 = _interopRequireDefault(_pois);

var _pinnedPOIs = __webpack_require__(223);

var _pinnedPOIs2 = _interopRequireDefault(_pinnedPOIs);

var _selectedPOI = __webpack_require__(156);

var _selectedPOI2 = _interopRequireDefault(_selectedPOI);

var _editedPOI = __webpack_require__(153);

var _editedPOI2 = _interopRequireDefault(_editedPOI);

var _poiModifications = __webpack_require__(119);

var _poiModifications2 = _interopRequireDefault(_poiModifications);

var _savePOI = __webpack_require__(218);

var _savePOI2 = _interopRequireDefault(_savePOI);

var _poi = __webpack_require__(46);

var _poi2 = _interopRequireDefault(_poi);

var _geo = __webpack_require__(53);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _zIndex = __webpack_require__(69);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _ConfirmDialog = __webpack_require__(146);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_COLOR = "red";
var DEFAULT_STROKE_OPACITY = 0.1;
var FILL_OPACITY = 0.3;
var STROKE_WEIGHT = 2;
var HIGHLIGHTED_STROKE_OPACITY = 1;

var POIController = function () {
	function POIController(map) {
		_classCallCheck(this, POIController);

		this.map = map;
		this.initPOIs();
		this.setListeners();
	}

	_createClass(POIController, [{
		key: "initPOIs",
		value: function initPOIs() {
			this.pois = this.pois || {};
			this.removeAllPOIs();
			this.addPOIs(_pinnedPOIs2.default.getAll());
		}
	}, {
		key: "setListeners",
		value: function setListeners() {
			var _this = this;

			google.maps.event.addListener(this.map, 'click', function () {
				return _this.handleMapClick();
			});
			google.maps.event.addListener(this.map, 'bounds_changed', function () {
				return _this.updateVisibilities();
			});

			_pinnedPOIs2.default.on('set', function (_) {
				return _this.initPOIs();
			});
			_pinnedPOIs2.default.on('insert', function (poiIds) {
				return _this.addPOIs(poiIds);
			});
			_pinnedPOIs2.default.on('remove', function (poiIds) {
				return _this.removePOIs(poiIds);
			});
			_selectedPOI2.default.on('change', function (poiId) {
				return _this.updateSelectedAndEditedPOI();
			});
			_editedPOI2.default.on('change', function (editing) {
				return _this.updateSelectedAndEditedPOI();
			});
			_poiModifications2.default.on('update', function (modificationDoc) {
				return _this.updateShape(modificationDoc);
			});
			_poiModifications2.default.on('insert', function (modificationDocs) {
				return _this.updateShape(modificationDocs[0] || null);
			});
			_poiModifications2.default.on('remove', function (modificationDocs) {
				return _this.updateShape(modificationDocs[0] || null);
			});
		}
	}, {
		key: "addPOIs",
		value: function addPOIs(poiIds) {
			var _this2 = this;

			if (!poiIds) return;

			poiIds.forEach(function (poiId) {
				return _this2.addPOI(poiId);
			});
		}
	}, {
		key: "addPOI",
		value: function addPOI(poiId) {
			if (poiId in this.pois) return;
			var type = _poi2.default.getTypeOfPOI(poiId);
			if (type == "PolygonalPOI") this.addPolygonPOI(poiId);else if (type == "RadialPOI") this.addRadialPOI(poiId);else return;

			this.setPOIListeners(poiId);
		}
	}, {
		key: "addPolygonPOI",
		value: function addPolygonPOI(poiId) {
			var paths = _poi2.default.getPathOfPOI(poiId);
			if (!paths) return;

			this.pois[poiId] = new google.maps.Polygon({
				map: this.map,
				paths: paths,
				strokeColor: _poi2.default.getColorOfPOI(poiId),
				strokeOpacity: DEFAULT_STROKE_OPACITY,
				strokeWeight: STROKE_WEIGHT,
				fillColor: _poi2.default.getColorOfPOI(poiId),
				fillOpacity: FILL_OPACITY,
				editable: false,
				draggable: false,
				zIndex: _zIndex2.default.POI
			});
		}
	}, {
		key: "addRadialPOI",
		value: function addRadialPOI(poiId) {
			var center = _poi2.default.getCenterOfPOI(poiId);
			var radius = _poi2.default.getRadiusOfPOI(poiId);
			if (!center || radius === null) return;

			this.pois[poiId] = new google.maps.Circle({
				map: this.map,
				strokeColor: _poi2.default.getColorOfPOI(poiId),
				strokeOpacity: DEFAULT_STROKE_OPACITY,
				strokeWeight: STROKE_WEIGHT,
				fillColor: _poi2.default.getColorOfPOI(poiId),
				fillOpacity: FILL_OPACITY,
				editable: false,
				draggable: false,
				zIndex: _zIndex2.default.POI,
				center: center,
				radius: radius
			});
		}
	}, {
		key: "setPOIListeners",
		value: function setPOIListeners(poiId) {
			var _this3 = this;

			if (!this.pois[poiId]) return;

			google.maps.event.addListener(this.pois[poiId], 'click', function (evt) {
				return _this3.handlePOIClick(evt, poiId);
			});
			google.maps.event.addListener(this.pois[poiId], 'dblclick', function (evt) {
				return _this3.handlePOIDoubleClick(evt, poiId);
			});
			google.maps.event.addListener(this.pois[poiId], 'mouseover', function (evt) {
				return _this3.handlePOIMouseOver(evt, poiId);
			});
			google.maps.event.addListener(this.pois[poiId], 'mouseup', function (_) {
				return _this3.handlePOIEditing(poiId);
			});
			google.maps.event.addListener(this.pois[poiId], 'radius_changed', function () {
				return _this3.handleRadiusChange(poiId);
			});
		}
	}, {
		key: "removePOIs",
		value: function removePOIs(poiIds) {
			var _this4 = this;

			if (!poiIds) return;

			poiIds.forEach(function (poiId) {
				if (!_this4.pois[poiId]) return;

				_this4.pois[poiId].setMap(null);
				delete _this4.pois[poiId];
			});
		}
	}, {
		key: "removeAllPOIs",
		value: function removeAllPOIs() {
			this.removePOIs(Object.keys(this.pois));
		}
	}, {
		key: "handleMapClick",
		value: function handleMapClick() {
			_dispatcher2.default.dispatch('selectPOI', null);
			this.closeEditing();
		}
	}, {
		key: "handlePOIClick",
		value: function handlePOIClick(evt, poiId) {
			evt.stop();
			_dispatcher2.default.dispatch('selectPOI', poiId);
			if (_editedPOI2.default.get() !== poiId) this.closeEditing();
		}
	}, {
		key: "handlePOIDoubleClick",
		value: function handlePOIDoubleClick(evt, poiId) {
			evt.stop();
			if (!this.pois[poiId]) return;
			if (evt.vertex !== null && evt.vertex !== undefined) {
				this.pois[poiId].getPath().removeAt(evt.vertex);
				_dispatcher2.default.dispatch('modifyPOI', poiId, this.getModifications(poiId));
			} else {
				_dispatcher2.default.dispatch('editPOI', poiId);
			}
		}
	}, {
		key: "handleRadiusChange",
		value: function handleRadiusChange(poiId) {
			if (!this.pois[poiId]) return;

			if (this.pois[poiId].getRadius() != _poi2.default.getRadiusOfPOI(poiId)) this.handlePOIEditing(poiId);
		}
	}, {
		key: "handlePOIEditing",
		value: function handlePOIEditing(poiId) {
			var _this5 = this;

			if (!_editedPOI2.default.get()) return;
			setTimeout(function () {
				return _dispatcher2.default.dispatch("modifyPOI", poiId, _this5.getModifications(poiId));
			});
		}
	}, {
		key: "handlePOIMouseOver",
		value: function handlePOIMouseOver(evt, poiId) {
			var tooltipId = Date.now();
			_dispatcher2.default.dispatch("createTooltip", tooltipId, evt.latLng, _poi2.default.getNameOfPOI(poiId));
			google.maps.event.addListenerOnce(this.pois[poiId], 'mouseout', function (_) {
				return _dispatcher2.default.dispatch("removeTooltip", tooltipId);
			});
		}
	}, {
		key: "closeEditing",
		value: function closeEditing() {
			var editedPOIId = _editedPOI2.default.get();
			if (!editedPOIId) return;
			var modificationDoc = _poiModifications2.default.get(editedPOIId);
			if (!modificationDoc || Object.keys(modificationDoc.modifications).length == 0) {
				_dispatcher2.default.dispatch('editPOI', null);
				return;
			} else {
				_ConfirmDialog2.default.open({
					text: _lang2.default.DO_YOU_WANT_TO_SAVE_CHANGES,
					cancelable: true,
					onDiscard: function onDiscard() {
						_dispatcher2.default.dispatch("restorePOIShape", editedPOIId);
						_dispatcher2.default.dispatch("editPOI", null);
					},
					onConfirm: function onConfirm() {
						return (0, _savePOI2.default)(editedPOIId);
					}
				});
			}
		}
	}, {
		key: "getVisibilityOfPOI",
		value: function getVisibilityOfPOI(poiId) {
			var poiBounds = _poi2.default.getBoundsOfPOI(poiId);
			var mapBounds = this.map.getBounds();
			if (!poiBounds || !mapBounds) return;

			return mapBounds.intersects(poiBounds);
		}
	}, {
		key: "getLocationOfPOIShape",
		value: function getLocationOfPOIShape(poiId) {
			if (!this.pois[poiId]) return null;
			if (_poi2.default.getTypeOfPOI(poiId) == "RadialPOI") return (0, _geo.latLngToPoint)(this.pois[poiId].getCenter());else if (_poi2.default.getTypeOfPOI(poiId) == "PolygonalPOI") return mvcArrayToMultiPolygon(this.pois[poiId].getPath());
			return null;
		}
	}, {
		key: "getModifications",
		value: function getModifications(poiId) {

			if (!this.pois[poiId]) return null;

			if (_poi2.default.getTypeOfPOI(poiId) == "RadialPOI") {
				return {
					location: this.getLocationOfPOIShape(poiId),
					radius: this.pois[poiId].getRadius()
				};
			} else if (_poi2.default.getTypeOfPOI(poiId) == "PolygonalPOI") {
				return {
					location: this.getLocationOfPOIShape(poiId)
				};
			} else return null;
		}
	}, {
		key: "updateVisibilities",
		value: function updateVisibilities() {
			for (var poiId in this.pois) {
				this.pois[poiId].setVisible(this.getVisibilityOfPOI(poiId));
			}
		}
	}, {
		key: "updateFocus",
		value: function updateFocus(poiId) {
			var bounds = _poi2.default.getBoundsOfPOI(poiId);
			if (!bounds) return;

			this.map.fitBounds(bounds);
		}
	}, {
		key: "updateSelectedAndEditedPOI",
		value: function updateSelectedAndEditedPOI() {
			var editedPOIId = _editedPOI2.default.get();
			var selectedPOIId = _selectedPOI2.default.get();
			for (var poiId in this.pois) {
				var selected = poiId == selectedPOIId;
				var editable = poiId == editedPOIId;
				var draggable = editable;
				var strokeOpacity = editable || selected ? HIGHLIGHTED_STROKE_OPACITY : DEFAULT_STROKE_OPACITY;
				this.pois[poiId].setOptions({ strokeOpacity: strokeOpacity, editable: editable, draggable: draggable });
			}
			this.updateZIndexes();
		}
	}, {
		key: "updateZIndexes",
		value: function updateZIndexes() {
			for (var poiId in this.pois) {
				this.pois[poiId].setOptions({ zIndex: _zIndex2.default.POI });
			}
		}
	}, {
		key: "updateShape",
		value: function updateShape(modificationDoc) {
			if (!modificationDoc || !this.pois[modificationDoc.poi]) return;
			var type = _poi2.default.getTypeOfPOI(modificationDoc.poi);
			if (type == "RadialPOI") {
				this.pois[modificationDoc.poi].setCenter(_poi2.default.getCenterOfPOI(modificationDoc.poi));
				this.pois[modificationDoc.poi].setRadius(_poi2.default.getRadiusOfPOI(modificationDoc.poi));
			} else if (type == "PolygonalPOI") {
				this.pois[modificationDoc.poi].setPath(_poi2.default.getPathOfPOI(modificationDoc.poi));
			}
			var color = _poi2.default.getColorOfPOI(modificationDoc.poi);
			this.pois[modificationDoc.poi].setOptions({ fillColor: color, strokeColor: color });
		}
	}]);

	return POIController;
}();

exports.default = POIController;


function mvcArrayToMultiPolygon(mvcArray) {
	var first = mvcArray.getAt(0);
	return {
		type: "MultiPolygon",
		coordinates: [[[].concat(_toConsumableArray(mvcArray.getArray().map(function (latLng) {
			return [latLng.lng(), latLng.lat()];
		})), [[first.lng(), first.lat()]])]]
	};
}

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _mapTooltip = __webpack_require__(222);

var _mapTooltip2 = _interopRequireDefault(_mapTooltip);

var _zIndex = __webpack_require__(69);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _Tooltip = __webpack_require__(230);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MAX_LIFE_TIME = 10000;

var TooltipController = function () {
	function TooltipController(map) {
		_classCallCheck(this, TooltipController);

		this.map = map;
		this.setListeners();
		this.tooltip = null;
	}

	_createClass(TooltipController, [{
		key: "setListeners",
		value: function setListeners() {
			var _this = this;

			_mapTooltip2.default.on("change", function (tooltipDescriptor) {
				return _this.handleTooltipStoreChange(tooltipDescriptor);
			});
		}
	}, {
		key: "handleTooltipStoreChange",
		value: function handleTooltipStoreChange(tooltipDescriptor) {
			if (this.tooltip) {
				this.tooltip.close();
				this.tooltip = null;
			}
			if (tooltipDescriptor) {
				this.tooltip = new _Tooltip2.default({
					map: this.map,
					position: tooltipDescriptor.position,
					icon: tooltipDescriptor.icon,
					label: tooltipDescriptor.label,
					zIndex: _zIndex2.default.TOOLTIP
				});
				setTimeout(function (_) {
					return _dispatcher2.default.dispatch("removeTooltip", tooltipDescriptor.id);
				}, MAX_LIFE_TIME);
			}
		}
	}]);

	return TooltipController;
}();

exports.default = TooltipController;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

__webpack_require__(887);

var _InfoBox2 = __webpack_require__(229);

var _InfoBox3 = _interopRequireDefault(_InfoBox2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Z_INDEX = 11;
var MAX_WIDTH = 300;

/**
	@param {Object} params
		@param {google.maps.Map} params.map
		@param {google.maps.LatLng} params.position
		@param {String} params.label
		@param {Number} [params.zIndex=11]
		@param {Number} [params.maxWidth=200]
*/

var Tooltip = function (_InfoBox) {
	_inherits(Tooltip, _InfoBox);

	function Tooltip() {
		var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		_classCallCheck(this, Tooltip);

		if (!params.map) throw new Error("Missing map");

		if (!params.position) throw new Error("Missing position");

		if (!params.label) throw new Error("Missing label");

		var container = document.createElement("div");
		container.className = "Tooltip";
		if (params.icon) {
			var icon = document.createElement("i");
			icon.classList.add("mdi");
			icon.classList.add("mdi-" + params.icon);
			container.appendChild(icon);
		}
		var label = document.createElement("label");
		label.textContent = params.label;
		container.appendChild(label);

		var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, {
			position: params.position,
			content: container,
			closeBoxURL: "",
			zIndex: params.zIndex !== undefined && params.zIndex !== null ? params.zIndex : Z_INDEX,
			maxWidth: params.maxWidth || MAX_WIDTH,
			alignBottom: true,
			pixelOffset: new google.maps.Size(10, -10)
		}));

		_this.open(params.map);

		setTimeout(function () {
			return container.classList.add("Shown");
		});
		return _this;
	}

	_createClass(Tooltip, [{
		key: "close",
		value: function close() {
			var _this2 = this;

			this.getContent().classList.remove("Shown");
			setTimeout(function () {
				return _get(Tooltip.prototype.__proto__ || Object.getPrototypeOf(Tooltip.prototype), "close", _this2).call(_this2);
			}, 200);
		}
	}]);

	return Tooltip;
}(_InfoBox3.default);

exports.default = Tooltip;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _vehicleActivities = __webpack_require__(121);

var _vehicleActivities2 = _interopRequireDefault(_vehicleActivities);

var _displayedDetails = __webpack_require__(44);

var _displayedDetails2 = _interopRequireDefault(_displayedDetails);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

var _vehicleActivity = __webpack_require__(104);

var _vehicleActivity2 = _interopRequireDefault(_vehicleActivity);

var _geo = __webpack_require__(53);

var _zIndex = __webpack_require__(69);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ROUTE_START_END_MARKER = {
	zIndex: _zIndex2.default.ROUTE_START_END_MARKER,
	icon: {
		path: google.maps.SymbolPath.CIRCLE,
		scale: 4,
		fillOpacity: 1,
		fillColor: "red",
		strokeColor: "black",
		strokeOpacity: 0.5,
		strokeWeight: 2
	}
};

var HIGHLIGHTED_ROUTE_START_END_MARKER = {
	zIndex: _zIndex2.default.HIGHLIGHTED_ROUTE_START_END_MARKER,
	icon: {
		path: google.maps.SymbolPath.CIRCLE,
		scale: 4,
		fillOpacity: 1,
		fillColor: "#00ebff",
		strokeColor: "black",
		strokeOpacity: 0.5,
		strokeWeight: 2
	}
};

var ROUTE_POINTER_MARKER = {
	zIndex: _zIndex2.default.ROUTE_POINTER,
	icon: {
		path: google.maps.SymbolPath.CIRCLE,
		scale: 5,
		fillOpacity: 1,
		fillColor: "red",
		strokeColor: "red",
		strokeOpacity: 0.5,
		strokeWeight: 10
	}
};

var DEFAULT_POLY_OPTIONS = {
	strokeOpacity: 1.0,
	strokeWeight: 2,
	geodesic: true,
	zIndex: _zIndex2.default.ROUTE_DEFAULT
};

var DEFAULT_STROKE_OPTIONS = {
	strokeColor: "black",
	strokeOpacity: 0.5,
	strokeWeight: 5,
	geodesic: true,
	zIndex: _zIndex2.default.ROUTE_DEFAULT_STROKE
};

var SELECTED_POLY_OPTIONS = {
	strokeColor: "black",
	strokeOpacity: 1,
	strokeWeight: 7,
	geodesic: true,
	zIndex: _zIndex2.default.ROUTE_SECTION_SELECTED_STROKE
};

var TRANSPARENT_POLY_OPTIONS = {
	strokeOpacity: 0,
	strokeWeight: 7,
	geodesic: true,
	zIndex: _zIndex2.default.ROUTE_SECTION_TRANSPARENT
};

var HIGHLIGHTED_POLY_OPTIONS = {
	strokeColor: "#00ebff",
	strokeOpacity: 1.0,
	strokeWeight: 2,
	geodesic: true,
	zIndex: _zIndex2.default.ROUTE_SECTION_HIGHLIGHT,
	icons: [{
		icon: { path: 'M 8,0 -8,5 -8,-5 8,0 z',
			fillColor: "#00ebff",
			fillOpacity: 1,
			strokeColor: "black",
			strokeWeight: 1,
			scale: 1,
			rotation: -90 },
		repeat: "100px",
		offset: "100%"
	}]
};

var VehicleActivityController = function () {
	function VehicleActivityController(map) {
		_classCallCheck(this, VehicleActivityController);

		this.map = map;
		this.initActivities();
		this.setListeners();
	}

	_createClass(VehicleActivityController, [{
		key: "initActivities",
		value: function initActivities() {
			this.activities = this.activities || {};
		}
	}, {
		key: "setListeners",
		value: function setListeners() {
			var _this = this;

			google.maps.event.addListener(this.map, "click", function (_) {
				return _this.handleMapClick();
			});

			_vehicleActivities2.default.on("insert", function (activityDescriptors) {
				return _this.addActivities(activityDescriptors);
			});
			_vehicleActivities2.default.on("remove", function (activityDescriptors) {
				return _this.removeActivities(activityDescriptors);
			});
			_vehicleActivities2.default.on("update", function (activityDescriptor) {
				return _this.updateActivity(activityDescriptor.vehicle);
			});
			_displayedDetails2.default.on("change", function (detailsDescriptor) {
				return _this.handleDetailsStoreUpdate(detailsDescriptor);
			});
		}
	}, {
		key: "handleMapClick",
		value: function handleMapClick() {
			_dispatcher2.default.dispatch("selectVehicleActivityRoute", _displayedDetails2.default.get() ? _displayedDetails2.default.get().id : null, null, null);
		}
	}, {
		key: "handleDetailsStoreUpdate",
		value: function handleDetailsStoreUpdate(detailsDescriptor) {
			this.updateVisibilities();
			if (detailsDescriptor && _openedDetails2.default.get(detailsDescriptor.id).activePage == "activity") {
				var activityDescriptor = _vehicleActivities2.default.get(detailsDescriptor.id);
				_vehicleActivity2.default.focusOnVehicleActivity(detailsDescriptor.id);
			}
		}
	}, {
		key: "addActivities",
		value: function addActivities(activities) {
			var _this2 = this;

			activities.forEach(function (activity) {
				return _this2.addActivity(activity.vehicle);
			});
		}
	}, {
		key: "removeActivities",
		value: function removeActivities(activities) {
			var _this3 = this;

			activities.forEach(function (activity) {
				return _this3.removeActivity(activity.vehicle);
			});
		}
	}, {
		key: "addActivity",
		value: function addActivity(vehicleId) {
			this.removeActivity(vehicleId);

			window.poly = 0;

			var descriptor = _vehicleActivities2.default.get(vehicleId);
			if (!descriptor || descriptor.pending) return;

			this.activities[vehicleId] = {
				from: descriptor.from,
				to: descriptor.to,
				shapes: this.createShapes(vehicleId),
				selectedRoute: null,
				selectedPosition: null
			};

			this.updateVisibility(vehicleId);
		}
	}, {
		key: "removeActivity",
		value: function removeActivity(vehicleId) {
			var _this4 = this;

			var activity = this.activities[vehicleId];
			if (!activity) return;

			activity.shapes.forEach(function (shapeCollection) {
				return _this4.removeShapeCollection(shapeCollection);
			});

			if (activity.selectedRoute && activity.selectedRoute.polyline) {
				activity.selectedRoute.polyline.setMap(null);
			}

			delete this.activities[vehicleId];
		}
	}, {
		key: "existsActivity",
		value: function existsActivity(vehicleId) {
			return !!this.activities[vehicleId];
		}
	}, {
		key: "wasChangedActivity",
		value: function wasChangedActivity(vehicleId) {
			var descriptor = _vehicleActivities2.default.get(vehicleId);
			if (!descriptor) return false;
			if (!this.existsActivity(vehicleId)) return true;
			if (descriptor.from !== this.activities[vehicleId].from || descriptor.to !== this.activities[vehicleId].to) return true;
			return false;
		}
	}, {
		key: "updateActivity",
		value: function updateActivity(vehicleId) {
			if (this.wasChangedActivity(vehicleId)) {
				this.removeActivity(vehicleId);
				this.addActivity(vehicleId);
			}
			this.updateSelectedRoute(vehicleId);
			this.updateSelectedPosition(vehicleId);
			this.updateVisibility(vehicleId);
		}
	}, {
		key: "updateVisibilities",
		value: function updateVisibilities() {
			for (var vehicleId in this.activities) {
				this.updateVisibility(vehicleId);
			}
		}
	}, {
		key: "updateVisibility",
		value: function updateVisibility(vehicleId) {

			var activity = this.activities[vehicleId];
			var descriptor = _vehicleActivities2.default.get(vehicleId);

			if (!descriptor || !activity) {
				return;
			}

			var canBeDisplayed = _vehicleActivity2.default.getVisibilityOfActivity(vehicleId);

			if (activity.selectedRoute && activity.selectedRoute.polyline) activity.selectedRoute.polyline.setVisible(canBeDisplayed);

			(descriptor.sections || []).forEach(function (section, sectionIndex) {
				var shapeCollection = activity.shapes[sectionIndex];
				if (!shapeCollection) return;
				var pinned = descriptor.pinnedSections[sectionIndex];
				var shouldBeDisplayed = canBeDisplayed && pinned;
				var highlighted = descriptor.highlightedSections[sectionIndex];

				//route előtérbe hozása, ha érinti a selected route-ot
				if (activity.selectedRoute && section.start.time.value < activity.selectedRoute.to && section.end.time.value > activity.selectedRoute.from) {
					shapeCollection.defaultPolylines.forEach(function (e) {
						return e.setOptions({ zIndex: _zIndex2.default.ROUTE_SECTION_SELECTED });
					});
				} else if (shapeCollection.defaultPolylines[0].get("zIndex") != _zIndex2.default.ROUTE_DEFAULT) {
					shapeCollection.defaultPolylines.forEach(function (e) {
						return e.setOptions({ zIndex: _zIndex2.default.ROUTE_DEFAULT });
					});
				}

				if (shouldBeDisplayed != shapeCollection.defaultPolylines[0].getVisible()) {
					shapeCollection.defaultPolylines.forEach(function (e) {
						return e.setVisible(shouldBeDisplayed);
					});
					shapeCollection.startMarker.setVisible(shouldBeDisplayed);
					shapeCollection.endMarker.setVisible(shouldBeDisplayed);
					shapeCollection.stroke.setVisible(canBeDisplayed && (pinned || highlighted));
					shapeCollection.transparent.setVisible(shouldBeDisplayed);
				}
				if (highlighted != shapeCollection.highlighted.getVisible()) {
					var isSectionHighlightedAndPinned = canBeDisplayed && pinned && highlighted;
					shapeCollection.highlighted.setVisible(canBeDisplayed && highlighted);
					shapeCollection.highlightedStartMarker.setVisible(canBeDisplayed && highlighted);
					shapeCollection.highlightedEndMarker.setVisible(canBeDisplayed && highlighted);
					shapeCollection.stroke.setVisible(canBeDisplayed && (pinned || highlighted));
					shapeCollection.stroke.setOptions({ zIndex: isSectionHighlightedAndPinned ? _zIndex2.default.ROUTE_SECTION_HIGHLIGHTED_STROKE : _zIndex2.default.ROUTE_DEFAULT_STROKE });
				}
			});
		}
	}, {
		key: "updateSelectedRoute",
		value: function updateSelectedRoute(vehicleId) {
			var activity = this.activities[vehicleId];
			var descriptor = _vehicleActivities2.default.get(vehicleId);

			if (!activity || !descriptor) {
				return;
			}

			// ha nem változott a kezdő- és végpont,
			// akkor kilépünk
			if (activity.selectedRoute && descriptor.selectedRoute && descriptor.selectedRoute.from === activity.selectedRoute.from && descriptor.selectedRoute.to === activity.selectedRoute.to) {
				return;
			}

			this.removeSelectedRouteStroke(vehicleId);

			// ha eltávolítottuk a selectiont,
			// akkor csak kitöröljük a hozzá tartozó shape-et
			if (!descriptor.selectedRoute || descriptor.selectedRoute && descriptor.selectedRoute.from == null && descriptor.selectedRoute.to == null) {
				return;
			}

			var path = _vehicleActivity2.default.createPathFromInterval(vehicleId, descriptor.selectedRoute.from, descriptor.selectedRoute.to);

			activity.selectedRoute = {};
			activity.selectedRoute.from = descriptor.selectedRoute.from;
			activity.selectedRoute.to = descriptor.selectedRoute.to;

			if (path && path.length) {
				activity.selectedRoute.polyline = this.createSelectedRouteStroke(path);
			}
		}
	}, {
		key: "updateSelectedPosition",
		value: function updateSelectedPosition(vehicleId) {
			var descriptor = _vehicleActivities2.default.get(vehicleId);
			var activity = this.activities[vehicleId];
			if (!activity) return;

			// ha nem változott, akkor kilépünk
			if (activity.selectedPosition && descriptor.selectedPosition == activity.selectedPosition.time) {
				return;
			}

			this.removeSelectedPositionMarker(descriptor.vehicle);

			if (!descriptor.selectedPosition) {
				return;
			}

			var latLng = _vehicleActivity2.default.getLatLngOfVehicleRoutesByTime(vehicleId, descriptor.selectedPosition);

			if (latLng) {
				activity.selectedPosition = {};
				activity.selectedPosition.time = descriptor.selectedPosition;
				activity.selectedPosition.marker = this.createRoutePointerMarker(latLng);
			}
		}
	}, {
		key: "removeSelectedRouteStroke",
		value: function removeSelectedRouteStroke(vehicleId) {
			if (this.activities[vehicleId].selectedRoute && this.activities[vehicleId].selectedRoute.polyline) {
				this.activities[vehicleId].selectedRoute.polyline.setMap(null);
				delete this.activities[vehicleId].selectedRoute;
			}
		}
	}, {
		key: "removeSelectedPositionMarker",
		value: function removeSelectedPositionMarker(vehicleId) {
			if (this.activities[vehicleId].selectedPosition) {
				this.activities[vehicleId].selectedPosition.marker.setMap(null);
				delete this.activities[vehicleId].selectedPosition;
			}
		}
	}, {
		key: "createShapes",
		value: function createShapes(vehicleId) {
			var _this5 = this;

			var activity = _vehicleActivities2.default.get(vehicleId);
			if (!activity) return;

			return activity.routes.map(function (route, i) {
				if (route.length && activity.sections[i].active) {
					return _this5.createShapeCollection(vehicleId, route, i);
				} else {
					return null;
				}
			});
		}
	}, {
		key: "createShapeCollection",
		value: function createShapeCollection(vehicleId, route, index) {
			var path = route.map(_geo.positionToLatLng);

			return {
				startMarker: this.createStartEndMarker(path[0]),
				highlightedStartMarker: this.createHighlightedStartEndMarker(path[0]),
				endMarker: this.createStartEndMarker(path[path.length - 1]),
				highlightedEndMarker: this.createHighlightedStartEndMarker(path[path.length - 1]),
				defaultPolylines: this.createDefaultSectionPolylines(route),
				highlighted: this.createHighlightedSectionPolyline(path),
				stroke: this.createDefaultSectionStroke(path),
				transparent: this.createTransparentSectionPolyline(path, vehicleId, index, route[0].time, route[route.length - 1].time)
			};
		}
	}, {
		key: "removeShapeCollection",
		value: function removeShapeCollection(shapeCollection) {
			if (!shapeCollection) return;

			shapeCollection.defaultPolylines.forEach(function (e) {
				return e.setMap(null);
			});
			shapeCollection.startMarker.setMap(null);
			shapeCollection.endMarker.setMap(null);
			shapeCollection.stroke.setMap(null);
			shapeCollection.transparent.setMap(null);
			shapeCollection.highlighted.setMap(null);
		}
	}, {
		key: "createDefaultSectionPolylines",
		value: function createDefaultSectionPolylines(route) {
			var polylines = [];

			for (var i = 1; i < route.length; i++) {

				var currentColor = getColorFromSpeed(route[i].speed);
				var prevColor = getColorFromSpeed(route[i - 1].speed);

				if (i > 2 && polylines.length > 1 && currentColor == prevColor) {
					var prevPolyline = polylines[polylines.length - 1];
					var newPath = prevPolyline.getPath();
					newPath.push((0, _geo.positionToLatLng)(route[i]));
					prevPolyline.setOptions({ path: newPath });
				} else {
					var polyline = new google.maps.Polyline({
						path: [(0, _geo.positionToLatLng)(route[i - 1]), (0, _geo.positionToLatLng)(route[i])],
						map: this.map,
						strokeColor: getColorFromSpeed(route[i].speed)
					});
					polyline.setOptions(DEFAULT_POLY_OPTIONS);
					polylines.push(polyline);
				}
			}

			window.poly += polylines.length;

			return polylines;
		}
	}, {
		key: "createHighlightedSectionPolyline",
		value: function createHighlightedSectionPolyline(path) {
			var polyline = new google.maps.Polyline({
				path: path,
				map: this.map,
				visible: false
			});
			polyline.setOptions(HIGHLIGHTED_POLY_OPTIONS);
			return polyline;
		}
	}, {
		key: "createDefaultSectionStroke",
		value: function createDefaultSectionStroke(path) {
			var polyline = new google.maps.Polyline({
				path: path,
				map: this.map
			});
			polyline.setOptions(DEFAULT_STROKE_OPTIONS);
			return polyline;
		}
	}, {
		key: "handleTransparentSectionPolylineMouseover",
		value: function handleTransparentSectionPolylineMouseover(evt, vehicleId, sectionIndex) {
			_dispatcher2.default.dispatch("highlightVehicleActivitySection", vehicleId, [sectionIndex], true);

			var tooltipId = Date.now();
			var tooltipLabel = _lang2.default.SECTION + " #" + _vehicleActivity2.default.getActiveSectionNumberOfSectionIndex(vehicleId, sectionIndex);
			_dispatcher2.default.dispatch("createTooltip", tooltipId, evt.latLng, tooltipLabel);

			google.maps.event.addListenerOnce(this.activities[vehicleId].shapes[sectionIndex].transparent, "mouseout", function (_) {
				_dispatcher2.default.dispatch("removeTooltip", tooltipId);
			});
		}
	}, {
		key: "createTransparentSectionPolyline",
		value: function createTransparentSectionPolyline(path, vehicleId, sectionIndex, sectionStartTime, sectionEndTime) {
			var _this6 = this;

			var polyline = new google.maps.Polyline({
				path: path,
				map: this.map
			});
			polyline.setOptions(TRANSPARENT_POLY_OPTIONS);
			google.maps.event.addListener(polyline, "mouseover", function (evt) {
				return _this6.handleTransparentSectionPolylineMouseover(evt, vehicleId, sectionIndex);
			});
			google.maps.event.addListener(polyline, "mouseout", function (evt) {
				_dispatcher2.default.dispatch("highlightVehicleActivitySection", vehicleId, [sectionIndex], false);
			});
			google.maps.event.addListener(polyline, "click", function (evt) {
				_dispatcher2.default.dispatch("selectVehicleActivityRoute", vehicleId, sectionStartTime, sectionEndTime);
				_vehicleActivity2.default.focusOnVehicleActivity(vehicleId, sectionStartTime, sectionEndTime);
			});
			return polyline;
		}
	}, {
		key: "createStartEndMarker",
		value: function createStartEndMarker(position) {
			var marker = new google.maps.Marker({
				map: this.map,
				position: position
			});
			marker.setOptions(ROUTE_START_END_MARKER);
			return marker;
		}
	}, {
		key: "createHighlightedStartEndMarker",
		value: function createHighlightedStartEndMarker(position) {
			var marker = new google.maps.Marker({
				map: this.map,
				position: position,
				visible: false
			});
			marker.setOptions(HIGHLIGHTED_ROUTE_START_END_MARKER);
			return marker;
		}
	}, {
		key: "createRoutePointerMarker",
		value: function createRoutePointerMarker(position) {
			var marker = new google.maps.Marker({
				map: this.map,
				position: position
			});
			marker.setOptions(ROUTE_POINTER_MARKER);
			return marker;
		}
	}, {
		key: "createSelectedRouteStroke",
		value: function createSelectedRouteStroke(path) {
			var polyline = new google.maps.Polyline({
				path: path,
				map: this.map
			});
			polyline.setOptions(SELECTED_POLY_OPTIONS);
			return polyline;
		}
	}]);

	return VehicleActivityController;
}();

exports.default = VehicleActivityController;


function getColorFromSpeed(speed) {
	var lowerThresholdSpeed = 10;
	var upperThresholdSpeed = 100;

	if (speed >= upperThresholdSpeed) return "#00FF00";else if (speed <= lowerThresholdSpeed) return "#FF0000";

	var numberOfColorsByChannel = 2; //Árnyalatok száma csatornánként
	var colorDivider = Math.floor(255 / numberOfColorsByChannel);

	var medianSpeed = (lowerThresholdSpeed + upperThresholdSpeed) / 2;
	var colorStep = 255 / (medianSpeed - lowerThresholdSpeed);

	var color = { r: 255, g: 255, b: 0 };

	if (speed < medianSpeed) {
		color.g = Math.round((speed - lowerThresholdSpeed) * colorStep / colorDivider) * colorDivider;
		color.g = Math.min(Math.ceil(color.g), 255);
	} else {
		color.r = Math.round((255 - (speed - medianSpeed) * colorStep) / colorDivider) * colorDivider;
		color.r = Math.min(Math.floor(color.r), 255);
	}

	var colorHex = "#" + hexLPad(color.r.toString(16)) + hexLPad(color.g.toString(16)) + hexLPad(color.b.toString(16));
	return colorHex;
}

function hexLPad(str) {
	if (str.length < 2) {
		str = "0" + str;
	}
	return str;
}

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(888);

var _zIndex = __webpack_require__(69);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _Bubble2 = __webpack_require__(228);

var _Bubble3 = _interopRequireDefault(_Bubble2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_WIDTH = 200;

/**
	@param {Object} params
		@param {google.maps.Map} params.map
		@param {google.maps.LatLng} params.position
		@param {Boolean} params.visible
		@param {String} params.name
		@param {String} params.movingState
		@param {Boolean} params.selected
		@param {Number} [zIndex]
		@param {Function} [params.onClick=(alt => {})]
*/

var COLORS = {
	default: "white",
	onIgnition: "#FFB300",
	moving: "#8BC34A",
	selected: "#797979"
};

var VehicleBubble = function (_Bubble) {
	_inherits(VehicleBubble, _Bubble);

	function VehicleBubble(params) {
		_classCallCheck(this, VehicleBubble);

		params = params || {};

		var content = document.createElement("div");

		var _this = _possibleConstructorReturn(this, (VehicleBubble.__proto__ || Object.getPrototypeOf(VehicleBubble)).call(this, {
			map: params.map,
			position: params.position,
			content: content,
			maxWidth: MAX_WIDTH,
			zIndex: params.zIndex || _zIndex2.default.IGNITION_OFF
		}));

		_this.wrapper.classList.add("VehicleBubble");

		if (params.onClick) content.addEventListener('click', function (evt) {
			return params.onClick(evt.altKey ? true : false);
		});

		_this.createLabel(content);

		_this.lastMovingState = "";

		_this.update(params);
		return _this;
	}

	_createClass(VehicleBubble, [{
		key: "createLabel",
		value: function createLabel(parent) {
			this.label = document.createElement("label");
			parent.appendChild(this.label);
		}

		/**
  	@param {Object} params
  		@param {google.maps.LatLng} params.position
  		@param {Boolean} params.visible
  		@param {String} params.name
  		@param {String} params.movingState
  		@param {Boolean} params.selected
  		@param {Number} params.zIndex
  */

	}, {
		key: "update",
		value: function update(params) {
			if (params.position !== undefined) this.setPosition(params.position);
			if (params.visible !== undefined) this.setVisible(params.visible);
			if (params.name !== undefined) {
				this.label.textContent = params.name;
				this.refresh();
			}
			if (params.selected !== undefined || params.movingState !== undefined) {
				if (params.movingState !== undefined) this.lastMovingState = params.movingState;
				var colorMode = params.selected ? "selected" : params.movingState || this.lastMovingState;
				this.setColor(COLORS[colorMode], colorMode == "selected" ? "white" : null);
			}
			if (params.zIndex !== undefined) {
				this.setZIndex(params.zIndex);
			}
		}
	}]);

	return VehicleBubble;
}(_Bubble3.default);

exports.default = VehicleBubble;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VehicleBubble = __webpack_require__(395);

var _VehicleBubble2 = _interopRequireDefault(_VehicleBubble);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VehicleBubble2.default;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _vehicleHeatmaps = __webpack_require__(158);

var _vehicleHeatmaps2 = _interopRequireDefault(_vehicleHeatmaps);

var _displayedDetails = __webpack_require__(44);

var _displayedDetails2 = _interopRequireDefault(_displayedDetails);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

var _vehicleHeatmap = __webpack_require__(226);

var _vehicleHeatmap2 = _interopRequireDefault(_vehicleHeatmap);

var _geo = __webpack_require__(53);

var _grayscale = __webpack_require__(400);

var _grayscale2 = _interopRequireDefault(_grayscale);

var _zIndex = __webpack_require__(69);

var _zIndex2 = _interopRequireDefault(_zIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HEATMAP_POLY_OPTIONS = {
	strokeColor: "red",
	strokeWeight: 5,
	geodesic: true,
	zIndex: _zIndex2.default.ROUTE_DEFAULT
};

var HEATMAP_START_END_MARKER_ICON = {
	path: google.maps.SymbolPath.CIRCLE,
	scale: 4,
	fillColor: "red",
	strokeOpacity: 0
};

var VehicleHeatmapController = function () {
	function VehicleHeatmapController(map) {
		_classCallCheck(this, VehicleHeatmapController);

		this.map = map;
		this.setStoreListeners();
		this.initHeatmaps();
	}

	_createClass(VehicleHeatmapController, [{
		key: "initHeatmaps",
		value: function initHeatmaps() {
			this.heatmaps = this.heatmaps || {};
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this = this;

			_vehicleHeatmaps2.default.on("insert", function (heatmaps) {
				return _this.addHeatmaps(heatmaps);
			});
			_vehicleHeatmaps2.default.on("remove", function (heatmaps) {
				return _this.removeHeatmaps(heatmaps);
			});
			_vehicleHeatmaps2.default.on("update", function (heatmap) {
				return _this.updateHeatmap(heatmap);
			});
			_displayedDetails2.default.on("change", function (_) {
				return _this.updateHeatmaps();
			});
			_openedDetails2.default.on("change", function (_) {
				return _this.updateHeatmaps();
			});
		}
	}, {
		key: "addHeatmaps",
		value: function addHeatmaps(heatmaps) {
			var _this2 = this;

			heatmaps.forEach(function (heatmap) {
				return _this2.addHeatmap(heatmap);
			});
		}
	}, {
		key: "removeHeatmaps",
		value: function removeHeatmaps(heatmaps) {
			var _this3 = this;

			heatmaps.forEach(function (heatmap) {
				return _this3.removeHeatmap(heatmap.vehicle);
			});
		}
	}, {
		key: "addHeatmap",
		value: function addHeatmap(heatmap) {
			var _this4 = this;

			var vehicleId = heatmap.vehicle;
			this.removeHeatmap(vehicleId);

			var opacity = _vehicleHeatmap2.default.getHeatmapShapeOpacity(vehicleId);
			var shapes = heatmap.sections.map(function (section) {
				return _this4.createShapeCollection(section, opacity);
			});

			this.heatmaps[vehicleId] = { shapes: shapes, sections: heatmap.sections };

			this.updateVisibility(vehicleId);

			if (_vehicleHeatmap2.default.getVisibilityOfHeatmap(vehicleId)) {
				this.focusOnHeatmap(vehicleId);
			}
		}
	}, {
		key: "removeHeatmap",
		value: function removeHeatmap(vehicleId) {
			var heatmap = this.heatmaps[vehicleId];
			if (!heatmap) {
				return;
			}

			heatmap.shapes.forEach(function (shapes) {
				shapes.polyline.setMap(null);
				shapes.startMarker.setMap(null);
				shapes.endMarker.setMap(null);
			});

			delete this.heatmaps[vehicleId];
		}
	}, {
		key: "updateHeatmap",
		value: function updateHeatmap(heatmap) {
			if (heatmap.sections != this.heatmaps[heatmap.vehicle].sections) {
				this.removeHeatmap(heatmap.vehicle);
				this.addHeatmap(heatmap);
			} else {
				this.updateVisibility(heatmap.vehicle);
			}
		}
	}, {
		key: "updateHeatmaps",
		value: function updateHeatmaps() {
			this.updateMapStyle();
			this.updateVisibilities();
		}
	}, {
		key: "updateMapStyle",
		value: function updateMapStyle() {
			var displayedDetails = _displayedDetails2.default.get();
			if (!displayedDetails) {
				this.map.setOptions({ styles: null }); //default style
				return;
			}
			var detailsDescriptor = _openedDetails2.default.get(displayedDetails.id);
			if (detailsDescriptor && detailsDescriptor.activePage == "heatmap") {
				this.map.setOptions({ styles: _grayscale2.default });
			} else {
				this.map.setOptions({ styles: null }); //default style
			}
		}
	}, {
		key: "updateVisibilities",
		value: function updateVisibilities() {
			for (var vehicleId in this.heatmaps) {
				this.updateVisibility(vehicleId);
			}
		}
	}, {
		key: "updateVisibility",
		value: function updateVisibility(vehicleId) {
			var heatmapShapes = this.heatmaps[vehicleId].shapes;

			var canBeDisplayed = _vehicleHeatmap2.default.getVisibilityOfHeatmap(vehicleId);
			var descriptor = _vehicleHeatmaps2.default.get(vehicleId);

			heatmapShapes.forEach(function (shape) {
				shape.startMarker.setVisible(canBeDisplayed && descriptor && descriptor.show.stops);
				shape.endMarker.setVisible(canBeDisplayed && descriptor && descriptor.show.stops);
				shape.polyline.setVisible(canBeDisplayed && descriptor && descriptor.show.routes);
			});
		}
	}, {
		key: "focusOnHeatmap",
		value: function focusOnHeatmap(vehicleId) {
			var heatmap = _vehicleHeatmaps2.default.get(vehicleId);

			if (heatmap.sections.length == 0) {
				return;
			}

			var bounds = new google.maps.LatLngBounds();

			heatmap.sections.forEach(function (section) {
				return section.coordinates.forEach(function (coordinate) {
					var point = (0, _geo.coordinateToLatLng)(coordinate);
					bounds.extend(point);
				});
			});

			_dispatcher2.default.dispatch("setMap", { bounds: bounds.toJSON() });
		}
	}, {
		key: "createShapeCollection",
		value: function createShapeCollection(section, opacity) {
			var path = section.coordinates.map(_geo.coordinateToLatLng);
			var startPosition = (0, _geo.coordinateToLatLng)(section.coordinates[0]);
			var endPosition = (0, _geo.coordinateToLatLng)(section.coordinates[section.coordinates.length - 1]);
			return {
				polyline: this.createHeatmapPolyline(path, opacity),
				startMarker: this.createHeatmapStartEndMarker(startPosition, opacity),
				endMarker: this.createHeatmapStartEndMarker(endPosition, opacity)
			};
		}
	}, {
		key: "createHeatmapStartEndMarker",
		value: function createHeatmapStartEndMarker(position, opacity) {
			var marker = new google.maps.Marker({
				map: this.map,
				position: position
			});

			var icon = HEATMAP_START_END_MARKER_ICON;
			icon["fillOpacity"] = opacity;

			marker.setOptions({
				zIndex: _zIndex2.default.ROUTE_START_END_MARKER,
				icon: icon
			});
			return marker;
		}
	}, {
		key: "createHeatmapPolyline",
		value: function createHeatmapPolyline(path, opacity) {
			var polyline = new google.maps.Polyline({
				path: path,
				map: this.map
			});

			var polyOptions = HEATMAP_POLY_OPTIONS;
			polyOptions["strokeOpacity"] = opacity;

			polyline.setOptions(polyOptions);
			return polyline;
		}
	}]);

	return VehicleHeatmapController;
}();

exports.default = VehicleHeatmapController;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _session = __webpack_require__(30);

var _session2 = _interopRequireDefault(_session);

var _vehiclePOICrossings = __webpack_require__(89);

var _vehiclePOICrossings2 = _interopRequireDefault(_vehiclePOICrossings);

var _displayedDetails = __webpack_require__(44);

var _displayedDetails2 = _interopRequireDefault(_displayedDetails);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

var _Tooltip = __webpack_require__(230);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _zIndex = __webpack_require__(69);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _geo = __webpack_require__(53);

var _poi = __webpack_require__(46);

var _vehiclePOICrossing = __webpack_require__(105);

var _vehiclePOICrossing2 = _interopRequireDefault(_vehiclePOICrossing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FOCUS_ZOOM = 16;

var POI_CROSSING_MARKER = {
	zIndex: _zIndex2.default.POI_CROSSING_MARKER,
	icon: {
		path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
		scale: 3,
		fillOpacity: 1,
		strokeWeight: 2,
		anchor: new google.maps.Point(0, 4)
	}
};

var HIGHLIGHTED_POI_CROSSING_MARKER = {
	zIndex: _zIndex2.default.HIGHLIGHTED_POI_CROSSING_MARKER,
	icon: {
		path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
		scale: 3,
		fillOpacity: 1,
		strokeOpacity: 0.5,
		strokeWeight: 10,
		anchor: new google.maps.Point(0, 4)
	}
};

var VehiclePOICrossingsController = function () {
	function VehiclePOICrossingsController(map) {
		_classCallCheck(this, VehiclePOICrossingsController);

		this.map = map;
		this.initMarkers();
		this.setListeners();
	}

	_createClass(VehiclePOICrossingsController, [{
		key: "initMarkers",
		value: function initMarkers() {
			this.markers = {};
		}
	}, {
		key: "setListeners",
		value: function setListeners() {
			var _this = this;

			_vehiclePOICrossings2.default.on("insert", function (poiCrossingDescriptors) {
				return _this.addPOICrossings(poiCrossingDescriptors);
			});
			_vehiclePOICrossings2.default.on("remove", function (poiCrossingDescriptors) {
				poiCrossingDescriptors.forEach(function (descriptor) {
					return _this.removePOICrossingsByVehicleId(descriptor.vehicle);
				});
			});
			_vehiclePOICrossings2.default.on("update", function (poiCrossingDescriptor) {
				return _this.updatePOICrossing(poiCrossingDescriptor);
			});
			_displayedDetails2.default.on("change", function (detailsDescriptor) {
				return _this.handleDetailsStoreChange(detailsDescriptor);
			});
		}
	}, {
		key: "handleDetailsStoreChange",
		value: function handleDetailsStoreChange(detailsDescriptor) {
			this.updateVisibilities();
			if (detailsDescriptor && _openedDetails2.default.get(detailsDescriptor.id).activePage == "poiCrossings") {
				var poiCrossingsDescriptor = _vehiclePOICrossings2.default.get(detailsDescriptor.id);
			}
		}
	}, {
		key: "removePOICrossingsByVehicleId",
		value: function removePOICrossingsByVehicleId(vehicleId) {
			if (!this.markers[vehicleId]) {
				return;
			}

			for (var poiId in this.markers[vehicleId]) {
				for (var time in this.markers[vehicleId][poiId]) {
					this.markers[vehicleId][poiId][time].setMap(null);
				}
			}
		}
	}, {
		key: "addPOICrossings",
		value: function addPOICrossings(poiCrossingsDescriptors) {
			var _this2 = this;

			poiCrossingsDescriptors.forEach(function (poiCrossingDescriptor) {
				return _this2.addPOICrossing(poiCrossingDescriptor);
			});
		}
	}, {
		key: "addPOICrossing",
		value: function addPOICrossing(descriptor) {
			var _this3 = this;

			if (this.markers[descriptor.vehicle]) {
				this.removePOICrossingsByVehicleId(descriptor.vehicle);
				this.markers[descriptor.vehicle] = {};
			} else {
				this.markers[descriptor.vehicle] = {};
			}

			descriptor.result.crossings.forEach(function (crossing) {
				if (!_this3.markers[descriptor.vehicle][crossing.poi]) {
					_this3.markers[descriptor.vehicle][crossing.poi] = {};
				}
				_this3.markers[descriptor.vehicle][crossing.poi][crossing.time] = _this3.createMarker(descriptor.vehicle, crossing);
			});

			_vehiclePOICrossing2.default.focusOnVehiclePOICrossings(descriptor.vehicle);
		}
	}, {
		key: "removeHighlightedMarker",
		value: function removeHighlightedMarker() {
			if (this.highlightedMarker) {
				this.highlightedMarker.setMap(null);
				this.highlightedMarker = null;
			}
		}
	}, {
		key: "updateHighlightedPOICrossing",
		value: function updateHighlightedPOICrossing(poiCrossingDescriptor) {
			this.removeHighlightedMarker();

			if (poiCrossingDescriptor.highlightedCrossing) {
				var poiCrossing = _vehiclePOICrossing2.default.getPOICrossingByTime(poiCrossingDescriptor.vehicle, poiCrossingDescriptor.highlightedCrossing);

				if (poiCrossing) {
					this.createHighlightedMarker(poiCrossing);
				}
			}
		}
	}, {
		key: "updatePOICrossing",
		value: function updatePOICrossing(poiCrossingDescriptor) {
			if (!poiCrossingDescriptor) {
				return;
			}

			this.updateVisibility(poiCrossingDescriptor.vehicle);
			this.updateHighlightedPOICrossing(poiCrossingDescriptor);
		}
	}, {
		key: "updateVisibilities",
		value: function updateVisibilities() {
			this.removeHighlightedMarker();
			for (var vehicleId in this.markers) {
				this.updateVisibility(vehicleId);
			}
		}
	}, {
		key: "updateVisibility",
		value: function updateVisibility(vehicleId) {
			var markers = this.markers[vehicleId];
			var descriptor = _vehiclePOICrossings2.default.get(vehicleId);

			if (!descriptor) {
				return;
			}

			var canBeDisplayed = _vehiclePOICrossing2.default.getVisibilityOfPOICrossings(vehicleId);

			for (var poiId in markers) {
				var pinned = descriptor.pinnedCrossings.has(poiId);
				var shouldBeDisplayed = canBeDisplayed && pinned;

				for (var time in markers[poiId]) {
					if (shouldBeDisplayed != markers[poiId][time].getVisible()) {
						markers[poiId][time].setVisible(shouldBeDisplayed);
					}
				}
			}
		}
	}, {
		key: "createHighlightedMarker",
		value: function createHighlightedMarker(crossing) {
			this.highlightedMarker = new google.maps.Marker({
				map: this.map,
				position: (0, _geo.pointToLatLng)(crossing.location)
			});

			var options = HIGHLIGHTED_POI_CROSSING_MARKER;
			options.icon.fillColor = (0, _poi.getColorOfPOI)(crossing.poi);
			options.icon.strokeColor = (0, _poi.getColorOfPOI)(crossing.poi);
			options.icon.rotation = crossing.heading;

			this.highlightedMarker.setOptions(options);
		}
	}, {
		key: "handleEventmarkerMouseover",
		value: function handleEventmarkerMouseover(vehicleId, crossing) {
			_dispatcher2.default.dispatch("highlightVehiclePOICrossing", vehicleId, crossing.time);

			var tooltipId = Date.now();
			var position = (0, _geo.pointToLatLng)(crossing.location);
			var icon = crossing.inside ? "login" : "logout";
			var label = new Date(crossing.time).toLocaleString();
			_dispatcher2.default.dispatch("createTooltip", tooltipId, position, label, icon);

			google.maps.event.addListenerOnce(this.highlightedMarker, "mouseout", function (_) {
				_dispatcher2.default.dispatch("removeTooltip", tooltipId);
				_dispatcher2.default.dispatch("unhighlightVehiclePOICrossing", vehicleId);
			});
		}
	}, {
		key: "createMarker",
		value: function createMarker(vehicleId, crossing) {
			var _this4 = this;

			var dateString = new Date(crossing.time).toLocaleDateString();

			var marker = new google.maps.Marker({
				map: this.map,
				position: (0, _geo.pointToLatLng)(crossing.location)
			});

			var options = POI_CROSSING_MARKER;
			options.icon.fillColor = (0, _poi.getColorOfPOI)(crossing.poi);
			options.icon.strokeOpacity = 0;
			options.icon.rotation = crossing.heading;

			marker.setOptions(options);

			google.maps.event.addListener(marker, "mouseover", function (evt) {
				return _this4.handleEventmarkerMouseover(vehicleId, crossing);
			});

			return marker;
		}
	}]);

	return VehiclePOICrossingsController;
}();

exports.default = VehiclePOICrossingsController;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Map = __webpack_require__(389);

var _Map2 = _interopRequireDefault(_Map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Map2.default;

/***/ },
/* 400 */
/***/ function(module, exports) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var grayscale = [{
    "featureType": "landscape",
    "stylers": [{
        "saturation": -100
    }, {
        "lightness": 65
    }, {
        "visibility": "on"
    }]
}, {
    "featureType": "poi",
    "stylers": [{
        "saturation": -100
    }, {
        "lightness": 51
    }, {
        "visibility": "simplified"
    }]
}, {
    "featureType": "road.highway",
    "stylers": [{
        "saturation": -100
    }, {
        "visibility": "simplified"
    }]
}, {
    "featureType": "road.arterial",
    "stylers": [{
        "saturation": -100
    }, {
        "lightness": 30
    }, {
        "visibility": "on"
    }]
}, {
    "featureType": "road.local",
    "stylers": [{
        "saturation": -100
    }, {
        "lightness": 40
    }, {
        "visibility": "on"
    }]
}, {
    "featureType": "transit",
    "stylers": [{
        "saturation": -100
    }, {
        "visibility": "simplified"
    }]
}, {
    "featureType": "administrative.province",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "water",
    "elementType": "labels",
    "stylers": [{
        "visibility": "on"
    }, {
        "lightness": -25
    }, {
        "saturation": -100
    }]
}, {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [{
        "hue": "#ffff00"
    }, {
        "lightness": -25
    }, {
        "saturation": -97
    }]
}];

exports.default = grayscale;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(889);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Select = __webpack_require__(74);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CollaboratorCard = function (_React$Component) {
	_inherits(CollaboratorCard, _React$Component);

	function CollaboratorCard() {
		_classCallCheck(this, CollaboratorCard);

		return _possibleConstructorReturn(this, (CollaboratorCard.__proto__ || Object.getPrototypeOf(CollaboratorCard)).apply(this, arguments));
	}

	_createClass(CollaboratorCard, [{
		key: "render",
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_Card2.default,
				{ className: "CollaboratorCard" },
				_react2.default.createElement(
					"header",
					null,
					_react2.default.createElement(
						"div",
						{ id: "nameContainer" },
						_react2.default.createElement(
							"h1",
							null,
							this.props.name
						),
						_react2.default.createElement(
							"h2",
							null,
							this.props.isGroup ? _lang2.default._GROUP : ""
						)
					),
					_react2.default.createElement(_Button2.default, {
						icon: "close",
						className: this.props.canClear ? "" : "Hidden",
						onClick: function onClick(_) {
							return _this2.props.onClear();
						}
					})
				),
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(
						_Select2.default,
						{
							disabled: !this.props.canChange,
							value: this.props.privilege,
							onChange: function onChange(evt) {
								return _this2.props.onChange(parseInt(evt.target.value));
							}
						},
						_react2.default.createElement(
							"option",
							{ value: 1 },
							_lang2.default.CAN_VIEW
						),
						_react2.default.createElement(
							"option",
							{ value: 2 },
							_lang2.default.CAN_EDIT
						),
						_react2.default.createElement(
							"option",
							{ value: 3 },
							_lang2.default.CAN_SHARE
						),
						_react2.default.createElement(
							"option",
							{ value: 4 },
							_lang2.default.CAN_DELETE
						)
					)
				)
			);
		}
	}]);

	return CollaboratorCard;
}(_react2.default.Component);

exports.default = CollaboratorCard;


CollaboratorCard.propTypes = {
	name: _react2.default.PropTypes.string,
	privilege: _react2.default.PropTypes.number,
	isGroup: _react2.default.PropTypes.bool,
	canClear: _react2.default.PropTypes.bool,
	canChange: _react2.default.PropTypes.bool,
	onClear: _react2.default.PropTypes.func,
	onChange: _react2.default.PropTypes.func
};

CollaboratorCard.defaultProps = {
	name: "",
	privilege: 0,
	isGroup: false,
	canClear: false,
	canChange: false,
	onClear: function onClear() {},
	onChange: function onChange(privilege) {}
};

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CollaboratorCard = __webpack_require__(401);

var _CollaboratorCard2 = _interopRequireDefault(_CollaboratorCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CollaboratorCard2.default;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(890);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _poiCollaborations = __webpack_require__(155);

var _poiCollaborations2 = _interopRequireDefault(_poiCollaborations);

var _users = __webpack_require__(370);

var _users2 = _interopRequireDefault(_users);

var _poi = __webpack_require__(46);

var _getPOICollaborations2 = __webpack_require__(151);

var _getPOICollaborations3 = _interopRequireDefault(_getPOICollaborations2);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _api = __webpack_require__(16);

var _api2 = _interopRequireDefault(_api);

var _ProgressBar = __webpack_require__(34);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _EEP = __webpack_require__(33);

var _EEP2 = _interopRequireDefault(_EEP);

var _CollaboratorCard = __webpack_require__(402);

var _CollaboratorCard2 = _interopRequireDefault(_CollaboratorCard);

var _ShareDialog = __webpack_require__(405);

var _ShareDialog2 = _interopRequireDefault(_ShareDialog);

var _Dialog = __webpack_require__(73);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _addPOICollaboration = __webpack_require__(350);

var _addPOICollaboration2 = _interopRequireDefault(_addPOICollaboration);

var _clearPOICollaboration = __webpack_require__(352);

var _clearPOICollaboration2 = _interopRequireDefault(_clearPOICollaboration);

var _updatePOICollaboration = __webpack_require__(366);

var _updatePOICollaboration2 = _interopRequireDefault(_updatePOICollaboration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POICollaborators = function (_React$Component) {
	_inherits(POICollaborators, _React$Component);

	function POICollaborators(props) {
		_classCallCheck(this, POICollaborators);

		var _this = _possibleConstructorReturn(this, (POICollaborators.__proto__ || Object.getPrototypeOf(POICollaborators)).call(this, props));

		_this.initState();
		_this.eep = new _EEP2.default();
		_this.setStoreListeners();
		return _this;
	}

	_createClass(POICollaborators, [{
		key: "initState",
		value: function initState() {
			this.state = {
				inProgress: false,
				displayButton: true,
				collaborations: this.getCollaborationsFromStore(),
				users: _users2.default.getAll(),
				inShare: false
			};
		}
	}, {
		key: "getCollaborationsFromStore",
		value: function getCollaborationsFromStore() {
			return _poiCollaborations2.default.get(this.props.poiId).getAll() || [];
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			this.eep.on(_poiCollaborations2.default.get(this.props.poiId), 'change', function (collaborations) {
				_this2.setState({ collaborations: collaborations });
			});
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			this.createScrollHandler();
			this.getPOICollaborations();
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			this.eep.close();
		}
	}, {
		key: "createScrollHandler",
		value: function createScrollHandler() {
			var _this3 = this;

			var lastScrollTop = 0;

			this.handleScroll = function () {
				if (_this3.refs.content.scrollTop <= 30) {
					_this3.setState({ displayButton: true });
				} else {
					if (_this3.refs.content.scrollTop > lastScrollTop) _this3.setState({ displayButton: false });else _this3.setState({ displayButton: true });
				}
				lastScrollTop = _this3.refs.content.scrollTop;
			};
		}
	}, {
		key: "getPOICollaborations",
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								this.setState({ inProgress: true });
								_context.next = 3;
								return (0, _getPOICollaborations3.default)(this.props.poiId);

							case 3:
								this.setState({ inProgress: false });

							case 4:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function getPOICollaborations() {
				return _ref.apply(this, arguments);
			}

			return getPOICollaborations;
		}()
	}, {
		key: "updateCollaboration",
		value: function () {
			var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(collaboratorId, privilege) {
				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								this.setState({ inProgress: true });
								_context2.next = 3;
								return (0, _updatePOICollaboration2.default)(this.props.poiId, collaboratorId, privilege);

							case 3:
								this.setState({ inProgress: false });

							case 4:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, this);
			}));

			function updateCollaboration(_x, _x2) {
				return _ref2.apply(this, arguments);
			}

			return updateCollaboration;
		}()
	}, {
		key: "clearCollaboration",
		value: function () {
			var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(collaboratorId) {
				return regeneratorRuntime.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								this.setState({ inProgress: true });
								_context3.next = 3;
								return (0, _clearPOICollaboration2.default)(this.props.poiId, collaboratorId);

							case 3:
								this.setState({ inProgress: false });

							case 4:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, this);
			}));

			function clearCollaboration(_x3) {
				return _ref3.apply(this, arguments);
			}

			return clearCollaboration;
		}()
	}, {
		key: "addCollaboration",
		value: function () {
			var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(collaboration) {
				var result;
				return regeneratorRuntime.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								this.setState({ inProgress: true });
								_context4.next = 3;
								return (0, _addPOICollaboration2.default)(this.props.poiId, collaboration);

							case 3:
								result = _context4.sent;

								if (result === true) this.setState({ inShare: false });
								this.setState({ inProgress: false });

							case 6:
							case "end":
								return _context4.stop();
						}
					}
				}, _callee4, this);
			}));

			function addCollaboration(_x4) {
				return _ref4.apply(this, arguments);
			}

			return addCollaboration;
		}()
	}, {
		key: "getPossibleCollaborators",
		value: function getPossibleCollaborators() {
			var _this4 = this;

			if (!this.state.users) return [];

			return this.state.users.filter(function (user) {
				if (!_this4.state.collaborations) return true;
				return !_this4.state.collaborations.find(function (c) {
					return c.collaborator == user._id;
				});
			}).map(function (user) {
				return {
					id: user._id,
					name: getNameOfUser(user._id),
					isGroup: getTypeOfUser(user._id) == "UserGroup"
				};
			});
		}
	}, {
		key: "isButtonHidden",
		value: function isButtonHidden() {
			return !this.state.displayButton;
		}
	}, {
		key: "isButtonDisabled",
		value: function isButtonDisabled() {
			return (0, _poi.getPrivilegeOfPOI)(this.props.poiId) < 3 || this.getPossibleCollaborators().length == 0;
		}
	}, {
		key: "renderCard",
		value: function renderCard(collaboration) {
			var _this5 = this;

			return _react2.default.createElement(_CollaboratorCard2.default, {
				key: collaboration.collaborator,
				name: getNameOfUser(collaboration.collaborator),
				privilege: collaboration.privilege,
				isGroup: getTypeOfUser(collaboration.collaborator) == "UserGroup",
				onChange: function onChange(privilege) {
					return _this5.updateCollaboration(collaboration.collaborator, privilege);
				},
				onClear: function onClear() {
					return _this5.clearCollaboration(collaboration.collaborator);
				},
				canClear: canChangeCollaboration(this.props.poiId, collaboration),
				canChange: canChangeCollaboration(this.props.poiId, collaboration)
			});
		}
	}, {
		key: "renderCards",
		value: function renderCards() {
			return this.state.collaborations ? this.state.collaborations.map(this.renderCard.bind(this)) : null;
		}
	}, {
		key: "render",
		value: function render() {
			var _this6 = this;

			return _react2.default.createElement(
				"div",
				{ className: "POICollaborators" },
				_react2.default.createElement(_Button2.default, {
					icon: "account-plus",
					className: (0, _classnames2.default)("Floating", "Red", { "Hidden": this.isButtonHidden() }),
					title: _lang2.default.ADD_COLLABORATOR,
					disabled: this.isButtonDisabled(),
					onClick: function onClick(_) {
						return _this6.setState({ inShare: true });
					}
				}),
				_react2.default.createElement(_ProgressBar2.default, {
					indeterminate: true,
					shown: this.state.inProgress
				}),
				_react2.default.createElement(
					"div",
					{
						ref: "content",
						onScroll: function onScroll() {
							return _this6.handleScroll();
						},
						className: (0, _classnames2.default)("Content", { "Hidden": this.state.inProgress })
					},
					this.renderCards()
				),
				_react2.default.createElement(_ShareDialog2.default, {
					shown: this.state.inShare,
					maxPrivilege: (0, _poi.getPrivilegeOfPOI)(this.props.poiId),
					possibleCollaborators: this.getPossibleCollaborators(this.props.poiId),
					onCancel: function onCancel() {
						return _this6.setState({ inShare: false });
					},
					onShare: function onShare(collaboration) {
						return _this6.addCollaboration(collaboration);
					}
				})
			);
		}
	}]);

	return POICollaborators;
}(_react2.default.Component);

exports.default = POICollaborators;


POICollaborators.propTypes = {
	poiId: _react2.default.PropTypes.string
};

POICollaborators.defaultProps = {
	poiId: null
};

function getNameOfUser(userId) {
	var collaborator = _users2.default.get(userId);
	if (!collaborator) return _lang2.default.UNKNOWN;

	if (collaborator.type == "UserGroup") return collaborator.name;else if (collaborator.type == "User") return collaborator.firstName + " " + collaborator.lastName;

	return _lang2.default.UNKNOWN;
}

function getTypeOfUser(userId) {
	var collaborator = _users2.default.get(userId);
	if (!collaborator) return null;
	return collaborator.type || null;
}

function canChangeCollaboration(poiId, collaboration) {
	var myPrivilege = (0, _poi.getPrivilegeOfPOI)(poiId);
	if (isItTheLastOwner(poiId, collaboration)) return false;
	if (myPrivilege == 4) return true;
	if (myPrivilege == 3 && collaboration.privilege < 4) return true;
	return false;
}

function isItTheLastOwner(poiId, collaboration) {
	var collaborations = _poiCollaborations2.default.get(poiId).getAll();
	if (!collaborations) return false;

	var ownerships = collaborations.filter(function (c) {
		return c.privilege == 4;
	});
	if (collaboration.privilege == 4 && ownerships.length == 1) return true;else return false;
}

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(891);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Form = __webpack_require__(38);

var _Form2 = _interopRequireDefault(_Form);

var _Dialog = __webpack_require__(73);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Select = __webpack_require__(74);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShareDialog = function (_React$Component) {
	_inherits(ShareDialog, _React$Component);

	function ShareDialog() {
		_classCallCheck(this, ShareDialog);

		return _possibleConstructorReturn(this, (ShareDialog.__proto__ || Object.getPrototypeOf(ShareDialog)).apply(this, arguments));
	}

	_createClass(ShareDialog, [{
		key: "getCollaboration",
		value: function getCollaboration() {
			return {
				collaborator: _reactDom2.default.findDOMNode(this.refs.collaborator).value,
				privilege: parseInt(_reactDom2.default.findDOMNode(this.refs.privilege).value)
			};
		}
	}, {
		key: "renderUserOption",
		value: function renderUserOption(possibleCollaborator) {
			return _react2.default.createElement(
				"option",
				{
					key: possibleCollaborator.id,
					value: possibleCollaborator.id
				},
				"" + possibleCollaborator.name + (possibleCollaborator.isGroup ? " (group)" : "")
			);
		}
	}, {
		key: "renderUserOptions",
		value: function renderUserOptions() {
			if (!this.props.possibleCollaborators) return;

			return this.props.possibleCollaborators.map(this.renderUserOption.bind(this));
		}
	}, {
		key: "renderPrivilegeOptions",
		value: function renderPrivilegeOptions() {
			var _this2 = this;

			var privileges = [{ value: 1, text: _lang2.default.CAN_VIEW }, { value: 2, text: _lang2.default.CAN_EDIT }, { value: 3, text: _lang2.default.CAN_SHARE }, { value: 4, text: _lang2.default.CAN_DELETE }];

			return privileges.map(function (privilege) {
				return _react2.default.createElement(
					"option",
					{
						key: privilege.value,
						value: privilege.value,
						disabled: privilege.value > _this2.props.maxPrivilege
					},
					privilege.text
				);
			});
		}
	}, {
		key: "render",
		value: function render() {
			var _this3 = this;

			return _react2.default.createElement(
				_Dialog2.default,
				{ shown: this.props.shown, className: "ShareDialog" },
				_react2.default.createElement(
					"header",
					null,
					_react2.default.createElement(
						"h1",
						null,
						_lang2.default.SHARE_POI
					)
				),
				_react2.default.createElement(
					_Form2.default,
					null,
					_react2.default.createElement(
						"label",
						null,
						_lang2.default.COLLABORATOR
					),
					_react2.default.createElement(
						_Select2.default,
						{ ref: "collaborator" },
						this.renderUserOptions()
					),
					_react2.default.createElement(
						"label",
						null,
						_lang2.default.PRIVILEGE
					),
					_react2.default.createElement(
						_Select2.default,
						{ ref: "privilege" },
						this.renderPrivilegeOptions()
					)
				),
				_react2.default.createElement(
					"footer",
					null,
					_react2.default.createElement(
						_Button2.default,
						{ onClick: function onClick() {
								return _this3.props.onCancel();
							} },
						_lang2.default.CANCEL
					),
					_react2.default.createElement(
						_Button2.default,
						{ onClick: function onClick() {
								return _this3.props.onShare(_this3.getCollaboration());
							}, className: "Red" },
						_lang2.default.SHARE
					)
				)
			);
		}
	}]);

	return ShareDialog;
}(_react2.default.Component);

exports.default = ShareDialog;


ShareDialog.propTypes = {
	shown: _react2.default.PropTypes.bool,
	maxPrivilege: _react2.default.PropTypes.number,
	onCancel: _react2.default.PropTypes.func,
	onShare: _react2.default.PropTypes.func,
	possibleCollaborators: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
		id: _react2.default.PropTypes.string,
		name: _react2.default.PropTypes.string,
		isGroup: _react2.default.PropTypes.bool
	}))
};

ShareDialog.defaultProps = {
	shown: false,
	maxPrivilege: 4,
	onCancel: function onCancel() {},
	onShare: function onShare(collaboration) {}
};

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ShareDialog = __webpack_require__(404);

var _ShareDialog2 = _interopRequireDefault(_ShareDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ShareDialog2.default;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _POICollaborators = __webpack_require__(403);

var _POICollaborators2 = _interopRequireDefault(_POICollaborators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _POICollaborators2.default;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Dialog = __webpack_require__(73);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Select = __webpack_require__(74);

var _Select2 = _interopRequireDefault(_Select);

var _Form = __webpack_require__(38);

var _Form2 = _interopRequireDefault(_Form);

var _MultiSelector = __webpack_require__(102);

var _MultiSelector2 = _interopRequireDefault(_MultiSelector);

var _Checkbox = __webpack_require__(66);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _notification = __webpack_require__(90);

var _POICrossingNotificationConfigForm = __webpack_require__(231);

var _POICrossingNotificationConfigForm2 = _interopRequireDefault(_POICrossingNotificationConfigForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddDialog = function (_React$Component) {
	_inherits(AddDialog, _React$Component);

	function AddDialog(props) {
		_classCallCheck(this, AddDialog);

		var _this = _possibleConstructorReturn(this, (AddDialog.__proto__ || Object.getPrototypeOf(AddDialog)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(AddDialog, [{
		key: "initState",
		value: function initState() {
			this.state = {
				eventDescriptor: null,
				notificationConfig: null
			};
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			this.setState({
				eventDescriptor: this.refs.poiCrossingNotificationConfigForm.getEventDescriptor(),
				notificationConfig: this.refs.poiCrossingNotificationConfigForm.getNotificationConfig()
			});
		}
	}, {
		key: "clear",
		value: function clear() {
			this.refs.poiCrossingNotificationConfigForm.clear();
		}
	}, {
		key: "handleCancel",
		value: function handleCancel() {
			this.refs.poiCrossingNotificationConfigForm.clear();
			this.props.onCancel();
		}
	}, {
		key: "getSaveButtonDisabled",
		value: function getSaveButtonDisabled() {
			return !(0, _notification.isValidNotificationConfig)(this.state.notificationConfig) || !(0, _notification.isValidEventDescriptor)(this.state.eventDescriptor);
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_Dialog2.default,
				{ shown: this.props.shown, className: "AddDialog" },
				_react2.default.createElement(
					"header",
					null,
					_react2.default.createElement(
						"h1",
						null,
						_lang2.default.SET_NOTIFICATION
					)
				),
				_react2.default.createElement(_POICrossingNotificationConfigForm2.default, {
					ref: "poiCrossingNotificationConfigForm",
					pois: this.props.pois,
					vehicles: this.props.vehicles,
					onChange: function onChange(eventDescriptor, notificationConfig) {
						return _this2.setState({ eventDescriptor: eventDescriptor, notificationConfig: notificationConfig });
					}
				}),
				_react2.default.createElement(
					"footer",
					null,
					_react2.default.createElement(
						_Button2.default,
						{ onClick: function onClick() {
								return _this2.handleCancel();
							} },
						_lang2.default.CANCEL
					),
					_react2.default.createElement(
						_Button2.default,
						{ disabled: this.getSaveButtonDisabled(), onClick: function onClick() {
								return _this2.props.onAdd(_this2.state.eventDescriptor, _this2.state.notificationConfig);
							}, className: "Red" },
						_lang2.default.SAVE
					)
				)
			);
		}
	}]);

	return AddDialog;
}(_react2.default.Component);

exports.default = AddDialog;


AddDialog.propTypes = {
	shown: _react2.default.PropTypes.bool,
	onCancel: _react2.default.PropTypes.func,
	onAdd: _react2.default.PropTypes.func,
	pois: _react2.default.PropTypes.array,
	vehicles: _react2.default.PropTypes.array
};

AddDialog.defaultProps = {
	shown: false,
	onCancel: function onCancel() {},
	onAdd: function onAdd(eventDescriptor, notificationConfig) {},
	pois: [],
	vehicles: []
};

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AddDialog = __webpack_require__(407);

var _AddDialog2 = _interopRequireDefault(_AddDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AddDialog2.default;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(892);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _notification = __webpack_require__(90);

var _POICrossingNotificationConfigForm = __webpack_require__(231);

var _POICrossingNotificationConfigForm2 = _interopRequireDefault(_POICrossingNotificationConfigForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotificationConfigCard = function (_React$Component) {
	_inherits(NotificationConfigCard, _React$Component);

	function NotificationConfigCard(props) {
		_classCallCheck(this, NotificationConfigCard);

		var _this = _possibleConstructorReturn(this, (NotificationConfigCard.__proto__ || Object.getPrototypeOf(NotificationConfigCard)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(NotificationConfigCard, [{
		key: "initState",
		value: function initState() {
			this.state = { //fromban megváltozott, de az api felé nem kiküldött adatok
				eventDescriptor: null,
				notificationConfig: null
			};
		}
	}, {
		key: "handleChange",
		value: function handleChange(eventDescriptor, notificationConfig) {
			var _this2 = this;

			this.setState({
				eventDescriptor: eventDescriptor,
				notificationConfig: notificationConfig
			}, function (_) {
				if (_this2.getSaveButtonDisabled()) {
					new _Toast2.default(_lang2.default.INVALID_CONFIGURATION, "orange");
				}
			});
		}
	}, {
		key: "save",
		value: function save() {
			this.props.onSave(this.state.eventDescriptor, this.state.notificationConfig);
			this.setState({
				eventDescriptor: null,
				notificationConfig: null
			});
		}
	}, {
		key: "getSaveButtonDisabled",
		value: function getSaveButtonDisabled() {
			return !(0, _notification.isValidEventDescriptor)(this.state.eventDescriptor) || !(0, _notification.isValidNotificationConfig)(this.state.notificationConfig);
		}
	}, {
		key: "render",
		value: function render() {
			var _this3 = this;

			return _react2.default.createElement(
				_Card2.default,
				{ className: "NotificationConfigCard" },
				_react2.default.createElement(
					"header",
					null,
					_react2.default.createElement(_Button2.default, {
						icon: "close",
						onClick: function onClick(_) {
							return _this3.props.onRemove();
						}
					}),
					_react2.default.createElement(_Button2.default, {
						icon: "check",
						disabled: this.getSaveButtonDisabled(),
						onClick: function onClick(_) {
							return _this3.save();
						}
					})
				),
				_react2.default.createElement(_POICrossingNotificationConfigForm2.default, {
					pois: this.props.pois,
					vehicles: this.props.vehicles,
					onChange: function onChange(eventDescriptor, notificationConfig) {
						return _this3.handleChange(eventDescriptor, notificationConfig);
					},
					notificationConfig: this.props.notificationConfig
				})
			);
		}
	}]);

	return NotificationConfigCard;
}(_react2.default.Component);

exports.default = NotificationConfigCard;


NotificationConfigCard.propTypes = {
	onSave: _react2.default.PropTypes.func,
	onRemove: _react2.default.PropTypes.func,
	pois: _react2.default.PropTypes.array,
	vehicles: _react2.default.PropTypes.array,
	notificationConfig: _react2.default.PropTypes.object,
	eventDescriptor: _react2.default.PropTypes.object
};

NotificationConfigCard.defaultProps = {
	onSave: function onSave(eventDescriptor, notificationConfig) {},
	onRemove: function onRemove() {},
	pois: [],
	vehicles: [],
	notificationConfig: null,
	eventDescriptor: null
};

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NotificationConfigCard = __webpack_require__(409);

var _NotificationConfigCard2 = _interopRequireDefault(_NotificationConfigCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NotificationConfigCard2.default;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(893);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Form = __webpack_require__(38);

var _Form2 = _interopRequireDefault(_Form);

var _MultiSelector = __webpack_require__(102);

var _MultiSelector2 = _interopRequireDefault(_MultiSelector);

var _Checkbox = __webpack_require__(66);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _getModificationsByRef = __webpack_require__(101);

var _getModificationsByRef2 = _interopRequireDefault(_getModificationsByRef);

var _user = __webpack_require__(20);

var _notification = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POICrossingNotificationConfigForm = function (_React$Component) {
	_inherits(POICrossingNotificationConfigForm, _React$Component);

	function POICrossingNotificationConfigForm(props) {
		_classCallCheck(this, POICrossingNotificationConfigForm);

		var _this = _possibleConstructorReturn(this, (POICrossingNotificationConfigForm.__proto__ || Object.getPrototypeOf(POICrossingNotificationConfigForm)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(POICrossingNotificationConfigForm, [{
		key: "initState",
		value: function initState() {
			this.state = this.getDefaultState();
		}
	}, {
		key: "componentDidUpdate",
		value: function componentDidUpdate(_, prevState) {
			if (!!(0, _getModificationsByRef2.default)(prevState, this.state)) {
				this.props.onChange(this.getEventDescriptor(), this.getNotificationConfig());
			}
		}
	}, {
		key: "clear",
		value: function clear() {
			this.setState(this.getDefaultState());
			this.refs.poiSelector.clear();
			this.refs.vehicleSelector.clear();
		}
	}, {
		key: "getDefaultPOIsFromAssignmentDescriptor",
		value: function getDefaultPOIsFromAssignmentDescriptor(assignmentDescriptor) {
			if (assignmentDescriptor.user) {
				return null;
			} else {
				return assignmentDescriptor.pois;
			}
		}
	}, {
		key: "getDefaultVehiclesFromAssignmentDescriptor",
		value: function getDefaultVehiclesFromAssignmentDescriptor(assignmentDescriptor) {
			if (assignmentDescriptor.user) {
				return null;
			} else {
				return assignmentDescriptor.carriers;
			}
		}
	}, {
		key: "getDefaultState",
		value: function getDefaultState() {
			var eventDescriptor = (0, _notification.getEventDescriptorFromNotificationConfig)(this.props.notificationConfig);

			return {
				pois: this.props.notificationConfig ? this.getDefaultPOIsFromAssignmentDescriptor(eventDescriptor.pois) : null,
				vehicles: this.props.notificationConfig ? this.getDefaultVehiclesFromAssignmentDescriptor(eventDescriptor.carriers) : null,
				arriving: this.props.notificationConfig ? eventDescriptor.arriving : true,
				departing: this.props.notificationConfig ? eventDescriptor.departing : true,
				web: this.props.notificationConfig ? this.props.notificationConfig.web : true,
				email: this.props.notificationConfig ? this.props.notificationConfig.email : false,
				sms: this.props.notificationConfig ? this.props.notificationConfig.sms : false
			};
		}
	}, {
		key: "getPOIOptions",
		value: function getPOIOptions() {
			if (this.props.pois) {
				return this.props.pois.map(function (poi) {
					return {
						value: poi._id,
						label: poi.name
					};
				});
			} else {
				return [];
			}
		}
	}, {
		key: "getVehicleOptions",
		value: function getVehicleOptions() {
			if (this.props.vehicles) {
				return this.props.vehicles.map(function (vehicle) {
					return {
						value: vehicle._id,
						label: vehicle.name
					};
				});
			} else {
				return [];
			}
		}
	}, {
		key: "getVehiclesAssignmentDescriptor",
		value: function getVehiclesAssignmentDescriptor() {
			return {
				user: this.state.vehicles ? null : (0, _user.getUserId)(),
				type: "CarrierAssignmentDescriptor",
				carriers: this.state.vehicles ? this.state.vehicles : null
			};
		}
	}, {
		key: "getPOIsAssignmentDescriptor",
		value: function getPOIsAssignmentDescriptor() {
			return {
				user: this.state.pois ? null : (0, _user.getUserId)(),
				type: "POIAssignmentDescriptor",
				pois: this.state.pois ? this.state.pois : null
			};
		}
	}, {
		key: "getEventDescriptor",
		value: function getEventDescriptor() {
			var eventDescriptor = {
				carriers: this.getVehiclesAssignmentDescriptor(),
				pois: this.getPOIsAssignmentDescriptor(),
				arriving: this.state.arriving,
				departing: this.state.departing,
				type: "POICrossingDescriptor"
			};

			if (this.props.notificationConfig) {
				eventDescriptor = Object.assign(eventDescriptor, { _id: this.props.notificationConfig.descriptor });
			}

			return eventDescriptor;
		}
	}, {
		key: "getNotificationConfig",
		value: function getNotificationConfig() {
			return {
				web: this.state.web,
				email: this.state.email,
				sms: this.state.sms
			};
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_Form2.default,
				{ className: "POICrossingNotificationConfigForm" },
				_react2.default.createElement(_MultiSelector2.default, {
					title: _lang2.default.POIS,
					ref: "poiSelector",
					options: this.getPOIOptions(),
					onChange: function onChange(pois, all) {
						return _this2.setState({ pois: all ? null : pois });
					},
					defaultValue: this.state.pois
				}),
				_react2.default.createElement(_MultiSelector2.default, {
					title: _lang2.default.VEHICLES,
					ref: "vehicleSelector",
					options: this.getVehicleOptions(),
					onChange: function onChange(vehicles, all) {
						return _this2.setState({ vehicles: all ? null : vehicles });
					},
					defaultValue: this.state.vehicles
				}),
				_react2.default.createElement(
					"div",
					{ className: "CheckboxContainer" },
					_react2.default.createElement(
						"label",
						{ className: "Title" },
						_lang2.default.SEND_NOTIFICATIONS_AT
					),
					_react2.default.createElement(_Checkbox2.default, {
						checked: this.state.arriving,
						onChange: function onChange(value) {
							return _this2.setState({ arriving: value });
						}
					}),
					_react2.default.createElement(
						"label",
						null,
						_lang2.default.ARRIVING
					),
					_react2.default.createElement(_Checkbox2.default, {
						checked: this.state.departing,
						onChange: function onChange(value) {
							return _this2.setState({ departing: value });
						}
					}),
					_react2.default.createElement(
						"label",
						null,
						_lang2.default.DEPARTING
					)
				),
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(
						"label",
						{ className: "Title" },
						_lang2.default.SEND_NOTIFICATIONS_VIA
					),
					_react2.default.createElement(
						"div",
						{ className: "CheckboxContainer" },
						_react2.default.createElement(_Checkbox2.default, {
							checked: this.state.web,
							onChange: function onChange(value) {
								return _this2.setState({ web: value });
							}
						}),
						_react2.default.createElement(
							"label",
							null,
							_lang2.default.WEB
						),
						_react2.default.createElement(_Checkbox2.default, {
							checked: this.state.email,
							onChange: function onChange(value) {
								return _this2.setState({ email: value });
							}
						}),
						_react2.default.createElement(
							"label",
							null,
							_lang2.default.EMAIL
						),
						_react2.default.createElement(_Checkbox2.default, {
							checked: this.state.sms,
							onChange: function onChange(value) {
								return _this2.setState({ sms: value });
							}
						}),
						_react2.default.createElement(
							"label",
							null,
							_lang2.default.TEXT_MESSAGE
						)
					)
				)
			);
		}
	}]);

	return POICrossingNotificationConfigForm;
}(_react2.default.Component);

exports.default = POICrossingNotificationConfigForm;


POICrossingNotificationConfigForm.propTypes = {
	pois: _react2.default.PropTypes.array,
	vehicles: _react2.default.PropTypes.array,
	onChange: _react2.default.PropTypes.func,
	notificationConfig: _react2.default.PropTypes.object
};

POICrossingNotificationConfigForm.defaultProps = {
	pois: [],
	vehicles: [],
	onChange: function onChange(getEventDescriptor, NotificationConfig) {},
	notificationConfig: null
};

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(894);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _ProgressBar = __webpack_require__(34);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _session = __webpack_require__(30);

var _session2 = _interopRequireDefault(_session);

var _pois = __webpack_require__(29);

var _pois2 = _interopRequireDefault(_pois);

var _vehicles = __webpack_require__(45);

var _vehicles2 = _interopRequireDefault(_vehicles);

var _eventDescriptors = __webpack_require__(103);

var _eventDescriptors2 = _interopRequireDefault(_eventDescriptors);

var _NotificationConfigCard = __webpack_require__(410);

var _NotificationConfigCard2 = _interopRequireDefault(_NotificationConfigCard);

var _addNotificationConfig2 = __webpack_require__(214);

var _addNotificationConfig3 = _interopRequireDefault(_addNotificationConfig2);

var _updateNotificationConfig2 = __webpack_require__(219);

var _updateNotificationConfig3 = _interopRequireDefault(_updateNotificationConfig2);

var _removeNotificationConfig2 = __webpack_require__(216);

var _removeNotificationConfig3 = _interopRequireDefault(_removeNotificationConfig2);

var _shouldComponentUpdate2 = __webpack_require__(43);

var _shouldComponentUpdate3 = _interopRequireDefault(_shouldComponentUpdate2);

var _AddDialog = __webpack_require__(408);

var _AddDialog2 = _interopRequireDefault(_AddDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POICrossingNotifications = function (_React$Component) {
	_inherits(POICrossingNotifications, _React$Component);

	function POICrossingNotifications(props) {
		_classCallCheck(this, POICrossingNotifications);

		var _this = _possibleConstructorReturn(this, (POICrossingNotifications.__proto__ || Object.getPrototypeOf(POICrossingNotifications)).call(this, props));

		_this.initState();
		_this.initStoreListeners();
		return _this;
	}

	_createClass(POICrossingNotifications, [{
		key: "initState",
		value: function initState() {
			this.state = {
				inAddition: false,
				inProgress: false,
				displayButton: true,
				notificationConfigs: null
			};
		}
	}, {
		key: "initStoreListeners",
		value: function initStoreListeners() {
			var _this2 = this;

			_eventDescriptors2.default.on("change", function (eventDescriptors) {
				return _this2.updatePOINotificationConfigsFromStore();
			});
			_session2.default.on("change", function (_) {
				return _this2.updatePOINotificationConfigsFromStore();
			});
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			this.createScrollHandler();
			this.updatePOINotificationConfigsFromStore();
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate() {
			for (var _len = arguments.length, nexts = Array(_len), _key = 0; _key < _len; _key++) {
				nexts[_key] = arguments[_key];
			}

			return _shouldComponentUpdate3.default.apply(undefined, [this].concat(nexts));
		}
	}, {
		key: "createScrollHandler",
		value: function createScrollHandler() {
			var _this3 = this;

			var lastScrollTop = 0;

			this.handleScroll = function () {
				if (_this3.refs.content.scrollTop <= 30) {
					_this3.setState({ displayButton: true });
				} else {
					if (_this3.refs.content.scrollTop > lastScrollTop) _this3.setState({ displayButton: false });else _this3.setState({ displayButton: true });
				}
				lastScrollTop = _this3.refs.content.scrollTop;
			};
		}
	}, {
		key: "updateNotificationConfig",
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(eventDescriptor, notificationConfig) {
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								this.setState({ inProgress: true });
								(0, _updateNotificationConfig3.default)(eventDescriptor, notificationConfig);
								this.setState({ inProgress: false });
								new _Toast2.default(_lang2.default.YOUR_MODIFICATIONS_WILL_TAKE_EFFECT_WITHIN_ONE_HOUR, "green");

							case 4:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function updateNotificationConfig(_x, _x2) {
				return _ref.apply(this, arguments);
			}

			return updateNotificationConfig;
		}()
	}, {
		key: "addNotificationConfig",
		value: function () {
			var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(eventDescriptor, notificationConfig) {
				var _this4 = this;

				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								this.setState({ inProgress: true });
								_context2.next = 3;
								return (0, _addNotificationConfig3.default)(eventDescriptor, notificationConfig);

							case 3:
								if (!_context2.sent) {
									_context2.next = 6;
									break;
								}

								this.setState({ inAddition: false });
								this.refs.addDialog.clear();

							case 6:
								setTimeout(function (_) {
									return _this4.updatePOINotificationConfigsFromStore();
								});
								this.setState({ inProgress: false });
								new _Toast2.default(_lang2.default.YOUR_MODIFICATIONS_WILL_TAKE_EFFECT_WITHIN_ONE_HOUR, "green");

							case 9:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, this);
			}));

			function addNotificationConfig(_x3, _x4) {
				return _ref2.apply(this, arguments);
			}

			return addNotificationConfig;
		}()
	}, {
		key: "removeNotificationConfig",
		value: function () {
			var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(eventDescriptorId) {
				return regeneratorRuntime.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								this.setState({ inProgress: true });
								(0, _removeNotificationConfig3.default)(eventDescriptorId);
								this.setState({ inProgress: false });
								new _Toast2.default(_lang2.default.YOUR_MODIFICATIONS_WILL_TAKE_EFFECT_WITHIN_ONE_HOUR, "green");

							case 4:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, this);
			}));

			function removeNotificationConfig(_x5) {
				return _ref3.apply(this, arguments);
			}

			return removeNotificationConfig;
		}()
	}, {
		key: "updatePOINotificationConfigsFromStore",
		value: function updatePOINotificationConfigsFromStore() {
			var session = _session2.default.get();

			if (!session) {
				return null;
			}

			var notificationSets = session.user.services.filter(function (service) {
				return service.type == "NotificationSet";
			});

			var eventDescriptors = _eventDescriptors2.default.getAll();
			if (!eventDescriptors) {
				return null;
			}

			var notificationConfigs = eventDescriptors.filter(function (eventDescriptor) {
				return eventDescriptor.type == "POICrossingDescriptor";
			}).map(function (eventDescriptor) {
				var notificationSet = notificationSets.find(function (e) {
					return e.value.descriptor == eventDescriptor._id;
				});
				if (notificationSet) {
					return notificationSet.value;
				} else {
					return null;
				}
			});

			this.setState({ notificationConfigs: notificationConfigs });
		}
	}, {
		key: "isButtonHidden",
		value: function isButtonHidden() {
			return !this.state.displayButton || this.state.inProgress;
		}
	}, {
		key: "renderCard",
		value: function renderCard(notificationConfig) {
			var _this5 = this;

			if (notificationConfig) {
				return _react2.default.createElement(_NotificationConfigCard2.default, {
					key: notificationConfig.descriptor,
					notificationConfig: notificationConfig,
					onSave: function onSave(eventDescriptor, notificationConfig) {
						return _this5.updateNotificationConfig(eventDescriptor, notificationConfig);
					},
					pois: _pois2.default.getAll(),
					vehicles: _vehicles2.default.getAll(),
					onRemove: function onRemove() {
						return _this5.removeNotificationConfig(notificationConfig.descriptor);
					}
				});
			}
			return null;
		}
	}, {
		key: "renderCards",
		value: function renderCards() {
			var _this6 = this;

			return this.state.notificationConfigs ? this.state.notificationConfigs.map(function (e) {
				return _this6.renderCard(e);
			}) : null;
		}
	}, {
		key: "render",
		value: function render() {
			var _this7 = this;

			return _react2.default.createElement(
				"div",
				{ className: "POICrossingNotifications" },
				_react2.default.createElement(_Button2.default, {
					icon: "plus",
					className: (0, _classnames2.default)("Floating", "Red", { "Hidden": this.isButtonHidden() }),
					title: _lang2.default.ADD_NOTIFICATION_SETUP,
					onClick: function onClick(_) {
						return _this7.setState({ inAddition: true });
					}
				}),
				_react2.default.createElement(_ProgressBar2.default, {
					indeterminate: true,
					shown: this.state.inProgress
				}),
				_react2.default.createElement(
					"div",
					{
						ref: "content",
						onScroll: function onScroll() {
							return _this7.handleScroll();
						},
						className: (0, _classnames2.default)("Content", { "Hidden": this.state.inProgress })
					},
					this.renderCards()
				),
				_react2.default.createElement(_AddDialog2.default, {
					ref: "addDialog",
					shown: this.state.inAddition && !this.state.inProgress,
					pois: _pois2.default.getAll(),
					vehicles: _vehicles2.default.getAll(),
					onCancel: function onCancel() {
						return _this7.setState({ inAddition: false });
					},
					onAdd: function onAdd(eventDescriptor, notificationConfig) {
						return _this7.addNotificationConfig(eventDescriptor, notificationConfig);
					}
				})
			);
		}
	}]);

	return POICrossingNotifications;
}(_react2.default.Component);

exports.default = POICrossingNotifications;


POICrossingNotifications.propTypes = {};

POICrossingNotifications.defaultProps = {};

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _POICrossingNotifications = __webpack_require__(412);

var _POICrossingNotifications2 = _interopRequireDefault(_POICrossingNotifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _POICrossingNotifications2.default;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _pois = __webpack_require__(29);

var _pois2 = _interopRequireDefault(_pois);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

var _shouldComponentUpdate2 = __webpack_require__(43);

var _shouldComponentUpdate3 = _interopRequireDefault(_shouldComponentUpdate2);

var _Details = __webpack_require__(148);

var _Details2 = _interopRequireDefault(_Details);

var _Pager = __webpack_require__(87);

var _Pager2 = _interopRequireDefault(_Pager);

var _POIProperties = __webpack_require__(424);

var _POIProperties2 = _interopRequireDefault(_POIProperties);

var _POICollaborators = __webpack_require__(406);

var _POICollaborators2 = _interopRequireDefault(_POICollaborators);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _EEP = __webpack_require__(33);

var _EEP2 = _interopRequireDefault(_EEP);

var _getServiceSet = __webpack_require__(145);

var _getServiceSet2 = _interopRequireDefault(_getServiceSet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POIDetails = function (_React$Component) {
	_inherits(POIDetails, _React$Component);

	function POIDetails(props) {
		_classCallCheck(this, POIDetails);

		var _this = _possibleConstructorReturn(this, (POIDetails.__proto__ || Object.getPrototypeOf(POIDetails)).call(this, props));

		_this.initState();
		_this.eep = new _EEP2.default();
		_this.setStoreListeners();
		return _this;
	}

	_createClass(POIDetails, [{
		key: "initState",
		value: function initState() {
			this.state = {
				poi: _pois2.default.get(this.props.poiId),
				page: _openedDetails2.default.get(this.props.poiId).activePage
			};
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			this.eep.on(_pois2.default, "update", function (poi) {
				if (poi._id == _this2.props.poiId) _this2.setState({ poi: poi });
			});

			this.eep.on(_openedDetails2.default, "update", function (detailsDescriptor) {
				if (detailsDescriptor.id == _this2.props.poiId) _this2.setState({ page: detailsDescriptor.activePage });
			});
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate() {
			for (var _len = arguments.length, nexts = Array(_len), _key = 0; _key < _len; _key++) {
				nexts[_key] = arguments[_key];
			}

			return _shouldComponentUpdate3.default.apply(undefined, [this].concat(nexts));
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			this.eep.close();
		}
	}, {
		key: "render",
		value: function render() {
			var _this3 = this;

			var tabs = [{ id: "properties", label: _lang2.default.PROPERTIES }, { id: "collaborators", label: _lang2.default.COLLABORATORS }];

			var detailsProps = {
				title: this.state.poi.name || "",
				onClose: function onClose() {
					return _dispatcher2.default.dispatch('closeDetails', "POIDetails", _this3.props.poiId);
				},
				tabs: tabs,
				onTabChange: function onTabChange(tabId) {
					return _dispatcher2.default.dispatch('switchDetailsPage', _this3.props.poiId, tabId);
				},
				activeTab: this.state.page,
				dragable: true,
				ondrag: this.props.ondrag,
				className: this.props.className
			};

			return _react2.default.createElement(
				_Details2.default,
				detailsProps,
				_react2.default.createElement(
					_Pager2.default,
					{ active: this.state.page },
					_react2.default.createElement(
						"div",
						{ id: "properties" },
						_react2.default.createElement(_POIProperties2.default, { poiId: this.props.poiId })
					),
					_react2.default.createElement(
						"div",
						{ id: "collaborators" },
						_react2.default.createElement(_POICollaborators2.default, { poiId: this.props.poiId })
					)
				)
			);
		}
	}]);

	return POIDetails;
}(_react2.default.Component);

exports.default = POIDetails;


POIDetails.propTypes = {
	poiId: _react2.default.PropTypes.string,
	ondrag: _react2.default.PropTypes.func
};

POIDetails.defaultProps = {
	poiId: null,
	ondrag: function ondrag(dragEvt) {}
};

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _POIDetails = __webpack_require__(414);

var _POIDetails2 = _interopRequireDefault(_POIDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _POIDetails2.default;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(895);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _TextFilter = __webpack_require__(207);

var _TextFilter2 = _interopRequireDefault(_TextFilter);

var _Pin = __webpack_require__(61);

var _Pin2 = _interopRequireDefault(_Pin);

var _ButtonGroup = __webpack_require__(202);

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Filter = function (_React$Component) {
	_inherits(Filter, _React$Component);

	function Filter(props) {
		_classCallCheck(this, Filter);

		var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(Filter, [{
		key: "initState",
		value: function initState() {
			this.state = {
				expanded: false
			};
		}
	}, {
		key: "toggle",
		value: function toggle() {
			this.setState({
				expanded: !this.state.expanded
			});
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			var pin = this.props.pinStatus > 0;
			var pinAll = this.props.pinStatus == 2;
			var className = this.state.expanded ? "" : "Hidden";

			return _react2.default.createElement(
				"div",
				{ className: "Filter" },
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(_TextFilter2.default, { onSubmit: function onSubmit(value) {
							return _this2.props.onFilter({ text: value });
						}, value: this.props.filterExpression.text }),
					_react2.default.createElement(_Pin2.default, { onChange: function onChange(value) {
							return _this2.props.onPinChange(value);
						}, checked: pin, indeterminate: !pinAll, useForAll: true })
				),
				_react2.default.createElement(
					"div",
					{ className: className },
					_react2.default.createElement(
						_ButtonGroup2.default,
						{ onChange: function onChange(id) {
								return _this2.props.onFilter({ type: id });
							}, selected: this.props.filterExpression.type },
						_react2.default.createElement(
							_Button2.default,
							{ id: "PolygonalPOI", className: "Light" },
							_lang2.default.POLYGONAL
						),
						_react2.default.createElement(
							_Button2.default,
							{ id: "RadialPOI", className: "Light" },
							_lang2.default.RADIAL
						)
					)
				),
				_react2.default.createElement(
					"footer",
					{ onClick: function onClick(_) {
							return _this2.toggle();
						} },
					"\u2022\u2022\u2022"
				)
			);
		}
	}]);

	return Filter;
}(_react2.default.Component);

exports.default = Filter;


Filter.propTypes = {
	pinStatus: _react2.default.PropTypes.number,
	filterExpression: _react2.default.PropTypes.shape({
		text: _react2.default.PropTypes.string,
		type: _react2.default.PropTypes.string
	}),
	onFilter: _react2.default.PropTypes.func,
	onPinChange: _react2.default.PropTypes.func
};

Filter.defaultProps = {
	onFilter: function onFilter(expression) {},
	onPinChange: function onPinChange(value) {},
	pinStatus: 2
};

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filter = __webpack_require__(416);

var _Filter2 = _interopRequireDefault(_Filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Filter2.default;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(896);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _pois = __webpack_require__(29);

var _pois2 = _interopRequireDefault(_pois);

var _selectedPOI = __webpack_require__(156);

var _selectedPOI2 = _interopRequireDefault(_selectedPOI);

var _poiFilterExpression = __webpack_require__(369);

var _poiFilterExpression2 = _interopRequireDefault(_poiFilterExpression);

var _pinnedPOIs = __webpack_require__(223);

var _pinnedPOIs2 = _interopRequireDefault(_pinnedPOIs);

var _shouldComponentUpdate = __webpack_require__(43);

var _shouldComponentUpdate2 = _interopRequireDefault(_shouldComponentUpdate);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _List = __webpack_require__(205);

var _List2 = _interopRequireDefault(_List);

var _Filter = __webpack_require__(417);

var _Filter2 = _interopRequireDefault(_Filter);

var _Summary = __webpack_require__(420);

var _Summary2 = _interopRequireDefault(_Summary);

var _filterGroups = __webpack_require__(67);

var _filterGroups2 = _interopRequireDefault(_filterGroups);

var _filterPOIs = __webpack_require__(421);

var _filterPOIs2 = _interopRequireDefault(_filterPOIs);

var _poi = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POIList = function (_React$Component) {
	_inherits(POIList, _React$Component);

	function POIList(props) {
		_classCallCheck(this, POIList);

		var _this = _possibleConstructorReturn(this, (POIList.__proto__ || Object.getPrototypeOf(POIList)).call(this, props));

		_this.initState();
		_this.setStoreListeners();
		return _this;
	}

	_createClass(POIList, [{
		key: "initState",
		value: function initState() {
			this.state = {
				pois: (0, _filterGroups2.default)(_pois2.default.getAll()),
				filterExpression: _poiFilterExpression2.default.get(),
				selectedPOI: _selectedPOI2.default.get(),
				pinnedPOIs: _pinnedPOIs2.default.getAll()
			};
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			_pois2.default.on('change', function (pois) {
				return _this2.setState({ pois: (0, _filterGroups2.default)(pois) });
			});
			_poiFilterExpression2.default.on('change', function (filterExpression) {
				return _this2.setState({ filterExpression: filterExpression });
			});
			_selectedPOI2.default.on('change', function (selectedPOI) {
				return _this2.setState({ selectedPOI: selectedPOI });
			});
			_pinnedPOIs2.default.on('change', function (pinnedPOIs) {
				return _this2.setState({ pinnedPOIs: pinnedPOIs });
			});
		}

		// SIDE_EFFECT: referenciálisan ugyanaz a state és a nextState
		/* shouldComponentUpdate(...nexts){
  	return shouldComponentUpdate(this, ...nexts);
  } */

	}, {
		key: "handleFilterChange",
		value: function handleFilterChange(expression) {
			_dispatcher2.default.dispatch('filterPOIs', expression);
		}
	}, {
		key: "handlePinChange",
		value: function handlePinChange(value) {
			var poiIds = this.getListedPOIs().map(function (v) {
				return v._id;
			});
			_dispatcher2.default.dispatch('pinPOIs', poiIds, value);
		}
	}, {
		key: "onSwitchPOIDetails",
		value: function onSwitchPOIDetails(poiId) {
			var _this3 = this;

			var displayedDetails = displayedDetailsStore.get();
			if (!displayedDetails) {
				_dispatcher2.default.dispatch("openDetails", "POIDetails", poiId);
				setTimeout(function () {
					return _this3.focusPOI(poiId);
				}, 600);
			} else if (displayedDetails.id == poiId) _dispatcher2.default.dispatch("closeDetails", "POIDetails", poiId);else {
				_dispatcher2.default.dispatch("openDetails", "POIDetails", poiId);
				setTimeout(function () {
					return _this3.focusPOI(poiId);
				});
			}
		}
	}, {
		key: "focusPOI",
		value: function focusPOI(poiId) {
			_dispatcher2.default.dispatch('setMap', {
				bounds: (0, _poi.getBoundsOfPOI)(poiId).toJSON()
			});
		}
	}, {
		key: "getFilteredPOIs",
		value: function getFilteredPOIs() {
			return (0, _filterPOIs2.default)(this.state.pois, this.state.filterExpression);
		}
	}, {
		key: "getListedPOIs",
		value: function getListedPOIs() {
			var filteredPOIs = this.getFilteredPOIs();
			if (filteredPOIs) {
				return filteredPOIs;
			} else if (this.state.pois) {
				return this.state.pois;
			} else {
				return [];
			}
		}
	}, {
		key: "getListedPOIsPinStatus",
		value: function getListedPOIsPinStatus() {
			var _this4 = this;

			var currentListedPOIs = this.getListedPOIs().map(function (v) {
				return v._id;
			});
			var pinnedCurrentListedPOIIds = currentListedPOIs.filter(function (id) {
				return _this4.state.pinnedPOIs && _this4.state.pinnedPOIs.indexOf(id) > -1;
			});

			if (pinnedCurrentListedPOIIds.length == 0) {
				return 0;
			} else if (pinnedCurrentListedPOIIds.length < currentListedPOIs.length && pinnedCurrentListedPOIIds.length > 0) {
				return 1;
			} else if (pinnedCurrentListedPOIIds.length == currentListedPOIs.length) {
				return 2;
			}
			return 0;
		}
	}, {
		key: "renderFilter",
		value: function renderFilter() {
			return _react2.default.createElement(_Filter2.default, {
				filterExpression: this.state.filterExpression,
				pinStatus: this.getListedPOIsPinStatus(),
				onFilter: this.handleFilterChange.bind(this),
				onPinChange: this.handlePinChange.bind(this)
			});
		}
	}, {
		key: "renderList",
		value: function renderList(pois) {
			var _this5 = this;

			return _react2.default.createElement(
				_List2.default,
				null,
				pois ? pois.map(function (poi) {
					return _react2.default.createElement(_Summary2.default, {
						key: poi._id,
						poi: poi,
						onFocus: function onFocus() {
							return _this5.focusPOI(poi._id);
						},
						pinned: _this5.state.pinnedPOIs ? _this5.state.pinnedPOIs.find(function (e) {
							return e == poi._id;
						}) ? true : false : false,
						onPinChange: function onPinChange(value) {
							return _dispatcher2.default.dispatch('pinPOIs', [poi._id], value);
						},
						onSwitchPOIDetails: function onSwitchPOIDetails(_) {
							return _this5.onSwitchPOIDetails(poi._id);
						}
					});
				}) : ""
			);
		}
	}, {
		key: "renderFullList",
		value: function renderFullList() {
			return _react2.default.createElement(
				"div",
				{ className: "ListContainer" },
				this.renderList(this.state.pois)
			);
		}
	}, {
		key: "renderFilteredList",
		value: function renderFilteredList() {

			var className = (0, _classnames2.default)("ListContainer", { "Hidden": !this.getFilteredPOIs() });

			return _react2.default.createElement(
				"div",
				{ className: className },
				_react2.default.createElement(
					"header",
					null,
					_react2.default.createElement(_Button2.default, { icon: "arrow-left", onClick: function onClick(_) {
							return _dispatcher2.default.dispatch('filterPOIs', null);
						} })
				),
				this.renderList(this.getFilteredPOIs())
			);
		}
	}, {
		key: "renderSelectedList",
		value: function renderSelectedList() {
			var _this6 = this;

			var className = (0, _classnames2.default)("ListContainer", { "Hidden": !this.state.selectedPOI });
			var poi = this.state.selectedPOI ? this.state.pois.find(function (p) {
				return p._id == _this6.state.selectedPOI;
			}) : null;
			return _react2.default.createElement(
				"div",
				{ className: className },
				_react2.default.createElement(
					"header",
					null,
					_react2.default.createElement(_Button2.default, { icon: "arrow-left", onClick: function onClick(_) {
							return _dispatcher2.default.dispatch('selectPOI', null);
						} })
				),
				this.renderList(poi ? [poi] : null)
			);
		}
	}, {
		key: "renderCreatePOIButton",
		value: function renderCreatePOIButton() {
			var _this7 = this;

			return _react2.default.createElement(_Button2.default, { icon: "plus", className: "Floating Red", onClick: function onClick(_) {
					return _this7.props.onCreatePOI();
				} });
		}
	}, {
		key: "render",
		value: function render() {

			var filter = this.renderFilter();
			var fullList = this.renderFullList();
			var filteredList = this.renderFilteredList();
			var selectedList = this.renderSelectedList();
			var createPOIButton = this.renderCreatePOIButton();

			return _react2.default.createElement(
				"div",
				{ className: "POIList" },
				filter,
				_react2.default.createElement(
					"div",
					{ id: "body" },
					fullList,
					filteredList,
					selectedList,
					createPOIButton
				)
			);
		}
	}]);

	return POIList;
}(_react2.default.Component);

exports.default = POIList;


POIList.propTypes = {
	onCreatePOI: _react2.default.PropTypes.func
};

POIList.defaultProps = {
	onCreatePOI: function onCreatePOI(location) {}
};

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(897);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _Pin = __webpack_require__(61);

var _Pin2 = _interopRequireDefault(_Pin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Summary = function (_React$Component) {
	_inherits(Summary, _React$Component);

	function Summary(props) {
		_classCallCheck(this, Summary);

		return _possibleConstructorReturn(this, (Summary.__proto__ || Object.getPrototypeOf(Summary)).call(this, props));
	}

	_createClass(Summary, [{
		key: "createTouchProps",
		value: function createTouchProps() {
			var _this2 = this;

			var pressStarted = false;

			return {
				onTouchStart: function onTouchStart() {
					pressStarted = true;
					setTimeout(function () {
						if (pressStarted) _this2.props.onSwitchPOIDetails();
						pressStarted = false;
					}, 1000);
				},
				onTouchEnd: function onTouchEnd() {
					pressStarted = false;
				},
				onTouchCancel: function onTouchCancel() {
					pressStarted = false;
				}
			};
		}
	}, {
		key: "renderPin",
		value: function renderPin() {
			var _this3 = this;

			return _react2.default.createElement(_Pin2.default, {
				checked: this.props.pinned,
				onChange: function onChange(value) {
					return _this3.props.onPinChange(value);
				}
			});
		}
	}, {
		key: "renderHeader",
		value: function renderHeader() {
			var _this4 = this;

			return _react2.default.createElement(
				"header",
				null,
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(
						"div",
						{ id: "nameContainer" },
						_react2.default.createElement(
							"h1",
							{ onClick: function onClick(evt) {
									evt.stopPropagation();
									_this4.props.onSwitchPOIDetails();
								} },
							this.props.poi.name
						)
					),
					this.renderPin()
				),
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(
						"label",
						null,
						this.props.poi.address
					)
				)
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this5 = this;

			var touchProps = this.createTouchProps();

			return _react2.default.createElement(
				_Card2.default,
				_extends({ className: "Summary", onClick: function onClick(_) {
						return _this5.props.onFocus();
					}, onDoubleClick: this.props.onSwitchPOIDetails }, touchProps),
				this.renderHeader()
			);
		}
	}]);

	return Summary;
}(_react2.default.Component);

exports.default = Summary;


Summary.propTypes = {
	poi: _react2.default.PropTypes.object.isRequired,
	pinned: _react2.default.PropTypes.bool,
	onFocus: _react2.default.PropTypes.func,
	onSwitchPOIDetails: _react2.default.PropTypes.func,
	onPinChange: _react2.default.PropTypes.func
};

Summary.defaultProps = {
	onFocus: function onFocus() {},
	onDetailsOpen: function onDetailsOpen(page) {},
	onPinChange: function onPinChange(value) {},
	onSwitchPOIDetails: function onSwitchPOIDetails() {}
};

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Summary = __webpack_require__(419);

var _Summary2 = _interopRequireDefault(_Summary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Summary2.default;

/***/ },
/* 421 */
/***/ function(module, exports) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = filterPOIs;
function filterByText(pois, text) {
	return pois.filter(function (poi) {

		var pattern = new RegExp(text, "i");

		if (poi.name && pattern.test(poi.name)) return true;
		if (poi.address && pattern.test(poi.address)) return true;
		return false;
	});
}

function filterByType(pois, type) {

	return pois.filter(function (poi) {

		if (poi.type == type) {
			return true;
		} else {
			return false;
		}
	});
}

function filterPOIs(pois, expression) {
	if (!pois || expression.text == "" && !expression.type) return null;

	var filteredPOIs = pois.slice();

	if (expression.text) filteredPOIs = filterByText(filteredPOIs, expression.text);

	if (expression.type) filteredPOIs = filterByType(filteredPOIs, expression.type);

	return filteredPOIs;
}

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _POIList = __webpack_require__(418);

var _POIList2 = _interopRequireDefault(_POIList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _POIList2.default;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(898);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _pois = __webpack_require__(29);

var _pois2 = _interopRequireDefault(_pois);

var _editedPOI = __webpack_require__(153);

var _editedPOI2 = _interopRequireDefault(_editedPOI);

var _poiModifications = __webpack_require__(119);

var _poiModifications2 = _interopRequireDefault(_poiModifications);

var _poiCollaborations = __webpack_require__(155);

var _poiCollaborations2 = _interopRequireDefault(_poiCollaborations);

var _Form = __webpack_require__(38);

var _Form2 = _interopRequireDefault(_Form);

var _ProgressBar = __webpack_require__(34);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Input = __webpack_require__(52);

var _Input2 = _interopRequireDefault(_Input);

var _ColorPicker = __webpack_require__(203);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _ConfirmDialog = __webpack_require__(146);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _EEP = __webpack_require__(33);

var _EEP2 = _interopRequireDefault(_EEP);

var _poi = __webpack_require__(46);

var _getPOICollaborations = __webpack_require__(151);

var _getPOICollaborations2 = _interopRequireDefault(_getPOICollaborations);

var _savePOI = __webpack_require__(218);

var _savePOI2 = _interopRequireDefault(_savePOI);

var _deletePOI2 = __webpack_require__(353);

var _deletePOI3 = _interopRequireDefault(_deletePOI2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_COLOR = "#FFFFFF";

var POIProperties = function (_React$Component) {
	_inherits(POIProperties, _React$Component);

	function POIProperties(props) {
		_classCallCheck(this, POIProperties);

		var _this = _possibleConstructorReturn(this, (POIProperties.__proto__ || Object.getPrototypeOf(POIProperties)).call(this, props));

		_this.initState();
		_this.eep = new _EEP2.default();
		_this.setStoreListeners();
		return _this;
	}

	_createClass(POIProperties, [{
		key: "initState",
		value: function initState() {
			this.state = {
				inProgress: false,
				poi: _pois2.default.get(this.props.poiId),
				modifications: this.getModificationsFromStore(),
				editedPOIId: _editedPOI2.default.get()
			};
		}
	}, {
		key: "getModificationsFromStore",
		value: function getModificationsFromStore() {
			var modDoc = _poiModifications2.default.get(this.props.poiId);
			if (!modDoc) return {};
			return modDoc.modifications;
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			this.eep.on(_pois2.default, "update", function (poi) {
				if (poi._id == _this2.props.poiId) _this2.setState({ poi: poi });
			});
			this.eep.on(_poiModifications2.default, "insert", function (modificationDocs) {
				var modificationDoc = modificationDocs.find(function (md) {
					return md.poi == _this2.props.poiId;
				});
				if (!modificationDoc) return;
				_this2.setState({
					modifications: _this2.getModificationsFromStore()
				});
			});
			this.eep.on(_poiModifications2.default, "update", function (modificationDoc) {
				if (modificationDoc.poi == _this2.props.poiId) _this2.setState({
					modifications: _this2.getModificationsFromStore()
				});
			});
			this.eep.on(_poiModifications2.default, "remove", function (modificationDocs) {
				var modificationDoc = modificationDocs.find(function (md) {
					return md.poi == _this2.props.poiId;
				});
				if (!modificationDoc) return;
				_this2.setState({
					modifications: _this2.getModificationsFromStore()
				});
			});
			this.eep.on(_editedPOI2.default, "change", function (editedPOIId) {
				return _this2.setState({ editedPOIId: editedPOIId });
			});
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			this.eep.close();
		}
	}, {
		key: "getValue",
		value: function getValue(field) {
			if (field in this.state.modifications) return this.state.modifications[field];else return this.state.poi[field];
		}
	}, {
		key: "canEdit",
		value: function canEdit() {
			var privilege = (0, _poi.getPrivilegeOfPOI)(this.props.poiId);
			return privilege >= 2;
		}
	}, {
		key: "canDelete",
		value: function canDelete() {
			var privilege = (0, _poi.getPrivilegeOfPOI)(this.props.poiId);
			return privilege == 4;
		}
	}, {
		key: "hasModifications",
		value: function hasModifications() {
			return Object.keys(this.state.modifications).length > 0;
		}
	}, {
		key: "getShapeEditingButtonLabel",
		value: function getShapeEditingButtonLabel() {
			if (this.state.editedPOIId == this.props.poiId) return _lang2.default.RESTORE_SHAPE;else return _lang2.default.EDIT_SHAPE;
		}
	}, {
		key: "save",
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								this.setState({ inProgress: true });
								_context.next = 3;
								return (0, _savePOI2.default)(this.props.poiId);

							case 3:
								this.setState({ inProgress: false });

							case 4:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function save() {
				return _ref.apply(this, arguments);
			}

			return save;
		}()
	}, {
		key: "handleShapeEditingButton",
		value: function handleShapeEditingButton() {
			if (this.state.editedPOIId == this.props.poiId) {
				_dispatcher2.default.dispatch("restorePOIShape", this.props.poiId);
				_dispatcher2.default.dispatch("editPOI", null);
			} else {
				_dispatcher2.default.dispatch("editPOI", this.props.poiId);
			}
		}
	}, {
		key: "confirmDeleting",
		value: function confirmDeleting() {
			var _this3 = this;

			_ConfirmDialog2.default.open({
				text: _lang2.default.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_POI,
				onConfirm: function onConfirm() {
					return _this3.deletePOI();
				}
			});
		}
	}, {
		key: "deletePOI",
		value: function () {
			var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								this.setState({ inProgress: true });
								(0, _deletePOI3.default)(this.props.poiId);
								this.setState({ inProgress: false });

							case 3:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, this);
			}));

			function deletePOI() {
				return _ref2.apply(this, arguments);
			}

			return deletePOI;
		}()
	}, {
		key: "getSaveButtonDisabled",
		value: function getSaveButtonDisabled() {
			return !this.canEdit() || !this.hasModifications();
		}
	}, {
		key: "render",
		value: function render() {
			var _this4 = this;

			return _react2.default.createElement(
				"div",
				{ className: "POIProperties" },
				_react2.default.createElement(
					"header",
					{ className: "Shadowed" },
					_react2.default.createElement(
						_Button2.default,
						{
							className: "Red",
							onClick: function onClick() {
								return _this4.save();
							},
							disabled: this.getSaveButtonDisabled()
						},
						_lang2.default.SAVE
					),
					_react2.default.createElement(
						_Button2.default,
						{
							onClick: function onClick() {
								return _this4.handleShapeEditingButton();
							},
							disabled: !this.canEdit()
						},
						this.getShapeEditingButtonLabel()
					),
					_react2.default.createElement(
						_Button2.default,
						{
							onClick: function onClick() {
								return _this4.confirmDeleting();
							},
							disabled: !this.canDelete()
						},
						_lang2.default.DELETE
					)
				),
				_react2.default.createElement(_ProgressBar2.default, {
					indeterminate: true,
					shown: this.state.inProgress
				}),
				_react2.default.createElement(
					"div",
					{ className: (0, _classnames2.default)("Content", { "Hidden": this.state.inProgress }) },
					_react2.default.createElement(
						_Card2.default,
						null,
						_react2.default.createElement(
							_Form2.default,
							null,
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.NAME
							),
							_react2.default.createElement(_Input2.default, {
								value: this.getValue("name") || "",
								onChange: function onChange(evt) {
									return _dispatcher2.default.dispatch("modifyPOI", _this4.props.poiId, { name: evt.target.value });
								},
								disabled: !this.canEdit()
							}),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.ADDRESS
							),
							_react2.default.createElement(_Input2.default, {
								value: this.getValue("address") || "",
								onChange: function onChange(evt) {
									return _dispatcher2.default.dispatch("modifyPOI", _this4.props.poiId, { address: evt.target.value });
								},
								disabled: !this.canEdit()
							}),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.COLOR
							),
							_react2.default.createElement(_ColorPicker2.default, {
								color: this.getValue("color") || DEFAULT_COLOR,
								onChange: function onChange(color) {
									return _dispatcher2.default.dispatch("modifyPOI", _this4.props.poiId, { color: color });
								},
								disabled: !this.canEdit()
							})
						)
					)
				)
			);
		}
	}]);

	return POIProperties;
}(_react2.default.Component);

exports.default = POIProperties;


POIProperties.propTypes = {
	poiId: _react2.default.PropTypes.string
};

POIProperties.defaultProps = {
	poiId: null
};

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _POIProperties = __webpack_require__(423);

var _POIProperties2 = _interopRequireDefault(_POIProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _POIProperties2.default;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(899);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _countryCodes = __webpack_require__(307);

var _countryCodes2 = _interopRequireDefault(_countryCodes);

var _pattern = __webpack_require__(308);

var _pattern2 = _interopRequireDefault(_pattern);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Form = __webpack_require__(38);

var _Form2 = _interopRequireDefault(_Form);

var _Input = __webpack_require__(52);

var _Input2 = _interopRequireDefault(_Input);

var _Select = __webpack_require__(74);

var _Select2 = _interopRequireDefault(_Select);

var _ProgressBar = __webpack_require__(34);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _session = __webpack_require__(30);

var _session2 = _interopRequireDefault(_session);

var _user = __webpack_require__(20);

var _saveContacts = __webpack_require__(364);

var _saveContacts2 = _interopRequireDefault(_saveContacts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserContacts = function (_React$Component) {
	_inherits(UserContacts, _React$Component);

	function UserContacts(props) {
		_classCallCheck(this, UserContacts);

		var _this = _possibleConstructorReturn(this, (UserContacts.__proto__ || Object.getPrototypeOf(UserContacts)).call(this, props));

		_this.initState();
		_this.setStoreListeners();
		return _this;
	}

	_createClass(UserContacts, [{
		key: "initState",
		value: function initState() {
			this.state = {
				inProgress: false,
				email: "",
				phone: {
					countryCode: "",
					number: ""
				},
				valid: false
			};
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			_session2.default.on("change", function (_) {
				return _this2.setStateFromStore();
			});
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			this.setStateFromStore();
			this.setEmailValidity();
		}
	}, {
		key: "setStateFromStore",
		value: function setStateFromStore() {
			var contacts = (0, _user.getContacts)();
			this.setState({
				email: this.getEmailFromContacts(contacts),
				phone: this.getPhoneFromContacts(contacts)
			});
		}
	}, {
		key: "getEmailFromContacts",
		value: function getEmailFromContacts(contacts) {
			var emailContact = contacts.find(function (contact) {
				return contact.type == "Email";
			});
			return emailContact ? emailContact.email : "";
		}
	}, {
		key: "getPhoneFromContacts",
		value: function getPhoneFromContacts(contacts) {
			var _ref = contacts.find(function (contact) {
				return contact.type == "Phone";
			}) || {},
			    _ref$countryCode = _ref.countryCode,
			    countryCode = _ref$countryCode === undefined ? "" : _ref$countryCode,
			    _ref$number = _ref.number,
			    number = _ref$number === undefined ? "" : _ref$number;

			return { countryCode: countryCode, number: formatPhoneNumber(number) };
		}
	}, {
		key: "getContactsFromState",
		value: function getContactsFromState() {
			var contacts = [];
			if (this.state.email) contacts.push({ type: "Email", email: this.state.email });
			if (this.state.phone.number) contacts.push({ type: "Phone", countryCode: this.state.phone.countryCode, number: this.state.phone.number });
			return contacts;
		}
	}, {
		key: "setEmailValidity",
		value: function setEmailValidity() {
			var emailInput = _reactDom2.default.findDOMNode(this.refs.email);
			this.setState({
				valid: emailInput.validity.valid
			});
		}
	}, {
		key: "handleEmailChange",
		value: function handleEmailChange(email) {
			this.setEmailValidity();
			this.setState({ email: email });
		}
	}, {
		key: "handlePhoneChange",
		value: function handlePhoneChange() {
			var countryCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			this.setState({
				phone: {
					countryCode: countryCode !== null ? countryCode : this.state.phone.countryCode,
					number: formatPhoneNumber(number !== null ? number : this.state.phone.number)
				}
			});
		}
	}, {
		key: "handleSave",
		value: function handleSave() {
			this.save();
		}
	}, {
		key: "save",
		value: function () {
			var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				var contacts;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								contacts = this.getContactsFromState();

								this.setState({ inProgress: true });
								_context.prev = 2;
								_context.next = 5;
								return (0, _saveContacts2.default)(contacts);

							case 5:
								this.hide();
								_context.next = 11;
								break;

							case 8:
								_context.prev = 8;
								_context.t0 = _context["catch"](2);

								this.setState({
									errorMessage: _context.t0.message
								});

							case 11:
								this.setState({ inProgress: false });

							case 12:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this, [[2, 8]]);
			}));

			function save() {
				return _ref2.apply(this, arguments);
			}

			return save;
		}()
	}, {
		key: "getSaveButtonDisabled",
		value: function getSaveButtonDisabled() {
			return this.state.inProgress || !this.state.valid;
		}
	}, {
		key: "renderSelect",
		value: function renderSelect(countryCode) {
			var _this3 = this;

			return _react2.default.createElement(
				_Select2.default,
				{
					defaultValue: countryCode,
					value: this.state.phone.countryCode,
					onChange: function onChange(evt) {
						return _this3.handlePhoneChange(evt.target.value, null);
					}
				},
				_react2.default.createElement("option", { key: "", value: null }),
				_countryCodes2.default.map(function (cc) {
					return _react2.default.createElement(
						"option",
						{ key: cc, value: cc },
						cc
					);
				})
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this4 = this;

			return _react2.default.createElement(
				"div",
				{ className: "UserContacts" },
				_react2.default.createElement(
					"header",
					{ className: "Shadowed" },
					_react2.default.createElement(
						_Button2.default,
						{ className: "Red", disabled: this.getSaveButtonDisabled(), onClick: function onClick(_) {
								return _this4.handleSave();
							} },
						_lang2.default.SAVE
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "Content" },
					_react2.default.createElement(_ProgressBar2.default, { indeterminate: true, shown: this.state.inProgress }),
					_react2.default.createElement(
						_Card2.default,
						{ className: this.state.inProgress ? "Hidden" : null },
						_react2.default.createElement(
							_Form2.default,
							null,
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.EMAIL
							),
							_react2.default.createElement(_Input2.default, { ref: "email", value: this.state.email, onChange: function onChange(evt) {
									return _this4.handleEmailChange(evt.target.value);
								}, pattern: _pattern2.default.EMAIL.source }),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.PHONE
							),
							_react2.default.createElement(
								"div",
								{ className: "PhoneContainer" },
								_react2.default.createElement(
									"span",
									null,
									"+"
								),
								this.renderSelect(),
								_react2.default.createElement(_Input2.default, { value: this.state.phone.number, onChange: function onChange(evt) {
										return _this4.handlePhoneChange(null, evt.target.value);
									} })
							)
						)
					)
				)
			);
		}
	}]);

	return UserContacts;
}(_react2.default.Component);

exports.default = UserContacts;


UserContacts.propTypes = {
	contacts: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.shape({
		type: _react2.default.PropTypes.string,
		email: _react2.default.PropTypes.string
	}), _react2.default.PropTypes.shape({
		type: _react2.default.PropTypes.string,
		countryCode: _react2.default.PropTypes.string,
		number: _react2.default.PropTypes.string
	})]))
};

UserContacts.defaultProps = {
	contacts: []
};

function formatPhoneNumber(number) {
	return number.replace(/[\s\D]+/g, '');
}

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UserContacts = __webpack_require__(425);

var _UserContacts2 = _interopRequireDefault(_UserContacts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _UserContacts2.default;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(900);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Tabs = __webpack_require__(116);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Pager = __webpack_require__(87);

var _Pager2 = _interopRequireDefault(_Pager);

var _POICrossingNotifications = __webpack_require__(413);

var _POICrossingNotifications2 = _interopRequireDefault(_POICrossingNotifications);

var _CriticalValueNotifications = __webpack_require__(380);

var _CriticalValueNotifications2 = _interopRequireDefault(_CriticalValueNotifications);

var _eventDescriptors = __webpack_require__(103);

var _eventDescriptors2 = _interopRequireDefault(_eventDescriptors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserNotifications = function (_React$Component) {
	_inherits(UserNotifications, _React$Component);

	function UserNotifications(props) {
		_classCallCheck(this, UserNotifications);

		var _this = _possibleConstructorReturn(this, (UserNotifications.__proto__ || Object.getPrototypeOf(UserNotifications)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(UserNotifications, [{
		key: "initState",
		value: function initState() {
			this.state = {
				page: "poiCrossingNotifications"
			};
		}
	}, {
		key: "getPOINotificationSets",
		value: function getPOINotificationSets() {
			var session = sessionStore.get();

			if (!session) {
				return null;
			}

			var notificationSets = session.user.services.filter(function (service) {
				return service.type == "NotificationSet";
			});

			var eventDescriptors = _eventDescriptors2.default.getAll();
			if (!eventDescriptors) {
				return null;
			}

			var poiNotificationSets = eventDescriptors.filter(function (eventDescriptor) {
				return eventDescriptor.type == "POI";
			}).map(function (eventDescriptor) {
				return notificationSets.find(function (e) {
					return e.descriptor == eventDescriptor._id;
				});
			});
		}
	}, {
		key: "getCriticalValueNotificationSets",
		value: function getCriticalValueNotificationSets() {
			var session = sessionStore.get();

			if (!session) {
				return null;
			}

			var notificationSets = session.user.services.filter(function (service) {
				return service.type == "NotificationSet";
			});

			var eventDescriptors = _eventDescriptors2.default.getAll();
			if (!eventDescriptors) {
				return null;
			}

			var criticalValueNotificationSets = eventDescriptors.filter(function (eventDescriptor) {
				return eventDescriptor.type == "CriticalValue";
			}).map(function (eventDescriptor) {
				return notificationSets.find(function (e) {
					return e.descriptor == eventDescriptor._id;
				});
			});
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				"div",
				{ className: "UserNotifications" },
				_react2.default.createElement(
					"header",
					{ className: "Shadowed" },
					_react2.default.createElement(
						_Tabs2.default,
						{
							selected: this.state.page,
							onChange: function onChange(id) {
								return _this2.setState({ page: id });
							}
						},
						_react2.default.createElement(
							"li",
							{ id: "poiCrossingNotifications" },
							_lang2.default.POI_CROSSING_NOTIFICATIONS
						),
						_react2.default.createElement(
							"li",
							{ id: "criticalValueNotifications" },
							_lang2.default.CRITICAL_VALUE_NOTIFICATIONS
						)
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "Content" },
					_react2.default.createElement(
						_Pager2.default,
						{ active: this.state.page },
						_react2.default.createElement(
							"div",
							{ id: "poiCrossingNotifications" },
							_react2.default.createElement(_POICrossingNotifications2.default, null)
						),
						_react2.default.createElement(
							"div",
							{ id: "criticalValueNotifications" },
							_react2.default.createElement(_CriticalValueNotifications2.default, null)
						)
					)
				)
			);
		}
	}]);

	return UserNotifications;
}(_react2.default.Component);

exports.default = UserNotifications;


UserNotifications.propTypes = {};

UserNotifications.defaultProps = {};

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UserNotifications = __webpack_require__(427);

var _UserNotifications2 = _interopRequireDefault(_UserNotifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _UserNotifications2.default;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(901);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _ProgressBar = __webpack_require__(34);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _Form = __webpack_require__(38);

var _Form2 = _interopRequireDefault(_Form);

var _Input = __webpack_require__(52);

var _Input2 = _interopRequireDefault(_Input);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _changePassword2 = __webpack_require__(351);

var _changePassword3 = _interopRequireDefault(_changePassword2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserPassword = function (_React$Component) {
	_inherits(UserPassword, _React$Component);

	function UserPassword(props) {
		_classCallCheck(this, UserPassword);

		var _this = _possibleConstructorReturn(this, (UserPassword.__proto__ || Object.getPrototypeOf(UserPassword)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(UserPassword, [{
		key: "initState",
		value: function initState() {
			this.state = {
				oldPassword: "",
				newPassword1: "",
				newPassword2: "",
				errorMessage: "",
				inProgress: false
			};
		}
	}, {
		key: "clear",
		value: function clear() {
			this.setState({
				oldPassword: "",
				newPassword1: "",
				newPassword2: "",
				errorMessage: ""
			});
		}
	}, {
		key: "check",
		value: function check() {
			if (this.state.newPassword1 !== this.state.newPassword2) {
				this.setState({ errorMessage: _lang2.default.CONFIRM_PASSWORD_ERROR_MESSAGE });
				return false;
			} else {
				this.setState({ errorMessage: "" });
				return true;
			}
		}
	}, {
		key: "handleInputChange",
		value: function handleInputChange(which, value) {
			this.setState(_defineProperty({}, which, value));
		}
	}, {
		key: "handleSave",
		value: function handleSave() {
			if (!this.check()) return;
			this.changePassword();
		}
	}, {
		key: "changePassword",
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								this.setState({ inProgress: true });
								_context.prev = 1;
								_context.next = 4;
								return (0, _changePassword3.default)(this.state.oldPassword, this.state.newPassword2);

							case 4:
								this.clear();
								new _Toast2.default(_lang2.default.CHANGE_PASSWORD_SUCCESSFUL);
								_context.next = 11;
								break;

							case 8:
								_context.prev = 8;
								_context.t0 = _context["catch"](1);

								this.setState({
									errorMessage: _context.t0.message
								});

							case 11:
								this.setState({ inProgress: false });

							case 12:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this, [[1, 8]]);
			}));

			function changePassword() {
				return _ref.apply(this, arguments);
			}

			return changePassword;
		}()
	}, {
		key: "getSaveButtonDisabled",
		value: function getSaveButtonDisabled() {
			if (!this.state.oldPassword || !this.state.newPassword1 || !this.state.newPassword2) return true;
			return false;
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				"div",
				{ className: "UserPassword" },
				_react2.default.createElement(
					"header",
					{ className: "Shadowed" },
					_react2.default.createElement(
						_Button2.default,
						{ className: "Red", disabled: this.getSaveButtonDisabled(), onClick: function onClick(_) {
								return _this2.handleSave();
							} },
						_lang2.default.SAVE
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "Content" },
					_react2.default.createElement(_ProgressBar2.default, { indeterminate: true, shown: this.state.inProgress }),
					_react2.default.createElement(
						_Card2.default,
						{ className: this.state.inProgress ? "Hidden" : null },
						_react2.default.createElement(
							_Form2.default,
							null,
							_react2.default.createElement(
								"span",
								{ className: !this.state.errorMessage ? "Hidden" : "", id: "errorMessage" },
								this.state.errorMessage
							),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.OLD_PASSWORD
							),
							_react2.default.createElement(_Input2.default, { type: "password", value: this.state.oldPassword, onChange: function onChange(evt) {
									return _this2.handleInputChange("oldPassword", evt.target.value);
								} }),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.NEW_PASSWORD
							),
							_react2.default.createElement(_Input2.default, { type: "password", value: this.state.newPassword1, onChange: function onChange(evt) {
									return _this2.handleInputChange("newPassword1", evt.target.value);
								} }),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.CONFIRM_NEW_PASSWORD
							),
							_react2.default.createElement(_Input2.default, { type: "password", value: this.state.newPassword2, onChange: function onChange(evt) {
									return _this2.handleInputChange("newPassword2", evt.target.value);
								} })
						)
					)
				)
			);
		}
	}]);

	return UserPassword;
}(_react2.default.Component);

exports.default = UserPassword;


UserPassword.propTypes = {};

UserPassword.defaultProps = {};

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UserPassword = __webpack_require__(429);

var _UserPassword2 = _interopRequireDefault(_UserPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _UserPassword2.default;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Details = __webpack_require__(148);

var _Details2 = _interopRequireDefault(_Details);

var _Pager = __webpack_require__(87);

var _Pager2 = _interopRequireDefault(_Pager);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _UserPassword = __webpack_require__(430);

var _UserPassword2 = _interopRequireDefault(_UserPassword);

var _UserContacts = __webpack_require__(426);

var _UserContacts2 = _interopRequireDefault(_UserContacts);

var _UserNotifications = __webpack_require__(428);

var _UserNotifications2 = _interopRequireDefault(_UserNotifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserSettings = function (_React$Component) {
	_inherits(UserSettings, _React$Component);

	function UserSettings(props) {
		_classCallCheck(this, UserSettings);

		var _this = _possibleConstructorReturn(this, (UserSettings.__proto__ || Object.getPrototypeOf(UserSettings)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(UserSettings, [{
		key: "initState",
		value: function initState() {
			this.state = {
				page: "notifications"
			};
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			var tabs = [{ id: "notifications", label: _lang2.default.NOTIFICATIONS }, { id: "contacts", label: _lang2.default.CONTACTS }, { id: "password", label: _lang2.default.PASSWORD }];

			var detailsProps = {
				title: _lang2.default.SETTINGS,
				onClose: function onClose() {
					return _this2.props.onClose();
				},
				tabs: tabs,
				onTabChange: function onTabChange(tabId) {
					return _this2.setState({ page: tabId });
				},
				activeTab: this.state.page,
				dragable: false
			};

			return _react2.default.createElement(
				_Details2.default,
				detailsProps,
				_react2.default.createElement(
					_Pager2.default,
					{ active: this.state.page },
					_react2.default.createElement(
						"div",
						{ id: "notifications" },
						_react2.default.createElement(_UserNotifications2.default, null)
					),
					_react2.default.createElement(
						"div",
						{ id: "contacts" },
						_react2.default.createElement(_UserContacts2.default, null)
					),
					_react2.default.createElement(
						"div",
						{ id: "password" },
						_react2.default.createElement(_UserPassword2.default, null)
					)
				)
			);
		}
	}]);

	return UserSettings;
}(_react2.default.Component);

exports.default = UserSettings;


UserSettings.propTypes = {
	onClose: _react2.default.PropTypes.func
};

UserSettings.defaultProps = {
	onClose: function onClose() {}
};

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UserSettings = __webpack_require__(431);

var _UserSettings2 = _interopRequireDefault(_UserSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _UserSettings2.default;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(902);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _highcharts = __webpack_require__(762);

var _highcharts2 = _interopRequireDefault(_highcharts);

var _reactHighcharts = __webpack_require__(834);

var _reactHighcharts2 = _interopRequireDefault(_reactHighcharts);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _dataTypes = __webpack_require__(68);

var _dataTypes2 = _interopRequireDefault(_dataTypes);

var _user = __webpack_require__(20);

var _vehicleActivity = __webpack_require__(104);

var _vehicleActivity2 = _interopRequireDefault(_vehicleActivity);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _createWellQuantity = __webpack_require__(88);

var _createWellQuantity2 = _interopRequireDefault(_createWellQuantity);

var _EEP = __webpack_require__(33);

var _EEP2 = _interopRequireDefault(_EEP);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(763)(_reactHighcharts2.default.Highcharts);
__webpack_require__(764)(_reactHighcharts2.default.Highcharts);

var HIGHCHARTS_LEGEND_INDEX = {
	"MaxSpeed": 4,
	"AvgSpeed": 6,
	"TotalVehicleDistance": 5,
	"FuelConsumption": 7,
	"FuelLevel": 8,
	"TotalFuelUsed": 9,
	"EngineSpeed": 10,
	"EngineLoad": 11,
	"TotalHoursOfOperation": 12,
	"SignalStrength": 3,
	"BackupSupplyVoltage": 2,
	"BatteryVoltage": 1,
	"AcceleratorPedalPosition": 13,
	"BrakeForce": 14
};

var HIGHCHARTS_COLOR_INDEX = {
	"MaxSpeed": "#F21515",
	"AvgSpeed": "#11C111",
	"TotalVehicleDistance": "#3F51B5",
	"FuelConsumption": "#26A69A",
	"FuelLevel": "#4CAF50",
	"TotalFuelUsed": "#7CB342",
	"EngineSpeed": "#D50000",
	"EngineLoad": "#8BC34A",
	"TotalHoursOfOperation": "#880E4F",
	"BackupSupplyVoltage": "#006064",
	"BatteryVoltage": "#F57F17",
	"AcceleratorPedalPosition": "#6200EA",
	"BrakeForce": "#263238",
	"SignalStrength": "#757575"
};

var SELECTED_POSITION_ZOOM = 15;

var VehicleActivityChart = function (_React$Component) {
	_inherits(VehicleActivityChart, _React$Component);

	function VehicleActivityChart(props) {
		_classCallCheck(this, VehicleActivityChart);

		var _this2 = _possibleConstructorReturn(this, (VehicleActivityChart.__proto__ || Object.getPrototypeOf(VehicleActivityChart)).call(this, props));

		_this2.initState();
		_this2.eep = new _EEP2.default();
		_this2.setStoreListeners();

		_highcharts2.default.setOptions({
			global: {
				useUTC: false
				//timezoneOffset: (new Date()).getTimezoneOffset()  //this isnt needed
			}
		});
		return _this2;
	}

	_createClass(VehicleActivityChart, [{
		key: "initState",
		value: function initState() {
			this.state = {
				sections: null,
				selectedRoute: { from: null, to: null }
			};
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this3 = this;

			this.eep.on(vehicleActivityStore, "insert", function (activityDescriptors) {
				return _this3.handleInsertActivityDescriptors(activityDescriptors);
			});
			this.eep.on(vehicleActivityStore, "update", function (activityDescriptor) {
				return _this3.handleUpdateActivityDescriptor(activityDescriptor);
			});
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			this.eep.close();
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate(nextProps, nextState) {
			if (nextState.selectedRoute.from != this.state.selectedRoute.from || nextState.selectedRoute.to != this.state.selectedRoute.to) {
				this.setExtremes(nextState.selectedRoute.from, nextState.selectedRoute.to);
			}
			if (nextState.sections != this.state.sections) {
				return true;
			}
			return false;
		}
	}, {
		key: "handleInsertActivityDescriptors",
		value: function handleInsertActivityDescriptors(activityDescriptors) {
			var _this4 = this;

			var activityDescriptor = activityDescriptors.find(function (d) {
				return d.vehicle == _this4.props.vehicleId;
			});

			if (!activityDescriptor) {
				return;
			}

			this.setState({
				sections: activityDescriptor.sections
			});

			this.updateChart();
		}
	}, {
		key: "handleUpdateActivityDescriptor",
		value: function handleUpdateActivityDescriptor(activityDescriptor) {
			if (activityDescriptor.vehicle != this.props.vehicleId || activityDescriptor.pending) {
				return;
			}

			if (activityDescriptor.sections != this.state.sections) {
				this.setState({
					sections: activityDescriptor.sections
				});
				this.updateChart();
			}

			if (activityDescriptor.selectedRoute && this.state.selectedRoute != activityDescriptor.selectedRoute) {
				this.setState({
					selectedRoute: activityDescriptor.selectedRoute
				});
			}
		}
	}, {
		key: "updateChart",
		value: function updateChart() {
			var _this5 = this;

			if (!this.state.sections || !this.refs.chart) {
				return;
			}

			var seriesArray = generateHighchartsCompatibleSeriesFromSections(this.state.sections);
			seriesArray.forEach(function (series) {
				_this5.refs.chart.getChart().addSeries(series);
				if (_this5.refs.chart.getChart().yAxis[series.yAxis].hasVisibleSeries) {
					_this5.refs.chart.getChart().yAxis[series.yAxis].setExtremes(series.min, series.max);
				}
			});

			var plotBandsArray = generateHighchartsPlotBandsFromSections(this.state.sections);
			plotBandsArray.forEach(function (plotBand) {
				_this5.refs.chart.getChart().xAxis[0].addPlotBand(plotBand);
			});

			setTimeout(function () {
				this.refs.chart.getChart().reflow();
			}.bind(this));
		}
	}, {
		key: "onSelectRoute",
		value: function onSelectRoute(from, to) {
			_dispatcher2.default.dispatch("selectVehicleActivityRoute", this.props.vehicleId, from, to);
			_vehicleActivity2.default.focusOnVehicleActivity(this.props.vehicleId, from, to);
		}
	}, {
		key: "onClearSelection",
		value: function onClearSelection() {
			_dispatcher2.default.dispatch("selectVehicleActivityRoute", this.props.vehicleId, null, null);
			_vehicleActivity2.default.focusOnVehicleActivity(this.props.vehicleId, null, null);
		}
	}, {
		key: "onMouseOverOnChartPoint",
		value: function onMouseOverOnChartPoint(time) {
			_dispatcher2.default.dispatch("selectVehicleActivityPosition", this.props.vehicleId, time);
		}
	}, {
		key: "onMouseOutFromChart",
		value: function onMouseOutFromChart() {
			_dispatcher2.default.dispatch("selectVehicleActivityPosition", this.props.vehicleId, null);
		}
	}, {
		key: "onClickOnChartPoint",
		value: function onClickOnChartPoint(time) {
			_dispatcher2.default.dispatch("selectVehicleActivityPosition", this.props.vehicleId, time);

			var positionLatLng = _vehicleActivity2.default.getLatLngOfVehicleRoutesByTime(this.props.vehicleId, time);
			if (positionLatLng) {
				_dispatcher2.default.dispatch("setMap", { center: positionLatLng.toJSON(), zoom: SELECTED_POSITION_ZOOM });
			}
		}
	}, {
		key: "setExtremes",
		value: function setExtremes(from, to) {
			this.refs.chart.getChart().xAxis[0].setExtremes(from, to);
		}
	}, {
		key: "renderChart",
		value: function renderChart() {
			var _this = this;
			var unitAssignment = (0, _user.getUnitAssignment)();

			var chartConfig = {
				exporting: {
					chartOptions: { // specific options for the exported image
						plotOptions: {
							series: {
								connectNulls: true,
								dataLabels: {
									enabled: false
								}
							}
						}
					},
					fallbackToExportServer: false
				},
				chart: {
					resetZoomButton: {
						position: {
							verticalAlign: "bottom",
							x: -10,
							y: -28
						},
						relativeTo: "chart"
					},
					events: {
						click: function (evt) {
							var selectedPosition = vehicleActivityStore.get(this.props.vehicleId).selectedPosition;
							_this.onClickOnChartPoint(selectedPosition);
						}.bind(_this),
						selection: function selection(evt) {
							if (!evt.xAxis) {
								_this.onClearSelection();
								return;
							};
							_this.onSelectRoute(evt.xAxis[0].min, evt.xAxis[0].max);
							_this.refs.chart.getChart().showResetZoom();
						}
					},
					zoomType: "x",
					height: 320
				},
				plotOptions: {
					series: {
						point: {
							events: {
								mouseOver: function (evt) {
									this.onMouseOverOnChartPoint(evt.target.x);
								}.bind(_this),
								click: function (evt) {
									this.onClickOnChartPoint(evt.point.x);
								}.bind(_this)
							}
						},
						events: {
							hide: function (evt) {
								this.refs.chart.getChart().zoom();
								this.refs.chart.getChart().redraw(_highcharts2.default.pick(this.refs.chart.getChart().options.chart.animation, evt && evt.animation, this.refs.chart.getChart().pointCount < 100));
							}.bind(_this),
							mouseOut: function (evt) {
								this.onMouseOutFromChart();
							}.bind(this)
						}
					},
					area: {}
				},
				legend: {
					//adds tooltip to the legends
					useHTML: true,
					labelFormatter: function labelFormatter() {

						return '<div class="tooltip">' + this.name + '<span class="tooltiptext">Click here to fix it</span>' + '</div>';
					}
				},
				xAxis: {
					type: 'datetime',
					dateTimeLabelFormats: {
						minute: getLocaleTimeFormat() == "12H" ? '%l:%M %p' : '%H:%M',
						hour: getLocaleTimeFormat() == "12H" ? '%l:%M %p' : '%H:%M',
						month: '%e. %b',
						year: '%b'
					},
					events: {
						afterSetExtremes: function (evt) {
							if (!this.refs.chart.getChart().resetZoomButton) {
								this.refs.chart.getChart().showResetZoom();
							}
							for (var i in this.refs.chart.getChart().yAxis) {
								if (_this.yAxisExtremes && _this.yAxisExtremes[i] && this.refs.chart.getChart().yAxis[i].hasVisibleSeries) {
									this.refs.chart.getChart().yAxis[i].setExtremes(_this.yAxisExtremes[i].min, _this.yAxisExtremes[i].max);
								}
							}
						}.bind(_this)
					}
				},
				tooltip: {
					formatter: function formatter() {
						var timeFormatString = getLocaleTimeFormat() == "12H" ? "%A,  %Y. %b %e %I:%M %p" : "%A,  %Y. %b %e %H:%M";
						var text = "<span style=\"text-decoration: underline;\">" + _highcharts2.default.dateFormat(timeFormatString, this.x) + "</span>";
						this.points.forEach(function (point, index) {
							text += '<br><b>' + point.series.name + ':</b> ' + point.y.toFixed(point.series.options.roundingDecimals ? point.series.options.roundingDecimals : 0) + ' ' + point.series.options.tooltipUnit;
						});
						return text;
					},
					borderWidth: 0,
					shared: true
				},
				title: {
					text: ""
				},
				yAxis: [{ //0 Temperature
					labels: {
						format: '{value:.1f}'
					},
					title: {
						text: unitAssignment.temperature
					},
					options: {
						quantity: "Temperature",
						unit: unitAssignment.temperature
					},
					opposite: true,
					showEmpty: false
				}, { //1 Speed
					labels: {
						format: '{value}'
					},
					title: {
						text: unitAssignment.vehicleSpeed
					},
					options: {
						quantity: "Speed",
						unit: unitAssignment.vehicleSpeed
					},
					opposite: true,
					showEmpty: false,
					min: 0
				}, { //2 Rpm
					labels: {
						format: '{value}'
					},
					title: {
						text: unitAssignment.rpm
					},
					options: {
						quantity: unitAssignment.rpm,
						unit: ""
					},
					opposite: true,
					showEmpty: false
				}, { //3 Voltage
					labels: {
						format: '{value:.1f}'
					},
					title: {
						text: unitAssignment.voltage
					},
					options: {
						quantity: "Voltage",
						unit: unitAssignment.voltage
					},
					opposite: true,
					showEmpty: false,
					min: 0
				}, { //4 Distance
					labels: {
						format: '{value}'
					},
					title: {
						text: unitAssignment.distanceTraveled
					},
					options: {
						quantity: "Distance",
						unit: unitAssignment.distanceTraveled
					},
					opposite: true,
					showEmpty: false
				}, { //5 Time
					labels: {
						format: '{value}'
					},
					title: {
						text: _lang2.default.TIME + "[" + unitAssignment.timeTraveled + "]"
					},
					options: {
						quantity: "Time",
						unit: unitAssignment.timeTraveled
					},
					opposite: true,
					showEmpty: false
				}, { //6 Volume
					labels: {
						format: '{value:.1f}'
					},
					title: {
						text: _lang2.default.VOLUME + "[" + unitAssignment.fuelQuantity + "]"
					},
					options: {
						quantity: "Fuel Level",
						unit: unitAssignment.fuelQuantity
					},
					opposite: true,
					showEmpty: false,
					min: 0
				}, { //7 FuelConsumption
					labels: {
						format: '{value:.1f}'
					},
					title: {
						text: unitAssignment.consumption
					},
					options: {
						quantity: "Consumption",
						unit: unitAssignment.consumption
					},
					opposite: true,
					showEmpty: false,
					min: 0
				}, { //8 Signal Strength
					labels: {
						format: '{value}'
					},
					title: {
						text: "Signal Strength"
					},
					opposite: true,
					showEmpty: false,
					min: 0
				}, { //9 Percentage
					labels: {
						format: '{value}'
					},
					title: {
						text: "%"
					},
					opposite: true,
					showEmpty: false,
					min: 0
				}]
			};

			return _react2.default.createElement(_reactHighcharts2.default, { config: chartConfig, ref: "chart" });
		}
	}, {
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				_Card2.default,
				{ className: "VehicleActivityChart" },
				this.renderChart()
			);
		}
	}]);

	return VehicleActivityChart;
}(_react2.default.Component);

exports.default = VehicleActivityChart;


VehicleActivityChart.propTypes = {
	vehicleId: _react2.default.PropTypes.string
};

VehicleActivityChart.defaultProps = {
	vehicleId: null
};

function generateHighchartsPlotBandsFromSections(sections) {
	if (!sections) {
		return null;
	}

	return sections.filter(function (section) {
		return section.active;
	}).map(function (activeSection) {
		return {
			from: activeSection.start.time.value,
			to: activeSection.end.time.value,
			color: "rgba(255, 169, 0, 0.1)",
			id: "plotline"
		};
	});
}

function generateHighchartsCompatibleSeriesFromSections(sections) {
	if (!sections) {
		return null;
	}

	var dataSeries = {}; //for sorting by datatypes //dataType szerint csoportos�tott series-ek

	var unitAssignment = (0, _user.getUnitAssignment)();

	sections.forEach(function (section) {
		return section.data.forEach(function (data) {
			if (data.type != "Scalar" || data.dataType == _dataTypes2.default.get("MobileNetworkCode")._id) {
				return;
			}
			if (!dataSeries[_dataTypes2.default.get(data.dataType).name]) {
				dataSeries[_dataTypes2.default.get(data.dataType).name] = {};
			}

			var wellQuantity = (0, _createWellQuantity2.default)(unitAssignment, _dataTypes2.default.get(data.dataType).applicationType, data.value, _dataTypes2.default.get(data.dataType).unit, _dataTypes2.default.get(data.dataType).representationType);

			dataSeries[_dataTypes2.default.get(data.dataType).name][data.time] = wellQuantity.value;
		});
	});

	var series = []; //Highcharts format
	for (var dataType in dataSeries) {
		var seriesElement = {};
		seriesElement.dataType = dataType;
		seriesElement.data = [];
		seriesElement.name = _lang2.default["DATA_TYPE_" + _dataTypes2.default.get(dataType)._id];
		seriesElement.min = dataSeries[dataType][Object.keys(dataSeries[dataType])[0]];
		seriesElement.max = dataSeries[dataType][Object.keys(dataSeries[dataType])[0]];

		for (var value in dataSeries[dataType]) {
			seriesElement.data.push([parseInt(value), dataSeries[dataType][value]]);

			if (dataSeries[dataType][value] < seriesElement.min) {
				seriesElement.min = dataSeries[dataType][value];
			}

			if (dataSeries[dataType][value] > seriesElement.max) {
				seriesElement.max = dataSeries[dataType][value];
			}
		}

		seriesElement.data = seriesElement.data.sort(function (a, b) {
			return a[0] - b[0];
		});

		seriesElement.type = "spline";
		seriesElement.unit = _dataTypes2.default.get(seriesElement.dataType).unit || _lang2.default["DATA_TYPE_" + _dataTypes2.default.get(seriesElement.dataType)._id];
		seriesElement.tooltipUnit = unitAssignment[_dataTypes2.default.get(seriesElement.dataType).applicationType] || "";
		seriesElement.legendIndex = HIGHCHARTS_LEGEND_INDEX[seriesElement.dataType];
		seriesElement.color = HIGHCHARTS_COLOR_INDEX[seriesElement.dataType];

		if (seriesElement.name == _lang2.default.TEMPERATURE) {
			seriesElement.yAxis = 0;
		} else if (seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("MaxSpeed")._id]) {
			seriesElement.yAxis = 1;
			seriesElement.min = 0;
		} else if (seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("AvgSpeed")._id]) {
			seriesElement.yAxis = 1;
			seriesElement.roundingDecimals = 2;
			seriesElement.min = 0;
		} else if (seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("EngineSpeed")._id]) {
			seriesElement.yAxis = 2;
			seriesElement.min = 0;
		} else if (seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("BatteryVoltage")._id] || seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("BackupSupplyVoltage")._id]) {
			seriesElement.yAxis = 3;
			seriesElement.visible = false;
			seriesElement.roundingDecimals = 2;
			seriesElement.min = 0;
		} else if (seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("TotalVehicleDistance")._id]) {
			seriesElement.yAxis = 4;
			seriesElement.roundingDecimals = 2;
		} else if (seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("TotalHoursOfOperation")._id]) {
			seriesElement.yAxis = 5;
		} else if (seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("TotalFuelUsed")._id] || seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("FuelLevel")._id]) {
			seriesElement.yAxis = 6;
			seriesElement.roundingDecimals = 2;
			seriesElement.min = 0;
		} else if (seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("BrakeForce")._id] || seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("AcceleratorPedalPosition")._id] || seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("EngineLoad")._id]) {
			seriesElement.yAxis = 9;
			seriesElement.min = 0;
		} else if (seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("FuelConsumption")._id]) {
			seriesElement.yAxis = 7;
			seriesElement.roundingDecimals = 2;
			seriesElement.min = 0;
		} else if (seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("SignalStrength")._id]) {
			seriesElement.yAxis = 8;
			seriesElement.min = 0;
		}

		if (seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("MaxSpeed")._id] || seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("EngineSpeed")._id] || seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("AcceleratorPedalPosition")._id] || seriesElement.name == _lang2.default["DATA_TYPE_" + _dataTypes2.default.get("EngineLoad")._id]) {

			seriesElement.step = "right";
			seriesElement.type = "line";
		}

		series.push(seriesElement);
	}

	return series;
}

function getLocaleTimeFormat() {
	var localeFormattedTimeString = new Date().toLocaleTimeString();
	if (localeFormattedTimeString.search("am") != -1 || localeFormattedTimeString.search("AM") != -1 || localeFormattedTimeString.search("pm") != -1 || localeFormattedTimeString.search("PM") != -1) {
		return "12H";
	}

	return "24H";
}

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VehicleActivityChart = __webpack_require__(433);

var _VehicleActivityChart2 = _interopRequireDefault(_VehicleActivityChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VehicleActivityChart2.default;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(903);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _Pin = __webpack_require__(61);

var _Pin2 = _interopRequireDefault(_Pin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SectionCard = function (_React$Component) {
	_inherits(SectionCard, _React$Component);

	function SectionCard(props) {
		_classCallCheck(this, SectionCard);

		var _this = _possibleConstructorReturn(this, (SectionCard.__proto__ || Object.getPrototypeOf(SectionCard)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(SectionCard, [{
		key: "initState",
		value: function initState() {
			this.state = {
				expanded: false
			};
		}
	}, {
		key: "toggle",
		value: function toggle() {
			this.setState({
				expanded: !this.state.expanded
			});
		}
	}, {
		key: "handleAddressClick",
		value: function handleAddressClick(evt, which) {
			evt.stopPropagation();
			this.props.onAddressClick(which);
		}
	}, {
		key: "handleDataClick",
		value: function handleDataClick(evt, which) {
			evt.stopPropagation();
			this.props.onFixData(which);
		}
	}, {
		key: "isDisplayedData",
		value: function isDisplayedData(which) {
			return this.props.fixedData.includes(which) || this.state.expanded;
		}
	}, {
		key: "areDisplayedAnyData",
		value: function areDisplayedAnyData() {
			return this.props.fixedData.length > 0;
		}
	}, {
		key: "isBodyShown",
		value: function isBodyShown() {
			return this.state.expanded || this.areDisplayedAnyData();
		}
	}, {
		key: "getRowDataClassName",
		value: function getRowDataClassName(which) {
			return (0, _classnames2.default)({ "Hidden": !this.isDisplayedData(which) }, { "Fixed": this.props.fixedData.includes(which) });
		}
	}, {
		key: "renderCardHeader",
		value: function renderCardHeader() {
			var _this2 = this;

			return _react2.default.createElement(
				"header",
				null,
				_react2.default.createElement(
					"div",
					{ className: "SectionNumber" },
					_react2.default.createElement(
						"label",
						{ onClick: function onClick(evt) {
								return _this2.props.onClick();
							} },
						this.props.isSummary ? "Σ" : this.props.sectionNumber
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "TimeAndAddress" },
					_react2.default.createElement(
						"div",
						null,
						_react2.default.createElement(
							"div",
							null,
							this.props.section.start.time.toLocaleString()
						),
						_react2.default.createElement(
							"div",
							null,
							this.props.section.active && this.props.section.start.truncated ? _react2.default.createElement(
								"label",
								{ className: "EnRoute" },
								_lang2.default.EN_ROUTE
							) : null,
							_react2.default.createElement(
								"label",
								{
									className: "Address",
									onClick: function onClick(evt) {
										return _this2.handleAddressClick(evt, "start");
									}
								},
								this.props.section.start.address
							)
						)
					),
					_react2.default.createElement(
						"div",
						null,
						_react2.default.createElement(
							"div",
							null,
							this.props.section.end.time.toLocaleString()
						),
						_react2.default.createElement(
							"div",
							null,
							this.props.section.active && this.props.section.end.truncated ? _react2.default.createElement(
								"label",
								{ className: "EnRoute" },
								_lang2.default.EN_ROUTE
							) : null,
							_react2.default.createElement(
								"label",
								{
									className: "Address",
									onClick: function onClick(evt) {
										return _this2.handleAddressClick(evt, "end");
									}
								},
								this.props.section.end.address
							)
						)
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "DistanceAndTimeDiff" },
					_react2.default.createElement(
						"label",
						null,
						this.props.section.totalVehicleDistanceDiff,
						" / ",
						this.props.section.timeDiff
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "Pin" },
					_react2.default.createElement(_Pin2.default, {
						checked: this.props.pinned,
						indeterminate: !this.props.pinnedAll,
						onChange: function onChange(value) {
							return _this2.props.onPinChange(value);
						},
						useForAll: this.props.isSummary
					})
				)
			);
		}
	}, {
		key: "renderCardBody",
		value: function renderCardBody() {
			var _this3 = this;

			return _react2.default.createElement(
				"table",
				{ className: (0, _classnames2.default)({ "Hidden": !this.isBodyShown() }) },
				_react2.default.createElement(
					"tbody",
					null,
					_react2.default.createElement(
						"tr",
						{ className: this.getRowDataClassName("totalVehicleDistance") },
						_react2.default.createElement(
							"td",
							{
								title: _lang2.default.CLICK_HERE_TO_FIX_IT,
								onClick: function onClick(evt) {
									return _this3.handleDataClick(evt, "totalVehicleDistance");
								}
							},
							_lang2.default.TOTAL_VEHICLE_DISTANCE
						),
						_react2.default.createElement(
							"td",
							null,
							this.props.section.start.totalVehicleDistance
						),
						_react2.default.createElement(
							"td",
							null,
							" \u2192 "
						),
						_react2.default.createElement(
							"td",
							null,
							this.props.section.end.totalVehicleDistance
						)
					),
					_react2.default.createElement(
						"tr",
						{ className: this.getRowDataClassName("avgSpeed") },
						_react2.default.createElement(
							"td",
							{
								title: _lang2.default.CLICK_HERE_TO_FIX_IT,
								onClick: function onClick(evt) {
									return _this3.handleDataClick(evt, "avgSpeed");
								}
							},
							_lang2.default.AVERAGE_SPEED
						),
						_react2.default.createElement(
							"td",
							null,
							this.props.section.avgSpeed
						)
					),
					_react2.default.createElement(
						"tr",
						{ className: this.getRowDataClassName("maxSpeed") },
						_react2.default.createElement(
							"td",
							{
								title: _lang2.default.CLICK_HERE_TO_FIX_IT,
								onClick: function onClick(evt) {
									return _this3.handleDataClick(evt, "maxSpeed");
								}
							},
							_lang2.default.MAXIMUM_SPEED
						),
						_react2.default.createElement(
							"td",
							null,
							this.props.section.maxSpeed
						)
					)
				)
			);
		}
	}, {
		key: "renderCardFooter",
		value: function renderCardFooter() {
			var _this4 = this;

			return _react2.default.createElement(
				"footer",
				{
					onClick: function onClick(evt) {
						evt.stopPropagation();_this4.toggle();
					}
				},
				"\u2022\u2022\u2022"
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this5 = this;

			return _react2.default.createElement(
				_Card2.default,
				{
					className: "SectionCard",
					onClick: function onClick() {
						return _this5.props.onClick();
					},
					onMouseEnter: function onMouseEnter() {
						return _this5.props.onMouseEnter();
					},
					onMouseLeave: function onMouseLeave() {
						return _this5.props.onMouseLeave();
					}
				},
				this.renderCardHeader(),
				this.renderCardBody(),
				this.renderCardFooter()
			);
		}
	}]);

	return SectionCard;
}(_react2.default.Component);

exports.default = SectionCard;


SectionCard.propTypes = {
	section: _react2.default.PropTypes.object,
	sectionNumber: _react2.default.PropTypes.number,
	isSummary: _react2.default.PropTypes.bool,
	fixedData: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string),
	pinned: _react2.default.PropTypes.bool,
	pinnedAll: _react2.default.PropTypes.bool,
	onPinChange: _react2.default.PropTypes.func,
	onClick: _react2.default.PropTypes.func,
	onMouseEnter: _react2.default.PropTypes.func,
	onMouseLeave: _react2.default.PropTypes.func,
	onAddressClick: _react2.default.PropTypes.func,
	onFixData: _react2.default.PropTypes.func
};

SectionCard.defaultProps = {
	section: null,
	sectionNumber: null,
	isSummary: false,
	fixedData: [],
	pinned: false,
	pinnedAll: false,
	onPinChange: function onPinChange(pinStatus) {},
	onClick: function onClick() {},
	onMouseEnter: function onMouseEnter() {},
	onMouseLeave: function onMouseLeave() {},
	onAddressClick: function onAddressClick(which) {},
	onFixData: function onFixData(which) {}
};

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SectionCard = __webpack_require__(435);

var _SectionCard2 = _interopRequireDefault(_SectionCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SectionCard2.default;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(904);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _Pin = __webpack_require__(61);

var _Pin2 = _interopRequireDefault(_Pin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Section = function (_React$Component) {
	_inherits(Section, _React$Component);

	function Section() {
		_classCallCheck(this, Section);

		return _possibleConstructorReturn(this, (Section.__proto__ || Object.getPrototypeOf(Section)).apply(this, arguments));
	}

	_createClass(Section, [{
		key: "isDayChanger",
		value: function isDayChanger() {
			var start = this.props.section.start.time;
			var end = this.props.section.end.time;

			if (start.getDate() != end.getDate()) return true;else return false;
		}
	}, {
		key: "handleAddressClick",
		value: function handleAddressClick(evt, which) {
			evt.stopPropagation();
			this.props.onAddressClick(which);
		}
	}, {
		key: "renderDot",
		value: function renderDot() {
			if (this.props.section.active) return null;

			return _react2.default.createElement("div", { className: "Dot" });
		}
	}, {
		key: "renderLabel",
		value: function renderLabel() {
			if (this.props.isFirst) {
				var label = this.props.section.active ? this.props.section.start.time.toLocaleDateString() : this.props.section.end.time.toLocaleDateString();
				return _react2.default.createElement(
					"label",
					null,
					label
				);
			} else if (this.isDayChanger()) {
				return _react2.default.createElement(
					"label",
					null,
					this.props.section.end.time.toLocaleDateString()
				);
			} else {
				return null;
			}
		}
	}, {
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"div",
				{ className: (0, _classnames2.default)("Section", { "First": this.props.isFirst }) },
				_react2.default.createElement(
					"div",
					null,
					this.renderLabel()
				),
				_react2.default.createElement(
					"div",
					null,
					this.renderDot(),
					this.props.children
				)
			);
		}
	}]);

	return Section;
}(_react2.default.Component);

exports.default = Section;


Section.propTypes = {
	section: _react2.default.PropTypes.object,
	isFirst: _react2.default.PropTypes.bool
};

Section.defaultProps = {
	section: null,
	isFirst: false
};

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Section = __webpack_require__(437);

var _Section2 = _interopRequireDefault(_Section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Section2.default;

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(905);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _vehicleActivities = __webpack_require__(121);

var _vehicleActivities2 = _interopRequireDefault(_vehicleActivities);

var _vehicleActivity = __webpack_require__(104);

var _vehicleActivity2 = _interopRequireDefault(_vehicleActivity);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _EEP = __webpack_require__(33);

var _EEP2 = _interopRequireDefault(_EEP);

var _Section = __webpack_require__(438);

var _Section2 = _interopRequireDefault(_Section);

var _SectionCard = __webpack_require__(436);

var _SectionCard2 = _interopRequireDefault(_SectionCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ALL = Symbol();
var ANY = Symbol();

var VehicleActivityTimeline = function (_React$Component) {
	_inherits(VehicleActivityTimeline, _React$Component);

	function VehicleActivityTimeline(props) {
		_classCallCheck(this, VehicleActivityTimeline);

		var _this = _possibleConstructorReturn(this, (VehicleActivityTimeline.__proto__ || Object.getPrototypeOf(VehicleActivityTimeline)).call(this, props));

		_this.initState();
		_this.eep = new _EEP2.default();
		_this.setStoreListeners();
		return _this;
	}

	_createClass(VehicleActivityTimeline, [{
		key: "initState",
		value: function initState() {
			this.state = Object.assign({
				fixedData: []
			}, this.getStoreDependentState());
		}
	}, {
		key: "getStoreDependentState",
		value: function getStoreDependentState() {
			var resolvedActivity = _vehicleActivity2.default.getResolvedVehicleActivity(this.props.vehicleId);
			var activityDescriptor = _vehicleActivities2.default.get(this.props.vehicleId);

			return {
				from: activityDescriptor ? activityDescriptor.from : null,
				to: activityDescriptor ? activityDescriptor.to : null,
				summary: resolvedActivity ? resolvedActivity.summary : null,
				sections: resolvedActivity ? resolvedActivity.sections : null,
				pinnedSections: activityDescriptor ? Array.from(activityDescriptor.pinnedSections) : []
			};
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			this.eep.on(_vehicleActivities2.default, "insert", function (descriptors) {
				var descriptor = descriptors.find(function (d) {
					return d.vehicle == _this2.props.vehicleId;
				});
				if (descriptor && !descriptor.pending) {
					_this2.setState(_this2.getStoreDependentState());
				}
			});
			this.eep.on(_vehicleActivities2.default, "update", function (descriptor) {
				if (descriptor.vehicle == _this2.props.vehicleId && !descriptor.pending) {
					_this2.setState(_this2.getStoreDependentState());
				}
			});
			this.eep.on(_vehicleActivities2.default, "remove", function (vehicleIds) {
				if (vehicleIds.find(function (id) {
					return id == _this2.props.vehicleId;
				})) _this2.setState(_this2.getStoreDependentState());
			});
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			this.eep.close();
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate(_, nextState) {
			var _this3 = this;

			if (nextState.from !== this.state.from || nextState.to !== this.state.to) {
				return true;
			}
			if (nextState.fixedData.some(function (fd) {
				return !_this3.state.fixedData.includes(fd);
			}) || this.state.fixedData.some(function (fd) {
				return !nextState.fixedData.includes(fd);
			})) {
				return true;
			}
			if (nextState.pinnedSections.some(function (ps, i) {
				return ps !== _this3.state.pinnedSections[i];
			})) {
				return true;
			}
			return false;
		}
	}, {
		key: "getSectionsCumulativePinnedStatus",
		value: function getSectionsCumulativePinnedStatus(how) {
			var _this4 = this;

			if (!this.state.sections) return;

			var activeSectionsPinnedStatus = this.state.pinnedSections.filter(function (_, i) {
				return _this4.state.sections[i].active;
			});
			if (how === ALL) return activeSectionsPinnedStatus.every(function (_) {
				return _;
			});else if (how === ANY) return activeSectionsPinnedStatus.some(function (_) {
				return _;
			});

			return false;
		}
	}, {
		key: "handlePinAll",
		value: function handlePinAll(value) {
			if (!this.state.sections) return;

			_dispatcher2.default.dispatch("pinVehicleActivitySection", this.props.vehicleId, this.state.sections.map(function (_, i) {
				return i;
			}), value);
		}
	}, {
		key: "handleHighlightAll",
		value: function handleHighlightAll(value) {
			if (!this.state.sections) return;

			_dispatcher2.default.dispatch("highlightVehicleActivitySection", this.props.vehicleId, this.state.sections.map(function (_, i) {
				return i;
			}), value);
		}
	}, {
		key: "handleOnAddressClick",
		value: function handleOnAddressClick(section, which) {
			if (!section[which].position) return;
			_dispatcher2.default.dispatch("setMap", {
				center: section[which].position,
				zoom: 16
			});
		}
	}, {
		key: "handleFixData",
		value: function handleFixData(which) {
			var prevFixedData = Array.from(this.state.fixedData);
			var index = prevFixedData.indexOf(which);
			if (index > -1) {
				prevFixedData.splice(index, 1);
			} else {
				prevFixedData.push(which);
			}
			this.setState({
				fixedData: prevFixedData
			});
		}
	}, {
		key: "renderSummary",
		value: function renderSummary() {
			var _this5 = this;

			if (!this.state.summary) return null;

			var summary = this.state.summary;

			return _react2.default.createElement(
				"div",
				{ className: "SummaryContainer" },
				_react2.default.createElement("div", { className: "LeftPadding" }),
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(_SectionCard2.default, {
						section: summary,
						isSummary: true,
						fixedData: this.state.fixedData,
						pinned: this.getSectionsCumulativePinnedStatus(ANY),
						pinnedAll: this.getSectionsCumulativePinnedStatus(ALL),
						onPinChange: function onPinChange(value) {
							return _this5.handlePinAll(value);
						},
						onClick: function onClick() {
							_vehicleActivity2.default.focusOnVehicleActivity(_this5.props.vehicleId);
							_dispatcher2.default.dispatch("selectVehicleActivityRoute", _this5.props.vehicleId);
						},
						onAddressClick: function onAddressClick(which) {
							return _this5.handleOnAddressClick(summary, which);
						},
						onMouseEnter: function onMouseEnter() {
							return _this5.handleHighlightAll(true);
						},
						onMouseLeave: function onMouseLeave() {
							return _this5.handleHighlightAll(false);
						},
						onFixData: function onFixData(which) {
							return _this5.handleFixData(which);
						}
					})
				)
			);
		}
	}, {
		key: "renderSection",
		value: function renderSection(section, count, sectionNumber) {
			var _this6 = this;

			return _react2.default.createElement(
				_Section2.default,
				{
					key: count,
					section: section,
					isFirst: count === 0
				},
				section.active ? _react2.default.createElement(_SectionCard2.default, {
					key: count,
					section: section,
					sectionNumber: sectionNumber,
					fixedData: this.state.fixedData,
					pinned: this.state.pinnedSections[count],
					onPinChange: function onPinChange(value) {
						return _dispatcher2.default.dispatch("pinVehicleActivitySection", _this6.props.vehicleId, [count], value);
					},
					onClick: function onClick() {
						_vehicleActivity2.default.focusOnVehicleActivity(_this6.props.vehicleId, section.start.time.getTime(), section.end.time.getTime());
						_dispatcher2.default.dispatch("selectVehicleActivityRoute", _this6.props.vehicleId, section.start.time.getTime(), section.end.time.getTime());
					},
					onAddressClick: function onAddressClick(which) {
						return _this6.handleOnAddressClick(section, which);
					},
					onMouseEnter: function onMouseEnter() {
						return _dispatcher2.default.dispatch("highlightVehicleActivitySection", _this6.props.vehicleId, [count], true);
					},
					onMouseLeave: function onMouseLeave() {
						return _dispatcher2.default.dispatch("highlightVehicleActivitySection", _this6.props.vehicleId, [count], false);
					},
					onFixData: function onFixData(which) {
						return _this6.handleFixData(which);
					}
				}) : null
			);
		}
	}, {
		key: "renderSections",
		value: function renderSections() {
			var _this7 = this;

			if (!this.state.sections || this.state.sections.length == 1 && !this.state.sections[0].active) return null;

			return this.state.sections.map(function (section, i) {
				return _this7.renderSection(section, i, _vehicleActivity2.default.getActiveSectionNumberOfSectionIndex(_this7.props.vehicleId, i));
			});
		}
	}, {
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"div",
				{ className: "VehicleActivityTimeline" },
				_react2.default.createElement(
					"div",
					null,
					this.renderSummary(),
					this.renderSections()
				)
			);
		}
	}]);

	return VehicleActivityTimeline;
}(_react2.default.Component);

exports.default = VehicleActivityTimeline;


VehicleActivityTimeline.propTypes = {
	vehicleId: _react2.default.PropTypes.string
};

VehicleActivityTimeline.defaultProps = {
	vehicleId: null
};

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VehicleActivityTimeline = __webpack_require__(439);

var _VehicleActivityTimeline2 = _interopRequireDefault(_VehicleActivityTimeline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VehicleActivityTimeline2.default;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(906);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _vehicleActivities = __webpack_require__(121);

var _vehicleActivities2 = _interopRequireDefault(_vehicleActivities);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

var _displayedDetails = __webpack_require__(44);

var _displayedDetails2 = _interopRequireDefault(_displayedDetails);

var _vehicleActivity = __webpack_require__(104);

var _vehicleActivity2 = _interopRequireDefault(_vehicleActivity);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _IntervalEditor = __webpack_require__(149);

var _IntervalEditor2 = _interopRequireDefault(_IntervalEditor);

var _ProgressBar = __webpack_require__(34);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _DateTimePicker = __webpack_require__(147);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _EEP = __webpack_require__(33);

var _EEP2 = _interopRequireDefault(_EEP);

var _VehicleActivityChart = __webpack_require__(434);

var _VehicleActivityChart2 = _interopRequireDefault(_VehicleActivityChart);

var _VehicleActivityTimeline = __webpack_require__(440);

var _VehicleActivityTimeline2 = _interopRequireDefault(_VehicleActivityTimeline);

var _getVehicleActivity = __webpack_require__(215);

var _getVehicleActivity2 = _interopRequireDefault(_getVehicleActivity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_INTERVAL = 1000 * 60 * 60 * 24 * 31 * 6;

var VehicleActivity = function (_React$Component) {
	_inherits(VehicleActivity, _React$Component);

	function VehicleActivity(props) {
		_classCallCheck(this, VehicleActivity);

		var _this = _possibleConstructorReturn(this, (VehicleActivity.__proto__ || Object.getPrototypeOf(VehicleActivity)).call(this, props));

		_this.initState();
		_this.eep = new _EEP2.default();
		_this.setStoreListeners();
		return _this;
	}

	_createClass(VehicleActivity, [{
		key: "initState",
		value: function initState() {
			this.state = {
				activityDescriptor: null,
				from: Date.parse(function (d) {
					d.setDate(d.getDate() - 1);return d;
				}(new Date())),
				to: Date.now(),
				inProgress: false
			};
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			this.eep.on(_vehicleActivities2.default, "insert", function (activityDescriptors) {
				return _this2.loadActivity(activityDescriptors);
			});
			this.eep.on(_vehicleActivities2.default, "update", function (activityDescriptor) {
				return _this2.loadActivity([activityDescriptor]);
			});
			this.eep.on(_displayedDetails2.default, "change", function (detailsDescriptor) {
				return _this2.handleDetailsStoreChange(detailsDescriptor);
			});
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate(nextProps, nextState) {
			return true; //egyelőre költségesebb getmodbyref-fel vizsgálni, mint egy újrarenderelés
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			this.eep.close();
		}
	}, {
		key: "handleDetailsStoreChange",
		value: function handleDetailsStoreChange(detailsDescriptor) {
			if (detailsDescriptor && detailsDescriptor.id == this.props.vehicleId && _vehicleActivity2.default.getVisibilityOfActivity(this.props.vehicleId) && !this.state.activityDescriptor) {
				this.getActivityDescriptors();
			}
		}
	}, {
		key: "loadActivity",
		value: function loadActivity(activityDescriptors) {
			if (activityDescriptors[0].vehicle == this.props.vehicleId && activityDescriptors[0] != this.state.activityDescriptor) {

				this.setState({
					from: activityDescriptors[0].pending ? activityDescriptors[0].from : this.state.from,
					to: activityDescriptors[0].pending ? activityDescriptors[0].to : this.state.to,
					activityDescriptor: activityDescriptors[0]
				});
			}
		}
	}, {
		key: "getActivityDescriptors",
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return (0, _getVehicleActivity2.default)(this.props.vehicleId, this.state.from, this.state.to);

							case 2:
								_vehicleActivity2.default.focusOnVehicleActivity(this.props.vehicleId);

							case 3:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function getActivityDescriptors() {
				return _ref.apply(this, arguments);
			}

			return getActivityDescriptors;
		}()
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			if (_openedDetails2.default.get(this.props.vehicleId).activePage == "activity") {
				this.getActivityDescriptors();
			}
		}
	}, {
		key: "render",
		value: function render() {
			var _this3 = this;

			var intervalEditorProps = {
				nullable: false,
				interval: {
					from: this.state.from,
					to: this.state.to
				},
				onChange: function onChange(interval) {
					if (interval.to - interval.from > MAX_INTERVAL) {
						new _Toast2.default(_lang2.default.TOO_LONG_INTERVAL, "Orange");
					}
					_this3.setState({
						from: interval.from,
						to: interval.to
					});
				}
			};

			var noResult = this.state.activityDescriptor && !this.state.activityDescriptor.pending && this.state.activityDescriptor.sections.length == 1 && this.state.activityDescriptor.sections[0].data.length == 0;

			var resultClassNames = (0, _classnames2.default)("Result", { "Invisible": this.state.activityDescriptor && this.state.activityDescriptor.pending || !this.state.activityDescriptor || noResult });

			return _react2.default.createElement(
				"div",
				{ className: "VehicleActivity" },
				_react2.default.createElement(
					"header",
					{ className: "Shadowed" },
					_react2.default.createElement(_IntervalEditor2.default, intervalEditorProps),
					_react2.default.createElement(
						_Button2.default,
						{ className: "Red", disabled: this.state.activityDescriptor && this.state.activityDescriptor.pending || this.state.from && this.state.to && this.state.to - this.state.from > MAX_INTERVAL, onClick: function onClick(_) {
								return _this3.getActivityDescriptors();
							} },
						_lang2.default.SUBMIT
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "Content" },
					_react2.default.createElement(_ProgressBar2.default, { indeterminate: true, shown: this.state.activityDescriptor && this.state.activityDescriptor.pending }),
					_react2.default.createElement(
						"h1",
						{ className: (0, _classnames2.default)("Message", { "Hidden": !noResult }) },
						_lang2.default.NO_RESULTS_FOUND
					),
					_react2.default.createElement(
						"div",
						{ className: resultClassNames },
						_react2.default.createElement(_VehicleActivityChart2.default, { vehicleId: this.props.vehicleId }),
						_react2.default.createElement(_VehicleActivityTimeline2.default, { vehicleId: this.props.vehicleId })
					)
				)
			);
		}
	}]);

	return VehicleActivity;
}(_react2.default.Component);

exports.default = VehicleActivity;


VehicleActivity.propTypes = {
	vehicleId: _react2.default.PropTypes.string
};

VehicleActivity.defaultProps = {
	vehicleId: ""
};

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VehicleActivity = __webpack_require__(441);

var _VehicleActivity2 = _interopRequireDefault(_VehicleActivity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VehicleActivity2.default;

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _vehicles = __webpack_require__(45);

var _vehicles2 = _interopRequireDefault(_vehicles);

var _openedDetails = __webpack_require__(28);

var _openedDetails2 = _interopRequireDefault(_openedDetails);

var _VehicleProperties = __webpack_require__(473);

var _VehicleProperties2 = _interopRequireDefault(_VehicleProperties);

var _VehicleActivity = __webpack_require__(442);

var _VehicleActivity2 = _interopRequireDefault(_VehicleActivity);

var _VehicleHeatmap = __webpack_require__(446);

var _VehicleHeatmap2 = _interopRequireDefault(_VehicleHeatmap);

var _VehiclePOICrossings = __webpack_require__(471);

var _VehiclePOICrossings2 = _interopRequireDefault(_VehiclePOICrossings);

var _shouldComponentUpdate2 = __webpack_require__(43);

var _shouldComponentUpdate3 = _interopRequireDefault(_shouldComponentUpdate2);

var _Details = __webpack_require__(148);

var _Details2 = _interopRequireDefault(_Details);

var _Pager = __webpack_require__(87);

var _Pager2 = _interopRequireDefault(_Pager);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _EEP = __webpack_require__(33);

var _EEP2 = _interopRequireDefault(_EEP);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VehicleDetails = function (_React$Component) {
	_inherits(VehicleDetails, _React$Component);

	function VehicleDetails(props) {
		_classCallCheck(this, VehicleDetails);

		var _this = _possibleConstructorReturn(this, (VehicleDetails.__proto__ || Object.getPrototypeOf(VehicleDetails)).call(this, props));

		_this.initState();
		_this.eep = new _EEP2.default();
		_this.setStoreListeners();
		return _this;
	}

	_createClass(VehicleDetails, [{
		key: "initState",
		value: function initState() {
			this.state = {
				vehicle: _vehicles2.default.get(this.props.vehicleId),
				page: _openedDetails2.default.get(this.props.vehicleId).activePage
			};
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			this.eep.on(_vehicles2.default, "update", function (vehicle) {
				if (vehicle._id == _this2.props.vehicleId) _this2.setState({ vehicle: vehicle });
			});
			this.eep.on(_openedDetails2.default, "update", function (detailsDescriptor) {
				if (detailsDescriptor.id == _this2.props.vehicleId && detailsDescriptor.activePage != _this2.state.page) {
					_this2.setState({ page: detailsDescriptor.activePage });
				}
			});
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			this.eep.close();
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate() {
			for (var _len = arguments.length, nexts = Array(_len), _key = 0; _key < _len; _key++) {
				nexts[_key] = arguments[_key];
			}

			return _shouldComponentUpdate3.default.apply(undefined, [this].concat(nexts));
		}
	}, {
		key: "getName",
		value: function getName() {
			if (!this.state.vehicle) return "";
			return this.state.vehicle.name || this.state.vehicle.plateNumber || "";
		}
	}, {
		key: "render",
		value: function render() {
			var _this3 = this;

			var tabs = [{ id: "activity", label: _lang2.default.ACTIVITY }, { id: "heatmap", label: _lang2.default.HEATMAP }, { id: "poiCrossings", label: _lang2.default.POI_CROSSINGS }, { id: "properties", label: _lang2.default.PROPERTIES }];

			var detailsProps = {
				title: this.getName(),
				onClose: function onClose() {
					return _dispatcher2.default.dispatch('closeDetails', "VehicleDetails", _this3.props.vehicleId);
				},
				tabs: tabs,
				onTabChange: function onTabChange(tabId) {
					return _dispatcher2.default.dispatch('switchDetailsPage', _this3.props.vehicleId, tabId);
				},
				activeTab: this.state.page,
				dragable: true,
				ondrag: this.props.ondrag,
				className: this.props.className
			};

			return _react2.default.createElement(
				_Details2.default,
				detailsProps,
				_react2.default.createElement(
					_Pager2.default,
					{ active: this.state.page },
					_react2.default.createElement(
						"div",
						{ id: "activity" },
						_react2.default.createElement(_VehicleActivity2.default, { vehicleId: this.props.vehicleId })
					),
					_react2.default.createElement(
						"div",
						{ id: "heatmap" },
						_react2.default.createElement(_VehicleHeatmap2.default, { vehicleId: this.props.vehicleId })
					),
					_react2.default.createElement(
						"div",
						{ id: "poiCrossings" },
						_react2.default.createElement(_VehiclePOICrossings2.default, { vehicleId: this.props.vehicleId })
					),
					_react2.default.createElement(
						"div",
						{ id: "properties" },
						_react2.default.createElement(_VehicleProperties2.default, { vehicleId: this.props.vehicleId })
					)
				)
			);
		}
	}]);

	return VehicleDetails;
}(_react2.default.Component);

exports.default = VehicleDetails;


VehicleDetails.propTypes = {
	vehicleId: _react2.default.PropTypes.string,
	ondrag: _react2.default.PropTypes.func
};

VehicleDetails.defaultProps = {
	vehicleId: null,
	ondrag: function ondrag(dragEvt) {}
};

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VehicleDetails = __webpack_require__(443);

var _VehicleDetails2 = _interopRequireDefault(_VehicleDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VehicleDetails2.default;

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(907);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _vehicleHeatmaps = __webpack_require__(158);

var _vehicleHeatmaps2 = _interopRequireDefault(_vehicleHeatmaps);

var _displayedDetails = __webpack_require__(44);

var _displayedDetails2 = _interopRequireDefault(_displayedDetails);

var _vehicleHeatmap = __webpack_require__(226);

var _vehicleHeatmap2 = _interopRequireDefault(_vehicleHeatmap);

var _IntervalEditor = __webpack_require__(149);

var _IntervalEditor2 = _interopRequireDefault(_IntervalEditor);

var _ProgressBar = __webpack_require__(34);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Checkbox = __webpack_require__(66);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Form = __webpack_require__(38);

var _Form2 = _interopRequireDefault(_Form);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _EEP = __webpack_require__(33);

var _EEP2 = _interopRequireDefault(_EEP);

var _shouldComponentUpdate2 = __webpack_require__(43);

var _shouldComponentUpdate3 = _interopRequireDefault(_shouldComponentUpdate2);

var _getVehicleHeatmap = __webpack_require__(359);

var _getVehicleHeatmap2 = _interopRequireDefault(_getVehicleHeatmap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VehicleHeatmap = function (_React$Component) {
	_inherits(VehicleHeatmap, _React$Component);

	function VehicleHeatmap(props) {
		_classCallCheck(this, VehicleHeatmap);

		var _this = _possibleConstructorReturn(this, (VehicleHeatmap.__proto__ || Object.getPrototypeOf(VehicleHeatmap)).call(this, props));

		_this.initState();
		_this.eep = new _EEP2.default();
		_this.setStoreListeners();
		return _this;
	}

	_createClass(VehicleHeatmap, [{
		key: "initState",
		value: function initState() {
			this.state = {
				vehicleHeatmapDescriptor: null,
				from: Date.parse(function (d) {
					d.setDate(d.getDate() - 14);return d;
				}(new Date())),
				to: Date.now(),
				inProgress: false
			};
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			this.eep.on(_vehicleHeatmaps2.default, "change", function (vehicleHeatmapDescriptors) {
				return _this2.handleVehicleHeatmapStoreChange(vehicleHeatmapDescriptors);
			});
			this.eep.on(_displayedDetails2.default, "change", function (detailsDescriptor) {
				return _this2.handleDetailsStoreChange(detailsDescriptor);
			});
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate() {
			for (var _len = arguments.length, nexts = Array(_len), _key = 0; _key < _len; _key++) {
				nexts[_key] = arguments[_key];
			}

			return _shouldComponentUpdate3.default.apply(undefined, [this].concat(nexts));
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			this.eep.close();
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			if (openedDetailsStore.get(this.props.vehicleId).activePage == "heatmap") {
				this.getHeatmapDescriptors();
			}
		}
	}, {
		key: "handleDetailsStoreChange",
		value: function handleDetailsStoreChange(detailsDescriptor) {
			if (detailsDescriptor && detailsDescriptor.id == this.props.vehicleId && _vehicleHeatmap2.default.getVisibilityOfHeatmap(this.props.vehicleId) && !this.state.vehicleHeatmapDescriptor) {
				this.getHeatmapDescriptors();
			}
		}
	}, {
		key: "handleVehicleHeatmapStoreChange",
		value: function handleVehicleHeatmapStoreChange(vehicleHeatmapDescriptors) {
			var _this3 = this;

			var descriptor = (vehicleHeatmapDescriptors || []).find(function (e) {
				return e.vehicle == _this3.props.vehicleId;
			});
			if (descriptor) {
				this.setState({
					vehicleHeatmapDescriptor: vehicleHeatmapDescriptors[0]
				});
			}
		}
	}, {
		key: "getHeatmapDescriptors",
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								this.setState({ inProgress: true });
								_context.next = 3;
								return (0, _getVehicleHeatmap2.default)(this.props.vehicleId, this.state.from, this.state.to);

							case 3:
								this.setState({ inProgress: false });

							case 4:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function getHeatmapDescriptors() {
				return _ref.apply(this, arguments);
			}

			return getHeatmapDescriptors;
		}()
	}, {
		key: "render",
		value: function render() {
			var _this4 = this;

			var intervalEditorProps = {
				nullable: false,
				interval: {
					from: this.state.from,
					to: this.state.to
				},
				onChange: function onChange(interval) {
					_this4.setState({
						from: interval.from,
						to: interval.to
					});
				}
			};

			var noResult = !this.state.inProgress && this.state.vehicleHeatmapDescriptor && this.state.vehicleHeatmapDescriptor.sections && this.state.vehicleHeatmapDescriptor.sections.length == 0;

			return _react2.default.createElement(
				"div",
				{ className: "VehicleHeatmap" },
				_react2.default.createElement(
					"header",
					{ className: "Shadowed" },
					_react2.default.createElement(_IntervalEditor2.default, intervalEditorProps),
					_react2.default.createElement(
						_Button2.default,
						{ className: "Red", disabled: this.state.inProgress, onClick: function onClick(_) {
								return _this4.getHeatmapDescriptors();
							} },
						_lang2.default.SUBMIT
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "Content" },
					_react2.default.createElement(_ProgressBar2.default, { indeterminate: true, shown: this.state.inProgress }),
					_react2.default.createElement(
						"h1",
						{ className: (0, _classnames2.default)("Message", { "Hidden": !noResult }) },
						_lang2.default.NO_RESULTS_FOUND
					),
					_react2.default.createElement(
						"div",
						{ className: (0, _classnames2.default)("CheckboxContainer", { "Hidden": this.state.inProgress || noResult }) },
						_react2.default.createElement(
							"div",
							null,
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.ROUTES
							),
							_react2.default.createElement(_Checkbox2.default, {
								checked: this.state.vehicleHeatmapDescriptor ? this.state.vehicleHeatmapDescriptor.show.routes : false,
								onChange: function onChange(value) {
									return _dispatcher2.default.dispatch("showVehicleHeatmapElements", _this4.props.vehicleId, { routes: value, stops: _this4.state.vehicleHeatmapDescriptor.show.stops });
								}
							})
						),
						_react2.default.createElement(
							"div",
							null,
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.STOPS
							),
							_react2.default.createElement(_Checkbox2.default, {
								checked: this.state.vehicleHeatmapDescriptor ? this.state.vehicleHeatmapDescriptor.show.stops : false,
								onChange: function onChange(value) {
									return _dispatcher2.default.dispatch("showVehicleHeatmapElements", _this4.props.vehicleId, { routes: _this4.state.vehicleHeatmapDescriptor.show.routes, stops: value });
								}
							})
						)
					)
				)
			);
		}
	}]);

	return VehicleHeatmap;
}(_react2.default.Component);

exports.default = VehicleHeatmap;


VehicleHeatmap.propTypes = {
	vehicleId: _react2.default.PropTypes.string
};

VehicleHeatmap.defaultProps = {
	vehicleId: ""
};

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VehicleHeatmap = __webpack_require__(445);

var _VehicleHeatmap2 = _interopRequireDefault(_VehicleHeatmap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VehicleHeatmap2.default;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(908);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _TextFilter = __webpack_require__(207);

var _TextFilter2 = _interopRequireDefault(_TextFilter);

var _Pin = __webpack_require__(61);

var _Pin2 = _interopRequireDefault(_Pin);

var _ButtonGroup = __webpack_require__(202);

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Filter = function (_React$Component) {
	_inherits(Filter, _React$Component);

	function Filter(props) {
		_classCallCheck(this, Filter);

		var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(Filter, [{
		key: "initState",
		value: function initState() {
			this.state = {
				expanded: false
			};
		}
	}, {
		key: "toggle",
		value: function toggle() {
			this.setState({
				expanded: !this.state.expanded
			});
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			var pin = this.props.pinStatus > 0;
			var pinAll = this.props.pinStatus == 2;
			var className = this.state.expanded ? "" : "Hidden";

			return _react2.default.createElement(
				"div",
				{ className: "Filter" },
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(_TextFilter2.default, { onSubmit: function onSubmit(value) {
							return _this2.props.onFilter({ text: value });
						}, value: this.props.filterExpression.text }),
					_react2.default.createElement(_Pin2.default, { onChange: function onChange(value) {
							return _this2.props.onPinChange(value);
						}, checked: pin, indeterminate: !pinAll, useForAll: true })
				),
				_react2.default.createElement(
					"div",
					{ className: className },
					_react2.default.createElement(
						_ButtonGroup2.default,
						{ onChange: function onChange(id) {
								return _this2.props.onFilter({ movement: id });
							}, selected: this.props.filterExpression.movement },
						_react2.default.createElement(
							_Button2.default,
							{ id: "igOff", className: "Light" },
							_lang2.default.IGNITION_OFF
						),
						_react2.default.createElement(
							_Button2.default,
							{ id: "igOn", className: "Light" },
							_lang2.default.IGNITION_ON
						),
						_react2.default.createElement(
							_Button2.default,
							{ id: "moving", className: "Light" },
							_lang2.default.MOVING
						)
					)
				),
				_react2.default.createElement(
					"footer",
					{ onClick: function onClick(_) {
							return _this2.toggle();
						} },
					"\u2022\u2022\u2022"
				)
			);
		}
	}]);

	return Filter;
}(_react2.default.Component);

exports.default = Filter;


Filter.propTypes = {
	pinStatus: _react2.default.PropTypes.number,
	filterExpression: _react2.default.PropTypes.shape({
		text: _react2.default.PropTypes.string,
		movement: _react2.default.PropTypes.string
	}),
	onFilter: _react2.default.PropTypes.func,
	onPinChange: _react2.default.PropTypes.func

};

Filter.defaultProps = {
	onFilter: function onFilter(expression) {},
	onPinChange: function onPinChange(value) {},
	pinStatus: 2
};

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Filter = __webpack_require__(447);

var _Filter2 = _interopRequireDefault(_Filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Filter2.default;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(909);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _Pin = __webpack_require__(61);

var _Pin2 = _interopRequireDefault(_Pin);

var _Icon = __webpack_require__(114);

var _Icon2 = _interopRequireDefault(_Icon);

var _Table = __webpack_require__(451);

var _Table2 = _interopRequireDefault(_Table);

var _vehicle = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Summary = function (_React$Component) {
	_inherits(Summary, _React$Component);

	function Summary(props) {
		_classCallCheck(this, Summary);

		var _this = _possibleConstructorReturn(this, (Summary.__proto__ || Object.getPrototypeOf(Summary)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(Summary, [{
		key: "initState",
		value: function initState() {
			this.state = {
				expanded: this.props.expanded
			};
		}
	}, {
		key: "getTitle",
		value: function getTitle() {
			return this.props.vehicle.name ? this.props.vehicle.name : this.props.vehicle.plateNumber;
		}
	}, {
		key: "getSubTitle",
		value: function getSubTitle() {
			if (this.getTitle() == this.props.vehicle.plateNumber) return "";else return this.props.vehicle.plateNumber || "";
		}
	}, {
		key: "getLastTime",
		value: function getLastTime() {
			return (0, _vehicle.getLastTimeOfVehicleState)(this.props.vehicle._id);
		}
	}, {
		key: "toggle",
		value: function toggle() {
			this.setState({
				expanded: !this.state.expanded
			});
		}
	}, {
		key: "createTouchProps",
		value: function createTouchProps() {
			var _this2 = this;

			var pressStarted = false;

			return {
				onTouchStart: function onTouchStart() {
					pressStarted = true;
					setTimeout(function () {
						if (pressStarted) _this2.props.onSwitchVehicleDetails();
						pressStarted = false;
					}, 1000);
				},
				onTouchEnd: function onTouchEnd() {
					pressStarted = false;
				},
				onTouchCancel: function onTouchCancel() {
					pressStarted = false;
				}
			};
		}
	}, {
		key: "renderPin",
		value: function renderPin() {
			var _this3 = this;

			if ((0, _vehicle.hasStateOfVehicle)(this.props.vehicle._id) && (0, _vehicle.getPositionOfVehicle)(this.props.vehicle._id)) {
				return _react2.default.createElement(_Pin2.default, {
					checked: this.props.pinned,
					onChange: function onChange(value) {
						return _this3.props.onPinChange(value);
					}
				});
			}
		}
	}, {
		key: "renderLastTime",
		value: function renderLastTime() {
			var lastTime = this.getLastTime();

			if (lastTime) return _react2.default.createElement(
				"label",
				null,
				new Date(lastTime).toLocaleString()
			);else return null;
		}
	}, {
		key: "renderHeader",
		value: function renderHeader() {
			var _this4 = this;

			return _react2.default.createElement(
				"header",
				null,
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(
						"div",
						{ id: "nameContainer" },
						_react2.default.createElement(
							"h1",
							{ onClick: function onClick(evt) {
									evt.stopPropagation();
									_this4.props.onSwitchVehicleDetails();
								} },
							this.getTitle()
						),
						_react2.default.createElement(
							"h2",
							null,
							this.getSubTitle()
						)
					),
					this.renderPin()
				),
				_react2.default.createElement(
					"div",
					null,
					this.renderLastTime(),
					_react2.default.createElement(
						"label",
						null,
						(0, _vehicle.getAddressOfVehicle)(this.props.vehicle._id)
					)
				)
			);
		}
	}, {
		key: "renderTable",
		value: function renderTable() {
			return _react2.default.createElement(_Table2.default, {
				shown: this.state.expanded,
				vehicle: this.props.vehicle
			});
		}
	}, {
		key: "renderFooter",
		value: function renderFooter() {
			var _this5 = this;

			var className = (0, _vehicle.hasStateOfVehicle)(this.props.vehicle._id) != 0 ? "" : "Hidden";

			return _react2.default.createElement(
				"footer",
				{
					className: className,
					onClick: function onClick(evt) {
						evt.stopPropagation();_this5.toggle();
					}
				},
				"\u2022\u2022\u2022"
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this6 = this;

			var touchProps = this.createTouchProps();

			return _react2.default.createElement(
				_Card2.default,
				_extends({ className: "Summary", onClick: function onClick(_) {
						return _this6.props.onFocus();
					}, onDoubleClick: this.props.onSwitchVehicleDetails }, touchProps),
				_react2.default.createElement("div", { id: "ignitionMarker", className: (0, _vehicle.getMovingStateOfVehicle)(this.props.vehicle._id) }),
				this.renderHeader(),
				this.renderTable(),
				this.renderFooter()
			);
		}
	}]);

	return Summary;
}(_react2.default.Component);

exports.default = Summary;


Summary.propTypes = {
	vehicle: _react2.default.PropTypes.object.isRequired,
	pinned: _react2.default.PropTypes.bool,
	onFocus: _react2.default.PropTypes.func,
	onSwitchVehicleDetails: _react2.default.PropTypes.func,
	onPinChange: _react2.default.PropTypes.func,
	expanded: _react2.default.PropTypes.bool
};

Summary.defaultProps = {
	expanded: false,
	onFocus: function onFocus() {},
	onSwitchVehicleDetails: function onSwitchVehicleDetails() {},
	onPinChange: function onPinChange(value) {}
};

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(910);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _vehicle = __webpack_require__(91);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _round = __webpack_require__(213);

var _round2 = _interopRequireDefault(_round);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Table = function (_React$Component) {
	_inherits(Table, _React$Component);

	function Table() {
		_classCallCheck(this, Table);

		return _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
	}

	_createClass(Table, [{
		key: "getRowDataFromVehicleState",
		value: function getRowDataFromVehicleState() {

			if (!this.props.vehicleState || Object.keys(this.props.vehicleState).length == 0) return [];

			var ignoredNames = ["Position", "Ignition", "InputVector", "OutputVector"];

			var rows = [];

			for (var dataTypeName in this.props.vehicleState) {
				if (ignoredNames.indexOf(dataTypeName) > -1) continue;
				var data = this.props.vehicleState[dataTypeName];
				rows.push({
					dataTypeName: dataTypeName,
					name: data.name,
					value: data.value + " " + data.unit
				});
			}

			return rows;
		}
	}, {
		key: "renderRow",
		value: function renderRow(rowData) {
			if (rowData.dataTypeName == _lang2.default["DATA_TYPE_54ac0f62f556ea16b4a31fd4"]) //"Position"
				{
					return _react2.default.createElement(
						"tr",
						{ key: rowData.dataTypeName },
						_react2.default.createElement(
							"td",
							null,
							rowData.name
						),
						_react2.default.createElement(
							"td",
							null,
							"Lat:" + (0, _round2.default)(rowData.lat, 4)
						),
						_react2.default.createElement(
							"td",
							null,
							"Lng:" + (0, _round2.default)(rowData.lng, 4)
						)
					);
				};
			return _react2.default.createElement(
				"tr",
				{ key: rowData.dataTypeName },
				_react2.default.createElement(
					"td",
					null,
					rowData.name
				),
				_react2.default.createElement(
					"td",
					null,
					rowData.value + " " + rowData.unit
				)
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			var className = (0, _classnames2.default)("Table", { "Hidden": !this.props.shown });
			var rowData = (0, _vehicle.getScalarVehicleStatesWithResolvedUnits)(this.props.vehicle._id);
			return _react2.default.createElement(
				"table",
				{ className: className },
				_react2.default.createElement(
					"tbody",
					null,
					rowData.map(function (rd) {
						return _this2.renderRow(rd);
					})
				)
			);
		}
	}]);

	return Table;
}(_react2.default.Component);

exports.default = Table;


Table.propTypes = {
	shown: _react2.default.PropTypes.bool,
	vehicle: _react2.default.PropTypes.object.isRequired
};

Table.defaultProps = {
	shown: true
};

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Table = __webpack_require__(450);

var _Table2 = _interopRequireDefault(_Table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Table2.default;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Summary = __webpack_require__(449);

var _Summary2 = _interopRequireDefault(_Summary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Summary2.default;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(911);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _session = __webpack_require__(30);

var _session2 = _interopRequireDefault(_session);

var _dataTypes = __webpack_require__(68);

var _dataTypes2 = _interopRequireDefault(_dataTypes);

var _services = __webpack_require__(120);

var _services2 = _interopRequireDefault(_services);

var _vehicles = __webpack_require__(45);

var _vehicles2 = _interopRequireDefault(_vehicles);

var _vehicleFilterExpression = __webpack_require__(371);

var _vehicleFilterExpression2 = _interopRequireDefault(_vehicleFilterExpression);

var _selectedVehicle = __webpack_require__(157);

var _selectedVehicle2 = _interopRequireDefault(_selectedVehicle);

var _vehicleStates = __webpack_require__(122);

var _vehicleStates2 = _interopRequireDefault(_vehicleStates);

var _pinnedVehicles = __webpack_require__(154);

var _pinnedVehicles2 = _interopRequireDefault(_pinnedVehicles);

var _displayedDetails = __webpack_require__(44);

var _displayedDetails2 = _interopRequireDefault(_displayedDetails);

var _shouldComponentUpdate = __webpack_require__(43);

var _shouldComponentUpdate2 = _interopRequireDefault(_shouldComponentUpdate);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _List = __webpack_require__(205);

var _List2 = _interopRequireDefault(_List);

var _Filter = __webpack_require__(448);

var _Filter2 = _interopRequireDefault(_Filter);

var _Summary = __webpack_require__(452);

var _Summary2 = _interopRequireDefault(_Summary);

var _filterGroups = __webpack_require__(67);

var _filterGroups2 = _interopRequireDefault(_filterGroups);

var _filterVehicles = __webpack_require__(454);

var _filterVehicles2 = _interopRequireDefault(_filterVehicles);

var _vehicle = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VehicleList = function (_React$Component) {
	_inherits(VehicleList, _React$Component);

	function VehicleList(props) {
		_classCallCheck(this, VehicleList);

		var _this = _possibleConstructorReturn(this, (VehicleList.__proto__ || Object.getPrototypeOf(VehicleList)).call(this, props));

		_this.initState();
		_this.setStoreListeners();
		return _this;
	}

	_createClass(VehicleList, [{
		key: "initState",
		value: function initState() {
			this.state = {
				vehicles: (0, _filterGroups2.default)(_vehicles2.default.getAll()),
				filterExpression: _vehicleFilterExpression2.default.get(),
				selectedVehicle: _selectedVehicle2.default.get(),
				vehicleStates: _vehicleStates2.default.getAll(),
				pinnedVehicles: _pinnedVehicles2.default.getAll()
			};
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			_vehicles2.default.on('change', function (vehicles) {
				return _this2.setState({ vehicles: (0, _filterGroups2.default)(vehicles) });
			});
			_vehicleFilterExpression2.default.on('change', function (filterExpression) {
				return _this2.setState({ filterExpression: filterExpression });
			});
			_selectedVehicle2.default.on('change', function (selectedVehicle) {
				return _this2.setState({ selectedVehicle: selectedVehicle });
			});
			_vehicleStates2.default.on('change', function (vehicleStates) {
				return _this2.setState({ vehicleStates: vehicleStates });
			});
			_pinnedVehicles2.default.on('change', function (pinnedVehicles) {
				return _this2.setState({ pinnedVehicles: pinnedVehicles });
			});
		}
	}, {
		key: "getState",
		value: function getState(vehicleId) {
			if (!this.state.vehicleStates) return null;
			var vehicleState = this.state.vehicleStates.find(function (s) {
				return s.carrier == vehicleId;
			});
			return vehicleState || null;
		}

		// SIDE_EFFECT: referenciálisan ugyanaz a state és a nextState
		/* shouldComponentUpdate(...nexts){
  	return shouldComponentUpdate(this, ...nexts);
  } */

	}, {
		key: "getStatefulAndListedVehicles",
		value: function getStatefulAndListedVehicles() {
			var _this3 = this;

			var filteredVehicles = this.getFilteredVehicles();

			var filteredAndStatefulVehicles = filteredVehicles ? filteredVehicles.filter(function (v) {
				return _this3.getState(v._id);
			}) : null;

			if (this.state.selectedVehicle) {
				if (this.getState(this.state.selectedVehicle)) return [_vehicles2.default.get(this.state.selectedVehicle)];else return [];
			} else if (filteredVehicles) {
				return filteredAndStatefulVehicles;
			} else if (this.state.vehicles) {
				return this.state.vehicles.filter(function (v) {
					return _this3.getState(v._id);
				});
			} else return [];
		}
	}, {
		key: "getListedVehiclesPinStatus",
		value: function getListedVehiclesPinStatus() {
			var _this4 = this;

			var currentListedVehicles = this.getStatefulAndListedVehicles().map(function (v) {
				return v._id;
			});
			var pinnedCurrentListedVehicleIds = currentListedVehicles.filter(function (id) {
				return _this4.state.pinnedVehicles && _this4.state.pinnedVehicles.indexOf(id) > -1;
			});

			if (pinnedCurrentListedVehicleIds.length == 0) return 0;else if (pinnedCurrentListedVehicleIds.length == currentListedVehicles.length) return 2;else if (pinnedCurrentListedVehicleIds.length < currentListedVehicles.length && pinnedCurrentListedVehicleIds.length > 0) return 1;else return 0;
		}
	}, {
		key: "handleFilterChange",
		value: function handleFilterChange(expression) {
			_dispatcher2.default.dispatch('filterVehicles', expression);
		}
	}, {
		key: "handlePinChange",
		value: function handlePinChange(value) {
			var vehicleIds = this.getStatefulAndListedVehicles().map(function (v) {
				return v._id;
			});
			_dispatcher2.default.dispatch('pinVehicles', vehicleIds, value);
		}
	}, {
		key: "switchVehicleDetails",
		value: function switchVehicleDetails(vehicleId) {
			var displayedDetails = _displayedDetails2.default.get();
			if (!displayedDetails) _dispatcher2.default.dispatch("openDetails", "VehicleDetails", vehicleId);else if (displayedDetails.id == vehicleId) _dispatcher2.default.dispatch("closeDetails", "VehicleDetails", vehicleId);else _dispatcher2.default.dispatch("openDetails", "VehicleDetails", vehicleId);
		}
	}, {
		key: "getFilteredVehicles",
		value: function getFilteredVehicles() {
			return (0, _filterVehicles2.default)(_dataTypes2.default, this.state.vehicles, this.state.vehicleStates, this.state.filterExpression);
		}
	}, {
		key: "renderFilter",
		value: function renderFilter() {
			return _react2.default.createElement(_Filter2.default, {
				filterExpression: this.state.filterExpression,
				pinStatus: this.getListedVehiclesPinStatus(),
				onFilter: this.handleFilterChange.bind(this),
				onPinChange: this.handlePinChange.bind(this)
			});
		}
	}, {
		key: "renderList",
		value: function renderList(vehicles, expanded) {
			var _this5 = this;

			expanded = expanded || false;
			return _react2.default.createElement(
				_List2.default,
				null,
				vehicles ? vehicles.map(function (vehicle) {
					return _react2.default.createElement(_Summary2.default, {
						expanded: expanded,
						key: vehicle._id,
						vehicle: vehicle,
						onFocus: function onFocus() {
							return _dispatcher2.default.dispatch('focusVehicle', vehicle._id);
						},
						pinned: _this5.state.pinnedVehicles ? _this5.state.pinnedVehicles.find(function (e) {
							return e == vehicle._id;
						}) ? true : false : false,
						onPinChange: function onPinChange(value) {
							return _dispatcher2.default.dispatch('pinVehicles', [vehicle._id], value);
						},
						onSwitchVehicleDetails: function onSwitchVehicleDetails() {
							return _this5.switchVehicleDetails(vehicle._id);
						}
					});
				}) : ""
			);
		}
	}, {
		key: "renderFullList",
		value: function renderFullList() {
			return _react2.default.createElement(
				"div",
				{ className: "ListContainer" },
				this.renderList(this.state.vehicles)
			);
		}
	}, {
		key: "renderFilteredList",
		value: function renderFilteredList() {

			var className = (0, _classnames2.default)("ListContainer", { "Hidden": !this.getFilteredVehicles() });

			return _react2.default.createElement(
				"div",
				{ className: className },
				_react2.default.createElement(
					"header",
					null,
					_react2.default.createElement(_Button2.default, { icon: "arrow-left", onClick: function onClick(_) {
							return _dispatcher2.default.dispatch('filterVehicles', null);
						} })
				),
				this.renderList(this.getFilteredVehicles())
			);
		}
	}, {
		key: "renderSelectedList",
		value: function renderSelectedList() {
			var _this6 = this;

			var className = (0, _classnames2.default)("ListContainer", { "Hidden": !this.state.selectedVehicle });
			var vehicle = this.state.selectedVehicle ? this.state.vehicles.find(function (v) {
				return v._id == _this6.state.selectedVehicle;
			}) : null;
			return _react2.default.createElement(
				"div",
				{ className: className },
				_react2.default.createElement(
					"header",
					null,
					_react2.default.createElement(_Button2.default, { icon: "arrow-left", onClick: function onClick(_) {
							return _dispatcher2.default.dispatch('selectVehicle', null);
						} })
				),
				this.renderList(vehicle ? [vehicle] : null, true)
			);
		}
	}, {
		key: "render",
		value: function render() {

			var filter = this.renderFilter();
			var fullList = this.renderFullList();
			var filteredList = this.renderFilteredList();
			var selectedList = this.renderSelectedList();

			return _react2.default.createElement(
				"div",
				{ className: "VehicleList" },
				filter,
				_react2.default.createElement(
					"div",
					{ id: "body" },
					fullList,
					filteredList,
					selectedList
				)
			);
		}
	}]);

	return VehicleList;
}(_react2.default.Component);

exports.default = VehicleList;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = filterVehicles;

var _vehicle = __webpack_require__(91);

function filterByText(vehicles, text) {
	return vehicles.filter(function (vehicle) {

		var pattern = new RegExp(text, "i");

		if (vehicle.name && pattern.test(vehicle.name)) return true;
		if (vehicle.plateNumber && pattern.test(vehicle.plateNumber)) return true;
		if (vehicle.make && pattern.test(vehicle.make)) return true;
		return false;
	});
}

function filterByMovement(dataTypeStore, vehicles, vehicleStates, movement) {

	if (!vehicleStates) return [];

	return vehicles.filter(function (vehicle) {

		var movingState = (0, _vehicle.getMovingStateOfVehicle)(vehicle._id);

		if (movement == 'igOff' && movingState == '') return true;
		if (movement == 'igOn' && (movingState == 'onIgnition' || movingState == 'moving')) return true;
		if (movement == 'moving' && movingState == 'moving') return true;

		return false;
	});
}

function filterVehicles(dataTypeStore, vehicles, vehicleStates, expression) {
	if (!vehicles) return null;

	if (!expression.text && !expression.movement) return null;

	var filteredVehicles = vehicles.slice();

	if (expression.text) filteredVehicles = filterByText(filteredVehicles, expression.text);

	if (expression.movement) filteredVehicles = filterByMovement(dataTypeStore, filteredVehicles, vehicleStates, expression.movement);

	return filteredVehicles;
}

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VehicleList = __webpack_require__(453);

var _VehicleList2 = _interopRequireDefault(_VehicleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VehicleList2.default;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(912);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _Pin = __webpack_require__(61);

var _Pin2 = _interopRequireDefault(_Pin);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StayCard = function (_React$Component) {
	_inherits(StayCard, _React$Component);

	function StayCard(props) {
		_classCallCheck(this, StayCard);

		var _this = _possibleConstructorReturn(this, (StayCard.__proto__ || Object.getPrototypeOf(StayCard)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(StayCard, [{
		key: "initState",
		value: function initState() {
			this.state = {
				expanded: false
			};
		}
	}, {
		key: "toggle",
		value: function toggle() {
			this.setState({
				expanded: !this.state.expanded
			});
		}
	}, {
		key: "handleAddressClick",
		value: function handleAddressClick(evt, time) {
			evt.stopPropagation();
			this.props.onAddressClick(time);
		}
	}, {
		key: "handleDataClick",
		value: function handleDataClick(evt, which) {
			evt.stopPropagation();
			this.props.onFixData(which);
		}
	}, {
		key: "isDisplayedData",
		value: function isDisplayedData(which) {
			return this.props.fixedData.includes(which) || this.state.expanded;
		}
	}, {
		key: "areDisplayedAnyData",
		value: function areDisplayedAnyData() {
			return this.props.fixedData.length > 0;
		}
	}, {
		key: "isBodyShown",
		value: function isBodyShown() {
			return this.state.expanded || this.areDisplayedAnyData();
		}
	}, {
		key: "getRowDataClassName",
		value: function getRowDataClassName(which) {
			return (0, _classnames2.default)({ "Hidden": !this.isDisplayedData(which) }, { "Fixed": this.props.fixedData.includes(which) });
		}
	}, {
		key: "renderCardHeader",
		value: function renderCardHeader() {
			var _this2 = this;

			return _react2.default.createElement(
				"header",
				null,
				_react2.default.createElement(
					"h1",
					{ className: "POIName" },
					this.props.section.poi
				),
				_react2.default.createElement(
					"div",
					{ className: "Summary" },
					_react2.default.createElement(
						"div",
						{ className: "TimeAndAddress" },
						_react2.default.createElement(
							"div",
							null,
							_react2.default.createElement(
								"div",
								null,
								this.props.section.start.time.toLocaleString()
							),
							_react2.default.createElement(
								"div",
								null,
								this.props.section.start.truncated ? _react2.default.createElement(
									"label",
									{ className: "Indicator" },
									_lang2.default.ALREADY_IN_POI
								) : null,
								_react2.default.createElement(
									"label",
									{
										className: "Address",
										onMouseOver: function onMouseOver(evt) {
											return _this2.props.onAddressMouseOver(_this2.props.section.start.timeStamp);
										},
										onMouseLeave: function onMouseLeave(evt) {
											return _this2.props.onAddressMouseLeave(_this2.props.section.start.timeStamp);
										},
										onClick: function onClick(evt) {
											return _this2.handleAddressClick(evt, _this2.props.section.start.timeStamp);
										}
									},
									this.props.section.start.address
								)
							)
						),
						_react2.default.createElement(
							"div",
							null,
							_react2.default.createElement(
								"div",
								null,
								this.props.section.end.time.toLocaleString()
							),
							_react2.default.createElement(
								"div",
								null,
								this.props.section.end.truncated ? _react2.default.createElement(
									"label",
									{ className: "Indicator" },
									_lang2.default.STILL_IN_POI
								) : null,
								_react2.default.createElement(
									"label",
									{
										className: "Address",
										onMouseOver: function onMouseOver(evt) {
											return _this2.props.onAddressMouseOver(_this2.props.section.end.timeStamp);
										},
										onMouseLeave: function onMouseLeave(evt) {
											return _this2.props.onAddressMouseLeave(_this2.props.section.end.timeStamp);
										},
										onClick: function onClick(evt) {
											return _this2.handleAddressClick(evt, _this2.props.section.end.timeStamp);
										}
									},
									this.props.section.end.address
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "DistanceAndTimeDiff" },
						_react2.default.createElement(
							"label",
							null,
							this.props.section.totalVehicleDistanceDiff,
							" / ",
							this.props.section.timeDiff
						),
						_react2.default.createElement(_Button2.default, {
							icon: "chart-bar",
							onClick: function onClick(evt) {
								return _this2.props.onGetActivity(_this2.props.section.start.timeStamp, _this2.props.section.end.timeStamp);
							}
						})
					)
				)
			);
		}
	}, {
		key: "renderCardBody",
		value: function renderCardBody() {
			var _this3 = this;

			return _react2.default.createElement(
				"table",
				{ className: (0, _classnames2.default)({ "Hidden": !this.isBodyShown() }) },
				_react2.default.createElement(
					"tbody",
					null,
					_react2.default.createElement(
						"tr",
						{ className: this.getRowDataClassName("totalVehicleDistance") },
						_react2.default.createElement(
							"td",
							{
								title: _lang2.default.CLICK_HERE_TO_FIX_IT,
								onClick: function onClick(evt) {
									return _this3.handleDataClick(evt, "totalVehicleDistance");
								}
							},
							_lang2.default.TOTAL_VEHICLE_DISTANCE
						),
						_react2.default.createElement(
							"td",
							null,
							this.props.section.start.totalVehicleDistance
						),
						_react2.default.createElement(
							"td",
							null,
							" \u2192 "
						),
						_react2.default.createElement(
							"td",
							null,
							this.props.section.end.totalVehicleDistance
						)
					),
					_react2.default.createElement(
						"tr",
						{ className: this.getRowDataClassName("avgSpeed") },
						_react2.default.createElement(
							"td",
							{
								title: _lang2.default.CLICK_HERE_TO_FIX_IT,
								onClick: function onClick(evt) {
									return _this3.handleDataClick(evt, "avgSpeed");
								}
							},
							_lang2.default.AVERAGE_SPEED
						),
						_react2.default.createElement(
							"td",
							null,
							this.props.section.avgSpeed
						)
					),
					_react2.default.createElement(
						"tr",
						{ className: this.getRowDataClassName("maxSpeed") },
						_react2.default.createElement(
							"td",
							{
								title: _lang2.default.CLICK_HERE_TO_FIX_IT,
								onClick: function onClick(evt) {
									return _this3.handleDataClick(evt, "maxSpeed");
								}
							},
							_lang2.default.MAXIMUM_SPEED
						),
						_react2.default.createElement(
							"td",
							null,
							this.props.section.maxSpeed
						)
					),
					_react2.default.createElement(
						"tr",
						{ className: this.getRowDataClassName("starts") },
						_react2.default.createElement(
							"td",
							{
								title: _lang2.default.CLICK_HERE_TO_FIX_IT,
								onClick: function onClick(evt) {
									return _this3.handleDataClick(evt, "starts");
								}
							},
							_lang2.default.NUMBER_OF_STARTS
						),
						_react2.default.createElement(
							"td",
							null,
							this.props.section.starts
						)
					),
					_react2.default.createElement(
						"tr",
						{ className: this.getRowDataClassName("stops") },
						_react2.default.createElement(
							"td",
							{
								title: _lang2.default.CLICK_HERE_TO_FIX_IT,
								onClick: function onClick(evt) {
									return _this3.handleDataClick(evt, "stops");
								}
							},
							_lang2.default.NUMBER_OF_STOPS
						),
						_react2.default.createElement(
							"td",
							null,
							this.props.section.stops
						)
					)
				)
			);
		}
	}, {
		key: "renderCardFooter",
		value: function renderCardFooter() {
			var _this4 = this;

			return _react2.default.createElement(
				"footer",
				{
					onClick: function onClick(evt) {
						evt.stopPropagation();_this4.toggle();
					}
				},
				"\u2022\u2022\u2022"
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this5 = this;

			return _react2.default.createElement(
				_Card2.default,
				{
					className: "StayCard",
					onClick: function onClick() {
						return _this5.props.onClick();
					}
				},
				this.renderCardHeader(),
				this.renderCardBody(),
				this.renderCardFooter()
			);
		}
	}]);

	return StayCard;
}(_react2.default.Component);

exports.default = StayCard;


StayCard.propTypes = {
	section: _react2.default.PropTypes.object,
	fixedData: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string),
	onClick: _react2.default.PropTypes.func,
	onAddressMouseOver: _react2.default.PropTypes.func,
	onAddressClick: _react2.default.PropTypes.func,
	onFixData: _react2.default.PropTypes.func
};

StayCard.defaultProps = {
	section: null,
	fixedData: [],
	onClick: function onClick() {},
	onAddressMouseOver: function onAddressMouseOver(corssingTime) {},
	onAddressClick: function onAddressClick(crossingTime) {},
	onFixData: function onFixData(which) {}
};

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StayCard = __webpack_require__(456);

var _StayCard2 = _interopRequireDefault(_StayCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _StayCard2.default;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(913);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _getVehicleActivity = __webpack_require__(215);

var _getVehicleActivity2 = _interopRequireDefault(_getVehicleActivity);

var _vehiclePOICrossings = __webpack_require__(89);

var _vehiclePOICrossings2 = _interopRequireDefault(_vehiclePOICrossings);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _EEP = __webpack_require__(33);

var _EEP2 = _interopRequireDefault(_EEP);

var _poi = __webpack_require__(46);

var _vehiclePOICrossing = __webpack_require__(105);

var _vehiclePOICrossing2 = _interopRequireDefault(_vehiclePOICrossing);

var _StayCard = __webpack_require__(457);

var _StayCard2 = _interopRequireDefault(_StayCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VehiclePOICrossingsStays = function (_React$Component) {
	_inherits(VehiclePOICrossingsStays, _React$Component);

	function VehiclePOICrossingsStays(props) {
		_classCallCheck(this, VehiclePOICrossingsStays);

		var _this = _possibleConstructorReturn(this, (VehiclePOICrossingsStays.__proto__ || Object.getPrototypeOf(VehiclePOICrossingsStays)).call(this, props));

		_this.initState();
		_this.eep = new _EEP2.default();
		_this.setStoreListeners();
		return _this;
	}

	_createClass(VehiclePOICrossingsStays, [{
		key: "initState",
		value: function initState() {
			this.state = Object.assign({
				fixedData: []
			}, this.getStoreDependentState());
		}
	}, {
		key: "getStoreDependentState",
		value: function getStoreDependentState() {

			var vehiclePOICrossingsDescriptor = _vehiclePOICrossings2.default.get(this.props.vehicleId);

			return {
				from: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.options.from : null,
				to: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.options.to : null,
				pois: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.options.poi : [],
				sections: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.result.sections : null
			};
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			this.eep.on(_vehiclePOICrossings2.default, "insert", function (descriptors) {
				var descriptor = descriptors.find(function (d) {
					return d.vehicle == _this2.props.vehicleId;
				});
				if (descriptor) {
					_this2.setState(_this2.getStoreDependentState());
				}
			});
			this.eep.on(_vehiclePOICrossings2.default, "update", function (descriptor) {
				if (descriptor.vehicle == _this2.props.vehicleId) {
					_this2.setState(_this2.getStoreDependentState());
				}
			});
			this.eep.on(_vehiclePOICrossings2.default, "remove", function (vehicleIds) {
				if (vehicleIds.find(function (id) {
					return id == _this2.props.vehicleId;
				})) _this2.setState(_this2.getStoreDependentState());
			});
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			this.eep.close();
		}
	}, {
		key: "focusPOI",
		value: function focusPOI(poi) {
			_dispatcher2.default.dispatch('setMap', {
				bounds: (0, _poi.getBoundsOfPOI)(poi).toJSON()
			});
		}
	}, {
		key: "handleFixData",
		value: function handleFixData(which) {
			var prevFixedData = Array.from(this.state.fixedData);
			var index = prevFixedData.indexOf(which);
			if (index > -1) {
				prevFixedData.splice(index, 1);
			} else {
				prevFixedData.push(which);
			}
			this.setState({
				fixedData: prevFixedData
			});
		}
	}, {
		key: "handleGetActivity",
		value: function handleGetActivity(from, to) {
			_dispatcher2.default.dispatch("switchDetailsPage", this.props.vehicleId, "activity");
			(0, _getVehicleActivity2.default)(this.props.vehicleId, from, to, 0);
		}
	}, {
		key: "highlightVehiclePOICrossing",
		value: function highlightVehiclePOICrossing(time) {
			_dispatcher2.default.dispatch("highlightVehiclePOICrossing", this.props.vehicleId, time);
		}
	}, {
		key: "unhighlightVehiclePOICrossing",
		value: function unhighlightVehiclePOICrossing(time) {
			_dispatcher2.default.dispatch("unhighlightVehiclePOICrossing", this.props.vehicleId, time);
		}
	}, {
		key: "renderStays",
		value: function renderStays() {
			var _this3 = this;

			if (!this.state.sections || this.state.sections && this.state.sections.length == 0) {
				return null;
			}

			return this.state.sections.map(function (section, index) {
				return _react2.default.createElement(_StayCard2.default, {
					key: index,
					section: _vehiclePOICrossing2.default.getResolvedSection(section),
					fixedData: _this3.state.fixedData,
					onClick: function onClick(_) {
						return _this3.focusPOI(section.poi);
					},
					onAddressClick: function onAddressClick(crossingTime) {
						return _vehiclePOICrossing2.default.focusOnVehiclePOICrossing(_this3.props.vehicleId, crossingTime);
					},
					onAddressMouseOver: function onAddressMouseOver(crossingTime) {
						return _this3.highlightVehiclePOICrossing(crossingTime);
					},
					onAddressMouseLeave: function onAddressMouseLeave(crossingTime) {
						return _this3.unhighlightVehiclePOICrossing(crossingTime);
					},
					onFixData: function onFixData(which) {
						return _this3.handleFixData(which);
					},
					onGetActivity: function onGetActivity(from, to) {
						return _this3.handleGetActivity(from, to);
					}
				});
			});
		}
	}, {
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"div",
				{ className: "VehiclePOICrossingsStays" },
				this.renderStays()
			);
		}
	}]);

	return VehiclePOICrossingsStays;
}(_react2.default.Component);

exports.default = VehiclePOICrossingsStays;


VehiclePOICrossingsStays.propTypes = {
	vehicleId: _react2.default.PropTypes.string
};

VehiclePOICrossingsStays.defaultProps = {
	vehicleId: null
};

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VehiclePOICrossingsStays = __webpack_require__(458);

var _VehiclePOICrossingsStays2 = _interopRequireDefault(_VehiclePOICrossingsStays);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VehiclePOICrossingsStays2.default;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(914);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _Pin = __webpack_require__(61);

var _Pin2 = _interopRequireDefault(_Pin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SummaryCard = function (_React$Component) {
	_inherits(SummaryCard, _React$Component);

	function SummaryCard(props) {
		_classCallCheck(this, SummaryCard);

		var _this = _possibleConstructorReturn(this, (SummaryCard.__proto__ || Object.getPrototypeOf(SummaryCard)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(SummaryCard, [{
		key: "initState",
		value: function initState() {
			this.state = {
				expanded: false
			};
		}
	}, {
		key: "toggle",
		value: function toggle() {
			this.setState({
				expanded: !this.state.expanded
			});
		}
	}, {
		key: "handleAddressClick",
		value: function handleAddressClick(evt, time) {
			evt.stopPropagation();
			this.props.onAddressClick(time);
		}
	}, {
		key: "handleDataClick",
		value: function handleDataClick(evt, which) {
			evt.stopPropagation();
			this.props.onFixData(which);
		}
	}, {
		key: "isDisplayedData",
		value: function isDisplayedData(which) {
			return this.props.fixedData.includes(which) || this.state.expanded;
		}
	}, {
		key: "areDisplayedAnyData",
		value: function areDisplayedAnyData() {
			return this.props.fixedData.length > 0;
		}
	}, {
		key: "isBodyShown",
		value: function isBodyShown() {
			return this.state.expanded || this.areDisplayedAnyData();
		}
	}, {
		key: "getRowDataClassName",
		value: function getRowDataClassName(which) {
			return (0, _classnames2.default)({ "Hidden": !this.isDisplayedData(which) }, { "Fixed": this.props.fixedData.includes(which) });
		}
	}, {
		key: "renderCardHeader",
		value: function renderCardHeader() {
			var _this2 = this;

			return _react2.default.createElement(
				"header",
				null,
				_react2.default.createElement(
					"h1",
					{ className: "POIName" },
					this.props.isSummaryOfSummaries ? _lang2.default.SUMMARY_FOR + " " + this.props.summary.poiCount + " " + _lang2.default.POIS : this.props.summary.poi
				),
				_react2.default.createElement(
					"div",
					{ className: "RightContainer" },
					_react2.default.createElement(
						"div",
						{ className: "EmphasizedData" },
						_react2.default.createElement(
							"label",
							null,
							this.props.isSummaryOfSummaries ? this.props.summary.timeDiff : this.props.summary.timeDiff.sum
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "PinContainer" },
						_react2.default.createElement(_Pin2.default, {
							checked: this.props.pinned,
							indeterminate: !this.props.pinnedAll,
							onChange: function onChange(value) {
								return _this2.props.onPinChange(value);
							},
							useForAll: this.props.isSummaryOfSummaries
						})
					)
				)
			);
		}
	}, {
		key: "renderDataTableColumns",
		value: function renderDataTableColumns(data) {
			if (typeof data == "number" || typeof data == "string") {
				return _react2.default.createElement(
					"td",
					null,
					data
				);
			} else if (data.value !== null && data.value !== undefined) {
				return _react2.default.createElement(
					"td",
					null,
					data.value
				);
			} else {
				return [_react2.default.createElement(
					"td",
					{ key: "sum" + Date.now() },
					data.sum
				), _react2.default.createElement(
					"td",
					{ key: "avg" + Date.now() },
					data.avg
				), _react2.default.createElement(
					"td",
					{ key: "max" + Date.now() },
					data.max
				), _react2.default.createElement(
					"td",
					{ key: "min" + Date.now() },
					data.min
				)];
			}
		}
	}, {
		key: "renderTableRow",
		value: function renderTableRow(dataType, label) {
			var _this3 = this;

			var data = this.props.summary[dataType];

			if (data !== null && data !== undefined) {
				return _react2.default.createElement(
					"tr",
					{ className: this.getRowDataClassName(dataType) },
					_react2.default.createElement(
						"td",
						{
							title: _lang2.default.CLICK_HERE_TO_FIX_IT,
							onClick: function onClick(evt) {
								return _this3.handleDataClick(evt, dataType);
							}
						},
						label
					),
					this.renderDataTableColumns(data)
				);
			} else {
				return null;
			}
		}
	}, {
		key: "renderCardBody",
		value: function renderCardBody() {
			return _react2.default.createElement(
				"table",
				{ className: (0, _classnames2.default)({ "Hidden": !this.isBodyShown() }) },
				!this.props.isSummaryOfSummaries ? _react2.default.createElement(
					"thead",
					null,
					_react2.default.createElement(
						"tr",
						null,
						_react2.default.createElement("td", null),
						_react2.default.createElement(
							"td",
							null,
							_lang2.default.SUM
						),
						_react2.default.createElement(
							"td",
							null,
							_lang2.default.AVG
						),
						_react2.default.createElement(
							"td",
							null,
							_lang2.default.MAX
						),
						_react2.default.createElement(
							"td",
							null,
							_lang2.default.MIN
						)
					)
				) : null,
				_react2.default.createElement(
					"tbody",
					null,
					this.renderTableRow("timeDiff", _lang2.default.STAY_TIME),
					this.renderTableRow("totalVehicleDistanceDiff", _lang2.default.DISTANCE_TRAVELED_WITHIN_POI),
					this.renderTableRow("speed", _lang2.default.SPEED),
					this.renderTableRow("ignitionTime", _lang2.default.IGNITION_TIME),
					this.renderTableRow("nonIgnitionTime", _lang2.default.NON_IGNITION_TIME),
					this.renderTableRow("starts", _lang2.default.NUMBER_OF_STARTS),
					this.renderTableRow("stops", _lang2.default.NUMBER_OF_STOPS),
					this.renderTableRow("sectionCount", _lang2.default.NUMBER_OF_SECTIONS),
					this.renderTableRow("arrivals", _lang2.default.NUMBER_OF_ARRIVALS),
					this.renderTableRow("departures", _lang2.default.NUMBER_OF_DEPARTURES)
				)
			);
		}
	}, {
		key: "renderCardFooter",
		value: function renderCardFooter() {
			var _this4 = this;

			return _react2.default.createElement(
				"footer",
				{
					onClick: function onClick(evt) {
						evt.stopPropagation();_this4.toggle();
					}
				},
				"\u2022\u2022\u2022"
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this5 = this;

			return _react2.default.createElement(
				_Card2.default,
				{
					className: "SummaryCard",
					onClick: function onClick() {
						return _this5.props.onClick();
					}
				},
				this.renderCardHeader(),
				this.renderCardBody(),
				this.renderCardFooter()
			);
		}
	}]);

	return SummaryCard;
}(_react2.default.Component);

exports.default = SummaryCard;


SummaryCard.propTypes = {
	summary: _react2.default.PropTypes.object,
	fixedData: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string),
	onClick: _react2.default.PropTypes.func,
	onPinChange: _react2.default.PropTypes.func,
	onFixData: _react2.default.PropTypes.func,
	isSummaryOfSummaries: _react2.default.PropTypes.bool,
	pinned: _react2.default.PropTypes.bool,
	pinnedAll: _react2.default.PropTypes.bool
};

SummaryCard.defaultProps = {
	summary: null,
	fixedData: [],
	onClick: function onClick() {},
	onPinChange: function onPinChange(value) {},
	onFixData: function onFixData(which) {},
	isSummaryOfSummaries: false,
	pinned: false,
	pinnedAll: false
};

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SummaryCard = __webpack_require__(460);

var _SummaryCard2 = _interopRequireDefault(_SummaryCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SummaryCard2.default;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(915);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _vehiclePOICrossings = __webpack_require__(89);

var _vehiclePOICrossings2 = _interopRequireDefault(_vehiclePOICrossings);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _EEP = __webpack_require__(33);

var _EEP2 = _interopRequireDefault(_EEP);

var _poi = __webpack_require__(46);

var _vehiclePOICrossing = __webpack_require__(105);

var _vehiclePOICrossing2 = _interopRequireDefault(_vehiclePOICrossing);

var _SummaryCard = __webpack_require__(461);

var _SummaryCard2 = _interopRequireDefault(_SummaryCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ALL = Symbol();
var ANY = Symbol();

var VehiclePOICrossingsSummaries = function (_React$Component) {
	_inherits(VehiclePOICrossingsSummaries, _React$Component);

	function VehiclePOICrossingsSummaries(props) {
		_classCallCheck(this, VehiclePOICrossingsSummaries);

		var _this = _possibleConstructorReturn(this, (VehiclePOICrossingsSummaries.__proto__ || Object.getPrototypeOf(VehiclePOICrossingsSummaries)).call(this, props));

		_this.initState();
		_this.eep = new _EEP2.default();
		_this.setStoreListeners();
		return _this;
	}

	_createClass(VehiclePOICrossingsSummaries, [{
		key: "initState",
		value: function initState() {
			this.state = Object.assign({
				fixedData: []
			}, this.getStoreDependentState());
		}
	}, {
		key: "getStoreDependentState",
		value: function getStoreDependentState() {

			var vehiclePOICrossingsDescriptor = _vehiclePOICrossings2.default.get(this.props.vehicleId);

			return {
				from: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.options.from : null,
				to: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.options.to : null,
				pois: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.options.poi : [],
				summaries: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.result.summaries : null,
				pinnedCrossings: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.pinnedCrossings : null
			};
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			this.eep.on(_vehiclePOICrossings2.default, "insert", function (descriptors) {
				var descriptor = descriptors.find(function (d) {
					return d.vehicle == _this2.props.vehicleId;
				});
				if (descriptor) {
					_this2.setState(_this2.getStoreDependentState());
				}
			});
			this.eep.on(_vehiclePOICrossings2.default, "update", function (descriptor) {
				if (descriptor.vehicle == _this2.props.vehicleId) {
					_this2.setState(_this2.getStoreDependentState());
				}
			});
			this.eep.on(_vehiclePOICrossings2.default, "remove", function (vehicleIds) {
				if (vehicleIds.find(function (id) {
					return id == _this2.props.vehicleId;
				})) _this2.setState(_this2.getStoreDependentState());
			});
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			this.eep.close();
		}
	}, {
		key: "focusPOI",
		value: function focusPOI(poi) {
			_dispatcher2.default.dispatch('setMap', {
				bounds: (0, _poi.getBoundsOfPOI)(poi).toJSON()
			});
		}
	}, {
		key: "handleFixData",
		value: function handleFixData(which) {
			var prevFixedData = Array.from(this.state.fixedData);
			var index = prevFixedData.indexOf(which);
			if (index > -1) {
				prevFixedData.splice(index, 1);
			} else {
				prevFixedData.push(which);
			}
			this.setState({
				fixedData: prevFixedData
			});
		}
	}, {
		key: "pinPOICrossings",
		value: function pinPOICrossings(poi, value) {
			_dispatcher2.default.dispatch("pinVehiclePOICrossingsOfPOI", this.props.vehicleId, [poi], value);
		}
	}, {
		key: "pinAllPOICrossings",
		value: function pinAllPOICrossings(value) {
			var pois = this.state.summaries.pois.map(function (summary) {
				return summary.poi;
			});
			_dispatcher2.default.dispatch("pinVehiclePOICrossingsOfPOI", this.props.vehicleId, pois, value);
		}
	}, {
		key: "getCumulativePinnedStatus",
		value: function getCumulativePinnedStatus(how) {
			var _this3 = this;

			if (!this.state.summaries) {
				return null;
			}

			var pois = this.state.summaries.pois.map(function (summary) {
				return summary.poi;
			});

			if (how === ALL) {
				return pois.every(function (poi) {
					return _this3.state.pinnedCrossings.has(poi);
				});
			}
			if (how === ANY) {
				return pois.some(function (poi) {
					return _this3.state.pinnedCrossings.has(poi);
				});
			}

			return false;
		}
	}, {
		key: "renderSummaryOfSummaries",
		value: function renderSummaryOfSummaries() {
			var _this4 = this;

			return _react2.default.createElement(_SummaryCard2.default, {
				summary: _vehiclePOICrossing2.default.getResolvedSummaryOfSummaries(this.state.summaries.summary),
				fixedData: this.state.fixedData,
				onClick: function onClick(_) {
					return _vehiclePOICrossing2.default.focusOnVehiclePOICrossings();
				},
				onPinChange: function onPinChange(value) {
					return _this4.pinAllPOICrossings(value);
				},
				onFixData: function onFixData(which) {
					return _this4.handleFixData(which);
				},
				isSummaryOfSummaries: true,
				pinned: this.getCumulativePinnedStatus(ANY),
				pinnedAll: this.getCumulativePinnedStatus(ALL)
			});
		}
	}, {
		key: "renderSummaries",
		value: function renderSummaries() {
			var _this5 = this;

			return this.state.summaries.pois.map(function (summary, index) {
				return _react2.default.createElement(_SummaryCard2.default, {
					key: index,
					summary: _vehiclePOICrossing2.default.getResolvedSummary(summary),
					fixedData: _this5.state.fixedData,
					onClick: function onClick(_) {
						return _this5.focusPOI(summary.poi);
					},
					onPinChange: function onPinChange(value) {
						return _this5.pinPOICrossings(summary.poi, value);
					},
					onFixData: function onFixData(which) {
						return _this5.handleFixData(which);
					},
					pinned: _this5.state.pinnedCrossings ? _this5.state.pinnedCrossings.has(summary.poi) : false
				});
			});
		}
	}, {
		key: "render",
		value: function render() {
			if (!this.state.summaries || this.state.summaries && this.state.summaries.length == 0) {
				return null;
			}

			return _react2.default.createElement(
				"div",
				{ className: "VehiclePOICrossingsSummaries" },
				this.renderSummaryOfSummaries(),
				this.renderSummaries()
			);
		}
	}]);

	return VehiclePOICrossingsSummaries;
}(_react2.default.Component);

exports.default = VehiclePOICrossingsSummaries;


VehiclePOICrossingsSummaries.propTypes = {
	vehicleId: _react2.default.PropTypes.string
};

VehiclePOICrossingsSummaries.defaultProps = {
	vehicleId: null
};

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VehiclePOICrossingsSummaries = __webpack_require__(462);

var _VehiclePOICrossingsSummaries2 = _interopRequireDefault(_VehiclePOICrossingsSummaries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VehiclePOICrossingsSummaries2.default;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(916);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _Pin = __webpack_require__(61);

var _Pin2 = _interopRequireDefault(_Pin);

var _Icon = __webpack_require__(114);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CrossingCard = function (_React$Component) {
	_inherits(CrossingCard, _React$Component);

	function CrossingCard(props) {
		_classCallCheck(this, CrossingCard);

		var _this = _possibleConstructorReturn(this, (CrossingCard.__proto__ || Object.getPrototypeOf(CrossingCard)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(CrossingCard, [{
		key: "initState",
		value: function initState() {
			this.state = {
				expanded: false
			};
		}
	}, {
		key: "toggle",
		value: function toggle() {
			this.setState({
				expanded: !this.state.expanded
			});
		}
	}, {
		key: "handlePOINameClick",
		value: function handlePOINameClick(evt, which) {
			evt.stopPropagation();
			this.props.onPOINameClick(which);
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			var dateTimeString = new Date(this.props.crossing.time).toLocaleString();
			var poiName = poiStore.get(this.props.crossing.poi).name;

			return _react2.default.createElement(
				_Card2.default,
				{
					className: "CrossingCard",
					onClick: function onClick() {
						return _this2.props.onClick();
					},
					onMouseEnter: function onMouseEnter() {
						return _this2.props.onMouseEnter();
					},
					onMouseLeave: function onMouseLeave() {
						return _this2.props.onMouseLeave();
					}
				},
				_react2.default.createElement(
					"div",
					{ className: "InfoContainer" },
					_react2.default.createElement(
						"div",
						{ className: "IconContainer" },
						_react2.default.createElement(
							_Icon2.default,
							null,
							this.props.crossing.inside ? "login" : "logout"
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "DateContainer" },
						_react2.default.createElement(
							"label",
							null,
							dateTimeString
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "AddressContainer" },
						_react2.default.createElement(
							"label",
							{ onClick: function onClick(evt) {
									evt.stopPropagation();
									_this2.props.onPOINameClick(evt, _this2.props.crossing.time);
								} },
							poiName
						)
					)
				)
			);
		}
	}]);

	return CrossingCard;
}(_react2.default.Component);

exports.default = CrossingCard;


CrossingCard.propTypes = {
	crossing: _react2.default.PropTypes.object,
	onClick: _react2.default.PropTypes.func,
	onMouseEnter: _react2.default.PropTypes.func,
	onMouseLeave: _react2.default.PropTypes.func,
	onPOINameClick: _react2.default.PropTypes.func
};

CrossingCard.defaultProps = {
	crossing: null,
	onClick: function onClick() {},
	onMouseEnter: function onMouseEnter() {},
	onMouseLeave: function onMouseLeave() {},
	onPOINameClick: function onPOINameClick(which) {}
};

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CrossingCard = __webpack_require__(464);

var _CrossingCard2 = _interopRequireDefault(_CrossingCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CrossingCard2.default;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(917);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _vehiclePOICrossings = __webpack_require__(89);

var _vehiclePOICrossings2 = _interopRequireDefault(_vehiclePOICrossings);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _EEP = __webpack_require__(33);

var _EEP2 = _interopRequireDefault(_EEP);

var _poi = __webpack_require__(46);

var _vehiclePOICrossing = __webpack_require__(105);

var _CrossingCard = __webpack_require__(465);

var _CrossingCard2 = _interopRequireDefault(_CrossingCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ALL = Symbol();
var ANY = Symbol();

var VehiclePOICrossingsTimeline = function (_React$Component) {
	_inherits(VehiclePOICrossingsTimeline, _React$Component);

	function VehiclePOICrossingsTimeline(props) {
		_classCallCheck(this, VehiclePOICrossingsTimeline);

		var _this = _possibleConstructorReturn(this, (VehiclePOICrossingsTimeline.__proto__ || Object.getPrototypeOf(VehiclePOICrossingsTimeline)).call(this, props));

		_this.initState();
		_this.eep = new _EEP2.default();
		_this.setStoreListeners();
		return _this;
	}

	_createClass(VehiclePOICrossingsTimeline, [{
		key: "initState",
		value: function initState() {
			this.state = this.getStoreDependentState();
		}
	}, {
		key: "getStoreDependentState",
		value: function getStoreDependentState() {

			var vehiclePOICrossingsDescriptor = _vehiclePOICrossings2.default.get(this.props.vehicleId);

			return {
				from: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.options.from : null,
				to: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.options.to : null,
				pois: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.options.poi : [],
				crossings: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.result.crossings : null,
				pinnedCrossings: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.pinnedCrossings : []
			};
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			this.eep.on(_vehiclePOICrossings2.default, "insert", function (descriptors) {
				var descriptor = descriptors.find(function (d) {
					return d.vehicle == _this2.props.vehicleId;
				});
				if (descriptor) {
					_this2.setState(_this2.getStoreDependentState());
				}
			});
			this.eep.on(_vehiclePOICrossings2.default, "update", function (descriptor) {
				if (descriptor.vehicle == _this2.props.vehicleId) {
					_this2.setState(_this2.getStoreDependentState());
				}
			});
			this.eep.on(_vehiclePOICrossings2.default, "remove", function (vehicleIds) {
				if (vehicleIds.find(function (id) {
					return id == _this2.props.vehicleId;
				})) _this2.setState(_this2.getStoreDependentState());
			});
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			this.eep.close();
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate(_, nextState) {
			var _this3 = this;

			if (nextState.from !== this.state.from || nextState.to !== this.state.to) {
				return true;
			}
			if (Object.keys(nextState.pinnedCrossings).some(function (time) {
				return _this3.state.pinnedCrossings[time] != _this3.state.pinnedCrossings[time];
			})) {
				return true;
			}
			// A pois állapot egyenes store-on keresztül
			// az api-től jön. Tehát csak akkor változik
			// a referenciája, ha az api új payload-ot hoz.
			if (nextState.pois !== this.state.pois) return true;
			return false;
		}
	}, {
		key: "getSectionsCumulativePinnedStatus",
		value: function getSectionsCumulativePinnedStatus(how) {
			var _this4 = this;

			if (!this.state.pinnedCrossings) return;

			var times = Object.keys(this.state.pinnedCrossings);

			if (how === ALL) return times.every(function (time) {
				return _this4.state.pinnedCrossings[time];
			});else if (how === ANY) return times.some(function (time) {
				return _this4.state.pinnedCrossings[time];
			});

			return false;
		}
	}, {
		key: "handlePinAll",
		value: function handlePinAll(value) {
			if (!this.state.sections) return;

			_dispatcher2.default.dispatch("pinVehicleActivitySection", this.props.vehicleId, this.state.sections.map(function (_, i) {
				return i;
			}), value);
		}
	}, {
		key: "handleHighlightAll",
		value: function handleHighlightAll(value) {
			if (!this.state.sections) return;

			_dispatcher2.default.dispatch("highlightVehicleActivitySection", this.props.vehicleId, this.state.sections.map(function (_, i) {
				return i;
			}), value);
		}
	}, {
		key: "focusPOI",
		value: function focusPOI(poi) {
			_dispatcher2.default.dispatch('setMap', {
				bounds: (0, _poi.getBoundsOfPOI)(poi).toJSON()
			});
		}
	}, {
		key: "renderCrossing",
		value: function renderCrossing(crossing, count) {
			var _this5 = this;

			return _react2.default.createElement(
				"div",
				{ className: "Crossing", key: count },
				_react2.default.createElement("div", null),
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(_CrossingCard2.default, {
						key: count,
						crossing: crossing,
						onClick: function onClick(evt) {
							return (0, _vehiclePOICrossing.focusOnVehiclePOICrossing)(_this5.props.vehicleId, crossing.time);
						},
						onPOINameClick: function onPOINameClick(_) {
							return _this5.focusPOI(crossing.poi);
						},
						onMouseEnter: function onMouseEnter() {
							return _dispatcher2.default.dispatch("highlightVehiclePOICrossing", _this5.props.vehicleId, crossing.time, true);
						},
						onMouseLeave: function onMouseLeave() {
							return _dispatcher2.default.dispatch("unhighlightVehiclePOICrossing", _this5.props.vehicleId, crossing.time);
						}
					})
				)
			);
		}
	}, {
		key: "renderDaySeparator",
		value: function renderDaySeparator(dateString, key) {
			return _react2.default.createElement(
				"div",
				{ className: "DateSeparator", key: "timeseparator" + key },
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(
						"label",
						null,
						dateString
					)
				),
				_react2.default.createElement(
					"div",
					null,
					_react2.default.createElement("div", { className: "Dot" })
				)
			);
		}
	}, {
		key: "renderCrossings",
		value: function renderCrossings() {
			var _this6 = this;

			if (!this.state.crossings || this.state.crossings && this.state.crossings.length == 0) {
				return null;
			}

			var elements = [];

			this.state.crossings.forEach(function (crossing, i) {
				if (i == 0 || new Date(crossing.time).getDay() != new Date(_this6.state.crossings[i - 1].time).getDay()) {
					elements.push(_this6.renderDaySeparator(new Date(crossing.time).toLocaleDateString(), i));
				}

				elements.push(_this6.renderCrossing(crossing, i));
			});

			return elements;
		}
	}, {
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				"div",
				{ className: "VehiclePOICrossingsTimeline" },
				_react2.default.createElement(
					"div",
					null,
					this.renderCrossings()
				)
			);
		}
	}]);

	return VehiclePOICrossingsTimeline;
}(_react2.default.Component);

exports.default = VehiclePOICrossingsTimeline;


VehiclePOICrossingsTimeline.propTypes = {
	vehicleId: _react2.default.PropTypes.string
};

VehiclePOICrossingsTimeline.defaultProps = {
	vehicleId: null
};

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VehiclePOICrossingsTimeline = __webpack_require__(466);

var _VehiclePOICrossingsTimeline2 = _interopRequireDefault(_VehiclePOICrossingsTimeline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VehiclePOICrossingsTimeline2.default;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(918);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Picker = __webpack_require__(115);

var _Picker2 = _interopRequireDefault(_Picker);

var _MultiSelector = __webpack_require__(102);

var _MultiSelector2 = _interopRequireDefault(_MultiSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POISelector = function (_React$Component) {
	_inherits(POISelector, _React$Component);

	function POISelector(props) {
		_classCallCheck(this, POISelector);

		var _this = _possibleConstructorReturn(this, (POISelector.__proto__ || Object.getPrototypeOf(POISelector)).call(this, props));

		_this.initState();
		return _this;
	}

	_createClass(POISelector, [{
		key: "initState",
		value: function initState() {
			this.state = {
				shown: false
			};
		}
	}, {
		key: "toggle",
		value: function toggle() {
			this.setState({ shown: !this.state.shown });
		}
	}, {
		key: "getPOIOptions",
		value: function getPOIOptions() {
			return (this.props.pois || []).map(function (poi) {
				return {
					value: poi._id,
					label: poi.name
				};
			});
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_Button2.default,
				{
					className: "POISelector",
					icon: "filter",
					onClick: function onClick() {
						return _this2.toggle();
					}
				},
				_react2.default.createElement(
					_Picker2.default,
					{
						className: "POISelectorPicker",
						shown: this.state.shown,
						onWindowClick: function onWindowClick() {
							return _this2.setState({ shown: false });
						}
					},
					_react2.default.createElement(_MultiSelector2.default, {
						title: _lang2.default.SELECT_POIS,
						options: this.getPOIOptions(),
						onChange: this.props.onChange
					})
				)
			);
		}
	}]);

	return POISelector;
}(_react2.default.Component);

exports.default = POISelector;


POISelector.propTypes = {
	pois: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape),
	onChange: _react2.default.PropTypes.func
};

POISelector.defaultProps = {
	pois: [],
	onChange: function onChange(poiIds) {}
};

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _POISelector = __webpack_require__(468);

var _POISelector2 = _interopRequireDefault(_POISelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _POISelector2.default;

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(919);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _pois = __webpack_require__(29);

var _pois2 = _interopRequireDefault(_pois);

var _vehiclePOICrossings = __webpack_require__(89);

var _vehiclePOICrossings2 = _interopRequireDefault(_vehiclePOICrossings);

var _displayedDetails = __webpack_require__(44);

var _displayedDetails2 = _interopRequireDefault(_displayedDetails);

var _vehiclePOICrossing = __webpack_require__(105);

var _vehiclePOICrossing2 = _interopRequireDefault(_vehiclePOICrossing);

var _IntervalEditor = __webpack_require__(149);

var _IntervalEditor2 = _interopRequireDefault(_IntervalEditor);

var _ProgressBar = __webpack_require__(34);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _DateTimePicker = __webpack_require__(147);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Tabs = __webpack_require__(116);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Pager = __webpack_require__(87);

var _Pager2 = _interopRequireDefault(_Pager);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _EEP = __webpack_require__(33);

var _EEP2 = _interopRequireDefault(_EEP);

var _POISelector = __webpack_require__(469);

var _POISelector2 = _interopRequireDefault(_POISelector);

var _VehiclePOICrossingsTimeline = __webpack_require__(467);

var _VehiclePOICrossingsTimeline2 = _interopRequireDefault(_VehiclePOICrossingsTimeline);

var _VehiclePOICrossingsStays = __webpack_require__(459);

var _VehiclePOICrossingsStays2 = _interopRequireDefault(_VehiclePOICrossingsStays);

var _VehiclePOICrossingsSummaries = __webpack_require__(463);

var _VehiclePOICrossingsSummaries2 = _interopRequireDefault(_VehiclePOICrossingsSummaries);

var _getVehiclePOICrossings = __webpack_require__(360);

var _getVehiclePOICrossings2 = _interopRequireDefault(_getVehiclePOICrossings);

var _shouldComponentUpdate2 = __webpack_require__(43);

var _shouldComponentUpdate3 = _interopRequireDefault(_shouldComponentUpdate2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_INTERVAL = 1000 * 60 * 60 * 24 * 31 * 6;

var VehiclePOICrossings = function (_React$Component) {
	_inherits(VehiclePOICrossings, _React$Component);

	function VehiclePOICrossings(props) {
		_classCallCheck(this, VehiclePOICrossings);

		var _this = _possibleConstructorReturn(this, (VehiclePOICrossings.__proto__ || Object.getPrototypeOf(VehiclePOICrossings)).call(this, props));

		_this.initState();
		_this.eep = new _EEP2.default();
		_this.setStoreListeners();
		return _this;
	}

	_createClass(VehiclePOICrossings, [{
		key: "initState",
		value: function initState() {
			this.state = {
				poiCrossingsDescriptor: null,
				from: Date.parse(function (d) {
					d.setDate(d.getDate() - 1);return d;
				}(new Date())),
				to: Date.now(),
				selectedPOIIds: _pois2.default.getAll().map(function (poi) {
					return poi._id;
				}),
				inProgress: false,
				page: "timeline",
				pois: _pois2.default.getAll() || []
			};
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			this.eep.on(_vehiclePOICrossings2.default, "insert", function (poiCrossingsDescriptors) {
				return _this2.loadActivity(poiCrossingsDescriptors);
			});
			this.eep.on(_vehiclePOICrossings2.default, "update", function (poiCrossingsDescriptor) {
				return _this2.loadActivity([poiCrossingsDescriptor]);
			});
			this.eep.on(_displayedDetails2.default, "change", function (detailsDescriptor) {
				return _this2.handleDetailsStoreChange(detailsDescriptor);
			});
			this.eep.on(_pois2.default, "change", function (pois) {
				return _this2.setState({ pois: pois });
			});
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate() {
			for (var _len = arguments.length, nexts = Array(_len), _key = 0; _key < _len; _key++) {
				nexts[_key] = arguments[_key];
			}

			return _shouldComponentUpdate3.default.apply(undefined, [this].concat(nexts));
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			this.eep.close();
		}
	}, {
		key: "handleDetailsStoreChange",
		value: function handleDetailsStoreChange(detailsDescriptor) {
			if (detailsDescriptor && detailsDescriptor.id == this.props.vehicleId && _vehiclePOICrossing2.default.getVisibilityOfPOICrossings(this.props.vehicleId) && !this.state.poiCrossingsDescriptor) {
				this.getPOICrossingsDescriptors();
			}
		}
	}, {
		key: "loadActivity",
		value: function loadActivity(poiCrossingsDescriptors) {
			if (poiCrossingsDescriptors[0].vehicle == this.props.vehicleId) {
				this.setState({ poiCrossingsDescriptor: poiCrossingsDescriptors[0] });
			}
		}
	}, {
		key: "getPOICrossingsDescriptors",
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								this.setState({ inProgress: true });
								_dispatcher2.default.dispatch("clearVehiclePOICrossings", this.props.vehicleId);
								_context.next = 4;
								return (0, _getVehiclePOICrossings2.default)({
									vehicleId: this.props.vehicleId,
									from: this.state.from,
									to: this.state.to,
									poi: this.state.selectedPOIIds
								});

							case 4:
								this.setState({ inProgress: false });

							case 5:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function getPOICrossingsDescriptors() {
				return _ref.apply(this, arguments);
			}

			return getPOICrossingsDescriptors;
		}()
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			if (openedDetailsStore.get(this.props.vehicleId).activePage == "poiCrossings") {
				this.getPOICrossingsDescriptors();
			}
		}
	}, {
		key: "render",
		value: function render() {
			var _this3 = this;

			var intervalEditorProps = {
				nullable: false,
				interval: {
					from: this.state.from,
					to: this.state.to
				},
				onChange: function onChange(interval) {
					if (interval.to - interval.from > MAX_INTERVAL) {
						new _Toast2.default(_lang2.default.TOO_LONG_INTERVAL, "Orange");
					}
					_this3.setState({
						from: interval.from,
						to: interval.to
					});
				}
			};

			var noResult = !this.state.inProgress && this.state.poiCrossingsDescriptor && this.state.poiCrossingsDescriptor.result && this.state.poiCrossingsDescriptor.result.crossings.length == 0;

			var resultClassNames = (0, _classnames2.default)("Result", { "Invisible": this.state.inProgress || !this.state.poiCrossingsDescriptor || noResult });

			return _react2.default.createElement(
				"div",
				{ className: "VehiclePOICrossings" },
				_react2.default.createElement(
					"header",
					{ className: "Shadowed" },
					_react2.default.createElement(
						"div",
						{ className: "IntervalEditorContainer" },
						_react2.default.createElement(_IntervalEditor2.default, intervalEditorProps),
						_react2.default.createElement(_POISelector2.default, { onChange: function onChange(selectedPOIIds) {
								return _this3.setState({ selectedPOIIds: selectedPOIIds });
							}, pois: this.state.pois }),
						_react2.default.createElement(
							_Button2.default,
							{ className: "Red", disabled: this.state.inProgress || this.state.from && this.state.to && this.state.to - this.state.from > MAX_INTERVAL, onClick: function onClick(_) {
									return _this3.getPOICrossingsDescriptors();
								} },
							_lang2.default.SUBMIT
						)
					),
					_react2.default.createElement(
						_Tabs2.default,
						{
							selected: this.state.page,
							onChange: function onChange(id) {
								return _this3.setState({ page: id });
							},
							className: noResult ? "Hidden" : null
						},
						_react2.default.createElement(
							"li",
							{ id: "timeline" },
							_lang2.default.TIMELINE
						),
						_react2.default.createElement(
							"li",
							{ id: "stays" },
							_lang2.default.STAYS
						),
						_react2.default.createElement(
							"li",
							{ id: "summaries" },
							_lang2.default.SUMMARIES
						)
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "Content" },
					_react2.default.createElement(_ProgressBar2.default, { indeterminate: true, shown: this.state.inProgress }),
					_react2.default.createElement(
						"h1",
						{ className: (0, _classnames2.default)("Message", { "Hidden": !noResult }) },
						_lang2.default.NO_RESULTS_FOUND
					),
					_react2.default.createElement(
						_Pager2.default,
						{ active: this.state.page },
						_react2.default.createElement(
							"div",
							{ className: resultClassNames, id: "timeline" },
							_react2.default.createElement(_VehiclePOICrossingsTimeline2.default, { vehicleId: this.props.vehicleId })
						),
						_react2.default.createElement(
							"div",
							{ className: resultClassNames, id: "stays" },
							_react2.default.createElement(_VehiclePOICrossingsStays2.default, { vehicleId: this.props.vehicleId })
						),
						_react2.default.createElement(
							"div",
							{ className: resultClassNames, id: "summaries" },
							_react2.default.createElement(_VehiclePOICrossingsSummaries2.default, { vehicleId: this.props.vehicleId })
						)
					)
				)
			);
		}
	}]);

	return VehiclePOICrossings;
}(_react2.default.Component);

exports.default = VehiclePOICrossings;


VehiclePOICrossings.propTypes = {
	vehicleId: _react2.default.PropTypes.string
};

VehiclePOICrossings.defaultProps = {
	vehicleId: ""
};

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VehiclePOICrossings = __webpack_require__(470);

var _VehiclePOICrossings2 = _interopRequireDefault(_VehiclePOICrossings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VehiclePOICrossings2.default;

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(920);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _dispatcher = __webpack_require__(2);

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _vehicles = __webpack_require__(45);

var _vehicles2 = _interopRequireDefault(_vehicles);

var _vehicleModifications = __webpack_require__(224);

var _vehicleModifications2 = _interopRequireDefault(_vehicleModifications);

var _session = __webpack_require__(30);

var _session2 = _interopRequireDefault(_session);

var _createWellQuantity = __webpack_require__(88);

var _createWellQuantity2 = _interopRequireDefault(_createWellQuantity);

var _getOriginalValueFromWellQuantity = __webpack_require__(212);

var _getOriginalValueFromWellQuantity2 = _interopRequireDefault(_getOriginalValueFromWellQuantity);

var _format = __webpack_require__(211);

var _format2 = _interopRequireDefault(_format);

var _user = __webpack_require__(20);

var _Form = __webpack_require__(38);

var _Form2 = _interopRequireDefault(_Form);

var _ProgressBar = __webpack_require__(34);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Card = __webpack_require__(21);

var _Card2 = _interopRequireDefault(_Card);

var _Button = __webpack_require__(10);

var _Button2 = _interopRequireDefault(_Button);

var _Input = __webpack_require__(52);

var _Input2 = _interopRequireDefault(_Input);

var _ColorPicker = __webpack_require__(203);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _InputWithUnit = __webpack_require__(204);

var _InputWithUnit2 = _interopRequireDefault(_InputWithUnit);

var _Toast = __webpack_require__(12);

var _Toast2 = _interopRequireDefault(_Toast);

var _lang = __webpack_require__(5);

var _lang2 = _interopRequireDefault(_lang);

var _EEP = __webpack_require__(33);

var _EEP2 = _interopRequireDefault(_EEP);

var _shouldComponentUpdate2 = __webpack_require__(43);

var _shouldComponentUpdate3 = _interopRequireDefault(_shouldComponentUpdate2);

var _vehicle = __webpack_require__(91);

var _saveVehicle = __webpack_require__(365);

var _saveVehicle2 = _interopRequireDefault(_saveVehicle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_COLOR = "#FFFFFF";

var propertyToQuantity = {
	weight: "weight",
	height: "vehicleLength",
	length: "vehicleLength",
	width: "vehicleLength"
};

var defaultUnits = {
	weight: "kg",
	vehicleLength: "cm"
};

var VehicleProperties = function (_React$Component) {
	_inherits(VehicleProperties, _React$Component);

	function VehicleProperties(props) {
		_classCallCheck(this, VehicleProperties);

		var _this = _possibleConstructorReturn(this, (VehicleProperties.__proto__ || Object.getPrototypeOf(VehicleProperties)).call(this, props));

		_this.initState();
		_this.eep = new _EEP2.default();
		_this.setStoreListeners();
		return _this;
	}

	_createClass(VehicleProperties, [{
		key: "initState",
		value: function initState() {
			this.state = {
				inProgress: false,
				vehicle: _vehicles2.default.get(this.props.vehicleId),
				modifications: this.getModificationsFromStore()
			};
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate() {
			for (var _len = arguments.length, nexts = Array(_len), _key = 0; _key < _len; _key++) {
				nexts[_key] = arguments[_key];
			}

			return _shouldComponentUpdate3.default.apply(undefined, [this].concat(nexts));
		}
	}, {
		key: "getModificationsFromStore",
		value: function getModificationsFromStore() {
			var modDoc = _vehicleModifications2.default.get(this.props.vehicleId);
			if (!modDoc) return {};
			return modDoc.modifications;
		}
	}, {
		key: "setStoreListeners",
		value: function setStoreListeners() {
			var _this2 = this;

			this.eep.on(_vehicles2.default, "update", function (vehicle) {
				if (vehicle._id == _this2.props.vehicleId) _this2.setState({ vehicle: vehicle });
			});
			this.eep.on(_vehicleModifications2.default, "insert", function (modificationDocs) {
				var modificationDoc = modificationDocs.find(function (md) {
					return md.vehicle == _this2.props.vehicleId;
				});
				if (!modificationDoc) return;
				_this2.setState({
					modifications: _this2.getModificationsFromStore()
				});
			});
			this.eep.on(_vehicleModifications2.default, "update", function (modificationDoc) {
				if (modificationDoc.vehicle == _this2.props.vehicleId) _this2.setState({
					modifications: _this2.getModificationsFromStore()
				});
			});
			this.eep.on(_vehicleModifications2.default, "remove", function (modificationDocs) {
				var modificationDoc = modificationDocs.find(function (md) {
					return md.vehicle == _this2.props.vehicleId;
				});
				if (!modificationDoc) return;
				_this2.setState({
					modifications: _this2.getModificationsFromStore()
				});
			});
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			this.eep.close();
		}
	}, {
		key: "hasModifications",
		value: function hasModifications() {
			return Object.keys(this.state.modifications).length > 0;
		}
	}, {
		key: "getPropertyValue",
		value: function getPropertyValue(field) {
			var value = null;
			if (field in this.state.modifications) return this.state.modifications[field];else return this.state.vehicle[field];
		}
	}, {
		key: "getWellQuantity",
		value: function getWellQuantity(field) {
			var value = this.getPropertyValue(field);
			var unitAssignment = (0, _user.getUnitAssignment)();
			if (!unitAssignment) return { value: value };
			var quantity = propertyToQuantity[field];
			if (!quantity) return { value: value };
			var defaultUnit = defaultUnits[quantity];
			return (0, _createWellQuantity2.default)(unitAssignment, quantity, value, defaultUnit, "integer") || { value: value };
		}
	}, {
		key: "getValue",
		value: function getValue(field) {
			return this.getWellQuantity(field).value || "";
		}
	}, {
		key: "getUnit",
		value: function getUnit(field) {
			return this.getWellQuantity(field).unit || "";
		}
	}, {
		key: "canEdit",
		value: function canEdit() {
			var privilege = (0, _vehicle.getPrivilegeOfVehicle)(this.props.vehicleId);
			return privilege >= 2;
		}
	}, {
		key: "handleQuantityPropertyChange",
		value: function handleQuantityPropertyChange(field, value) {
			var hasUnit = !!this.getUnit(field);
			var originalValue = originalValue ? (0, _getOriginalValueFromWellQuantity2.default)({ value: value, unit: this.getUnit(field) }, defaultUnits[propertyToQuantity[field]], "integer") : (0, _format2.default)(value);

			var modifications = _defineProperty({}, field, originalValue);

			_dispatcher2.default.dispatch("modifyVehicle", this.props.vehicleId, modifications);
		}
	}, {
		key: "handlePropertyChange",
		value: function handlePropertyChange(field, value) {
			_dispatcher2.default.dispatch("modifyVehicle", this.props.vehicleId, _defineProperty({}, field, value));
		}
	}, {
		key: "getSaveButtonDisabled",
		value: function getSaveButtonDisabled() {
			return !this.canEdit() || !this.hasModifications();
		}
	}, {
		key: "save",
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								this.setState({ inProgress: true });
								_context.next = 3;
								return (0, _saveVehicle2.default)(this.props.vehicleId);

							case 3:
								this.setState({ inProgress: false });

							case 4:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function save() {
				return _ref.apply(this, arguments);
			}

			return save;
		}()
	}, {
		key: "render",
		value: function render() {
			var _this3 = this;

			return _react2.default.createElement(
				"div",
				{ className: "VehicleProperties" },
				_react2.default.createElement(
					"header",
					{ className: "Shadowed" },
					_react2.default.createElement(
						_Button2.default,
						{
							className: "Red",
							onClick: function onClick() {
								return _this3.save();
							},
							disabled: this.getSaveButtonDisabled()
						},
						_lang2.default.SAVE
					)
				),
				_react2.default.createElement(_ProgressBar2.default, {
					indeterminate: true,
					shown: this.state.inProgress
				}),
				_react2.default.createElement(
					"div",
					{ className: (0, _classnames2.default)("Content", { "Hidden": this.state.inProgress }) },
					_react2.default.createElement(
						_Card2.default,
						null,
						_react2.default.createElement(
							_Form2.default,
							null,
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.NAME
							),
							_react2.default.createElement(_Input2.default, {
								value: this.getValue("name"),
								onChange: function onChange(evt) {
									return _this3.handlePropertyChange("name", evt.target.value);
								},
								disabled: !this.canEdit()
							}),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.PLATE_NUMBER
							),
							_react2.default.createElement(_Input2.default, {
								value: this.getValue("plateNumber"),
								onChange: function onChange(evt) {
									return _this3.handlePropertyChange("plateNumber", evt.target.value);
								},
								disabled: !this.canEdit()
							}),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.VIN
							),
							_react2.default.createElement(_Input2.default, {
								value: this.getValue("vin"),
								onChange: function onChange(evt) {
									return _this3.handlePropertyChange("vin", evt.target.value);
								},
								disabled: !this.canEdit()
							}),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.MAKE
							),
							_react2.default.createElement(_Input2.default, {
								value: this.getValue("make"),
								onChange: function onChange(evt) {
									return _this3.handlePropertyChange("make", evt.target.value);
								},
								disabled: !this.canEdit()
							}),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.YEAR_OF_PRODUCTION
							),
							_react2.default.createElement(_Input2.default, {
								value: this.getValue("yearOfProduction"),
								type: "number",
								onChange: function onChange(evt) {
									return _this3.handlePropertyChange("yearOfProduction", parseInt(evt.target.value));
								},
								min: "1900",
								max: new Date().getFullYear(),
								disabled: !this.canEdit()
							})
						)
					),
					_react2.default.createElement(
						_Card2.default,
						null,
						_react2.default.createElement(
							_Form2.default,
							null,
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.WEIGHT
							),
							_react2.default.createElement(_InputWithUnit2.default, {
								value: this.getValue("weight"),
								type: "number",
								onChange: function onChange(evt) {
									return _this3.handleQuantityPropertyChange("weight", evt.target.value);
								},
								label: this.getUnit("weight"),
								disabled: !this.canEdit()
							}),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.HEIGHT
							),
							_react2.default.createElement(_InputWithUnit2.default, {
								value: this.getValue("height"),
								type: "number",
								onChange: function onChange(evt) {
									return _this3.handleQuantityPropertyChange("height", evt.target.value);
								},
								label: this.getUnit("height"),
								disabled: !this.canEdit()
							}),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.LENGTH
							),
							_react2.default.createElement(_InputWithUnit2.default, {
								value: this.getValue("length"),
								type: "number",
								onChange: function onChange(evt) {
									return _this3.handleQuantityPropertyChange("length", evt.target.value);
								},
								label: this.getUnit("length"),
								disabled: !this.canEdit()
							}),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.WIDTH
							),
							_react2.default.createElement(_InputWithUnit2.default, {
								value: this.getValue("width"),
								type: "number",
								onChange: function onChange(evt) {
									return _this3.handleQuantityPropertyChange("width", evt.target.value);
								},
								label: this.getUnit("width"),
								disabled: !this.canEdit()
							}),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.COLOR
							),
							_react2.default.createElement(_ColorPicker2.default, {
								color: this.getValue("color") || DEFAULT_COLOR,
								onChange: function onChange(color) {
									return _this3.handlePropertyChange("color", color);
								},
								disabled: !this.canEdit()
							}),
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.AXLE_NUMBER,
								":"
							),
							_react2.default.createElement(_Input2.default, {
								value: this.getValue("axleNumber"),
								type: "number",
								onChange: function onChange(evt) {
									return _this3.handlePropertyChange("axleNumber", parseInt(evt.target.value));
								},
								disabled: !this.canEdit()
							})
						)
					)
				)
			);
		}
	}]);

	return VehicleProperties;
}(_react2.default.Component);

exports.default = VehicleProperties;


VehicleProperties.propTypes = {
	vehicleId: _react2.default.PropTypes.string
};

VehicleProperties.defaultProps = {
	vehicleId: null
};

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VehicleProperties = __webpack_require__(472);

var _VehicleProperties2 = _interopRequireDefault(_VehicleProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VehicleProperties2.default;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Connection = __webpack_require__(349);

var _Connection2 = _interopRequireDefault(_Connection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Connection2.default();

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(482);
module.exports = __webpack_require__(48).RegExp.escape;


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
var isArray = __webpack_require__(127);
var SPECIES = __webpack_require__(18)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(11);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var anObject = __webpack_require__(8);
var toPrimitive = __webpack_require__(58);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(80);
var gOPS = __webpack_require__(131);
var pIE = __webpack_require__(108);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ },
/* 480 */
/***/ function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ },
/* 481 */
/***/ function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(480)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(233) });

__webpack_require__(70)('copyWithin');


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var $every = __webpack_require__(54)(4);

$export($export.P + $export.F * !__webpack_require__(50)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(159) });

__webpack_require__(70)('fill');


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var $filter = __webpack_require__(54)(2);

$export($export.P + $export.F * !__webpack_require__(50)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(54)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(70)(KEY);


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(54)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(70)(KEY);


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var $forEach = __webpack_require__(54)(0);
var STRICT = __webpack_require__(50)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var ctx = __webpack_require__(49);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(27);
var call = __webpack_require__(244);
var isArrayIter = __webpack_require__(167);
var toLength = __webpack_require__(24);
var createProperty = __webpack_require__(161);
var getIterFn = __webpack_require__(183);

$export($export.S + $export.F * !__webpack_require__(129)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(123)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(50)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(127) });


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(42);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(107) != Object || !__webpack_require__(50)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(42);
var toInteger = __webpack_require__(57);
var toLength = __webpack_require__(24);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(50)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var $map = __webpack_require__(54)(1);

$export($export.P + $export.F * !__webpack_require__(50)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var createProperty = __webpack_require__(161);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(11)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var $reduce = __webpack_require__(235);

$export($export.P + $export.F * !__webpack_require__(50)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var $reduce = __webpack_require__(235);

$export($export.P + $export.F * !__webpack_require__(50)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var html = __webpack_require__(165);
var cof = __webpack_require__(47);
var toAbsoluteIndex = __webpack_require__(84);
var toLength = __webpack_require__(24);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(11)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var $some = __webpack_require__(54)(3);

$export($export.P + $export.F * !__webpack_require__(50)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(31);
var toObject = __webpack_require__(27);
var fails = __webpack_require__(11);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(50)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(83)('Array');


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(477);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var toObject = __webpack_require__(27);
var toPrimitive = __webpack_require__(58);

$export($export.P + $export.F * __webpack_require__(11)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(18)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(35)(proto, TO_PRIMITIVE, __webpack_require__(478));


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(36)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(236) });


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var isObject = __webpack_require__(13);
var getPrototypeOf = __webpack_require__(41);
var HAS_INSTANCE = __webpack_require__(18)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(23).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

var dP = __webpack_require__(23).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(22) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(247);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(171);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(170);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(246) });


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(11)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(247) });


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(171) });


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(170);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(11)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(170);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var global = __webpack_require__(9);
var has = __webpack_require__(39);
var cof = __webpack_require__(47);
var inheritIfRequired = __webpack_require__(166);
var toPrimitive = __webpack_require__(58);
var fails = __webpack_require__(11);
var gOPN = __webpack_require__(79).f;
var gOPD = __webpack_require__(40).f;
var dP = __webpack_require__(23).f;
var $trim = __webpack_require__(94).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(78)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(22) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(36)(global, NUMBER, $Number);
}


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(9).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(243) });


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(243);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(255);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(256);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var toInteger = __webpack_require__(57);
var aNumberValue = __webpack_require__(232);
var repeat = __webpack_require__(178);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(11)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var $fails = __webpack_require__(11);
var aNumberValue = __webpack_require__(232);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(249) });


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(78) });


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(22), 'Object', { defineProperties: __webpack_require__(250) });


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(22), 'Object', { defineProperty: __webpack_require__(23).f });


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(13);
var meta = __webpack_require__(72).onFreeze;

__webpack_require__(56)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(42);
var $getOwnPropertyDescriptor = __webpack_require__(40).f;

__webpack_require__(56)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(56)('getOwnPropertyNames', function () {
  return __webpack_require__(251).f;
});


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(27);
var $getPrototypeOf = __webpack_require__(41);

__webpack_require__(56)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(13);

__webpack_require__(56)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(13);

__webpack_require__(56)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(13);

__webpack_require__(56)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(481) });


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(27);
var $keys = __webpack_require__(80);

__webpack_require__(56)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(13);
var meta = __webpack_require__(72).onFreeze;

__webpack_require__(56)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(13);
var meta = __webpack_require__(72).onFreeze;

__webpack_require__(56)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(174).set });


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(106);
var test = {};
test[__webpack_require__(18)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(36)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(255);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(256);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var LIBRARY = __webpack_require__(71);
var global = __webpack_require__(9);
var ctx = __webpack_require__(49);
var classof = __webpack_require__(106);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(13);
var aFunction = __webpack_require__(31);
var anInstance = __webpack_require__(76);
var forOf = __webpack_require__(77);
var speciesConstructor = __webpack_require__(135);
var task = __webpack_require__(180).set;
var microtask = __webpack_require__(172)();
var newPromiseCapabilityModule = __webpack_require__(173);
var perform = __webpack_require__(257);
var userAgent = __webpack_require__(137);
var promiseResolve = __webpack_require__(258);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(18)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(82)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(93)($Promise, PROMISE);
__webpack_require__(83)(PROMISE);
Wrapper = __webpack_require__(48)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(129)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(31);
var anObject = __webpack_require__(8);
var rApply = (__webpack_require__(9).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(11)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(78);
var aFunction = __webpack_require__(31);
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(13);
var fails = __webpack_require__(11);
var bind = __webpack_require__(236);
var rConstruct = (__webpack_require__(9).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(23);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(8);
var toPrimitive = __webpack_require__(58);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(11)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(40).f;
var anObject = __webpack_require__(8);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(8);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(168)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(40);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(8);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(41);
var anObject = __webpack_require__(8);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(40);
var getPrototypeOf = __webpack_require__(41);
var has = __webpack_require__(39);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(13);
var anObject = __webpack_require__(8);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(8);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(254) });


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(8);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(174);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(23);
var gOPD = __webpack_require__(40);
var getPrototypeOf = __webpack_require__(41);
var has = __webpack_require__(39);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(81);
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(13);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var inheritIfRequired = __webpack_require__(166);
var dP = __webpack_require__(23).f;
var gOPN = __webpack_require__(79).f;
var isRegExp = __webpack_require__(128);
var $flags = __webpack_require__(126);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(22) && (!CORRECT_NEW || __webpack_require__(11)(function () {
  re2[__webpack_require__(18)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(36)(global, 'RegExp', $RegExp);
}

__webpack_require__(83)('RegExp');


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(125)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(125)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(125)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(125)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(128);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
__webpack_require__(263);
var anObject = __webpack_require__(8);
var $flags = __webpack_require__(126);
var DESCRIPTORS = __webpack_require__(22);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(36)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(11)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(37)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// B.2.3.3 String.prototype.big()
__webpack_require__(37)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// B.2.3.4 String.prototype.blink()
__webpack_require__(37)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// B.2.3.5 String.prototype.bold()
__webpack_require__(37)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var $at = __webpack_require__(176)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
'use strict';
var $export = __webpack_require__(0);
var toLength = __webpack_require__(24);
var context = __webpack_require__(177);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(164)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// B.2.3.6 String.prototype.fixed()
__webpack_require__(37)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(37)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(37)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(84);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';
var $export = __webpack_require__(0);
var context = __webpack_require__(177);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(164)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// B.2.3.9 String.prototype.italics()
__webpack_require__(37)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $at = __webpack_require__(176)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(169)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// B.2.3.10 String.prototype.link(url)
__webpack_require__(37)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(42);
var toLength = __webpack_require__(24);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(178)
});


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// B.2.3.11 String.prototype.small()
__webpack_require__(37)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';
var $export = __webpack_require__(0);
var toLength = __webpack_require__(24);
var context = __webpack_require__(177);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(164)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// B.2.3.12 String.prototype.strike()
__webpack_require__(37)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// B.2.3.13 String.prototype.sub()
__webpack_require__(37)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// B.2.3.14 String.prototype.sup()
__webpack_require__(37)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// 21.1.3.25 String.prototype.trim()
__webpack_require__(94)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// ECMAScript 6 symbols shim
var global = __webpack_require__(9);
var has = __webpack_require__(39);
var DESCRIPTORS = __webpack_require__(22);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(36);
var META = __webpack_require__(72).KEY;
var $fails = __webpack_require__(11);
var shared = __webpack_require__(134);
var setToStringTag = __webpack_require__(93);
var uid = __webpack_require__(85);
var wks = __webpack_require__(18);
var wksExt = __webpack_require__(261);
var wksDefine = __webpack_require__(182);
var enumKeys = __webpack_require__(479);
var isArray = __webpack_require__(127);
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(13);
var toIObject = __webpack_require__(42);
var toPrimitive = __webpack_require__(58);
var createDesc = __webpack_require__(81);
var _create = __webpack_require__(78);
var gOPNExt = __webpack_require__(251);
var $GOPD = __webpack_require__(40);
var $DP = __webpack_require__(23);
var $keys = __webpack_require__(80);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(79).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(108).f = $propertyIsEnumerable;
  __webpack_require__(131).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(71)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(35)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var $typed = __webpack_require__(136);
var buffer = __webpack_require__(181);
var anObject = __webpack_require__(8);
var toAbsoluteIndex = __webpack_require__(84);
var toLength = __webpack_require__(24);
var isObject = __webpack_require__(13);
var ArrayBuffer = __webpack_require__(9).ArrayBuffer;
var speciesConstructor = __webpack_require__(135);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(11)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(83)(ARRAY_BUFFER);


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(136).ABV, {
  DataView: __webpack_require__(181).DataView
});


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(63)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(63)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(63)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(63)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(63)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(63)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(63)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(63)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(63)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var weak = __webpack_require__(239);
var validate = __webpack_require__(95);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(124)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(240);
var toObject = __webpack_require__(27);
var toLength = __webpack_require__(24);
var aFunction = __webpack_require__(31);
var arraySpeciesCreate = __webpack_require__(160);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(70)('flatMap');


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(240);
var toObject = __webpack_require__(27);
var toLength = __webpack_require__(24);
var toInteger = __webpack_require__(57);
var arraySpeciesCreate = __webpack_require__(160);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(70)('flatten');


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(123)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(70)('includes');


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(172)();
var process = __webpack_require__(9).process;
var isNode = __webpack_require__(47)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(47);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(9) });


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(132)('Map');


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(133)('Map');


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(238)('Map') });


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(248);
var fround = __webpack_require__(246);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(248) });


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var toObject = __webpack_require__(27);
var aFunction = __webpack_require__(31);
var $defineProperty = __webpack_require__(23);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(22) && $export($export.P + __webpack_require__(130), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var toObject = __webpack_require__(27);
var aFunction = __webpack_require__(31);
var $defineProperty = __webpack_require__(23);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(22) && $export($export.P + __webpack_require__(130), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(253)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(254);
var toIObject = __webpack_require__(42);
var gOPD = __webpack_require__(40);
var createProperty = __webpack_require__(161);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var toObject = __webpack_require__(27);
var toPrimitive = __webpack_require__(58);
var getPrototypeOf = __webpack_require__(41);
var getOwnPropertyDescriptor = __webpack_require__(40).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(22) && $export($export.P + __webpack_require__(130), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
var $export = __webpack_require__(0);
var toObject = __webpack_require__(27);
var toPrimitive = __webpack_require__(58);
var getPrototypeOf = __webpack_require__(41);
var getOwnPropertyDescriptor = __webpack_require__(40).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(22) && $export($export.P + __webpack_require__(130), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(253)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(9);
var core = __webpack_require__(48);
var microtask = __webpack_require__(172)();
var OBSERVABLE = __webpack_require__(18)('observable');
var aFunction = __webpack_require__(31);
var anObject = __webpack_require__(8);
var anInstance = __webpack_require__(76);
var redefineAll = __webpack_require__(82);
var hide = __webpack_require__(35);
var forOf = __webpack_require__(77);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(83)('Observable');


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally
'use strict';
var $export = __webpack_require__(0);
var core = __webpack_require__(48);
var global = __webpack_require__(9);
var speciesConstructor = __webpack_require__(135);
var promiseResolve = __webpack_require__(258);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(173);
var perform = __webpack_require__(257);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(62);
var anObject = __webpack_require__(8);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(62);
var anObject = __webpack_require__(8);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

var Set = __webpack_require__(264);
var from = __webpack_require__(234);
var metadata = __webpack_require__(62);
var anObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(41);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(62);
var anObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(41);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(62);
var anObject = __webpack_require__(8);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(62);
var anObject = __webpack_require__(8);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(62);
var anObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(41);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(62);
var anObject = __webpack_require__(8);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(62);
var anObject = __webpack_require__(8);
var aFunction = __webpack_require__(31);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(132)('Set');


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(133)('Set');


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(238)('Set') });


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(176)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(55);
var toLength = __webpack_require__(24);
var isRegExp = __webpack_require__(128);
var getFlags = __webpack_require__(126);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(168)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(259);
var userAgent = __webpack_require__(137);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(259);
var userAgent = __webpack_require__(137);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(94)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(94)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(182)('asyncIterator');


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(182)('observable');


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(9) });


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(132)('WeakMap');


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(133)('WeakMap');


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(132)('WeakSet');


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(133)('WeakSet');


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(184);
var getKeys = __webpack_require__(80);
var redefine = __webpack_require__(36);
var global = __webpack_require__(9);
var hide = __webpack_require__(35);
var Iterators = __webpack_require__(92);
var wks = __webpack_require__(18);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(180);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(9);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(137);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(602);
__webpack_require__(541);
__webpack_require__(543);
__webpack_require__(542);
__webpack_require__(545);
__webpack_require__(547);
__webpack_require__(552);
__webpack_require__(546);
__webpack_require__(544);
__webpack_require__(554);
__webpack_require__(553);
__webpack_require__(549);
__webpack_require__(550);
__webpack_require__(548);
__webpack_require__(540);
__webpack_require__(551);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(508);
__webpack_require__(510);
__webpack_require__(509);
__webpack_require__(558);
__webpack_require__(557);
__webpack_require__(528);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(589);
__webpack_require__(594);
__webpack_require__(601);
__webpack_require__(592);
__webpack_require__(584);
__webpack_require__(585);
__webpack_require__(590);
__webpack_require__(595);
__webpack_require__(597);
__webpack_require__(580);
__webpack_require__(581);
__webpack_require__(582);
__webpack_require__(583);
__webpack_require__(586);
__webpack_require__(587);
__webpack_require__(588);
__webpack_require__(591);
__webpack_require__(593);
__webpack_require__(596);
__webpack_require__(598);
__webpack_require__(599);
__webpack_require__(600);
__webpack_require__(503);
__webpack_require__(505);
__webpack_require__(504);
__webpack_require__(507);
__webpack_require__(506);
__webpack_require__(492);
__webpack_require__(490);
__webpack_require__(496);
__webpack_require__(493);
__webpack_require__(499);
__webpack_require__(501);
__webpack_require__(489);
__webpack_require__(495);
__webpack_require__(486);
__webpack_require__(500);
__webpack_require__(484);
__webpack_require__(498);
__webpack_require__(497);
__webpack_require__(491);
__webpack_require__(494);
__webpack_require__(483);
__webpack_require__(485);
__webpack_require__(488);
__webpack_require__(487);
__webpack_require__(502);
__webpack_require__(184);
__webpack_require__(574);
__webpack_require__(579);
__webpack_require__(263);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(577);
__webpack_require__(578);
__webpack_require__(559);
__webpack_require__(262);
__webpack_require__(264);
__webpack_require__(265);
__webpack_require__(614);
__webpack_require__(603);
__webpack_require__(604);
__webpack_require__(609);
__webpack_require__(612);
__webpack_require__(613);
__webpack_require__(607);
__webpack_require__(610);
__webpack_require__(608);
__webpack_require__(611);
__webpack_require__(605);
__webpack_require__(606);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(562);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(567);
__webpack_require__(565);
__webpack_require__(566);
__webpack_require__(568);
__webpack_require__(569);
__webpack_require__(570);
__webpack_require__(571);
__webpack_require__(573);
__webpack_require__(572);
__webpack_require__(617);
__webpack_require__(615);
__webpack_require__(616);
__webpack_require__(658);
__webpack_require__(661);
__webpack_require__(660);
__webpack_require__(662);
__webpack_require__(663);
__webpack_require__(659);
__webpack_require__(664);
__webpack_require__(665);
__webpack_require__(639);
__webpack_require__(642);
__webpack_require__(638);
__webpack_require__(636);
__webpack_require__(637);
__webpack_require__(640);
__webpack_require__(641);
__webpack_require__(623);
__webpack_require__(657);
__webpack_require__(622);
__webpack_require__(656);
__webpack_require__(668);
__webpack_require__(670);
__webpack_require__(621);
__webpack_require__(655);
__webpack_require__(667);
__webpack_require__(669);
__webpack_require__(620);
__webpack_require__(666);
__webpack_require__(619);
__webpack_require__(624);
__webpack_require__(625);
__webpack_require__(626);
__webpack_require__(627);
__webpack_require__(628);
__webpack_require__(630);
__webpack_require__(629);
__webpack_require__(631);
__webpack_require__(632);
__webpack_require__(633);
__webpack_require__(635);
__webpack_require__(634);
__webpack_require__(644);
__webpack_require__(645);
__webpack_require__(646);
__webpack_require__(647);
__webpack_require__(649);
__webpack_require__(648);
__webpack_require__(651);
__webpack_require__(650);
__webpack_require__(652);
__webpack_require__(653);
__webpack_require__(654);
__webpack_require__(618);
__webpack_require__(643);
__webpack_require__(673);
__webpack_require__(672);
__webpack_require__(671);
module.exports = __webpack_require__(48);


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(303)))

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _assign = __webpack_require__(19);

var emptyObject = __webpack_require__(139);
var _invariant = __webpack_require__(7);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ },
/* 677 */
/***/ function(module, exports) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".ButtonGroup {\r\n\tdisplay: inline-block;\r\n\toverflow: visible;\r\n}\r\n\r\n.ButtonGroup button {\r\n\tdisplay: inline-block;\r\n\tborder-radius: 0px;\r\n\tmargin: 0px 2px;\r\n\tfont-family: Roboto;\r\n}\r\n\r\n.ButtonGroup button.Selected {\r\n\tcolor: #B02234;\r\n}\r\n\r\n.ButtonGroup button:first-child{\r\n\tborder-radius: 3px 0px 0px 3px;\r\n\tmargin-left: 0px;\r\n}\r\n\r\n.ButtonGroup button:last-child{\r\n\tborder-radius: 0px 3px 3px 0px;\r\n\tmargin-right: 0px;\r\n}", ""]);

// exports


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Button {\r\n\tdisplay: inline-block;\r\n\tborder: 0px;\r\n\tborder-radius: 3px;\r\n\toutline: 0;\r\n\tpadding: 5px 5px;\r\n\tcursor: pointer;\r\n\ttransition: box-shadow ease .2s;\r\n\tbackground-color: transparent;\r\n\tcolor: #444444;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 500;\r\n\tfont-size: 14px;\r\n\ttext-align: center;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.Button:not(:disabled):hover {\r\n\tbox-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.5);\r\n\t-moz-box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.5);\r\n\t-webkit-box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.Button:not(:disabled):active {\r\n\tbox-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.75);\r\n\t-moz-box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.75);\r\n\t-webkit-box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.Button > i {\r\n\tcolor: #444;\r\n\tdisplay: inline-block;\r\n\tvertical-align: middle;\r\n\tline-height: 24px;\r\n\twidth: 24px;\r\n\theight: 24px;\r\n\tfont-size: 24px;\r\n}\r\n\r\n.Button > i > svg {\r\n\tfill: #444;\r\n\twidth: 24px;\r\n\theight: 24px;\r\n}\r\n\r\n.Button > span {\r\n\tvertical-align: middle;\r\n\tpadding: 0px 10px;\r\n\tline-height: 24px;\r\n\tfont-size: 13px;\r\n}\r\n\r\n.Button.Red > i {\r\n\tcolor: white;\r\n}\r\n\r\n.Button.Red > i > svg {\r\n\tfill: white;\r\n}\r\n\r\n.Button.Red {\r\n\tbackground-color: #b02234;\r\n\tcolor: white;\r\n}\r\n\r\n.Button.White {\r\n\tbackground-color: white;\r\n\tcolor: #b02234;\r\n}\r\n\r\n.Button.Turquoise {\r\n\tbackground-color: #0D9191;\r\n\tcolor: white;\r\n}\r\n\r\n.Button.Light {\r\n\tbackground-color: #DDD;\r\n\tcolor: #777;\r\n}\r\n\r\n.ButtonGroup .Button.Light {\r\n\tcolor: #AAA;\r\n}\r\n\r\n.Button.Light.Selected {\r\n\tcolor: #444;\r\n}\r\n\r\n.Button.Dark {\r\n\tbackground-color: #555;\r\n\tcolor: white;\r\n}\r\n\r\n.Button.WhiteText {\r\n\tcolor: white;\r\n}\r\n\r\n.Button.Inline {\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.Button:disabled {\r\n\tcursor: default;\r\n}\r\n\r\n.Button.Red:disabled, .Button.Dark:disabled, .Button.Turquoise:disabled {\r\n\tbackground-color: #9E9E9E;\r\n\tcolor: white;\r\n}\r\n\r\n.Button:not(.Red):not(.Dark):not(.Turquoise):disabled, .Button:not(.Red):not(.Dark):not(.Turquoise):disabled > i {\r\n\tcolor: #AAA;\r\n}\r\n\r\n.Button > img {\r\n\t/* position: absolute;\r\n\ttop: 5px;\r\n\tleft: 5px; */\r\n\tdisplay: inline-block;\r\n\tfloat: left;\r\n\t\r\n\twidth: 20px;\r\n\theight: 20px;\r\n}\r\n\r\n.Button > img:only-child {\r\n\t\r\n}\r\n\r\n.Button.Floating {\r\n\t\r\n\tpadding: 12px 12px;\r\n\t\r\n\tbox-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.5);\r\n\t-moz-box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.5);\r\n\t-webkit-box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.5);\r\n\t\r\n\tborder-radius: 50%;\r\n}\r\n\r\n.Button.Floating:hover {\r\n\tbox-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.75);\r\n\t-moz-box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.75);\r\n\t-webkit-box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.Button.Floating:active {\r\n\tbox-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.9);\r\n\t-moz-box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.9);\r\n\t-webkit-box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.9);\r\n}\r\n\r\n.Button.Floating:disabled {\r\n\tbox-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.2);\r\n\t-moz-box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.2);\r\n\t-webkit-box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.Button.Floating > img {\r\n\twidth: 25px;\r\n\theight: 25px;\r\n}", ""]);

// exports


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Card {\r\n\tbackground-color: white;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n}", ""]);

// exports


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Checkbox {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.Checkbox > div {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.Checkbox label {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.Checkbox label {\r\n\tmargin-left: 5px;\r\n}\r\n\r\n.Checkbox label:empty {\r\n\tdisplay: none;\r\n}\r\n\r\n.Checkbox i, .Checkbox svg {\r\n\topacity: 0.5;\r\n}\r\n\r\n.Checkbox.Checked i, .Checkbox.Checked svg {\r\n\topacity: 1;\r\n}", ""]);

// exports


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".ColorPicker button{\r\n\twidth: 26px;\r\n\theight: 26px;\r\n\tmargin: 2px;\r\n}\r\n\r\n.ColorPicker.ColorInput {\r\n\tposition: relative;\r\n\twidth: 26px;\r\n\theight: 26px;\r\n\tmargin-bottom: 10px;\r\n\tborder: 1px solid #AAA;\r\n\tmargin-top: 5px;\r\n}", ""]);

// exports


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".DateTimePicker:not(.Input):not(.Picker):not(.Picker *) {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n\tpadding: 10px;\r\n}\r\n\r\n.Picker.DateTimePicker {\r\n\tpadding: 5px;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.Input.DateTimePicker {\r\n\tmargin: 0px 0px 0px 5px;\r\n\tmin-width: 150px;\r\n\ttext-align: center;\r\n\tbackground-color: transparent;\r\n\tborder: 0;\r\n\tborder-bottom: 1px solid #BEBEBE;\r\n\tpadding: 3px;\r\n}\r\n\r\n.Picker.DateTimePicker input[type=number]::-webkit-inner-spin-button{\r\n\t-webkit-appearance: inner-spin-button;\r\n}\r\n\r\n.Picker.DateTimePicker input[type=number]::-webkit-outer-spin-button {\r\n\t-webkit-appearance: outer-spin-button;\r\n\tmargin: 0;\r\n}\r\n\r\n.Picker.DateTimePicker select{\r\n\tbackground-color: #CECECE;\r\n\tborder: 0;\r\n\tmargin-left: 5px;\r\n\tpadding: 3px;\r\n}\r\n\r\n.Picker.DateTimePicker table{\r\n\tpadding: 5px;\r\n}\r\n\r\n.Picker.DateTimePicker table button{\r\n\tmargin: 2px;\r\n\tpadding: 5px;\r\n\tmin-width: 27px;\r\n\tmin-height: 27px;\r\n}\r\n\r\n.Picker.DateTimePicker table button:disabled{\r\n\tbackground-color: transparent;\r\n\tcolor: #AAAAAA;\r\n}\r\n\r\n.Picker.DateTimePicker table button.Selected{\r\n\tbackground-color: #B02234;\r\n\tcolor: white;\r\n}\r\n\r\n.Picker.DateTimePicker table button.Today{\r\n\tcolor: #B02234; \r\n}\r\n\r\n.Picker.DateTimePicker td{\r\n\twidth: 15px;\r\n\theight: 25px;\r\n\ttext-align: center;\r\n}\r\n\r\n.Picker.DateTimePicker header{\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-item-align: center;\r\n\t    align-self: center;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n}\r\n\r\n.Picker.DateTimePicker header button{\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n}\r\n\r\n.Picker.DateTimePicker label{\r\n\t-ms-flex-item-align: center;\r\n\t    -ms-grid-row-align: center;\r\n\t    align-self: center;\r\n\tdisplay: inline-block;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.Picker.DateTimePicker header label{\r\n\tmargin-left: 5px;\r\n\tmargin-right: 5px;\r\n\ttext-align: center;\r\n}\r\n\r\n.Picker.DateTimePicker label.Month{\r\n\twidth: 80px;\r\n}\r\n\r\n.Picker.DateTimePicker footer{\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n}\r\n\r\n.Picker.DateTimePicker footer > div{\r\n\t-ms-flex-item-align: center;\r\n\t    -ms-grid-row-align: center;\r\n\t    align-self: center;\r\n}\r\n\r\n.Picker.DateTimePicker footer input[type=number]{\r\n\twidth: 48px;\r\n}\r\n\r\n.Picker.DateTimePicker footer input{\r\n\tbackground-color: transparent;\r\n\tborder: 0;\r\n\tborder-bottom: 1px solid #BEBEBE;\r\n\ttext-align: right;\r\n\tmargin-left: 5px;\r\n\tpadding: 3px;\r\n}\r\n\r\n.Picker.DateTimePicker footer button{\r\n\tbackground-color: #B02234;\r\n\tcolor: white;\r\n\tpadding-left: 10px;\r\n\tpadding-right: 10px;\r\n\tmargin: 10px;\r\n}", ""]);

// exports


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Details{\r\n\tposition: relative;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\twidth: 100%;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex: 1 0 auto;\r\n\t    flex: 1 0 auto;\r\n}\r\n\r\n.Details > header{\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tposition: relative;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: row;\r\n\t    flex-direction: row;\r\n\tbackground-color: #b02234;\r\n\tcolor: white;\r\n\tbox-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.75);\r\n    -moz-box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.75);\r\n    -webkit-box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.75);\r\n\tz-index: 2;\r\n}\r\n\r\n.Details > header > h1{\r\n\tline-height: 34px;\r\n    min-width: 80px;\r\n\tmargin: 0px 10px;\r\n    color: white;\r\n    font-family: Roboto;\r\n    font-weight: 500;\r\n    font-size: 18px;\r\n}\r\n\r\n.Details > header .Tabs{\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n}\r\n\r\n.Details > header .ButtonContainer > button > i{\r\n\tcolor: white;\r\n\t\r\n}\r\n\r\n.Details > div.Content{\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\tz-index: 1;\r\n}", ""]);

// exports


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Popup.DialogOverlay {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.Popup.DialogOverlay.Shown {\r\n\tbackground-color: rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.Dialog {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t\r\n\tbackground-color: white;\r\n\tbox-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.5);\r\n\t\r\n\ttransition: all .2s;\r\n\ttransform: translateY(10%);\r\n\topacity: 0;\r\n}\r\n\r\n.Popup.DialogOverlay.Shown .Dialog {\r\n\ttransform: translateY(0);\r\n\topacity: 1;\r\n}\r\n\r\n.Dialog > header {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\r\n\tpadding: 20px 20px 0px 20px;\r\n}\r\n\r\n.Dialog > header > h1 {\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 26px;\r\n\tcolor: #777;\r\n}\r\n\r\n.Dialog > div {\r\n\t-ms-flex: 1 1 auto;\r\n\t    flex: 1 1 auto;\r\n\tpadding: 20px;\r\n}\r\n\r\n.Dialog > footer {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tborder-top: 1px solid #DDD;\r\n\tbackground-color: #F8F8F8;\r\n\tpadding: 10px 20px;\r\n\toverflow: auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-pack: end;\r\n\t    justify-content: flex-end;\r\n}\r\n\r\n.Dialog > footer:empty {\r\n\tdisplay: none;\r\n}\r\n\r\n.Dialog > footer > button {\r\n\tmargin-left: 10px;\r\n}\r\n", ""]);

// exports


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Picker.DropdownMenu {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\tbackground-color: white;\r\n\tbox-shadow: 0px 2px 25px 0px rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.DropdownMenu .Item {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-user-select: none;\r\n\t   -moz-user-select: none;\r\n\t    -ms-user-select: none;\r\n\t        user-select: none;\r\n\tpadding: 15px;\r\n\tcolor: #444;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tfont-family: Roboto;\r\n\tfont-size: 13px;\r\n}\r\n\r\n.DropdownMenu .Item > label {\r\n\tcolor: #444;\r\n}\r\n\r\n.DropdownMenu .Item.Disabled {\r\n\topacity: 0.5;\r\n\tcursor: default;\r\n}\r\n\r\n.DropdownMenu .Item:not(.Disabled):not(.Separator),\r\n.DropdownMenu .Item:not(.Disabled):not(.Separator) > * {\r\n\tcursor: pointer;\r\n}\r\n\r\n.DropdownMenu .Item:not(.Disabled):not(.Separator):hover {\r\n\tbackground-color: #EEE;\r\n}\r\n\r\n.DropdownMenu .Separator {\r\n\theight: 1px;\r\n\twidth: 100%;\r\n\tmargin-top: 5px;\r\n\tmargin-bottom: 5px;\r\n\tbackground-color: #EEE;\r\n}", ""]);

// exports


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Form {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n}\r\n\r\n.Form > label {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: block;\r\n\tcolor: #AAA;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 16px;\r\n}\r\n\r\n.Form > .Input, .Form > .InputWithUnit, .Form > .Select, .Form > .TextArea {\r\n\twidth: 100%;\r\n\tmargin: 5px 0px 10px 0px;\r\n}", ""]);

// exports


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "i {\r\n\twidth: 24px !important;\r\n\theight: 24px !important;\r\n\tfont-size: 24px !important;\r\n}", ""]);

// exports


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".InputWithUnit {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.InputWithUnit > div {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\theight: 26px;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.InputWithUnit input {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\ttext-align: right;\r\n\tmargin: 0px;\r\n}\r\n\r\n.InputWithUnit label {\r\n\tpadding: 5px;\r\n\theight: 26px;\r\n\t\r\n\tcolor: #AAA;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.InputWithUnit.Shadowed {\r\n\tbackground-color: white;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n\t-moz-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n\t-webkit-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.InputWithUnit.Shadowed .Input {\r\n\tborder-bottom: 0;\r\n}", ""]);

// exports


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Input {\r\n\ttransition: .3s opacity;\r\n\t-moz-transition: .3s opacity;\r\n\t-webkit-transition: .3s opacity;\r\n\t-ms-transition: .3s opacity;\r\n\tposition: relative;\r\n\tborder: 0px;\r\n\toutline: 0;\r\n\tpadding: 5px 5px;\r\n\tborder-bottom: 1px solid #DDD;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 14px;\r\n\tcolor: #444;\r\n}\r\n\r\n.Input:disabled {\r\n\tbackground-color: transparent;\r\n\tcolor: graytext;\r\n}\r\n\r\n.Input:invalid {\r\n\tborder-bottom: 1px solid #FF4444;\r\n}\r\n\r\n.Input[type=number]::-webkit-inner-spin-button,\r\n.Input[type=number]::-webkit-outer-spin-button {\r\n\t-webkit-appearance: none;\r\n\tmargin: 0;\r\n}\r\n\r\n.Input.Shadowed {\r\n\tbackground-color: white;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n\t-moz-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n\t-webkit-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n\tborder-bottom: 0;\r\n}", ""]);

// exports


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".IntervalEditor {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.IntervalEditor > div {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: stretch;\r\n\t    align-items: stretch;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\t-ms-flex-pack: justify;\r\n\t    justify-content: space-between;\r\n}\r\n\r\n.IntervalEditor > div > #hyphen {\r\n\tline-height: 41px;\r\n\ttext-align: center;\r\n\twidth: 50px;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.IntervalEditor > div > *:not(#hyphen) {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.IntervalEditor > div > .Input {\r\n\tpadding: 5px;\r\n\tmargin: 5px;\r\n\ttext-align: center;\r\n}", ""]);

// exports


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".List {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tpadding: 15px;\r\n\toverflow-y: auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n}\r\n\r\n.List > * {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n}", ""]);

// exports


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".LoginDialog {\r\n\twidth: 300px;\r\n}\r\n\r\n.LoginDialog header {\r\n\tbackground-color: #B02234;\r\n}\r\n\r\n.LoginDialog > header > h1 {\r\n\tcolor: white;\r\n}\r\n\r\n.LoginDialog > div {\r\n\tposition: relative;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n\tmin-height: 170px;\r\n}\r\n\r\n.LoginDialog > div > div:not(.ProgressBar) {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\twidth: 100%;\r\n}\r\n\r\n.LoginDialog #errorMsg {\r\n\tcolor: white;\r\n\tbackground-color: rgba(255, 0, 0, 0.5);\r\n\tfont-weight: bold;\r\n\tpadding: 10px;\r\n\tmargin-bottom: 5px;\r\n}\r\n\r\n.LoginDialog #errorMsg:empty {\r\n\tdisplay: none;\r\n}\r\n\r\n.LoginDialog .Input {\r\n\twidth: 80%;\r\n\tmargin: 5px 0px;\r\n}\r\n\r\n.LoginDialog.InProgress > div > div:not(.ProgressBar) {\r\n\tdisplay: none;\r\n}", ""]);

// exports


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\r\n * React Select\r\n * ============\r\n * Created by Jed Watson and Joss Mackison for KeystoneJS, http://www.keystonejs.com/\r\n * https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs\r\n * MIT License: https://github.com/keystonejs/react-select\r\n*/\r\n\r\n.MultiSelect {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n\tmin-width: 200px;\r\n}\r\n\r\n.MultiSelect.Shadowed {\r\n\tbackground-color: white;\r\n}\r\n\r\n.MultiSelect.Shadowed .Select {\r\n\tborder-bottom: 0;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.MultiSelect .Select {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.MultiSelect .Select,\r\n.MultiSelect .Select div,\r\n.MultiSelect .Select input,\r\n.MultiSelect .Select span {\r\n  box-sizing: border-box;\r\n}\r\n.Select.is-disabled > .Select-control {\r\n}\r\n.Select.is-disabled > .Select-control:hover {\r\n  box-shadow: none;\r\n}\r\n.Select.is-disabled .Select-arrow-zone {\r\n  cursor: default;\r\n  pointer-events: none;\r\n}\r\n.Select-control {\r\n  color: #333;\r\n  cursor: default;\r\n  display: table;\r\n  height: 36px;\r\n  outline: none;\r\n  overflow: hidden;\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n.Select-control:hover {\r\n  /* box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06); */\r\n}\r\n.is-searchable.is-open > .Select-control {\r\n  cursor: text;\r\n}\r\n.is-open > .Select-control {\r\n  /* border-bottom-right-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n  background: #fff;\r\n  border-color: #b3b3b3 #ccc #d9d9d9; */\r\n}\r\n.is-open > .Select-control > .Select-arrow {\r\n  /* border-color: transparent transparent #999;\r\n  border-width: 0 5px 5px; */\r\n}\r\n.is-searchable.is-focused:not(.is-open) > .Select-control {\r\n  cursor: text;\r\n}\r\n.is-focused:not(.is-open) > .Select-control {\r\n  /* border-color: #007eff;\r\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1); */\r\n}\r\n.Select-placeholder,\r\n:not(.Select--multi) > .Select-control .Select-value {\r\n  bottom: 0;\r\n  color: #aaa;\r\n  left: 0;\r\n  line-height: 36px;\r\n  padding-left: 5px;\r\n  padding-right: 5px;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n  max-width: 100%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-family: Roboto;\r\n  font-weight: 300;\r\n}\r\n.has-value:not(.Select--multi) > .Select-control > .Select-value .Select-value-label,\r\n.has-value.is-pseudo-focused:not(.Select--multi) > .Select-control > .Select-value .Select-value-label {\r\n  color: #333;\r\n}\r\n.has-value:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label,\r\n.has-value.is-pseudo-focused:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label {\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n}\r\n.has-value:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label:hover,\r\n.has-value.is-pseudo-focused:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label:hover,\r\n.has-value:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label:focus,\r\n.has-value.is-pseudo-focused:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label:focus {\r\n  color: #007eff;\r\n  outline: none;\r\n  text-decoration: underline;\r\n}\r\n.Select-input {\r\n  height: 34px;\r\n  padding-left: 5px;\r\n  padding-right: 5px;\r\n  vertical-align: middle;\r\n}\r\n.Select-input > input {\r\n  background: none transparent;\r\n  border: 0 none;\r\n  box-shadow: none;\r\n  cursor: default;\r\n  display: inline-block;\r\n  font-family: inherit;\r\n  font-size: inherit;\r\n  height: 34px;\r\n  margin: 0;\r\n  outline: none;\r\n  padding: 0;\r\n  -webkit-appearance: none;\r\n}\r\n.is-focused .Select-input > input {\r\n  cursor: text;\r\n}\r\n.has-value.is-pseudo-focused .Select-input {\r\n  opacity: 0;\r\n}\r\n.Select-control:not(.is-searchable) > .Select-input {\r\n  outline: none;\r\n}\r\n.Select-loading-zone {\r\n  cursor: pointer;\r\n  display: table-cell;\r\n  position: relative;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  width: 16px;\r\n}\r\n.Select-loading {\r\n  animation: Select-animation-spin 400ms infinite linear;\r\n  width: 16px;\r\n  height: 16px;\r\n  box-sizing: border-box;\r\n  /* border-radius: 50%;\r\n  border: 2px solid #ccc;\r\n  border-right-color: #333; */\r\n  display: inline-block;\r\n  position: relative;\r\n  vertical-align: middle;\r\n}\r\n.Select-clear-zone {\r\n  animation: Select-animation-fadeIn 200ms;\r\n  color: #999;\r\n  cursor: pointer;\r\n  display: table-cell;\r\n  position: relative;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  width: 17px;\r\n}\r\n.Select-clear-zone:hover {\r\n  /* color: #D0021B; */\r\n}\r\n.Select-clear {\r\n  display: inline-block;\r\n  font-size: 18px;\r\n  line-height: 1;\r\n}\r\n.Select--multi .Select-clear-zone {\r\n  width: 17px;\r\n}\r\n.Select-arrow-zone {\r\n  cursor: pointer;\r\n  display: table-cell;\r\n  position: relative;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  width: 25px;\r\n  padding-right: 5px;\r\n}\r\n.Select-arrow {\r\n  border-color: #999 transparent transparent;\r\n  border-style: solid;\r\n  border-width: 5px 5px 2.5px;\r\n  display: inline-block;\r\n  height: 0;\r\n  width: 0;\r\n}\r\n.is-open .Select-arrow,\r\n.Select-arrow-zone:hover > .Select-arrow {\r\n  border-top-color: #666;\r\n}\r\n@keyframes Select-animation-fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n.Select-menu-outer {\r\n  background-color: #fff;\r\n  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.5);\r\n  box-sizing: border-box;\r\n  margin-top: -1px;\r\n  max-height: 200px;\r\n  position: absolute;\r\n  top: 100%;\r\n  width: 100%;\r\n  z-index: 1;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n.Select-menu {\r\n  max-height: 198px;\r\n  overflow-y: auto;\r\n}\r\n.Select-option {\r\n  box-sizing: border-box;\r\n  background-color: #fff;\r\n  color: #666666;\r\n  cursor: pointer;\r\n  display: block;\r\n  padding: 8px 10px;\r\n}\r\n.Select-option:last-child {\r\n  /* border-bottom-right-radius: 4px;\r\n  border-bottom-left-radius: 4px; */\r\n}\r\n.Select-option.is-focused {\r\n  background-color: #EEE;\r\n  color: #333;\r\n}\r\n.Select-option.is-disabled {\r\n  color: #cccccc;\r\n  cursor: default;\r\n}\r\n.Select-noresults {\r\n  box-sizing: border-box;\r\n  color: #999999;\r\n  cursor: default;\r\n  display: block;\r\n  padding: 8px 10px;\r\n}\r\n.Select--multi .Select-input {\r\n  vertical-align: middle;\r\n  margin-left: 5px;\r\n  padding: 0;\r\n}\r\n.Select--multi.has-value .Select-input {\r\n  margin-left: 5px;\r\n}\r\n.Select--multi .Select-value {\r\n  background-color: #EEE;\r\n  /* border-radius: 2px; */\r\n  display: inline-block;\r\n  font-size: 0.9em;\r\n  line-height: 1.8;\r\n  margin-left: 5px;\r\n  margin-top: 5px;\r\n  vertical-align: top;\r\n}\r\n.Select--multi .Select-value-icon,\r\n.Select--multi .Select-value-label {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n.Select--multi .Select-value-label {\r\n  /* border-bottom-right-radius: 2px;\r\n  border-top-right-radius: 2px; */\r\n  cursor: default;\r\n  padding: 2px 5px;\r\n}\r\n.Select--multi a.Select-value-label {\r\n  color: #007eff;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n}\r\n.Select--multi a.Select-value-label:hover {\r\n  text-decoration: underline;\r\n}\r\n.Select--multi .Select-value-icon {\r\n  cursor: pointer;\r\n  /* border-bottom-left-radius: 2px; */\r\n  /* border-top-left-radius: 2px; */\r\n  border-right: 1px solid #DDD;\r\n  padding: 1px 5px 3px;\r\n}\r\n.Select--multi .Select-value-icon:hover,\r\n.Select--multi .Select-value-icon:focus {\r\n  background-color: rgba(0, 113, 230, 0.08);\r\n  color: #0071e6;\r\n}\r\n.Select--multi .Select-value-icon:active {\r\n  background-color: rgba(0, 126, 255, 0.24);\r\n}\r\n.Select--multi.is-disabled .Select-value {\r\n  background-color: #fcfcfc;\r\n  border: 1px solid #e3e3e3;\r\n  color: #333;\r\n}\r\n.Select--multi.is-disabled .Select-value-icon {\r\n  cursor: not-allowed;\r\n  border-right: 1px solid #e3e3e3;\r\n}\r\n.Select--multi.is-disabled .Select-value-icon:hover,\r\n.Select--multi.is-disabled .Select-value-icon:focus,\r\n.Select--multi.is-disabled .Select-value-icon:active {\r\n  background-color: #fcfcfc;\r\n}\r\n@keyframes Select-animation-spin {\r\n  to {\r\n    transform: rotate(1turn);\r\n  }\r\n}\r\n", ""]);

// exports


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".MultiSelector {\r\n}\r\n\r\n.MultiSelector > label {\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.MultiSelector > .Container {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: row;\r\n\t    flex-direction: row;\r\n\t-ms-flex-align: start;\r\n\t    align-items: flex-start;\r\n}\r\n\r\n.MultiSelector .All {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tmargin-right: 5px;\r\n}\r\n\r\n.MultiSelector .All .Checkbox {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tmargin-right: 5px;\r\n}\r\n\r\n.MultiSelector .All label {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tcolor: #444;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 13px;\r\n}\r\n\r\n.MultiSelector .MultiSelect {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n}\r\n\r\n.MultiSelector.Vertical > .Container {\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-align: stretch;\r\n\t    align-items: stretch;\r\n}", ""]);

// exports


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Pager {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n}\r\n\r\n.Pager > div {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n}", ""]);

// exports


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Picker {\r\n\tposition: fixed;\r\n\t/* background-color: #EAEAEA; */\r\n\tbackground-color: #F8F8F8;\r\n\toverflow: visible;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n}", ""]);

// exports


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Pin {\r\n\tposition: relative;\r\n}\r\n\r\n.Pin i {\r\n\ttransform: translate(-1px, 1px) rotateZ(45deg);\r\n}", ""]);

// exports


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Popup {\r\n\tposition: absolute;\r\n\tz-index: 99;\r\n\tvisibility: hidden;\r\n\ttransition: all .2s;\r\n\topacity: 0;\r\n\tvisibility: hidden;\r\n}\r\n\r\n.Popup.Shown {\r\n\topacity: 1;\r\n\tvisibility: visible;\r\n}\r\n\r\n.Popup.Overlay {\r\n\tposition: fixed;\r\n\ttop: 0px;\r\n\tbottom: 0px;\r\n\tleft: 0px;\r\n\tright: 0px;\r\n}", ""]);

// exports


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".ProgressBar {\r\n\tposition: relative;\r\n\ttext-align: center;\r\n\tpadding: 5px;\r\n\twidth: 100%;\r\n}\r\n\r\n.ProgressBar label {\r\n\tdisplay: block;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 16px;\r\n\tmargin-bottom: 10px;\r\n\tcolor: #444;\r\n}\r\n\r\n.ProgressBar label:empty {\r\n\tdisplay: none;\r\n}\r\n\r\n.ProgressBar > div {\r\n\tmin-width: 60px;\r\n}\r\n\r\n.ProgressBar.Indeterminate > div > div {\r\n\tdisplay: inline-block;\r\n}\r\n\r\n/* .ProgressBar.Indeterminate > div > div {\r\n\tdisplay: inline-block;\r\n\twidth: 10px;\r\n\theight: 10px;\r\n\tborder-radius: 50%;\r\n\tbackground-color: gray;\r\n\tmargin: 0px 5px;\r\n}\r\n\r\n.ProgressBar.Indeterminate > div > div:nth-child(1) {\r\n\tanimation: progressBarDot 0.5s infinite;\r\n\tanimation-direction: alternate;\r\n\t-webkit-animation: progressBarDot 0.5s infinite;\r\n\t-webkit-animation-direction: alternate;\r\n\t-moz-animation: progressBarDot 0.5s infinite;\r\n\t-moz-animation-direction: alternate;\r\n}\r\n\r\n.ProgressBar.Indeterminate > div > div:nth-child(2) {\r\n\tanimation: progressBarDot 0.5s infinite;\r\n\tanimation-direction: alternate;\r\n\t-webkit-animation: progressBarDot 0.5s infinite;\r\n\t-webkit-animation-direction: alternate;\r\n\t-webkit-animation-delay: .1666s;\r\n\t-moz-animation: progressBarDot 0.5s infinite;\r\n\t-moz-animation-direction: alternate;\r\n\t-moz-animation-delay: .1666s;\r\n}\r\n\r\n.ProgressBar.Indeterminate > div > div:nth-child(3) {\r\n\tanimation: progressBarDot 0.5s infinite;\r\n\tanimation-direction: alternate;\r\n\t-webkit-animation: progressBarDot 0.5s infinite;\r\n\t-webkit-animation-direction: alternate;\r\n\t-webkit-animation-delay: .3333s;\r\n\t-moz-animation: progressBarDot 0.5s infinite;\r\n\t-moz-animation-direction: alternate;\r\n\t-moz-animation-delay: .3333s;\r\n} */\r\n\r\n@keyframes progressBarDot {\r\n\t0% {opacity: 0;}\r\n\t100% {opcaity: 1;}\r\n}\r\n\r\n.ProgressBar.Determinate{\r\n}\r\n\r\n.ProgressBar.Determinate > div:first-child {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tmargin: 10px auto;\r\n\t-ms-flex-align: end;\r\n\t    align-items: flex-end;\r\n}\r\n\r\n.ProgressBar.Determinate > div:first-child > label {\r\n\tfont-family: 'Roboto', Roboto, sans-serif;\r\n\tfont-size: 12px;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\ttext-align: left;\r\n\tfont-size: 14px;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tfont-weight: 400;\r\n}\r\n\r\n.ProgressBar.Determinate > div:first-child > span{\r\n\tfont-family: 'Roboto', Roboto, sans-serif;\r\n\tfont-size: 8px;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tfont-weight: 400;\r\n\tcolor: #444;\r\n}\r\n\r\n.ProgressBar.Determinate > div:nth-child(2) > div {\r\n\twidth: 0%;\r\n\theight: 5px;\r\n\r\n\tbackground-color: red;\r\n\tanimation: greenBackground 2s infinite;\r\n\ttransition: width 0.2s;\r\n}", ""]);

// exports


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Select {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n\tborder: 0px;\r\n\toutline: 0;\r\n\tborder-bottom: 1px solid #DDD;\r\n\theight: 28px;\r\n\t\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 14px;\r\n\tcolor: #444;\r\n}\r\n\r\n.Select option {\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 14px;\r\n\tcolor: #444;\r\n}\r\n\r\n.Select:invalid {\r\n\tborder-bottom: 1px solid #FF4444;\r\n}\r\n\r\n.Select:disabled {\r\n\tcolor: graytext;\r\n}\r\n\r\n.Select option:disabled {\r\n\tcolor: graytext;\r\n}\r\n\r\n.Select::-webkit-inner-spin-button,\r\n.Select::-webkit-outer-spin-button {\r\n\t/* -webkit-appearance: none;\r\n\tmargin: 0; */\r\n}\r\n\r\n.Select.Shadowed {\r\n\tbackground-color: white;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n\tborder-bottom: 0;\r\n}", ""]);

// exports


/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Spinner {\r\n  position: relative;\r\n  margin: 0px auto;\r\n  width: 30px;\r\n}\r\n.Spinner:before {\r\n  content: '';\r\n  display: block;\r\n  padding-top: 100%;\r\n}\r\n\r\n.circular {\r\n  animation: rotate 2s linear infinite;\r\n  height: 100%;\r\n  transform-origin: center center;\r\n  width: 100%;\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  margin: auto;\r\n}\r\n\r\n.path {\r\n  stroke-dasharray: 1,200;\r\n  stroke-dashoffset: 0;\r\n  stroke-width: 3px;\r\n  stroke: #B02234;\r\n  animation: dash 1.5s ease-in-out infinite;\r\n  stroke-linecap: round;\r\n}\r\n\r\n@keyframes rotate {\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n@keyframes dash {\r\n  0% {\r\n    stroke-dasharray: 1,200;\r\n    stroke-dashoffset: 0;\r\n  }\r\n  50% {\r\n    stroke-dasharray: 89,200;\r\n    stroke-dashoffset: -35px;\r\n  }\r\n  100% {\r\n    stroke-dasharray: 89,200;\r\n    stroke-dashoffset: -124px;\r\n  }\r\n}\r\n@keyframes color {\r\n  100%, 0% {\r\n    stroke: #d62d20;\r\n  }\r\n  40% {\r\n    stroke: #0057e7;\r\n  }\r\n  66% {\r\n    stroke: #008744;\r\n  }\r\n  80%, 90% {\r\n    stroke: #ffa700;\r\n  }\r\n}", ""]);

// exports


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "ul.Tabs {\r\n\theight: 100%;\r\n\tdisplay: block;\r\n\tposition: relative;\r\n\toverflow: auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n}\r\n\r\nul.Tabs li {\r\n\tflex: 0 1 auto;\r\n\t-webkit-flex: 0 1 auto;\r\n\t-ms-flex: 0 1 auto;\r\n\tposition: relative;\r\n\tfloat: left;\r\n\tpadding: 7px 14px;\r\n\tline-height: 20px;\r\n\tfont-size: 14px;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 500;\r\n\tcursor: pointer;\r\n\t/* transition: background-color ease .2s; */\r\n\tcolor: rgba(44, 44, 44, 0.5);\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\t-webkit-align-items: center;\r\n}\r\n\r\nul.Tabs.Light li {\r\n\tcolor: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\nul.Tabs li > span {\r\n\tflex: 1 1 0;\r\n\t-webkit-flex: 1 1 0;\r\n\t-ms-flex: 1 1 0;\r\n}\r\n\r\nul.Tabs li:hover:not(.Selected) {\r\n\tcolor: rgba(44, 44, 44, 0.75);\r\n}\r\n\r\nul.Tabs.Light li:hover:not(.Selected) {\r\n\tcolor: rgba(255, 255, 255, 0.75);\r\n}\r\n\r\nul.Tabs li.Selected {\r\n\tcursor: default;\r\n\tcolor: #444;\r\n}\r\n\r\nul.Tabs.Light li.Selected {\r\n\tcolor: white;\r\n}\r\n\r\nul.Tabs li > img {\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\topacity: 0.5;\r\n}\r\n\r\nul.Tabs li:hover:not(.Selected) > img {\r\n\topacity: 0.75;\r\n}\r\n\r\nul.Tabs li.Selected > img {\r\n\topacity: 1;\r\n}\r\n\r\nul.Tabs li > i {\r\n\tdisplay: block;\r\n\tcolor: #444;\r\n\topacity: 0.5;\r\n}\r\n\r\nul.Tabs.Light li > i {\r\n\tcolor: white;\r\n}\r\n\r\nul.Tabs li:hover:not(.Selected) > i {\r\n\topacity: 0.75;\r\n}\r\n\r\nul.Tabs li.Selected > i {\r\n\topacity: 1;\r\n}", ""]);

// exports


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".TextFilter {\r\n\tdisplay: inline-block;\r\n\tbackground-color: white;\r\n\toverflow: visible;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n\t-moz-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n\t-webkit-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.TextFilter > div {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: stretch;\r\n\t    align-items: stretch;\r\n\toverflow: visible;\r\n}\r\n\r\n.TextFilter > div > .Input {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tmargin: 0;\r\n\tbackground-color: transparent;\r\n\tborder: 0;\r\n\tpadding-left: 15px;\r\n}\r\n\r\n.TextFilter > div > .Button {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n}", ""]);

// exports


/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Toast {\r\n\tposition: fixed;\r\n\tright: 50px;\r\n\tbottom: -10%;\r\n\tbackground-color: #333;\r\n\tcolor: white;\r\n\tpadding: 20px;\r\n\tfont-size: 20px;\r\n\tz-index: 1000;\r\n\tmax-width: 70%;\r\n\t\r\n\topacity: 0;\r\n\t\r\n\tanimation: fade 5s;\r\n\t\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n}\r\n\r\n.Toast.Green {\r\n\tbackground-color: #0D9191;\r\n}\r\n\r\n.Toast.Orange {\r\n\tbackground-color: #F27915;\r\n}\r\n.Toast.Red {\r\n\tbackground-color: #ac2925;\r\n}\r\n\r\n@keyframes fade {\r\n\t0% {\r\n\t\topacity: 0;\r\n\t\tbottom: -10%;\r\n\t}\r\n    5% {\r\n\t\topacity: 1;\r\n\t\tbottom: 50px;\r\n\t}\r\n\t95% {\r\n\t\topacity: 1;\r\n\t\tbottom: 50px;\r\n\t}\r\n\t100% {\r\n\t\topacity: 0;\r\n\t\tbottom: -10%;\r\n\t}\r\n}\r\n\r\n@media (max-width: 640px) {\r\n    .Toast {\r\n        margin: 0 auto;\r\n        position: fixed;\r\n        left: auto;\r\n        font-size: 11px;\r\n\r\n    }\r\n}", ""]);

// exports


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "* {\r\n\tbox-sizing: border-box;\r\n\tmargin: 0px;\r\n\tpadding: 0px;\r\n\tfont-weight: normal;\r\n}\r\n\r\nhtml, body {\r\n\tpadding: 0px;\r\n\tmargin: 0px;\r\n\tfont-family: Arial;\r\n\tfont-size: 13px;\r\n\tcolor: #444;\r\n\tbackground-color: #FEFEFE;\r\n\t-moz-user-select: none;\r\n\t-webkit-user-select: none;\r\n\t-ms-user-select: none;\r\n\tcursor: default;\r\n}\r\n\r\nh1, h2 {\r\n\tcolor: #666;\r\n}\r\n\r\nimg {\r\n\tuser-drag: none;\r\n\t-moz-user-select: none;\r\n\t-webkit-user-drag: none;\r\n}\r\n\r\n.Hidden{\r\n\tdisplay: none !important;\r\n}\r\n\r\n.Invisible{\r\n\tvisibility: hidden !important;\r\n}\r\n\r\nbutton::-moz-focus-inner, input::-moz-focus-inner { \r\n\tborder: 0 !important;\r\n\tpadding: 0 !important;\r\n}", ""]);

// exports


/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".CreatePOIDialog > div {\r\n\tposition: relative;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n}\r\n\r\n.CreatePOIDialog > div > * {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n}\r\n\r\n.CreatePOIDialog.InProgress > div > *:not(#progressBarContainer) {\r\n\tvisibility: hidden;\r\n}\r\n\r\n.CreatePOIDialog #progressBarContainer {\r\n\tdisplay: none;\r\n}\r\n\r\n.CreatePOIDialog.InProgress #progressBarContainer {\r\n\tdisplay: block;\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.CreatePOIDialog .Form #shapeSelector {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-pack: justify;\r\n\t    justify-content: space-between;\r\n\tmargin-top: 10px;\r\n}\r\n\r\n.CreatePOIDialog .Form #shapeSelector > div {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\t-moz-box-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\t-webkit-box-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\tcursor: pointer;\r\n\ttransition: box-shadow .2s ease;\r\n}\r\n\r\n.CreatePOIDialog .Form #shapeSelector > div:hover {\r\n\tbox-shadow: 0px 1px 10px 0px rgba(119, 119, 119, 0.75);\r\n\t-moz-box-shadow: 0px 1px 10px 0px rgba(119, 119, 119, 0.75);\r\n\t-webkit-box-shadow: 0px 1px 10px 0px rgba(119, 119, 119, 0.75);\r\n}\r\n\r\n.CreatePOIDialog .Form #shapeSelector > div:nth-child(1) {\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.CreatePOIDialog .Form #shapeSelector > div:nth-child(2) {\r\n\tmargin-left: 10px;\r\n}\r\n\r\n.CreatePOIDialog .Form #shapeSelector > div > i {\r\n\tdisplay: block;\r\n\twidth: 150px !important;\r\n\theight: 150px !important;\r\n\tfilter: grayscale(100%);\r\n}\r\n\r\n.CreatePOIDialog .Form #shapeSelector > div.Selected > i {\r\n\tfilter: grayscale(0%);\r\n}\r\n\r\n.CreatePOIDialog .Form #shapeSelector > div > label {\r\n\tdisplay: block;\r\n\tfont-family: Roboto;\r\n\ttext-align: center;\r\n\tfont-weight: 300;\r\n\tfont-size: 15px;\r\n\tcolor: #444;\r\n\tpadding-bottom: 10px;\r\n}\r\n\r\n.CreatePOIDialog .Form #shapeSelector > div.Selected > label {\r\n\tfont-weight: 500;\r\n}\r\n\r\n.CreatePOIDialog input.Invalid{\r\n\tborder-bottom: 1px solid #FF4444;\r\n}\r\n\r\n.CreatePOIDialog input.Untouched:invalid{\r\n\tborder-bottom: 1px solid #DDD;\r\n}\r\n", ""]);

// exports


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".CriticalValueNotificationConfigForm {\r\n\twidth: 600px;\r\n}\r\n\r\n.CriticalValueNotificationConfigForm > div:not(:last-child) {\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.CriticalValueNotificationConfigForm .CheckboxContainer label {\r\n\tmargin-right: 15px;\r\n}\r\n\r\n.CriticalValueNotificationConfigForm label.Title {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: block;\r\n\tcolor: #AAA;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 16px;\r\n}\r\n\r\n.CriticalValueNotificationConfigForm .ConditionContainer div {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-line-pack: justify;\r\n\t    align-content: space-between;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center; \r\n\t-ms-flex: 0 0 auto; \r\n\t    flex: 0 0 auto;\r\n}\r\n\r\n.CriticalValueNotificationConfigForm .ConditionContainer label.Inactive {\r\n\tcolor: #AAA;\r\n}\r\n\r\n.CriticalValueNotificationConfigForm .ConditionContainer > div:first-of-type {\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.CriticalValueNotificationConfigForm .ConditionContainer > div:first-of-type .Select {\r\n\t-ms-flex: 1 0 auto;\r\n\t    flex: 1 0 auto;\r\n\tmargin-right: 15px;\r\n}\r\n\r\n.CriticalValueNotificationConfigForm .ConditionContainer #relationSelect {\r\n\tmin-width: 50px;\r\n}\r\n\r\n.CriticalValueNotificationConfigForm .ConditionContainer #debounceTimeInput {\r\n\t-ms-flex: 1 0 auto;\r\n\t    flex: 1 0 auto;\r\n\tmargin-right: 5px;\r\n\tmargin-left: 5px;\r\n\ttext-align: right;\r\n\twidth: 0;\r\n}\r\n\r\n.CriticalValueNotificationConfigForm .ConditionContainer #timeUnitSelect {\r\n\twidth: 100px;\r\n}\r\n\r\n.CriticalValueNotificationConfigForm .Checkbox {\r\n\tmargin-right: 5px;\r\n}\r\n\r\n.CriticalValueNotificationConfigForm .ConditionContainer .OperandInputContainer input[type=number] {\r\n\twidth: 65px;\r\n\ttext-align: right;\r\n}", ""]);

// exports


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".CriticalValueNotifications {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tbackground-color: #F8F8F8;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\toverflow: hidden;\r\n}\r\n\r\n.CriticalValueNotifications .Button.Floating {\r\n\tposition: absolute;\r\n\ttop: 10px;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, 0px);\r\n\ttransition: all 0.2s ease;\r\n\tz-index: 1;\r\n}\r\n\r\n.CriticalValueNotifications .Button.Floating.Hidden {\r\n\tdisplay: block !important;\r\n\ttransform: translate(-50%, -100px);\r\n}\r\n\r\n.CriticalValueNotifications .Content {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\toverflow: auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tpadding: 75px 0px 20px 0px;\r\n}\r\n\r\n.CriticalValueNotifications .ProgressBar {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, -50%);\r\n}", ""]);

// exports


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".NotificationConfigCard {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tbackground-color: white;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\t-moz-box-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\t-webkit-box-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\tmargin-bottom: 15px;\r\n\tpadding: 10px;\r\n}\r\n\r\n.NotificationConfigCard > header {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: row-reverse;\r\n\t    flex-direction: row-reverse;\r\n}", ""]);

// exports


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Dashboard {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\t\r\n\tbackground-color: white;\r\n\t\r\n\tdisplay: -ms-flexbox;\r\n\t\r\n\tdisplay: flex;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.Dashboard .ProgressBar {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\twidth: 30%;\r\n}\r\n\r\n.Dashboard #content {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\t\r\n\tdisplay: -ms-flexbox;\r\n\t\r\n\tdisplay: flex;\r\n}\r\n\r\n.Dashboard #leftContainer {\r\n\twidth: 400px;\r\n\tposition: relative;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\toverflow: hidden;\r\n\ttransition: 0.5s;\r\n\tbackground-color: #F8F8F8;\r\n\tz-index: 1;\r\n\tbox-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);\r\n\t-moz-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);\r\n\t-webkit-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);\r\n\r\n}\r\n\r\n.Dashboard #leftContainer > header {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\theight: 50px;\r\n\tbackground-color: #b02234;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-pack: justify;\r\n\t    justify-content: space-between;\r\n\t-webkit-justify-content: space-between;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\t-webkit-align-items: center;\r\n\tpadding: 0px 5px;\r\n\tposition: relative;\r\n\tz-index: 3;\r\n\r\n\tbox-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\t-moz-box-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\t-webkit-box-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n}\r\n\r\n.Dashboard #leftContainer > header > div:first-child {\r\n\t/* flex: 0 0 auto; */\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\t-ms-flex-pack: justify;\r\n\t    justify-content: space-between;\r\n}\r\n\r\n.Dashboard #leftContainer > header > div:first-child .Button {\r\n\t/* margin-left: 10px; */\r\n}\r\n\r\n.Dashboard #leftContainer > header #logo {\r\n\twidth: 30px !important;\r\n\theight: 30px !important;\r\n}\r\n\r\n.Dashboard #leftContainer > header .Tabs {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n}\r\n\r\n.Dashboard #leftContainer .ListContainer {\r\n\t\r\n}\r\n\r\n/*left container close button*/\r\n.Dashboard #toggleLeftContainerBtn {\r\n\tcolor: white;\r\n\tcursor: pointer;\r\n}\r\n\r\n.Dashboard #toggleLeftContainerBtn2 {\r\n\tposition: fixed;\r\n\tleft: 0px;\r\n\ttop: 50%;\r\n\tcolor: black;\r\n\tcursor: pointer;\r\n\tz-index: 1;\r\n}", ""]);

// exports


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Dashboard > #content > div.RightContainer {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tposition: relative;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\toverflow: hidden;\r\n\tz-index: 0;\r\n}\r\n\r\n.Dashboard > #content > div.RightContainer #mapContainer {\r\n\tposition: absolute;\r\n\twidth: 100%;\r\n\ttransition: height .2s ease;\r\n}\r\n\r\n.Dashboard > #content > div.RightContainer #mapContainer > div {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\ttransition: none;\r\n\ttransition: opacity 1s;\r\n}\r\n\r\n.Dashboard > #content > div.RightContainer #mapContainer > div.Cat {\r\n\topacity: 0.5;\r\n\ttransition-delay: 5s;\r\n}\r\n\r\n.Dashboard > #content > div.RightContainer #mapContainer iframe {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\toutline: 0;\r\n\tborder: 0;\r\n}\r\n\r\n.Dashboard > #content > div.RightContainer #detailsContainer {\r\n\tposition: absolute;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tmin-height: 34px;\r\n\ttransition: height .2s ease;\r\n}\r\n\r\n.Dashboard > #content > div.RightContainer #settingsContainer {\r\n\tposition: absolute;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n}", ""]);

// exports


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Bubble{\r\n\toverflow-y: auto;\r\n\toverflow-x: auto;\r\n\tuser-select: none;\r\n\t-moz-user-select: none;\r\n\t-webkit-user-select: none;\r\n\t-ms-user-select: none;\r\n\topacity: 1;\r\n\tpadding: 0px 10px;\r\n}\r\n\r\n.Bubble .Body{\r\n\tposition: relative;\r\n\toverflow-y: auto;\r\n\toverflow-x: hidden;\r\n\tbox-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\t-moz-box-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\t-webkit-box-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\tborder-radius: 3px;\r\n\tbackground: white;\r\n\tdisplay: table;\r\n\tmargin-top: 5px;\r\n\tmargin-left: auto;\r\n\tmargin-right: auto;\r\n\tz-index: 1;\r\n}\r\n\r\n.Bubble .TriangleContainer{\r\n\theight: 10px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.Bubble .TriangleContainer > div:first-child {\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\tposition: absolute;\r\n\tleft: 50%;\r\n\tbackground-color: transparent;\r\n\ttransform: translate(-50%, -50%) scale(0.5, 1) rotate(45deg);\r\n\t-webkit-transform: translate(-50%, -50%) scale(0.5, 1) rotate(45deg);\r\n\tbox-shadow: 0px 0px 7px 0px rgba(119, 119, 119, 0.75);\r\n\t-moz-box-shadow: 0px 0px 7px 0px rgba(119, 119, 119, 0.75);\r\n\t-webkit-box-shadow: 0px 0px 7px 0px rgba(119, 119, 119, 0.75);\r\n\tz-index: 0;\r\n}\r\n\r\n.Bubble .TriangleContainer > div:nth-child(2) {\r\n\tposition: absolute;\r\n\tleft: 50%;\r\n\twidth: 0;\r\n\theight: 0;\r\n\tborder-style: solid;\r\n\tborder-width: 15px 7.5px 0 7.5px;\r\n\tborder-color: #ffffff transparent transparent transparent;\r\n\ttransform: translateX(-50%);\r\n\t-webkit-transform: translateX(-50%);\r\n\tz-index: 2;\r\n}\r\n\r\n/* .Bubble .TriangleContainer > div > div {\r\n\twidth: 0;\r\n\theight: 0;\r\n\tborder-style: solid;\r\n\tfloat: left;\r\n}\r\n\r\n.Bubble .TriangleContainer > div > div:first-child {\r\n\tborder-width: 0 5px 10px 0;\r\n\tborder-color: transparent #ffffff transparent transparent;\r\n}\r\n\r\n.Bubble .TriangleContainer > div > div:nth-child(2) {\r\n\tborder-width: 10px 5px 0 0;\r\n\tborder-color: #ffffff transparent transparent transparent;\r\n} */\r\n", ""]);

// exports


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "ul.Map.ContextMenu {\r\n\tposition: relative;\r\n\tpadding: 5px 0px;\r\n}\r\n\r\nul.Map.ContextMenu > li {\r\n\tposition: relative;\r\n\tpadding: 5px 15px;\r\n\tcursor: pointer;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 15px;\r\n\tcolor: #444;\r\n}\r\n\r\nul.Map.ContextMenu > li:hover {\r\n\tbackground-color: #EEE;\r\n}", ""]);

// exports


/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".MapButton{\r\n\tbackground-color: white;\r\n\tmargin: 10px;\r\n\tborder-radius: 2px;\r\n\tpadding: 4px;\r\n\ttext-align: center;\r\n\tcursor: pointer;\r\n\tbox-shadow: 0px 1px 1x 0px rgba(0, 0, 0, 0.25);\r\n\t-moz-box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.25);\r\n\t-webkit-box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.MapButton.Inactive{\r\n\t/* opacity: 0.5 */\r\n}\r\n\r\n.MapButton.Inactive > i {\r\n\topacity: 0.5;\r\n}\r\n\r\n.MapButton > i {\r\n\twidth: 18px;\r\n\theight: 18px;\r\n\tcursor: pointer;\r\n}", ""]);

// exports


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".Tooltip{\r\n\tbackground-color: white;\r\n\tmin-width: 70px;\r\n\tpadding: 5px;\r\n\ttext-align: center;\r\n\t\r\n\tbox-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\t-moz-box-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\t-webkit-box-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\t\r\n\topacity: 0;\r\n\ttransition: opacity 0.2s ease;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: row;\r\n\t    flex-direction: row;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n}\r\n\r\n.Tooltip i:not(:last-child) {\r\n\tmargin-right: 5px;\r\n}\r\n\r\n.Tooltip.Shown {\r\n\topacity: 1;\r\n}", ""]);

// exports


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehicleBubble{\r\n\r\n}\r\n\r\n.VehicleBubble .Body > div label {\r\n\tdisplay: block;\r\n\tposition: relative;\r\n\tpadding: 5px 10px;\r\n\tfont-size: 16px;\r\n\tfont-weight: bold;\r\n\tcursor: pointer;\r\n\twhite-space: nowrap;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden;\r\n}\r\n\r\n.VehicleBubble .Body {\r\n\tmax-width: 180px;\r\n\ttransition: background-color 1s ease;\r\n}\r\n\r\n.VehicleBubble .TriangleContainer > div:nth-child(2) {\r\n\ttransition: border-color 1s ease;\r\n}", ""]);

// exports


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".CollaboratorCard {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tbackground-color: white;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\t-moz-box-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\t-webkit-box-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\tmargin-bottom: 15px;\r\n\tpadding: 10px;\r\n\twidth: 400px;\r\n}\r\n\r\n/* .CollaboratorCard > header {\r\n\tdisplay: -webkit-flex;\r\n\tdisplay: flex;\r\n}\r\n\r\n.CollaboratorCard > header > div:nth-child(1) {\r\n\tflex: 1 1 0;\r\n}\r\n\r\n.CollaboratorCard > header > div:nth-child(2) {\r\n\tflex: 0 0 auto;\r\n}\r\n\r\n.CollaboratorCard > header > div:nth-child(2) > button {\r\n\tflex: 0 0 auto;\r\n} */\r\n\r\n.CollaboratorCard  h1 {\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 30px;\r\n\tcolor: #444;\r\n}\r\n\r\n.CollaboratorCard h2 {\r\n\tfont-family: Roboto;\r\n\tfont-size: 12px;\r\n\tcolor: #888;\r\n}\r\n\r\n.CollaboratorCard select {\r\n\twidth: 100%;\r\n}\r\n\r\n\r\n\r\n.CollaboratorCard > header {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tmargin-bottom: 5px;\r\n}\r\n\r\n.CollaboratorCard > header #nameContainer {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: end;\r\n\t    align-items: flex-end;\r\n\tmargin-right: 5px;\r\n}\r\n\r\n.CollaboratorCard > header h1, .CollaboratorCard > header h2 {\r\n\twhite-space: nowrap;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n}\r\n\r\n.CollaboratorCard > header h1 {\r\n\tfont-size: 30px;\r\n\tmax-width: 294px;\r\n}\r\n\r\n.CollaboratorCard > header h2 {\r\n\tfont-size: 20px;\r\n\tmargin-left: 10px;\r\n\tmin-width: 52px;\r\n\tmargin-bottom: 3px;\r\n}\r\n\r\n.CollaboratorCard > header h2:empty {\r\n\tdisplay: none;\r\n}", ""]);

// exports


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".POICollaborators {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tbackground-color: #F8F8F8;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\toverflow: hidden;\r\n}\r\n\r\n.POICollaborators .Button.Floating {\r\n\tposition: absolute;\r\n\ttop: 10px;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, 0px);\r\n\ttransition: all 0.2s ease;\r\n\tz-index: 1;\r\n}\r\n\r\n.POICollaborators .Button.Floating.Hidden {\r\n\tdisplay: block !important;\r\n\ttransform: translate(-50%, -100px);\r\n}\r\n\r\n.POICollaborators .Content {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\toverflow: auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tpadding: 75px 0px 20px 0px;\r\n}\r\n\r\n.POICollaborators .ProgressBar {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, -50%);\r\n}", ""]);

// exports


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".ShareDialog {\r\n\twidth: 350px;\r\n}", ""]);

// exports


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".NotificationConfigCard {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tbackground-color: white;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\t-moz-box-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\t-webkit-box-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\tmargin-bottom: 15px;\r\n\tpadding: 10px;\r\n}\r\n\r\n.NotificationConfigCard > header {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: row-reverse;\r\n\t    flex-direction: row-reverse;\r\n}", ""]);

// exports


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".POICrossingNotificationConfigForm {\r\n\twidth: 600px;\r\n}\r\n\r\n.POICrossingNotificationConfigForm > div:not(:last-child) {\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.POICrossingNotificationConfigForm .CheckboxContainer label {\r\n\tmargin-right: 15px;\r\n}\r\n\r\n.POICrossingNotificationConfigForm label.Title {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: block;\r\n\tcolor: #AAA;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 16px;\r\n}\r\n\r\n.POICrossingNotificationConfigForm .Checkbox {\r\n\tmargin-right: 5px;\r\n}", ""]);

// exports


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".POICrossingNotifications {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tbackground-color: #F8F8F8;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\toverflow: hidden;\r\n}\r\n\r\n.POICrossingNotifications .Button.Floating {\r\n\tposition: absolute;\r\n\ttop: 10px;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, 0px);\r\n\ttransition: all 0.2s ease;\r\n\tz-index: 1;\r\n}\r\n\r\n.POICrossingNotifications .Button.Floating.Hidden {\r\n\tdisplay: block !important;\r\n\ttransform: translate(-50%, -100px);\r\n}\r\n\r\n.POICrossingNotifications .Content {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\toverflow: auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tpadding: 75px 0px 20px 0px;\r\n}\r\n\r\n.POICrossingNotifications .ProgressBar {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, -50%);\r\n}", ""]);

// exports


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".POIList .Filter {\r\n\tposition: relative;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\toverflow: hidden;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t\r\n\tbox-shadow: 0px 1px 10px 1px rgba(48, 48, 84, 0.5);\r\n\t-moz-box-shadow: 0px 1px 10px 1px rgba(48, 48, 48, 0.5);\r\n\t-webkit-box-shadow: 0px 1px 10px 1px rgba(48, 48, 48, 0.5);\r\n\tz-index: 2;\r\n\tbackground-color: #EEE;\r\n}\r\n\r\n.POIList .Filter > div {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n}\r\n\r\n.POIList .Filter > div:first-child {\r\n\tpadding: 10px 10px 5px 10px;\r\n}\r\n\r\n.POIList .Filter > div:nth-child(2) {\r\n\tpadding: 5px 10px;\r\n}\r\n\r\n.POIList .Filter .TextFilter {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n}\r\n\r\n.POIList .Filter .Pin {\r\n\toverflow: 0 0 auto;\r\n\tmargin-left: 10px;\r\n}\r\n\r\n.POIList .Filter footer {\r\n\ttext-align: center;\r\n\tpadding: 3px 0px;\r\n\tcursor: pointer;\r\n}", ""]);

// exports


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".POIList {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\toverflow: hidden;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n}\r\n\r\n.POIList #body {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\toverflow: hidden;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\tposition: relative;\r\n\tbackground-color: #F8F8F8;\r\n}\r\n\r\n.POIList .ListContainer {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\toverflow: hidden;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\tbackground-color: #F8F8F8;\r\n}\r\n\r\n.POIList .ListContainer > header {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\toverflow: hidden;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tbackground-color: #EAEAEA;\r\n\tpadding: 5px 10px;\r\n\tbox-shadow: 0px 1px 10px 1px rgba(48, 48, 48, 0.5);\r\n\t-moz-box-shadow: 0px 1px 10px 1px rgba(48, 48, 48, 0.5);\r\n\t-webkit-box-shadow: 0px 1px 10px 1px rgba(48, 48, 48, 0.5);\r\n\tz-index: 1;\r\n}\r\n\r\n.POIList #body .Button.Floating {\r\n\tposition: absolute;\r\n\tbottom: 10px;\r\n\tright: 10px;\r\n}", ""]);

// exports


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".POIList .Summary {\r\n\tposition: relative;\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.POIList .Summary > header {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\tpadding: 10px;\r\n}\r\n\r\n.POIList .Summary > header > div:first-child {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.POIList .Summary > header #nameContainer {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: end;\r\n\t    align-items: flex-end;\r\n\toverflow: hidden;\r\n}\r\n\r\n.POIList .Summary > header h1, .POIList .Summary > header h2 {\r\n\twhite-space: nowrap;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n}\r\n\r\n.POIList .Summary > header h1 {\r\n\tfont-size: 30px;\r\n\tmax-width: 100%;\r\n}\r\n\r\n.POIList .Summary > header h1:hover {\r\n\tcursor: pointer;\r\n}\r\n\r\n.POIList .Summary > header > div:nth-child(2) {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: start;\r\n\t    align-items: flex-start;\r\n\t-ms-flex-pack: end;\r\n\t    justify-content: flex-end;\r\n\tmargin-top: 5px;\r\n\tfont-size: 11px;\r\n\tcolor: #888;\r\n}\r\n\r\n.POIList .Summary > header > div:nth-child(2):empty {\r\n\tdisplay: none;\r\n}\r\n\r\n.POIList .Summary > header > div:nth-child(2) > label {\r\n\ttext-align: right;\r\n\tfont-style: italic;\r\n\tcursor: pointer;\r\n}\r\n\r\n.POIList .Summary > header > div:nth-child(2) > label:hover {\r\n\ttext-decoration: underline;\r\n}\r\n\r\n.POIList .Summary footer {\r\n\ttext-align: center;\r\n\tpadding: 3px 0px;\r\n\tcursor: pointer;\r\n}", ""]);

// exports


/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".POIProperties  {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction:\tcolumn;\r\n\t    flex-direction:\tcolumn;\r\n\tbackground-color: #F8F8F8;\r\n}\r\n\r\n.POIProperties > header {\r\n\tbackground-color: transparent;\r\n\ttransition: box-shadow .2s, background-color .2s;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tpadding-left: 20px;\r\n\tz-index: 1;\r\n\theight: 50px;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.POIProperties > header .Button {\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.POIProperties header.Shadowed {\r\n\tbox-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\t-moz-box-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\t-webkit-box-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\tbackground-color: #EEE;\r\n}\r\n\r\n.POIProperties div.Content {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\toverflow: auto;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n\t-ms-flex-align: start;\r\n\t    align-items: flex-start;\r\n\tpadding: 20px;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n\t.POIProperties div.Content {\r\n\t\t-ms-flex-direction: column;\r\n\t\t    flex-direction: column;\r\n\t\t-ms-flex-pack: start;\r\n\t\t    justify-content: flex-start;\r\n\t\t-ms-flex-align: center;\r\n\t\t    align-items: center;\r\n\t}\r\n}\r\n\r\n.POIProperties div.Content .Card {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\twidth: 320px;\r\n\tmargin: 0px 20px 20px 0px;\r\n\tpadding: 20px;\r\n\toverflow: visible;\r\n}\r\n\r\n.POIProperties .ProgressBar {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, -50%);\r\n}", ""]);

// exports


/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".UserContacts  {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction:\tcolumn;\r\n\t    flex-direction:\tcolumn;\r\n\tbackground-color: #F8F8F8;\r\n}\r\n\r\n.UserContacts > header {\r\n\tbackground-color: transparent;\r\n\ttransition: box-shadow .2s, background-color .2s;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tpadding-left: 20px;\r\n\tz-index: 1;\r\n\theight: 50px;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.UserContacts header.Shadowed {\r\n\tbox-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\tbackground-color: #EEE;\r\n}\r\n\r\n.UserContacts .Content {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\toverflow: hidden;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\tpadding: 20px;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.UserContacts .ProgressBar {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, -50%);\r\n}\r\n\r\n.UserContacts .Content > .Card {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tbackground-color: white;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\t-moz-box-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\t-webkit-box-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\tmargin-bottom: 15px;\r\n\tpadding: 10px;\r\n\twidth: 400px;\r\n}", ""]);

// exports


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".UserNotifications  {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction:\tcolumn;\r\n\t    flex-direction:\tcolumn;\r\n\tbackground-color: #F8F8F8;\r\n}\r\n\r\n.UserNotifications > header {\r\n\tbackground-color: transparent;\r\n\ttransition: box-shadow .2s, background-color .2s;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tpadding-left: 20px;\r\n\tz-index: 1;\r\n\theight: 50px;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.UserNotifications header.Shadowed {\r\n\tbox-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\tbackground-color: #EEE;\r\n}\r\n\r\n.UserNotifications .Content {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\toverflow: hidden;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.UserNotifications .ProgressBar {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, -50%);\r\n}\r\n\r\n.UserNotifications .Pager {\r\n\twidth: 100%;\r\n}", ""]);

// exports


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".UserPassword  {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction:\tcolumn;\r\n\t    flex-direction:\tcolumn;\r\n\tbackground-color: #F8F8F8;\r\n}\r\n\r\n.UserPassword > header {\r\n\tbackground-color: transparent;\r\n\ttransition: box-shadow .2s, background-color .2s;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tpadding-left: 20px;\r\n\tz-index: 1;\r\n\theight: 50px;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.UserPassword header.Shadowed {\r\n\tbox-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\tbackground-color: #EEE;\r\n}\r\n\r\n.UserPassword .Content {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\toverflow: hidden;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\tpadding: 20px;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.UserPassword .ProgressBar {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, -50%);\r\n}\r\n\r\n.UserPassword .Content > .Card {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tbackground-color: white;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\t-moz-box-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\t-webkit-box-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\tmargin-bottom: 15px;\r\n\tpadding: 10px;\r\n\twidth: 400px;\r\n}\r\n\r\n.UserPassword .Content .Form #errorMessage{\r\n\tcolor: white;\r\n\tbackground-color: rgba(255, 0, 0, 0.5);\r\n\tfont-weight: bold;\r\n\tpadding: 10px;\r\n\tmargin-bottom: 5px;\r\n\tmargin-bottom: 15px;\r\n\ttext-align: center;\r\n}", ""]);

// exports


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehicleActivityChart{\r\n\twidth: 100%;\r\n\tmargin-bottom: 20px;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n}\r\n\r\n.VehicleActivityChart .highcharts-credits{\r\n\tdisplay: none;\r\n}\r\n\r\n/* Tooltip container */\r\n.VehicleActivityChart .highcharts-container .tooltip {\r\n    position: relative;\r\n    display: inline-block;\r\n}\r\n\r\n/* Tooltip text */\r\n.VehicleActivityChart .highcharts-container .tooltiptext {\r\n    visibility: hidden;\r\n\tdisplay: none;\r\n    width: 120px;\r\n    background-color: #555;\r\n    color: #fff;\r\n    text-align: center;\r\n    padding: 5px 0;\r\n    border-radius: 6px;\r\n\r\n    /* Position the tooltip text */\r\n    position: absolute;\r\n    z-index: 1;\r\n    bottom: 125%;\r\n    left: 50%;\r\n    margin-left: -60px;\r\n\r\n    /* Fade in tooltip */\r\n    opacity: 0;\r\n    transition: opacity 0.5s;\r\n}\r\n\r\n/* Tooltip arrow */\r\n.VehicleActivityChart .highcharts-container .tooltip .tooltiptext::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 50%;\r\n    margin-left: -5px;\r\n    border-width: 5px;\r\n    border-style: solid;\r\n    border-color: #555 transparent transparent transparent;\r\n}\r\n\r\n/* Show the tooltip text when you mouse over the tooltip container */\r\n.VehicleActivityChart .highcharts-container .tooltip:hover .tooltiptext {\r\n    visibility: visible;\r\n\tdisplay: block;\r\n    opacity: 1;\r\n}", ""]);

// exports


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehicleActivityTimeline .SectionCard {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t\r\n\tfont-family: Roboto;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard header {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tpadding: 10px 10px 0px 10px;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard header .SectionNumber {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tpadding: 5px;\r\n\twidth: 50px;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard header .SectionNumber > label {\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 18px;\r\n\tcursor: pointer;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard header .TimeAndAddress {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard header .TimeAndAddress > div {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard header .TimeAndAddress > div > div:nth-child(1) {\r\n\tpadding: 5px;\r\n\tcolor: #888;\r\n\twidth: 170px;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard header .TimeAndAddress > div > div:nth-child(2) {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tpadding: 5px;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: row;\r\n\t    flex-direction: row;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard header .TimeAndAddress > div > div:nth-child(2) > label.Address {\r\n\tcursor: pointer;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard header .TimeAndAddress > div > div:nth-child(2) > label:hover.Address {\r\n\ttext-decoration: underline;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard header .TimeAndAddress .EnRoute {\r\n\tpadding: 2px;\r\n\tborder-radius: 2px;\r\n\tcolor: white;\r\n\tfont-size: 10px;\r\n\tmargin-right: 3px;\r\n\tbackground-color: #999;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard header .DistanceAndTimeDiff {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tpadding: 5px;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard header .DistanceAndTimeDiff > label {\r\n\tfont-size: 18px;\r\n\tfont-weight: 300;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard header .Pin {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tpadding: 5px;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard table {\r\n\tpadding: 0px 10px;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard table tr.Fixed {\r\n\tcolor: #B02234;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard table td {\r\n\tpadding: 3px;\r\n\tfont-size: 11px;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard table td:first-child {\r\n\ttext-align: right;\r\n\tcursor: pointer;\r\n\twidth: 167px;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard table td:first-child,\r\n.VehicleActivityTimeline .SectionCard table td:first-child > * {\r\n\tfont-weight: 500;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard table td:first-child:hover {\r\n\ttext-decoration: underline;\r\n}\r\n\r\n.VehicleActivityTimeline .SectionCard footer {\r\n\ttext-align: center;\r\n\tpadding: 3px 0px;\r\n\tcursor: pointer;\r\n}", ""]);

// exports


/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehicleActivityTimeline .Section {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n}\r\n\r\n.VehicleActivityTimeline .Section > div:nth-child(1) {\r\n\tposition: relative;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\twidth: 100px;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\t-ms-flex-pack: end;\r\n\t    justify-content: flex-end;\r\n\tpadding-right: 10px;\r\n\tmin-height: 15px;\r\n}\r\n\r\n.VehicleActivityTimeline .Section.First > div:nth-child(1) {\r\n\t-ms-flex-align: start;\r\n\t    align-items: flex-start;\r\n}\r\n\r\n.VehicleActivityTimeline .Section > div:nth-child(1) > label {\r\n\tcolor: #AAA;\r\n\tfont-size: 10px;\r\n\tfont-family: Roboto;\r\n}\r\n\r\n.VehicleActivityTimeline .Section > div:nth-child(2) {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tborder-left: 1px solid #DDD;\r\n\tpadding-left: 10px;\r\n}\r\n\r\n.VehicleActivityTimeline .Section > div:nth-child(2) .Dot {\r\n\twidth: 8px;\r\n\theight: 8px;\r\n\tborder-radius: 50%;\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 0px;\r\n\tbackground-color: #DDD;\r\n\ttransform: translate(-50%, -50%);\r\n}", ""]);

// exports


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehicleActivityTimeline{\r\n\twidth: 100%;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n}\r\n\r\n.VehicleActivityTimeline > div {\r\n\twidth: 100%;\r\n\tmax-width: 1000px;\r\n\toverflow-y: visible;\r\n}\r\n\r\n.VehicleActivityTimeline .SummaryContainer {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tpadding-bottom: 15px;\r\n}\r\n\r\n.VehicleActivityTimeline .SummaryContainer .LeftPadding {\r\n\tposition: relative;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\twidth: 100px;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\t-ms-flex-pack: end;\r\n\t    justify-content: flex-end;\r\n\tpadding-right: 30px;\r\n\tmin-height: 15px;\r\n\tfont-family: Roboto;\r\n\tfont-size: 40px;\r\n\tcolor: #DDD;\r\n}\r\n\r\n.VehicleActivityTimeline .SummaryContainer > div:nth-child(2) {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tpadding-left: 10px;\r\n}\r\n\r\n.VehicleActivityTimeline .SummaryContainer .SectionCard {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tborder-left: 1px solid #DDD;\r\n}", ""]);

// exports


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehicleActivity  {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction:\tcolumn;\r\n\t    flex-direction:\tcolumn;\r\n\tbackground-color: #F8F8F8;\r\n}\r\n\r\n.VehicleActivity > header {\r\n\tbackground-color: transparent;\r\n\ttransition: box-shadow .2s, background-color .2s;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tpadding-left: 20px;\r\n\tz-index: 1;\r\n\theight: 50px;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.VehicleActivity header.Shadowed {\r\n\tbox-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\tbackground-color: #EEE;\r\n}\r\n\r\n.VehicleActivity header .IntervalEditor {\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.VehicleActivity .Content {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\toverflow: hidden;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n}\r\n\r\n.VehicleActivity .Result {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\toverflow: auto;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tpadding: 20px;\r\n}\r\n\r\n.VehicleActivity .ProgressBar {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, -50%);\r\n}\r\n\r\n.VehicleActivity  h1.Message {\r\n\tcolor: #666;\r\n\tmargin: 20px;\r\n}", ""]);

// exports


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehicleHeatmap  {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction:\tcolumn;\r\n\t    flex-direction:\tcolumn;\r\n\tbackground-color: #F8F8F8;\r\n}\r\n\r\n.VehicleHeatmap > header {\r\n\tbackground-color: transparent;\r\n\ttransition: box-shadow .2s, background-color .2s;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tpadding-left: 20px;\r\n\tz-index: 1;\r\n\theight: 50px;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.VehicleHeatmap header.Shadowed {\r\n\tbox-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\t-moz-box-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\t-webkit-box-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\tbackground-color: #EEE;\r\n}\r\n\r\n.VehicleHeatmap header .IntervalEditor {\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.VehicleHeatmap div.Content {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\toverflow: auto;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n}\r\n\r\n.VehicleHeatmap div.Content > div {\r\n\t-ms-flex-item-align: start;\r\n\t    align-self: flex-start;\r\n}\r\n\r\n.VehicleHeatmap div.Content .CheckboxContainer {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tpadding: 20px;\r\n}\r\n\r\n.VehicleHeatmap div.Content .CheckboxContainer label {\r\n\tmargin-right: 5px;\r\n}\r\n\r\n.VehicleHeatmap div.Content .CheckboxContainer > div:first-child {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tmargin-right: 30px;\r\n}\r\n\r\n.VehicleHeatmap .ProgressBar {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, -50%);\r\n}\r\n\r\n.VehicleHeatmap  h1.Message {\r\n\tcolor: #666;\r\n\tpadding: 20px;\r\n}", ""]);

// exports


/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehicleList .Filter {\r\n\tposition: relative;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\toverflow: hidden;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t\r\n\tbox-shadow: 0px 1px 10px 1px rgba(48, 48, 84, 0.5);\r\n\t-moz-box-shadow: 0px 1px 10px 1px rgba(48, 48, 48, 0.5);\r\n\t-webkit-box-shadow: 0px 1px 10px 1px rgba(48, 48, 48, 0.5);\r\n\tz-index: 2;\r\n\tbackground-color: #EEE;\r\n}\r\n\r\n.VehicleList .Filter > div {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n}\r\n\r\n.VehicleList .Filter > div:first-child {\r\n\tpadding: 10px 10px 5px 10px;\r\n}\r\n\r\n.VehicleList .Filter > div:nth-child(2) {\r\n\tpadding: 5px 10px;\r\n}\r\n\r\n.VehicleList .Filter .TextFilter {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n}\r\n\r\n.VehicleList .Filter .Pin {\r\n\toverflow: 0 0 auto;\r\n\tmargin-left: 10px;\r\n}\r\n\r\n.VehicleList .Filter footer {\r\n\ttext-align: center;\r\n\tpadding: 3px 0px;\r\n\tcursor: pointer;\r\n}", ""]);

// exports


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehicleList .Summary {\r\n\tposition: relative;\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.VehicleList .Summary #ignitionMarker {\r\n\tposition: absolute;\r\n\ttop: 0px;\r\n\tleft: 0px;\r\n\t\r\n\twidth: 50px;\r\n\theight: 50px;\r\n\tborder-radius: 0 0 50px 0;\r\n\topacity: 0.5;\r\n\t\r\n\ttransition: background-color 1s ease;\r\n}\r\n\r\n.VehicleList .Summary #ignitionMarker.onIgnition {\r\n\tbackground-color: #FFB300;\r\n}\r\n\r\n.VehicleList .Summary #ignitionMarker.moving {\r\n\tbackground-color: #8BC34A;\r\n}\r\n\r\n.VehicleList .Summary > *:not(#ignitionMarker) {\r\n\tposition: relative;\r\n}\r\n\r\n.VehicleList .Summary > header {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\tpadding: 10px;\r\n}\r\n\r\n.VehicleList .Summary > header > div:first-child {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.VehicleList .Summary > header #nameContainer {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: end;\r\n\t    align-items: flex-end;\r\n}\r\n\r\n.VehicleList .Summary > header h1, .VehicleList .Summary > header h2 {\r\n\twhite-space: nowrap;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n}\r\n\r\n.VehicleList .Summary > header h1 {\r\n\tfont-size: 30px;\r\n\tmax-width: 200px;\r\n\tcursor: pointer;\r\n\r\n}\r\n\r\n.VehicleList .Summary > header h1:hover {\r\n\t\r\n}\r\n\r\n.VehicleList .Summary > header h2 {\r\n\tfont-size: 20px;\r\n\tmargin-left: 10px;\r\n\tmax-width: 100px;\r\n\tmargin-bottom: 3px;\r\n}\r\n\r\n.VehicleList .Summary > header h2:empty {\r\n\tdisplay: none;\r\n}\r\n\r\n.VehicleList .Summary > header > div:nth-child(2) {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: start;\r\n\t    align-items: flex-start;\r\n\t-ms-flex-pack: justify;\r\n\t    justify-content: space-between;\r\n\tmargin-top: 5px;\r\n\tfont-size: 11px;\r\n\tcolor: #888;\r\n}\r\n\r\n.VehicleList .Summary > header > div:nth-child(2):empty {\r\n\tdisplay: none;\r\n}\r\n\r\n.VehicleList .Summary > header > div:nth-child(2) > label:first-child {\r\n\tmin-width: 120px;\r\n}\r\n\r\n.VehicleList .Summary > header > div:nth-child(2) > label:nth-child(2) {\r\n\ttext-align: right;\r\n\tfont-style: italic;\r\n}\r\n\r\n.VehicleList .Summary > header > div:nth-child(2) > label:nth-child(2):hover {\r\n\ttext-decoration: underline;\r\n\tcursor: pointer;\r\n}\r\n\r\n.VehicleList .Summary footer {\r\n\ttext-align: center;\r\n\tpadding: 3px 0px;\r\n\tcursor: pointer;\r\n}", ""]);

// exports


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehicleList .Summary .Table {\r\n\twidth: 100%;\r\n\tmargin-top: 10px;\r\n\tfont-size: 11px;\r\n}\r\n\r\n.VehicleList .Summary .Table tr{\r\n\tline-height: 15px;\r\n}\r\n\r\n.VehicleList .Summary .Table td:nth-child(1){\r\n\ttext-align: right;\r\n\tfont-weight: bold;\r\n\twidth: 175px;\r\n}\r\n\r\n.VehicleList .Summary .Table td:nth-child(2){\r\n\ttext-align: left;\r\n\tpadding-left: 10px;\r\n}", ""]);

// exports


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehicleList {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\toverflow: hidden;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n}\r\n\r\n.VehicleList #body {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\toverflow: hidden;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\tposition: relative;\r\n\tbackground-color: #F8F8F8;\r\n}\r\n\r\n.VehicleList .ListContainer {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\toverflow: hidden;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\tbackground-color: #F8F8F8;\r\n\tz-index: 0;\r\n}\r\n\r\n.VehicleList .ListContainer > header {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\toverflow: hidden;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tbackground-color: #EAEAEA;\r\n\tpadding: 5px 10px;\r\n\tbox-shadow: 0px 1px 10px 1px rgba(48, 48, 48, 0.5);\r\n\t-moz-box-shadow: 0px 1px 10px 1px rgba(48, 48, 48, 0.5);\r\n\t-webkit-box-shadow: 0px 1px 10px 1px rgba(48, 48, 48, 0.5);\r\n\tz-index: 1;\r\n}", ""]);

// exports


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehiclePOICrossingsStays .StayCard {\r\n\twidth: 75%;\r\n\tmin-width: 800px;\r\n\tmax-width: 1000px;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard header {\r\n\tpadding-left: 10px;\r\n\tpadding-right: 10px;\r\n\tpadding-top: 10px;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard header h1 {\r\n\tfont-size: 18px;\r\n\tfont-weight: 300;\r\n\tfont-family: Roboto;\r\n\tcursor: pointer;\r\n\tpadding: 5px;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard header .Summary {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: row;\r\n\t    flex-direction: row;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard header .Summary .TimeAndAddress {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex: 1 1 auto;\r\n\t    flex: 1 1 auto;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard header .Summary .TimeAndAddress .Indicator {\r\n\tpadding: 2px;\r\n\tborder-radius: 2px;\r\n\tcolor: white;\r\n\tfont-size: 10px;\r\n\tmargin-right: 3px;\r\n\tbackground-color: #999;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard header .Summary .TimeAndAddress > div {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex: 1 1 auto;\r\n\t    flex: 1 1 auto;\r\n\t-ms-flex-direction: row;\r\n\t    flex-direction: row;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard header .Summary .TimeAndAddress > div > div {\r\n\tdisplay: block;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard header .Summary .TimeAndAddress > div > div:nth-child(1) {\r\n\tpadding: 5px;\r\n\tcolor: #888;\r\n\twidth: 170px;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard header .Summary .TimeAndAddress > div > div:nth-child(2) {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tpadding: 5px;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: row;\r\n\t    flex-direction: row;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard header .Summary .TimeAndAddress > div > div:nth-child(2) > label.Address {\r\n\tcursor: pointer;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard header .Summary .TimeAndAddress > div > div:nth-child(2) > label.Address:hover {\r\n\ttext-decoration: underline;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard header .DistanceAndTimeDiff {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard header .DistanceAndTimeDiff > label {\r\n\tfont-size: 18px;\r\n\tfont-weight: 300;\r\n\tfont-family: Roboto;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard header .DistanceAndTimeDiff .Button {\r\n\tmargin-left: 15px;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard table {\r\n\tpadding: 0px 10px;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard table tr.Fixed {\r\n\tcolor: #B02234;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard table td {\r\n\tpadding: 3px;\r\n\tfont-size: 11px;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard table td:first-child {\r\n\ttext-align: right;\r\n\tcursor: pointer;\r\n\twidth: 167px;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard table td:first-child,\r\n.VehiclePOICrossingsStays .StayCard table td:first-child > * {\r\n\tfont-weight: 500;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard table td:first-child:hover {\r\n\ttext-decoration: underline;\r\n}\r\n\r\n.VehiclePOICrossingsStays .StayCard footer {\r\n\ttext-align: center;\r\n\tpadding: 3px 0px;\r\n\tcursor: pointer;\r\n}", ""]);

// exports


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehiclePOICrossingsStays{\r\n\twidth: 100%;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n}\r\n\r\n.VehiclePOICrossingsStays .Card{\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.VehiclePOICrossingsStays .Card:nth-last-child(){\r\n\tmargin-bottom: 0px;\r\n}", ""]);

// exports


/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehiclePOICrossingsSummaries .SummaryCard {\r\n\twidth: 75%;\r\n\tmin-width: 800px;\r\n\tmax-width: 1000px;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .SummaryCard header {\r\n\tpadding-left: 10px;\r\n\tpadding-right: 10px;\r\n\tpadding-top: 10px;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: row;\r\n\t    flex-direction: row;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .SummaryCard header h1 {\r\n\tfont-size: 18px;\r\n\tfont-weight: 300;\r\n\tfont-family: Roboto;\r\n\tcursor: pointer;\r\n\tpadding: 5px;\r\n\t-ms-flex: 1 1 auto;\r\n\t    flex: 1 1 auto;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .SummaryCard header .RightContainer {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .SummaryCard header .RightContainer .EmphasizedData {\r\n\tmargin-right: 5px;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .SummaryCard header .RightContainer .EmphasizedData > label {\r\n\tfont-size: 18px;\r\n\tfont-weight: 300;\r\n\tfont-family: Roboto;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .SummaryCard table thead {\r\n\tfont-weight: 500;\r\n\ttext-transform: uppercase;\r\n\tcolor: #AAA;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .SummaryCard table {\r\n\tpadding: 0px 10px;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .SummaryCard table tr.Fixed {\r\n\tcolor: #B02234;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .SummaryCard table td {\r\n\tfont-family: Roboto;\r\n\tpadding: 3px;\r\n\tfont-size: 11px;\r\n\tmin-width: 75px;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .SummaryCard table td:first-child{\r\n\tfont-weight: 500;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .SummaryCard table td:not(:first-child){\r\n\ttext-align: center;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .SummaryCard table td:first-child {\r\n\ttext-align: right;\r\n\tcursor: pointer;\r\n\twidth: 167px;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .SummaryCard table td:first-child,\r\n.VehiclePOICrossingsSummaries .SummaryCard table td:first-child > * {\r\n\tfont-weight: 500;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .SummaryCard table td:first-child:hover {\r\n\ttext-decoration: underline;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .SummaryCard footer {\r\n\ttext-align: center;\r\n\tpadding: 3px 0px;\r\n\tcursor: pointer;\r\n}", ""]);

// exports


/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehiclePOICrossingsSummaries{\r\n\twidth: 100%;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .Card{\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.VehiclePOICrossingsSummaries .Card:nth-last-child(){\r\n\tmargin-bottom: 0px;\r\n}", ""]);

// exports


/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehiclePOICrossingsTimeline .CrossingCard {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: row;\r\n\t    flex-direction: row;\r\n\tfont-family: Roboto;\r\n\tpadding: 5px;\r\n}\r\n\r\n.VehiclePOICrossingsTimeline .CrossingCard .InfoContainer {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\t-ms-flex: 1 1 auto;\r\n\t    flex: 1 1 auto;\r\n\tpadding: 5px;\r\n}\r\n\r\n.VehiclePOICrossingsTimeline .CrossingCard .InfoContainer .DateContainer {\r\n\tpadding: 5px;\r\n\tcolor: #888;\r\n\twidth: 170px;\r\n}\r\n\r\n.VehiclePOICrossingsTimeline .CrossingCard .InfoContainer i,\r\n.VehiclePOICrossingsTimeline .CrossingCard .InfoContainer label {\r\n\tcursor: pointer;\r\n}\r\n\r\n.VehiclePOICrossingsTimeline .CrossingCard .InfoContainer .AddressContainer > label:hover {\r\n\tcursor: pointer;\r\n\ttext-decoration: underline;\r\n}\r\n\r\n.VehiclePOICrossingsTimeline .CrossingCard .InfoContainer .IconContainer {\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.VehiclePOICrossingsTimeline .CrossingCard .PinContainer {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n}", ""]);

// exports


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehiclePOICrossingsTimeline{\r\n\twidth: 100%;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n}\r\n\r\n\r\n.VehiclePOICrossingsTimeline div.CrossingCard{\r\n\tmin-width: 400px;\r\n}\r\n\r\n.VehiclePOICrossingsTimeline > div {\r\n\twidth: 100%;\r\n\tmax-width: 1000px;\r\n\toverflow-y: visible;\r\n}\r\n\r\n.VehiclePOICrossingsTimeline > div > div {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: row;\r\n\t    flex-direction: row;\r\n}\r\n\r\n.VehiclePOICrossingsTimeline .DateSeparator > div {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-pack: end;\r\n\t    justify-content: flex-end;\r\n\tpadding-right: 10px;\r\n}\r\n\r\n.VehiclePOICrossingsTimeline .DateSeparator label {\r\n\tcolor: #AAA;\r\n\tfont-size: 10px;\r\n\tfont-family: Roboto;\r\n}\r\n\r\n.VehiclePOICrossingsTimeline > div > div > div:nth-child(1) {\r\n\tposition: relative;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\twidth: 100px;\r\n}\r\n\r\n.VehiclePOICrossingsTimeline > div > div > div:nth-child(2) {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tborder-left: 1px solid #DDD;\r\n\tpadding-left: 10px;\r\n\tpadding-top: 7px;\r\n\tpadding-bottom: 7px;\r\n}\r\n\r\n.VehiclePOICrossingsTimeline div.Dot {\r\n\twidth: 8px;\r\n\theight: 8px;\r\n\tborder-radius: 50%;\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 0px;\r\n\tbackground-color: #DDD;\r\n\ttransform: translate(-50%, -50%);\r\n}", ""]);

// exports


/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".POISelectorPicker {\r\n\tpadding: 10px;\r\n}\r\n\r\n.POISelectorPicker .MultiSelector {\r\n\twidth: 400px;\r\n}\r\n\r\n.POISelectorPicker .MultiSelector > label {\r\n\tcolor: #444;\r\n}", ""]);

// exports


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehiclePOICrossings  {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction:\tcolumn;\r\n\t    flex-direction:\tcolumn;\r\n\tbackground-color: #F8F8F8;\r\n}\r\n\r\n.VehiclePOICrossings > header {\r\n\tbackground-color: transparent;\r\n\ttransition: box-shadow .2s, background-color .2s;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tpadding-left: 20px;\r\n\tpadding-right: 20px;\r\n\tz-index: 1;\r\n\theight: 50px;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.VehiclePOICrossings header.Shadowed {\r\n\tbox-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\tbackground-color: #EEE;\r\n}\r\n\r\n.VehiclePOICrossings header .IntervalEditorContainer {\r\n\t-ms-flex: 1;\r\n\t    flex: 1;\r\n\tdisplay: -ms-flexbox;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.VehiclePOICrossings header .IntervalEditor {\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.VehiclePOICrossings header .POISelector {\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.VehiclePOICrossings .Content {\r\n\tposition: relative;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\toverflow: hidden;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n}\r\n\r\n.VehiclePOICrossings .Content .Pager {\r\n\twidth: 100%;\r\n}\r\n\r\n.VehiclePOICrossings .Result {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\toverflow: auto;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\tpadding: 20px;\r\n}\r\n\r\n.VehiclePOICrossings .ProgressBar {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, -50%);\r\n}\r\n\r\n.VehiclePOICrossings  h1.Message {\r\n\tcolor: #666;\r\n\tmargin: 20px;\r\n}", ""]);

// exports


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".VehicleProperties  {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction:\tcolumn;\r\n\t    flex-direction:\tcolumn;\r\n\tbackground-color: #F8F8F8;\r\n}\r\n\r\n.VehicleProperties > header {\r\n\tbackground-color: transparent;\r\n\ttransition: box-shadow .2s, background-color .2s;\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tpadding-left: 20px;\r\n\tz-index: 1;\r\n\theight: 50px;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.VehicleProperties header.Shadowed {\r\n\tbox-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\t-moz-box-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\t-webkit-box-shadow: 0px 1px 7px 0px rgba(119, 119, 119, 0.75);\r\n\tbackground-color: #EEE;\r\n}\r\n\r\n.VehicleProperties div.Content {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\toverflow: auto;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n\t-ms-flex-align: start;\r\n\t    align-items: flex-start;\r\n\tpadding: 20px;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n\t.VehicleProperties div.Content {\r\n\t\t-ms-flex-direction: column;\r\n\t\t    flex-direction: column;\r\n\t\t-ms-flex-pack: start;\r\n\t\t    justify-content: flex-start;\r\n\t\t-ms-flex-align: center;\r\n\t\t    align-items: center;\r\n\t}\r\n}\r\n\r\n.VehicleProperties div.Content .Card {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\twidth: 320px;\r\n\tmargin: 0px 20px 20px 0px;\r\n\tpadding: 20px;\r\n\toverflow: visible;\r\n}\r\n\r\n.VehicleProperties .ProgressBar {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, -50%);\r\n}", ""]);

// exports


/***/ },
/* 750 */
/***/ function(module, exports) {

"use strict";
"use strict";

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

'use strict';

var camelize = __webpack_require__(750);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(760);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(7);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(32);

var createArrayFromMixed = __webpack_require__(753);
var getMarkupWrap = __webpack_require__(755);
var invariant = __webpack_require__(7);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(32);

var invariant = __webpack_require__(7);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ },
/* 756 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

'use strict';

/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ },
/* 757 */
/***/ function(module, exports) {

"use strict";
'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

'use strict';

var hyphenate = __webpack_require__(757);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ },
/* 759 */
/***/ function(module, exports) {

"use strict";
'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(759);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ },
/* 761 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */

'use strict';

/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ },
/* 762 */
/***/ function(module, exports) {

/*
 Highcharts JS v5.0.14 (2017-07-28)

 (c) 2009-2016 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(M,S){"object"===typeof module&&module.exports?module.exports=M.document?S(M):S:M.Highcharts=S(M)})("undefined"!==typeof window?window:this,function(M){M=function(){var a=window,C=a.document,A=a.navigator&&a.navigator.userAgent||"",F=C&&C.createElementNS&&!!C.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,E=/(edge|msie|trident)/i.test(A)&&!window.opera,m=!F,f=/Firefox/.test(A),l=f&&4>parseInt(A.split("Firefox/")[1],10);return a.Highcharts?a.Highcharts.error(16,!0):{product:"Highcharts",
version:"5.0.14",deg2rad:2*Math.PI/360,doc:C,hasBidiBug:l,hasTouch:C&&void 0!==C.documentElement.ontouchstart,isMS:E,isWebKit:/AppleWebKit/.test(A),isFirefox:f,isTouchDevice:/(Mobile|Android|Windows Phone)/.test(A),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:F,vml:m,win:a,marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){},charts:[]}}();(function(a){var C=[],A=a.charts,F=a.doc,E=a.win;a.error=function(m,f){m=a.isNumber(m)?"Highcharts error #"+
m+": www.highcharts.com/errors/"+m:m;if(f)throw Error(m);E.console&&console.log(m)};a.Fx=function(a,f,l){this.options=f;this.elem=a;this.prop=l};a.Fx.prototype={dSetter:function(){var a=this.paths[0],f=this.paths[1],l=[],r=this.now,u=a.length,t;if(1===r)l=this.toD;else if(u===f.length&&1>r)for(;u--;)t=parseFloat(a[u]),l[u]=isNaN(t)?a[u]:r*parseFloat(f[u]-t)+t;else l=f;this.elem.attr("d",l,null,!0)},update:function(){var a=this.elem,f=this.prop,l=this.now,r=this.options.step;if(this[f+"Setter"])this[f+
"Setter"]();else a.attr?a.element&&a.attr(f,l,null,!0):a.style[f]=l+this.unit;r&&r.call(a,l,this)},run:function(a,f,l){var r=this,m=function(a){return m.stopped?!1:r.step(a)},t;this.startTime=+new Date;this.start=a;this.end=f;this.unit=l;this.now=this.start;this.pos=0;m.elem=this.elem;m.prop=this.prop;m()&&1===C.push(m)&&(m.timerId=setInterval(function(){for(t=0;t<C.length;t++)C[t]()||C.splice(t--,1);C.length||clearInterval(m.timerId)},13))},step:function(m){var f=+new Date,l,r=this.options,u=this.elem,
t=r.complete,g=r.duration,d=r.curAnim;u.attr&&!u.element?m=!1:m||f>=g+this.startTime?(this.now=this.end,this.pos=1,this.update(),l=d[this.prop]=!0,a.objectEach(d,function(a){!0!==a&&(l=!1)}),l&&t&&t.call(u),m=!1):(this.pos=r.easing((f-this.startTime)/g),this.now=this.start+(this.end-this.start)*this.pos,this.update(),m=!0);return m},initPath:function(m,f,l){function r(a){var c,e;for(n=a.length;n--;)c="M"===a[n]||"L"===a[n],e=/[a-zA-Z]/.test(a[n+3]),c&&e&&a.splice(n+1,0,a[n+1],a[n+2],a[n+1],a[n+2])}
function u(a,c){for(;a.length<v;){a[0]=c[v-a.length];var b=a.slice(0,e);[].splice.apply(a,[0,0].concat(b));D&&(b=a.slice(a.length-e),[].splice.apply(a,[a.length,0].concat(b)),n--)}a[0]="M"}function t(a,c){for(var q=(v-a.length)/e;0<q&&q--;)y=a.slice().splice(a.length/J-e,e*J),y[0]=c[v-e-q*e],b&&(y[e-6]=y[e-2],y[e-5]=y[e-1]),[].splice.apply(a,[a.length/J,0].concat(y)),D&&q--}f=f||"";var g,d=m.startX,k=m.endX,b=-1<f.indexOf("C"),e=b?7:3,v,y,n;f=f.split(" ");l=l.slice();var D=m.isArea,J=D?2:1,c;b&&(r(f),
r(l));if(d&&k){for(n=0;n<d.length;n++)if(d[n]===k[0]){g=n;break}else if(d[0]===k[k.length-d.length+n]){g=n;c=!0;break}void 0===g&&(f=[])}f.length&&a.isNumber(g)&&(v=l.length+g*J*e,c?(u(f,l),t(l,f)):(u(l,f),t(f,l)));return[f,l]}};a.Fx.prototype.fillSetter=a.Fx.prototype.strokeSetter=function(){this.elem.attr(this.prop,a.color(this.start).tweenTo(a.color(this.end),this.pos),null,!0)};a.extend=function(a,f){var m;a||(a={});for(m in f)a[m]=f[m];return a};a.merge=function(){var m,f=arguments,l,r={},u=
function(f,g){"object"!==typeof f&&(f={});a.objectEach(g,function(d,k){!a.isObject(d,!0)||a.isClass(d)||a.isDOMElement(d)?f[k]=g[k]:f[k]=u(f[k]||{},d)});return f};!0===f[0]&&(r=f[1],f=Array.prototype.slice.call(f,2));l=f.length;for(m=0;m<l;m++)r=u(r,f[m]);return r};a.pInt=function(a,f){return parseInt(a,f||10)};a.isString=function(a){return"string"===typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(m,
f){return!!m&&"object"===typeof m&&(!f||!a.isArray(m))};a.isDOMElement=function(m){return a.isObject(m)&&"number"===typeof m.nodeType};a.isClass=function(m){var f=m&&m.constructor;return!(!a.isObject(m,!0)||a.isDOMElement(m)||!f||!f.name||"Object"===f.name)};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)};a.erase=function(a,f){for(var m=a.length;m--;)if(a[m]===f){a.splice(m,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(m,f,l){var r;a.isString(f)?a.defined(l)?
m.setAttribute(f,l):m&&m.getAttribute&&(r=m.getAttribute(f)):a.defined(f)&&a.isObject(f)&&a.objectEach(f,function(a,f){m.setAttribute(f,a)});return r};a.splat=function(m){return a.isArray(m)?m:[m]};a.syncTimeout=function(a,f,l){if(f)return setTimeout(a,f,l);a.call(0,l)};a.pick=function(){var a=arguments,f,l,r=a.length;for(f=0;f<r;f++)if(l=a[f],void 0!==l&&null!==l)return l};a.css=function(m,f){a.isMS&&!a.svg&&f&&void 0!==f.opacity&&(f.filter="alpha(opacity\x3d"+100*f.opacity+")");a.extend(m.style,
f)};a.createElement=function(m,f,l,r,u){m=F.createElement(m);var t=a.css;f&&a.extend(m,f);u&&t(m,{padding:0,border:"none",margin:0});l&&t(m,l);r&&r.appendChild(m);return m};a.extendClass=function(m,f){var l=function(){};l.prototype=new m;a.extend(l.prototype,f);return l};a.pad=function(a,f,l){return Array((f||2)+1-String(a).length).join(l||0)+a};a.relativeLength=function(a,f,l){return/%$/.test(a)?f*parseFloat(a)/100+(l||0):parseFloat(a)};a.wrap=function(a,f,l){var r=a[f];a[f]=function(){var a=Array.prototype.slice.call(arguments),
f=arguments,g=this;g.proceed=function(){r.apply(g,arguments.length?arguments:f)};a.unshift(r);a=l.apply(this,a);g.proceed=null;return a}};a.getTZOffset=function(m){var f=a.Date;return 6E4*(f.hcGetTimezoneOffset&&f.hcGetTimezoneOffset(m)||f.hcTimezoneOffset||0)};a.dateFormat=function(m,f,l){if(!a.defined(f)||isNaN(f))return a.defaultOptions.lang.invalidDate||"";m=a.pick(m,"%Y-%m-%d %H:%M:%S");var r=a.Date,u=new r(f-a.getTZOffset(f)),t=u[r.hcGetHours](),g=u[r.hcGetDay](),d=u[r.hcGetDate](),k=u[r.hcGetMonth](),
b=u[r.hcGetFullYear](),e=a.defaultOptions.lang,v=e.weekdays,y=e.shortWeekdays,n=a.pad,r=a.extend({a:y?y[g]:v[g].substr(0,3),A:v[g],d:n(d),e:n(d,2," "),w:g,b:e.shortMonths[k],B:e.months[k],m:n(k+1),y:b.toString().substr(2,2),Y:b,H:n(t),k:t,I:n(t%12||12),l:t%12||12,M:n(u[r.hcGetMinutes]()),p:12>t?"AM":"PM",P:12>t?"am":"pm",S:n(u.getSeconds()),L:n(Math.round(f%1E3),3)},a.dateFormats);a.objectEach(r,function(a,e){for(;-1!==m.indexOf("%"+e);)m=m.replace("%"+e,"function"===typeof a?a(f):a)});return l?m.substr(0,
1).toUpperCase()+m.substr(1):m};a.formatSingle=function(m,f){var l=/\.([0-9])/,r=a.defaultOptions.lang;/f$/.test(m)?(l=(l=m.match(l))?l[1]:-1,null!==f&&(f=a.numberFormat(f,l,r.decimalPoint,-1<m.indexOf(",")?r.thousandsSep:""))):f=a.dateFormat(m,f);return f};a.format=function(m,f){for(var l="{",r=!1,u,t,g,d,k=[],b;m;){l=m.indexOf(l);if(-1===l)break;u=m.slice(0,l);if(r){u=u.split(":");t=u.shift().split(".");d=t.length;b=f;for(g=0;g<d;g++)b=b[t[g]];u.length&&(b=a.formatSingle(u.join(":"),b));k.push(b)}else k.push(u);
m=m.slice(l+1);l=(r=!r)?"}":"{"}k.push(m);return k.join("")};a.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(m,f,l,r,u){var t,g=m;l=a.pick(l,1);t=m/l;f||(f=u?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===r&&(1===l?f=a.grep(f,function(a){return 0===a%1}):.1>=l&&(f=[1/l])));for(r=0;r<f.length&&!(g=f[r],u&&g*l>=m||!u&&t<=(f[r]+(f[r+1]||f[r]))/2);r++);return g=a.correctFloat(g*l,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=
function(a,f){var l=a.length,r,m;for(m=0;m<l;m++)a[m].safeI=m;a.sort(function(a,g){r=f(a,g);return 0===r?a.safeI-g.safeI:r});for(m=0;m<l;m++)delete a[m].safeI};a.arrayMin=function(a){for(var f=a.length,l=a[0];f--;)a[f]<l&&(l=a[f]);return l};a.arrayMax=function(a){for(var f=a.length,l=a[0];f--;)a[f]>l&&(l=a[f]);return l};a.destroyObjectProperties=function(m,f){a.objectEach(m,function(a,r){a&&a!==f&&a.destroy&&a.destroy();delete m[r]})};a.discardElement=function(m){var f=a.garbageBin;f||(f=a.createElement("div"));
m&&f.appendChild(m);f.innerHTML=""};a.correctFloat=function(a,f){return parseFloat(a.toPrecision(f||14))};a.setAnimation=function(m,f){f.renderer.globalAnimation=a.pick(m,f.options.chart.animation,!0)};a.animObject=function(m){return a.isObject(m)?a.merge(m):{duration:m?500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};a.numberFormat=function(m,f,l,r){m=+m||0;f=+f;var u=a.defaultOptions.lang,t=(m.toString().split(".")[1]||"").split("e")[0].length,
g,d,k=m.toString().split("e");-1===f?f=Math.min(t,20):a.isNumber(f)||(f=2);d=(Math.abs(k[1]?k[0]:m)+Math.pow(10,-Math.max(f,t)-1)).toFixed(f);t=String(a.pInt(d));g=3<t.length?t.length%3:0;l=a.pick(l,u.decimalPoint);r=a.pick(r,u.thousandsSep);m=(0>m?"-":"")+(g?t.substr(0,g)+r:"");m+=t.substr(g).replace(/(\d{3})(?=\d)/g,"$1"+r);f&&(m+=l+d.slice(-f));k[1]&&(m+="e"+k[1]);return m};Math.easeInOutSine=function(a){return-.5*(Math.cos(Math.PI*a)-1)};a.getStyle=function(m,f,l){if("width"===f)return Math.min(m.offsetWidth,
m.scrollWidth)-a.getStyle(m,"padding-left")-a.getStyle(m,"padding-right");if("height"===f)return Math.min(m.offsetHeight,m.scrollHeight)-a.getStyle(m,"padding-top")-a.getStyle(m,"padding-bottom");if(m=E.getComputedStyle(m,void 0))m=m.getPropertyValue(f),a.pick(l,!0)&&(m=a.pInt(m));return m};a.inArray=function(a,f){return f.indexOf?f.indexOf(a):[].indexOf.call(f,a)};a.grep=function(a,f){return[].filter.call(a,f)};a.find=function(a,f){return[].find.call(a,f)};a.map=function(a,f){for(var l=[],r=0,m=
a.length;r<m;r++)l[r]=f.call(a[r],a[r],r,a);return l};a.offset=function(a){var f=F.documentElement;a=a.getBoundingClientRect();return{top:a.top+(E.pageYOffset||f.scrollTop)-(f.clientTop||0),left:a.left+(E.pageXOffset||f.scrollLeft)-(f.clientLeft||0)}};a.stop=function(a,f){for(var l=C.length;l--;)C[l].elem!==a||f&&f!==C[l].prop||(C[l].stopped=!0)};a.each=function(a,f,l){return Array.prototype.forEach.call(a,f,l)};a.objectEach=function(a,f,l){for(var r in a)a.hasOwnProperty(r)&&f.call(l,a[r],r,a)};
a.addEvent=function(m,f,l){function r(a){a.target=a.srcElement||E;l.call(m,a)}var u=m.hcEvents=m.hcEvents||{};m.addEventListener?m.addEventListener(f,l,!1):m.attachEvent&&(m.hcEventsIE||(m.hcEventsIE={}),l.hcGetKey||(l.hcGetKey=a.uniqueKey()),m.hcEventsIE[l.hcGetKey]=r,m.attachEvent("on"+f,r));u[f]||(u[f]=[]);u[f].push(l);return function(){a.removeEvent(m,f,l)}};a.removeEvent=function(m,f,l){function r(a,b){m.removeEventListener?m.removeEventListener(a,b,!1):m.attachEvent&&(b=m.hcEventsIE[b.hcGetKey],
m.detachEvent("on"+a,b))}function u(){var d,b;m.nodeName&&(f?(d={},d[f]=!0):d=g,a.objectEach(d,function(a,d){if(g[d])for(b=g[d].length;b--;)r(d,g[d][b])}))}var t,g=m.hcEvents,d;g&&(f?(t=g[f]||[],l?(d=a.inArray(l,t),-1<d&&(t.splice(d,1),g[f]=t),r(f,l)):(u(),g[f]=[])):(u(),m.hcEvents={}))};a.fireEvent=function(m,f,l,r){var u;u=m.hcEvents;var t,g;l=l||{};if(F.createEvent&&(m.dispatchEvent||m.fireEvent))u=F.createEvent("Events"),u.initEvent(f,!0,!0),a.extend(u,l),m.dispatchEvent?m.dispatchEvent(u):m.fireEvent(f,
u);else if(u)for(u=u[f]||[],t=u.length,l.target||a.extend(l,{preventDefault:function(){l.defaultPrevented=!0},target:m,type:f}),f=0;f<t;f++)(g=u[f])&&!1===g.call(m,l)&&l.preventDefault();r&&!l.defaultPrevented&&r(l)};a.animate=function(m,f,l){var r,u="",t,g,d;a.isObject(l)||(d=arguments,l={duration:d[2],easing:d[3],complete:d[4]});a.isNumber(l.duration)||(l.duration=400);l.easing="function"===typeof l.easing?l.easing:Math[l.easing]||Math.easeInOutSine;l.curAnim=a.merge(f);a.objectEach(f,function(d,
b){a.stop(m,b);g=new a.Fx(m,l,b);t=null;"d"===b?(g.paths=g.initPath(m,m.d,f.d),g.toD=f.d,r=0,t=1):m.attr?r=m.attr(b):(r=parseFloat(a.getStyle(m,b))||0,"opacity"!==b&&(u="px"));t||(t=d);t&&t.match&&t.match("px")&&(t=t.replace(/px/g,""));g.run(r,t,u)})};a.seriesType=function(m,f,l,r,u){var t=a.getOptions(),g=a.seriesTypes;t.plotOptions[m]=a.merge(t.plotOptions[f],l);g[m]=a.extendClass(g[f]||function(){},r);g[m].prototype.type=m;u&&(g[m].prototype.pointClass=a.extendClass(a.Point,u));return g[m]};a.uniqueKey=
function(){var a=Math.random().toString(36).substring(2,9),f=0;return function(){return"highcharts-"+a+"-"+f++}}();E.jQuery&&(E.jQuery.fn.highcharts=function(){var m=[].slice.call(arguments);if(this[0])return m[0]?(new (a[a.isString(m[0])?m.shift():"Chart"])(this[0],m[0],m[1]),this):A[a.attr(this[0],"data-highcharts-chart")]});F&&!F.defaultView&&(a.getStyle=function(m,f){var l={width:"clientWidth",height:"clientHeight"}[f];if(m.style[f])return a.pInt(m.style[f]);"opacity"===f&&(f="filter");if(l)return m.style.zoom=
1,Math.max(m[l]-2*a.getStyle(m,"padding"),0);m=m.currentStyle[f.replace(/\-(\w)/g,function(a,f){return f.toUpperCase()})];"filter"===f&&(m=m.replace(/alpha\(opacity=([0-9]+)\)/,function(a,f){return f/100}));return""===m?1:a.pInt(m)});Array.prototype.forEach||(a.each=function(a,f,l){for(var r=0,m=a.length;r<m;r++)if(!1===f.call(l,a[r],r,a))return r});Array.prototype.indexOf||(a.inArray=function(a,f){var l,r=0;if(f)for(l=f.length;r<l;r++)if(f[r]===a)return r;return-1});Array.prototype.filter||(a.grep=
function(a,f){for(var l=[],r=0,m=a.length;r<m;r++)f(a[r],r)&&l.push(a[r]);return l});Array.prototype.find||(a.find=function(a,f){var l,r=a.length;for(l=0;l<r;l++)if(f(a[l],l))return a[l]})})(M);(function(a){var C=a.each,A=a.isNumber,F=a.map,E=a.merge,m=a.pInt;a.Color=function(f){if(!(this instanceof a.Color))return new a.Color(f);this.init(f)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[m(a[1]),
m(a[2]),m(a[3]),parseFloat(a[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(a){return[m(a[1]),m(a[2]),m(a[3]),1]}}],names:{none:"rgba(255,255,255,0)",white:"#ffffff",black:"#000000"},init:function(f){var l,r,m,t;if((this.input=f=this.names[f&&f.toLowerCase?f.toLowerCase():""]||f)&&f.stops)this.stops=F(f.stops,function(g){return new a.Color(g[1])});else if(f&&"#"===f.charAt()&&(l=f.length,f=parseInt(f.substr(1),16),7===l?r=[(f&16711680)>>16,(f&65280)>>
8,f&255,1]:4===l&&(r=[(f&3840)>>4|(f&3840)>>8,(f&240)>>4|f&240,(f&15)<<4|f&15,1])),!r)for(m=this.parsers.length;m--&&!r;)t=this.parsers[m],(l=t.regex.exec(f))&&(r=t.parse(l));this.rgba=r||[]},get:function(a){var f=this.input,r=this.rgba,m;this.stops?(m=E(f),m.stops=[].concat(m.stops),C(this.stops,function(f,g){m.stops[g]=[m.stops[g][0],f.get(a)]})):m=r&&A(r[0])?"rgb"===a||!a&&1===r[3]?"rgb("+r[0]+","+r[1]+","+r[2]+")":"a"===a?r[3]:"rgba("+r.join(",")+")":f;return m},brighten:function(a){var f,r=this.rgba;
if(this.stops)C(this.stops,function(f){f.brighten(a)});else if(A(a)&&0!==a)for(f=0;3>f;f++)r[f]+=m(255*a),0>r[f]&&(r[f]=0),255<r[f]&&(r[f]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this},tweenTo:function(a,l){var f,m;a.rgba.length?(f=this.rgba,a=a.rgba,m=1!==a[3]||1!==f[3],a=(m?"rgba(":"rgb(")+Math.round(a[0]+(f[0]-a[0])*(1-l))+","+Math.round(a[1]+(f[1]-a[1])*(1-l))+","+Math.round(a[2]+(f[2]-a[2])*(1-l))+(m?","+(a[3]+(f[3]-a[3])*(1-l)):"")+")"):a=a.input||"none";return a}};a.color=
function(f){return new a.Color(f)}})(M);(function(a){var C,A,F=a.addEvent,E=a.animate,m=a.attr,f=a.charts,l=a.color,r=a.css,u=a.createElement,t=a.defined,g=a.deg2rad,d=a.destroyObjectProperties,k=a.doc,b=a.each,e=a.extend,v=a.erase,y=a.grep,n=a.hasTouch,D=a.inArray,J=a.isArray,c=a.isFirefox,G=a.isMS,q=a.isObject,B=a.isString,K=a.isWebKit,p=a.merge,z=a.noop,I=a.objectEach,L=a.pick,h=a.pInt,w=a.removeEvent,P=a.stop,H=a.svg,O=a.SVG_NS,Q=a.symbolSizes,R=a.win;C=a.SVGElement=function(){return this};e(C.prototype,
{opacity:1,SVG_NS:O,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline".split(" "),init:function(a,h){this.element="span"===h?u(h):k.createElementNS(this.SVG_NS,h);this.renderer=a},animate:function(x,h,c){h=a.animObject(L(h,this.renderer.globalAnimation,!0));0!==h.duration?(c&&(h.complete=c),E(this,x,h)):(this.attr(x,null,c),h.step&&h.step.call(this));return this},colorGradient:function(x,h,c){var w=this.renderer,
e,q,N,d,n,g,k,H,G,v,z=[],f;x.radialGradient?q="radialGradient":x.linearGradient&&(q="linearGradient");q&&(N=x[q],n=w.gradients,k=x.stops,v=c.radialReference,J(N)&&(x[q]=N={x1:N[0],y1:N[1],x2:N[2],y2:N[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===q&&v&&!t(N.gradientUnits)&&(d=N,N=p(N,w.getRadialAttr(v,d),{gradientUnits:"userSpaceOnUse"})),I(N,function(a,x){"id"!==x&&z.push(x,a)}),I(k,function(a){z.push(a)}),z=z.join(","),n[z]?v=n[z].attr("id"):(N.id=v=a.uniqueKey(),n[z]=g=w.createElement(q).attr(N).add(w.defs),
g.radAttr=d,g.stops=[],b(k,function(x){0===x[1].indexOf("rgba")?(e=a.color(x[1]),H=e.get("rgb"),G=e.get("a")):(H=x[1],G=1);x=w.createElement("stop").attr({offset:x[0],"stop-color":H,"stop-opacity":G}).add(g);g.stops.push(x)})),f="url("+w.url+"#"+v+")",c.setAttribute(h,f),c.gradient=z,x.toString=function(){return f})},applyTextOutline:function(x){var h=this.element,c,w,p,e,q;-1!==x.indexOf("contrast")&&(x=x.replace(/contrast/g,this.renderer.getContrast(h.style.fill)));x=x.split(" ");w=x[x.length-1];
if((p=x[0])&&"none"!==p&&a.svg){this.fakeTS=!0;x=[].slice.call(h.getElementsByTagName("tspan"));this.ySetter=this.xSetter;p=p.replace(/(^[\d\.]+)(.*?)$/g,function(a,x,h){return 2*x+h});for(q=x.length;q--;)c=x[q],"highcharts-text-outline"===c.getAttribute("class")&&v(x,h.removeChild(c));e=h.firstChild;b(x,function(a,x){0===x&&(a.setAttribute("x",h.getAttribute("x")),x=h.getAttribute("y"),a.setAttribute("y",x||0),null===x&&h.setAttribute("y",0));a=a.cloneNode(1);m(a,{"class":"highcharts-text-outline",
fill:w,stroke:w,"stroke-width":p,"stroke-linejoin":"round"});h.insertBefore(a,e)})}},attr:function(a,h,c,w){var x,p=this.element,e,q=this,b,N;"string"===typeof a&&void 0!==h&&(x=a,a={},a[x]=h);"string"===typeof a?q=(this[a+"Getter"]||this._defaultGetter).call(this,a,p):(I(a,function(x,h){b=!1;w||P(this,h);this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/.test(h)&&(e||(this.symbolAttr(a),e=!0),b=!0);!this.rotation||"x"!==h&&"y"!==h||(this.doTransform=!0);b||(N=this[h+"Setter"]||
this._defaultSetter,N.call(this,x,h,p),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(h)&&this.updateShadows(h,x,N))},this),this.afterSetters());c&&c();return q},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)},updateShadows:function(a,h,c){for(var x=this.shadows,w=x.length;w--;)c.call(x[w],"height"===a?Math.max(h-(x[w].cutHeight||0),0):"d"===a?this.d:h,a,x[w])},addClass:function(a,h){var x=this.attr("class")||"";-1===x.indexOf(a)&&
(h||(a=(x+(x?" ":"")+a).replace("  "," ")),this.attr("class",a));return this},hasClass:function(a){return-1!==D(a,(this.attr("class")||"").split(" "))},removeClass:function(a){return this.attr("class",(this.attr("class")||"").replace(a,""))},symbolAttr:function(a){var x=this;b("x y r start end width height innerR anchorX anchorY".split(" "),function(h){x[h]=L(a[h],x[h])});x.attr({d:x.renderer.symbols[x.symbolName](x.x,x.y,x.width,x.height,x)})},clip:function(a){return this.attr("clip-path",a?"url("+
this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,h){var x=this,c={},w;h=h||a.strokeWidth||0;w=Math.round(h)%2/2;a.x=Math.floor(a.x||x.x||0)+w;a.y=Math.floor(a.y||x.y||0)+w;a.width=Math.floor((a.width||x.width||0)-2*w);a.height=Math.floor((a.height||x.height||0)-2*w);t(a.strokeWidth)&&(a.strokeWidth=h);I(a,function(a,h){x[h]!==a&&(x[h]=c[h]=a)});return c},css:function(a){var x=this.styles,c={},w=this.element,p,q="",b,d=!x,n=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);
x&&I(a,function(a,h){a!==x[h]&&(c[h]=a,d=!0)});d&&(x&&(a=e(x,c)),p=this.textWidth=a&&a.width&&"auto"!==a.width&&"text"===w.nodeName.toLowerCase()&&h(a.width),this.styles=a,p&&!H&&this.renderer.forExport&&delete a.width,G&&!H?r(this.element,a):(b=function(a,x){return"-"+x.toLowerCase()},I(a,function(a,x){-1===D(x,n)&&(q+=x.replace(/([A-Z])/g,b)+":"+a+";")}),q&&m(w,"style",q)),this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline)));
return this},strokeWidth:function(){return this["stroke-width"]||0},on:function(a,h){var x=this,c=x.element;n&&"click"===a?(c.ontouchstart=function(a){x.touchEventFired=Date.now();a.preventDefault();h.call(c,a)},c.onclick=function(a){(-1===R.navigator.userAgent.indexOf("Android")||1100<Date.now()-(x.touchEventFired||0))&&h.call(c,a)}):c["on"+a]=h;return this},setRadialReference:function(a){var x=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;x&&x.radAttr&&x.animate(this.renderer.getRadialAttr(a,
x.radAttr));return this},translate:function(a,h){return this.attr({translateX:a,translateY:h})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,h=this.translateY||0,c=this.scaleX,w=this.scaleY,p=this.inverted,e=this.rotation,q=this.element;p&&(a+=this.width,h+=this.height);a=["translate("+a+","+h+")"];p?a.push("rotate(90) scale(-1,1)"):e&&a.push("rotate("+e+" "+(q.getAttribute("x")||0)+" "+(q.getAttribute("y")||0)+")");(t(c)||
t(w))&&a.push("scale("+L(c,1)+" "+L(w,1)+")");a.length&&q.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,h,c){var x,w,p,e,q={};w=this.renderer;p=w.alignedObjects;var b,d;if(a){if(this.alignOptions=a,this.alignByTranslate=h,!c||B(c))this.alignTo=x=c||"renderer",v(p,this),p.push(this),c=null}else a=this.alignOptions,h=this.alignByTranslate,x=this.alignTo;c=L(c,w[x],w);x=a.align;w=a.verticalAlign;p=(c.x||0)+(a.x||
0);e=(c.y||0)+(a.y||0);"right"===x?b=1:"center"===x&&(b=2);b&&(p+=(c.width-(a.width||0))/b);q[h?"translateX":"x"]=Math.round(p);"bottom"===w?d=1:"middle"===w&&(d=2);d&&(e+=(c.height-(a.height||0))/d);q[h?"translateY":"y"]=Math.round(e);this[this.placed?"animate":"attr"](q);this.placed=!0;this.alignAttr=q;return this},getBBox:function(a,h){var x,c=this.renderer,w,p=this.element,q=this.styles,d,n=this.textStr,k,N=c.cache,H=c.cacheKeys,G;h=L(h,this.rotation);w=h*g;d=q&&q.fontSize;void 0!==n&&(G=n.toString(),
-1===G.indexOf("\x3c")&&(G=G.replace(/[0-9]/g,"0")),G+=["",h||0,d,q&&q.width,q&&q.textOverflow].join());G&&!a&&(x=N[G]);if(!x){if(p.namespaceURI===this.SVG_NS||c.forExport){try{(k=this.fakeTS&&function(a){b(p.querySelectorAll(".highcharts-text-outline"),function(x){x.style.display=a})})&&k("none"),x=p.getBBox?e({},p.getBBox()):{width:p.offsetWidth,height:p.offsetHeight},k&&k("")}catch(W){}if(!x||0>x.width)x={width:0,height:0}}else x=this.htmlGetBBox();c.isSVG&&(a=x.width,c=x.height,q&&"11px"===q.fontSize&&
17===Math.round(c)&&(x.height=c=14),h&&(x.width=Math.abs(c*Math.sin(w))+Math.abs(a*Math.cos(w)),x.height=Math.abs(c*Math.cos(w))+Math.abs(a*Math.sin(w))));if(G&&0<x.height){for(;250<H.length;)delete N[H.shift()];N[G]||H.push(G);N[G]=x}}return x},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},fadeOut:function(a){var x=this;x.animate({opacity:0},{duration:a||150,complete:function(){x.attr({y:-9999})}})},add:function(a){var x=
this.renderer,h=this.element,c;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&x.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)c=this.zIndexSetter();c||(a?a.element:x.box).appendChild(h);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var x=a.parentNode;x&&x.removeChild(a)},destroy:function(){var a=this,h=a.element||{},c=a.renderer.isSVG&&"SPAN"===h.nodeName&&a.parentGroup,w=h.ownerSVGElement;h.onclick=h.onmouseout=h.onmouseover=h.onmousemove=
h.point=null;P(a);a.clipPath&&w&&(b(w.querySelectorAll("[clip-path]"),function(x){-1<x.getAttribute("clip-path").indexOf(a.clipPath.element.id+")")&&x.removeAttribute("clip-path")}),a.clipPath=a.clipPath.destroy());if(a.stops){for(w=0;w<a.stops.length;w++)a.stops[w]=a.stops[w].destroy();a.stops=null}a.safeRemoveChild(h);for(a.destroyShadows();c&&c.div&&0===c.div.childNodes.length;)h=c.parentGroup,a.safeRemoveChild(c.div),delete c.div,c=h;a.alignTo&&v(a.renderer.alignedObjects,a);I(a,function(x,h){delete a[h]});
return null},shadow:function(a,h,c){var x=[],w,p,q=this.element,e,b,d,n;if(!a)this.destroyShadows();else if(!this.shadows){b=L(a.width,3);d=(a.opacity||.15)/b;n=this.parentInverted?"(-1,-1)":"("+L(a.offsetX,1)+", "+L(a.offsetY,1)+")";for(w=1;w<=b;w++)p=q.cloneNode(0),e=2*b+1-2*w,m(p,{isShadow:"true",stroke:a.color||"#000000","stroke-opacity":d*w,"stroke-width":e,transform:"translate"+n,fill:"none"}),c&&(m(p,"height",Math.max(m(p,"height")-e,0)),p.cutHeight=e),h?h.element.appendChild(p):q.parentNode.insertBefore(p,
q),x.push(p);this.shadows=x}return this},destroyShadows:function(){b(this.shadows||[],function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=L(this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,h,c){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");this[h]!==
a&&(c.setAttribute(h,a),this[h]=a)},dashstyleSetter:function(a){var x,c=this["stroke-width"];"inherit"===c&&(c=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(x=a.length;x--;)a[x]=h(a[x])*c;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){this.element.setAttribute("text-anchor",
{left:"start",center:"middle",right:"end"}[a])},opacitySetter:function(a,h,c){this[h]=a;c.setAttribute(h,a)},titleSetter:function(a){var h=this.element.getElementsByTagName("title")[0];h||(h=k.createElementNS(this.SVG_NS,"title"),this.element.appendChild(h));h.firstChild&&h.removeChild(h.firstChild);h.appendChild(k.createTextNode(String(L(a),"").replace(/<[^>]*>/g,"")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this))},fillSetter:function(a,
h,c){"string"===typeof a?c.setAttribute(h,a):a&&this.colorGradient(a,h,c)},visibilitySetter:function(a,h,c){"inherit"===a?c.removeAttribute(h):this[h]!==a&&c.setAttribute(h,a);this[h]=a},zIndexSetter:function(a,c){var x=this.renderer,w=this.parentGroup,p=(w||x).element||x.box,q,e=this.element,b;q=this.added;var d;t(a)&&(e.zIndex=a,a=+a,this[c]===a&&(q=!1),this[c]=a);if(q){(a=this.zIndex)&&w&&(w.handleZ=!0);c=p.childNodes;for(d=0;d<c.length&&!b;d++)w=c[d],q=w.zIndex,w!==e&&(h(q)>a||!t(a)&&t(q)||0>
a&&!t(q)&&p!==x.box)&&(p.insertBefore(e,w),b=!0);b||p.appendChild(e)}return b},_defaultSetter:function(a,h,c){c.setAttribute(h,a)}});C.prototype.yGetter=C.prototype.xGetter;C.prototype.translateXSetter=C.prototype.translateYSetter=C.prototype.rotationSetter=C.prototype.verticalAlignSetter=C.prototype.scaleXSetter=C.prototype.scaleYSetter=function(a,h){this[h]=a;this.doTransform=!0};C.prototype["stroke-widthSetter"]=C.prototype.strokeSetter=function(a,h,c){this[h]=a;this.stroke&&this["stroke-width"]?
(C.prototype.fillSetter.call(this,this.stroke,"stroke",c),c.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===h&&0===a&&this.hasStroke&&(c.removeAttribute("stroke"),this.hasStroke=!1)};A=a.SVGRenderer=function(){this.init.apply(this,arguments)};e(A.prototype,{Element:C,SVG_NS:O,init:function(a,h,w,p,q,e){var x;p=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"}).css(this.getStyle(p));x=p.element;a.appendChild(x);-1===a.innerHTML.indexOf("xmlns")&&
m(x,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=x;this.boxWrapper=p;this.alignedObjects=[];this.url=(c||K)&&k.getElementsByTagName("base").length?R.location.href.replace(/#.*?$/,"").replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(k.createTextNode("Created with Highcharts 5.0.14"));this.defs=this.createElement("defs").add();this.allowHTML=e;this.forExport=q;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=
0;this.setSize(h,w,!1);var b;c&&a.getBoundingClientRect&&(h=function(){r(a,{left:0,top:0});b=a.getBoundingClientRect();r(a,{left:Math.ceil(b.left)-b.left+"px",top:Math.ceil(b.top)-b.top+"px"})},h(),this.unSubPixelFix=F(R,"resize",h))},getStyle:function(a){return this.style=e({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=
this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();d(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var h=new this.Element;h.init(this,a);return h},draw:z,getRadialAttr:function(a,h){return{cx:a[0]-a[2]/2+h.cx*a[2],cy:a[1]-a[2]/2+h.cy*a[2],r:h.r*a[2]}},getSpanWidth:function(a,h){var c=a.getBBox(!0).width;!H&&this.forExport&&(c=this.measureSpanWidth(h.firstChild.data,
a.styles));return c},applyEllipsis:function(a,h,c,w){var x=a.rotation,p=c,q,e=0,b=c.length,d=function(a){h.removeChild(h.firstChild);a&&h.appendChild(k.createTextNode(a))},n;a.rotation=0;p=this.getSpanWidth(a,h);if(n=p>w){for(;e<=b;)q=Math.ceil((e+b)/2),p=c.substring(0,q)+"\u2026",d(p),p=this.getSpanWidth(a,h),e===b?e=b+1:p>w?b=q-1:e=q;0===b&&d("")}a.rotation=x;return n},buildText:function(a){var c=a.element,w=this,x=w.forExport,p=L(a.textStr,"").toString(),q=-1!==p.indexOf("\x3c"),e=c.childNodes,
d,n,g,G,v=m(c,"x"),z=a.styles,f=a.textWidth,I=z&&z.lineHeight,B=z&&z.textOutline,D=z&&"ellipsis"===z.textOverflow,l=z&&"nowrap"===z.whiteSpace,P=z&&z.fontSize,t,J,u=e.length,z=f&&!a.added&&this.box,K=function(a){var x;x=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:P||w.style.fontSize||12;return I?h(I):w.fontMetrics(x,a.getAttribute("style")?a:c).h};t=[p,D,l,I,B,P,f].join();if(t!==a.textCache){for(a.textCache=t;u--;)c.removeChild(e[u]);q||B||D||f||-1!==p.indexOf(" ")?(d=/<.*class="([^"]+)".*>/,
n=/<.*style="([^"]+)".*>/,g=/<.*href="([^"]+)".*>/,z&&z.appendChild(c),p=q?p.replace(/<(b|strong)>/g,'\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g,'\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g,"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,"\x3c/span\x3e").split(/<br.*?>/g):[p],p=y(p,function(a){return""!==a}),b(p,function(h,p){var q,e=0;h=h.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");q=h.split("|||");b(q,function(h){if(""!==
h||1===q.length){var b={},z=k.createElementNS(w.SVG_NS,"tspan"),y,I;d.test(h)&&(y=h.match(d)[1],m(z,"class",y));n.test(h)&&(I=h.match(n)[1].replace(/(;| |^)color([ :])/,"$1fill$2"),m(z,"style",I));g.test(h)&&!x&&(m(z,"onclick",'location.href\x3d"'+h.match(g)[1]+'"'),r(z,{cursor:"pointer"}));h=(h.replace(/<(.|\n)*?>/g,"")||" ").replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e");if(" "!==h){z.appendChild(k.createTextNode(h));e?b.dx=0:p&&null!==v&&(b.x=v);m(z,b);c.appendChild(z);!e&&J&&(!H&&x&&r(z,{display:"block"}),
m(z,"dy",K(z)));if(f){b=h.replace(/([^\^])-/g,"$1- ").split(" ");y=1<q.length||p||1<b.length&&!l;var B=[],N,P=K(z),t=a.rotation;for(D&&(G=w.applyEllipsis(a,z,h,f));!D&&y&&(b.length||B.length);)a.rotation=0,N=w.getSpanWidth(a,z),h=N>f,void 0===G&&(G=h),h&&1!==b.length?(z.removeChild(z.firstChild),B.unshift(b.pop())):(b=B,B=[],b.length&&!l&&(z=k.createElementNS(O,"tspan"),m(z,{dy:P,x:v}),I&&m(z,"style",I),c.appendChild(z)),N>f&&(f=N)),b.length&&z.appendChild(k.createTextNode(b.join(" ").replace(/- /g,
"-")));a.rotation=t}e++}}});J=J||c.childNodes.length}),G&&a.attr("title",a.textStr),z&&z.removeChild(c),B&&a.applyTextOutline&&a.applyTextOutline(B)):c.appendChild(k.createTextNode(p.replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e")))}},getContrast:function(a){a=l(a).rgba;return 510<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,h,c,w,q,b,d,n,g){var x=this.label(a,h,c,g,null,null,null,null,"button"),k=0;x.attr(p({padding:8,r:2},q));var z,H,v,f;q=p({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,
style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},q);z=q.style;delete q.style;b=p(q,{fill:"#e6e6e6"},b);H=b.style;delete b.style;d=p(q,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},d);v=d.style;delete d.style;n=p(q,{style:{color:"#cccccc"}},n);f=n.style;delete n.style;F(x.element,G?"mouseover":"mouseenter",function(){3!==k&&x.setState(1)});F(x.element,G?"mouseout":"mouseleave",function(){3!==k&&x.setState(k)});x.setState=function(a){1!==a&&(x.state=k=a);x.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+
["normal","hover","pressed","disabled"][a||0]);x.attr([q,b,d,n][a||0]).css([z,H,v,f][a||0])};x.attr(q).css(e({cursor:"default"},z));return x.on("click",function(a){3!==k&&w.call(x,a)})},crispLine:function(a,h){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-h%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+h%2/2);return a},path:function(a){var h={fill:"none"};J(a)?h.d=a:q(a)&&e(h,a);return this.createElement("path").attr(h)},circle:function(a,h,c){a=q(a)?a:{x:a,y:h,r:c};h=this.createElement("circle");h.xSetter=
h.ySetter=function(a,h,c){c.setAttribute("c"+h,a)};return h.attr(a)},arc:function(a,h,c,w,p,b){q(a)?(w=a,h=w.y,c=w.r,a=w.x):w={innerR:w,start:p,end:b};a=this.symbol("arc",a,h,c,c,w);a.r=c;return a},rect:function(a,h,c,w,p,b){p=q(a)?a.r:p;var x=this.createElement("rect");a=q(a)?a:void 0===a?{}:{x:a,y:h,width:Math.max(c,0),height:Math.max(w,0)};void 0!==b&&(a.strokeWidth=b,a=x.crisp(a));a.fill="none";p&&(a.r=p);x.rSetter=function(a,h,c){m(c,{rx:a,ry:a})};return x.attr(a)},setSize:function(a,h,c){var w=
this.alignedObjects,p=w.length;this.width=a;this.height=h;for(this.boxWrapper.animate({width:a,height:h},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:L(c,!0)?void 0:0});p--;)w[p].align()},g:function(a){var h=this.createElement("g");return a?h.attr({"class":"highcharts-"+a}):h},image:function(a,h,c,w,p){var x={preserveAspectRatio:"none"};1<arguments.length&&e(x,{x:h,y:c,width:w,height:p});x=this.createElement("image").attr(x);x.element.setAttributeNS?
x.element.setAttributeNS("http://www.w3.org/1999/xlink","href",a):x.element.setAttribute("hc-svg-href",a);return x},symbol:function(a,h,c,w,p,q){var x=this,d,n=/^url\((.*?)\)$/,g=n.test(a),z=!g&&(this.symbols[a]?a:"circle"),G=z&&this.symbols[z],H=t(h)&&G&&G.call(this.symbols,Math.round(h),Math.round(c),w,p,q),v,y;G?(d=this.path(H),d.attr("fill","none"),e(d,{symbolName:z,x:h,y:c,width:w,height:p}),q&&e(d,q)):g&&(v=a.match(n)[1],d=this.image(v),d.imgwidth=L(Q[v]&&Q[v].width,q&&q.width),d.imgheight=
L(Q[v]&&Q[v].height,q&&q.height),y=function(){d.attr({width:d.width,height:d.height})},b(["width","height"],function(a){d[a+"Setter"]=function(a,h){var c={},w=this["img"+h],p="width"===h?"translateX":"translateY";this[h]=a;t(w)&&(this.element&&this.element.setAttribute(h,w),this.alignByTranslate||(c[p]=((this[h]||0)-w)/2,this.attr(c)))}}),t(h)&&d.attr({x:h,y:c}),d.isImg=!0,t(d.imgwidth)&&t(d.imgheight)?y():(d.attr({width:0,height:0}),u("img",{onload:function(){var a=f[x.chartIndex];0===this.width&&
(r(this,{position:"absolute",top:"-999em"}),k.body.appendChild(this));Q[v]={width:this.width,height:this.height};d.imgwidth=this.width;d.imgheight=this.height;d.element&&y();this.parentNode&&this.parentNode.removeChild(this);x.imgCount--;if(!x.imgCount&&a&&a.onload)a.onload()},src:v}),this.imgCount++));return d},symbols:{circle:function(a,h,c,w){return this.arc(a+c/2,h+w/2,c/2,w/2,{start:0,end:2*Math.PI,open:!1})},square:function(a,h,c,w){return["M",a,h,"L",a+c,h,a+c,h+w,a,h+w,"Z"]},triangle:function(a,
h,c,w){return["M",a+c/2,h,"L",a+c,h+w,a,h+w,"Z"]},"triangle-down":function(a,h,c,w){return["M",a,h,"L",a+c,h,a+c/2,h+w,"Z"]},diamond:function(a,h,c,w){return["M",a+c/2,h,"L",a+c,h+w/2,a+c/2,h+w,a,h+w/2,"Z"]},arc:function(a,h,c,w,p){var q=p.start,b=p.r||c,x=p.r||w||c,e=p.end-.001;c=p.innerR;w=L(p.open,.001>Math.abs(p.end-p.start-2*Math.PI));var d=Math.cos(q),n=Math.sin(q),g=Math.cos(e),e=Math.sin(e);p=.001>p.end-q-Math.PI?0:1;b=["M",a+b*d,h+x*n,"A",b,x,0,p,1,a+b*g,h+x*e];t(c)&&b.push(w?"M":"L",a+c*
g,h+c*e,"A",c,c,0,p,0,a+c*d,h+c*n);b.push(w?"":"Z");return b},callout:function(a,h,c,w,p){var q=Math.min(p&&p.r||0,c,w),b=q+6,e=p&&p.anchorX;p=p&&p.anchorY;var d;d=["M",a+q,h,"L",a+c-q,h,"C",a+c,h,a+c,h,a+c,h+q,"L",a+c,h+w-q,"C",a+c,h+w,a+c,h+w,a+c-q,h+w,"L",a+q,h+w,"C",a,h+w,a,h+w,a,h+w-q,"L",a,h+q,"C",a,h,a,h,a+q,h];e&&e>c?p>h+b&&p<h+w-b?d.splice(13,3,"L",a+c,p-6,a+c+6,p,a+c,p+6,a+c,h+w-q):d.splice(13,3,"L",a+c,w/2,e,p,a+c,w/2,a+c,h+w-q):e&&0>e?p>h+b&&p<h+w-b?d.splice(33,3,"L",a,p+6,a-6,p,a,p-6,
a,h+q):d.splice(33,3,"L",a,w/2,e,p,a,w/2,a,h+q):p&&p>w&&e>a+b&&e<a+c-b?d.splice(23,3,"L",e+6,h+w,e,h+w+6,e-6,h+w,a+q,h+w):p&&0>p&&e>a+b&&e<a+c-b&&d.splice(3,3,"L",e-6,h,e,h-6,e+6,h,c-q,h);return d}},clipRect:function(h,c,w,p){var q=a.uniqueKey(),b=this.createElement("clipPath").attr({id:q}).add(this.defs);h=this.rect(h,c,w,p,0).add(b);h.id=q;h.clipPath=b;h.count=0;return h},text:function(a,h,c,w){var p=!H&&this.forExport,q={};if(w&&(this.allowHTML||!this.forExport))return this.html(a,h,c);q.x=Math.round(h||
0);c&&(q.y=Math.round(c));if(a||0===a)q.text=a;a=this.createElement("text").attr(q);p&&a.css({position:"absolute"});w||(a.xSetter=function(a,h,c){var w=c.getElementsByTagName("tspan"),p,q=c.getAttribute(h),b;for(b=0;b<w.length;b++)p=w[b],p.getAttribute(h)===q&&p.setAttribute(h,a);c.setAttribute(h,a)});return a},fontMetrics:function(a,c){a=a||c&&c.style&&c.style.fontSize||this.style&&this.style.fontSize;a=/px/.test(a)?h(a):/em/.test(a)?parseFloat(a)*(c?this.fontMetrics(null,c.parentNode).f:16):12;
c=24>a?a+3:Math.round(1.2*a);return{h:c,b:Math.round(.8*c),f:a}},rotCorr:function(a,h,c){var w=a;h&&c&&(w=Math.max(w*Math.cos(h*g),4));return{x:-a/3*Math.sin(h*g),y:w}},label:function(h,c,q,d,n,g,k,z,G){var x=this,H=x.g("button"!==G&&"label"),v=H.text=x.text("",0,0,k).attr({zIndex:1}),f,y,I=0,B=3,D=0,r,l,P,m,J,O={},L,u,N=/^url\((.*?)\)$/.test(d),K=N,U,T,Q,R;G&&H.addClass("highcharts-"+G);K=N;U=function(){return(L||0)%2/2};T=function(){var a=v.element.style,h={};y=(void 0===r||void 0===l||J)&&t(v.textStr)&&
v.getBBox();H.width=(r||y.width||0)+2*B+D;H.height=(l||y.height||0)+2*B;u=B+x.fontMetrics(a&&a.fontSize,v).b;K&&(f||(H.box=f=x.symbols[d]||N?x.symbol(d):x.rect(),f.addClass(("button"===G?"":"highcharts-label-box")+(G?" highcharts-"+G+"-box":"")),f.add(H),a=U(),h.x=a,h.y=(z?-u:0)+a),h.width=Math.round(H.width),h.height=Math.round(H.height),f.attr(e(h,O)),O={})};Q=function(){var a=D+B,h;h=z?0:u;t(r)&&y&&("center"===J||"right"===J)&&(a+={center:.5,right:1}[J]*(r-y.width));if(a!==v.x||h!==v.y)v.attr("x",
a),void 0!==h&&v.attr("y",h);v.x=a;v.y=h};R=function(a,h){f?f.attr(a,h):O[a]=h};H.onAdd=function(){v.add(H);H.attr({text:h||0===h?h:"",x:c,y:q});f&&t(n)&&H.attr({anchorX:n,anchorY:g})};H.widthSetter=function(h){r=a.isNumber(h)?h:null};H.heightSetter=function(a){l=a};H["text-alignSetter"]=function(a){J=a};H.paddingSetter=function(a){t(a)&&a!==B&&(B=H.padding=a,Q())};H.paddingLeftSetter=function(a){t(a)&&a!==D&&(D=a,Q())};H.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==I&&(I=a,y&&H.attr({x:P}))};
H.textSetter=function(a){void 0!==a&&v.textSetter(a);T();Q()};H["stroke-widthSetter"]=function(a,h){a&&(K=!0);L=this["stroke-width"]=a;R(h,a)};H.strokeSetter=H.fillSetter=H.rSetter=function(a,h){"r"!==h&&("fill"===h&&a&&(K=!0),H[h]=a);R(h,a)};H.anchorXSetter=function(a,h){n=H.anchorX=a;R(h,Math.round(a)-U()-P)};H.anchorYSetter=function(a,h){g=H.anchorY=a;R(h,a-m)};H.xSetter=function(a){H.x=a;I&&(a-=I*((r||y.width)+2*B));P=Math.round(a);H.attr("translateX",P)};H.ySetter=function(a){m=H.y=Math.round(a);
H.attr("translateY",m)};var V=H.css;return e(H,{css:function(a){if(a){var h={};a=p(a);b(H.textProps,function(c){void 0!==a[c]&&(h[c]=a[c],delete a[c])});v.css(h)}return V.call(H,a)},getBBox:function(){return{width:y.width+2*B,height:y.height+2*B,x:y.x-B,y:y.y-B}},shadow:function(a){a&&(T(),f&&f.shadow(a));return H},destroy:function(){w(H.element,"mouseenter");w(H.element,"mouseleave");v&&(v=v.destroy());f&&(f=f.destroy());C.prototype.destroy.call(H);H=x=T=Q=R=null}})}});a.Renderer=A})(M);(function(a){var C=
a.attr,A=a.createElement,F=a.css,E=a.defined,m=a.each,f=a.extend,l=a.isFirefox,r=a.isMS,u=a.isWebKit,t=a.pInt,g=a.SVGRenderer,d=a.win,k=a.wrap;f(a.SVGElement.prototype,{htmlCss:function(a){var b=this.element;if(b=a&&"SPAN"===b.tagName&&a.width)delete a.width,this.textWidth=b,this.updateTransform();a&&"ellipsis"===a.textOverflow&&(a.whiteSpace="nowrap",a.overflow="hidden");this.styles=f(this.styles,a);F(this.element,a);return this},htmlGetBBox:function(){var a=this.element;"text"===a.nodeName&&(a.style.position=
"absolute");return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,e=this.element,d=this.translateX||0,g=this.translateY||0,n=this.x||0,k=this.y||0,f=this.textAlign||"left",c={left:0,center:.5,right:1}[f],G=this.styles;F(e,{marginLeft:d,marginTop:g});this.shadows&&m(this.shadows,function(a){F(a,{marginLeft:d+1,marginTop:g+1})});this.inverted&&m(e.childNodes,function(c){a.invertChild(c,e)});if("SPAN"===e.tagName){var q=
this.rotation,B=t(this.textWidth),r=G&&G.whiteSpace,p=[q,f,e.innerHTML,this.textWidth,this.textAlign].join();p!==this.cTT&&(G=a.fontMetrics(e.style.fontSize).b,E(q)&&this.setSpanRotation(q,c,G),F(e,{width:"",whiteSpace:r||"nowrap"}),e.offsetWidth>B&&/[ \-]/.test(e.textContent||e.innerText)&&F(e,{width:B+"px",display:"block",whiteSpace:r||"normal"}),this.getSpanCorrection(e.offsetWidth,G,c,q,f));F(e,{left:n+(this.xCorr||0)+"px",top:k+(this.yCorr||0)+"px"});u&&(G=e.offsetHeight);this.cTT=p}}else this.alignOnAdd=
!0},setSpanRotation:function(a,e,g){var b={},n=r?"-ms-transform":u?"-webkit-transform":l?"MozTransform":d.opera?"-o-transform":"";b[n]=b.transform="rotate("+a+"deg)";b[n+(l?"Origin":"-origin")]=b.transformOrigin=100*e+"% "+g+"px";F(this.element,b)},getSpanCorrection:function(a,e,d){this.xCorr=-a*d;this.yCorr=-e}});f(g.prototype,{html:function(a,e,d){var b=this.createElement("span"),n=b.element,g=b.renderer,v=g.isSVG,c=function(a,c){m(["opacity","visibility"],function(q){k(a,q+"Setter",function(a,
p,q,b){a.call(this,p,q,b);c[q]=p})})};b.textSetter=function(a){a!==n.innerHTML&&delete this.bBox;n.innerHTML=this.textStr=a;b.htmlUpdateTransform()};v&&c(b,b.element.style);b.xSetter=b.ySetter=b.alignSetter=b.rotationSetter=function(a,c){"align"===c&&(c="textAlign");b[c]=a;b.htmlUpdateTransform()};b.attr({text:a,x:Math.round(e),y:Math.round(d)}).css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize,position:"absolute"});n.style.whiteSpace="nowrap";b.css=b.htmlCss;v&&(b.add=function(a){var q,
e=g.box.parentNode,d=[];if(this.parentGroup=a){if(q=a.div,!q){for(;a;)d.push(a),a=a.parentGroup;m(d.reverse(),function(a){var p,n=C(a.element,"class");n&&(n={className:n});q=a.div=a.div||A("div",n,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},q||e);p=q.style;f(a,{classSetter:function(a){this.element.setAttribute("class",a);q.className=a},on:function(){d[0].div&&b.on.apply({element:d[0].div},
arguments);return a},translateXSetter:function(c,h){p.left=c+"px";a[h]=c;a.doTransform=!0},translateYSetter:function(c,h){p.top=c+"px";a[h]=c;a.doTransform=!0}});c(a,p)})}}else q=e;q.appendChild(n);b.added=!0;b.alignOnAdd&&b.htmlUpdateTransform();return b});return b}})})(M);(function(a){var C,A,F=a.createElement,E=a.css,m=a.defined,f=a.deg2rad,l=a.discardElement,r=a.doc,u=a.each,t=a.erase,g=a.extend;C=a.extendClass;var d=a.isArray,k=a.isNumber,b=a.isObject,e=a.merge;A=a.noop;var v=a.pick,y=a.pInt,
n=a.SVGElement,D=a.SVGRenderer,J=a.win;a.svg||(A={docMode8:r&&8===r.documentMode,init:function(a,b){var c=["\x3c",b,' filled\x3d"f" stroked\x3d"f"'],e=["position: ","absolute",";"],d="div"===b;("shape"===b||d)&&e.push("left:0;top:0;width:1px;height:1px;");e.push("visibility: ",d?"hidden":"visible");c.push(' style\x3d"',e.join(""),'"/\x3e');b&&(c=d||"span"===b||"img"===b?c.join(""):a.prepVML(c),this.element=F(c));this.renderer=a},add:function(a){var c=this.renderer,b=this.element,e=c.box,d=a&&a.inverted,
e=a?a.element||a:e;a&&(this.parentGroup=a);d&&c.invertChild(b,e);e.appendChild(b);this.added=!0;this.alignOnAdd&&!this.deferUpdateTransform&&this.updateTransform();if(this.onAdd)this.onAdd();this.className&&this.attr("class",this.className);return this},updateTransform:n.prototype.htmlUpdateTransform,setSpanRotation:function(){var a=this.rotation,b=Math.cos(a*f),q=Math.sin(a*f);E(this.element,{filter:a?["progid:DXImageTransform.Microsoft.Matrix(M11\x3d",b,", M12\x3d",-q,", M21\x3d",q,", M22\x3d",
b,", sizingMethod\x3d'auto expand')"].join(""):"none"})},getSpanCorrection:function(a,b,q,e,d){var c=e?Math.cos(e*f):1,n=e?Math.sin(e*f):0,g=v(this.elemHeight,this.element.offsetHeight),k;this.xCorr=0>c&&-a;this.yCorr=0>n&&-g;k=0>c*n;this.xCorr+=n*b*(k?1-q:q);this.yCorr-=c*b*(e?k?q:1-q:1);d&&"left"!==d&&(this.xCorr-=a*q*(0>c?-1:1),e&&(this.yCorr-=g*q*(0>n?-1:1)),E(this.element,{textAlign:d}))},pathToVML:function(a){for(var c=a.length,b=[];c--;)k(a[c])?b[c]=Math.round(10*a[c])-5:"Z"===a[c]?b[c]="x":
(b[c]=a[c],!a.isArc||"wa"!==a[c]&&"at"!==a[c]||(b[c+5]===b[c+7]&&(b[c+7]+=a[c+7]>a[c+5]?1:-1),b[c+6]===b[c+8]&&(b[c+8]+=a[c+8]>a[c+6]?1:-1)));return b.join(" ")||"x"},clip:function(a){var c=this,b;a?(b=a.members,t(b,c),b.push(c),c.destroyClip=function(){t(b,c)},a=a.getCSS(c)):(c.destroyClip&&c.destroyClip(),a={clip:c.docMode8?"inherit":"rect(auto)"});return c.css(a)},css:n.prototype.htmlCss,safeRemoveChild:function(a){a.parentNode&&l(a)},destroy:function(){this.destroyClip&&this.destroyClip();return n.prototype.destroy.apply(this)},
on:function(a,b){this.element["on"+a]=function(){var a=J.event;a.target=a.srcElement;b(a)};return this},cutOffPath:function(a,b){var c;a=a.split(/[ ,]/);c=a.length;if(9===c||11===c)a[c-4]=a[c-2]=y(a[c-2])-10*b;return a.join(" ")},shadow:function(a,b,e){var c=[],q,p=this.element,d=this.renderer,n,g=p.style,h,w=p.path,k,H,f,D;w&&"string"!==typeof w.value&&(w="x");H=w;if(a){f=v(a.width,3);D=(a.opacity||.15)/f;for(q=1;3>=q;q++)k=2*f+1-2*q,e&&(H=this.cutOffPath(w.value,k+.5)),h=['\x3cshape isShadow\x3d"true" strokeweight\x3d"',
k,'" filled\x3d"false" path\x3d"',H,'" coordsize\x3d"10 10" style\x3d"',p.style.cssText,'" /\x3e'],n=F(d.prepVML(h),null,{left:y(g.left)+v(a.offsetX,1),top:y(g.top)+v(a.offsetY,1)}),e&&(n.cutOff=k+1),h=['\x3cstroke color\x3d"',a.color||"#000000",'" opacity\x3d"',D*q,'"/\x3e'],F(d.prepVML(h),null,null,n),b?b.element.appendChild(n):p.parentNode.insertBefore(n,p),c.push(n);this.shadows=c}return this},updateShadows:A,setAttr:function(a,b){this.docMode8?this.element[a]=b:this.element.setAttribute(a,b)},
classSetter:function(a){(this.added?this.element:this).className=a},dashstyleSetter:function(a,b,e){(e.getElementsByTagName("stroke")[0]||F(this.renderer.prepVML(["\x3cstroke/\x3e"]),null,null,e))[b]=a||"solid";this[b]=a},dSetter:function(a,b,e){var c=this.shadows;a=a||[];this.d=a.join&&a.join(" ");e.path=a=this.pathToVML(a);if(c)for(e=c.length;e--;)c[e].path=c[e].cutOff?this.cutOffPath(a,c[e].cutOff):a;this.setAttr(b,a)},fillSetter:function(a,b,e){var c=e.nodeName;"SPAN"===c?e.style.color=a:"IMG"!==
c&&(e.filled="none"!==a,this.setAttr("fillcolor",this.renderer.color(a,e,b,this)))},"fill-opacitySetter":function(a,b,e){F(this.renderer.prepVML(["\x3c",b.split("-")[0],' opacity\x3d"',a,'"/\x3e']),null,null,e)},opacitySetter:A,rotationSetter:function(a,b,e){e=e.style;this[b]=e[b]=a;e.left=-Math.round(Math.sin(a*f)+1)+"px";e.top=Math.round(Math.cos(a*f))+"px"},strokeSetter:function(a,b,e){this.setAttr("strokecolor",this.renderer.color(a,e,b,this))},"stroke-widthSetter":function(a,b,e){e.stroked=!!a;
this[b]=a;k(a)&&(a+="px");this.setAttr("strokeweight",a)},titleSetter:function(a,b){this.setAttr(b,a)},visibilitySetter:function(a,b,e){"inherit"===a&&(a="visible");this.shadows&&u(this.shadows,function(c){c.style[b]=a});"DIV"===e.nodeName&&(a="hidden"===a?"-999em":0,this.docMode8||(e.style[b]=a?"visible":"hidden"),b="top");e.style[b]=a},xSetter:function(a,b,e){this[b]=a;"x"===b?b="left":"y"===b&&(b="top");this.updateClipping?(this[b]=a,this.updateClipping()):e.style[b]=a},zIndexSetter:function(a,
b,e){e.style[b]=a}},A["stroke-opacitySetter"]=A["fill-opacitySetter"],a.VMLElement=A=C(n,A),A.prototype.ySetter=A.prototype.widthSetter=A.prototype.heightSetter=A.prototype.xSetter,A={Element:A,isIE8:-1<J.navigator.userAgent.indexOf("MSIE 8.0"),init:function(a,b,e){var c,d;this.alignedObjects=[];c=this.createElement("div").css({position:"relative"});d=c.element;a.appendChild(c.element);this.isVML=!0;this.box=d;this.boxWrapper=c;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(b,
e,!1);if(!r.namespaces.hcv){r.namespaces.add("hcv","urn:schemas-microsoft-com:vml");try{r.createStyleSheet().cssText="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}catch(p){r.styleSheets[0].cssText+="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}}},isHidden:function(){return!this.box.offsetWidth},clipRect:function(a,e,d,n){var c=this.createElement(),p=b(a);return g(c,{members:[],
count:0,left:(p?a.x:a)+1,top:(p?a.y:e)+1,width:(p?a.width:d)-1,height:(p?a.height:n)-1,getCSS:function(a){var c=a.element,b=c.nodeName,h=a.inverted,w=this.top-("shape"===b?c.offsetTop:0),p=this.left,c=p+this.width,e=w+this.height,w={clip:"rect("+Math.round(h?p:w)+"px,"+Math.round(h?e:c)+"px,"+Math.round(h?c:e)+"px,"+Math.round(h?w:p)+"px)"};!h&&a.docMode8&&"DIV"===b&&g(w,{width:c+"px",height:e+"px"});return w},updateClipping:function(){u(c.members,function(a){a.element&&a.css(c.getCSS(a))})}})},color:function(c,
b,e,d){var q=this,p,n=/^rgba/,g,k,h="none";c&&c.linearGradient?k="gradient":c&&c.radialGradient&&(k="pattern");if(k){var w,v,H=c.linearGradient||c.radialGradient,f,D,y,x,r,B="";c=c.stops;var l,G=[],m=function(){g=['\x3cfill colors\x3d"'+G.join(",")+'" opacity\x3d"',y,'" o:opacity2\x3d"',D,'" type\x3d"',k,'" ',B,'focus\x3d"100%" method\x3d"any" /\x3e'];F(q.prepVML(g),null,null,b)};f=c[0];l=c[c.length-1];0<f[0]&&c.unshift([0,f[1]]);1>l[0]&&c.push([1,l[1]]);u(c,function(h,c){n.test(h[1])?(p=a.color(h[1]),
w=p.get("rgb"),v=p.get("a")):(w=h[1],v=1);G.push(100*h[0]+"% "+w);c?(y=v,x=w):(D=v,r=w)});if("fill"===e)if("gradient"===k)e=H.x1||H[0]||0,c=H.y1||H[1]||0,f=H.x2||H[2]||0,H=H.y2||H[3]||0,B='angle\x3d"'+(90-180*Math.atan((H-c)/(f-e))/Math.PI)+'"',m();else{var h=H.r,t=2*h,J=2*h,A=H.cx,C=H.cy,E=b.radialReference,M,h=function(){E&&(M=d.getBBox(),A+=(E[0]-M.x)/M.width-.5,C+=(E[1]-M.y)/M.height-.5,t*=E[2]/M.width,J*=E[2]/M.height);B='src\x3d"'+a.getOptions().global.VMLRadialGradientURL+'" size\x3d"'+t+","+
J+'" origin\x3d"0.5,0.5" position\x3d"'+A+","+C+'" color2\x3d"'+r+'" ';m()};d.added?h():d.onAdd=h;h=x}else h=w}else n.test(c)&&"IMG"!==b.tagName?(p=a.color(c),d[e+"-opacitySetter"](p.get("a"),e,b),h=p.get("rgb")):(h=b.getElementsByTagName(e),h.length&&(h[0].opacity=1,h[0].type="solid"),h=c);return h},prepVML:function(a){var c=this.isIE8;a=a.join("");c?(a=a.replace("/\x3e",' xmlns\x3d"urn:schemas-microsoft-com:vml" /\x3e'),a=-1===a.indexOf('style\x3d"')?a.replace("/\x3e",' style\x3d"display:inline-block;behavior:url(#default#VML);" /\x3e'):
a.replace('style\x3d"','style\x3d"display:inline-block;behavior:url(#default#VML);')):a=a.replace("\x3c","\x3chcv:");return a},text:D.prototype.html,path:function(a){var c={coordsize:"10 10"};d(a)?c.d=a:b(a)&&g(c,a);return this.createElement("shape").attr(c)},circle:function(a,e,d){var c=this.symbol("circle");b(a)&&(d=a.r,e=a.y,a=a.x);c.isCircle=!0;c.r=d;return c.attr({x:a,y:e})},g:function(a){var c;a&&(c={className:"highcharts-"+a,"class":"highcharts-"+a});return this.createElement("div").attr(c)},
image:function(a,b,e,d,n){var c=this.createElement("img").attr({src:a});1<arguments.length&&c.attr({x:b,y:e,width:d,height:n});return c},createElement:function(a){return"rect"===a?this.symbol(a):D.prototype.createElement.call(this,a)},invertChild:function(a,b){var c=this;b=b.style;var e="IMG"===a.tagName&&a.style;E(a,{flip:"x",left:y(b.width)-(e?y(e.top):1),top:y(b.height)-(e?y(e.left):1),rotation:-90});u(a.childNodes,function(b){c.invertChild(b,a)})},symbols:{arc:function(a,b,e,d,n){var c=n.start,
q=n.end,g=n.r||e||d;e=n.innerR;d=Math.cos(c);var k=Math.sin(c),h=Math.cos(q),w=Math.sin(q);if(0===q-c)return["x"];c=["wa",a-g,b-g,a+g,b+g,a+g*d,b+g*k,a+g*h,b+g*w];n.open&&!e&&c.push("e","M",a,b);c.push("at",a-e,b-e,a+e,b+e,a+e*h,b+e*w,a+e*d,b+e*k,"x","e");c.isArc=!0;return c},circle:function(a,b,e,d,n){n&&m(n.r)&&(e=d=2*n.r);n&&n.isCircle&&(a-=e/2,b-=d/2);return["wa",a,b,a+e,b+d,a+e,b+d/2,a+e,b+d/2,"e"]},rect:function(a,b,e,d,n){return D.prototype.symbols[m(n)&&n.r?"callout":"square"].call(0,a,b,
e,d,n)}}},a.VMLRenderer=C=function(){this.init.apply(this,arguments)},C.prototype=e(D.prototype,A),a.Renderer=C);D.prototype.measureSpanWidth=function(a,b){var c=r.createElement("span");a=r.createTextNode(a);c.appendChild(a);E(c,b);this.box.appendChild(c);b=c.offsetWidth;l(c);return b}})(M);(function(a){function C(){var f=a.defaultOptions.global,l=r.moment;if(f.timezone){if(l)return function(a){return-l.tz(a,f.timezone).utcOffset()};a.error(25)}return f.useUTC&&f.getTimezoneOffset}function A(){var f=
a.defaultOptions.global,t,g=f.useUTC,d=g?"getUTC":"get",k=g?"setUTC":"set";a.Date=t=f.Date||r.Date;t.hcTimezoneOffset=g&&f.timezoneOffset;t.hcGetTimezoneOffset=C();t.hcMakeTime=function(a,e,d,k,n,f){var b;g?(b=t.UTC.apply(0,arguments),b+=m(b)):b=(new t(a,e,l(d,1),l(k,0),l(n,0),l(f,0))).getTime();return b};E("Minutes Hours Day Date Month FullYear".split(" "),function(a){t["hcGet"+a]=d+a});E("Milliseconds Seconds Minutes Hours Date Month FullYear".split(" "),function(a){t["hcSet"+a]=k+a})}var F=a.color,
E=a.each,m=a.getTZOffset,f=a.merge,l=a.pick,r=a.win;a.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{useUTC:!0,VMLRadialGradientURL:"http://code.highcharts.com/5.0.14/gfx/vml-radial-gradient.png"},chart:{borderRadius:0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:20},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",
align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},
shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:a.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",
day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,backgroundColor:F("#f7f7f7").setOpacity(.85).get(),borderWidth:1,headerFormat:'\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",
whiteSpace:"nowrap"}},credits:{enabled:!0,href:"http://www.highcharts.com",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};a.setOptions=function(r){a.defaultOptions=f(!0,a.defaultOptions,r);A();return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};a.defaultPlotOptions=a.defaultOptions.plotOptions;A()})(M);(function(a){var C=a.correctFloat,A=a.defined,F=a.destroyObjectProperties,E=a.isNumber,
m=a.merge,f=a.pick,l=a.deg2rad;a.Tick=function(a,f,l,g){this.axis=a;this.pos=f;this.type=l||"";this.isNewLabel=this.isNew=!0;l||g||this.addLabel()};a.Tick.prototype={addLabel:function(){var a=this.axis,l=a.options,t=a.chart,g=a.categories,d=a.names,k=this.pos,b=l.labels,e=a.tickPositions,v=k===e[0],y=k===e[e.length-1],d=g?f(g[k],d[k],k):k,g=this.label,e=e.info,n;a.isDatetimeAxis&&e&&(n=l.dateTimeLabelFormats[e.higherRanks[k]||e.unitName]);this.isFirst=v;this.isLast=y;l=a.labelFormatter.call({axis:a,
chart:t,isFirst:v,isLast:y,dateTimeLabelFormat:n,value:a.isLog?C(a.lin2log(d)):d,pos:k});A(g)?g&&g.attr({text:l}):(this.labelLength=(this.label=g=A(l)&&b.enabled?t.renderer.text(l,0,0,b.useHTML).css(m(b.style)).add(a.labelGroup):null)&&g.getBBox().width,this.rotation=0)},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var r=this.axis,m=a.x,g=r.chart.chartWidth,d=r.chart.spacing,k=f(r.labelLeft,Math.min(r.pos,d[3])),d=f(r.labelRight,
Math.max(r.pos+r.len,g-d[1])),b=this.label,e=this.rotation,v={left:0,center:.5,right:1}[r.labelAlign],y=b.getBBox().width,n=r.getSlotWidth(),D=n,J=1,c,G={};if(e)0>e&&m-v*y<k?c=Math.round(m/Math.cos(e*l)-k):0<e&&m+v*y>d&&(c=Math.round((g-m)/Math.cos(e*l)));else if(g=m+(1-v)*y,m-v*y<k?D=a.x+D*(1-v)-k:g>d&&(D=d-a.x+D*v,J=-1),D=Math.min(n,D),D<n&&"center"===r.labelAlign&&(a.x+=J*(n-D-v*(n-Math.min(y,D)))),y>D||r.autoRotation&&(b.styles||{}).width)c=D;c&&(G.width=c,(r.options.labels.style||{}).textOverflow||
(G.textOverflow="ellipsis"),b.css(G))},getPosition:function(a,f,l,g){var d=this.axis,k=d.chart,b=g&&k.oldChartHeight||k.chartHeight;return{x:a?d.translate(f+l,null,null,g)+d.transB:d.left+d.offset+(d.opposite?(g&&k.oldChartWidth||k.chartWidth)-d.right-d.left:0),y:a?b-d.bottom+d.offset-(d.opposite?d.height:0):b-d.translate(f+l,null,null,g)-d.transB}},getLabelPosition:function(a,f,m,g,d,k,b,e){var v=this.axis,y=v.transA,n=v.reversed,D=v.staggerLines,r=v.tickRotCorr||{x:0,y:0},c=d.y;A(c)||(c=0===v.side?
m.rotation?-8:-m.getBBox().height:2===v.side?r.y+8:Math.cos(m.rotation*l)*(r.y-m.getBBox(!1,0).height/2));a=a+d.x+r.x-(k&&g?k*y*(n?-1:1):0);f=f+c-(k&&!g?k*y*(n?1:-1):0);D&&(m=b/(e||1)%D,v.opposite&&(m=D-m-1),f+=v.labelOffset/D*m);return{x:a,y:Math.round(f)}},getMarkPath:function(a,f,l,g,d,k){return k.crispLine(["M",a,f,"L",a+(d?0:-l),f+(d?l:0)],g)},renderGridLine:function(a,f,l){var g=this.axis,d=g.options,k=this.gridLine,b={},e=this.pos,v=this.type,y=g.tickmarkOffset,n=g.chart.renderer,D=v?v+"Grid":
"grid",r=d[D+"LineWidth"],c=d[D+"LineColor"],d=d[D+"LineDashStyle"];k||(b.stroke=c,b["stroke-width"]=r,d&&(b.dashstyle=d),v||(b.zIndex=1),a&&(b.opacity=0),this.gridLine=k=n.path().attr(b).addClass("highcharts-"+(v?v+"-":"")+"grid-line").add(g.gridGroup));if(!a&&k&&(a=g.getPlotLinePath(e+y,k.strokeWidth()*l,a,!0)))k[this.isNew?"attr":"animate"]({d:a,opacity:f})},renderMark:function(a,l,m){var g=this.axis,d=g.options,k=g.chart.renderer,b=this.type,e=b?b+"Tick":"tick",v=g.tickSize(e),y=this.mark,n=!y,
D=a.x;a=a.y;var r=f(d[e+"Width"],!b&&g.isXAxis?1:0),d=d[e+"Color"];v&&(g.opposite&&(v[0]=-v[0]),n&&(this.mark=y=k.path().addClass("highcharts-"+(b?b+"-":"")+"tick").add(g.axisGroup),y.attr({stroke:d,"stroke-width":r})),y[n?"attr":"animate"]({d:this.getMarkPath(D,a,v[0],y.strokeWidth()*m,g.horiz,k),opacity:l}))},renderLabel:function(a,l,m,g){var d=this.axis,k=d.horiz,b=d.options,e=this.label,v=b.labels,y=v.step,n=d.tickmarkOffset,D=!0,r=a.x;a=a.y;e&&E(r)&&(e.xy=a=this.getLabelPosition(r,a,e,k,v,n,
g,y),this.isFirst&&!this.isLast&&!f(b.showFirstLabel,1)||this.isLast&&!this.isFirst&&!f(b.showLastLabel,1)?D=!1:!k||d.isRadial||v.step||v.rotation||l||0===m||this.handleOverflow(a),y&&g%y&&(D=!1),D&&E(a.y)?(a.opacity=m,e[this.isNewLabel?"attr":"animate"](a),this.isNewLabel=!1):(e.attr("y",-9999),this.isNewLabel=!0),this.isNew=!1)},render:function(a,l,m){var g=this.axis,d=g.horiz,k=this.getPosition(d,this.pos,g.tickmarkOffset,l),b=k.x,e=k.y,g=d&&b===g.pos+g.len||!d&&e===g.pos?-1:1;m=f(m,1);this.isActive=
!0;this.renderGridLine(l,m,g);this.renderMark(k,m,g);this.renderLabel(k,l,m,a)},destroy:function(){F(this,this.axis)}}})(M);var S=function(a){var C=a.addEvent,A=a.animObject,F=a.arrayMax,E=a.arrayMin,m=a.color,f=a.correctFloat,l=a.defaultOptions,r=a.defined,u=a.deg2rad,t=a.destroyObjectProperties,g=a.each,d=a.extend,k=a.fireEvent,b=a.format,e=a.getMagnitude,v=a.grep,y=a.inArray,n=a.isArray,D=a.isNumber,J=a.isString,c=a.merge,G=a.normalizeTickInterval,q=a.objectEach,B=a.pick,K=a.removeEvent,p=a.splat,
z=a.syncTimeout,I=a.Tick,L=function(){this.init.apply(this,arguments)};a.extend(L.prototype,{defaultOptions:{dateTimeLabelFormats:{millisecond:"%H:%M:%S.%L",second:"%H:%M:%S",minute:"%H:%M",hour:"%H:%M",day:"%e. %b",week:"%e. %b",month:"%b '%y",year:"%Y"},endOnTick:!1,labels:{enabled:!0,style:{color:"#666666",cursor:"default",fontSize:"11px"},x:0},minPadding:.01,maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",startOfWeek:1,startOnTick:!1,tickLength:10,tickmarkPlacement:"between",tickPixelInterval:100,
tickPosition:"outside",title:{align:"middle",style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},maxPadding:.05,minPadding:.05,startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,formatter:function(){return a.numberFormat(this.total,-1)},
style:{fontSize:"11px",fontWeight:"bold",color:"#000000",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},init:function(a,c){var h=c.isX,b=this;b.chart=a;b.horiz=a.inverted&&!b.isZAxis?!h:h;b.isXAxis=h;b.coll=b.coll||(h?
"xAxis":"yAxis");b.opposite=c.opposite;b.side=c.side||(b.horiz?b.opposite?0:2:b.opposite?1:3);b.setOptions(c);var w=this.options,e=w.type;b.labelFormatter=w.labels.formatter||b.defaultLabelFormatter;b.userOptions=c;b.minPixelPadding=0;b.reversed=w.reversed;b.visible=!1!==w.visible;b.zoomEnabled=!1!==w.zoomEnabled;b.hasNames="category"===e||!0===w.categories;b.categories=w.categories||b.hasNames;b.names=b.names||[];b.plotLinesAndBandsGroups={};b.isLog="logarithmic"===e;b.isDatetimeAxis="datetime"===
e;b.positiveValuesOnly=b.isLog&&!b.allowNegativeLog;b.isLinked=r(w.linkedTo);b.ticks={};b.labelEdge=[];b.minorTicks={};b.plotLinesAndBands=[];b.alternateBands={};b.len=0;b.minRange=b.userMinRange=w.minRange||w.maxZoom;b.range=w.range;b.offset=w.offset||0;b.stacks={};b.oldStacks={};b.stacksTouched=0;b.max=null;b.min=null;b.crosshair=B(w.crosshair,p(a.options.tooltip.crosshairs)[h?0:1],!1);c=b.options.events;-1===y(b,a.axes)&&(h?a.axes.splice(a.xAxis.length,0,b):a.axes.push(b),a[b.coll].push(b));b.series=
b.series||[];a.inverted&&!b.isZAxis&&h&&void 0===b.reversed&&(b.reversed=!0);q(c,function(a,h){C(b,h,a)});b.lin2log=w.linearToLogConverter||b.lin2log;b.isLog&&(b.val2lin=b.log2lin,b.lin2val=b.lin2log)},setOptions:function(a){this.options=c(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],c(l[this.coll],a))},defaultLabelFormatter:function(){var h=this.axis,
c=this.value,e=h.categories,p=this.dateTimeLabelFormat,d=l.lang,n=d.numericSymbols,d=d.numericSymbolMagnitude||1E3,q=n&&n.length,x,g=h.options.labels.format,h=h.isLog?Math.abs(c):h.tickInterval;if(g)x=b(g,this);else if(e)x=c;else if(p)x=a.dateFormat(p,c);else if(q&&1E3<=h)for(;q--&&void 0===x;)e=Math.pow(d,q+1),h>=e&&0===10*c%e&&null!==n[q]&&0!==c&&(x=a.numberFormat(c/e,-1)+n[q]);void 0===x&&(x=1E4<=Math.abs(c)?a.numberFormat(c,-1):a.numberFormat(c,-1,void 0,""));return x},getSeriesExtremes:function(){var a=
this,b=a.chart;a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();g(a.series,function(h){if(h.visible||!b.options.chart.ignoreHiddenSeries){var c=h.options,w=c.threshold,e;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=w&&(w=null);if(a.isXAxis)c=h.xData,c.length&&(h=E(c),D(h)||h instanceof Date||(c=v(c,function(a){return D(a)}),h=E(c)),a.dataMin=Math.min(B(a.dataMin,c[0]),h),a.dataMax=Math.max(B(a.dataMax,c[0]),F(c)));else if(h.getExtremes(),
e=h.dataMax,h=h.dataMin,r(h)&&r(e)&&(a.dataMin=Math.min(B(a.dataMin,h),h),a.dataMax=Math.max(B(a.dataMax,e),e)),r(w)&&(a.threshold=w),!c.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})},translate:function(a,b,c,e,p,d){var h=this.linkedParent||this,w=1,n=0,q=e?h.oldTransA:h.transA;e=e?h.oldMin:h.min;var g=h.minPixelPadding;p=(h.isOrdinal||h.isBroken||h.isLog&&p)&&h.lin2val;q||(q=h.transA);c&&(w*=-1,n=h.len);h.reversed&&(w*=-1,n-=w*(h.sector||h.len));b?(a=(a*w+n-g)/q+e,p&&(a=h.lin2val(a))):
(p&&(a=h.val2lin(a)),a=w*(a-e)*q+n+w*g+(D(d)?q*d:0));return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,c,e,p){var h=this.chart,w=this.left,d=this.top,n,q,g=c&&h.oldChartHeight||h.chartHeight,k=c&&h.oldChartWidth||h.chartWidth,f;n=this.transB;var v=function(a,h,b){if(a<h||a>b)e?a=Math.min(Math.max(h,a),b):f=!0;return a};p=B(p,this.translate(a,
null,null,c));a=c=Math.round(p+n);n=q=Math.round(g-p-n);D(p)?this.horiz?(n=d,q=g-this.bottom,a=c=v(a,w,w+this.width)):(a=w,c=k-this.right,n=q=v(n,d,d+this.height)):f=!0;return f&&!e?null:h.renderer.crispLine(["M",a,n,"L",c,q],b||1)},getLinearTickPositions:function(a,b,c){var h,w=f(Math.floor(b/a)*a);c=f(Math.ceil(c/a)*a);var e=[];if(this.single)return[b];for(b=w;b<=c;){e.push(b);b=f(b+a);if(b===h)break;h=b}return e},getMinorTickPositions:function(){var a=this,b=a.options,c=a.tickPositions,e=a.minorTickInterval,
p=[],d=a.pointRangePadding||0,n=a.min-d,d=a.max+d,q=d-n;if(q&&q/e<a.len/3)if(a.isLog)g(this.paddedTicks,function(h,b,c){b&&p.push.apply(p,a.getLogTickPositions(e,c[b-1],c[b],!0))});else if(a.isDatetimeAxis&&"auto"===b.minorTickInterval)p=p.concat(a.getTimeTicks(a.normalizeTimeTickInterval(e),n,d,b.startOfWeek));else for(b=n+(c[0]-n)%e;b<=d&&b!==p[0];b+=e)p.push(b);0!==p.length&&a.trimTicks(p);return p},adjustForMinRange:function(){var a=this.options,b=this.min,c=this.max,e,p,d,n,q,k,f,v;this.isXAxis&&
void 0===this.minRange&&!this.isLog&&(r(a.min)||r(a.max)?this.minRange=null:(g(this.series,function(a){k=a.xData;for(n=f=a.xIncrement?1:k.length-1;0<n;n--)if(q=k[n]-k[n-1],void 0===d||q<d)d=q}),this.minRange=Math.min(5*d,this.dataMax-this.dataMin)));c-b<this.minRange&&(p=this.dataMax-this.dataMin>=this.minRange,v=this.minRange,e=(v-c+b)/2,e=[b-e,B(a.min,b-e)],p&&(e[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),b=F(e),c=[b+v,B(a.max,b+v)],p&&(c[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),
c=E(c),c-b<v&&(e[0]=c-v,e[1]=B(a.min,c-v),b=F(e)));this.min=b;this.max=c},getClosest:function(){var a;this.categories?a=1:g(this.series,function(h){var b=h.closestPointRange,c=h.visible||!h.chart.options.chart.ignoreHiddenSeries;!h.noSharedTooltip&&r(b)&&c&&(a=r(a)?Math.min(a,b):b)});return a},nameToX:function(a){var h=n(this.categories),b=h?this.categories:this.names,c=a.options.x,e;a.series.requireSorting=!1;r(c)||(c=!1===this.options.uniqueNames?a.series.autoIncrement():y(a.name,b));-1===c?h||
(e=b.length):e=c;void 0!==e&&(this.names[e]=a.name);return e},updateNames:function(){var a=this;0<this.names.length&&(this.names.length=0,this.minRange=this.userMinRange,g(this.series||[],function(h){h.xIncrement=null;if(!h.points||h.isDirtyData)h.processData(),h.generatePoints();g(h.points,function(b,c){var e;b.options&&(e=a.nameToX(b),void 0!==e&&e!==b.x&&(b.x=e,h.xData[c]=e))})}))},setAxisTranslation:function(a){var h=this,b=h.max-h.min,c=h.axisPointRange||0,e,p=0,d=0,n=h.linkedParent,q=!!h.categories,
k=h.transA,f=h.isXAxis;if(f||q||c)e=h.getClosest(),n?(p=n.minPointOffset,d=n.pointRangePadding):g(h.series,function(a){var b=q?1:f?B(a.options.pointRange,e,0):h.axisPointRange||0;a=a.options.pointPlacement;c=Math.max(c,b);h.single||(p=Math.max(p,J(a)?0:b/2),d=Math.max(d,"on"===a?0:b))}),n=h.ordinalSlope&&e?h.ordinalSlope/e:1,h.minPointOffset=p*=n,h.pointRangePadding=d*=n,h.pointRange=Math.min(c,b),f&&(h.closestPointRange=e);a&&(h.oldTransA=k);h.translationSlope=h.transA=k=h.options.staticScale||h.len/
(b+d||1);h.transB=h.horiz?h.left:h.bottom;h.minPixelPadding=k*p},minFromRange:function(){return this.max-this.range},setTickInterval:function(h){var b=this,c=b.chart,p=b.options,d=b.isLog,n=b.log2lin,q=b.isDatetimeAxis,x=b.isXAxis,v=b.isLinked,z=p.maxPadding,y=p.minPadding,l=p.tickInterval,I=p.tickPixelInterval,m=b.categories,J=b.threshold,t=b.softThreshold,L,u,K,A;q||m||v||this.getTickAmount();K=B(b.userMin,p.min);A=B(b.userMax,p.max);v?(b.linkedParent=c[b.coll][p.linkedTo],c=b.linkedParent.getExtremes(),
b.min=B(c.min,c.dataMin),b.max=B(c.max,c.dataMax),p.type!==b.linkedParent.options.type&&a.error(11,1)):(!t&&r(J)&&(b.dataMin>=J?(L=J,y=0):b.dataMax<=J&&(u=J,z=0)),b.min=B(K,L,b.dataMin),b.max=B(A,u,b.dataMax));d&&(b.positiveValuesOnly&&!h&&0>=Math.min(b.min,B(b.dataMin,b.min))&&a.error(10,1),b.min=f(n(b.min),15),b.max=f(n(b.max),15));b.range&&r(b.max)&&(b.userMin=b.min=K=Math.max(b.dataMin,b.minFromRange()),b.userMax=A=b.max,b.range=null);k(b,"foundExtremes");b.beforePadding&&b.beforePadding();b.adjustForMinRange();
!(m||b.axisPointRange||b.usePercentage||v)&&r(b.min)&&r(b.max)&&(n=b.max-b.min)&&(!r(K)&&y&&(b.min-=n*y),!r(A)&&z&&(b.max+=n*z));D(p.softMin)&&(b.min=Math.min(b.min,p.softMin));D(p.softMax)&&(b.max=Math.max(b.max,p.softMax));D(p.floor)&&(b.min=Math.max(b.min,p.floor));D(p.ceiling)&&(b.max=Math.min(b.max,p.ceiling));t&&r(b.dataMin)&&(J=J||0,!r(K)&&b.min<J&&b.dataMin>=J?b.min=J:!r(A)&&b.max>J&&b.dataMax<=J&&(b.max=J));b.tickInterval=b.min===b.max||void 0===b.min||void 0===b.max?1:v&&!l&&I===b.linkedParent.options.tickPixelInterval?
l=b.linkedParent.tickInterval:B(l,this.tickAmount?(b.max-b.min)/Math.max(this.tickAmount-1,1):void 0,m?1:(b.max-b.min)*I/Math.max(b.len,I));x&&!h&&g(b.series,function(a){a.processData(b.min!==b.oldMin||b.max!==b.oldMax)});b.setAxisTranslation(!0);b.beforeSetTickPositions&&b.beforeSetTickPositions();b.postProcessTickInterval&&(b.tickInterval=b.postProcessTickInterval(b.tickInterval));b.pointRange&&!l&&(b.tickInterval=Math.max(b.pointRange,b.tickInterval));h=B(p.minTickInterval,b.isDatetimeAxis&&b.closestPointRange);
!l&&b.tickInterval<h&&(b.tickInterval=h);q||d||l||(b.tickInterval=G(b.tickInterval,null,e(b.tickInterval),B(p.allowDecimals,!(.5<b.tickInterval&&5>b.tickInterval&&1E3<b.max&&9999>b.max)),!!this.tickAmount));this.tickAmount||(b.tickInterval=b.unsquish());this.setTickPositions()},setTickPositions:function(){var a=this.options,b,c=a.tickPositions,e=a.tickPositioner,p=a.startOnTick,d=a.endOnTick;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval=
"auto"===a.minorTickInterval&&this.tickInterval?this.tickInterval/5:a.minorTickInterval;this.single=this.min===this.max&&r(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==a.allowDecimals);this.tickPositions=b=c&&c.slice();!b&&(b=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,
this.min,this.max),b.length>this.len&&(b=[b[0],b.pop()]),this.tickPositions=b,e&&(e=e.apply(this,[this.min,this.max])))&&(this.tickPositions=b=e);this.paddedTicks=b.slice(0);this.trimTicks(b,p,d);this.isLinked||(this.single&&2>b.length&&(this.min-=.5,this.max+=.5),c||e||this.adjustTickAmount())},trimTicks:function(a,b,c){var h=a[0],e=a[a.length-1],p=this.minPointOffset||0;if(!this.isLinked){if(b&&-Infinity!==h)this.min=h;else for(;this.min-p>a[0];)a.shift();if(c)this.max=e;else for(;this.max+p<a[a.length-
1];)a.pop();0===a.length&&r(h)&&a.push((e+h)/2)}},alignToOthers:function(){var a={},b,c=this.options;!1===this.chart.options.chart.alignTicks||!1===c.alignTicks||this.isLog||g(this.chart[this.coll],function(h){var c=h.options,c=[h.horiz?c.left:c.top,c.width,c.height,c.pane].join();h.series.length&&(a[c]?b=!0:a[c]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,c=a.tickPixelInterval;!r(a.tickInterval)&&this.len<c&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=
2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/c)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.tickInterval,b=this.tickPositions,c=this.tickAmount,e=this.finalTickAmt,p=b&&b.length;if(p<c){for(;b.length<c;)b.push(f(b[b.length-1]+a));this.transA*=(p-1)/(c-1);this.max=b[b.length-1]}else p>c&&(this.tickInterval*=2,this.setTickPositions());if(r(e)){for(a=c=b.length;a--;)(3===e&&1===a%2||2>=e&&0<a&&a<c-1)&&b.splice(a,1);this.finalTickAmt=void 0}},setScale:function(){var a,
b;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();b=this.len!==this.oldAxisLength;g(this.series,function(b){if(b.isDirtyData||b.isDirty||b.xAxis.isDirty)a=!0});b||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||
(this.isDirty=b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks()},setExtremes:function(a,b,c,e,p){var h=this,n=h.chart;c=B(c,!0);g(h.series,function(a){delete a.kdTree});p=d(p,{min:a,max:b});k(h,"setExtremes",p,function(){h.userMin=a;h.userMax=b;h.eventArgs=p;c&&n.redraw(e)})},zoom:function(a,b){var h=this.dataMin,c=this.dataMax,e=this.options,p=Math.min(h,B(e.min,h)),e=Math.max(c,B(e.max,c));if(a!==this.min||b!==this.max)this.allowZoomOutside||(r(h)&&(a<p&&(a=
p),a>e&&(a=e)),r(c)&&(b<p&&(b=p),b>e&&(b=e))),this.displayBtn=void 0!==a||void 0!==b,this.setExtremes(a,b,!1,void 0,{trigger:"zoom"});return!0},setAxisSize:function(){var b=this.chart,c=this.options,e=c.offsets||[0,0,0,0],p=this.horiz,d=this.width=Math.round(a.relativeLength(B(c.width,b.plotWidth-e[3]+e[1]),b.plotWidth)),n=this.height=Math.round(a.relativeLength(B(c.height,b.plotHeight-e[0]+e[2]),b.plotHeight)),q=this.top=Math.round(a.relativeLength(B(c.top,b.plotTop+e[0]),b.plotHeight,b.plotTop)),
c=this.left=Math.round(a.relativeLength(B(c.left,b.plotLeft+e[3]),b.plotWidth,b.plotLeft));this.bottom=b.chartHeight-n-q;this.right=b.chartWidth-d-c;this.len=Math.max(p?d:n,0);this.pos=p?c:q},getExtremes:function(){var a=this.isLog,b=this.lin2log;return{min:a?f(b(this.min)):this.min,max:a?f(b(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,h=this.lin2log,c=b?h(this.min):this.min,b=b?h(this.max):this.max;
null===a?a=c:c>a?a=c:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){a=(B(a,0)-90*this.side+720)%360;return 15<a&&165>a?"right":195<a&&345>a?"left":"center"},tickSize:function(a){var b=this.options,h=b[a+"Length"],c=B(b[a+"Width"],"tick"===a&&this.isXAxis?1:0);if(c&&h)return"inside"===b[a+"Position"]&&(h=-h),[h,c]},labelMetrics:function(){var a=this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&this.options.labels.style.fontSize,
this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var a=this.options.labels,b=this.horiz,c=this.tickInterval,e=c,p=this.len/(((this.categories?1:0)+this.max-this.min)/c),d,n=a.rotation,q=this.labelMetrics(),k,f=Number.MAX_VALUE,v,z=function(a){a/=p||1;a=1<a?Math.ceil(a):1;return a*c};b?(v=!a.staggerLines&&!a.step&&(r(n)?[n]:p<B(a.autoRotationLimit,80)&&a.autoRotation))&&g(v,function(a){var b;if(a===n||a&&-90<=a&&90>=a)k=z(Math.abs(q.h/Math.sin(u*a))),b=k+Math.abs(a/360),b<f&&(f=b,d=a,e=k)}):
a.step||(e=z(q.h));this.autoRotation=v;this.labelRotation=B(d,n);return e},getSlotWidth:function(){var a=this.chart,b=this.horiz,c=this.options.labels,e=Math.max(this.tickPositions.length-(this.categories?0:1),1),p=a.margin[3];return b&&2>(c.step||0)&&!c.rotation&&(this.staggerLines||1)*this.len/e||!b&&(p&&p-a.spacing[3]||.33*a.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,e=this.tickPositions,p=this.ticks,d=this.options.labels,n=this.horiz,q=this.getSlotWidth(),k=Math.max(1,
Math.round(q-2*(d.padding||5))),f={},v=this.labelMetrics(),z=d.style&&d.style.textOverflow,D,y=0,l,I;J(d.rotation)||(f.rotation=d.rotation||0);g(e,function(a){(a=p[a])&&a.labelLength>y&&(y=a.labelLength)});this.maxLabelLength=y;if(this.autoRotation)y>k&&y>v.h?f.rotation=this.labelRotation:this.labelRotation=0;else if(q&&(D={width:k+"px"},!z))for(D.textOverflow="clip",l=e.length;!n&&l--;)if(I=e[l],k=p[I].label)k.styles&&"ellipsis"===k.styles.textOverflow?k.css({textOverflow:"clip"}):p[I].labelLength>
q&&k.css({width:q+"px"}),k.getBBox().height>this.len/e.length-(v.h-v.f)&&(k.specCss={textOverflow:"ellipsis"});f.rotation&&(D={width:(y>.5*a.chartHeight?.33*a.chartHeight:a.chartHeight)+"px"},z||(D.textOverflow="ellipsis"));if(this.labelAlign=d.align||this.autoLabelAlign(this.labelRotation))f.align=this.labelAlign;g(e,function(a){var b=(a=p[a])&&a.label;b&&(b.attr(f),D&&b.css(c(D,b.specCss)),delete b.specCss,a.rotation=f.rotation)});this.tickRotCorr=b.rotCorr(v.b,this.labelRotation||0,0!==this.side)},
hasData:function(){return this.hasVisibleSeries||r(this.min)&&r(this.max)&&!!this.tickPositions},addTitle:function(a){var b=this.chart.renderer,c=this.horiz,h=this.opposite,e=this.options.title,p;this.axisTitle||((p=e.textAlign)||(p=(c?{low:"left",middle:"center",high:"right"}:{low:h?"right":"left",middle:"center",high:h?"left":"right"})[e.align]),this.axisTitle=b.text(e.text,0,0,e.useHTML).attr({zIndex:7,rotation:e.rotation||0,align:p}).addClass("highcharts-axis-title").css(e.style).add(this.axisGroup),
this.axisTitle.isNew=!0);e.style.width||this.isRadial||this.axisTitle.css({width:this.len});this.axisTitle[a?"show":"hide"](!0)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():b[a]=new I(this,a)},getOffset:function(){var a=this,b=a.chart,c=b.renderer,e=a.options,p=a.tickPositions,d=a.ticks,n=a.horiz,k=a.side,f=b.inverted&&!a.isZAxis?[1,0,3,2][k]:k,v,z,D=0,y,l=0,I=e.title,m=e.labels,G=0,J=b.axisOffset,b=b.clipOffset,t=[-1,1,1,-1][k],L=e.className,u=a.axisParent,K=this.tickSize("tick");
v=a.hasData();a.showAxis=z=v||B(e.showEmpty,!0);a.staggerLines=a.horiz&&m.staggerLines;a.axisGroup||(a.gridGroup=c.g("grid").attr({zIndex:e.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(L||"")).add(u),a.axisGroup=c.g("axis").attr({zIndex:e.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(L||"")).add(u),a.labelGroup=c.g("axis-labels").attr({zIndex:m.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(L||"")).add(u));v||a.isLinked?(g(p,function(b,
c){a.generateTick(b,c)}),a.renderUnsquish(),!1===m.reserveSpace||0!==k&&2!==k&&{1:"left",3:"right"}[k]!==a.labelAlign&&"center"!==a.labelAlign||g(p,function(a){G=Math.max(d[a].getLabelSize(),G)}),a.staggerLines&&(G*=a.staggerLines,a.labelOffset=G*(a.opposite?-1:1))):q(d,function(a,b){a.destroy();delete d[b]});I&&I.text&&!1!==I.enabled&&(a.addTitle(z),z&&!1!==I.reserveSpace&&(a.titleOffset=D=a.axisTitle.getBBox()[n?"height":"width"],y=I.offset,l=r(y)?0:B(I.margin,n?5:10)));a.renderLine();a.offset=
t*B(e.offset,J[k]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};c=0===k?-a.labelMetrics().h:2===k?a.tickRotCorr.y:0;l=Math.abs(G)+l;G&&(l=l-c+t*(n?B(m.y,a.tickRotCorr.y+8*t):m.x));a.axisTitleMargin=B(y,l);J[k]=Math.max(J[k],a.axisTitleMargin+D+t*a.offset,l,v&&p.length&&K?K[0]+t*a.offset:0);p=2*Math.floor(a.axisLine.strokeWidth()/2);0<e.offset&&(p-=2*e.offset);b[f]=Math.max(b[f]||p,p)},getLinePath:function(a){var b=this.chart,c=this.opposite,h=this.offset,e=this.horiz,p=this.left+(c?this.width:0)+h,h=b.chartHeight-
this.bottom-(c?this.height:0)+h;c&&(a*=-1);return b.renderer.crispLine(["M",e?this.left:p,e?h:this.top,"L",e?b.chartWidth-this.right:p,e?h:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,c=this.top,e=this.len,p=this.options.title,
d=a?b:c,n=this.opposite,q=this.offset,k=p.x||0,g=p.y||0,f=this.axisTitle,v=this.chart.renderer.fontMetrics(p.style&&p.style.fontSize,f),f=Math.max(f.getBBox(null,0).height-v.h-1,0),e={low:d+(a?0:e),middle:d+e/2,high:d+(a?e:0)}[p.align],b=(a?c+this.height:b)+(a?1:-1)*(n?-1:1)*this.axisTitleMargin+[-f,f,v.f,-f][this.side];return{x:a?e+k:b+(n?this.width:0)+q+k,y:a?b+g-(n?this.height:0)+q:e+g}},renderMinorTick:function(a){var b=this.chart.hasRendered&&D(this.oldMin),c=this.minorTicks;c[a]||(c[a]=new I(this,
a,"minor"));b&&c[a].isNew&&c[a].render(null,!0);c[a].render(null,!1,1)},renderTick:function(a,b){var c=this.isLinked,e=this.ticks,h=this.chart.hasRendered&&D(this.oldMin);if(!c||a>=this.min&&a<=this.max)e[a]||(e[a]=new I(this,a)),h&&e[a].isNew&&e[a].render(b,!0,.1),e[a].render(b)},render:function(){var b=this,c=b.chart,e=b.options,p=b.isLog,d=b.lin2log,n=b.isLinked,k=b.tickPositions,f=b.axisTitle,v=b.ticks,y=b.minorTicks,l=b.alternateBands,m=e.stackLabels,r=e.alternateGridColor,B=b.tickmarkOffset,
G=b.axisLine,J=b.showAxis,t=A(c.renderer.globalAnimation),L,u;b.labelEdge.length=0;b.overlap=!1;g([v,y,l],function(a){q(a,function(a){a.isActive=!1})});if(b.hasData()||n)b.minorTickInterval&&!b.categories&&g(b.getMinorTickPositions(),function(a){b.renderMinorTick(a)}),k.length&&(g(k,function(a,c){b.renderTick(a,c)}),B&&(0===b.min||b.single)&&(v[-1]||(v[-1]=new I(b,-1,null,!0)),v[-1].render(-1))),r&&g(k,function(e,h){u=void 0!==k[h+1]?k[h+1]+B:b.max-B;0===h%2&&e<b.max&&u<=b.max+(c.polar?-B:B)&&(l[e]||
(l[e]=new a.PlotLineOrBand(b)),L=e+B,l[e].options={from:p?d(L):L,to:p?d(u):u,color:r},l[e].render(),l[e].isActive=!0)}),b._addedPlotLB||(g((e.plotLines||[]).concat(e.plotBands||[]),function(a){b.addPlotBandOrLine(a)}),b._addedPlotLB=!0);g([v,y,l],function(a){var b,e=[],h=t.duration;q(a,function(a,b){a.isActive||(a.render(b,!1,0),a.isActive=!1,e.push(b))});z(function(){for(b=e.length;b--;)a[e[b]]&&!a[e[b]].isActive&&(a[e[b]].destroy(),delete a[e[b]])},a!==l&&c.hasRendered&&h?h:0)});G&&(G[G.isPlaced?
"animate":"attr"]({d:this.getLinePath(G.strokeWidth())}),G.isPlaced=!0,G[J?"show":"hide"](!0));f&&J&&(e=b.getTitlePosition(),D(e.y)?(f[f.isNew?"attr":"animate"](e),f.isNew=!1):(f.attr("y",-9999),f.isNew=!0));m&&m.enabled&&b.renderStackTotals();b.isDirty=!1},redraw:function(){this.visible&&(this.render(),g(this.plotLinesAndBands,function(a){a.render()}));g(this.series,function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var b=this,c=b.stacks,
e=b.plotLinesAndBands,h;a||K(b);q(c,function(a,b){t(a);c[b]=null});g([b.ticks,b.minorTicks,b.alternateBands],function(a){t(a)});if(e)for(a=e.length;a--;)e[a].destroy();g("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross".split(" "),function(a){b[a]&&(b[a]=b[a].destroy())});for(h in b.plotLinesAndBandsGroups)b.plotLinesAndBandsGroups[h]=b.plotLinesAndBandsGroups[h].destroy();q(b,function(a,c){-1===y(c,b.keepProps)&&delete b[c]})},drawCrosshair:function(a,b){var c,e=this.crosshair,
h=B(e.snap,!0),p,d=this.cross;a||(a=this.cross&&this.cross.e);this.crosshair&&!1!==(r(b)||!h)?(h?r(b)&&(p=this.isXAxis?b.plotX:this.len-b.plotY):p=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos),r(p)&&(c=this.getPlotLinePath(b&&(this.isXAxis?b.x:B(b.stackY,b.y)),null,null,null,p)||null),r(c)?(b=this.categories&&!this.isRadial,d||(this.cross=d=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(b?"category ":"thin ")+e.className).attr({zIndex:B(e.zIndex,2)}).add(),
d.attr({stroke:e.color||(b?m("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":B(e.width,1)}),e.dashStyle&&d.attr({dashstyle:e.dashStyle})),d.show().attr({d:c}),b&&!e.width&&d.attr({"stroke-width":this.transA}),this.cross.e=a):this.hideCrosshair()):this.hideCrosshair()},hideCrosshair:function(){this.cross&&this.cross.hide()}});return a.Axis=L}(M);(function(a){var C=a.Axis,A=a.Date,F=a.dateFormat,E=a.defaultOptions,m=a.defined,f=a.each,l=a.extend,r=a.getMagnitude,u=a.getTZOffset,t=a.normalizeTickInterval,
g=a.pick,d=a.timeUnits;C.prototype.getTimeTicks=function(a,b,e,v){var k=[],n={},D=E.global.useUTC,r,c=new A(b-Math.max(u(b),u(e))),G=A.hcMakeTime,q=a.unitRange,B=a.count,t,p;if(m(b)){c[A.hcSetMilliseconds](q>=d.second?0:B*Math.floor(c.getMilliseconds()/B));if(q>=d.second)c[A.hcSetSeconds](q>=d.minute?0:B*Math.floor(c.getSeconds()/B));if(q>=d.minute)c[A.hcSetMinutes](q>=d.hour?0:B*Math.floor(c[A.hcGetMinutes]()/B));if(q>=d.hour)c[A.hcSetHours](q>=d.day?0:B*Math.floor(c[A.hcGetHours]()/B));if(q>=d.day)c[A.hcSetDate](q>=
d.month?1:B*Math.floor(c[A.hcGetDate]()/B));q>=d.month&&(c[A.hcSetMonth](q>=d.year?0:B*Math.floor(c[A.hcGetMonth]()/B)),r=c[A.hcGetFullYear]());if(q>=d.year)c[A.hcSetFullYear](r-r%B);if(q===d.week)c[A.hcSetDate](c[A.hcGetDate]()-c[A.hcGetDay]()+g(v,1));r=c[A.hcGetFullYear]();v=c[A.hcGetMonth]();var z=c[A.hcGetDate](),I=c[A.hcGetHours]();if(A.hcTimezoneOffset||A.hcGetTimezoneOffset)p=(!D||!!A.hcGetTimezoneOffset)&&(e-b>4*d.month||u(b)!==u(e)),c=c.getTime(),t=u(c),c=new A(c+t);D=c.getTime();for(b=1;D<
e;)k.push(D),D=q===d.year?G(r+b*B,0):q===d.month?G(r,v+b*B):!p||q!==d.day&&q!==d.week?p&&q===d.hour?G(r,v,z,I+b*B,0,0,t)-t:D+q*B:G(r,v,z+b*B*(q===d.day?1:7)),b++;k.push(D);q<=d.hour&&1E4>k.length&&f(k,function(a){0===a%18E5&&"000000000"===F("%H%M%S%L",a)&&(n[a]="day")})}k.info=l(a,{higherRanks:n,totalRange:q*B});return k};C.prototype.normalizeTimeTickInterval=function(a,b){var e=b||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,
2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];b=e[e.length-1];var k=d[b[0]],g=b[1],n;for(n=0;n<e.length&&!(b=e[n],k=d[b[0]],g=b[1],e[n+1]&&a<=(k*g[g.length-1]+d[e[n+1][0]])/2);n++);k===d.year&&a<5*k&&(g=[1,2,5]);a=t(a/k,g,"year"===b[0]?Math.max(r(a/k),1):1);return{unitRange:k,count:a,unitName:b[0]}}})(M);(function(a){var C=a.Axis,A=a.getMagnitude,F=a.map,E=a.normalizeTickInterval,m=a.pick;C.prototype.getLogTickPositions=function(a,l,r,u){var f=this.options,g=this.len,
d=this.lin2log,k=this.log2lin,b=[];u||(this._minorAutoInterval=null);if(.5<=a)a=Math.round(a),b=this.getLinearTickPositions(a,l,r);else if(.08<=a)for(var g=Math.floor(l),e,v,y,n,D,f=.3<a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];g<r+1&&!D;g++)for(v=f.length,e=0;e<v&&!D;e++)y=k(d(g)*f[e]),y>l&&(!u||n<=r)&&void 0!==n&&b.push(n),n>r&&(D=!0),n=y;else l=d(l),r=d(r),a=f[u?"minorTickInterval":"tickInterval"],a=m("auto"===a?null:a,this._minorAutoInterval,f.tickPixelInterval/(u?5:1)*(r-l)/((u?g/this.tickPositions.length:
g)||1)),a=E(a,null,A(a)),b=F(this.getLinearTickPositions(a,l,r),k),u||(this._minorAutoInterval=a/5);u||(this.tickInterval=a);return b};C.prototype.log2lin=function(a){return Math.log(a)/Math.LN10};C.prototype.lin2log=function(a){return Math.pow(10,a)}})(M);(function(a,C){var A=a.arrayMax,F=a.arrayMin,E=a.defined,m=a.destroyObjectProperties,f=a.each,l=a.erase,r=a.merge,u=a.pick;a.PlotLineOrBand=function(a,g){this.axis=a;g&&(this.options=g,this.id=g.id)};a.PlotLineOrBand.prototype={render:function(){var f=
this,g=f.axis,d=g.horiz,k=f.options,b=k.label,e=f.label,v=k.to,l=k.from,n=k.value,D=E(l)&&E(v),m=E(n),c=f.svgElem,G=!c,q=[],B=k.color,K=u(k.zIndex,0),p=k.events,q={"class":"highcharts-plot-"+(D?"band ":"line ")+(k.className||"")},z={},I=g.chart.renderer,L=D?"bands":"lines",h=g.log2lin;g.isLog&&(l=h(l),v=h(v),n=h(n));m?(q={stroke:B,"stroke-width":k.width},k.dashStyle&&(q.dashstyle=k.dashStyle)):D&&(B&&(q.fill=B),k.borderWidth&&(q.stroke=k.borderColor,q["stroke-width"]=k.borderWidth));z.zIndex=K;L+=
"-"+K;(B=g.plotLinesAndBandsGroups[L])||(g.plotLinesAndBandsGroups[L]=B=I.g("plot-"+L).attr(z).add());G&&(f.svgElem=c=I.path().attr(q).add(B));if(m)q=g.getPlotLinePath(n,c.strokeWidth());else if(D)q=g.getPlotBandPath(l,v,k);else return;G&&q&&q.length?(c.attr({d:q}),p&&a.objectEach(p,function(a,b){c.on(b,function(a){p[b].apply(f,[a])})})):c&&(q?(c.show(),c.animate({d:q})):(c.hide(),e&&(f.label=e=e.destroy())));b&&E(b.text)&&q&&q.length&&0<g.width&&0<g.height&&!q.flat?(b=r({align:d&&D&&"center",x:d?
!D&&4:10,verticalAlign:!d&&D&&"middle",y:d?D?16:10:D?6:-4,rotation:d&&!D&&90},b),this.renderLabel(b,q,D,K)):e&&e.hide();return f},renderLabel:function(a,g,d,k){var b=this.label,e=this.axis.chart.renderer;b||(b={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+(d?"band":"line")+"-label "+(a.className||"")},b.zIndex=k,this.label=b=e.text(a.text,0,0,a.useHTML).attr(b).add(),b.css(a.style));k=[g[1],g[4],d?g[6]:g[1]];g=[g[2],g[5],d?g[7]:g[2]];d=F(k);e=F(g);b.align(a,!1,{x:d,y:e,
width:A(k)-d,height:A(g)-e});b.show()},destroy:function(){l(this.axis.plotLinesAndBands,this);delete this.axis;m(this)}};a.extend(C.prototype,{getPlotBandPath:function(a,g){var d=this.getPlotLinePath(g,null,null,!0),k=this.getPlotLinePath(a,null,null,!0),b=this.horiz,e=1;a=a<this.min&&g<this.min||a>this.max&&g>this.max;k&&d?(a&&(k.flat=k.toString()===d.toString(),e=0),k.push(b&&d[4]===k[4]?d[4]+e:d[4],b||d[5]!==k[5]?d[5]:d[5]+e,b&&d[1]===k[1]?d[1]+e:d[1],b||d[2]!==k[2]?d[2]:d[2]+e)):k=null;return k},
addPlotBand:function(a){return this.addPlotBandOrLine(a,"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,"plotLines")},addPlotBandOrLine:function(f,g){var d=(new a.PlotLineOrBand(this,f)).render(),k=this.userOptions;d&&(g&&(k[g]=k[g]||[],k[g].push(f)),this.plotLinesAndBands.push(d));return d},removePlotBandOrLine:function(a){for(var g=this.plotLinesAndBands,d=this.options,k=this.userOptions,b=g.length;b--;)g[b].id===a&&g[b].destroy();f([d.plotLines||[],k.plotLines||[],d.plotBands||
[],k.plotBands||[]],function(e){for(b=e.length;b--;)e[b].id===a&&l(e,e[b])})},removePlotBand:function(a){this.removePlotBandOrLine(a)},removePlotLine:function(a){this.removePlotBandOrLine(a)}})})(M,S);(function(a){var C=a.dateFormat,A=a.each,F=a.extend,E=a.format,m=a.isNumber,f=a.map,l=a.merge,r=a.pick,u=a.splat,t=a.syncTimeout,g=a.timeUnits;a.Tooltip=function(){this.init.apply(this,arguments)};a.Tooltip.prototype={init:function(a,k){this.chart=a;this.options=k;this.crosshairs=[];this.now={x:0,y:0};
this.isHidden=!0;this.split=k.split&&!a.inverted;this.shared=k.shared||this.split},cleanSplit:function(a){A(this.chart.series,function(d){var b=d&&d.tt;b&&(!b.isActive||a?d.tt=b.destroy():b.isActive=!1)})},getLabel:function(){var a=this.chart.renderer,k=this.options;this.label||(this.split?this.label=a.g("tooltip"):(this.label=a.label("",0,0,k.shape||"callout",null,null,k.useHTML,null,"tooltip").attr({padding:k.padding,r:k.borderRadius}),this.label.attr({fill:k.backgroundColor,"stroke-width":k.borderWidth}).css(k.style).shadow(k.shadow)),
this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();l(!0,this.chart.options.tooltip.userOptions,a);this.init(this.chart,l(!0,this.options,a))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());clearTimeout(this.hideTimer);clearTimeout(this.tooltipTimeout)},move:function(a,k,b,e){var d=this,g=d.now,n=!1!==d.options.animation&&!d.isHidden&&(1<Math.abs(a-g.x)||1<Math.abs(k-
g.y)),f=d.followPointer||1<d.len;F(g,{x:n?(2*g.x+a)/3:a,y:n?(g.y+k)/2:k,anchorX:f?void 0:n?(2*g.anchorX+b)/3:b,anchorY:f?void 0:n?(g.anchorY+e)/2:e});d.getLabel().attr(g);n&&(clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){d&&d.move(a,k,b,e)},32))},hide:function(a){var d=this;clearTimeout(this.hideTimer);a=r(a,this.options.hideDelay,500);this.isHidden||(this.hideTimer=t(function(){d.getLabel()[a?"fadeOut":"hide"]();d.isHidden=!0},a))},getAnchor:function(a,k){var b,e=this.chart,
d=e.inverted,g=e.plotTop,n=e.plotLeft,l=0,m=0,c,r;a=u(a);b=a[0].tooltipPos;this.followPointer&&k&&(void 0===k.chartX&&(k=e.pointer.normalize(k)),b=[k.chartX-e.plotLeft,k.chartY-g]);b||(A(a,function(a){c=a.series.yAxis;r=a.series.xAxis;l+=a.plotX+(!d&&r?r.left-n:0);m+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!d&&c?c.top-g:0)}),l/=a.length,m/=a.length,b=[d?e.plotWidth-m:l,this.shared&&!d&&1<a.length&&k?k.chartY-g:d?e.plotHeight-l:m]);return f(b,Math.round)},getPosition:function(a,g,b){var e=this.chart,
d=this.distance,k={},n=b.h||0,f,l=["y",e.chartHeight,g,b.plotY+e.plotTop,e.plotTop,e.plotTop+e.plotHeight],c=["x",e.chartWidth,a,b.plotX+e.plotLeft,e.plotLeft,e.plotLeft+e.plotWidth],m=!this.followPointer&&r(b.ttBelow,!e.inverted===!!b.negative),q=function(a,b,c,e,p,q){var h=c<e-d,g=e+d+c<b,f=e-d-c;e+=d;if(m&&g)k[a]=e;else if(!m&&h)k[a]=f;else if(h)k[a]=Math.min(q-c,0>f-n?f:f-n);else if(g)k[a]=Math.max(p,e+n+c>b?e:e+n);else return!1},B=function(a,b,c,e){var h;e<d||e>b-d?h=!1:k[a]=e<c/2?1:e>b-c/2?
b-c-2:e-c/2;return h},t=function(a){var b=l;l=c;c=b;f=a},p=function(){!1!==q.apply(0,l)?!1!==B.apply(0,c)||f||(t(!0),p()):f?k.x=k.y=0:(t(!0),p())};(e.inverted||1<this.len)&&t();p();return k},defaultFormatter:function(a){var d=this.points||u(this),b;b=[a.tooltipFooterHeaderFormatter(d[0])];b=b.concat(a.bodyFormatter(d));b.push(a.tooltipFooterHeaderFormatter(d[0],!0));return b},refresh:function(a,g){var b,e=this.options,d,k=a,n,f={},l=[];b=e.formatter||this.defaultFormatter;var f=this.shared,c;e.enabled&&
(clearTimeout(this.hideTimer),this.followPointer=u(k)[0].series.tooltipOptions.followPointer,n=this.getAnchor(k,g),g=n[0],d=n[1],!f||k.series&&k.series.noSharedTooltip?f=k.getLabelConfig():(A(k,function(a){a.setState("hover");l.push(a.getLabelConfig())}),f={x:k[0].category,y:k[0].y},f.points=l,k=k[0]),this.len=l.length,f=b.call(f,this),c=k.series,this.distance=r(c.tooltipOptions.distance,16),!1===f?this.hide():(b=this.getLabel(),this.isHidden&&b.attr({opacity:1}).show(),this.split?this.renderSplit(f,
a):(e.style.width||b.css({width:this.chart.spacingBox.width}),b.attr({text:f&&f.join?f.join(""):f}),b.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+r(k.colorIndex,c.colorIndex)),b.attr({stroke:e.borderColor||k.color||c.color||"#666666"}),this.updatePosition({plotX:g,plotY:d,negative:k.negative,ttBelow:k.ttBelow,h:n[2]||0})),this.isHidden=!1))},renderSplit:function(d,k){var b=this,e=[],g=this.chart,f=g.renderer,n=!0,l=this.options,m=0,c=this.getLabel();A(d.slice(0,k.length+1),
function(a,d){if(!1!==a){d=k[d-1]||{isHeader:!0,plotX:k[0].plotX};var q=d.series||b,v=q.tt,p=d.series||{},z="highcharts-color-"+r(d.colorIndex,p.colorIndex,"none");v||(q.tt=v=f.label(null,null,null,"callout").addClass("highcharts-tooltip-box "+z).attr({padding:l.padding,r:l.borderRadius,fill:l.backgroundColor,stroke:l.borderColor||d.color||p.color||"#333333","stroke-width":l.borderWidth}).add(c));v.isActive=!0;v.attr({text:a});v.css(l.style).shadow(l.shadow);a=v.getBBox();p=a.width+v.strokeWidth();
d.isHeader?(m=a.height,p=Math.max(0,Math.min(d.plotX+g.plotLeft-p/2,g.chartWidth-p))):p=d.plotX+g.plotLeft-r(l.distance,16)-p;0>p&&(n=!1);a=(d.series&&d.series.yAxis&&d.series.yAxis.pos)+(d.plotY||0);a-=g.plotTop;e.push({target:d.isHeader?g.plotHeight+m:a,rank:d.isHeader?1:0,size:q.tt.getBBox().height+1,point:d,x:p,tt:v})}});this.cleanSplit();a.distribute(e,g.plotHeight+m);A(e,function(a){var b=a.point,c=b.series;a.tt.attr({visibility:void 0===a.pos?"hidden":"inherit",x:n||b.isHeader?a.x:b.plotX+
g.plotLeft+r(l.distance,16),y:a.pos+g.plotTop,anchorX:b.isHeader?b.plotX+g.plotLeft:b.plotX+c.xAxis.pos,anchorY:b.isHeader?a.pos+g.plotTop-15:b.plotY+c.yAxis.pos})})},updatePosition:function(a){var d=this.chart,b=this.getLabel(),b=(this.options.positioner||this.getPosition).call(this,b.width,b.height,a);this.move(Math.round(b.x),Math.round(b.y||0),a.plotX+d.plotLeft,a.plotY+d.plotTop)},getDateFormat:function(a,k,b,e){var d=C("%m-%d %H:%M:%S.%L",k),f,n,l={millisecond:15,second:12,minute:9,hour:6,day:3},
m="millisecond";for(n in g){if(a===g.week&&+C("%w",k)===b&&"00:00:00.000"===d.substr(6)){n="week";break}if(g[n]>a){n=m;break}if(l[n]&&d.substr(l[n])!=="01-01 00:00:00.000".substr(l[n]))break;"week"!==n&&(m=n)}n&&(f=e[n]);return f},getXDateFormat:function(a,g,b){g=g.dateTimeLabelFormats;var e=b&&b.closestPointRange;return(e?this.getDateFormat(e,a.x,b.options.startOfWeek,g):g.day)||g.year},tooltipFooterHeaderFormatter:function(a,g){var b=g?"footer":"header";g=a.series;var e=g.tooltipOptions,d=e.xDateFormat,
k=g.xAxis,n=k&&"datetime"===k.options.type&&m(a.key),b=e[b+"Format"];n&&!d&&(d=this.getXDateFormat(a,e,k));n&&d&&(b=b.replace("{point.key}","{point.key:"+d+"}"));return E(b,{point:a,series:g})},bodyFormatter:function(a){return f(a,function(a){var b=a.series.tooltipOptions;return(b.pointFormatter||a.point.tooltipFormatter).call(a.point,b.pointFormat)})}}})(M);(function(a){var C=a.addEvent,A=a.attr,F=a.charts,E=a.color,m=a.css,f=a.defined,l=a.each,r=a.extend,u=a.find,t=a.fireEvent,g=a.isObject,d=a.offset,
k=a.pick,b=a.removeEvent,e=a.splat,v=a.Tooltip,y=a.win;a.Pointer=function(a,b){this.init(a,b)};a.Pointer.prototype={init:function(a,b){this.options=b;this.chart=a;this.runChartClick=b.chart.events&&!!b.chart.events.click;this.pinchDown=[];this.lastValidTouch={};v&&(a.tooltip=new v(a,b.tooltip),this.followTouchMove=k(b.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var b=this.chart,e=b.options.chart,c=e.zoomType||"",b=b.inverted;/touch/.test(a.type)&&(c=k(e.pinchType,c));
this.zoomX=a=/x/.test(c);this.zoomY=c=/y/.test(c);this.zoomHor=a&&!b||c&&b;this.zoomVert=c&&!b||a&&b;this.hasZoom=a||c},normalize:function(a,b){var e,c;a=a||y.event;a.target||(a.target=a.srcElement);c=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:a;b||(this.chartPosition=b=d(this.chart.container));void 0===c.pageX?(e=Math.max(a.x,a.clientX-b.left),b=a.y):(e=c.pageX-b.left,b=c.pageY-b.top);return r(a,{chartX:Math.round(e),chartY:Math.round(b)})},getCoordinates:function(a){var b=
{xAxis:[],yAxis:[]};l(this.chart.axes,function(e){b[e.isXAxis?"xAxis":"yAxis"].push({axis:e,value:e.toValue(a[e.horiz?"chartX":"chartY"])})});return b},findNearestKDPoint:function(a,b,e){var c;l(a,function(a){var d=!(a.noSharedTooltip&&b)&&0>a.options.findNearestPointBy.indexOf("y");a=a.searchPoint(e,d);if((d=g(a,!0))&&!(d=!g(c,!0)))var d=c.distX-a.distX,n=c.dist-a.dist,k=(a.series.group&&a.series.group.zIndex)-(c.series.group&&c.series.group.zIndex),d=0<(0!==d&&b?d:0!==n?n:0!==k?k:c.series.index>
a.series.index?-1:1);d&&(c=a)});return c},getPointFromEvent:function(a){a=a.target;for(var b;a&&!b;)b=a.point,a=a.parentNode;return b},getChartCoordinatesFromPoint:function(a,b){var e=a.series,c=e.xAxis,e=e.yAxis;if(c&&e)return b?{chartX:c.len+c.pos-a.clientX,chartY:e.len+e.pos-a.plotY}:{chartX:a.clientX+c.pos,chartY:a.plotY+e.pos}},getHoverData:function(b,e,d,c,f,q){var n,v=[];c=!(!c||!b);var p=e&&!e.stickyTracking?[e]:a.grep(d,function(a){return a.visible&&!(!f&&a.directTouch)&&k(a.options.enableMouseTracking,
!0)&&a.stickyTracking});e=(n=c?b:this.findNearestKDPoint(p,f,q))&&n.series;n&&(f&&!e.noSharedTooltip?(p=a.grep(d,function(a){return a.visible&&!(!f&&a.directTouch)&&k(a.options.enableMouseTracking,!0)&&!a.noSharedTooltip}),l(p,function(a){a=u(a.points,function(a){return a.x===n.x});g(a)&&!a.isNull&&v.push(a)})):v.push(n));return{hoverPoint:n,hoverSeries:e,hoverPoints:v}},runPointActions:function(b,e){var d=this.chart,c=d.tooltip,g=c?c.shared:!1,n=e||d.hoverPoint,f=n&&n.series||d.hoverSeries,f=this.getHoverData(n,
f,d.series,!!e||f&&f.directTouch&&this.isDirectTouch,g,b),v,n=f.hoverPoint;v=f.hoverPoints;e=(f=f.hoverSeries)&&f.tooltipOptions.followPointer;g=g&&f&&!f.noSharedTooltip;if(n&&(n!==d.hoverPoint||c&&c.isHidden)){l(d.hoverPoints||[],function(b){-1===a.inArray(b,v)&&b.setState()});l(v||[],function(a){a.setState("hover")});if(d.hoverSeries!==f)f.onMouseOver();d.hoverPoint&&d.hoverPoint.firePointEvent("mouseOut");n.firePointEvent("mouseOver");d.hoverPoints=v;d.hoverPoint=n;c&&c.refresh(g?v:n,b)}else e&&
c&&!c.isHidden&&(n=c.getAnchor([{}],b),c.updatePosition({plotX:n[0],plotY:n[1]}));this.unDocMouseMove||(this.unDocMouseMove=C(d.container.ownerDocument,"mousemove",function(b){var c=F[a.hoverChartIndex];if(c)c.pointer.onDocumentMouseMove(b)}));l(d.axes,function(c){var e=k(c.crosshair.snap,!0),p=e?a.find(v,function(a){return a.series[c.coll]===c}):void 0;p||!e?c.drawCrosshair(b,p):c.hideCrosshair()})},reset:function(a,b){var d=this.chart,c=d.hoverSeries,g=d.hoverPoint,n=d.hoverPoints,f=d.tooltip,k=
f&&f.shared?n:g;a&&k&&l(e(k),function(b){b.series.isCartesian&&void 0===b.plotX&&(a=!1)});if(a)f&&k&&(f.refresh(k),g&&(g.setState(g.state,!0),l(d.axes,function(a){a.crosshair&&a.drawCrosshair(null,g)})));else{if(g)g.onMouseOut();n&&l(n,function(a){a.setState()});if(c)c.onMouseOut();f&&f.hide(b);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());l(d.axes,function(a){a.hideCrosshair()});this.hoverX=d.hoverPoints=d.hoverPoint=null}},scaleGroups:function(a,b){var e=this.chart,c;l(e.series,
function(d){c=a||d.getPlotBox();d.xAxis&&d.xAxis.zoomEnabled&&d.group&&(d.group.attr(c),d.markerGroup&&(d.markerGroup.attr(c),d.markerGroup.clip(b?e.clipRect:null)),d.dataLabelsGroup&&d.dataLabelsGroup.attr(c))});e.clipRect.attr(b||e.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=this.chart,e=b.options.chart,c=a.chartX,d=a.chartY,g=this.zoomHor,n=this.zoomVert,
f=b.plotLeft,p=b.plotTop,k=b.plotWidth,v=b.plotHeight,l,h=this.selectionMarker,w=this.mouseDownX,m=this.mouseDownY,r=e.panKey&&a[e.panKey+"Key"];h&&h.touch||(c<f?c=f:c>f+k&&(c=f+k),d<p?d=p:d>p+v&&(d=p+v),this.hasDragged=Math.sqrt(Math.pow(w-c,2)+Math.pow(m-d,2)),10<this.hasDragged&&(l=b.isInsidePlot(w-f,m-p),b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&l&&!r&&!h&&(this.selectionMarker=h=b.renderer.rect(f,p,g?1:k,n?1:v,0).attr({fill:e.selectionMarkerFill||E("#335cad").setOpacity(.25).get(),"class":"highcharts-selection-marker",
zIndex:7}).add()),h&&g&&(c-=w,h.attr({width:Math.abs(c),x:(0<c?0:c)+w})),h&&n&&(c=d-m,h.attr({height:Math.abs(c),y:(0<c?0:c)+m})),l&&!h&&e.panning&&b.pan(a,e.panning)))},drop:function(a){var b=this,e=this.chart,c=this.hasPinched;if(this.selectionMarker){var d={originalEvent:a,xAxis:[],yAxis:[]},g=this.selectionMarker,n=g.attr?g.attr("x"):g.x,k=g.attr?g.attr("y"):g.y,p=g.attr?g.attr("width"):g.width,v=g.attr?g.attr("height"):g.height,I;if(this.hasDragged||c)l(e.axes,function(e){if(e.zoomEnabled&&f(e.min)&&
(c||b[{xAxis:"zoomX",yAxis:"zoomY"}[e.coll]])){var h=e.horiz,g="touchend"===a.type?e.minPixelPadding:0,q=e.toValue((h?n:k)+g),h=e.toValue((h?n+p:k+v)-g);d[e.coll].push({axis:e,min:Math.min(q,h),max:Math.max(q,h)});I=!0}}),I&&t(e,"selection",d,function(a){e.zoom(r(a,c?{animation:!1}:null))});this.selectionMarker=this.selectionMarker.destroy();c&&this.scaleGroups()}e&&(m(e.container,{cursor:e._cursor}),e.cancelClick=10<this.hasDragged,e.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=
[])},onContainerMouseDown:function(a){a=this.normalize(a);this.zoomOption(a);a.preventDefault&&a.preventDefault();this.dragStart(a)},onDocumentMouseUp:function(b){F[a.hoverChartIndex]&&F[a.hoverChartIndex].pointer.drop(b)},onDocumentMouseMove:function(a){var b=this.chart,e=this.chartPosition;a=this.normalize(a,e);!e||this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(b){var e=F[a.hoverChartIndex];e&&(b.relatedTarget||
b.toElement)&&(e.pointer.reset(),e.pointer.chartPosition=null)},onContainerMouseMove:function(b){var e=this.chart;f(a.hoverChartIndex)&&F[a.hoverChartIndex]&&F[a.hoverChartIndex].mouseIsDown||(a.hoverChartIndex=e.index);b=this.normalize(b);b.returnValue=!1;"mousedown"===e.mouseIsDown&&this.drag(b);!this.inClass(b.target,"highcharts-tracker")&&!e.isInsidePlot(b.chartX-e.plotLeft,b.chartY-e.plotTop)||e.openMenu||this.runPointActions(b)},inClass:function(a,b){for(var e;a;){if(e=A(a,"class")){if(-1!==
e.indexOf(b))return!0;if(-1!==e.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!b||!a||b.stickyTracking||this.inClass(a,"highcharts-tooltip")||this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},onContainerClick:function(a){var b=this.chart,e=b.hoverPoint,c=b.plotLeft,d=b.plotTop;a=this.normalize(a);b.cancelClick||(e&&this.inClass(a.target,
"highcharts-tracker")?(t(e.series,"click",r(a,{point:e})),b.hoverPoint&&e.firePointEvent("click",a)):(r(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-c,a.chartY-d)&&t(b,"click",a)))},setDOMEvents:function(){var b=this,e=b.chart.container,d=e.ownerDocument;e.onmousedown=function(a){b.onContainerMouseDown(a)};e.onmousemove=function(a){b.onContainerMouseMove(a)};e.onclick=function(a){b.onContainerClick(a)};C(e,"mouseleave",b.onContainerMouseLeave);1===a.chartCount&&C(d,"mouseup",b.onDocumentMouseUp);
a.hasTouch&&(e.ontouchstart=function(a){b.onContainerTouchStart(a)},e.ontouchmove=function(a){b.onContainerTouchMove(a)},1===a.chartCount&&C(d,"touchend",b.onDocumentTouchEnd))},destroy:function(){var e=this,d=this.chart.container.ownerDocument;e.unDocMouseMove&&e.unDocMouseMove();b(e.chart.container,"mouseleave",e.onContainerMouseLeave);a.chartCount||(b(d,"mouseup",e.onDocumentMouseUp),a.hasTouch&&b(d,"touchend",e.onDocumentTouchEnd));clearInterval(e.tooltipTimeout);a.objectEach(e,function(a,b){e[b]=
null})}}})(M);(function(a){var C=a.charts,A=a.each,F=a.extend,E=a.map,m=a.noop,f=a.pick;F(a.Pointer.prototype,{pinchTranslate:function(a,f,m,t,g,d){this.zoomHor&&this.pinchTranslateDirection(!0,a,f,m,t,g,d);this.zoomVert&&this.pinchTranslateDirection(!1,a,f,m,t,g,d)},pinchTranslateDirection:function(a,f,m,t,g,d,k,b){var e=this.chart,v=a?"x":"y",l=a?"X":"Y",n="chart"+l,r=a?"width":"height",u=e["plot"+(a?"Left":"Top")],c,G,q=b||1,B=e.inverted,K=e.bounds[a?"h":"v"],p=1===f.length,z=f[0][n],I=m[0][n],
L=!p&&f[1][n],h=!p&&m[1][n],w;m=function(){!p&&20<Math.abs(z-L)&&(q=b||Math.abs(I-h)/Math.abs(z-L));G=(u-I)/q+z;c=e["plot"+(a?"Width":"Height")]/q};m();f=G;f<K.min?(f=K.min,w=!0):f+c>K.max&&(f=K.max-c,w=!0);w?(I-=.8*(I-k[v][0]),p||(h-=.8*(h-k[v][1])),m()):k[v]=[I,h];B||(d[v]=G-u,d[r]=c);d=B?1/q:q;g[r]=c;g[v]=f;t[B?a?"scaleY":"scaleX":"scale"+l]=q;t["translate"+l]=d*u+(I-d*z)},pinch:function(a){var l=this,u=l.chart,t=l.pinchDown,g=a.touches,d=g.length,k=l.lastValidTouch,b=l.hasZoom,e=l.selectionMarker,
v={},y=1===d&&(l.inClass(a.target,"highcharts-tracker")&&u.runTrackerClick||l.runChartClick),n={};1<d&&(l.initiated=!0);b&&l.initiated&&!y&&a.preventDefault();E(g,function(a){return l.normalize(a)});"touchstart"===a.type?(A(g,function(a,b){t[b]={chartX:a.chartX,chartY:a.chartY}}),k.x=[t[0].chartX,t[1]&&t[1].chartX],k.y=[t[0].chartY,t[1]&&t[1].chartY],A(u.axes,function(a){if(a.zoomEnabled){var b=u.bounds[a.horiz?"h":"v"],e=a.minPixelPadding,d=a.toPixels(f(a.options.min,a.dataMin)),g=a.toPixels(f(a.options.max,
a.dataMax)),k=Math.max(d,g);b.min=Math.min(a.pos,Math.min(d,g)-e);b.max=Math.max(a.pos+a.len,k+e)}}),l.res=!0):l.followTouchMove&&1===d?this.runPointActions(l.normalize(a)):t.length&&(e||(l.selectionMarker=e=F({destroy:m,touch:!0},u.plotBox)),l.pinchTranslate(t,g,v,e,n,k),l.hasPinched=b,l.scaleGroups(v,n),l.res&&(l.res=!1,this.reset(!1,0)))},touch:function(l,m){var r=this.chart,t,g;if(r.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=r.index;1===l.touches.length?
(l=this.normalize(l),(g=r.isInsidePlot(l.chartX-r.plotLeft,l.chartY-r.plotTop))&&!r.openMenu?(m&&this.runPointActions(l),"touchmove"===l.type&&(m=this.pinchDown,t=m[0]?4<=Math.sqrt(Math.pow(m[0].chartX-l.chartX,2)+Math.pow(m[0].chartY-l.chartY,2)):!1),f(t,!0)&&this.pinch(l)):m&&this.reset()):2===l.touches.length&&this.pinch(l)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(f){C[a.hoverChartIndex]&&
C[a.hoverChartIndex].pointer.drop(f)}})})(M);(function(a){var C=a.addEvent,A=a.charts,F=a.css,E=a.doc,m=a.extend,f=a.noop,l=a.Pointer,r=a.removeEvent,u=a.win,t=a.wrap;if(!a.hasTouch&&(u.PointerEvent||u.MSPointerEvent)){var g={},d=!!u.PointerEvent,k=function(){var b=[];b.item=function(a){return this[a]};a.objectEach(g,function(a){b.push({pageX:a.pageX,pageY:a.pageY,target:a.target})});return b},b=function(b,d,g,n){"touch"!==b.pointerType&&b.pointerType!==b.MSPOINTER_TYPE_TOUCH||!A[a.hoverChartIndex]||
(n(b),n=A[a.hoverChartIndex].pointer,n[d]({type:g,target:b.currentTarget,preventDefault:f,touches:k()}))};m(l.prototype,{onContainerPointerDown:function(a){b(a,"onContainerTouchStart","touchstart",function(a){g[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){b(a,"onContainerTouchMove","touchmove",function(a){g[a.pointerId]={pageX:a.pageX,pageY:a.pageY};g[a.pointerId].target||(g[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){b(a,
"onDocumentTouchEnd","touchend",function(a){delete g[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,d?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,d?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(E,d?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});t(l.prototype,"init",function(a,b,d){a.call(this,b,d);this.hasZoom&&F(b.container,{"-ms-touch-action":"none","touch-action":"none"})});t(l.prototype,"setDOMEvents",function(a){a.apply(this);
(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(C)});t(l.prototype,"destroy",function(a){this.batchMSEvents(r);a.call(this)})}})(M);(function(a){var C=a.addEvent,A=a.css,F=a.discardElement,E=a.defined,m=a.each,f=a.isFirefox,l=a.marginNames,r=a.merge,u=a.pick,t=a.setAnimation,g=a.stableSort,d=a.win,k=a.wrap;a.Legend=function(a,e){this.init(a,e)};a.Legend.prototype={init:function(a,e){this.chart=a;this.setOptions(e);e.enabled&&(this.render(),C(this.chart,"endResize",function(){this.legend.positionCheckboxes()}))},
setOptions:function(a){var b=u(a.padding,8);this.options=a;this.itemStyle=a.itemStyle;this.itemHiddenStyle=r(this.itemStyle,a.itemHiddenStyle);this.itemMarginTop=a.itemMarginTop||0;this.padding=b;this.initialItemY=b-5;this.itemHeight=this.maxItemWidth=0;this.symbolWidth=u(a.symbolWidth,16);this.pages=[]},update:function(a,e){var b=this.chart;this.setOptions(r(!0,this.options,a));this.destroy();b.isDirtyLegend=b.isDirtyBox=!0;u(e,!0)&&b.redraw()},colorizeItem:function(a,e){a.legendGroup[e?"removeClass":
"addClass"]("highcharts-legend-item-hidden");var b=this.options,d=a.legendItem,g=a.legendLine,f=a.legendSymbol,k=this.itemHiddenStyle.color,b=e?b.itemStyle.color:k,c=e?a.color||k:k,l=a.options&&a.options.marker,q={fill:c};d&&d.css({fill:b,color:b});g&&g.attr({stroke:c});f&&(l&&f.isMarker&&(q=a.pointAttribs(),e||(q.stroke=q.fill=k)),f.attr(q))},positionItem:function(a){var b=this.options,d=b.symbolPadding,b=!b.rtl,g=a._legendItemPos,f=g[0],g=g[1],k=a.checkbox;(a=a.legendGroup)&&a.element&&a.translate(b?
f:this.legendWidth-f-2*d-4,g);k&&(k.x=f,k.y=g)},destroyItem:function(a){var b=a.checkbox;m(["legendItem","legendLine","legendSymbol","legendGroup"],function(b){a[b]&&(a[b]=a[b].destroy())});b&&F(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}m(this.getAllItems(),function(b){m(["legendItem","legendGroup"],a,b)});m("clipRect up down pager nav box title group".split(" "),a,this);this.display=null},positionCheckboxes:function(a){var b=this.group&&this.group.alignAttr,
d,g=this.clipHeight||this.legendHeight,f=this.titleHeight;b&&(d=b.translateY,m(this.allItems,function(e){var k=e.checkbox,c;k&&(c=d+f+k.y+(a||0)+3,A(k,{left:b.translateX+e.checkboxOffset+k.x-20+"px",top:c+"px",display:c>d-6&&c<d+g-6?"":"none"}))}))},renderTitle:function(){var a=this.options,e=this.padding,d=a.title,g=0;d.text&&(this.title||(this.title=this.chart.renderer.label(d.text,e-3,e-4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}).css(d.style).add(this.group)),a=this.title.getBBox(),
g=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:g}));this.titleHeight=g},setText:function(b){var e=this.options;b.legendItem.attr({text:e.labelFormat?a.format(e.labelFormat,b):e.labelFormatter.call(b)})},renderItem:function(a){var b=this.chart,d=b.renderer,g=this.options,f="horizontal"===g.layout,k=this.symbolWidth,l=g.symbolPadding,c=this.itemStyle,m=this.itemHiddenStyle,q=this.padding,B=f?u(g.itemDistance,20):0,t=!g.rtl,p=g.width,z=g.itemMarginBottom||0,I=this.itemMarginTop,
L=a.legendItem,h=!a.series,w=!h&&a.series.drawLegendSymbol?a.series:a,P=w.options,H=this.createCheckboxForItem&&P&&P.showCheckbox,P=k+l+B+(H?20:0),O=g.useHTML,A=a.options.className;L||(a.legendGroup=d.g("legend-item").addClass("highcharts-"+w.type+"-series highcharts-color-"+a.colorIndex+(A?" "+A:"")+(h?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=L=d.text("",t?k+l:-l,this.baseline||0,O).css(r(a.visible?c:m)).attr({align:t?"left":"right",zIndex:2}).add(a.legendGroup),
this.baseline||(k=c.fontSize,this.fontMetrics=d.fontMetrics(k,L),this.baseline=this.fontMetrics.f+3+I,L.attr("y",this.baseline)),this.symbolHeight=g.symbolHeight||this.fontMetrics.f,w.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,L,O),H&&this.createCheckboxForItem(a));this.colorizeItem(a,a.visible);c.width||L.css({width:(g.itemWidth||g.width||b.spacingBox.width)-P});this.setText(a);d=L.getBBox();c=a.checkboxOffset=g.itemWidth||a.legendItemWidth||d.width+P;this.itemHeight=d=Math.round(a.legendItemHeight||
d.height||this.symbolHeight);f&&this.itemX-q+c>(p||b.spacingBox.width-2*q-g.x)&&(this.itemX=q,this.itemY+=I+this.lastLineHeight+z,this.lastLineHeight=0);this.maxItemWidth=Math.max(this.maxItemWidth,c);this.lastItemY=I+this.itemY+z;this.lastLineHeight=Math.max(d,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];f?this.itemX+=c:(this.itemY+=I+d+z,this.lastLineHeight=d);this.offsetWidth=p||Math.max((f?this.itemX-q-(a.checkbox?0:B):c)+q,this.offsetWidth)},getAllItems:function(){var a=[];m(this.chart.series,
function(b){var e=b&&b.options;b&&u(e.showInLegend,E(e.linkedTo)?!1:void 0,!0)&&(a=a.concat(b.legendItems||("point"===e.legendType?b.data:b)))});return a},adjustMargins:function(a,e){var b=this.chart,d=this.options,g=d.align.charAt(0)+d.verticalAlign.charAt(0)+d.layout.charAt(0);d.floating||m([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/],function(f,k){f.test(g)&&!E(a[k])&&(b[l[k]]=Math.max(b[l[k]],b.legend[(k+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][k]*d[k%2?"x":"y"]+u(d.margin,
12)+e[k]))})},render:function(){var a=this,e=a.chart,d=e.renderer,f=a.group,k,l,t,c,u=a.box,q=a.options,B=a.padding;a.itemX=B;a.itemY=a.initialItemY;a.offsetWidth=0;a.lastItemY=0;f||(a.group=f=d.g("legend").attr({zIndex:7}).add(),a.contentGroup=d.g().attr({zIndex:1}).add(f),a.scrollGroup=d.g().add(a.contentGroup));a.renderTitle();k=a.getAllItems();g(k,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});q.reversed&&k.reverse();a.allItems=k;a.display=l=
!!k.length;a.lastLineHeight=0;m(k,function(b){a.renderItem(b)});t=(q.width||a.offsetWidth)+B;c=a.lastItemY+a.lastLineHeight+a.titleHeight;c=a.handleOverflow(c);c+=B;u||(a.box=u=d.rect().addClass("highcharts-legend-box").attr({r:q.borderRadius}).add(f),u.isNew=!0);u.attr({stroke:q.borderColor,"stroke-width":q.borderWidth||0,fill:q.backgroundColor||"none"}).shadow(q.shadow);0<t&&0<c&&(u[u.isNew?"attr":"animate"](u.crisp({x:0,y:0,width:t,height:c},u.strokeWidth())),u.isNew=!1);u[l?"show":"hide"]();a.legendWidth=
t;a.legendHeight=c;m(k,function(b){a.positionItem(b)});l&&f.align(r(q,{width:t,height:c}),!0,"spacingBox");e.isResizing||this.positionCheckboxes()},handleOverflow:function(a){var b=this,d=this.chart,g=d.renderer,f=this.options,k=f.y,l=this.padding,d=d.spacingBox.height+("top"===f.verticalAlign?-k:k)-l,k=f.maxHeight,c,r=this.clipRect,q=f.navigation,B=u(q.animation,!0),t=q.arrowSize||12,p=this.nav,z=this.pages,I,L=this.allItems,h=function(a){"number"===typeof a?r.attr({height:a}):r&&(b.clipRect=r.destroy(),
b.contentGroup.clip());b.contentGroup.div&&(b.contentGroup.div.style.clip=a?"rect("+l+"px,9999px,"+(l+a)+"px,0)":"auto")};"horizontal"!==f.layout||"middle"===f.verticalAlign||f.floating||(d/=2);k&&(d=Math.min(d,k));z.length=0;a>d&&!1!==q.enabled?(this.clipHeight=c=Math.max(d-20-this.titleHeight-l,0),this.currentPage=u(this.currentPage,1),this.fullHeight=a,m(L,function(a,b){var e=a._legendItemPos[1];a=Math.round(a.legendItem.getBBox().height);var d=z.length;if(!d||e-z[d-1]>c&&(I||e)!==z[d-1])z.push(I||
e),d++;b===L.length-1&&e+a-z[d-1]>c&&z.push(e);e!==I&&(I=e)}),r||(r=b.clipRect=g.clipRect(0,l,9999,0),b.contentGroup.clip(r)),h(c),p||(this.nav=p=g.g().attr({zIndex:1}).add(this.group),this.up=g.symbol("triangle",0,0,t,t).on("click",function(){b.scroll(-1,B)}).add(p),this.pager=g.text("",15,10).addClass("highcharts-legend-navigation").css(q.style).add(p),this.down=g.symbol("triangle-down",0,0,t,t).on("click",function(){b.scroll(1,B)}).add(p)),b.scroll(0),a=d):p&&(h(),this.nav=p.destroy(),this.scrollGroup.attr({translateY:1}),
this.clipHeight=0);return a},scroll:function(a,e){var b=this.pages,d=b.length;a=this.currentPage+a;var g=this.clipHeight,f=this.options.navigation,k=this.pager,c=this.padding;a>d&&(a=d);0<a&&(void 0!==e&&t(e,this.chart),this.nav.attr({translateX:c,translateY:g+this.padding+7+this.titleHeight,visibility:"visible"}),this.up.attr({"class":1===a?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),k.attr({text:a+"/"+d}),this.down.attr({x:18+this.pager.getBBox().width,"class":a===d?"highcharts-legend-nav-inactive":
"highcharts-legend-nav-active"}),this.up.attr({fill:1===a?f.inactiveColor:f.activeColor}).css({cursor:1===a?"default":"pointer"}),this.down.attr({fill:a===d?f.inactiveColor:f.activeColor}).css({cursor:a===d?"default":"pointer"}),e=-b[a-1]+this.initialItemY,this.scrollGroup.animate({translateY:e}),this.currentPage=a,this.positionCheckboxes(e))}};a.LegendSymbolMixin={drawRectangle:function(a,e){var b=a.symbolHeight,d=a.options.squareSymbol;e.legendSymbol=this.chart.renderer.rect(d?(a.symbolWidth-b)/
2:0,a.baseline-b+1,d?b:a.symbolWidth,b,u(a.options.symbolRadius,b/2)).addClass("highcharts-point").attr({zIndex:3}).add(e.legendGroup)},drawLineMarker:function(a){var b=this.options,d=b.marker,g=a.symbolWidth,f=a.symbolHeight,k=f/2,l=this.chart.renderer,c=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);var m;m={"stroke-width":b.lineWidth||0};b.dashStyle&&(m.dashstyle=b.dashStyle);this.legendLine=l.path(["M",0,a,"L",g,a]).addClass("highcharts-graph").attr(m).add(c);d&&!1!==d.enabled&&
(b=Math.min(u(d.radius,k),k),0===this.symbol.indexOf("url")&&(d=r(d,{width:f,height:f}),b=0),this.legendSymbol=d=l.symbol(this.symbol,g/2-b,a-b,2*b,2*b,d).addClass("highcharts-point").add(c),d.isMarker=!0)}};(/Trident\/7\.0/.test(d.navigator.userAgent)||f)&&k(a.Legend.prototype,"positionItem",function(a,e){var b=this,d=function(){e._legendItemPos&&a.call(b,e)};d();setTimeout(d)})})(M);(function(a){var C=a.addEvent,A=a.animate,F=a.animObject,E=a.attr,m=a.doc,f=a.Axis,l=a.createElement,r=a.defaultOptions,
u=a.discardElement,t=a.charts,g=a.css,d=a.defined,k=a.each,b=a.extend,e=a.find,v=a.fireEvent,y=a.getStyle,n=a.grep,D=a.isNumber,J=a.isObject,c=a.isString,G=a.Legend,q=a.marginNames,B=a.merge,K=a.objectEach,p=a.Pointer,z=a.pick,I=a.pInt,L=a.removeEvent,h=a.seriesTypes,w=a.splat,P=a.svg,H=a.syncTimeout,O=a.win,Q=a.Renderer,R=a.Chart=function(){this.getArgs.apply(this,arguments)};a.chart=function(a,b,c){return new R(a,b,c)};b(R.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);
if(c(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(b,c){var e,d,h=b.series,p=b.plotOptions||{};b.series=null;e=B(r,b);for(d in e.plotOptions)e.plotOptions[d].tooltip=p[d]&&B(p[d].tooltip)||void 0;e.tooltip.userOptions=b.chart&&b.chart.forExport&&b.tooltip.userOptions||b.tooltip;e.series=b.series=h;this.userOptions=b;b=e.chart;d=b.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.callback=c;this.isResizing=0;this.options=e;this.axes=[];this.series=
[];this.hasCartesianSeries=b.showAxes;var g=this;g.index=t.length;t.push(g);a.chartCount++;d&&K(d,function(a,b){C(g,b,a)});g.xAxis=[];g.yAxis=[];g.pointCount=g.colorCounter=g.symbolCounter=0;g.firstRender()},initSeries:function(b){var c=this.options.chart;(c=h[b.type||c.type||c.defaultSeriesType])||a.error(17,!0);c=new c;c.init(this,b);return c},orderSeries:function(a){var b=this.series;for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].name||"Series "+(b[a].index+1))},isInsidePlot:function(a,
b,c){var e=c?b:a;a=c?a:b;return 0<=e&&e<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(c){var e=this.axes,d=this.series,h=this.pointer,p=this.legend,g=this.isDirtyLegend,f,q,l=this.hasCartesianSeries,n=this.isDirtyBox,z,m=this.renderer,x=m.isHidden(),w=[];this.setResponsive&&this.setResponsive(!1);a.setAnimation(c,this);x&&this.temporaryDisplay();this.layOutTitles();for(c=d.length;c--;)if(z=d[c],z.options.stacking&&(f=!0,z.isDirty)){q=!0;break}if(q)for(c=d.length;c--;)z=d[c],z.options.stacking&&
(z.isDirty=!0);k(d,function(a){a.isDirty&&"point"===a.options.legendType&&(a.updateTotals&&a.updateTotals(),g=!0);a.isDirtyData&&v(a,"updatedData")});g&&p.options.enabled&&(p.render(),this.isDirtyLegend=!1);f&&this.getStacks();l&&k(e,function(a){a.updateNames();a.setScale()});this.getMargins();l&&(k(e,function(a){a.isDirty&&(n=!0)}),k(e,function(a){var c=a.min+","+a.max;a.extKey!==c&&(a.extKey=c,w.push(function(){v(a,"afterSetExtremes",b(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(n||f)&&
a.redraw()}));n&&this.drawChartBox();v(this,"predraw");k(d,function(a){(n||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});h&&h.reset(!0);m.draw();v(this,"redraw");v(this,"render");x&&this.temporaryDisplay(!0);k(w,function(a){a.call()})},get:function(a){function b(b){return b.id===a||b.options&&b.options.id===a}var c,d=this.series,h;c=e(this.axes,b)||e(this.series,b);for(h=0;!c&&h<d.length;h++)c=e(d[h].points||[],b);return c},getAxes:function(){var a=this,b=this.options,c=b.xAxis=w(b.xAxis||
{}),b=b.yAxis=w(b.yAxis||{});k(c,function(a,b){a.index=b;a.isX=!0});k(b,function(a,b){a.index=b});c=c.concat(b);k(c,function(b){new f(a,b)})},getSelectedPoints:function(){var a=[];k(this.series,function(b){a=a.concat(n(b.data||[],function(a){return a.selected}))});return a},getSelectedSeries:function(){return n(this.series,function(a){return a.selected})},setTitle:function(a,b,c){var e=this,d=e.options,h;h=d.title=B({style:{color:"#333333",fontSize:d.isStock?"16px":"18px"}},d.title,a);d=d.subtitle=
B({style:{color:"#666666"}},d.subtitle,b);k([["title",a,h],["subtitle",b,d]],function(a,b){var c=a[0],d=e[c],h=a[1];a=a[2];d&&h&&(e[c]=d=d.destroy());a&&a.text&&!d&&(e[c]=e.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+c,zIndex:a.zIndex||4}).add(),e[c].update=function(a){e.setTitle(!b&&a,b&&a)},e[c].css(a.style))});e.layOutTitles(c)},layOutTitles:function(a){var c=0,e,d=this.renderer,h=this.spacingBox;k(["title","subtitle"],function(a){var e=this[a],p=this.options[a];
a="title"===a?-3:p.verticalAlign?0:c+2;var g;e&&(g=p.style.fontSize,g=d.fontMetrics(g,e).b,e.css({width:(p.width||h.width+p.widthAdjust)+"px"}).align(b({y:a+g},p),!1,"spacingBox"),p.floating||p.verticalAlign||(c=Math.ceil(c+e.getBBox(p.useHTML).height)))},this);e=this.titleOffset!==c;this.titleOffset=c;!this.isDirtyBox&&e&&(this.isDirtyBox=e,this.hasRendered&&z(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var b=this.options.chart,c=b.width,b=b.height,e=this.renderTo;d(c)||(this.containerWidth=
y(e,"width"));d(b)||(this.containerHeight=y(e,"height"));this.chartWidth=Math.max(0,c||this.containerWidth||600);this.chartHeight=Math.max(0,a.relativeLength(b,this.chartWidth)||this.containerHeight||400)},temporaryDisplay:function(b){var c=this.renderTo;if(b)for(;c&&c.style;)c.hcOrigStyle&&(a.css(c,c.hcOrigStyle),delete c.hcOrigStyle),c.hcOrigDetached&&(m.body.removeChild(c),c.hcOrigDetached=!1),c=c.parentNode;else for(;c&&c.style;){m.body.contains(c)||(c.hcOrigDetached=!0,m.body.appendChild(c));
if("none"===y(c,"display",!1)||c.hcOricDetached)c.hcOrigStyle={display:c.style.display,height:c.style.height,overflow:c.style.overflow},b={display:"block",overflow:"hidden"},c!==this.renderTo&&(b.height=0),a.css(c,b),c.offsetWidth||c.style.setProperty("display","block","important");c=c.parentNode;if(c===m.body)break}},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var e,d=this.options,h=d.chart,p,g;e=this.renderTo;var f=a.uniqueKey(),k;e||
(this.renderTo=e=h.renderTo);c(e)&&(this.renderTo=e=m.getElementById(e));e||a.error(13,!0);p=I(E(e,"data-highcharts-chart"));D(p)&&t[p]&&t[p].hasRendered&&t[p].destroy();E(e,"data-highcharts-chart",this.index);e.innerHTML="";h.skipClone||e.offsetWidth||this.temporaryDisplay();this.getChartSize();p=this.chartWidth;g=this.chartHeight;k=b({position:"relative",overflow:"hidden",width:p+"px",height:g+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},h.style);
this.container=e=l("div",{id:f},k,e);this._cursor=e.style.cursor;this.renderer=new (a[h.renderer]||Q)(e,p,g,null,h.forExport,d.exporting&&d.exporting.allowHTML);this.setClassName(h.className);this.renderer.setStyle(h.style);this.renderer.chartIndex=this.index},getMargins:function(a){var b=this.spacing,c=this.margin,e=this.titleOffset;this.resetMargins();e&&!d(c[0])&&(this.plotTop=Math.max(this.plotTop,e+this.options.title.margin+b[0]));this.legend.display&&this.legend.adjustMargins(c,b);this.extraMargin&&
(this[this.extraMargin.type]=(this[this.extraMargin.type]||0)+this.extraMargin.value);this.extraTopMargin&&(this.plotTop+=this.extraTopMargin);a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],c=a.margin;a.hasCartesianSeries&&k(a.axes,function(a){a.visible&&a.getOffset()});k(q,function(e,h){d(c[h])||(a[e]+=b[h])});a.setChartSize()},reflow:function(a){var b=this,c=b.options.chart,e=b.renderTo,h=d(c.width)&&d(c.height),p=c.width||y(e,"width"),c=c.height||y(e,"height"),
e=a?a.target:O;if(!h&&!b.isPrinting&&p&&c&&(e===O||e===m)){if(p!==b.containerWidth||c!==b.containerHeight)clearTimeout(b.reflowTimeout),b.reflowTimeout=H(function(){b.container&&b.setSize(void 0,void 0,!1)},a?100:0);b.containerWidth=p;b.containerHeight=c}},initReflow:function(){var a=this,b;b=C(O,"resize",function(b){a.reflow(b)});C(a,"destroy",b)},setSize:function(b,c,e){var d=this,h=d.renderer;d.isResizing+=1;a.setAnimation(e,d);d.oldChartHeight=d.chartHeight;d.oldChartWidth=d.chartWidth;void 0!==
b&&(d.options.chart.width=b);void 0!==c&&(d.options.chart.height=c);d.getChartSize();b=h.globalAnimation;(b?A:g)(d.container,{width:d.chartWidth+"px",height:d.chartHeight+"px"},b);d.setChartSize(!0);h.setSize(d.chartWidth,d.chartHeight,e);k(d.axes,function(a){a.isDirty=!0;a.setScale()});d.isDirtyLegend=!0;d.isDirtyBox=!0;d.layOutTitles();d.getMargins();d.redraw(e);d.oldChartHeight=null;v(d,"resize");H(function(){d&&v(d,"endResize",null,function(){--d.isResizing})},F(b).duration)},setChartSize:function(a){function b(a){a=
f[a]||0;return Math.max(m||a,a)/2}var c=this.inverted,e=this.renderer,d=this.chartWidth,h=this.chartHeight,p=this.options.chart,g=this.spacing,f=this.clipOffset,q,n,l,z,m;this.plotLeft=q=Math.round(this.plotLeft);this.plotTop=n=Math.round(this.plotTop);this.plotWidth=l=Math.max(0,Math.round(d-q-this.marginRight));this.plotHeight=z=Math.max(0,Math.round(h-n-this.marginBottom));this.plotSizeX=c?z:l;this.plotSizeY=c?l:z;this.plotBorderWidth=p.plotBorderWidth||0;this.spacingBox=e.spacingBox={x:g[3],y:g[0],
width:d-g[3]-g[1],height:h-g[0]-g[2]};this.plotBox=e.plotBox={x:q,y:n,width:l,height:z};m=2*Math.floor(this.plotBorderWidth/2);c=Math.ceil(b(3));e=Math.ceil(b(0));this.clipBox={x:c,y:e,width:Math.floor(this.plotSizeX-b(1)-c),height:Math.max(0,Math.floor(this.plotSizeY-b(2)-e))};a||k(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()})},resetMargins:function(){var a=this,b=a.options.chart;k(["margin","spacing"],function(c){var e=b[c],d=J(e)?e:[e,e,e,e];k(["Top","Right","Bottom","Left"],function(e,
h){a[c][h]=z(b[c+e],d[h])})});k(q,function(b,c){a[b]=z(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,0];a.clipOffset=[]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=this.chartWidth,e=this.chartHeight,d=this.chartBackground,h=this.plotBackground,p=this.plotBorder,g,f=this.plotBGImage,k=a.backgroundColor,q=a.plotBackgroundColor,l=a.plotBackgroundImage,n,z=this.plotLeft,m=this.plotTop,w=this.plotWidth,I=this.plotHeight,v=this.plotBox,r=this.clipRect,B=this.clipBox,y="animate";
d||(this.chartBackground=d=b.rect().addClass("highcharts-background").add(),y="attr");g=a.borderWidth||0;n=g+(a.shadow?8:0);k={fill:k||"none"};if(g||d["stroke-width"])k.stroke=a.borderColor,k["stroke-width"]=g;d.attr(k).shadow(a.shadow);d[y]({x:n/2,y:n/2,width:c-n-g%2,height:e-n-g%2,r:a.borderRadius});y="animate";h||(y="attr",this.plotBackground=h=b.rect().addClass("highcharts-plot-background").add());h[y](v);h.attr({fill:q||"none"}).shadow(a.plotShadow);l&&(f?f.animate(v):this.plotBGImage=b.image(l,
z,m,w,I).add());r?r.animate({width:B.width,height:B.height}):this.clipRect=b.clipRect(B);y="animate";p||(y="attr",this.plotBorder=p=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());p.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});p[y](p.crisp({x:z,y:m,width:w,height:I},-p.strokeWidth()));this.isDirtyBox=!1},propFromSeries:function(){var a=this,b=a.options.chart,c,e=a.options.series,d,p;k(["inverted","angular","polar"],function(g){c=h[b.type||b.defaultSeriesType];
p=b[g]||c&&c.prototype[g];for(d=e&&e.length;!p&&d--;)(c=h[e[d].type])&&c.prototype[g]&&(p=!0);a[g]=p})},linkSeries:function(){var a=this,b=a.series;k(b,function(a){a.linkedSeries.length=0});k(b,function(b){var e=b.options.linkedTo;c(e)&&(e=":previous"===e?a.series[b.index-1]:a.get(e))&&e.linkedParent!==b&&(e.linkedSeries.push(b),b.linkedParent=e,b.visible=z(b.options.visible,e.options.visible,b.visible))})},renderSeries:function(){k(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=
this,c=a.options.labels;c.items&&k(c.items,function(e){var d=b(c.style,e.style),h=I(d.left)+a.plotLeft,p=I(d.top)+a.plotTop+12;delete d.left;delete d.top;a.renderer.text(e.html,h,p).attr({zIndex:2}).css(d).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,e,d,h;this.setTitle();this.legend=new G(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;e=this.plotHeight-=21;k(a,function(a){a.setScale()});this.getAxisMargins();d=
1.1<c/this.plotWidth;h=1.05<e/this.plotHeight;if(d||h)k(a,function(a){(a.horiz&&d||!a.horiz&&h)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&k(a,function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=this;a=B(!0,this.options.credits,a);a.enabled&&!this.credits&&
(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(O.location.href=a.href)}).attr({align:a.position.align,zIndex:8}).css(a.style).add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var b=this,c=b.axes,e=b.series,d=b.container,h,p=d&&d.parentNode;v(b,"destroy");b.renderer.forExport?a.erase(t,b):t[b.index]=void 0;a.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");
L(b);for(h=c.length;h--;)c[h]=c[h].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(h=e.length;h--;)e[h]=e[h].destroy();k("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "),function(a){var c=b[a];c&&c.destroy&&(b[a]=c.destroy())});d&&(d.innerHTML="",L(d),p&&u(d));K(b,function(a,c){delete b[c]})},isReadyToRender:function(){var a=this;return P||O!=O.top||
"complete"===m.readyState?!0:(m.attachEvent("onreadystatechange",function(){m.detachEvent("onreadystatechange",a.firstRender);"complete"===m.readyState&&a.firstRender()}),!1)},firstRender:function(){var a=this,b=a.options;if(a.isReadyToRender()){a.getContainer();v(a,"init");a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();k(b.series||[],function(b){a.initSeries(b)});a.linkSeries();v(a,"beforeRender");p&&(a.pointer=new p(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();
a.temporaryDisplay(!0)}},onload:function(){k([this.callback].concat(this.callbacks),function(a){a&&void 0!==this.index&&a.apply(this,[this])},this);v(this,"load");v(this,"render");d(this.index)&&!1!==this.options.chart.reflow&&this.initReflow();this.onload=null}})})(M);(function(a){var C,A=a.each,F=a.extend,E=a.erase,m=a.fireEvent,f=a.format,l=a.isArray,r=a.isNumber,u=a.pick,t=a.removeEvent;a.Point=C=function(){};a.Point.prototype={init:function(a,d,f){this.series=a;this.color=a.color;this.applyOptions(d,
f);a.options.colorByPoint?(d=a.options.colors||a.chart.options.colors,this.color=this.color||d[a.colorCounter],d=d.length,f=a.colorCounter,a.colorCounter++,a.colorCounter===d&&(a.colorCounter=0)):f=a.colorIndex;this.colorIndex=u(this.colorIndex,f);a.chart.pointCount++;return this},applyOptions:function(a,d){var g=this.series,b=g.options.pointValKey||g.pointValKey;a=C.prototype.optionsToObject.call(this,a);F(this,a);this.options=this.options?F(this.options,a):a;a.group&&delete this.group;b&&(this.y=
this[b]);this.isNull=u(this.isValid&&!this.isValid(),null===this.x||!r(this.y,!0));this.selected&&(this.state="select");"name"in this&&void 0===d&&g.xAxis&&g.xAxis.hasNames&&(this.x=g.xAxis.nameToX(this));void 0===this.x&&g&&(this.x=void 0===d?g.autoIncrement(this):d);return this},optionsToObject:function(a){var d={},g=this.series,b=g.options.keys,e=b||g.pointArrayMap||["y"],f=e.length,m=0,n=0;if(r(a)||null===a)d[e[0]]=a;else if(l(a))for(!b&&a.length>f&&(g=typeof a[0],"string"===g?d.name=a[0]:"number"===
g&&(d.x=a[0]),m++);n<f;)b&&void 0===a[m]||(d[e[n]]=a[m]),m++,n++;else"object"===typeof a&&(d=a,a.dataLabels&&(g._hasPointLabels=!0),a.marker&&(g._hasPointMarkers=!0));return d},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?
" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var a=this.series,d=a.zones,a=a.zoneAxis||"y",f=0,b;for(b=d[f];this[a]>=b.value;)b=d[++f];b&&b.color&&!this.options.color&&(this.color=b.color);return b},destroy:function(){var a=this.series.chart,d=a.hoverPoints,f;a.pointCount--;d&&(this.setState(),E(d,this),d.length||(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)t(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);
for(f in this)this[f]=null},destroyElements:function(){for(var a=["graphic","dataLabel","dataLabelUpper","connector","shadowGroup"],d,f=6;f--;)d=a[f],this[d]&&(this[d]=this[d].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var d=this.series,g=d.tooltipOptions,b=u(g.valueDecimals,""),
e=g.valuePrefix||"",l=g.valueSuffix||"";A(d.pointArrayMap||["y"],function(d){d="{point."+d;if(e||l)a=a.replace(d+"}",e+d+"}"+l);a=a.replace(d+"}",d+":,."+b+"f}")});return f(a,{point:this,series:this.series})},firePointEvent:function(a,d,f){var b=this,e=this.series.options;(e.point.events[a]||b.options&&b.options.events&&b.options.events[a])&&this.importEvents();"click"===a&&e.allowPointSelect&&(f=function(a){b.select&&b.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});m(this,a,d,f)},visible:!0}})(M);
(function(a){var C=a.addEvent,A=a.animObject,F=a.arrayMax,E=a.arrayMin,m=a.correctFloat,f=a.Date,l=a.defaultOptions,r=a.defaultPlotOptions,u=a.defined,t=a.each,g=a.erase,d=a.extend,k=a.fireEvent,b=a.grep,e=a.isArray,v=a.isNumber,y=a.isString,n=a.merge,D=a.objectEach,J=a.pick,c=a.removeEvent,G=a.splat,q=a.SVGElement,B=a.syncTimeout,K=a.win;a.Series=a.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",radius:4,
states:{hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":a.numberFormat(this.y,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0,padding:5},cropThreshold:300,pointRange:0,softThreshold:!0,states:{hover:{animation:{duration:50},lineWidthPlus:1,marker:{},
halo:{size:10,opacity:.25}},select:{marker:{}}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x","y"],coll:"series",init:function(a,b){var c=this,e,h=a.series,p;c.chart=a;c.options=b=c.setOptions(b);c.linkedSeries=[];c.bindAxes();d(c,{name:b.name,state:"",visible:!1!==b.visible,selected:!0===b.selected});e=b.events;D(e,function(a,b){C(c,b,a)});if(e&&
e.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;c.getColor();c.getSymbol();t(c.parallelArrays,function(a){c[a+"Data"]=[]});c.setData(b.data,!1);c.isCartesian&&(a.hasCartesianSeries=!0);h.length&&(p=h[h.length-1]);c._i=J(p&&p._i,-1)+1;a.orderSeries(this.insert(h))},insert:function(a){var b=this.options.index,c;if(v(b)){for(c=a.length;c--;)if(b>=J(a[c].options.index,a[c]._i)){a.splice(c+1,0,this);break}-1===c&&a.unshift(this);c+=1}else a.push(this);return J(c,
a.length-1)},bindAxes:function(){var b=this,c=b.options,e=b.chart,d;t(b.axisTypes||[],function(h){t(e[h],function(a){d=a.options;if(c[h]===d.index||void 0!==c[h]&&c[h]===d.id||void 0===c[h]&&0===d.index)b.insert(a.series),b[h]=a,a.isDirty=!0});b[h]||b.optionalAxis===h||a.error(18,!0)})},updateParallelArrays:function(a,b){var c=a.series,e=arguments,d=v(b)?function(e){var d="y"===e&&c.toYData?c.toYData(a):a[e];c[e+"Data"][b]=d}:function(a){Array.prototype[b].apply(c[a+"Data"],Array.prototype.slice.call(e,
2))};t(c.parallelArrays,d)},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,e=a.pointIntervalUnit,b=J(b,a.pointStart,0);this.pointInterval=c=J(this.pointInterval,a.pointInterval,1);e&&(a=new f(b),"day"===e?a=+a[f.hcSetDate](a[f.hcGetDate]()+c):"month"===e?a=+a[f.hcSetMonth](a[f.hcGetMonth]()+c):"year"===e&&(a=+a[f.hcSetFullYear](a[f.hcGetFullYear]()+c)),c=a-b);this.xIncrement=b+c;return b},setOptions:function(a){var b=this.chart,c=b.options,e=c.plotOptions,d=(b.userOptions||{}).plotOptions||
{},p=e[this.type];this.userOptions=a;b=n(p,e.series,a);this.tooltipOptions=n(l.tooltip,l.plotOptions.series&&l.plotOptions.series.tooltip,l.plotOptions[this.type].tooltip,c.tooltip.userOptions,e.series&&e.series.tooltip,e[this.type].tooltip,a.tooltip);this.stickyTracking=J(a.stickyTracking,d[this.type]&&d[this.type].stickyTracking,d.series&&d.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:b.stickyTracking);null===p.marker&&delete b.marker;this.zoneAxis=b.zoneAxis;a=this.zones=
(b.zones||[]).slice();!b.negativeColor&&!b.negativeFillColor||b.zones||a.push({value:b[this.zoneAxis+"Threshold"]||b.threshold||0,className:"highcharts-negative",color:b.negativeColor,fillColor:b.negativeFillColor});a.length&&u(a[a.length-1].value)&&a.push({color:this.color,fillColor:this.fillColor});return b},getCyclic:function(a,b,c){var e,d=this.chart,p=this.userOptions,f=a+"Index",g=a+"Counter",k=c?c.length:J(d.options.chart[a+"Count"],d[a+"Count"]);b||(e=J(p[f],p["_"+f]),u(e)||(d.series.length||
(d[g]=0),p["_"+f]=e=d[g]%k,d[g]+=1),c&&(b=c[e]));void 0!==e&&(this[f]=e);this[a]=b},getColor:function(){this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||r[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,setData:function(b,c,d,f){var h=this,p=h.points,g=p&&p.length||0,k,q=h.options,l=h.chart,n=null,m=h.xAxis,
z=q.turboThreshold,r=this.xData,B=this.yData,I=(k=h.pointArrayMap)&&k.length;b=b||[];k=b.length;c=J(c,!0);if(!1!==f&&k&&g===k&&!h.cropped&&!h.hasGroupedData&&h.visible)t(b,function(a,b){p[b].update&&a!==q.data[b]&&p[b].update(a,!1,null,!1)});else{h.xIncrement=null;h.colorCounter=0;t(this.parallelArrays,function(a){h[a+"Data"].length=0});if(z&&k>z){for(d=0;null===n&&d<k;)n=b[d],d++;if(v(n))for(d=0;d<k;d++)r[d]=this.autoIncrement(),B[d]=b[d];else if(e(n))if(I)for(d=0;d<k;d++)n=b[d],r[d]=n[0],B[d]=n.slice(1,
I+1);else for(d=0;d<k;d++)n=b[d],r[d]=n[0],B[d]=n[1];else a.error(12)}else for(d=0;d<k;d++)void 0!==b[d]&&(n={series:h},h.pointClass.prototype.applyOptions.apply(n,[b[d]]),h.updateParallelArrays(n,d));y(B[0])&&a.error(14,!0);h.data=[];h.options.data=h.userOptions.data=b;for(d=g;d--;)p[d]&&p[d].destroy&&p[d].destroy();m&&(m.minRange=m.userMinRange);h.isDirty=l.isDirtyBox=!0;h.isDirtyData=!!p;d=!1}"point"===q.legendType&&(this.processData(),this.generatePoints());c&&l.redraw(d)},processData:function(b){var c=
this.xData,e=this.yData,d=c.length,h;h=0;var p,f,g=this.xAxis,k,q=this.options;k=q.cropThreshold;var n=this.getExtremesFromAll||q.getExtremesFromAll,l=this.isCartesian,q=g&&g.val2lin,m=g&&g.isLog,v,r;if(l&&!this.isDirty&&!g.isDirty&&!this.yAxis.isDirty&&!b)return!1;g&&(b=g.getExtremes(),v=b.min,r=b.max);if(l&&this.sorted&&!n&&(!k||d>k||this.forceCrop))if(c[d-1]<v||c[0]>r)c=[],e=[];else if(c[0]<v||c[d-1]>r)h=this.cropData(this.xData,this.yData,v,r),c=h.xData,e=h.yData,h=h.start,p=!0;for(k=c.length||
1;--k;)d=m?q(c[k])-q(c[k-1]):c[k]-c[k-1],0<d&&(void 0===f||d<f)?f=d:0>d&&this.requireSorting&&a.error(15);this.cropped=p;this.cropStart=h;this.processedXData=c;this.processedYData=e;this.closestPointRange=f},cropData:function(a,b,c,e){var d=a.length,p=0,g=d,f=J(this.cropShoulder,1),k;for(k=0;k<d;k++)if(a[k]>=c){p=Math.max(0,k-f);break}for(c=k;c<d;c++)if(a[c]>e){g=c+f;break}return{xData:a.slice(p,g),yData:b.slice(p,g),start:p,end:g}},generatePoints:function(){var a=this.options,b=a.data,c=this.data,
e,d=this.processedXData,g=this.processedYData,f=this.pointClass,k=d.length,q=this.cropStart||0,n,l=this.hasGroupedData,a=a.keys,m,v=[],r;c||l||(c=[],c.length=b.length,c=this.data=c);a&&l&&(this.options.keys=!1);for(r=0;r<k;r++)n=q+r,l?(m=(new f).init(this,[d[r]].concat(G(g[r]))),m.dataGroup=this.groupMap[r]):(m=c[n])||void 0===b[n]||(c[n]=m=(new f).init(this,b[n],d[r])),m&&(m.index=n,v[r]=m);this.options.keys=a;if(c&&(k!==(e=c.length)||l))for(r=0;r<e;r++)r!==q||l||(r+=k),c[r]&&(c[r].destroyElements(),
c[r].plotX=void 0);this.data=c;this.points=v},getExtremes:function(a){var b=this.yAxis,c=this.processedXData,d,h=[],p=0;d=this.xAxis.getExtremes();var g=d.min,f=d.max,k,q,n,l;a=a||this.stackedYData||this.processedYData||[];d=a.length;for(l=0;l<d;l++)if(q=c[l],n=a[l],k=(v(n,!0)||e(n))&&(!b.positiveValuesOnly||n.length||0<n),q=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(c[l]||q)>=g&&(c[l]||q)<=f,k&&q)if(k=n.length)for(;k--;)null!==n[k]&&(h[p++]=n[k]);else h[p++]=n;this.dataMin=
E(h);this.dataMax=F(h)},translate:function(){this.processedXData||this.processData();this.generatePoints();var a=this.options,b=a.stacking,c=this.xAxis,e=c.categories,d=this.yAxis,g=this.points,f=g.length,k=!!this.modifyValue,q=a.pointPlacement,n="between"===q||v(q),l=a.threshold,r=a.startFromThreshold?l:0,B,y,t,G,D=Number.MAX_VALUE;"between"===q&&(q=.5);v(q)&&(q*=J(a.pointRange||c.pointRange));for(a=0;a<f;a++){var K=g[a],A=K.x,C=K.y;y=K.low;var E=b&&d.stacks[(this.negStacks&&C<(r?0:l)?"-":"")+this.stackKey],
F;d.positiveValuesOnly&&null!==C&&0>=C&&(K.isNull=!0);K.plotX=B=m(Math.min(Math.max(-1E5,c.translate(A,0,0,0,1,q,"flags"===this.type)),1E5));b&&this.visible&&!K.isNull&&E&&E[A]&&(G=this.getStackIndicator(G,A,this.index),F=E[A],C=F.points[G.key],y=C[0],C=C[1],y===r&&G.key===E[A].base&&(y=J(l,d.min)),d.positiveValuesOnly&&0>=y&&(y=null),K.total=K.stackTotal=F.total,K.percentage=F.total&&K.y/F.total*100,K.stackY=C,F.setOffset(this.pointXOffset||0,this.barW||0));K.yBottom=u(y)?d.translate(y,0,1,0,1):
null;k&&(C=this.modifyValue(C,K));K.plotY=y="number"===typeof C&&Infinity!==C?Math.min(Math.max(-1E5,d.translate(C,0,1,0,1)),1E5):void 0;K.isInside=void 0!==y&&0<=y&&y<=d.len&&0<=B&&B<=c.len;K.clientX=n?m(c.translate(A,0,0,0,1,q)):B;K.negative=K.y<(l||0);K.category=e&&void 0!==e[K.x]?e[K.x]:K.x;K.isNull||(void 0!==t&&(D=Math.min(D,Math.abs(B-t))),t=B);K.zone=this.zones.length&&K.getZone()}this.closestPointRangePx=D},getValidPoints:function(a,c){var e=this.chart;return b(a||this.points||[],function(a){return c&&
!e.isInsidePlot(a.plotX,a.plotY,e.inverted)?!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,e=b.renderer,d=b.inverted,p=this.clipBox,g=p||b.clipBox,f=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,g.height,c.xAxis,c.yAxis].join(),k=b[f],q=b[f+"m"];k||(a&&(g.width=0,b[f+"m"]=q=e.clipRect(-99,d?-b.plotLeft:-b.plotTop,99,d?b.chartWidth:b.chartHeight)),b[f]=k=e.clipRect(g),k.count={length:0});a&&!k.count[this.index]&&(k.count[this.index]=!0,k.count.length+=1);!1!==c.clip&&
(this.group.clip(a||p?k:b.clipRect),this.markerGroup.clip(q),this.sharedClipKey=f);a||(k.count[this.index]&&(delete k.count[this.index],--k.count.length),0===k.count.length&&f&&b[f]&&(p||(b[f]=b[f].destroy()),b[f+"m"]&&(b[f+"m"]=b[f+"m"].destroy())))},animate:function(a){var b=this.chart,c=A(this.options.animation),e;a?this.setClip(c):(e=this.sharedClipKey,(a=b[e])&&a.animate({width:b.plotSizeX},c),b[e+"m"]&&b[e+"m"].animate({width:b.plotSizeX+99},c),this.animate=null)},afterAnimate:function(){this.setClip();
k(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=this.points,b=this.chart,c,e,d,f,g=this.options.marker,k,q,n,l,m=this[this.specialGroup]||this.markerGroup,r=J(g.enabled,this.xAxis.isRadial?!0:null,this.closestPointRangePx>=2*g.radius);if(!1!==g.enabled||this._hasPointMarkers)for(e=0;e<a.length;e++)d=a[e],c=d.plotY,f=d.graphic,k=d.marker||{},q=!!d.marker,n=r&&void 0===k.enabled||k.enabled,l=d.isInside,n&&v(c)&&null!==d.y?(c=J(k.symbol,this.symbol),d.hasImage=0===c.indexOf("url"),
n=this.markerAttribs(d,d.selected&&"select"),f?f[l?"show":"hide"](!0).animate(n):l&&(0<n.width||d.hasImage)&&(d.graphic=f=b.renderer.symbol(c,n.x,n.y,n.width,n.height,q?k:g).add(m)),f&&f.attr(this.pointAttribs(d,d.selected&&"select")),f&&f.addClass(d.getClassName(),!0)):f&&(d.graphic=f.destroy())},markerAttribs:function(a,b){var c=this.options.marker,e=a.marker||{},d=J(e.radius,c.radius);b&&(c=c.states[b],b=e.states&&e.states[b],d=J(b&&b.radius,c&&c.radius,d+(c&&c.radiusPlus||0)));a.hasImage&&(d=
0);a={x:Math.floor(a.plotX)-d,y:a.plotY-d};d&&(a.width=a.height=2*d);return a},pointAttribs:function(a,b){var c=this.options.marker,e=a&&a.options,d=e&&e.marker||{},f=this.color,g=e&&e.color,p=a&&a.color,e=J(d.lineWidth,c.lineWidth);a=a&&a.zone&&a.zone.color;f=g||a||p||f;a=d.fillColor||c.fillColor||f;f=d.lineColor||c.lineColor||f;b&&(c=c.states[b],b=d.states&&d.states[b]||{},e=J(b.lineWidth,c.lineWidth,e+J(b.lineWidthPlus,c.lineWidthPlus,0)),a=b.fillColor||c.fillColor||a,f=b.lineColor||c.lineColor||
f);return{stroke:f,"stroke-width":e,fill:a}},destroy:function(){var a=this,b=a.chart,e=/AppleWebKit\/533/.test(K.navigator.userAgent),d,h,f=a.data||[],n,l;k(a,"destroy");c(a);t(a.axisTypes||[],function(b){(l=a[b])&&l.series&&(g(l.series,a),l.isDirty=l.forceRedraw=!0)});a.legendItem&&a.chart.legend.destroyItem(a);for(h=f.length;h--;)(n=f[h])&&n.destroy&&n.destroy();a.points=null;clearTimeout(a.animationTimeout);D(a,function(a,b){a instanceof q&&!a.survive&&(d=e&&"group"===b?"hide":"destroy",a[d]())});
b.hoverSeries===a&&(b.hoverSeries=null);g(b.series,a);b.orderSeries();D(a,function(b,c){delete a[c]})},getGraphPath:function(a,b,c){var e=this,d=e.options,f=d.step,g,p=[],k=[],q;a=a||e.points;(g=a.reversed)&&a.reverse();(f={right:1,center:2}[f]||f&&3)&&g&&(f=4-f);!d.connectNulls||b||c||(a=this.getValidPoints(a));t(a,function(h,g){var n=h.plotX,l=h.plotY,m=a[g-1];(h.leftCliff||m&&m.rightCliff)&&!c&&(q=!0);h.isNull&&!u(b)&&0<g?q=!d.connectNulls:h.isNull&&!b?q=!0:(0===g||q?g=["M",h.plotX,h.plotY]:e.getPointSpline?
g=e.getPointSpline(a,h,g):f?(g=1===f?["L",m.plotX,l]:2===f?["L",(m.plotX+n)/2,m.plotY,"L",(m.plotX+n)/2,l]:["L",n,m.plotY],g.push("L",n,l)):g=["L",n,l],k.push(h.x),f&&k.push(h.x),p.push.apply(p,g),q=!1)});p.xMap=k;return e.graphPath=p},drawGraph:function(){var a=this,b=this.options,c=(this.gappedPath||this.getGraphPath).call(this),e=[["graph","highcharts-graph",b.lineColor||this.color,b.dashStyle]];t(this.zones,function(c,d){e.push(["zone-graph-"+d,"highcharts-graph highcharts-zone-graph-"+d+" "+
(c.className||""),c.color||a.color,c.dashStyle||b.dashStyle])});t(e,function(e,d){var h=e[0],f=a[h];f?(f.endX=c.xMap,f.animate({d:c})):c.length&&(a[h]=a.chart.renderer.path(c).addClass(e[1]).attr({zIndex:1}).add(a.group),f={stroke:e[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},e[3]?f.dashstyle=e[3]:"square"!==b.linecap&&(f["stroke-linecap"]=f["stroke-linejoin"]="round"),f=a[h].attr(f).shadow(2>d&&b.shadow));f&&(f.startX=c.xMap,f.isArea=c.isArea)})},applyZones:function(){var a=
this,b=this.chart,c=b.renderer,e=this.zones,d,f,g=this.clips||[],k,q=this.graph,n=this.area,l=Math.max(b.chartWidth,b.chartHeight),m=this[(this.zoneAxis||"y")+"Axis"],r,v,B=b.inverted,y,u,G,D,K=!1;e.length&&(q||n)&&m&&void 0!==m.min&&(v=m.reversed,y=m.horiz,q&&q.hide(),n&&n.hide(),r=m.getExtremes(),t(e,function(e,h){d=v?y?b.plotWidth:0:y?0:m.toPixels(r.min);d=Math.min(Math.max(J(f,d),0),l);f=Math.min(Math.max(Math.round(m.toPixels(J(e.value,r.max),!0)),0),l);K&&(d=f=m.toPixels(r.max));u=Math.abs(d-
f);G=Math.min(d,f);D=Math.max(d,f);m.isXAxis?(k={x:B?D:G,y:0,width:u,height:l},y||(k.x=b.plotHeight-k.x)):(k={x:0,y:B?D:G,width:l,height:u},y&&(k.y=b.plotWidth-k.y));B&&c.isVML&&(k=m.isXAxis?{x:0,y:v?G:D,height:k.width,width:b.chartWidth}:{x:k.y-b.plotLeft-b.spacingBox.x,y:0,width:k.height,height:b.chartHeight});g[h]?g[h].animate(k):(g[h]=c.clipRect(k),q&&a["zone-graph-"+h].clip(g[h]),n&&a["zone-area-"+h].clip(g[h]));K=e.value>r.max}),this.clips=g)},invertGroups:function(a){function b(){t(["group",
"markerGroup"],function(b){c[b]&&(e.renderer.isVML&&c[b].attr({width:c.yAxis.len,height:c.xAxis.len}),c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,e=c.chart,d;c.xAxis&&(d=C(e,"resize",b),C(c,"destroy",d),b(a),c.invertGroups=b)},plotGroup:function(a,b,c,e,d){var h=this[a],f=!h;f&&(this[a]=h=this.chart.renderer.g().attr({zIndex:e||.1}).add(d));h.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series highcharts-color-"+this.colorIndex+
" "+(this.options.className||""),!0);h.attr({visibility:c})[f?"attr":"animate"](this.getPlotBox());return h},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;a.inverted&&(b=c,c=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,c,e=a.options,d=!!a.animate&&b.renderer.isSVG&&A(e.animation).duration,f=a.visible?"inherit":"hidden",g=e.zIndex,k=a.hasRendered,q=b.seriesGroup,n=b.inverted;c=a.plotGroup("group",
"series",f,g,q);a.markerGroup=a.plotGroup("markerGroup","markers",f,g,q);d&&a.animate(!0);c.inverted=a.isCartesian?n:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.drawDataLabels&&a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(n);!1===e.clip||a.sharedClipKey||k||c.clip(b.clipRect);d&&a.animate();k||(a.animationTimeout=B(function(){a.afterAnimate()},d));a.isDirty=!1;a.hasRendered=!0},redraw:function(){var a=this.chart,
b=this.isDirty||this.isDirtyData,c=this.group,e=this.xAxis,d=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:J(e&&e.left,a.plotLeft),translateY:J(d&&d.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,e=this.yAxis,d=this.chart.inverted;return this.searchKDTree({clientX:d?c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:d?e.len-a.chartX+e.pos:a.chartY-e.pos},b)},
buildKDTree:function(){function a(c,e,d){var h,f;if(f=c&&c.length)return h=b.kdAxisArray[e%d],c.sort(function(a,b){return a[h]-b[h]}),f=Math.floor(f/2),{point:c[f],left:a(c.slice(0,f),e+1,d),right:a(c.slice(f+1),e+1,d)}}this.buildingKdTree=!0;var b=this,c=-1<b.options.findNearestPointBy.indexOf("y")?2:1;delete b.kdTree;B(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c);b.buildingKdTree=!1},b.options.kdNow?0:1)},searchKDTree:function(a,b){function c(a,b,h,k){var p=b.point,q=e.kdAxisArray[h%
k],n,l,m=p;l=u(a[d])&&u(p[d])?Math.pow(a[d]-p[d],2):null;n=u(a[f])&&u(p[f])?Math.pow(a[f]-p[f],2):null;n=(l||0)+(n||0);p.dist=u(n)?Math.sqrt(n):Number.MAX_VALUE;p.distX=u(l)?Math.sqrt(l):Number.MAX_VALUE;q=a[q]-p[q];n=0>q?"left":"right";l=0>q?"right":"left";b[n]&&(n=c(a,b[n],h+1,k),m=n[g]<m[g]?n:p);b[l]&&Math.sqrt(q*q)<m[g]&&(a=c(a,b[l],h+1,k),m=a[g]<m[g]?a:m);return m}var e=this,d=this.kdAxisArray[0],f=this.kdAxisArray[1],g=b?"distX":"dist";b=-1<e.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||
this.buildingKdTree||this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,b,b)}})})(M);(function(a){var C=a.Axis,A=a.Chart,F=a.correctFloat,E=a.defined,m=a.destroyObjectProperties,f=a.each,l=a.format,r=a.objectEach,u=a.pick,t=a.Series;a.StackItem=function(a,d,f,b,e){var g=a.chart.inverted;this.axis=a;this.isNegative=f;this.options=d;this.x=b;this.total=null;this.points={};this.stack=e;this.rightCliff=this.leftCliff=0;this.alignOptions={align:d.align||(g?f?"left":"right":"center"),verticalAlign:d.verticalAlign||
(g?"middle":f?"bottom":"top"),y:u(d.y,g?4:f?14:-6),x:u(d.x,g?f?-6:6:0)};this.textAlign=d.textAlign||(g?f?"right":"left":"center")};a.StackItem.prototype={destroy:function(){m(this,this.axis)},render:function(a){var d=this.options,f=d.format,f=f?l(f,this):d.formatter.call(this);this.label?this.label.attr({text:f,visibility:"hidden"}):this.label=this.axis.chart.renderer.text(f,null,null,d.useHTML).css(d.style).attr({align:this.textAlign,rotation:d.rotation,visibility:"hidden"}).add(a)},setOffset:function(a,
d){var f=this.axis,b=f.chart,e=f.translate(f.usePercentage?100:this.total,0,0,0,1),f=f.translate(0),f=Math.abs(e-f);a=b.xAxis[0].translate(this.x)+a;e=this.getStackBox(b,this,a,e,d,f);if(d=this.label)d.align(this.alignOptions,null,e),e=d.alignAttr,d[!1===this.options.crop||b.isInsidePlot(e.x,e.y)?"show":"hide"](!0)},getStackBox:function(a,d,f,b,e,l){var g=d.axis.reversed,k=a.inverted;a=a.plotHeight;d=d.isNegative&&!g||!d.isNegative&&g;return{x:k?d?b:b-l:f,y:k?a-f-e:d?a-b-l:a-b,width:k?l:e,height:k?
e:l}}};A.prototype.getStacks=function(){var a=this;f(a.yAxis,function(a){a.stacks&&a.hasVisibleSeries&&(a.oldStacks=a.stacks)});f(a.series,function(d){!d.options.stacking||!0!==d.visible&&!1!==a.options.chart.ignoreHiddenSeries||(d.stackKey=d.type+u(d.options.stack,""))})};C.prototype.buildStacks=function(){var a=this.series,d=u(this.options.reversedStacks,!0),f=a.length,b;if(!this.isXAxis){this.usePercentage=!1;for(b=f;b--;)a[d?b:f-b-1].setStackedPoints();if(this.usePercentage)for(b=0;b<f;b++)a[b].setPercentStacks()}};
C.prototype.renderStackTotals=function(){var a=this.chart,d=a.renderer,f=this.stacks,b=this.stackTotalGroup;b||(this.stackTotalGroup=b=d.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());b.translate(a.plotLeft,a.plotTop);r(f,function(a){r(a,function(a){a.render(b)})})};C.prototype.resetStacks=function(){var a=this,d=a.stacks;a.isXAxis||r(d,function(d){r(d,function(b,e){b.touched<a.stacksTouched?(b.destroy(),delete d[e]):(b.total=null,b.cum=null)})})};C.prototype.cleanStacks=function(){var a;
this.isXAxis||(this.oldStacks&&(a=this.stacks=this.oldStacks),r(a,function(a){r(a,function(a){a.cum=a.total})}))};t.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var f=this.processedXData,d=this.processedYData,k=[],b=d.length,e=this.options,l=e.threshold,m=e.startFromThreshold?l:0,n=e.stack,e=e.stacking,r=this.stackKey,t="-"+r,c=this.negStacks,G=this.yAxis,q=G.stacks,B=G.oldStacks,K,p,z,I,A,h,w;G.stacksTouched+=
1;for(A=0;A<b;A++)h=f[A],w=d[A],K=this.getStackIndicator(K,h,this.index),I=K.key,z=(p=c&&w<(m?0:l))?t:r,q[z]||(q[z]={}),q[z][h]||(B[z]&&B[z][h]?(q[z][h]=B[z][h],q[z][h].total=null):q[z][h]=new a.StackItem(G,G.options.stackLabels,p,h,n)),z=q[z][h],null!==w&&(z.points[I]=z.points[this.index]=[u(z.cum,m)],E(z.cum)||(z.base=I),z.touched=G.stacksTouched,0<K.index&&!1===this.singleStacks&&(z.points[I][0]=z.points[this.index+","+h+",0"][0])),"percent"===e?(p=p?r:t,c&&q[p]&&q[p][h]?(p=q[p][h],z.total=p.total=
Math.max(p.total,z.total)+Math.abs(w)||0):z.total=F(z.total+(Math.abs(w)||0))):z.total=F(z.total+(w||0)),z.cum=u(z.cum,m)+(w||0),null!==w&&(z.points[I].push(z.cum),k[A]=z.cum);"percent"===e&&(G.usePercentage=!0);this.stackedYData=k;G.oldStacks={}}};t.prototype.setPercentStacks=function(){var a=this,d=a.stackKey,k=a.yAxis.stacks,b=a.processedXData,e;f([d,"-"+d],function(d){for(var f=b.length,g,l;f--;)if(g=b[f],e=a.getStackIndicator(e,g,a.index,d),g=(l=k[d]&&k[d][g])&&l.points[e.key])l=l.total?100/
l.total:0,g[0]=F(g[0]*l),g[1]=F(g[1]*l),a.stackedYData[f]=g[1]})};t.prototype.getStackIndicator=function(a,d,f,b){!E(a)||a.x!==d||b&&a.key!==b?a={x:d,index:0,key:b}:a.index++;a.key=[f,d,a.index].join();return a}})(M);(function(a){var C=a.addEvent,A=a.animate,F=a.Axis,E=a.createElement,m=a.css,f=a.defined,l=a.each,r=a.erase,u=a.extend,t=a.fireEvent,g=a.inArray,d=a.isNumber,k=a.isObject,b=a.isArray,e=a.merge,v=a.objectEach,y=a.pick,n=a.Point,D=a.Series,J=a.seriesTypes,c=a.setAnimation,G=a.splat;u(a.Chart.prototype,
{addSeries:function(a,b,c){var e,d=this;a&&(b=y(b,!0),t(d,"addSeries",{options:a},function(){e=d.initSeries(a);d.isDirtyLegend=!0;d.linkSeries();b&&d.redraw(c)}));return e},addAxis:function(a,b,c,d){var f=b?"xAxis":"yAxis",g=this.options;a=e(a,{index:this[f].length,isX:b});b=new F(this,a);g[f]=G(g[f]||{});g[f].push(a);y(c,!0)&&this.redraw(d);return b},showLoading:function(a){var b=this,c=b.options,e=b.loadingDiv,d=c.loading,f=function(){e&&m(e,{left:b.plotLeft+"px",top:b.plotTop+"px",width:b.plotWidth+
"px",height:b.plotHeight+"px"})};e||(b.loadingDiv=e=E("div",{className:"highcharts-loading highcharts-loading-hidden"},null,b.container),b.loadingSpan=E("span",{className:"highcharts-loading-inner"},null,e),C(b,"redraw",f));e.className="highcharts-loading";b.loadingSpan.innerHTML=a||c.lang.loading;m(e,u(d.style,{zIndex:10}));m(b.loadingSpan,d.labelStyle);b.loadingShown||(m(e,{opacity:0,display:""}),A(e,{opacity:d.style.opacity||.5},{duration:d.showDuration||0}));b.loadingShown=!0;f()},hideLoading:function(){var a=
this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",A(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){m(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions tooltip".split(" "),update:function(a,b,c){var k=this,n={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},q=a.chart,m,h,r=[];if(q){e(!0,k.options.chart,q);"className"in q&&k.setClassName(q.className);if("inverted"in q||"polar"in q)k.propFromSeries(),m=!0;"alignTicks"in q&&(m=!0);v(q,function(a,b){-1!==g("chart."+b,k.propsRequireUpdateSeries)&&(h=!0);-1!==g(b,k.propsRequireDirtyBox)&&
(k.isDirtyBox=!0)});"style"in q&&k.renderer.setStyle(q.style)}a.colors&&(this.options.colors=a.colors);a.plotOptions&&e(!0,this.options.plotOptions,a.plotOptions);v(a,function(a,b){if(k[b]&&"function"===typeof k[b].update)k[b].update(a,!1);else if("function"===typeof k[n[b]])k[n[b]](a);"chart"!==b&&-1!==g(b,k.propsRequireUpdateSeries)&&(h=!0)});l("xAxis yAxis zAxis series colorAxis pane".split(" "),function(b){a[b]&&(l(G(a[b]),function(a,e){(e=f(a.id)&&k.get(a.id)||k[b][e])&&e.coll===b&&(e.update(a,
!1),c&&(e.touched=!0));if(!e&&c)if("series"===b)k.addSeries(a,!1).touched=!0;else if("xAxis"===b||"yAxis"===b)k.addAxis(a,"xAxis"===b,!1).touched=!0}),c&&l(k[b],function(a){a.touched?delete a.touched:r.push(a)}))});l(r,function(a){a.remove(!1)});m&&l(k.axes,function(a){a.update({},!1)});h&&l(k.series,function(a){a.update({},!1)});a.loading&&e(!0,k.options.loading,a.loading);m=q&&q.width;q=q&&q.height;d(m)&&m!==k.chartWidth||d(q)&&q!==k.chartHeight?k.setSize(m,q):y(b,!0)&&k.redraw()},setSubtitle:function(a){this.setTitle(void 0,
a)}});u(n.prototype,{update:function(a,b,c,e){function d(){f.applyOptions(a);null===f.y&&h&&(f.graphic=h.destroy());k(a,!0)&&(h&&h.element&&a&&a.marker&&void 0!==a.marker.symbol&&(f.graphic=h.destroy()),a&&a.dataLabels&&f.dataLabel&&(f.dataLabel=f.dataLabel.destroy()));p=f.index;g.updateParallelArrays(f,p);q.data[p]=k(q.data[p],!0)||k(a,!0)?f.options:a;g.isDirty=g.isDirtyData=!0;!g.fixedBox&&g.hasCartesianSeries&&(l.isDirtyBox=!0);"point"===q.legendType&&(l.isDirtyLegend=!0);b&&l.redraw(c)}var f=
this,g=f.series,h=f.graphic,p,l=g.chart,q=g.options;b=y(b,!0);!1===e?d():f.firePointEvent("update",{options:a},d)},remove:function(a,b){this.series.removePoint(g(this,this.series.data),a,b)}});u(D.prototype,{addPoint:function(a,b,c,e){var d=this.options,f=this.data,g=this.chart,h=this.xAxis,h=h&&h.hasNames&&h.names,k=d.data,p,l,q=this.xData,n,m;b=y(b,!0);p={series:this};this.pointClass.prototype.applyOptions.apply(p,[a]);m=p.x;n=q.length;if(this.requireSorting&&m<q[n-1])for(l=!0;n&&q[n-1]>m;)n--;
this.updateParallelArrays(p,"splice",n,0,0);this.updateParallelArrays(p,n);h&&p.name&&(h[m]=p.name);k.splice(n,0,a);l&&(this.data.splice(n,0,null),this.processData());"point"===d.legendType&&this.generatePoints();c&&(f[0]&&f[0].remove?f[0].remove(!1):(f.shift(),this.updateParallelArrays(p,"shift"),k.shift()));this.isDirtyData=this.isDirty=!0;b&&g.redraw(e)},removePoint:function(a,b,e){var d=this,f=d.data,g=f[a],k=d.points,h=d.chart,l=function(){k&&k.length===f.length&&k.splice(a,1);f.splice(a,1);
d.options.data.splice(a,1);d.updateParallelArrays(g||{series:d},"splice",a,1);g&&g.destroy();d.isDirty=!0;d.isDirtyData=!0;b&&h.redraw()};c(e,h);b=y(b,!0);g?g.firePointEvent("remove",null,l):l()},remove:function(a,b,c){function e(){d.destroy();f.isDirtyLegend=f.isDirtyBox=!0;f.linkSeries();y(a,!0)&&f.redraw(b)}var d=this,f=d.chart;!1!==c?t(d,"remove",null,e):e()},update:function(a,b){var c=this,d=c.chart,f=c.userOptions,g=c.oldType||c.type,k=a.type||f.type||d.options.chart.type,h=J[g].prototype,n,
q=["group","markerGroup","dataLabelsGroup","navigatorSeries","baseSeries"],m=c.finishedAnimating&&{animation:!1};if(Object.keys&&"data"===Object.keys(a).toString())return this.setData(a.data,b);if(k&&k!==g||void 0!==a.zIndex)q.length=0;l(q,function(a){q[a]=c[a];delete c[a]});a=e(f,m,{index:c.index,pointStart:c.xData[0]},{data:c.options.data},a);c.remove(!1,null,!1);for(n in h)c[n]=void 0;u(c,J[k||g].prototype);l(q,function(a){c[a]=q[a]});c.init(d,a);c.oldType=g;d.linkSeries();y(b,!0)&&d.redraw(!1)}});
u(F.prototype,{update:function(a,b){var c=this.chart;a=c.options[this.coll][this.options.index]=e(this.userOptions,a);this.destroy(!0);this.init(c,u(a,{events:void 0}));c.isDirtyBox=!0;y(b,!0)&&c.redraw()},remove:function(a){for(var c=this.chart,e=this.coll,d=this.series,f=d.length;f--;)d[f]&&d[f].remove(!1);r(c.axes,this);r(c[e],this);b(c.options[e])?c.options[e].splice(this.options.index,1):delete c.options[e];l(c[e],function(a,b){a.options.index=b});this.destroy();c.isDirtyBox=!0;y(a,!0)&&c.redraw()},
setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})})(M);(function(a){var C=a.color,A=a.each,F=a.map,E=a.pick,m=a.Series,f=a.seriesType;f("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(f){var l=[],m=[],t=this.xAxis,g=this.yAxis,d=g.stacks[this.stackKey],k={},b=this.index,e=g.series,v=e.length,y,n=E(g.options.reversedStacks,!0)?1:-1,D;f=f||this.points;if(this.options.stacking){for(D=0;D<f.length;D++)k[f[D].x]=
f[D];a.objectEach(d,function(a,b){null!==a.total&&m.push(b)});m.sort(function(a,b){return a-b});y=F(e,function(){return this.visible});A(m,function(a,c){var e=0,f,r;if(k[a]&&!k[a].isNull)l.push(k[a]),A([-1,1],function(e){var g=1===e?"rightNull":"leftNull",l=0,q=d[m[c+e]];if(q)for(D=b;0<=D&&D<v;)f=q.points[D],f||(D===b?k[a][g]=!0:y[D]&&(r=d[a].points[D])&&(l-=r[1]-r[0])),D+=n;k[a][1===e?"rightCliff":"leftCliff"]=l});else{for(D=b;0<=D&&D<v;){if(f=d[a].points[D]){e=f[1];break}D+=n}e=g.translate(e,0,
1,0,1);l.push({isNull:!0,plotX:t.translate(a,0,0,0,1),x:a,plotY:e,yBottom:e})}})}return l},getGraphPath:function(a){var f=m.prototype.getGraphPath,l=this.options,t=l.stacking,g=this.yAxis,d,k,b=[],e=[],v=this.index,y,n=g.stacks[this.stackKey],D=l.threshold,A=g.getThreshold(l.threshold),c,l=l.connectNulls||"percent"===t,G=function(c,d,f){var k=a[c];c=t&&n[k.x].points[v];var l=k[f+"Null"]||0;f=k[f+"Cliff"]||0;var q,m,k=!0;f||l?(q=(l?c[0]:c[1])+f,m=c[0]+f,k=!!l):!t&&a[d]&&a[d].isNull&&(q=m=D);void 0!==
q&&(e.push({plotX:y,plotY:null===q?A:g.getThreshold(q),isNull:k,isCliff:!0}),b.push({plotX:y,plotY:null===m?A:g.getThreshold(m),doCurve:!1}))};a=a||this.points;t&&(a=this.getStackPoints(a));for(d=0;d<a.length;d++)if(k=a[d].isNull,y=E(a[d].rectPlotX,a[d].plotX),c=E(a[d].yBottom,A),!k||l)l||G(d,d-1,"left"),k&&!t&&l||(e.push(a[d]),b.push({x:d,plotX:y,plotY:c})),l||G(d,d+1,"right");d=f.call(this,e,!0,!0);b.reversed=!0;k=f.call(this,b,!0,!0);k.length&&(k[0]="L");k=d.concat(k);f=f.call(this,e,!1,l);k.xMap=
d.xMap;this.areaPath=k;return f},drawGraph:function(){this.areaPath=[];m.prototype.drawGraph.apply(this);var a=this,f=this.areaPath,u=this.options,t=[["area","highcharts-area",this.color,u.fillColor]];A(this.zones,function(f,d){t.push(["zone-area-"+d,"highcharts-area highcharts-zone-area-"+d+" "+f.className,f.color||a.color,f.fillColor||u.fillColor])});A(t,function(g){var d=g[0],k=a[d];k?(k.endX=f.xMap,k.animate({d:f})):(k=a[d]=a.chart.renderer.path(f).addClass(g[1]).attr({fill:E(g[3],C(g[2]).setOpacity(E(u.fillOpacity,
.75)).get()),zIndex:0}).add(a.group),k.isArea=!0);k.startX=f.xMap;k.shiftUnit=u.step?2:1})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(M);(function(a){var C=a.pick;a=a.seriesType;a("spline","line",{},{getPointSpline:function(a,F,E){var m=F.plotX,f=F.plotY,l=a[E-1];E=a[E+1];var r,u,t,g;if(l&&!l.isNull&&!1!==l.doCurve&&!F.isCliff&&E&&!E.isNull&&!1!==E.doCurve&&!F.isCliff){a=l.plotY;t=E.plotX;E=E.plotY;var d=0;r=(1.5*m+l.plotX)/2.5;u=(1.5*f+a)/2.5;t=(1.5*m+t)/2.5;g=(1.5*f+E)/2.5;t!==r&&(d=
(g-u)*(t-m)/(t-r)+f-g);u+=d;g+=d;u>a&&u>f?(u=Math.max(a,f),g=2*f-u):u<a&&u<f&&(u=Math.min(a,f),g=2*f-u);g>E&&g>f?(g=Math.max(E,f),u=2*f-g):g<E&&g<f&&(g=Math.min(E,f),u=2*f-g);F.rightContX=t;F.rightContY=g}F=["C",C(l.rightContX,l.plotX),C(l.rightContY,l.plotY),C(r,m),C(u,f),m,f];l.rightContX=l.rightContY=null;return F}})})(M);(function(a){var C=a.seriesTypes.area.prototype,A=a.seriesType;A("areaspline","spline",a.defaultPlotOptions.area,{getStackPoints:C.getStackPoints,getGraphPath:C.getGraphPath,
drawGraph:C.drawGraph,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(M);(function(a){var C=a.animObject,A=a.color,F=a.each,E=a.extend,m=a.isNumber,f=a.merge,l=a.pick,r=a.Series,u=a.seriesType,t=a.svg;u("column","line",{borderRadius:0,crisp:!0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1,shadow:!1},select:{color:"#cccccc",borderColor:"#000000",shadow:!1}},dataLabels:{align:null,verticalAlign:null,y:null},
softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){r.prototype.init.apply(this,arguments);var a=this,d=a.chart;d.hasRendered&&F(d.series,function(d){d.type===a.type&&(d.isDirty=!0)})},getColumnMetrics:function(){var a=this,d=a.options,f=a.xAxis,b=a.yAxis,e=f.reversed,m,r={},n=0;!1===d.grouping?n=1:F(a.chart.series,function(c){var e=c.options,
d=c.yAxis,f;c.type!==a.type||!c.visible&&a.chart.options.chart.ignoreHiddenSeries||b.len!==d.len||b.pos!==d.pos||(e.stacking?(m=c.stackKey,void 0===r[m]&&(r[m]=n++),f=r[m]):!1!==e.grouping&&(f=n++),c.columnIndex=f)});var t=Math.min(Math.abs(f.transA)*(f.ordinalSlope||d.pointRange||f.closestPointRange||f.tickInterval||1),f.len),u=t*d.groupPadding,c=(t-2*u)/(n||1),d=Math.min(d.maxPointWidth||f.len,l(d.pointWidth,c*(1-2*d.pointPadding)));a.columnMetrics={width:d,offset:(c-d)/2+(u+((a.columnIndex||0)+
(e?1:0))*c-t/2)*(e?-1:1)};return a.columnMetrics},crispCol:function(a,d,f,b){var e=this.chart,g=this.borderWidth,k=-(g%2?.5:0),g=g%2?.5:1;e.inverted&&e.renderer.isVML&&(g+=1);this.options.crisp&&(f=Math.round(a+f)+k,a=Math.round(a)+k,f-=a);b=Math.round(d+b)+g;k=.5>=Math.abs(d)&&.5<b;d=Math.round(d)+g;b-=d;k&&b&&(--d,b+=1);return{x:a,y:d,width:f,height:b}},translate:function(){var a=this,d=a.chart,f=a.options,b=a.dense=2>a.closestPointRange*a.xAxis.transA,b=a.borderWidth=l(f.borderWidth,b?0:1),e=a.yAxis,
m=a.translatedThreshold=e.getThreshold(f.threshold),t=l(f.minPointLength,5),n=a.getColumnMetrics(),u=n.width,A=a.barW=Math.max(u,1+2*b),c=a.pointXOffset=n.offset;d.inverted&&(m-=.5);f.pointPadding&&(A=Math.ceil(A));r.prototype.translate.apply(a);F(a.points,function(b){var f=l(b.yBottom,m),g=999+Math.abs(f),g=Math.min(Math.max(-g,b.plotY),e.len+g),k=b.plotX+c,n=A,r=Math.min(g,f),v,y=Math.max(g,f)-r;Math.abs(y)<t&&t&&(y=t,v=!e.reversed&&!b.negative||e.reversed&&b.negative,r=Math.abs(r-m)>t?f-t:m-(v?
t:0));b.barX=k;b.pointWidth=u;b.tooltipPos=d.inverted?[e.len+e.pos-d.plotLeft-g,a.xAxis.len-k-n/2,y]:[k+n/2,g+e.pos-d.plotTop,y];b.shapeType="rect";b.shapeArgs=a.crispCol.apply(a,b.isNull?[k,m,n,0]:[k,r,n,y])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(a,d){var g=this.options,b,e=this.pointAttrToOptions||{};b=e.stroke||"borderColor";var l=e["stroke-width"]||
"borderWidth",m=a&&a.color||this.color,n=a[b]||g[b]||this.color||m,r=a[l]||g[l]||this[l]||0,e=g.dashStyle;a&&this.zones.length&&(m=a.getZone(),m=a.options.color||m&&m.color||this.color);d&&(a=f(g.states[d],a.options.states&&a.options.states[d]||{}),d=a.brightness,m=a.color||void 0!==d&&A(m).brighten(a.brightness).get()||m,n=a[b]||n,r=a[l]||r,e=a.dashStyle||e);b={fill:m,stroke:n,"stroke-width":r};e&&(b.dashstyle=e);return b},drawPoints:function(){var a=this,d=this.chart,k=a.options,b=d.renderer,e=
k.animationLimit||250,l;F(a.points,function(g){var n=g.graphic;if(m(g.plotY)&&null!==g.y){l=g.shapeArgs;if(n)n[d.pointCount<e?"animate":"attr"](f(l));else g.graphic=n=b[g.shapeType](l).add(g.group||a.group);k.borderRadius&&n.attr({r:k.borderRadius});n.attr(a.pointAttribs(g,g.selected&&"select")).shadow(k.shadow,null,k.stacking&&!k.borderRadius);n.addClass(g.getClassName(),!0)}else n&&(g.graphic=n.destroy())})},animate:function(a){var d=this,f=this.yAxis,b=d.options,e=this.chart.inverted,g={};t&&(a?
(g.scaleY=.001,a=Math.min(f.pos+f.len,Math.max(f.pos,f.toPixels(b.threshold))),e?g.translateX=a-f.len:g.translateY=a,d.group.attr(g)):(g[e?"translateX":"translateY"]=f.pos,d.group.animate(g,E(C(d.options.animation),{step:function(a,b){d.group.attr({scaleY:Math.max(.001,b.pos)})}})),d.animate=null))},remove:function(){var a=this,d=a.chart;d.hasRendered&&F(d.series,function(d){d.type===a.type&&(d.isDirty=!0)});r.prototype.remove.apply(a,arguments)}})})(M);(function(a){a=a.seriesType;a("bar","column",
null,{inverted:!0})})(M);(function(a){var C=a.Series;a=a.seriesType;a("scatter","line",{lineWidth:0,findNearestPointBy:"xy",marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 0.85em"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],
takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&C.prototype.drawGraph.call(this)}})})(M);(function(a){var C=a.pick,A=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,E=this.chart,m=2*(a.slicedOffset||0),f=E.plotWidth-2*m,E=E.plotHeight-2*m,l=a.center,l=[C(l[0],"50%"),C(l[1],"50%"),a.size||"100%",a.innerSize||0],r=Math.min(f,E),u,t;for(u=0;4>u;++u)t=l[u],a=2>u||2===u&&/%$/.test(t),l[u]=A(t,[f,E,r,l[2]][u])+(a?m:0);l[3]>l[2]&&(l[3]=l[2]);return l}}})(M);
(function(a){var C=a.addEvent,A=a.defined,F=a.each,E=a.extend,m=a.inArray,f=a.noop,l=a.pick,r=a.Point,u=a.Series,t=a.seriesType,g=a.setAnimation;t("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,states:{hover:{brightness:.1,
shadow:!1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:a.seriesTypes.column.prototype.pointAttribs,animate:function(a){var d=this,b=d.points,e=d.startAngleRad;a||(F(b,function(a){var b=a.graphic,f=a.shapeArgs;b&&(b.attr({r:a.startR||d.center[3]/2,start:e,end:e}),b.animate({r:f.r,start:f.start,end:f.end},d.options.animation))}),d.animate=null)},updateTotals:function(){var a,f=0,b=this.points,e=b.length,g,
l=this.options.ignoreHiddenPoint;for(a=0;a<e;a++)g=b[a],f+=l&&!g.visible?0:g.isNull?0:g.y;this.total=f;for(a=0;a<e;a++)g=b[a],g.percentage=0<f&&(g.visible||!l)?g.y/f*100:0,g.total=f},generatePoints:function(){u.prototype.generatePoints.call(this);this.updateTotals()},translate:function(a){this.generatePoints();var d=0,b=this.options,e=b.slicedOffset,f=e+(b.borderWidth||0),g,n,m,r=b.startAngle||0,c=this.startAngleRad=Math.PI/180*(r-90),r=(this.endAngleRad=Math.PI/180*(l(b.endAngle,r+360)-90))-c,t=
this.points,q,B=b.dataLabels.distance,b=b.ignoreHiddenPoint,u,p=t.length,z;a||(this.center=a=this.getCenter());this.getX=function(b,c,e){m=Math.asin(Math.min((b-a[1])/(a[2]/2+e.labelDistance),1));return a[0]+(c?-1:1)*Math.cos(m)*(a[2]/2+e.labelDistance)};for(u=0;u<p;u++){z=t[u];z.labelDistance=l(z.options.dataLabels&&z.options.dataLabels.distance,B);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,z.labelDistance);g=c+d*r;if(!b||z.visible)d+=z.percentage/100;n=c+d*r;z.shapeType="arc";z.shapeArgs=
{x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*g)/1E3,end:Math.round(1E3*n)/1E3};m=(n+g)/2;m>1.5*Math.PI?m-=2*Math.PI:m<-Math.PI/2&&(m+=2*Math.PI);z.slicedTranslation={translateX:Math.round(Math.cos(m)*e),translateY:Math.round(Math.sin(m)*e)};n=Math.cos(m)*a[2]/2;q=Math.sin(m)*a[2]/2;z.tooltipPos=[a[0]+.7*n,a[1]+.7*q];z.half=m<-Math.PI/2||m>Math.PI/2?1:0;z.angle=m;g=Math.min(f,z.labelDistance/5);z.labelPos=[a[0]+n+Math.cos(m)*z.labelDistance,a[1]+q+Math.sin(m)*z.labelDistance,a[0]+n+Math.cos(m)*
g,a[1]+q+Math.sin(m)*g,a[0]+n,a[1]+q,0>z.labelDistance?"center":z.half?"right":"left",m]}},drawGraph:null,drawPoints:function(){var a=this,f=a.chart.renderer,b,e,g,l,n=a.options.shadow;n&&!a.shadowGroup&&(a.shadowGroup=f.g("shadow").add(a.group));F(a.points,function(d){if(!d.isNull){e=d.graphic;l=d.shapeArgs;b=d.getTranslate();var k=d.shadowGroup;n&&!k&&(k=d.shadowGroup=f.g("shadow").add(a.shadowGroup));k&&k.attr(b);g=a.pointAttribs(d,d.selected&&"select");e?e.setRadialReference(a.center).attr(g).animate(E(l,
b)):(d.graphic=e=f[d.shapeType](l).setRadialReference(a.center).attr(b).add(a.group),d.visible||e.attr({visibility:"hidden"}),e.attr(g).attr({"stroke-linejoin":"round"}).shadow(n,k));e.addClass(d.getClassName())}})},searchPoint:f,sortByAngle:function(a,f){a.sort(function(a,e){return void 0!==a.angle&&(e.angle-a.angle)*f})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,getCenter:a.CenteredSeriesMixin.getCenter,getSymbol:f},{init:function(){r.prototype.init.apply(this,arguments);var a=this,f;a.name=
l(a.name,"Slice");f=function(b){a.slice("select"===b.type)};C(a,"select",f);C(a,"unselect",f);return a},isValid:function(){return a.isNumber(this.y,!0)&&0<=this.y},setVisible:function(a,f){var b=this,e=b.series,d=e.chart,g=e.options.ignoreHiddenPoint;f=l(f,g);a!==b.visible&&(b.visible=b.options.visible=a=void 0===a?!b.visible:a,e.options.data[m(b,e.data)]=b.options,F(["graphic","dataLabel","connector","shadowGroup"],function(e){if(b[e])b[e][a?"show":"hide"](!0)}),b.legendItem&&d.legend.colorizeItem(b,
a),a||"hover"!==b.state||b.setState(""),g&&(e.isDirty=!0),f&&d.redraw())},slice:function(a,f,b){var e=this.series;g(b,e.chart);l(f,!0);this.sliced=this.options.sliced=A(a)?a:!this.sliced;e.options.data[m(this,e.data)]=this.options;this.graphic.animate(this.getTranslate());this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(a){var d=this.shapeArgs;return this.sliced||!this.visible?
[]:this.series.chart.renderer.symbols.arc(d.x,d.y,d.r+a,d.r+a,{innerR:this.shapeArgs.r,start:d.start,end:d.end})}})})(M);(function(a){var C=a.addEvent,A=a.arrayMax,F=a.defined,E=a.each,m=a.extend,f=a.format,l=a.map,r=a.merge,u=a.noop,t=a.pick,g=a.relativeLength,d=a.Series,k=a.seriesTypes,b=a.stableSort;a.distribute=function(a,d){function e(a,b){return a.target-b.target}var f,g=!0,k=a,c=[],m;m=0;for(f=a.length;f--;)m+=a[f].size;if(m>d){b(a,function(a,b){return(b.rank||0)-(a.rank||0)});for(m=f=0;m<=
d;)m+=a[f].size,f++;c=a.splice(f-1,a.length)}b(a,e);for(a=l(a,function(a){return{size:a.size,targets:[a.target]}});g;){for(f=a.length;f--;)g=a[f],m=(Math.min.apply(0,g.targets)+Math.max.apply(0,g.targets))/2,g.pos=Math.min(Math.max(0,m-g.size/2),d-g.size);f=a.length;for(g=!1;f--;)0<f&&a[f-1].pos+a[f-1].size>a[f].pos&&(a[f-1].size+=a[f].size,a[f-1].targets=a[f-1].targets.concat(a[f].targets),a[f-1].pos+a[f-1].size>d&&(a[f-1].pos=d-a[f-1].size),a.splice(f,1),g=!0)}f=0;E(a,function(a){var b=0;E(a.targets,
function(){k[f].pos=a.pos+b;b+=k[f].size;f++})});k.push.apply(k,c);b(k,e)};d.prototype.drawDataLabels=function(){var b=this,d=b.options,g=d.dataLabels,k=b.points,l,m,c=b.hasRendered||0,u,q,B=t(g.defer,!!d.animation),A=b.chart.renderer;if(g.enabled||b._hasPointLabels)b.dlProcessOptions&&b.dlProcessOptions(g),q=b.plotGroup("dataLabelsGroup","data-labels",B&&!c?"hidden":"visible",g.zIndex||6),B&&(q.attr({opacity:+c}),c||C(b,"afterAnimate",function(){b.visible&&q.show(!0);q[d.animation?"animate":"attr"]({opacity:1},
{duration:200})})),m=g,E(k,function(c){var e,k=c.dataLabel,n,h,p=c.connector,v=!k,B;l=c.dlOptions||c.options&&c.options.dataLabels;if(e=t(l&&l.enabled,m.enabled)&&null!==c.y)g=r(m,l),n=c.getLabelConfig(),u=g.format?f(g.format,n):g.formatter.call(n,g),B=g.style,n=g.rotation,B.color=t(g.color,B.color,b.color,"#000000"),"contrast"===B.color&&(c.contrastColor=A.getContrast(c.color||b.color),B.color=g.inside||0>t(c.labelDistance,g.distance)||d.stacking?c.contrastColor:"#000000"),d.cursor&&(B.cursor=d.cursor),
h={fill:g.backgroundColor,stroke:g.borderColor,"stroke-width":g.borderWidth,r:g.borderRadius||0,rotation:n,padding:g.padding,zIndex:1},a.objectEach(h,function(a,b){void 0===a&&delete h[b]});!k||e&&F(u)?e&&F(u)&&(k?h.text=u:(k=c.dataLabel=A[n?"text":"label"](u,0,-9999,g.shape,null,null,g.useHTML,null,"data-label"),k.addClass("highcharts-data-label-color-"+c.colorIndex+" "+(g.className||"")+(g.useHTML?"highcharts-tracker":""))),k.attr(h),k.css(B).shadow(g.shadow),k.added||k.add(q),b.alignDataLabel(c,
k,g,null,v)):(c.dataLabel=k=k.destroy(),p&&(c.connector=p.destroy()))})};d.prototype.alignDataLabel=function(a,b,d,f,g){var e=this.chart,c=e.inverted,k=t(a.plotX,-9999),l=t(a.plotY,-9999),n=b.getBBox(),r,p=d.rotation,v=d.align,u=this.visible&&(a.series.forceDL||e.isInsidePlot(k,Math.round(l),c)||f&&e.isInsidePlot(k,c?f.x+1:f.y+f.height-1,c)),y="justify"===t(d.overflow,"justify");if(u&&(r=d.style.fontSize,r=e.renderer.fontMetrics(r,b).b,f=m({x:c?this.yAxis.len-l:k,y:Math.round(c?this.xAxis.len-k:l),
width:0,height:0},f),m(d,{width:n.width,height:n.height}),p?(y=!1,k=e.renderer.rotCorr(r,p),k={x:f.x+d.x+f.width/2+k.x,y:f.y+d.y+{top:0,middle:.5,bottom:1}[d.verticalAlign]*f.height},b[g?"attr":"animate"](k).attr({align:v}),l=(p+720)%360,l=180<l&&360>l,"left"===v?k.y-=l?n.height:0:"center"===v?(k.x-=n.width/2,k.y-=n.height/2):"right"===v&&(k.x-=n.width,k.y-=l?0:n.height)):(b.align(d,null,f),k=b.alignAttr),y?a.isLabelJustified=this.justifyDataLabel(b,d,k,n,f,g):t(d.crop,!0)&&(u=e.isInsidePlot(k.x,
k.y)&&e.isInsidePlot(k.x+n.width,k.y+n.height)),d.shape&&!p))b[g?"attr":"animate"]({anchorX:c?e.plotWidth-a.plotY:a.plotX,anchorY:c?e.plotHeight-a.plotX:a.plotY});u||(b.attr({y:-9999}),b.placed=!1)};d.prototype.justifyDataLabel=function(a,b,d,f,g,k){var c=this.chart,e=b.align,l=b.verticalAlign,m,n,p=a.box?0:a.padding||0;m=d.x+p;0>m&&("right"===e?b.align="left":b.x=-m,n=!0);m=d.x+f.width-p;m>c.plotWidth&&("left"===e?b.align="right":b.x=c.plotWidth-m,n=!0);m=d.y+p;0>m&&("bottom"===l?b.verticalAlign=
"top":b.y=-m,n=!0);m=d.y+f.height-p;m>c.plotHeight&&("top"===l?b.verticalAlign="bottom":b.y=c.plotHeight-m,n=!0);n&&(a.placed=!k,a.align(b,null,g));return n};k.pie&&(k.pie.prototype.drawDataLabels=function(){var b=this,f=b.data,g,k=b.chart,l=b.options.dataLabels,m=t(l.connectorPadding,10),c=t(l.connectorWidth,1),r=k.plotWidth,q=k.plotHeight,u,C=b.center,p=C[2]/2,z=C[1],I,L,h,w,M=[[],[]],H,O,Q,R,x=[0,0,0,0];b.visible&&(l.enabled||b._hasPointLabels)&&(E(f,function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&
(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),d.prototype.drawDataLabels.apply(b),E(f,function(a){a.dataLabel&&a.visible&&(M[a.half].push(a),a.dataLabel._pos=null)}),E(M,function(c,d){var e,f,n=c.length,v=[],u;if(n)for(b.sortByAngle(c,d-.5),0<b.maxLabelDistance&&(e=Math.max(0,z-p-b.maxLabelDistance),f=Math.min(z+p+b.maxLabelDistance,k.plotHeight),E(c,function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,z-p-a.labelDistance),a.bottom=
Math.min(z+p+a.labelDistance,k.plotHeight),u=a.dataLabel.getBBox().height||21,a.positionsIndex=v.push({target:a.labelPos[1]-a.top+u/2,size:u,rank:a.y})-1)}),a.distribute(v,f+u-e)),R=0;R<n;R++)g=c[R],f=g.positionsIndex,h=g.labelPos,I=g.dataLabel,Q=!1===g.visible?"hidden":"inherit",e=h[1],v&&F(v[f])?void 0===v[f].pos?Q="hidden":(w=v[f].size,O=g.top+v[f].pos):O=e,delete g.positionIndex,H=l.justify?C[0]+(d?-1:1)*(p+g.labelDistance):b.getX(O<g.top+2||O>g.bottom-2?e:O,d,g),I._attr={visibility:Q,align:h[6]},
I._pos={x:H+l.x+({left:m,right:-m}[h[6]]||0),y:O+l.y-10},h.x=H,h.y=O,t(l.crop,!0)&&(L=I.getBBox().width,e=null,H-L<m?(e=Math.round(L-H+m),x[3]=Math.max(e,x[3])):H+L>r-m&&(e=Math.round(H+L-r+m),x[1]=Math.max(e,x[1])),0>O-w/2?x[0]=Math.max(Math.round(-O+w/2),x[0]):O+w/2>q&&(x[2]=Math.max(Math.round(O+w/2-q),x[2])),I.sideOverflow=e)}),0===A(x)||this.verifyDataLabelOverflow(x))&&(this.placeDataLabels(),c&&E(this.points,function(a){var e;u=a.connector;if((I=a.dataLabel)&&I._pos&&a.visible&&0<a.labelDistance){Q=
I._attr.visibility;if(e=!u)a.connector=u=k.renderer.path().addClass("highcharts-data-label-connector highcharts-color-"+a.colorIndex).add(b.dataLabelsGroup),u.attr({"stroke-width":c,stroke:l.connectorColor||a.color||"#666666"});u[e?"attr":"animate"]({d:b.connectorPath(a.labelPos)});u.attr("visibility",Q)}else u&&(a.connector=u.destroy())}))},k.pie.prototype.connectorPath=function(a){var b=a.x,d=a.y;return t(this.options.dataLabels.softConnector,!0)?["M",b+("left"===a[6]?5:-5),d,"C",b,d,2*a[2]-a[4],
2*a[3]-a[5],a[2],a[3],"L",a[4],a[5]]:["M",b+("left"===a[6]?5:-5),d,"L",a[2],a[3],"L",a[4],a[5]]},k.pie.prototype.placeDataLabels=function(){E(this.points,function(a){var b=a.dataLabel;b&&a.visible&&((a=b._pos)?(b.sideOverflow&&(b._attr.width=b.getBBox().width-b.sideOverflow,b.css({width:b._attr.width+"px",textOverflow:"ellipsis"}),b.shortened=!0),b.attr(b._attr),b[b.moved?"animate":"attr"](a),b.moved=!0):b&&b.attr({y:-9999}))},this)},k.pie.prototype.alignDataLabel=u,k.pie.prototype.verifyDataLabelOverflow=
function(a){var b=this.center,d=this.options,e=d.center,f=d.minSize||80,k,c=null!==d.size;c||(null!==e[0]?k=Math.max(b[2]-Math.max(a[1],a[3]),f):(k=Math.max(b[2]-a[1]-a[3],f),b[0]+=(a[3]-a[1])/2),null!==e[1]?k=Math.max(Math.min(k,b[2]-Math.max(a[0],a[2])),f):(k=Math.max(Math.min(k,b[2]-a[0]-a[2]),f),b[1]+=(a[0]-a[2])/2),k<b[2]?(b[2]=k,b[3]=Math.min(g(d.innerSize||0,k),k),this.translate(b),this.drawDataLabels&&this.drawDataLabels()):c=!0);return c});k.column&&(k.column.prototype.alignDataLabel=function(a,
b,f,g,k){var e=this.chart.inverted,c=a.series,l=a.dlBox||a.shapeArgs,m=t(a.below,a.plotY>t(this.translatedThreshold,c.yAxis.len)),n=t(f.inside,!!this.options.stacking);l&&(g=r(l),0>g.y&&(g.height+=g.y,g.y=0),l=g.y+g.height-c.yAxis.len,0<l&&(g.height-=l),e&&(g={x:c.yAxis.len-g.y-g.height,y:c.xAxis.len-g.x-g.width,width:g.height,height:g.width}),n||(e?(g.x+=m?0:g.width,g.width=0):(g.y+=m?g.height:0,g.height=0)));f.align=t(f.align,!e||n?"center":m?"right":"left");f.verticalAlign=t(f.verticalAlign,e||
n?"middle":m?"top":"bottom");d.prototype.alignDataLabel.call(this,a,b,f,g,k);a.isLabelJustified&&a.contrastColor&&a.dataLabel.css({color:a.contrastColor})})})(M);(function(a){var C=a.Chart,A=a.each,F=a.objectEach,E=a.pick,m=a.addEvent;C.prototype.callbacks.push(function(a){function f(){var f=[];A(a.yAxis||[],function(a){a.options.stackLabels&&!a.options.stackLabels.allowOverlap&&F(a.stacks,function(a){F(a,function(a){f.push(a.label)})})});A(a.series||[],function(a){var l=a.options.dataLabels,g=a.dataLabelCollections||
["dataLabel"];(l.enabled||a._hasPointLabels)&&!l.allowOverlap&&a.visible&&A(g,function(d){A(a.points,function(a){a[d]&&(a[d].labelrank=E(a.labelrank,a.shapeArgs&&a.shapeArgs.height),f.push(a[d]))})})});a.hideOverlappingLabels(f)}f();m(a,"redraw",f)});C.prototype.hideOverlappingLabels=function(a){var f=a.length,m,u,t,g,d,k,b,e,v,y=function(a,b,d,c,e,f,g,k){return!(e>a+d||e+g<a||f>b+c||f+k<b)};for(u=0;u<f;u++)if(m=a[u])m.oldOpacity=m.opacity,m.newOpacity=1,m.width||(t=m.getBBox(),m.width=t.width,m.height=
t.height);a.sort(function(a,b){return(b.labelrank||0)-(a.labelrank||0)});for(u=0;u<f;u++)for(t=a[u],m=u+1;m<f;++m)if(g=a[m],t&&g&&t!==g&&t.placed&&g.placed&&0!==t.newOpacity&&0!==g.newOpacity&&(d=t.alignAttr,k=g.alignAttr,b=t.parentGroup,e=g.parentGroup,v=2*(t.box?0:t.padding||0),d=y(d.x+b.translateX,d.y+b.translateY,t.width-v,t.height-v,k.x+e.translateX,k.y+e.translateY,g.width-v,g.height-v)))(t.labelrank<g.labelrank?t:g).newOpacity=0;A(a,function(a){var b,d;a&&(d=a.newOpacity,a.oldOpacity!==d&&
a.placed&&(d?a.show(!0):b=function(){a.hide()},a.alignAttr.opacity=d,a[a.isOld?"animate":"attr"](a.alignAttr,null,b)),a.isOld=!0)})}})(M);(function(a){var C=a.addEvent,A=a.Chart,F=a.createElement,E=a.css,m=a.defaultOptions,f=a.defaultPlotOptions,l=a.each,r=a.extend,u=a.fireEvent,t=a.hasTouch,g=a.inArray,d=a.isObject,k=a.Legend,b=a.merge,e=a.pick,v=a.Point,y=a.Series,n=a.seriesTypes,D=a.svg,J;J=a.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart.pointer,d=function(a){var c=b.getPointFromEvent(a);
void 0!==c&&(b.isDirectTouch=!0,c.onMouseOver(a))};l(a.points,function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&(a.dataLabel.div?a.dataLabel.div.point=a:a.dataLabel.element.point=a)});a._hasTracking||(l(a.trackerGroups,function(c){if(a[c]){a[c].addClass("highcharts-tracker").on("mouseover",d).on("mouseout",function(a){b.onTrackerMouseOut(a)});if(t)a[c].on("touchstart",d);a.options.cursor&&a[c].css(E).css({cursor:a.options.cursor})}}),a._hasTracking=!0)},drawTrackerGraph:function(){var a=
this,b=a.options,d=b.trackByArea,e=[].concat(d?a.areaPath:a.graphPath),f=e.length,g=a.chart,k=g.pointer,m=g.renderer,n=g.options.tooltip.snap,h=a.tracker,r,u=function(){if(g.hoverSeries!==a)a.onMouseOver()},v="rgba(192,192,192,"+(D?.0001:.002)+")";if(f&&!d)for(r=f+1;r--;)"M"===e[r]&&e.splice(r+1,0,e[r+1]-n,e[r+2],"L"),(r&&"M"===e[r]||r===f)&&e.splice(r,0,"L",e[r-2]+n,e[r-1]);h?h.attr({d:e}):a.graph&&(a.tracker=m.path(e).attr({"stroke-linejoin":"round",visibility:a.visible?"visible":"hidden",stroke:v,
fill:d?v:"none","stroke-width":a.graph.strokeWidth()+(d?0:2*n),zIndex:2}).add(a.group),l([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",u).on("mouseout",function(a){k.onTrackerMouseOut(a)});b.cursor&&a.css({cursor:b.cursor});if(t)a.on("touchstart",u)}))}};n.column&&(n.column.prototype.drawTracker=J.drawTrackerPoint);n.pie&&(n.pie.prototype.drawTracker=J.drawTrackerPoint);n.scatter&&(n.scatter.prototype.drawTracker=J.drawTrackerPoint);r(k.prototype,{setItemEvents:function(a,
d,e){var c=this,f=c.chart.renderer.boxWrapper,g="highcharts-legend-"+(a.series?"point":"series")+"-active";(e?d:a.legendGroup).on("mouseover",function(){a.setState("hover");f.addClass(g);d.css(c.options.itemHoverStyle)}).on("mouseout",function(){d.css(b(a.visible?c.itemStyle:c.itemHiddenStyle));f.removeClass(g);a.setState()}).on("click",function(b){var c=function(){a.setVisible&&a.setVisible()};b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,c):u(a,"legendItemClick",b,c)})},
createCheckboxForItem:function(a){a.checkbox=F("input",{type:"checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);C(a.checkbox,"click",function(b){u(a.series||a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})}});m.legend.itemStyle.cursor="pointer";r(A.prototype,{showResetZoom:function(){var a=this,b=m.lang,d=a.options.chart.resetZoomButton,e=d.theme,f=e.states,g="chart"===d.relativeTo?null:"plotBox";this.resetZoomButton=
a.renderer.button(b.resetZoom,null,null,function(){a.zoomOut()},e,f&&f.hover).attr({align:d.position.align,title:b.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(d.position,!1,g)},zoomOut:function(){var a=this;u(a,"selection",{resetSelection:!0},function(){a.zoom()})},zoom:function(a){var b,c=this.pointer,f=!1,g;!a||a.resetSelection?(l(this.axes,function(a){b=a.zoom()}),c.initiated=!1):l(a.xAxis.concat(a.yAxis),function(a){var d=a.axis;c[d.isXAxis?"zoomX":"zoomY"]&&(b=d.zoom(a.min,
a.max),d.displayBtn&&(f=!0))});g=this.resetZoomButton;f&&!g?this.showResetZoom():!f&&d(g)&&(this.resetZoomButton=g.destroy());b&&this.redraw(e(this.options.chart.animation,a&&a.animation,100>this.pointCount))},pan:function(a,b){var c=this,d=c.hoverPoints,e;d&&l(d,function(a){a.setState()});l("xy"===b?[1,0]:[1],function(b){b=c[b?"xAxis":"yAxis"][0];var d=b.horiz,f=a[d?"chartX":"chartY"],d=d?"mouseDownX":"mouseDownY",g=c[d],h=(b.pointRange||0)/2,k=b.getExtremes(),l=b.toValue(g-f,!0)+h,h=b.toValue(g+
b.len-f,!0)-h,m=h<l,g=m?h:l,l=m?l:h,h=Math.min(k.dataMin,b.toValue(b.toPixels(k.min)-b.minPixelPadding)),m=Math.max(k.dataMax,b.toValue(b.toPixels(k.max)+b.minPixelPadding)),n;n=h-g;0<n&&(l+=n,g=h);n=l-m;0<n&&(l=m,g-=n);b.series.length&&g!==k.min&&l!==k.max&&(b.setExtremes(g,l,!1,!1,{trigger:"pan"}),e=!0);c[d]=f});e&&c.redraw(!1);E(c.container,{cursor:"move"})}});r(v.prototype,{select:function(a,b){var c=this,d=c.series,f=d.chart;a=e(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},
function(){c.selected=c.options.selected=a;d.options.data[g(c,d.data)]=c.options;c.setState(a&&"select");b||l(f.getSelectedPoints(),function(a){a.selected&&a!==c&&(a.selected=a.options.selected=!1,d.options.data[g(a,d.data)]=a.options,a.setState(""),a.firePointEvent("unselect"))})})},onMouseOver:function(a){var b=this.series.chart,c=b.pointer;a=a?c.normalize(a):c.getChartCoordinatesFromPoint(this,b.inverted);c.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");
l(a.hoverPoints||[],function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var c=this,d=b(c.series.options.point,c.options).events;c.events=d;a.objectEach(d,function(a,b){C(c,b,a)});this.hasImportedEvents=!0}},setState:function(a,b){var c=Math.floor(this.plotX),d=this.plotY,g=this.series,k=g.options.states[a]||{},l=f[g.type].marker&&g.options.marker,m=l&&!1===l.enabled,n=l&&l.states&&l.states[a]||{},h=!1===n.enabled,t=g.stateMarkerGraphic,u=
this.marker||{},v=g.chart,y=g.halo,A,C=l&&g.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===k.enabled||a&&(h||m&&!1===n.enabled)||a&&u.states&&u.states[a]&&!1===u.states[a].enabled)){C&&(A=g.markerAttribs(this,a));if(this.graphic)this.state&&this.graphic.removeClass("highcharts-point-"+this.state),a&&this.graphic.addClass("highcharts-point-"+a),this.graphic.animate(g.pointAttribs(this,a),e(v.options.chart.animation,k.animation)),A&&this.graphic.animate(A,e(v.options.chart.animation,
n.animation,l.animation)),t&&t.hide();else{if(a&&n){l=u.symbol||g.symbol;t&&t.currentSymbol!==l&&(t=t.destroy());if(t)t[b?"animate":"attr"]({x:A.x,y:A.y});else l&&(g.stateMarkerGraphic=t=v.renderer.symbol(l,A.x,A.y,A.width,A.height).add(g.markerGroup),t.currentSymbol=l);t&&t.attr(g.pointAttribs(this,a))}t&&(t[a&&v.isInsidePlot(c,d,v.inverted)?"show":"hide"](),t.element.point=this)}(c=k.halo)&&c.size?(y||(g.halo=y=v.renderer.path().add((this.graphic||t).parentGroup)),y[b?"animate":"attr"]({d:this.haloPath(c.size)}),
y.attr({"class":"highcharts-halo highcharts-color-"+e(this.colorIndex,g.colorIndex)}),y.point=this,y.attr(r({fill:this.color||g.color,"fill-opacity":c.opacity,zIndex:-1},c.attributes))):y&&y.point&&y.point.haloPath&&y.animate({d:y.point.haloPath(0)});this.state=a}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});r(y.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&
u(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,d=b.tooltip,e=b.hoverPoint;b.hoverSeries=null;if(e)e.onMouseOut();this&&a.events.mouseOut&&u(this,"mouseOut");!d||this.stickyTracking||d.shared&&!this.noSharedTooltip||d.hide();this.setState()},setState:function(a){var b=this,c=b.options,d=b.graph,f=c.states,g=c.lineWidth,c=0;a=a||"";if(b.state!==a&&(l([b.group,b.markerGroup,b.dataLabelsGroup],function(c){c&&(b.state&&c.removeClass("highcharts-series-"+
b.state),a&&c.addClass("highcharts-series-"+a))}),b.state=a,!f[a]||!1!==f[a].enabled)&&(a&&(g=f[a].lineWidth||g+(f[a].lineWidthPlus||0)),d&&!d.dashstyle))for(g={"stroke-width":g},d.animate(g,e(b.chart.options.chart.animation,f[a]&&f[a].animation));b["zone-graph-"+c];)b["zone-graph-"+c].attr(g),c+=1},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,f,g=d.options.chart.ignoreHiddenSeries,k=c.visible;f=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!k:a)?"show":"hide";l(["group",
"dataLabelsGroup","markerGroup","tracker","tt"],function(a){if(c[a])c[a][f]()});if(d.hoverSeries===c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&l(d.series,function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});l(c.linkedSeries,function(b){b.setVisible(a,!1)});g&&(d.isDirtyBox=!0);!1!==b&&d.redraw();u(c,f)},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=void 0===
a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);u(this,a?"select":"unselect")},drawTracker:J.drawTrackerGraph})})(M);(function(a){var C=a.Chart,A=a.each,F=a.inArray,E=a.isArray,m=a.isObject,f=a.pick,l=a.splat;C.prototype.setResponsive=function(f){var l=this.options.responsive,m=[],g=this.currentResponsive;l&&l.rules&&A(l.rules,function(d){void 0===d._id&&(d._id=a.uniqueKey());this.matchResponsiveRule(d,m,f)},this);var d=a.merge.apply(0,a.map(m,function(d){return a.find(l.rules,function(a){return a._id===
d}).chartOptions})),m=m.toString()||void 0;m!==(g&&g.ruleIds)&&(g&&this.update(g.undoOptions,f),m?(this.currentResponsive={ruleIds:m,mergedOptions:d,undoOptions:this.currentOptions(d)},this.update(d,f)):this.currentResponsive=void 0)};C.prototype.matchResponsiveRule=function(a,l){var m=a.condition;(m.callback||function(){return this.chartWidth<=f(m.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=f(m.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=f(m.minWidth,0)&&this.chartHeight>=f(m.minHeight,0)}).call(this)&&
l.push(a._id)};C.prototype.currentOptions=function(f){function r(f,d,k,b){var e;a.objectEach(f,function(a,g){if(!b&&-1<F(g,["series","xAxis","yAxis"]))for(f[g]=l(f[g]),k[g]=[],e=0;e<f[g].length;e++)d[g][e]&&(k[g][e]={},r(a[e],d[g][e],k[g][e],b+1));else m(a)?(k[g]=E(a)?[]:{},r(a,d[g]||{},k[g],b+1)):k[g]=d[g]||null})}var t={};r(f,this.options,t,0);return t}})(M);return M});


/***/ },
/* 763 */
/***/ function(module, exports) {

/*
 Highcharts JS v5.0.14 (2017-07-28)
 Exporting module

 (c) 2010-2017 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(k){"object"===typeof module&&module.exports?module.exports=k:k(Highcharts)})(function(k){(function(f){var k=f.defaultOptions,p=f.doc,B=f.Chart,x=f.addEvent,I=f.removeEvent,F=f.fireEvent,r=f.createElement,C=f.discardElement,v=f.css,n=f.merge,D=f.pick,h=f.each,G=f.objectEach,t=f.extend,J=f.isTouchDevice,E=f.win,H=E.navigator.userAgent,K=f.Renderer.prototype.symbols;/Edge\/|Trident\/|MSIE /.test(H);/firefox/i.test(H);t(k.lang,{printChart:"Print chart",downloadPNG:"Download PNG image",downloadJPEG:"Download JPEG image",
downloadPDF:"Download PDF document",downloadSVG:"Download SVG vector image",contextButtonTitle:"Chart context menu"});k.navigation={buttonOptions:{theme:{},symbolSize:14,symbolX:12.5,symbolY:10.5,align:"right",buttonSpacing:3,height:22,verticalAlign:"top",width:24}};n(!0,k.navigation,{menuStyle:{border:"1px solid #999999",background:"#ffffff",padding:"5px 0"},menuItemStyle:{padding:"0.5em 1em",background:"none",color:"#333333",fontSize:J?"14px":"11px",transition:"background 250ms, color 250ms"},menuItemHoverStyle:{background:"#335cad",
color:"#ffffff"},buttonOptions:{symbolFill:"#666666",symbolStroke:"#666666",symbolStrokeWidth:3,theme:{fill:"#ffffff",stroke:"none",padding:5}}});k.exporting={type:"image/png",url:"https://export.highcharts.com/",printMaxWidth:780,scale:2,buttons:{contextButton:{className:"highcharts-contextbutton",menuClassName:"highcharts-contextmenu",symbol:"menu",_titleKey:"contextButtonTitle",menuItems:"printChart separator downloadPNG downloadJPEG downloadPDF downloadSVG".split(" ")}},menuItemDefinitions:{printChart:{textKey:"printChart",
onclick:function(){this.print()}},separator:{separator:!0},downloadPNG:{textKey:"downloadPNG",onclick:function(){this.exportChart()}},downloadJPEG:{textKey:"downloadJPEG",onclick:function(){this.exportChart({type:"image/jpeg"})}},downloadPDF:{textKey:"downloadPDF",onclick:function(){this.exportChart({type:"application/pdf"})}},downloadSVG:{textKey:"downloadSVG",onclick:function(){this.exportChart({type:"image/svg+xml"})}}}};f.post=function(a,b,e){var c=r("form",n({method:"post",action:a,enctype:"multipart/form-data"},
e),{display:"none"},p.body);G(b,function(a,b){r("input",{type:"hidden",name:b,value:a},null,c)});c.submit();C(c)};t(B.prototype,{sanitizeSVG:function(a,b){if(b&&b.exporting&&b.exporting.allowHTML){var e=a.match(/<\/svg>(.*?$)/);e&&e[1]&&(e='\x3cforeignObject x\x3d"0" y\x3d"0" width\x3d"'+b.chart.width+'" height\x3d"'+b.chart.height+'"\x3e\x3cbody xmlns\x3d"http://www.w3.org/1999/xhtml"\x3e'+e[1]+"\x3c/body\x3e\x3c/foreignObject\x3e",a=a.replace("\x3c/svg\x3e",e+"\x3c/svg\x3e"))}a=a.replace(/zIndex="[^"]+"/g,
"").replace(/isShadow="[^"]+"/g,"").replace(/symbolName="[^"]+"/g,"").replace(/jQuery[0-9]+="[^"]+"/g,"").replace(/url\(("|&quot;)(\S+)("|&quot;)\)/g,"url($2)").replace(/url\([^#]+#/g,"url(#").replace(/<svg /,'\x3csvg xmlns:xlink\x3d"http://www.w3.org/1999/xlink" ').replace(/ (NS[0-9]+\:)?href=/g," xlink:href\x3d").replace(/\n/," ").replace(/<\/svg>.*?$/,"\x3c/svg\x3e").replace(/(fill|stroke)="rgba\(([ 0-9]+,[ 0-9]+,[ 0-9]+),([ 0-9\.]+)\)"/g,'$1\x3d"rgb($2)" $1-opacity\x3d"$3"').replace(/&nbsp;/g,
"\u00a0").replace(/&shy;/g,"\u00ad");return a=a.replace(/<IMG /g,"\x3cimage ").replace(/<(\/?)TITLE>/g,"\x3c$1title\x3e").replace(/height=([^" ]+)/g,'height\x3d"$1"').replace(/width=([^" ]+)/g,'width\x3d"$1"').replace(/hc-svg-href="([^"]+)">/g,'xlink:href\x3d"$1"/\x3e').replace(/ id=([^" >]+)/g,' id\x3d"$1"').replace(/class=([^" >]+)/g,'class\x3d"$1"').replace(/ transform /g," ").replace(/:(path|rect)/g,"$1").replace(/style="([^"]+)"/g,function(a){return a.toLowerCase()})},getChartHTML:function(){return this.container.innerHTML},
getSVG:function(a){var b,e,c,w,m,g=n(this.options,a);p.createElementNS||(p.createElementNS=function(a,b){return p.createElement(b)});e=r("div",null,{position:"absolute",top:"-9999em",width:this.chartWidth+"px",height:this.chartHeight+"px"},p.body);c=this.renderTo.style.width;m=this.renderTo.style.height;c=g.exporting.sourceWidth||g.chart.width||/px$/.test(c)&&parseInt(c,10)||600;m=g.exporting.sourceHeight||g.chart.height||/px$/.test(m)&&parseInt(m,10)||400;t(g.chart,{animation:!1,renderTo:e,forExport:!0,
renderer:"SVGRenderer",width:c,height:m});g.exporting.enabled=!1;delete g.data;g.series=[];h(this.series,function(a){w=n(a.userOptions,{animation:!1,enableMouseTracking:!1,showCheckbox:!1,visible:a.visible});w.isInternal||g.series.push(w)});h(this.axes,function(a){a.userOptions.internalKey||(a.userOptions.internalKey=f.uniqueKey())});b=new f.Chart(g,this.callback);a&&h(["xAxis","yAxis","series"],function(c){var d={};a[c]&&(d[c]=a[c],b.update(d))});h(this.axes,function(a){var c=f.find(b.axes,function(b){return b.options.internalKey===
a.userOptions.internalKey}),d=a.getExtremes(),e=d.userMin,d=d.userMax;!c||void 0===e&&void 0===d||c.setExtremes(e,d,!0,!1)});c=b.getChartHTML();c=this.sanitizeSVG(c,g);g=null;b.destroy();C(e);return c},getSVGForExport:function(a,b){var e=this.options.exporting;return this.getSVG(n({chart:{borderRadius:0}},e.chartOptions,b,{exporting:{sourceWidth:a&&a.sourceWidth||e.sourceWidth,sourceHeight:a&&a.sourceHeight||e.sourceHeight}}))},exportChart:function(a,b){b=this.getSVGForExport(a,b);a=n(this.options.exporting,
a);f.post(a.url,{filename:a.filename||"chart",type:a.type,width:a.width||0,scale:a.scale,svg:b},a.formAttributes)},print:function(){var a=this,b=a.container,e=[],c=b.parentNode,f=p.body,m=f.childNodes,g=a.options.exporting.printMaxWidth,d,u;if(!a.isPrinting){a.isPrinting=!0;a.pointer.reset(null,0);F(a,"beforePrint");if(u=g&&a.chartWidth>g)d=[a.options.chart.width,void 0,!1],a.setSize(g,void 0,!1);h(m,function(a,b){1===a.nodeType&&(e[b]=a.style.display,a.style.display="none")});f.appendChild(b);E.focus();
E.print();setTimeout(function(){c.appendChild(b);h(m,function(a,b){1===a.nodeType&&(a.style.display=e[b])});a.isPrinting=!1;u&&a.setSize.apply(a,d);F(a,"afterPrint")},1E3)}},contextMenu:function(a,b,e,c,w,m,g){var d=this,u=d.options.navigation,k=d.chartWidth,q=d.chartHeight,n="cache-"+a,l=d[n],y=Math.max(w,m),z,A;l||(d[n]=l=r("div",{className:a},{position:"absolute",zIndex:1E3,padding:y+"px"},d.container),z=r("div",{className:"highcharts-menu"},null,l),v(z,t({MozBoxShadow:"3px 3px 10px #888",WebkitBoxShadow:"3px 3px 10px #888",
boxShadow:"3px 3px 10px #888"},u.menuStyle)),A=function(){v(l,{display:"none"});g&&g.setState(0);d.openMenu=!1},d.exportEvents.push(x(l,"mouseleave",function(){l.hideTimer=setTimeout(A,500)}),x(l,"mouseenter",function(){clearTimeout(l.hideTimer)}),x(p,"mouseup",function(b){d.pointer.inClass(b.target,a)||A()})),h(b,function(a){"string"===typeof a&&(a=d.options.exporting.menuItemDefinitions[a]);if(f.isObject(a,!0)){var b;a.separator?b=r("hr",null,null,z):(b=r("div",{className:"highcharts-menu-item",
onclick:function(b){b&&b.stopPropagation();A();a.onclick&&a.onclick.apply(d,arguments)},innerHTML:a.text||d.options.lang[a.textKey]},null,z),b.onmouseover=function(){v(this,u.menuItemHoverStyle)},b.onmouseout=function(){v(this,u.menuItemStyle)},v(b,t({cursor:"pointer"},u.menuItemStyle)));d.exportDivElements.push(b)}}),d.exportDivElements.push(z,l),d.exportMenuWidth=l.offsetWidth,d.exportMenuHeight=l.offsetHeight);b={display:"block"};e+d.exportMenuWidth>k?b.right=k-e-w-y+"px":b.left=e-y+"px";c+m+d.exportMenuHeight>
q&&"top"!==g.alignOptions.verticalAlign?b.bottom=q-c-y+"px":b.top=c+m-y+"px";v(l,b);d.openMenu=!0},addButton:function(a){var b=this,e=b.renderer,c=n(b.options.navigation.buttonOptions,a),f=c.onclick,m=c.menuItems,g,d,k=c.symbolSize||12;b.btnCount||(b.btnCount=0);b.exportDivElements||(b.exportDivElements=[],b.exportSVGElements=[]);if(!1!==c.enabled){var h=c.theme,q=h.states,p=q&&q.hover,q=q&&q.select,l;delete h.states;f?l=function(a){a.stopPropagation();f.call(b,a)}:m&&(l=function(){b.contextMenu(d.menuClassName,
m,d.translateX,d.translateY,d.width,d.height,d);d.setState(2)});c.text&&c.symbol?h.paddingLeft=D(h.paddingLeft,25):c.text||t(h,{width:c.width,height:c.height,padding:0});d=e.button(c.text,0,0,l,h,p,q).addClass(a.className).attr({"stroke-linecap":"round",title:b.options.lang[c._titleKey],zIndex:3});d.menuClassName=a.menuClassName||"highcharts-menu-"+b.btnCount++;c.symbol&&(g=e.symbol(c.symbol,c.symbolX-k/2,c.symbolY-k/2,k,k).addClass("highcharts-button-symbol").attr({zIndex:1}).add(d),g.attr({stroke:c.symbolStroke,
fill:c.symbolFill,"stroke-width":c.symbolStrokeWidth||1}));d.add().align(t(c,{width:d.width,x:D(c.x,b.buttonOffset)}),!0,"spacingBox");b.buttonOffset+=(d.width+c.buttonSpacing)*("right"===c.align?-1:1);b.exportSVGElements.push(d,g)}},destroyExport:function(a){var b=a?a.target:this;a=b.exportSVGElements;var e=b.exportDivElements,c=b.exportEvents,f;a&&(h(a,function(a,c){a&&(a.onclick=a.ontouchstart=null,f="cache-"+a.menuClassName,b[f]&&delete b[f],b.exportSVGElements[c]=a.destroy())}),a.length=0);e&&
(h(e,function(a,c){clearTimeout(a.hideTimer);I(a,"mouseleave");b.exportDivElements[c]=a.onmouseout=a.onmouseover=a.ontouchstart=a.onclick=null;C(a)}),e.length=0);c&&(h(c,function(a){a()}),c.length=0)}});K.menu=function(a,b,e,c){return["M",a,b+2.5,"L",a+e,b+2.5,"M",a,b+c/2+.5,"L",a+e,b+c/2+.5,"M",a,b+c-1.5,"L",a+e,b+c-1.5]};B.prototype.renderExporting=function(){var a=this,b=a.options.exporting,e=b.buttons,c=a.isDirtyExporting||!a.exportSVGElements;a.buttonOffset=0;a.isDirtyExporting&&a.destroyExport();
c&&!1!==b.enabled&&(a.exportEvents=[],G(e,function(b){a.addButton(b)}),a.isDirtyExporting=!1);x(a,"destroy",a.destroyExport)};B.prototype.callbacks.push(function(a){a.renderExporting();x(a,"redraw",a.renderExporting);h(["exporting","navigation"],function(b){a[b]={update:function(e,c){a.isDirtyExporting=!0;n(!0,a.options[b],e);D(c,!0)&&a.redraw()}}})})})(k)});


/***/ },
/* 764 */
/***/ function(module, exports) {

/*
 Highcharts JS v5.0.14 (2017-07-28)
 Client side exporting module

 (c) 2015 Torstein Honsi / Oystein Moseng

 License: www.highcharts.com/license
*/
(function(n){"object"===typeof module&&module.exports?module.exports=n:n(Highcharts)})(function(n){(function(c){function n(a,c){var d=t.getElementsByTagName("head")[0],b=t.createElement("script");b.type="text/javascript";b.src=a;b.onload=c;b.onerror=function(){console.error("Error loading script",a)};d.appendChild(b)}var C=c.merge,e=c.win,r=e.navigator,t=e.document,z=c.each,w=e.URL||e.webkitURL||e,B=/Edge\/|Trident\/|MSIE /.test(r.userAgent),D=/Edge\/\d+/.test(r.userAgent),E=B?150:0;c.CanVGRenderer=
{};c.dataURLtoBlob=function(a){if(e.atob&&e.ArrayBuffer&&e.Uint8Array&&e.Blob&&w.createObjectURL){a=a.match(/data:([^;]*)(;base64)?,([0-9A-Za-z+/]+)/);for(var c=e.atob(a[3]),d=new e.ArrayBuffer(c.length),d=new e.Uint8Array(d),b=0;b<d.length;++b)d[b]=c.charCodeAt(b);a=new e.Blob([d],{type:a[1]});return w.createObjectURL(a)}};c.downloadURL=function(a,f){var d=t.createElement("a"),b;if("string"===typeof a||a instanceof String||!r.msSaveOrOpenBlob){if(D||2E6<a.length)if(a=c.dataURLtoBlob(a),!a)throw"Data URL length limit reached";
if(void 0!==d.download)d.href=a,d.download=f,t.body.appendChild(d),d.click(),t.body.removeChild(d);else try{if(b=e.open(a,"chart"),void 0===b||null===b)throw"Failed to open window";}catch(u){e.location.href=a}}else r.msSaveOrOpenBlob(a,f)};c.svgToDataUrl=function(a){var c=-1<r.userAgent.indexOf("WebKit")&&0>r.userAgent.indexOf("Chrome");try{if(!c&&0>r.userAgent.toLowerCase().indexOf("firefox"))return w.createObjectURL(new e.Blob([a],{type:"image/svg+xml;charset-utf-16"}))}catch(d){}return"data:image/svg+xml;charset\x3dUTF-8,"+
encodeURIComponent(a)};c.imageToDataUrl=function(a,c,d,b,u,l,k,m,p){var g=new e.Image,h,f=function(){setTimeout(function(){var e=t.createElement("canvas"),f=e.getContext&&e.getContext("2d"),x;try{if(f){e.height=g.height*b;e.width=g.width*b;f.drawImage(g,0,0,e.width,e.height);try{x=e.toDataURL(c),u(x,c,d,b)}catch(F){h(a,c,d,b)}}else k(a,c,d,b)}finally{p&&p(a,c,d,b)}},E)},q=function(){m(a,c,d,b);p&&p(a,c,d,b)};h=function(){g=new e.Image;h=l;g.crossOrigin="Anonymous";g.onload=f;g.onerror=q;g.src=a};
g.onload=f;g.onerror=q;g.src=a};c.downloadSVGLocal=function(a,f,d,b){function u(b,a){a=new e.jsPDF("l","pt",[b.width.baseVal.value+2*a,b.height.baseVal.value+2*a]);e.svg2pdf(b,a,{removeInvalid:!0});return a.output("datauristring")}function l(){y.innerHTML=a;var e=y.getElementsByTagName("text"),g,f=y.getElementsByTagName("svg")[0].style;z(e,function(b){z(["font-family","font-size"],function(a){!b.style[a]&&f[a]&&(b.style[a]=f[a])});b.style["font-family"]=b.style["font-family"]&&b.style["font-family"].split(" ").splice(-1);
g=b.getElementsByTagName("title");z(g,function(a){b.removeChild(a)})});e=u(y.firstChild,0);try{c.downloadURL(e,v),b&&b()}catch(G){d()}}var k,m,p=!0,g,h=f.libURL||c.getOptions().exporting.libURL,y=t.createElement("div"),q=f.type||"image/png",v=(f.filename||"chart")+"."+("image/svg+xml"===q?"svg":q.split("/")[1]),A=f.scale||1,h="/"!==h.slice(-1)?h+"/":h;if("image/svg+xml"===q)try{r.msSaveOrOpenBlob?(m=new MSBlobBuilder,m.append(a),k=m.getBlob("image/svg+xml")):k=c.svgToDataUrl(a),c.downloadURL(k,v),
b&&b()}catch(x){d()}else"application/pdf"===q?e.jsPDF&&e.svg2pdf?l():(p=!0,n(h+"jspdf.js",function(){n(h+"svg2pdf.js",function(){l()})})):(k=c.svgToDataUrl(a),g=function(){try{w.revokeObjectURL(k)}catch(x){}},c.imageToDataUrl(k,q,{},A,function(a){try{c.downloadURL(a,v),b&&b()}catch(F){d()}},function(){var f=t.createElement("canvas"),u=f.getContext("2d"),l=a.match(/^<svg[^>]*width\s*=\s*\"?(\d+)\"?[^>]*>/)[1]*A,k=a.match(/^<svg[^>]*height\s*=\s*\"?(\d+)\"?[^>]*>/)[1]*A,m=function(){u.drawSvg(a,0,0,
l,k);try{c.downloadURL(r.msSaveOrOpenBlob?f.msToBlob():f.toDataURL(q),v),b&&b()}catch(H){d()}finally{g()}};f.width=l;f.height=k;e.canvg?m():(p=!0,n(h+"rgbcolor.js",function(){n(h+"canvg.js",function(){m()})}))},d,d,function(){p&&g()}))};c.Chart.prototype.getSVGForLocalExport=function(a,e,d,b){var f=this,l,k=0,m,p,g,h,n,q=function(a,c,d){++k;d.imageElement.setAttributeNS("http://www.w3.org/1999/xlink","href",a);k===l.length&&b(f.sanitizeSVG(m.innerHTML,p))};c.wrap(c.Chart.prototype,"getChartHTML",
function(a){var b=a.apply(this,Array.prototype.slice.call(arguments,1));p=this.options;m=this.container.cloneNode(!0);return b});f.getSVGForExport(a,e);l=m.getElementsByTagName("image");try{if(l.length)for(h=0,n=l.length;h<n;++h)g=l[h],c.imageToDataUrl(g.getAttributeNS("http://www.w3.org/1999/xlink","href"),"image/png",{imageElement:g},a.scale,q,d,d,d);else b(f.sanitizeSVG(m.innerHTML,p))}catch(v){d()}};c.Chart.prototype.exportChartLocal=function(a,e){var d=this,b=c.merge(d.options.exporting,a),f=
function(){if(!1===b.fallbackToExportServer)if(b.error)b.error(b);else throw"Fallback to export server disabled";else d.exportChart(b)};B&&("application/pdf"===b.type||d.container.getElementsByTagName("image").length&&"image/svg+xml"!==b.type)||"application/pdf"===b.type&&d.container.getElementsByTagName("image").length?f():d.getSVGForLocalExport(b,e,f,function(a){-1<a.indexOf("\x3cforeignObject")&&"image/svg+xml"!==b.type?f():c.downloadSVGLocal(a,b,f)})};C(!0,c.getOptions().exporting,{libURL:"https://code.highcharts.com/5.0.14/lib/",
menuItemDefinitions:{downloadPNG:{textKey:"downloadPNG",onclick:function(){this.exportChartLocal()}},downloadJPEG:{textKey:"downloadJPEG",onclick:function(){this.exportChartLocal({type:"image/jpeg"})}},downloadSVG:{textKey:"downloadSVG",onclick:function(){this.exportChartLocal({type:"image/svg+xml"})}},downloadPDF:{textKey:"downloadPDF",onclick:function(){this.exportChartLocal({type:"application/pdf"})}}}})})(n)});


/***/ },
/* 765 */
/***/ function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          )

        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

var ReactPropTypesSecret = __webpack_require__(274);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

var assign = __webpack_require__(19);

var ReactPropTypesSecret = __webpack_require__(274);
var checkPropTypes = __webpack_require__(766);

var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? printWarning('Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ },
/* 769 */
/***/ function(module, exports) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ },
/* 770 */
/***/ function(module, exports) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ },
/* 771 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ReactDOMComponentTree = __webpack_require__(25);

var focusNode = __webpack_require__(268);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var EventPropagators = __webpack_require__(110);
var ExecutionEnvironment = __webpack_require__(32);
var FallbackCompositionState = __webpack_require__(779);
var SyntheticCompositionEvent = __webpack_require__(816);
var SyntheticInputEvent = __webpack_require__(819);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var CSSProperty = __webpack_require__(276);
var ExecutionEnvironment = __webpack_require__(32);
var ReactInstrumentation = __webpack_require__(51);

var camelizeStyleName = __webpack_require__(751);
var dangerousStyleValue = __webpack_require__(825);
var hyphenateStyleName = __webpack_require__(758);
var memoizeStringOnly = __webpack_require__(761);
var warning = __webpack_require__(17);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var EventPluginHub = __webpack_require__(109);
var EventPropagators = __webpack_require__(110);
var ExecutionEnvironment = __webpack_require__(32);
var ReactDOMComponentTree = __webpack_require__(25);
var ReactUpdates = __webpack_require__(60);
var SyntheticEvent = __webpack_require__(64);

var inputValueTracking = __webpack_require__(292);
var getEventTarget = __webpack_require__(198);
var isEventSupported = __webpack_require__(199);
var isTextInputElement = __webpack_require__(294);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var DOMLazyTree = __webpack_require__(96);
var ExecutionEnvironment = __webpack_require__(32);

var createNodesFromMarkup = __webpack_require__(754);
var emptyFunction = __webpack_require__(59);
var invariant = __webpack_require__(7);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ },
/* 777 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var EventPropagators = __webpack_require__(110);
var ReactDOMComponentTree = __webpack_require__(25);
var SyntheticMouseEvent = __webpack_require__(141);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _assign = __webpack_require__(19);

var PooledClass = __webpack_require__(86);

var getTextContentAccessor = __webpack_require__(291);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var DOMProperty = __webpack_require__(97);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ReactReconciler = __webpack_require__(98);

var instantiateReactComponent = __webpack_require__(293);
var KeyEscapeUtils = __webpack_require__(190);
var shouldUpdateReactComponent = __webpack_require__(200);
var traverseAllChildren = __webpack_require__(296);
var warning = __webpack_require__(17);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && {"BABEL_ENV":"production"} && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(298);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(271)))

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var DOMChildrenOperations = __webpack_require__(186);
var ReactDOMIDOperations = __webpack_require__(789);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15),
    _assign = __webpack_require__(19);

var React = __webpack_require__(99);
var ReactComponentEnvironment = __webpack_require__(192);
var ReactCurrentOwner = __webpack_require__(65);
var ReactErrorUtils = __webpack_require__(193);
var ReactInstanceMap = __webpack_require__(111);
var ReactInstrumentation = __webpack_require__(51);
var ReactNodeTypes = __webpack_require__(286);
var ReactReconciler = __webpack_require__(98);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(139);
var invariant = __webpack_require__(7);
var shallowEqual = __webpack_require__(185);
var shouldUpdateReactComponent = __webpack_require__(200);
var warning = __webpack_require__(17);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/

'use strict';

var ReactDOMComponentTree = __webpack_require__(25);
var ReactDefaultInjection = __webpack_require__(797);
var ReactMount = __webpack_require__(285);
var ReactReconciler = __webpack_require__(98);
var ReactUpdates = __webpack_require__(60);
var ReactVersion = __webpack_require__(810);

var findDOMNode = __webpack_require__(826);
var getHostComponentFromComposite = __webpack_require__(290);
var renderSubtreeIntoContainer = __webpack_require__(833);
var warning = __webpack_require__(17);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */

'use strict';

var _prodInvariant = __webpack_require__(15),
    _assign = __webpack_require__(19);

var AutoFocusUtils = __webpack_require__(772);
var CSSPropertyOperations = __webpack_require__(774);
var DOMLazyTree = __webpack_require__(96);
var DOMNamespaces = __webpack_require__(187);
var DOMProperty = __webpack_require__(97);
var DOMPropertyOperations = __webpack_require__(278);
var EventPluginHub = __webpack_require__(109);
var EventPluginRegistry = __webpack_require__(188);
var ReactBrowserEventEmitter = __webpack_require__(140);
var ReactDOMComponentFlags = __webpack_require__(279);
var ReactDOMComponentTree = __webpack_require__(25);
var ReactDOMInput = __webpack_require__(790);
var ReactDOMOption = __webpack_require__(791);
var ReactDOMSelect = __webpack_require__(280);
var ReactDOMTextarea = __webpack_require__(794);
var ReactInstrumentation = __webpack_require__(51);
var ReactMultiChild = __webpack_require__(803);
var ReactServerRenderingTransaction = __webpack_require__(808);

var emptyFunction = __webpack_require__(59);
var escapeTextContentForBrowser = __webpack_require__(143);
var invariant = __webpack_require__(7);
var isEventSupported = __webpack_require__(199);
var shallowEqual = __webpack_require__(185);
var inputValueTracking = __webpack_require__(292);
var validateDOMNesting = __webpack_require__(201);
var warning = __webpack_require__(17);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);

        // We also check that we haven't missed a value update, such as a
        // Radio group shifting the checked value to another named radio input.
        inputValueTracking.updateValueIfChanged(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var validateDOMNesting = __webpack_require__(201);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _assign = __webpack_require__(19);

var DOMLazyTree = __webpack_require__(96);
var ReactDOMComponentTree = __webpack_require__(25);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ },
/* 788 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var DOMChildrenOperations = __webpack_require__(186);
var ReactDOMComponentTree = __webpack_require__(25);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15),
    _assign = __webpack_require__(19);

var DOMPropertyOperations = __webpack_require__(278);
var LinkedValueUtils = __webpack_require__(191);
var ReactDOMComponentTree = __webpack_require__(25);
var ReactUpdates = __webpack_require__(60);

var invariant = __webpack_require__(7);
var warning = __webpack_require__(17);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _assign = __webpack_require__(19);

var React = __webpack_require__(99);
var ReactDOMComponentTree = __webpack_require__(25);
var ReactDOMSelect = __webpack_require__(280);

var warning = __webpack_require__(17);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(32);

var getNodeForCharacterOffset = __webpack_require__(830);
var getTextContentAccessor = __webpack_require__(291);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15),
    _assign = __webpack_require__(19);

var DOMChildrenOperations = __webpack_require__(186);
var DOMLazyTree = __webpack_require__(96);
var ReactDOMComponentTree = __webpack_require__(25);

var escapeTextContentForBrowser = __webpack_require__(143);
var invariant = __webpack_require__(7);
var validateDOMNesting = __webpack_require__(201);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15),
    _assign = __webpack_require__(19);

var LinkedValueUtils = __webpack_require__(191);
var ReactDOMComponentTree = __webpack_require__(25);
var ReactUpdates = __webpack_require__(60);

var invariant = __webpack_require__(7);
var warning = __webpack_require__(17);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(7);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _assign = __webpack_require__(19);

var ReactUpdates = __webpack_require__(60);
var Transaction = __webpack_require__(142);

var emptyFunction = __webpack_require__(59);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ARIADOMPropertyConfig = __webpack_require__(771);
var BeforeInputEventPlugin = __webpack_require__(773);
var ChangeEventPlugin = __webpack_require__(775);
var DefaultEventPluginOrder = __webpack_require__(777);
var EnterLeaveEventPlugin = __webpack_require__(778);
var HTMLDOMPropertyConfig = __webpack_require__(780);
var ReactComponentBrowserEnvironment = __webpack_require__(782);
var ReactDOMComponent = __webpack_require__(785);
var ReactDOMComponentTree = __webpack_require__(25);
var ReactDOMEmptyComponent = __webpack_require__(787);
var ReactDOMTreeTraversal = __webpack_require__(795);
var ReactDOMTextComponent = __webpack_require__(793);
var ReactDefaultBatchingStrategy = __webpack_require__(796);
var ReactEventListener = __webpack_require__(800);
var ReactInjection = __webpack_require__(801);
var ReactReconcileTransaction = __webpack_require__(806);
var SVGDOMPropertyConfig = __webpack_require__(811);
var SelectEventPlugin = __webpack_require__(812);
var SimpleEventPlugin = __webpack_require__(813);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ },
/* 798 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var EventPluginHub = __webpack_require__(109);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _assign = __webpack_require__(19);

var EventListener = __webpack_require__(267);
var ExecutionEnvironment = __webpack_require__(32);
var PooledClass = __webpack_require__(86);
var ReactDOMComponentTree = __webpack_require__(25);
var ReactUpdates = __webpack_require__(60);

var getEventTarget = __webpack_require__(198);
var getUnboundedScrollPosition = __webpack_require__(756);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var DOMProperty = __webpack_require__(97);
var EventPluginHub = __webpack_require__(109);
var EventPluginUtils = __webpack_require__(189);
var ReactComponentEnvironment = __webpack_require__(192);
var ReactEmptyComponent = __webpack_require__(281);
var ReactBrowserEventEmitter = __webpack_require__(140);
var ReactHostComponent = __webpack_require__(283);
var ReactUpdates = __webpack_require__(60);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var adler32 = __webpack_require__(824);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var ReactComponentEnvironment = __webpack_require__(192);
var ReactInstanceMap = __webpack_require__(111);
var ReactInstrumentation = __webpack_require__(51);

var ReactCurrentOwner = __webpack_require__(65);
var ReactReconciler = __webpack_require__(98);
var ReactChildReconciler = __webpack_require__(781);

var emptyFunction = __webpack_require__(59);
var flattenChildren = __webpack_require__(827);
var invariant = __webpack_require__(7);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var invariant = __webpack_require__(7);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ },
/* 805 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _assign = __webpack_require__(19);

var CallbackQueue = __webpack_require__(277);
var PooledClass = __webpack_require__(86);
var ReactBrowserEventEmitter = __webpack_require__(140);
var ReactInputSelection = __webpack_require__(284);
var ReactInstrumentation = __webpack_require__(51);
var Transaction = __webpack_require__(142);
var ReactUpdateQueue = __webpack_require__(194);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var ReactOwner = __webpack_require__(804);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _assign = __webpack_require__(19);

var PooledClass = __webpack_require__(86);
var Transaction = __webpack_require__(142);
var ReactInstrumentation = __webpack_require__(51);
var ReactServerUpdateQueue = __webpack_require__(809);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(194);

var warning = __webpack_require__(17);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ },
/* 810 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

module.exports = '15.6.2';

/***/ },
/* 811 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var EventPropagators = __webpack_require__(110);
var ExecutionEnvironment = __webpack_require__(32);
var ReactDOMComponentTree = __webpack_require__(25);
var ReactInputSelection = __webpack_require__(284);
var SyntheticEvent = __webpack_require__(64);

var getActiveElement = __webpack_require__(269);
var isTextInputElement = __webpack_require__(294);
var shallowEqual = __webpack_require__(185);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var EventListener = __webpack_require__(267);
var EventPropagators = __webpack_require__(110);
var ReactDOMComponentTree = __webpack_require__(25);
var SyntheticAnimationEvent = __webpack_require__(814);
var SyntheticClipboardEvent = __webpack_require__(815);
var SyntheticEvent = __webpack_require__(64);
var SyntheticFocusEvent = __webpack_require__(818);
var SyntheticKeyboardEvent = __webpack_require__(820);
var SyntheticMouseEvent = __webpack_require__(141);
var SyntheticDragEvent = __webpack_require__(817);
var SyntheticTouchEvent = __webpack_require__(821);
var SyntheticTransitionEvent = __webpack_require__(822);
var SyntheticUIEvent = __webpack_require__(112);
var SyntheticWheelEvent = __webpack_require__(823);

var emptyFunction = __webpack_require__(59);
var getEventCharCode = __webpack_require__(196);
var invariant = __webpack_require__(7);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var SyntheticEvent = __webpack_require__(64);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var SyntheticEvent = __webpack_require__(64);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var SyntheticEvent = __webpack_require__(64);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var SyntheticMouseEvent = __webpack_require__(141);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var SyntheticUIEvent = __webpack_require__(112);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var SyntheticEvent = __webpack_require__(64);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var SyntheticUIEvent = __webpack_require__(112);

var getEventCharCode = __webpack_require__(196);
var getEventKey = __webpack_require__(828);
var getEventModifierState = __webpack_require__(197);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var SyntheticUIEvent = __webpack_require__(112);

var getEventModifierState = __webpack_require__(197);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var SyntheticEvent = __webpack_require__(64);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var SyntheticMouseEvent = __webpack_require__(141);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ },
/* 824 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var CSSProperty = __webpack_require__(276);
var warning = __webpack_require__(17);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(15);

var ReactCurrentOwner = __webpack_require__(65);
var ReactDOMComponentTree = __webpack_require__(25);
var ReactInstanceMap = __webpack_require__(111);

var getHostComponentFromComposite = __webpack_require__(290);
var invariant = __webpack_require__(7);
var warning = __webpack_require__(17);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var KeyEscapeUtils = __webpack_require__(190);
var traverseAllChildren = __webpack_require__(296);
var warning = __webpack_require__(17);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && {"BABEL_ENV":"production"} && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(298);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(271)))

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var getEventCharCode = __webpack_require__(196);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ },
/* 829 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ },
/* 830 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ExecutionEnvironment = __webpack_require__(32);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var escapeTextContentForBrowser = __webpack_require__(143);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ReactMount = __webpack_require__(285);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(1),__webpack_require__(835)):"function"==typeof define&&define.amd?define(["react","highcharts"],t):"object"==typeof exports?exports.ReactHighcharts=t(require("react"),require("highcharts")):e.ReactHighcharts=t(e.React,e.Highcharts)}("undefined"!=typeof self?self:this,function(e,t){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var o=t[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:n})},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=4)}([function(t,r){t.exports=e},function(e,t,r){"use strict";(function(n){Object.defineProperty(t,"__esModule",{value:!0});var o,i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},a=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),c=r(0),u=(o=c,o&&o.__esModule?o:{default:o});var f=void 0===n?window:n;t.default=function(t,r){var n=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(n,c.Component);function n(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n);var e=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(n.__proto__||Object.getPrototypeOf(n)).call(this));return e.chartType=t,e.Highcharts=r,e.displayName="Highcharts"+t,e}return a(n,[{key:"setChartRef",value:function(e){this.chartRef=e}},{key:"renderChart",value:function(e){var t=this;if(!e)throw new Error("Config must be specified for the "+this.displayName+" component");var r=e.chart;this.chart=new this.Highcharts[this.chartType](i({},e,{chart:i({},r,{renderTo:this.chartRef})}),this.props.callback),this.props.neverReflow||f&&f.requestAnimationFrame&&requestAnimationFrame(function(){t.chart&&t.chart.options&&t.chart.reflow()})}},{key:"shouldComponentUpdate",value:function(e){return!!(e.neverReflow||e.isPureConfig&&this.props.config===e.config)||(this.renderChart(e.config),!1)}},{key:"getChart",value:function(){if(!this.chart)throw new Error("getChart() should not be called before the component is mounted");return this.chart}},{key:"componentDidMount",value:function(){this.renderChart(this.props.config)}},{key:"componentWillUnmount",value:function(){this.chart.destroy()}},{key:"render",value:function(){return u.default.createElement("div",i({ref:this.setChartRef.bind(this)},this.props.domProps))}}]),n}();n.defaultProps={callback:function(){},domProps:{}};var o=n;return o.Highcharts=r,o.withHighcharts=function(r){return e.exports(t,r)},o},e.exports=t.default}).call(t,r(2))},function(e,t){var r;r=function(){return this}();try{r=r||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(r=window)}e.exports=r},,function(e,t,r){e.exports=r(5)},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=i(r(1)),o=i(r(6));function i(e){return e&&e.__esModule?e:{default:e}}t.default=(0,n.default)("Chart",o.default),e.exports=t.default},function(e,r){e.exports=t}])});

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v6.1.2 (2018-08-31)

 (c) 2009-2016 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(T,K){"object"===typeof module&&module.exports?module.exports=T.document?K(T):K: true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return K(T)}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):T.Highcharts=K(T)})("undefined"!==typeof window?window:this,function(T){var K=function(){var a="undefined"===typeof T?window:T,C=a.document,D=a.navigator&&a.navigator.userAgent||"",E=C&&C.createElementNS&&!!C.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,m=/(edge|msie|trident)/i.test(D)&&!a.opera,h=-1!==D.indexOf("Firefox"),
f=-1!==D.indexOf("Chrome"),r=h&&4>parseInt(D.split("Firefox/")[1],10);return a.Highcharts?a.Highcharts.error(16,!0):{product:"Highcharts",version:"6.1.2",deg2rad:2*Math.PI/360,doc:C,hasBidiBug:r,hasTouch:C&&void 0!==C.documentElement.ontouchstart,isMS:m,isWebKit:-1!==D.indexOf("AppleWebKit"),isFirefox:h,isChrome:f,isSafari:!f&&-1!==D.indexOf("Safari"),isTouchDevice:/(Mobile|Android|Windows Phone)/.test(D),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:E,win:a,marginNames:["plotTop",
"marginRight","marginBottom","plotLeft"],noop:function(){},charts:[]}}();(function(a){a.timers=[];var C=a.charts,D=a.doc,E=a.win;a.error=function(m,h){m=a.isNumber(m)?"Highcharts error #"+m+": www.highcharts.com/errors/"+m:m;if(h)throw Error(m);E.console&&console.log(m)};a.Fx=function(a,h,f){this.options=h;this.elem=a;this.prop=f};a.Fx.prototype={dSetter:function(){var a=this.paths[0],h=this.paths[1],f=[],r=this.now,y=a.length,q;if(1===r)f=this.toD;else if(y===h.length&&1>r)for(;y--;)q=parseFloat(a[y]),
f[y]=isNaN(q)?h[y]:r*parseFloat(h[y]-q)+q;else f=h;this.elem.attr("d",f,null,!0)},update:function(){var a=this.elem,h=this.prop,f=this.now,r=this.options.step;if(this[h+"Setter"])this[h+"Setter"]();else a.attr?a.element&&a.attr(h,f,null,!0):a.style[h]=f+this.unit;r&&r.call(a,f,this)},run:function(m,h,f){var r=this,y=r.options,q=function(a){return q.stopped?!1:r.step(a)},w=E.requestAnimationFrame||function(a){setTimeout(a,13)},e=function(){for(var c=0;c<a.timers.length;c++)a.timers[c]()||a.timers.splice(c--,
1);a.timers.length&&w(e)};m!==h||this.elem["forceAnimate:"+this.prop]?(this.startTime=+new Date,this.start=m,this.end=h,this.unit=f,this.now=this.start,this.pos=0,q.elem=this.elem,q.prop=this.prop,q()&&1===a.timers.push(q)&&w(e)):(delete y.curAnim[this.prop],y.complete&&0===a.keys(y.curAnim).length&&y.complete.call(this.elem))},step:function(m){var h=+new Date,f,r=this.options,y=this.elem,q=r.complete,w=r.duration,e=r.curAnim;y.attr&&!y.element?m=!1:m||h>=w+this.startTime?(this.now=this.end,this.pos=
1,this.update(),f=e[this.prop]=!0,a.objectEach(e,function(a){!0!==a&&(f=!1)}),f&&q&&q.call(y),m=!1):(this.pos=r.easing((h-this.startTime)/w),this.now=this.start+(this.end-this.start)*this.pos,this.update(),m=!0);return m},initPath:function(m,h,f){function r(a){var d,k;for(b=a.length;b--;)d="M"===a[b]||"L"===a[b],k=/[a-zA-Z]/.test(a[b+3]),d&&k&&a.splice(b+1,0,a[b+1],a[b+2],a[b+1],a[b+2])}function y(a,d){for(;a.length<k;){a[0]=d[k-a.length];var c=a.slice(0,z);[].splice.apply(a,[0,0].concat(c));u&&(c=
a.slice(a.length-z),[].splice.apply(a,[a.length,0].concat(c)),b--)}a[0]="M"}function q(a,b){for(var c=(k-a.length)/z;0<c&&c--;)d=a.slice().splice(a.length/p-z,z*p),d[0]=b[k-z-c*z],l&&(d[z-6]=d[z-2],d[z-5]=d[z-1]),[].splice.apply(a,[a.length/p,0].concat(d)),u&&c--}h=h||"";var w,e=m.startX,c=m.endX,l=-1<h.indexOf("C"),z=l?7:3,k,d,b;h=h.split(" ");f=f.slice();var u=m.isArea,p=u?2:1,H;l&&(r(h),r(f));if(e&&c){for(b=0;b<e.length;b++)if(e[b]===c[0]){w=b;break}else if(e[0]===c[c.length-e.length+b]){w=b;H=
!0;break}void 0===w&&(h=[])}h.length&&a.isNumber(w)&&(k=f.length+w*p*z,H?(y(h,f),q(f,h)):(y(f,h),q(h,f)));return[h,f]},fillSetter:function(){a.Fx.prototype.strokeSetter.apply(this,arguments)},strokeSetter:function(){this.elem.attr(this.prop,a.color(this.start).tweenTo(a.color(this.end),this.pos),null,!0)}};a.merge=function(){var m,h=arguments,f,r={},y=function(f,m){"object"!==typeof f&&(f={});a.objectEach(m,function(e,c){!a.isObject(e,!0)||a.isClass(e)||a.isDOMElement(e)?f[c]=m[c]:f[c]=y(f[c]||{},
e)});return f};!0===h[0]&&(r=h[1],h=Array.prototype.slice.call(h,2));f=h.length;for(m=0;m<f;m++)r=y(r,h[m]);return r};a.pInt=function(a,h){return parseInt(a,h||10)};a.isString=function(a){return"string"===typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(m,h){return!!m&&"object"===typeof m&&(!h||!a.isArray(m))};a.isDOMElement=function(m){return a.isObject(m)&&"number"===typeof m.nodeType};a.isClass=function(m){var h=
m&&m.constructor;return!(!a.isObject(m,!0)||a.isDOMElement(m)||!h||!h.name||"Object"===h.name)};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)&&Infinity>a&&-Infinity<a};a.erase=function(a,h){for(var f=a.length;f--;)if(a[f]===h){a.splice(f,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(m,h,f){var r;a.isString(h)?a.defined(f)?m.setAttribute(h,f):m&&m.getAttribute&&((r=m.getAttribute(h))||"class"!==h||(r=m.getAttribute(h+"Name"))):a.defined(h)&&a.isObject(h)&&
a.objectEach(h,function(a,f){m.setAttribute(f,a)});return r};a.splat=function(m){return a.isArray(m)?m:[m]};a.syncTimeout=function(a,h,f){if(h)return setTimeout(a,h,f);a.call(0,f)};a.clearTimeout=function(m){a.defined(m)&&clearTimeout(m)};a.extend=function(a,h){var f;a||(a={});for(f in h)a[f]=h[f];return a};a.pick=function(){var a=arguments,h,f,r=a.length;for(h=0;h<r;h++)if(f=a[h],void 0!==f&&null!==f)return f};a.css=function(m,h){a.isMS&&!a.svg&&h&&void 0!==h.opacity&&(h.filter="alpha(opacity\x3d"+
100*h.opacity+")");a.extend(m.style,h)};a.createElement=function(m,h,f,r,y){m=D.createElement(m);var q=a.css;h&&a.extend(m,h);y&&q(m,{padding:0,border:"none",margin:0});f&&q(m,f);r&&r.appendChild(m);return m};a.extendClass=function(m,h){var f=function(){};f.prototype=new m;a.extend(f.prototype,h);return f};a.pad=function(a,h,f){return Array((h||2)+1-String(a).replace("-","").length).join(f||0)+a};a.relativeLength=function(a,h,f){return/%$/.test(a)?h*parseFloat(a)/100+(f||0):parseFloat(a)};a.wrap=
function(a,h,f){var m=a[h];a[h]=function(){var a=Array.prototype.slice.call(arguments),q=arguments,w=this;w.proceed=function(){m.apply(w,arguments.length?arguments:q)};a.unshift(m);a=f.apply(this,a);w.proceed=null;return a}};a.formatSingle=function(m,h,f){var r=/\.([0-9])/,y=a.defaultOptions.lang;/f$/.test(m)?(f=(f=m.match(r))?f[1]:-1,null!==h&&(h=a.numberFormat(h,f,y.decimalPoint,-1<m.indexOf(",")?y.thousandsSep:""))):h=(f||a.time).dateFormat(m,h);return h};a.format=function(m,h,f){for(var r="{",
y=!1,q,w,e,c,l=[],z;m;){r=m.indexOf(r);if(-1===r)break;q=m.slice(0,r);if(y){q=q.split(":");w=q.shift().split(".");c=w.length;z=h;for(e=0;e<c;e++)z&&(z=z[w[e]]);q.length&&(z=a.formatSingle(q.join(":"),z,f));l.push(z)}else l.push(q);m=m.slice(r+1);r=(y=!y)?"}":"{"}l.push(m);return l.join("")};a.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(m,h,f,r,y){var q,w=m;f=a.pick(f,1);q=m/f;h||(h=y?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],
!1===r&&(1===f?h=a.grep(h,function(a){return 0===a%1}):.1>=f&&(h=[1/f])));for(r=0;r<h.length&&!(w=h[r],y&&w*f>=m||!y&&q<=(h[r]+(h[r+1]||h[r]))/2);r++);return w=a.correctFloat(w*f,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=function(a,h){var f=a.length,m,y;for(y=0;y<f;y++)a[y].safeI=y;a.sort(function(a,f){m=h(a,f);return 0===m?a.safeI-f.safeI:m});for(y=0;y<f;y++)delete a[y].safeI};a.arrayMin=function(a){for(var h=a.length,f=a[0];h--;)a[h]<f&&(f=a[h]);return f};a.arrayMax=function(a){for(var h=
a.length,f=a[0];h--;)a[h]>f&&(f=a[h]);return f};a.destroyObjectProperties=function(m,h){a.objectEach(m,function(a,r){a&&a!==h&&a.destroy&&a.destroy();delete m[r]})};a.discardElement=function(m){var h=a.garbageBin;h||(h=a.createElement("div"));m&&h.appendChild(m);h.innerHTML=""};a.correctFloat=function(a,h){return parseFloat(a.toPrecision(h||14))};a.setAnimation=function(m,h){h.renderer.globalAnimation=a.pick(m,h.options.chart.animation,!0)};a.animObject=function(m){return a.isObject(m)?a.merge(m):
{duration:m?500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};a.numberFormat=function(m,h,f,r){m=+m||0;h=+h;var y=a.defaultOptions.lang,q=(m.toString().split(".")[1]||"").split("e")[0].length,w,e,c=m.toString().split("e");-1===h?h=Math.min(q,20):a.isNumber(h)?h&&c[1]&&0>c[1]&&(w=h+ +c[1],0<=w?(c[0]=(+c[0]).toExponential(w).split("e")[0],h=w):(c[0]=c[0].split(".")[0]||0,m=20>h?(c[0]*Math.pow(10,c[1])).toFixed(h):0,c[1]=0)):h=2;e=(Math.abs(c[1]?
c[0]:m)+Math.pow(10,-Math.max(h,q)-1)).toFixed(h);q=String(a.pInt(e));w=3<q.length?q.length%3:0;f=a.pick(f,y.decimalPoint);r=a.pick(r,y.thousandsSep);m=(0>m?"-":"")+(w?q.substr(0,w)+r:"");m+=q.substr(w).replace(/(\d{3})(?=\d)/g,"$1"+r);h&&(m+=f+e.slice(-h));c[1]&&0!==+m&&(m+="e"+c[1]);return m};Math.easeInOutSine=function(a){return-.5*(Math.cos(Math.PI*a)-1)};a.getStyle=function(m,h,f){if("width"===h)return Math.max(0,Math.min(m.offsetWidth,m.scrollWidth)-a.getStyle(m,"padding-left")-a.getStyle(m,
"padding-right"));if("height"===h)return Math.max(0,Math.min(m.offsetHeight,m.scrollHeight)-a.getStyle(m,"padding-top")-a.getStyle(m,"padding-bottom"));E.getComputedStyle||a.error(27,!0);if(m=E.getComputedStyle(m,void 0))m=m.getPropertyValue(h),a.pick(f,"opacity"!==h)&&(m=a.pInt(m));return m};a.inArray=function(m,h,f){return(a.indexOfPolyfill||Array.prototype.indexOf).call(h,m,f)};a.grep=function(m,h){return(a.filterPolyfill||Array.prototype.filter).call(m,h)};a.find=Array.prototype.find?function(a,
h){return a.find(h)}:function(a,h){var f,r=a.length;for(f=0;f<r;f++)if(h(a[f],f))return a[f]};a.some=function(m,h,f){return(a.somePolyfill||Array.prototype.some).call(m,h,f)};a.map=function(a,h){for(var f=[],r=0,y=a.length;r<y;r++)f[r]=h.call(a[r],a[r],r,a);return f};a.keys=function(m){return(a.keysPolyfill||Object.keys).call(void 0,m)};a.reduce=function(m,h,f){return(a.reducePolyfill||Array.prototype.reduce).apply(m,2<arguments.length?[h,f]:[h])};a.offset=function(a){var h=D.documentElement;a=a.parentElement||
a.parentNode?a.getBoundingClientRect():{top:0,left:0};return{top:a.top+(E.pageYOffset||h.scrollTop)-(h.clientTop||0),left:a.left+(E.pageXOffset||h.scrollLeft)-(h.clientLeft||0)}};a.stop=function(m,h){for(var f=a.timers.length;f--;)a.timers[f].elem!==m||h&&h!==a.timers[f].prop||(a.timers[f].stopped=!0)};a.each=function(m,h,f){return(a.forEachPolyfill||Array.prototype.forEach).call(m,h,f)};a.objectEach=function(a,h,f){for(var r in a)a.hasOwnProperty(r)&&h.call(f||a[r],a[r],r,a)};a.addEvent=function(m,
h,f,r){var y,q=m.addEventListener||a.addEventListenerPolyfill;y="function"===typeof m&&m.prototype?m.prototype.protoEvents=m.prototype.protoEvents||{}:m.hcEvents=m.hcEvents||{};a.Point&&m instanceof a.Point&&m.series&&m.series.chart&&(m.series.chart.runTrackerClick=!0);q&&q.call(m,h,f,!1);y[h]||(y[h]=[]);y[h].push(f);r&&a.isNumber(r.order)&&(f.order=r.order,y[h].sort(function(a,e){return a.order-e.order}));return function(){a.removeEvent(m,h,f)}};a.removeEvent=function(m,h,f){function r(e,c){var l=
m.removeEventListener||a.removeEventListenerPolyfill;l&&l.call(m,e,c,!1)}function y(e){var c,l;m.nodeName&&(h?(c={},c[h]=!0):c=e,a.objectEach(c,function(a,k){if(e[k])for(l=e[k].length;l--;)r(k,e[k][l])}))}var q,w;a.each(["protoEvents","hcEvents"],function(e){var c=m[e];c&&(h?(q=c[h]||[],f?(w=a.inArray(f,q),-1<w&&(q.splice(w,1),c[h]=q),r(h,f)):(y(c),c[h]=[])):(y(c),m[e]={}))})};a.fireEvent=function(m,h,f,r){var y,q,w,e,c;f=f||{};D.createEvent&&(m.dispatchEvent||m.fireEvent)?(y=D.createEvent("Events"),
y.initEvent(h,!0,!0),a.extend(y,f),m.dispatchEvent?m.dispatchEvent(y):m.fireEvent(h,y)):a.each(["protoEvents","hcEvents"],function(l){if(m[l])for(q=m[l][h]||[],w=q.length,f.target||a.extend(f,{preventDefault:function(){f.defaultPrevented=!0},target:m,type:h}),e=0;e<w;e++)(c=q[e])&&!1===c.call(m,f)&&f.preventDefault()});r&&!f.defaultPrevented&&r.call(m,f)};a.animate=function(m,h,f){var r,y="",q,w,e;a.isObject(f)||(e=arguments,f={duration:e[2],easing:e[3],complete:e[4]});a.isNumber(f.duration)||(f.duration=
400);f.easing="function"===typeof f.easing?f.easing:Math[f.easing]||Math.easeInOutSine;f.curAnim=a.merge(h);a.objectEach(h,function(c,e){a.stop(m,e);w=new a.Fx(m,f,e);q=null;"d"===e?(w.paths=w.initPath(m,m.d,h.d),w.toD=h.d,r=0,q=1):m.attr?r=m.attr(e):(r=parseFloat(a.getStyle(m,e))||0,"opacity"!==e&&(y="px"));q||(q=c);q&&q.match&&q.match("px")&&(q=q.replace(/px/g,""));w.run(r,q,y)})};a.seriesType=function(m,h,f,r,y){var q=a.getOptions(),w=a.seriesTypes;q.plotOptions[m]=a.merge(q.plotOptions[h],f);
w[m]=a.extendClass(w[h]||function(){},r);w[m].prototype.type=m;y&&(w[m].prototype.pointClass=a.extendClass(a.Point,y));return w[m]};a.uniqueKey=function(){var a=Math.random().toString(36).substring(2,9),h=0;return function(){return"highcharts-"+a+"-"+h++}}();E.jQuery&&(E.jQuery.fn.highcharts=function(){var m=[].slice.call(arguments);if(this[0])return m[0]?(new (a[a.isString(m[0])?m.shift():"Chart"])(this[0],m[0],m[1]),this):C[a.attr(this[0],"data-highcharts-chart")]})})(K);(function(a){var C=a.each,
D=a.isNumber,E=a.map,m=a.merge,h=a.pInt;a.Color=function(f){if(!(this instanceof a.Color))return new a.Color(f);this.init(f)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[h(a[1]),h(a[2]),h(a[3]),parseFloat(a[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(a){return[h(a[1]),h(a[2]),h(a[3]),1]}}],names:{white:"#ffffff",black:"#000000"},init:function(f){var h,
y,q,w;if((this.input=f=this.names[f&&f.toLowerCase?f.toLowerCase():""]||f)&&f.stops)this.stops=E(f.stops,function(e){return new a.Color(e[1])});else if(f&&f.charAt&&"#"===f.charAt()&&(h=f.length,f=parseInt(f.substr(1),16),7===h?y=[(f&16711680)>>16,(f&65280)>>8,f&255,1]:4===h&&(y=[(f&3840)>>4|(f&3840)>>8,(f&240)>>4|f&240,(f&15)<<4|f&15,1])),!y)for(q=this.parsers.length;q--&&!y;)w=this.parsers[q],(h=w.regex.exec(f))&&(y=w.parse(h));this.rgba=y||[]},get:function(a){var f=this.input,h=this.rgba,q;this.stops?
(q=m(f),q.stops=[].concat(q.stops),C(this.stops,function(f,e){q.stops[e]=[q.stops[e][0],f.get(a)]})):q=h&&D(h[0])?"rgb"===a||!a&&1===h[3]?"rgb("+h[0]+","+h[1]+","+h[2]+")":"a"===a?h[3]:"rgba("+h.join(",")+")":f;return q},brighten:function(a){var f,y=this.rgba;if(this.stops)C(this.stops,function(f){f.brighten(a)});else if(D(a)&&0!==a)for(f=0;3>f;f++)y[f]+=h(255*a),0>y[f]&&(y[f]=0),255<y[f]&&(y[f]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this},tweenTo:function(a,h){var f=this.rgba,
q=a.rgba;q.length&&f&&f.length?(a=1!==q[3]||1!==f[3],h=(a?"rgba(":"rgb(")+Math.round(q[0]+(f[0]-q[0])*(1-h))+","+Math.round(q[1]+(f[1]-q[1])*(1-h))+","+Math.round(q[2]+(f[2]-q[2])*(1-h))+(a?","+(q[3]+(f[3]-q[3])*(1-h)):"")+")"):h=a.input||"none";return h}};a.color=function(f){return new a.Color(f)}})(K);(function(a){var C,D,E=a.addEvent,m=a.animate,h=a.attr,f=a.charts,r=a.color,y=a.css,q=a.createElement,w=a.defined,e=a.deg2rad,c=a.destroyObjectProperties,l=a.doc,z=a.each,k=a.extend,d=a.erase,b=a.grep,
u=a.hasTouch,p=a.inArray,H=a.isArray,t=a.isFirefox,L=a.isMS,x=a.isObject,I=a.isString,n=a.isWebKit,G=a.merge,B=a.noop,M=a.objectEach,F=a.pick,g=a.pInt,v=a.removeEvent,P=a.stop,Q=a.svg,J=a.SVG_NS,O=a.symbolSizes,N=a.win;C=a.SVGElement=function(){return this};k(C.prototype,{opacity:1,SVG_NS:J,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline cursor".split(" "),init:function(a,g){this.element="span"===g?q(g):l.createElementNS(this.SVG_NS,
g);this.renderer=a},animate:function(A,g,b){g=a.animObject(F(g,this.renderer.globalAnimation,!0));0!==g.duration?(b&&(g.complete=b),m(this,A,g)):(this.attr(A,null,b),g.step&&g.step.call(this));return this},complexColor:function(A,g,b){var d=this.renderer,v,k,c,n,e,J,l,B,u,R,p,t=[],x;a.fireEvent(this.renderer,"complexColor",{args:arguments},function(){A.radialGradient?k="radialGradient":A.linearGradient&&(k="linearGradient");k&&(c=A[k],e=d.gradients,l=A.stops,R=b.radialReference,H(c)&&(A[k]=c={x1:c[0],
y1:c[1],x2:c[2],y2:c[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===k&&R&&!w(c.gradientUnits)&&(n=c,c=G(c,d.getRadialAttr(R,n),{gradientUnits:"userSpaceOnUse"})),M(c,function(a,A){"id"!==A&&t.push(A,a)}),M(l,function(a){t.push(a)}),t=t.join(","),e[t]?p=e[t].attr("id"):(c.id=p=a.uniqueKey(),e[t]=J=d.createElement(k).attr(c).add(d.defs),J.radAttr=n,J.stops=[],z(l,function(A){0===A[1].indexOf("rgba")?(v=a.color(A[1]),B=v.get("rgb"),u=v.get("a")):(B=A[1],u=1);A=d.createElement("stop").attr({offset:A[0],
"stop-color":B,"stop-opacity":u}).add(J);J.stops.push(A)})),x="url("+d.url+"#"+p+")",b.setAttribute(g,x),b.gradient=t,A.toString=function(){return x})})},applyTextOutline:function(A){var g=this.element,b,v,k,c,n;-1!==A.indexOf("contrast")&&(A=A.replace(/contrast/g,this.renderer.getContrast(g.style.fill)));A=A.split(" ");v=A[A.length-1];if((k=A[0])&&"none"!==k&&a.svg){this.fakeTS=!0;A=[].slice.call(g.getElementsByTagName("tspan"));this.ySetter=this.xSetter;k=k.replace(/(^[\d\.]+)(.*?)$/g,function(a,
A,g){return 2*A+g});for(n=A.length;n--;)b=A[n],"highcharts-text-outline"===b.getAttribute("class")&&d(A,g.removeChild(b));c=g.firstChild;z(A,function(a,A){0===A&&(a.setAttribute("x",g.getAttribute("x")),A=g.getAttribute("y"),a.setAttribute("y",A||0),null===A&&g.setAttribute("y",0));a=a.cloneNode(1);h(a,{"class":"highcharts-text-outline",fill:v,stroke:v,"stroke-width":k,"stroke-linejoin":"round"});g.insertBefore(a,c)})}},attr:function(a,g,b,d){var A,v=this.element,k,c=this,n,J;"string"===typeof a&&
void 0!==g&&(A=a,a={},a[A]=g);"string"===typeof a?c=(this[a+"Getter"]||this._defaultGetter).call(this,a,v):(M(a,function(A,g){n=!1;d||P(this,g);this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/.test(g)&&(k||(this.symbolAttr(a),k=!0),n=!0);!this.rotation||"x"!==g&&"y"!==g||(this.doTransform=!0);n||(J=this[g+"Setter"]||this._defaultSetter,J.call(this,A,g,v),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(g)&&this.updateShadows(g,A,J))},this),this.afterSetters());
b&&b.call(this);return c},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)},updateShadows:function(a,g,b){for(var A=this.shadows,d=A.length;d--;)b.call(A[d],"height"===a?Math.max(g-(A[d].cutHeight||0),0):"d"===a?this.d:g,a,A[d])},addClass:function(a,g){var A=this.attr("class")||"";-1===A.indexOf(a)&&(g||(a=(A+(A?" ":"")+a).replace("  "," ")),this.attr("class",a));return this},hasClass:function(a){return-1!==p(a,(this.attr("class")||"").split(" "))},removeClass:function(a){return this.attr("class",
(this.attr("class")||"").replace(a,""))},symbolAttr:function(a){var A=this;z("x y r start end width height innerR anchorX anchorY".split(" "),function(g){A[g]=F(a[g],A[g])});A.attr({d:A.renderer.symbols[A.symbolName](A.x,A.y,A.width,A.height,A)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,g){var A;g=g||a.strokeWidth||0;A=Math.round(g)%2/2;a.x=Math.floor(a.x||this.x||0)+A;a.y=Math.floor(a.y||this.y||0)+A;a.width=Math.floor((a.width||
this.width||0)-2*A);a.height=Math.floor((a.height||this.height||0)-2*A);w(a.strokeWidth)&&(a.strokeWidth=g);return a},css:function(a){var A=this.styles,b={},d=this.element,v,c="",n,J=!A,e=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);A&&M(a,function(a,g){a!==A[g]&&(b[g]=a,J=!0)});J&&(A&&(a=k(A,b)),a&&(null===a.width||"auto"===a.width?delete this.textWidth:"text"===d.nodeName.toLowerCase()&&a.width&&(v=this.textWidth=g(a.width))),this.styles=a,v&&!Q&&this.renderer.forExport&&
delete a.width,d.namespaceURI===this.SVG_NS?(n=function(a,A){return"-"+A.toLowerCase()},M(a,function(a,A){-1===p(A,e)&&(c+=A.replace(/([A-Z])/g,n)+":"+a+";")}),c&&h(d,"style",c)):y(d,a),this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline)));return this},strokeWidth:function(){return this["stroke-width"]||0},on:function(a,g){var A=this,b=A.element;u&&"click"===a?(b.ontouchstart=function(a){A.touchEventFired=Date.now();a.preventDefault();
g.call(b,a)},b.onclick=function(a){(-1===N.navigator.userAgent.indexOf("Android")||1100<Date.now()-(A.touchEventFired||0))&&g.call(b,a)}):b["on"+a]=g;return this},setRadialReference:function(a){var A=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;A&&A.radAttr&&A.animate(this.renderer.getRadialAttr(a,A.radAttr));return this},translate:function(a,g){return this.attr({translateX:a,translateY:g})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=
this.translateX||0,g=this.translateY||0,b=this.scaleX,d=this.scaleY,v=this.inverted,c=this.rotation,k=this.matrix,n=this.element;v&&(a+=this.width,g+=this.height);a=["translate("+a+","+g+")"];w(k)&&a.push("matrix("+k.join(",")+")");v?a.push("rotate(90) scale(-1,1)"):c&&a.push("rotate("+c+" "+F(this.rotationOriginX,n.getAttribute("x"),0)+" "+F(this.rotationOriginY,n.getAttribute("y")||0)+")");(w(b)||w(d))&&a.push("scale("+F(b,1)+" "+F(d,1)+")");a.length&&n.setAttribute("transform",a.join(" "))},toFront:function(){var a=
this.element;a.parentNode.appendChild(a);return this},align:function(a,g,b){var A,v,c,k,n={};v=this.renderer;c=v.alignedObjects;var J,e;if(a){if(this.alignOptions=a,this.alignByTranslate=g,!b||I(b))this.alignTo=A=b||"renderer",d(c,this),c.push(this),b=null}else a=this.alignOptions,g=this.alignByTranslate,A=this.alignTo;b=F(b,v[A],v);A=a.align;v=a.verticalAlign;c=(b.x||0)+(a.x||0);k=(b.y||0)+(a.y||0);"right"===A?J=1:"center"===A&&(J=2);J&&(c+=(b.width-(a.width||0))/J);n[g?"translateX":"x"]=Math.round(c);
"bottom"===v?e=1:"middle"===v&&(e=2);e&&(k+=(b.height-(a.height||0))/e);n[g?"translateY":"y"]=Math.round(k);this[this.placed?"animate":"attr"](n);this.placed=!0;this.alignAttr=n;return this},getBBox:function(a,g){var A,b=this.renderer,d,v=this.element,c=this.styles,n,J=this.textStr,l,B=b.cache,u=b.cacheKeys,p;g=F(g,this.rotation);d=g*e;n=c&&c.fontSize;w(J)&&(p=J.toString(),-1===p.indexOf("\x3c")&&(p=p.replace(/[0-9]/g,"0")),p+=["",g||0,n,this.textWidth,c&&c.textOverflow].join());p&&!a&&(A=B[p]);if(!A){if(v.namespaceURI===
this.SVG_NS||b.forExport){try{(l=this.fakeTS&&function(a){z(v.querySelectorAll(".highcharts-text-outline"),function(A){A.style.display=a})})&&l("none"),A=v.getBBox?k({},v.getBBox()):{width:v.offsetWidth,height:v.offsetHeight},l&&l("")}catch(W){}if(!A||0>A.width)A={width:0,height:0}}else A=this.htmlGetBBox();b.isSVG&&(a=A.width,b=A.height,c&&"11px"===c.fontSize&&17===Math.round(b)&&(A.height=b=14),g&&(A.width=Math.abs(b*Math.sin(d))+Math.abs(a*Math.cos(d)),A.height=Math.abs(b*Math.cos(d))+Math.abs(a*
Math.sin(d))));if(p&&0<A.height){for(;250<u.length;)delete B[u.shift()];B[p]||u.push(p);B[p]=A}}return A},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},fadeOut:function(a){var A=this;A.animate({opacity:0},{duration:a||150,complete:function(){A.attr({y:-9999})}})},add:function(a){var A=this.renderer,g=this.element,b;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&A.buildText(this);this.added=
!0;if(!a||a.handleZ||this.zIndex)b=this.zIndexSetter();b||(a?a.element:A.box).appendChild(g);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var A=a.parentNode;A&&A.removeChild(a)},destroy:function(){var a=this,g=a.element||{},b=a.renderer.isSVG&&"SPAN"===g.nodeName&&a.parentGroup,v=g.ownerSVGElement,c=a.clipPath;g.onclick=g.onmouseout=g.onmouseover=g.onmousemove=g.point=null;P(a);c&&v&&(z(v.querySelectorAll("[clip-path],[CLIP-PATH]"),function(a){var g=a.getAttribute("clip-path"),
A=c.element.id;(-1<g.indexOf("(#"+A+")")||-1<g.indexOf('("#'+A+'")'))&&a.removeAttribute("clip-path")}),a.clipPath=c.destroy());if(a.stops){for(v=0;v<a.stops.length;v++)a.stops[v]=a.stops[v].destroy();a.stops=null}a.safeRemoveChild(g);for(a.destroyShadows();b&&b.div&&0===b.div.childNodes.length;)g=b.parentGroup,a.safeRemoveChild(b.div),delete b.div,b=g;a.alignTo&&d(a.renderer.alignedObjects,a);M(a,function(g,A){delete a[A]});return null},shadow:function(a,g,b){var A=[],d,v,c=this.element,k,n,J,e;
if(!a)this.destroyShadows();else if(!this.shadows){n=F(a.width,3);J=(a.opacity||.15)/n;e=this.parentInverted?"(-1,-1)":"("+F(a.offsetX,1)+", "+F(a.offsetY,1)+")";for(d=1;d<=n;d++)v=c.cloneNode(0),k=2*n+1-2*d,h(v,{isShadow:"true",stroke:a.color||"#000000","stroke-opacity":J*d,"stroke-width":k,transform:"translate"+e,fill:"none"}),b&&(h(v,"height",Math.max(h(v,"height")-k,0)),v.cutHeight=k),g?g.element.appendChild(v):c.parentNode&&c.parentNode.insertBefore(v,c),A.push(v);this.shadows=A}return this},
destroyShadows:function(){z(this.shadows||[],function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=F(this[a+"Value"],this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,g,b){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");this[g]!==a&&(b.setAttribute(g,
a),this[g]=a)},dashstyleSetter:function(a){var b,A=this["stroke-width"];"inherit"===A&&(A=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(b=a.length;b--;)a[b]=g(a[b])*A;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){this.alignValue=
a;this.element.setAttribute("text-anchor",{left:"start",center:"middle",right:"end"}[a])},opacitySetter:function(a,g,b){this[g]=a;b.setAttribute(g,a)},titleSetter:function(a){var g=this.element.getElementsByTagName("title")[0];g||(g=l.createElementNS(this.SVG_NS,"title"),this.element.appendChild(g));g.firstChild&&g.removeChild(g.firstChild);g.appendChild(l.createTextNode(String(F(a),"").replace(/<[^>]*>/g,"").replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e")))},textSetter:function(a){a!==this.textStr&&
(delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this))},fillSetter:function(a,g,b){"string"===typeof a?b.setAttribute(g,a):a&&this.complexColor(a,g,b)},visibilitySetter:function(a,g,b){"inherit"===a?b.removeAttribute(g):this[g]!==a&&b.setAttribute(g,a);this[g]=a},zIndexSetter:function(a,b){var d=this.renderer,v=this.parentGroup,A=(v||d).element||d.box,c,k=this.element,n,J,d=A===d.box;c=this.added;var e;w(a)?(k.setAttribute("data-z-index",a),a=+a,this[b]===a&&(c=!1)):w(this[b])&&
k.removeAttribute("data-z-index");this[b]=a;if(c){(a=this.zIndex)&&v&&(v.handleZ=!0);b=A.childNodes;for(e=b.length-1;0<=e&&!n;e--)if(v=b[e],c=v.getAttribute("data-z-index"),J=!w(c),v!==k)if(0>a&&J&&!d&&!e)A.insertBefore(k,b[e]),n=!0;else if(g(c)<=a||J&&(!w(a)||0<=a))A.insertBefore(k,b[e+1]||null),n=!0;n||(A.insertBefore(k,b[d?3:0]||null),n=!0)}return n},_defaultSetter:function(a,g,b){b.setAttribute(g,a)}});C.prototype.yGetter=C.prototype.xGetter;C.prototype.translateXSetter=C.prototype.translateYSetter=
C.prototype.rotationSetter=C.prototype.verticalAlignSetter=C.prototype.rotationOriginXSetter=C.prototype.rotationOriginYSetter=C.prototype.scaleXSetter=C.prototype.scaleYSetter=C.prototype.matrixSetter=function(a,g){this[g]=a;this.doTransform=!0};C.prototype["stroke-widthSetter"]=C.prototype.strokeSetter=function(a,g,b){this[g]=a;this.stroke&&this["stroke-width"]?(C.prototype.fillSetter.call(this,this.stroke,"stroke",b),b.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===
g&&0===a&&this.hasStroke&&(b.removeAttribute("stroke"),this.hasStroke=!1)};D=a.SVGRenderer=function(){this.init.apply(this,arguments)};k(D.prototype,{Element:C,SVG_NS:J,init:function(a,g,b,d,v,c){var A;d=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"}).css(this.getStyle(d));A=d.element;a.appendChild(A);h(a,"dir","ltr");-1===a.innerHTML.indexOf("xmlns")&&h(A,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=A;this.boxWrapper=d;this.alignedObjects=[];this.url=(t||n)&&l.getElementsByTagName("base").length?
N.location.href.split("#")[0].replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(l.createTextNode("Created with Highcharts 6.1.2"));this.defs=this.createElement("defs").add();this.allowHTML=c;this.forExport=v;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(g,b,!1);var k;t&&a.getBoundingClientRect&&(g=function(){y(a,{left:0,top:0});k=a.getBoundingClientRect();y(a,{left:Math.ceil(k.left)-k.left+
"px",top:Math.ceil(k.top)-k.top+"px"})},g(),this.unSubPixelFix=E(N,"resize",g))},getStyle:function(a){return this.style=k({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();c(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());
this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var g=new this.Element;g.init(this,a);return g},draw:B,getRadialAttr:function(a,g){return{cx:a[0]-a[2]/2+g.cx*a[2],cy:a[1]-a[2]/2+g.cy*a[2],r:g.r*a[2]}},getSpanWidth:function(a){return a.getBBox(!0).width},applyEllipsis:function(a,g,b,d){var v=a.rotation,c=b,k,A=0,n=b.length,J=function(a){g.removeChild(g.firstChild);a&&g.appendChild(l.createTextNode(a))},e;a.rotation=0;c=this.getSpanWidth(a,g);if(e=
c>d){for(;A<=n;)k=Math.ceil((A+n)/2),c=b.substring(0,k)+"\u2026",J(c),c=this.getSpanWidth(a,g),A===n?A=n+1:c>d?n=k-1:A=k;0===n&&J("")}a.rotation=v;return e},escapes:{"\x26":"\x26amp;","\x3c":"\x26lt;","\x3e":"\x26gt;","'":"\x26#39;",'"':"\x26quot;"},buildText:function(a){var d=a.element,v=this,c=v.forExport,k=F(a.textStr,"").toString(),A=-1!==k.indexOf("\x3c"),n=d.childNodes,e,B=h(d,"x"),u=a.styles,t=a.textWidth,G=u&&u.lineHeight,x=u&&u.textOutline,f=u&&"ellipsis"===u.textOverflow,P=u&&"nowrap"===
u.whiteSpace,O=u&&u.fontSize,w,q,H=n.length,u=t&&!a.added&&this.box,I=function(a){var b;b=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:O||v.style.fontSize||12;return G?g(G):v.fontMetrics(b,a.getAttribute("style")?a:d).h},N=function(a,g){M(v.escapes,function(b,d){g&&-1!==p(b,g)||(a=a.toString().replace(new RegExp(b,"g"),d))});return a},m=function(a,g){var b;b=a.indexOf("\x3c");a=a.substring(b,a.indexOf("\x3e")-b);b=a.indexOf(g+"\x3d");if(-1!==b&&(b=b+g.length+1,g=a.charAt(b),'"'===g||"'"===
g))return a=a.substring(b+1),a.substring(0,a.indexOf(g))};w=[k,f,P,G,x,O,t].join();if(w!==a.textCache){for(a.textCache=w;H--;)d.removeChild(n[H]);A||x||f||t||-1!==k.indexOf(" ")?(u&&u.appendChild(d),k=A?k.replace(/<(b|strong)>/g,'\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g,'\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g,"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,"\x3c/span\x3e").split(/<br.*?>/g):[k],k=b(k,function(a){return""!==a}),z(k,function(g,b){var k,A=0;g=g.replace(/^\s+|\s+$/g,
"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");k=g.split("|||");z(k,function(g){if(""!==g||1===k.length){var n={},u=l.createElementNS(v.SVG_NS,"tspan"),p,G;(p=m(g,"class"))&&h(u,"class",p);if(p=m(g,"style"))p=p.replace(/(;| |^)color([ :])/,"$1fill$2"),h(u,"style",p);(G=m(g,"href"))&&!c&&(h(u,"onclick",'location.href\x3d"'+G+'"'),h(u,"class","highcharts-anchor"),y(u,{cursor:"pointer"}));g=N(g.replace(/<[a-zA-Z\/](.|\n)*?>/g,"")||" ");if(" "!==g){u.appendChild(l.createTextNode(g));
A?n.dx=0:b&&null!==B&&(n.x=B);h(u,n);d.appendChild(u);!A&&q&&(!Q&&c&&y(u,{display:"block"}),h(u,"dy",I(u)));if(t){n=g.replace(/([^\^])-/g,"$1- ").split(" ");G=1<k.length||b||1<n.length&&!P;var x=[],z,O=I(u),w=a.rotation;for(f&&(e=v.applyEllipsis(a,u,g,t));!f&&G&&(n.length||x.length);)a.rotation=0,z=v.getSpanWidth(a,u),g=z>t,void 0===e&&(e=g),g&&1!==n.length?(u.removeChild(u.firstChild),x.unshift(n.pop())):(n=x,x=[],n.length&&!P&&(u=l.createElementNS(J,"tspan"),h(u,{dy:O,x:B}),p&&h(u,"style",p),d.appendChild(u)),
z>t&&(t=z+1)),n.length&&u.appendChild(l.createTextNode(n.join(" ").replace(/- /g,"-")));a.rotation=w}A++}}});q=q||d.childNodes.length}),f&&e&&a.attr("title",N(a.textStr,["\x26lt;","\x26gt;"])),u&&u.removeChild(d),x&&a.applyTextOutline&&a.applyTextOutline(x)):d.appendChild(l.createTextNode(N(k)))}},getContrast:function(a){a=r(a).rgba;a[0]*=1;a[1]*=1.2;a[2]*=.5;return 459<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,g,b,d,v,c,n,e,J){var A=this.label(a,g,b,J,null,null,null,null,"button"),u=
0;A.attr(G({padding:8,r:2},v));var l,B,p,t;v=G({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},v);l=v.style;delete v.style;c=G(v,{fill:"#e6e6e6"},c);B=c.style;delete c.style;n=G(v,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},n);p=n.style;delete n.style;e=G(v,{style:{color:"#cccccc"}},e);t=e.style;delete e.style;E(A.element,L?"mouseover":"mouseenter",function(){3!==u&&A.setState(1)});E(A.element,L?"mouseout":"mouseleave",
function(){3!==u&&A.setState(u)});A.setState=function(a){1!==a&&(A.state=u=a);A.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][a||0]);A.attr([v,c,n,e][a||0]).css([l,B,p,t][a||0])};A.attr(v).css(k({cursor:"default"},l));return A.on("click",function(a){3!==u&&d.call(A,a)})},crispLine:function(a,g){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-g%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+g%2/2);return a},path:function(a){var g=
{fill:"none"};H(a)?g.d=a:x(a)&&k(g,a);return this.createElement("path").attr(g)},circle:function(a,g,b){a=x(a)?a:{x:a,y:g,r:b};g=this.createElement("circle");g.xSetter=g.ySetter=function(a,g,b){b.setAttribute("c"+g,a)};return g.attr(a)},arc:function(a,g,b,d,v,c){x(a)?(d=a,g=d.y,b=d.r,a=d.x):d={innerR:d,start:v,end:c};a=this.symbol("arc",a,g,b,b,d);a.r=b;return a},rect:function(a,g,b,d,v,c){v=x(a)?a.r:v;var k=this.createElement("rect");a=x(a)?a:void 0===a?{}:{x:a,y:g,width:Math.max(b,0),height:Math.max(d,
0)};void 0!==c&&(a.strokeWidth=c,a=k.crisp(a));a.fill="none";v&&(a.r=v);k.rSetter=function(a,g,b){h(b,{rx:a,ry:a})};return k.attr(a)},setSize:function(a,g,b){var d=this.alignedObjects,v=d.length;this.width=a;this.height=g;for(this.boxWrapper.animate({width:a,height:g},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:F(b,!0)?void 0:0});v--;)d[v].align()},g:function(a){var g=this.createElement("g");return a?g.attr({"class":"highcharts-"+a}):g},image:function(a,
g,b,d,v,c){var n={preserveAspectRatio:"none"},e,J=function(a,g){a.setAttributeNS?a.setAttributeNS("http://www.w3.org/1999/xlink","href",g):a.setAttribute("hc-svg-href",g)},A=function(g){J(e.element,a);c.call(e,g)};1<arguments.length&&k(n,{x:g,y:b,width:d,height:v});e=this.createElement("image").attr(n);c?(J(e.element,"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw\x3d\x3d"),n=new N.Image,E(n,"load",A),n.src=a,n.complete&&A({})):J(e.element,a);return e},symbol:function(a,
g,b,d,v,c){var n=this,e,J=/^url\((.*?)\)$/,A=J.test(a),u=!A&&(this.symbols[a]?a:"circle"),B=u&&this.symbols[u],p=w(g)&&B&&B.call(this.symbols,Math.round(g),Math.round(b),d,v,c),t,G;B?(e=this.path(p),e.attr("fill","none"),k(e,{symbolName:u,x:g,y:b,width:d,height:v}),c&&k(e,c)):A&&(t=a.match(J)[1],e=this.image(t),e.imgwidth=F(O[t]&&O[t].width,c&&c.width),e.imgheight=F(O[t]&&O[t].height,c&&c.height),G=function(){e.attr({width:e.width,height:e.height})},z(["width","height"],function(a){e[a+"Setter"]=
function(a,g){var b={},d=this["img"+g],v="width"===g?"translateX":"translateY";this[g]=a;w(d)&&(this.element&&this.element.setAttribute(g,d),this.alignByTranslate||(b[v]=((this[g]||0)-d)/2,this.attr(b)))}}),w(g)&&e.attr({x:g,y:b}),e.isImg=!0,w(e.imgwidth)&&w(e.imgheight)?G():(e.attr({width:0,height:0}),q("img",{onload:function(){var a=f[n.chartIndex];0===this.width&&(y(this,{position:"absolute",top:"-999em"}),l.body.appendChild(this));O[t]={width:this.width,height:this.height};e.imgwidth=this.width;
e.imgheight=this.height;e.element&&G();this.parentNode&&this.parentNode.removeChild(this);n.imgCount--;if(!n.imgCount&&a&&a.onload)a.onload()},src:t}),this.imgCount++));return e},symbols:{circle:function(a,g,b,d){return this.arc(a+b/2,g+d/2,b/2,d/2,{start:0,end:2*Math.PI,open:!1})},square:function(a,g,b,d){return["M",a,g,"L",a+b,g,a+b,g+d,a,g+d,"Z"]},triangle:function(a,g,b,d){return["M",a+b/2,g,"L",a+b,g+d,a,g+d,"Z"]},"triangle-down":function(a,g,b,d){return["M",a,g,"L",a+b,g,a+b/2,g+d,"Z"]},diamond:function(a,
g,b,d){return["M",a+b/2,g,"L",a+b,g+d/2,a+b/2,g+d,a,g+d/2,"Z"]},arc:function(a,g,b,d,v){var c=v.start,k=v.r||b,n=v.r||d||b,e=v.end-.001;b=v.innerR;d=F(v.open,.001>Math.abs(v.end-v.start-2*Math.PI));var J=Math.cos(c),u=Math.sin(c),A=Math.cos(e),e=Math.sin(e);v=.001>v.end-c-Math.PI?0:1;k=["M",a+k*J,g+n*u,"A",k,n,0,v,1,a+k*A,g+n*e];w(b)&&k.push(d?"M":"L",a+b*A,g+b*e,"A",b,b,0,v,0,a+b*J,g+b*u);k.push(d?"":"Z");return k},callout:function(a,g,b,d,v){var c=Math.min(v&&v.r||0,b,d),k=c+6,n=v&&v.anchorX;v=
v&&v.anchorY;var e;e=["M",a+c,g,"L",a+b-c,g,"C",a+b,g,a+b,g,a+b,g+c,"L",a+b,g+d-c,"C",a+b,g+d,a+b,g+d,a+b-c,g+d,"L",a+c,g+d,"C",a,g+d,a,g+d,a,g+d-c,"L",a,g+c,"C",a,g,a,g,a+c,g];n&&n>b?v>g+k&&v<g+d-k?e.splice(13,3,"L",a+b,v-6,a+b+6,v,a+b,v+6,a+b,g+d-c):e.splice(13,3,"L",a+b,d/2,n,v,a+b,d/2,a+b,g+d-c):n&&0>n?v>g+k&&v<g+d-k?e.splice(33,3,"L",a,v+6,a-6,v,a,v-6,a,g+c):e.splice(33,3,"L",a,d/2,n,v,a,d/2,a,g+c):v&&v>d&&n>a+k&&n<a+b-k?e.splice(23,3,"L",n+6,g+d,n,g+d+6,n-6,g+d,a+c,g+d):v&&0>v&&n>a+k&&n<a+b-
k&&e.splice(3,3,"L",n-6,g,n,g-6,n+6,g,b-c,g);return e}},clipRect:function(g,b,d,v){var c=a.uniqueKey(),k=this.createElement("clipPath").attr({id:c}).add(this.defs);g=this.rect(g,b,d,v,0).add(k);g.id=c;g.clipPath=k;g.count=0;return g},text:function(a,g,b,d){var v={};if(d&&(this.allowHTML||!this.forExport))return this.html(a,g,b);v.x=Math.round(g||0);b&&(v.y=Math.round(b));if(a||0===a)v.text=a;a=this.createElement("text").attr(v);d||(a.xSetter=function(a,g,b){var d=b.getElementsByTagName("tspan"),v,
c=b.getAttribute(g),k;for(k=0;k<d.length;k++)v=d[k],v.getAttribute(g)===c&&v.setAttribute(g,a);b.setAttribute(g,a)});return a},fontMetrics:function(a,b){a=a||b&&b.style&&b.style.fontSize||this.style&&this.style.fontSize;a=/px/.test(a)?g(a):/em/.test(a)?parseFloat(a)*(b?this.fontMetrics(null,b.parentNode).f:16):12;b=24>a?a+3:Math.round(1.2*a);return{h:b,b:Math.round(.8*b),f:a}},rotCorr:function(a,g,b){var d=a;g&&b&&(d=Math.max(d*Math.cos(g*e),4));return{x:-a/3*Math.sin(g*e),y:d}},label:function(g,
b,d,c,n,e,J,u,l){var B=this,p=B.g("button"!==l&&"label"),t=p.text=B.text("",0,0,J).attr({zIndex:1}),A,x,Q=0,f=3,P=0,h,O,q,F,H,I={},N,y,M=/^url\((.*?)\)$/.test(c),m=M,L,r,R,U;l&&p.addClass("highcharts-"+l);m=M;L=function(){return(N||0)%2/2};r=function(){var a=t.element.style,g={};x=(void 0===h||void 0===O||H)&&w(t.textStr)&&t.getBBox();p.width=(h||x.width||0)+2*f+P;p.height=(O||x.height||0)+2*f;y=f+B.fontMetrics(a&&a.fontSize,t).b;m&&(A||(p.box=A=B.symbols[c]||M?B.symbol(c):B.rect(),A.addClass(("button"===
l?"":"highcharts-label-box")+(l?" highcharts-"+l+"-box":"")),A.add(p),a=L(),g.x=a,g.y=(u?-y:0)+a),g.width=Math.round(p.width),g.height=Math.round(p.height),A.attr(k(g,I)),I={})};R=function(){var a=P+f,g;g=u?0:y;w(h)&&x&&("center"===H||"right"===H)&&(a+={center:.5,right:1}[H]*(h-x.width));if(a!==t.x||g!==t.y)t.attr("x",a),t.hasBoxWidthChanged&&(x=t.getBBox(!0),r()),void 0!==g&&t.attr("y",g);t.x=a;t.y=g};U=function(a,g){A?A.attr(a,g):I[a]=g};p.onAdd=function(){t.add(p);p.attr({text:g||0===g?g:"",x:b,
y:d});A&&w(n)&&p.attr({anchorX:n,anchorY:e})};p.widthSetter=function(g){h=a.isNumber(g)?g:null};p.heightSetter=function(a){O=a};p["text-alignSetter"]=function(a){H=a};p.paddingSetter=function(a){w(a)&&a!==f&&(f=p.padding=a,R())};p.paddingLeftSetter=function(a){w(a)&&a!==P&&(P=a,R())};p.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==Q&&(Q=a,x&&p.attr({x:q}))};p.textSetter=function(a){void 0!==a&&t.textSetter(a);r();R()};p["stroke-widthSetter"]=function(a,g){a&&(m=!0);N=this["stroke-width"]=
a;U(g,a)};p.strokeSetter=p.fillSetter=p.rSetter=function(a,g){"r"!==g&&("fill"===g&&a&&(m=!0),p[g]=a);U(g,a)};p.anchorXSetter=function(a,g){n=p.anchorX=a;U(g,Math.round(a)-L()-q)};p.anchorYSetter=function(a,g){e=p.anchorY=a;U(g,a-F)};p.xSetter=function(a){p.x=a;Q&&(a-=Q*((h||x.width)+2*f),p["forceAnimate:x"]=!0);q=Math.round(a);p.attr("translateX",q)};p.ySetter=function(a){F=p.y=Math.round(a);p.attr("translateY",F)};var S=p.css;return k(p,{css:function(a){if(a){var g={};a=G(a);z(p.textProps,function(b){void 0!==
a[b]&&(g[b]=a[b],delete a[b])});t.css(g);"width"in g&&r()}return S.call(p,a)},getBBox:function(){return{width:x.width+2*f,height:x.height+2*f,x:x.x-f,y:x.y-f}},shadow:function(a){a&&(r(),A&&A.shadow(a));return p},destroy:function(){v(p.element,"mouseenter");v(p.element,"mouseleave");t&&(t=t.destroy());A&&(A=A.destroy());C.prototype.destroy.call(p);p=B=r=R=U=null}})}});a.Renderer=D})(K);(function(a){var C=a.attr,D=a.createElement,E=a.css,m=a.defined,h=a.each,f=a.extend,r=a.isFirefox,y=a.isMS,q=a.isWebKit,
w=a.pick,e=a.pInt,c=a.SVGRenderer,l=a.win,z=a.wrap;f(a.SVGElement.prototype,{htmlCss:function(a){var d=this.element;if((d=a&&"SPAN"===d.tagName&&a.width)||this.textWidth&&!d)delete a.width,this.textWidth=d,this.htmlUpdateTransform();a&&"ellipsis"===a.textOverflow&&(a.whiteSpace="nowrap",a.overflow="hidden");this.styles=f(this.styles,a);E(this.element,a);return this},htmlGetBBox:function(){var a=this.element;return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=
this.renderer,d=this.element,b=this.translateX||0,c=this.translateY||0,p=this.x||0,l=this.y||0,t=this.textAlign||"left",f={left:0,center:.5,right:1}[t],x=this.styles,z=x&&x.whiteSpace;E(d,{marginLeft:b,marginTop:c});this.shadows&&h(this.shadows,function(a){E(a,{marginLeft:b+1,marginTop:c+1})});this.inverted&&h(d.childNodes,function(b){a.invertChild(b,d)});if("SPAN"===d.tagName){var x=this.rotation,n=this.textWidth&&e(this.textWidth),G=[x,t,d.innerHTML,this.textWidth,this.textAlign].join(),B;(B=n!==
this.oldTextWidth)&&!(B=n>this.oldTextWidth)&&((B=this.textPxLength)||(E(d,{width:"",whiteSpace:z||"nowrap"}),B=d.offsetWidth),B=B>n);B&&/[ \-]/.test(d.textContent||d.innerText)?(E(d,{width:n+"px",display:"block",whiteSpace:z||"normal"}),this.oldTextWidth=n,this.hasBoxWidthChanged=!0):this.hasBoxWidthChanged=!1;G!==this.cTT&&(z=a.fontMetrics(d.style.fontSize).b,!m(x)||x===(this.oldRotation||0)&&t===this.oldAlign||this.setSpanRotation(x,f,z),this.getSpanCorrection(!m(x)&&this.textPxLength||d.offsetWidth,
z,f,x,t));E(d,{left:p+(this.xCorr||0)+"px",top:l+(this.yCorr||0)+"px"});this.cTT=G;this.oldRotation=x;this.oldAlign=t}}else this.alignOnAdd=!0},setSpanRotation:function(a,d,b){var c={},k=this.renderer.getTransformKey();c[k]=c.transform="rotate("+a+"deg)";c[k+(r?"Origin":"-origin")]=c.transformOrigin=100*d+"% "+b+"px";E(this.element,c)},getSpanCorrection:function(a,d,b){this.xCorr=-a*b;this.yCorr=-d}});f(c.prototype,{getTransformKey:function(){return y&&!/Edge/.test(l.navigator.userAgent)?"-ms-transform":
q?"-webkit-transform":r?"MozTransform":l.opera?"-o-transform":""},html:function(a,d,b){var c=this.createElement("span"),k=c.element,e=c.renderer,l=e.isSVG,q=function(a,b){h(["opacity","visibility"],function(d){z(a,d+"Setter",function(a,d,c,k){a.call(this,d,c,k);b[c]=d})});a.addedSetters=!0};c.textSetter=function(a){a!==k.innerHTML&&delete this.bBox;this.textStr=a;k.innerHTML=w(a,"");c.doTransform=!0};l&&q(c,c.element.style);c.xSetter=c.ySetter=c.alignSetter=c.rotationSetter=function(a,b){"align"===
b&&(b="textAlign");c[b]=a;c.doTransform=!0};c.afterSetters=function(){this.doTransform&&(this.htmlUpdateTransform(),this.doTransform=!1)};c.attr({text:a,x:Math.round(d),y:Math.round(b)}).css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize,position:"absolute"});k.style.whiteSpace="nowrap";c.css=c.htmlCss;l&&(c.add=function(a){var b,d=e.box.parentNode,p=[];if(this.parentGroup=a){if(b=a.div,!b){for(;a;)p.push(a),a=a.parentGroup;h(p.reverse(),function(a){function k(g,b){a[b]=g;"translateX"===
b?n.left=g+"px":n.top=g+"px";a.doTransform=!0}var n,g=C(a.element,"class");g&&(g={className:g});b=a.div=a.div||D("div",g,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},b||d);n=b.style;f(a,{classSetter:function(a){return function(g){this.element.setAttribute("class",g);a.className=g}}(b),on:function(){p[0].div&&c.on.apply({element:p[0].div},arguments);return a},translateXSetter:k,translateYSetter:k});
a.addedSetters||q(a,n)})}}else b=d;b.appendChild(k);c.added=!0;c.alignOnAdd&&c.htmlUpdateTransform();return c});return c}})})(K);(function(a){var C=a.defined,D=a.each,E=a.extend,m=a.merge,h=a.pick,f=a.timeUnits,r=a.win;a.Time=function(a){this.update(a,!1)};a.Time.prototype={defaultOptions:{},update:function(a){var f=h(a&&a.useUTC,!0),w=this;this.options=a=m(!0,this.options||{},a);this.Date=a.Date||r.Date;this.timezoneOffset=(this.useUTC=f)&&a.timezoneOffset;this.getTimezoneOffset=this.timezoneOffsetFunction();
(this.variableTimezone=!(f&&!a.getTimezoneOffset&&!a.timezone))||this.timezoneOffset?(this.get=function(a,c){var e=c.getTime(),f=e-w.getTimezoneOffset(c);c.setTime(f);a=c["getUTC"+a]();c.setTime(e);return a},this.set=function(a,c,l){var e;if("Milliseconds"===a||"Seconds"===a||"Minutes"===a&&0===c.getTimezoneOffset()%60)c["set"+a](l);else e=w.getTimezoneOffset(c),e=c.getTime()-e,c.setTime(e),c["setUTC"+a](l),a=w.getTimezoneOffset(c),e=c.getTime()+a,c.setTime(e)}):f?(this.get=function(a,c){return c["getUTC"+
a]()},this.set=function(a,c,l){return c["setUTC"+a](l)}):(this.get=function(a,c){return c["get"+a]()},this.set=function(a,c,l){return c["set"+a](l)})},makeTime:function(f,q,w,e,c,l){var z,k,d;this.useUTC?(z=this.Date.UTC.apply(0,arguments),k=this.getTimezoneOffset(z),z+=k,d=this.getTimezoneOffset(z),k!==d?z+=d-k:k-36E5!==this.getTimezoneOffset(z-36E5)||a.isSafari||(z-=36E5)):z=(new this.Date(f,q,h(w,1),h(e,0),h(c,0),h(l,0))).getTime();return z},timezoneOffsetFunction:function(){var f=this,h=this.options,
w=r.moment;if(!this.useUTC)return function(a){return 6E4*(new Date(a)).getTimezoneOffset()};if(h.timezone){if(w)return function(a){return 6E4*-w.tz(a,h.timezone).utcOffset()};a.error(25)}return this.useUTC&&h.getTimezoneOffset?function(a){return 6E4*h.getTimezoneOffset(a)}:function(){return 6E4*(f.timezoneOffset||0)}},dateFormat:function(f,h,w){if(!a.defined(h)||isNaN(h))return a.defaultOptions.lang.invalidDate||"";f=a.pick(f,"%Y-%m-%d %H:%M:%S");var e=this,c=new this.Date(h),l=this.get("Hours",c),
z=this.get("Day",c),k=this.get("Date",c),d=this.get("Month",c),b=this.get("FullYear",c),u=a.defaultOptions.lang,p=u.weekdays,H=u.shortWeekdays,t=a.pad,c=a.extend({a:H?H[z]:p[z].substr(0,3),A:p[z],d:t(k),e:t(k,2," "),w:z,b:u.shortMonths[d],B:u.months[d],m:t(d+1),o:d+1,y:b.toString().substr(2,2),Y:b,H:t(l),k:l,I:t(l%12||12),l:l%12||12,M:t(e.get("Minutes",c)),p:12>l?"AM":"PM",P:12>l?"am":"pm",S:t(c.getSeconds()),L:t(Math.round(h%1E3),3)},a.dateFormats);a.objectEach(c,function(a,b){for(;-1!==f.indexOf("%"+
b);)f=f.replace("%"+b,"function"===typeof a?a.call(e,h):a)});return w?f.substr(0,1).toUpperCase()+f.substr(1):f},getTimeTicks:function(a,q,w,e){var c=this,l=[],z={},k,d=new c.Date(q),b=a.unitRange,u=a.count||1,p;if(C(q)){c.set("Milliseconds",d,b>=f.second?0:u*Math.floor(c.get("Milliseconds",d)/u));b>=f.second&&c.set("Seconds",d,b>=f.minute?0:u*Math.floor(c.get("Seconds",d)/u));b>=f.minute&&c.set("Minutes",d,b>=f.hour?0:u*Math.floor(c.get("Minutes",d)/u));b>=f.hour&&c.set("Hours",d,b>=f.day?0:u*Math.floor(c.get("Hours",
d)/u));b>=f.day&&c.set("Date",d,b>=f.month?1:u*Math.floor(c.get("Date",d)/u));b>=f.month&&(c.set("Month",d,b>=f.year?0:u*Math.floor(c.get("Month",d)/u)),k=c.get("FullYear",d));b>=f.year&&c.set("FullYear",d,k-k%u);b===f.week&&c.set("Date",d,c.get("Date",d)-c.get("Day",d)+h(e,1));k=c.get("FullYear",d);e=c.get("Month",d);var H=c.get("Date",d),t=c.get("Hours",d);q=d.getTime();c.variableTimezone&&(p=w-q>4*f.month||c.getTimezoneOffset(q)!==c.getTimezoneOffset(w));d=d.getTime();for(q=1;d<w;)l.push(d),d=
b===f.year?c.makeTime(k+q*u,0):b===f.month?c.makeTime(k,e+q*u):!p||b!==f.day&&b!==f.week?p&&b===f.hour&&1<u?c.makeTime(k,e,H,t+q*u):d+b*u:c.makeTime(k,e,H+q*u*(b===f.day?1:7)),q++;l.push(d);b<=f.hour&&1E4>l.length&&D(l,function(a){0===a%18E5&&"000000000"===c.dateFormat("%H%M%S%L",a)&&(z[a]="day")})}l.info=E(a,{higherRanks:z,totalRange:b*u});return l}}})(K);(function(a){var C=a.color,D=a.merge;a.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),
symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{},time:a.Time.prototype.defaultOptions,
chart:{borderRadius:0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",alignColumns:!0,layout:"horizontal",
labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",
position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:a.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,backgroundColor:C("#f7f7f7").setOpacity(.85).get(),borderWidth:1,headerFormat:'\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',
pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"https://www.highcharts.com",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};a.setOptions=function(C){a.defaultOptions=D(!0,a.defaultOptions,C);
a.time.update(D(a.defaultOptions.global,a.defaultOptions.time),!1);return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};a.defaultPlotOptions=a.defaultOptions.plotOptions;a.time=new a.Time(D(a.defaultOptions.global,a.defaultOptions.time));a.dateFormat=function(C,m,h){return a.time.dateFormat(C,m,h)}})(K);(function(a){var C=a.correctFloat,D=a.defined,E=a.destroyObjectProperties,m=a.fireEvent,h=a.isNumber,f=a.merge,r=a.pick,y=a.deg2rad;a.Tick=function(a,f,e,c){this.axis=a;this.pos=
f;this.type=e||"";this.isNewLabel=this.isNew=!0;e||c||this.addLabel()};a.Tick.prototype={addLabel:function(){var a=this.axis,h=a.options,e=a.chart,c=a.categories,l=a.names,z=this.pos,k=h.labels,d=a.tickPositions,b=z===d[0],u=z===d[d.length-1],l=c?r(c[z],l[z],z):z,c=this.label,d=d.info,p;a.isDatetimeAxis&&d&&(p=h.dateTimeLabelFormats[d.higherRanks[z]||d.unitName]);this.isFirst=b;this.isLast=u;h={axis:a,chart:e,isFirst:b,isLast:u,dateTimeLabelFormat:p,value:a.isLog?C(a.lin2log(l)):l,pos:z};h=a.labelFormatter.call(h,
h);if(D(c))c&&c.attr({text:h});else{if(this.label=c=D(h)&&k.enabled?e.renderer.text(h,0,0,k.useHTML).css(f(k.style)).add(a.labelGroup):null)c.textPxLength=c.getBBox().width;this.rotation=0}},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var f=this.axis,e=f.options.labels,c=a.x,l=f.chart.chartWidth,z=f.chart.spacing,k=r(f.labelLeft,Math.min(f.pos,z[3])),z=r(f.labelRight,Math.max(f.isRadial?0:f.pos+f.len,l-z[1])),d=this.label,
b=this.rotation,u={left:0,center:.5,right:1}[f.labelAlign||d.attr("align")],p=d.getBBox().width,h=f.getSlotWidth(this),t=h,q=1,x,I={};if(b||!1===e.overflow)0>b&&c-u*p<k?x=Math.round(c/Math.cos(b*y)-k):0<b&&c+u*p>z&&(x=Math.round((l-c)/Math.cos(b*y)));else if(l=c+(1-u)*p,c-u*p<k?t=a.x+t*(1-u)-k:l>z&&(t=z-a.x+t*u,q=-1),t=Math.min(h,t),t<h&&"center"===f.labelAlign&&(a.x+=q*(h-t-u*(h-Math.min(p,t)))),p>t||f.autoRotation&&(d.styles||{}).width)x=t;x&&(I.width=x,(e.style||{}).textOverflow||(I.textOverflow=
"ellipsis"),d.css(I))},getPosition:function(f,h,e,c){var l=this.axis,z=l.chart,k=c&&z.oldChartHeight||z.chartHeight;f={x:f?a.correctFloat(l.translate(h+e,null,null,c)+l.transB):l.left+l.offset+(l.opposite?(c&&z.oldChartWidth||z.chartWidth)-l.right-l.left:0),y:f?k-l.bottom+l.offset-(l.opposite?l.height:0):a.correctFloat(k-l.translate(h+e,null,null,c)-l.transB)};m(this,"afterGetPosition",{pos:f});return f},getLabelPosition:function(a,f,e,c,l,h,k,d){var b=this.axis,u=b.transA,p=b.reversed,z=b.staggerLines,
t=b.tickRotCorr||{x:0,y:0},w=l.y,x=c||b.reserveSpaceDefault?0:-b.labelOffset*("center"===b.labelAlign?.5:1),q={};D(w)||(w=0===b.side?e.rotation?-8:-e.getBBox().height:2===b.side?t.y+8:Math.cos(e.rotation*y)*(t.y-e.getBBox(!1,0).height/2));a=a+l.x+x+t.x-(h&&c?h*u*(p?-1:1):0);f=f+w-(h&&!c?h*u*(p?1:-1):0);z&&(e=k/(d||1)%z,b.opposite&&(e=z-e-1),f+=b.labelOffset/z*e);q.x=a;q.y=Math.round(f);m(this,"afterGetLabelPosition",{pos:q});return q},getMarkPath:function(a,f,e,c,l,h){return h.crispLine(["M",a,f,
"L",a+(l?0:-e),f+(l?e:0)],c)},renderGridLine:function(a,f,e){var c=this.axis,l=c.options,h=this.gridLine,k={},d=this.pos,b=this.type,u=c.tickmarkOffset,p=c.chart.renderer,H=b?b+"Grid":"grid",t=l[H+"LineWidth"],w=l[H+"LineColor"],l=l[H+"LineDashStyle"];h||(k.stroke=w,k["stroke-width"]=t,l&&(k.dashstyle=l),b||(k.zIndex=1),a&&(k.opacity=0),this.gridLine=h=p.path().attr(k).addClass("highcharts-"+(b?b+"-":"")+"grid-line").add(c.gridGroup));if(!a&&h&&(a=c.getPlotLinePath(d+u,h.strokeWidth()*e,a,!0)))h[this.isNew?
"attr":"animate"]({d:a,opacity:f})},renderMark:function(a,f,e){var c=this.axis,l=c.options,h=c.chart.renderer,k=this.type,d=k?k+"Tick":"tick",b=c.tickSize(d),u=this.mark,p=!u,H=a.x;a=a.y;var t=r(l[d+"Width"],!k&&c.isXAxis?1:0),l=l[d+"Color"];b&&(c.opposite&&(b[0]=-b[0]),p&&(this.mark=u=h.path().addClass("highcharts-"+(k?k+"-":"")+"tick").add(c.axisGroup),u.attr({stroke:l,"stroke-width":t})),u[p?"attr":"animate"]({d:this.getMarkPath(H,a,b[0],u.strokeWidth()*e,c.horiz,h),opacity:f}))},renderLabel:function(a,
f,e,c){var l=this.axis,z=l.horiz,k=l.options,d=this.label,b=k.labels,u=b.step,l=l.tickmarkOffset,p=!0,H=a.x;a=a.y;d&&h(H)&&(d.xy=a=this.getLabelPosition(H,a,d,z,b,l,c,u),this.isFirst&&!this.isLast&&!r(k.showFirstLabel,1)||this.isLast&&!this.isFirst&&!r(k.showLastLabel,1)?p=!1:!z||b.step||b.rotation||f||0===e||this.handleOverflow(a),u&&c%u&&(p=!1),p&&h(a.y)?(a.opacity=e,d[this.isNewLabel?"attr":"animate"](a),this.isNewLabel=!1):(d.attr("y",-9999),this.isNewLabel=!0))},render:function(f,h,e){var c=
this.axis,l=c.horiz,z=this.getPosition(l,this.pos,c.tickmarkOffset,h),k=z.x,d=z.y,c=l&&k===c.pos+c.len||!l&&d===c.pos?-1:1;e=r(e,1);this.isActive=!0;this.renderGridLine(h,e,c);this.renderMark(z,e,c);this.renderLabel(z,h,e,f);this.isNew=!1;a.fireEvent(this,"afterRender")},destroy:function(){E(this,this.axis)}}})(K);var V=function(a){var C=a.addEvent,D=a.animObject,E=a.arrayMax,m=a.arrayMin,h=a.color,f=a.correctFloat,r=a.defaultOptions,y=a.defined,q=a.deg2rad,w=a.destroyObjectProperties,e=a.each,c=
a.extend,l=a.fireEvent,z=a.format,k=a.getMagnitude,d=a.grep,b=a.inArray,u=a.isArray,p=a.isNumber,H=a.isString,t=a.merge,L=a.normalizeTickInterval,x=a.objectEach,I=a.pick,n=a.removeEvent,G=a.splat,B=a.syncTimeout,M=a.Tick,F=function(){this.init.apply(this,arguments)};a.extend(F.prototype,{defaultOptions:{dateTimeLabelFormats:{millisecond:"%H:%M:%S.%L",second:"%H:%M:%S",minute:"%H:%M",hour:"%H:%M",day:"%e. %b",week:"%e. %b",month:"%b '%y",year:"%Y"},endOnTick:!1,labels:{enabled:!0,x:0,style:{color:"#666666",
cursor:"default",fontSize:"11px"}},maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",minPadding:.01,startOfWeek:1,startOnTick:!1,tickLength:10,tickPixelInterval:100,tickmarkPlacement:"between",tickPosition:"outside",title:{align:"middle",style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,maxPadding:.05,minPadding:.05,
tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,formatter:function(){return a.numberFormat(this.total,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"#000000",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},
defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},init:function(a,d){var g=d.isX,v=this;v.chart=a;v.horiz=a.inverted&&!v.isZAxis?!g:g;v.isXAxis=g;v.coll=v.coll||(g?"xAxis":"yAxis");l(this,"init",{userOptions:d});v.opposite=d.opposite;v.side=d.side||(v.horiz?v.opposite?0:2:v.opposite?1:3);v.setOptions(d);var c=this.options,k=c.type;v.labelFormatter=c.labels.formatter||v.defaultLabelFormatter;v.userOptions=d;v.minPixelPadding=0;v.reversed=c.reversed;v.visible=!1!==c.visible;
v.zoomEnabled=!1!==c.zoomEnabled;v.hasNames="category"===k||!0===c.categories;v.categories=c.categories||v.hasNames;v.names||(v.names=[],v.names.keys={});v.plotLinesAndBandsGroups={};v.isLog="logarithmic"===k;v.isDatetimeAxis="datetime"===k;v.positiveValuesOnly=v.isLog&&!v.allowNegativeLog;v.isLinked=y(c.linkedTo);v.ticks={};v.labelEdge=[];v.minorTicks={};v.plotLinesAndBands=[];v.alternateBands={};v.len=0;v.minRange=v.userMinRange=c.minRange||c.maxZoom;v.range=c.range;v.offset=c.offset||0;v.stacks=
{};v.oldStacks={};v.stacksTouched=0;v.max=null;v.min=null;v.crosshair=I(c.crosshair,G(a.options.tooltip.crosshairs)[g?0:1],!1);d=v.options.events;-1===b(v,a.axes)&&(g?a.axes.splice(a.xAxis.length,0,v):a.axes.push(v),a[v.coll].push(v));v.series=v.series||[];a.inverted&&!v.isZAxis&&g&&void 0===v.reversed&&(v.reversed=!0);x(d,function(a,g){C(v,g,a)});v.lin2log=c.linearToLogConverter||v.lin2log;v.isLog&&(v.val2lin=v.log2lin,v.lin2val=v.lin2log);l(this,"afterInit")},setOptions:function(a){this.options=
t(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],t(r[this.coll],a));l(this,"afterSetOptions",{userOptions:a})},defaultLabelFormatter:function(){var g=this.axis,b=this.value,d=g.chart.time,c=g.categories,k=this.dateTimeLabelFormat,n=r.lang,e=n.numericSymbols,n=n.numericSymbolMagnitude||1E3,p=e&&e.length,l,u=g.options.labels.format,g=g.isLog?Math.abs(b):g.tickInterval;
if(u)l=z(u,this,d);else if(c)l=b;else if(k)l=d.dateFormat(k,b);else if(p&&1E3<=g)for(;p--&&void 0===l;)d=Math.pow(n,p+1),g>=d&&0===10*b%d&&null!==e[p]&&0!==b&&(l=a.numberFormat(b/d,-1)+e[p]);void 0===l&&(l=1E4<=Math.abs(b)?a.numberFormat(b,-1):a.numberFormat(b,-1,void 0,""));return l},getSeriesExtremes:function(){var a=this,b=a.chart;l(this,"getSeriesExtremes",null,function(){a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();e(a.series,
function(g){if(g.visible||!b.options.chart.ignoreHiddenSeries){var v=g.options,c=v.threshold,k;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=c&&(c=null);if(a.isXAxis)v=g.xData,v.length&&(g=m(v),k=E(v),p(g)||g instanceof Date||(v=d(v,p),g=m(v),k=E(v)),v.length&&(a.dataMin=Math.min(I(a.dataMin,v[0],g),g),a.dataMax=Math.max(I(a.dataMax,v[0],k),k)));else if(g.getExtremes(),k=g.dataMax,g=g.dataMin,y(g)&&y(k)&&(a.dataMin=Math.min(I(a.dataMin,g),g),a.dataMax=Math.max(I(a.dataMax,k),k)),y(c)&&(a.threshold=
c),!v.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})});l(this,"afterGetSeriesExtremes")},translate:function(a,b,d,c,k,n){var g=this.linkedParent||this,v=1,e=0,J=c?g.oldTransA:g.transA;c=c?g.oldMin:g.min;var l=g.minPixelPadding;k=(g.isOrdinal||g.isBroken||g.isLog&&k)&&g.lin2val;J||(J=g.transA);d&&(v*=-1,e=g.len);g.reversed&&(v*=-1,e-=v*(g.sector||g.len));b?(a=(a*v+e-l)/J+c,k&&(a=g.lin2val(a))):(k&&(a=g.val2lin(a)),a=p(c)?v*(a-c)*J+e+v*l+(p(n)?J*n:0):void 0);return a},toPixels:function(a,
b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,d,c,k){var g=this.chart,v=this.left,n=this.top,e,J,l=d&&g.oldChartHeight||g.chartHeight,u=d&&g.oldChartWidth||g.chartWidth,B;e=this.transB;var f=function(a,g,b){if(a<g||a>b)c?a=Math.min(Math.max(g,a),b):B=!0;return a};k=I(k,this.translate(a,null,null,d));k=Math.min(Math.max(-1E5,k),1E5);a=d=Math.round(k+e);e=J=Math.round(l-
k-e);p(k)?this.horiz?(e=n,J=l-this.bottom,a=d=f(a,v,v+this.width)):(a=v,d=u-this.right,e=J=f(e,n,n+this.height)):(B=!0,c=!1);return B&&!c?null:g.renderer.crispLine(["M",a,e,"L",d,J],b||1)},getLinearTickPositions:function(a,b,d){var g,v=f(Math.floor(b/a)*a);d=f(Math.ceil(d/a)*a);var c=[],k;f(v+a)===v&&(k=20);if(this.single)return[b];for(b=v;b<=d;){c.push(b);b=f(b+a,k);if(b===g)break;g=b}return c},getMinorTickInterval:function(){var a=this.options;return!0===a.minorTicks?I(a.minorTickInterval,"auto"):
!1===a.minorTicks?null:a.minorTickInterval},getMinorTickPositions:function(){var a=this,b=a.options,d=a.tickPositions,c=a.minorTickInterval,k=[],n=a.pointRangePadding||0,p=a.min-n,n=a.max+n,l=n-p;if(l&&l/c<a.len/3)if(a.isLog)e(this.paddedTicks,function(g,b,d){b&&k.push.apply(k,a.getLogTickPositions(c,d[b-1],d[b],!0))});else if(a.isDatetimeAxis&&"auto"===this.getMinorTickInterval())k=k.concat(a.getTimeTicks(a.normalizeTimeTickInterval(c),p,n,b.startOfWeek));else for(b=p+(d[0]-p)%c;b<=n&&b!==k[0];b+=
c)k.push(b);0!==k.length&&a.trimTicks(k);return k},adjustForMinRange:function(){var a=this.options,b=this.min,d=this.max,c,k,n,p,l,u,B,f;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(y(a.min)||y(a.max)?this.minRange=null:(e(this.series,function(a){u=a.xData;for(p=B=a.xIncrement?1:u.length-1;0<p;p--)if(l=u[p]-u[p-1],void 0===n||l<n)n=l}),this.minRange=Math.min(5*n,this.dataMax-this.dataMin)));d-b<this.minRange&&(k=this.dataMax-this.dataMin>=this.minRange,f=this.minRange,c=(f-d+b)/2,c=[b-c,I(a.min,
b-c)],k&&(c[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),b=E(c),d=[b+f,I(a.max,b+f)],k&&(d[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),d=m(d),d-b<f&&(c[0]=d-f,c[1]=I(a.min,d-f),b=E(c)));this.min=b;this.max=d},getClosest:function(){var a;this.categories?a=1:e(this.series,function(g){var b=g.closestPointRange,d=g.visible||!g.chart.options.chart.ignoreHiddenSeries;!g.noSharedTooltip&&y(b)&&d&&(a=y(a)?Math.min(a,b):b)});return a},nameToX:function(a){var g=u(this.categories),d=g?this.categories:
this.names,c=a.options.x,k;a.series.requireSorting=!1;y(c)||(c=!1===this.options.uniqueNames?a.series.autoIncrement():g?b(a.name,d):I(d.keys[a.name],-1));-1===c?g||(k=d.length):k=c;void 0!==k&&(this.names[k]=a.name,this.names.keys[a.name]=k);return k},updateNames:function(){var b=this,d=this.names;0<d.length&&(e(a.keys(d.keys),function(a){delete d.keys[a]}),d.length=0,this.minRange=this.userMinRange,e(this.series||[],function(a){a.xIncrement=null;if(!a.points||a.isDirtyData)a.processData(),a.generatePoints();
e(a.points,function(g,d){var c;g.options&&(c=b.nameToX(g),void 0!==c&&c!==g.x&&(g.x=c,a.xData[d]=c))})}))},setAxisTranslation:function(a){var b=this,g=b.max-b.min,d=b.axisPointRange||0,c,k=0,n=0,p=b.linkedParent,u=!!b.categories,f=b.transA,B=b.isXAxis;if(B||u||d)c=b.getClosest(),p?(k=p.minPointOffset,n=p.pointRangePadding):e(b.series,function(a){var g=u?1:B?I(a.options.pointRange,c,0):b.axisPointRange||0;a=a.options.pointPlacement;d=Math.max(d,g);b.single||(k=Math.max(k,H(a)?0:g/2),n=Math.max(n,"on"===
a?0:g))}),p=b.ordinalSlope&&c?b.ordinalSlope/c:1,b.minPointOffset=k*=p,b.pointRangePadding=n*=p,b.pointRange=Math.min(d,g),B&&(b.closestPointRange=c);a&&(b.oldTransA=f);b.translationSlope=b.transA=f=b.options.staticScale||b.len/(g+n||1);b.transB=b.horiz?b.left:b.bottom;b.minPixelPadding=f*k;l(this,"afterSetAxisTranslation")},minFromRange:function(){return this.max-this.range},setTickInterval:function(b){var g=this,d=g.chart,c=g.options,n=g.isLog,u=g.isDatetimeAxis,B=g.isXAxis,t=g.isLinked,h=c.maxPadding,
G=c.minPadding,x=c.tickInterval,z=c.tickPixelInterval,F=g.categories,H=p(g.threshold)?g.threshold:null,w=g.softThreshold,q,M,m,r;u||F||t||this.getTickAmount();m=I(g.userMin,c.min);r=I(g.userMax,c.max);t?(g.linkedParent=d[g.coll][c.linkedTo],d=g.linkedParent.getExtremes(),g.min=I(d.min,d.dataMin),g.max=I(d.max,d.dataMax),c.type!==g.linkedParent.options.type&&a.error(11,1)):(!w&&y(H)&&(g.dataMin>=H?(q=H,G=0):g.dataMax<=H&&(M=H,h=0)),g.min=I(m,q,g.dataMin),g.max=I(r,M,g.dataMax));n&&(g.positiveValuesOnly&&
!b&&0>=Math.min(g.min,I(g.dataMin,g.min))&&a.error(10,1),g.min=f(g.log2lin(g.min),15),g.max=f(g.log2lin(g.max),15));g.range&&y(g.max)&&(g.userMin=g.min=m=Math.max(g.dataMin,g.minFromRange()),g.userMax=r=g.max,g.range=null);l(g,"foundExtremes");g.beforePadding&&g.beforePadding();g.adjustForMinRange();!(F||g.axisPointRange||g.usePercentage||t)&&y(g.min)&&y(g.max)&&(d=g.max-g.min)&&(!y(m)&&G&&(g.min-=d*G),!y(r)&&h&&(g.max+=d*h));p(c.softMin)&&!p(g.userMin)&&(g.min=Math.min(g.min,c.softMin));p(c.softMax)&&
!p(g.userMax)&&(g.max=Math.max(g.max,c.softMax));p(c.floor)&&(g.min=Math.max(g.min,c.floor));p(c.ceiling)&&(g.max=Math.min(g.max,c.ceiling));w&&y(g.dataMin)&&(H=H||0,!y(m)&&g.min<H&&g.dataMin>=H?g.min=H:!y(r)&&g.max>H&&g.dataMax<=H&&(g.max=H));g.tickInterval=g.min===g.max||void 0===g.min||void 0===g.max?1:t&&!x&&z===g.linkedParent.options.tickPixelInterval?x=g.linkedParent.tickInterval:I(x,this.tickAmount?(g.max-g.min)/Math.max(this.tickAmount-1,1):void 0,F?1:(g.max-g.min)*z/Math.max(g.len,z));B&&
!b&&e(g.series,function(a){a.processData(g.min!==g.oldMin||g.max!==g.oldMax)});g.setAxisTranslation(!0);g.beforeSetTickPositions&&g.beforeSetTickPositions();g.postProcessTickInterval&&(g.tickInterval=g.postProcessTickInterval(g.tickInterval));g.pointRange&&!x&&(g.tickInterval=Math.max(g.pointRange,g.tickInterval));b=I(c.minTickInterval,g.isDatetimeAxis&&g.closestPointRange);!x&&g.tickInterval<b&&(g.tickInterval=b);u||n||x||(g.tickInterval=L(g.tickInterval,null,k(g.tickInterval),I(c.allowDecimals,
!(.5<g.tickInterval&&5>g.tickInterval&&1E3<g.max&&9999>g.max)),!!this.tickAmount));this.tickAmount||(g.tickInterval=g.unsquish());this.setTickPositions()},setTickPositions:function(){var a=this.options,b,d=a.tickPositions;b=this.getMinorTickInterval();var c=a.tickPositioner,k=a.startOnTick,n=a.endOnTick;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===b&&this.tickInterval?this.tickInterval/5:b;this.single=this.min===this.max&&
y(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==a.allowDecimals);this.tickPositions=b=d&&d.slice();!b&&(b=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),b.length>this.len&&(b=[b[0],b.pop()],b[0]===b[1]&&(b.length=
1)),this.tickPositions=b,c&&(c=c.apply(this,[this.min,this.max])))&&(this.tickPositions=b=c);this.paddedTicks=b.slice(0);this.trimTicks(b,k,n);this.isLinked||(this.single&&2>b.length&&(this.min-=.5,this.max+=.5),d||c||this.adjustTickAmount());l(this,"afterSetTickPositions")},trimTicks:function(a,b,d){var g=a[0],c=a[a.length-1],k=this.minPointOffset||0;if(!this.isLinked){if(b&&-Infinity!==g)this.min=g;else for(;this.min-k>a[0];)a.shift();if(d)this.max=c;else for(;this.max+k<a[a.length-1];)a.pop();
0===a.length&&y(g)&&!this.options.tickPositions&&a.push((c+g)/2)}},alignToOthers:function(){var a={},b,d=this.options;!1===this.chart.options.chart.alignTicks||!1===d.alignTicks||!1===d.startOnTick||!1===d.endOnTick||this.isLog||e(this.chart[this.coll],function(g){var d=g.options,d=[g.horiz?d.left:d.top,d.width,d.height,d.pane].join();g.series.length&&(a[d]?b=!0:a[d]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,d=a.tickPixelInterval;!y(a.tickInterval)&&this.len<d&&!this.isRadial&&
!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/d)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.tickInterval,b=this.tickPositions,d=this.tickAmount,c=this.finalTickAmt,k=b&&b.length,n=I(this.threshold,this.softThreshold?0:null);if(this.hasData()){if(k<d){for(;b.length<d;)b.length%2||this.min===n?b.push(f(b[b.length-1]+a)):b.unshift(f(b[0]-a));this.transA*=(k-1)/(d-1);this.min=b[0];this.max=b[b.length-1]}else k>
d&&(this.tickInterval*=2,this.setTickPositions());if(y(c)){for(a=d=b.length;a--;)(3===c&&1===a%2||2>=c&&0<a&&a<d-1)&&b.splice(a,1);this.finalTickAmt=void 0}}},setScale:function(){var a,b;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();b=this.len!==this.oldAxisLength;e(this.series,function(b){if(b.isDirtyData||b.isDirty||b.xAxis.isDirty)a=!0});b||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?
(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks();l(this,"afterSetScale")},setExtremes:function(a,b,d,k,n){var g=this,p=g.chart;d=I(d,!0);e(g.series,function(a){delete a.kdTree});n=c(n,{min:a,max:b});l(g,"setExtremes",n,function(){g.userMin=a;g.userMax=b;g.eventArgs=n;d&&
p.redraw(k)})},zoom:function(a,b){var g=this.dataMin,d=this.dataMax,c=this.options,k=Math.min(g,I(c.min,g)),c=Math.max(d,I(c.max,d));if(a!==this.min||b!==this.max)this.allowZoomOutside||(y(g)&&(a<k&&(a=k),a>c&&(a=c)),y(d)&&(b<k&&(b=k),b>c&&(b=c))),this.displayBtn=void 0!==a||void 0!==b,this.setExtremes(a,b,!1,void 0,{trigger:"zoom"});return!0},setAxisSize:function(){var b=this.chart,d=this.options,c=d.offsets||[0,0,0,0],k=this.horiz,n=this.width=Math.round(a.relativeLength(I(d.width,b.plotWidth-c[3]+
c[1]),b.plotWidth)),e=this.height=Math.round(a.relativeLength(I(d.height,b.plotHeight-c[0]+c[2]),b.plotHeight)),p=this.top=Math.round(a.relativeLength(I(d.top,b.plotTop+c[0]),b.plotHeight,b.plotTop)),d=this.left=Math.round(a.relativeLength(I(d.left,b.plotLeft+c[3]),b.plotWidth,b.plotLeft));this.bottom=b.chartHeight-e-p;this.right=b.chartWidth-n-d;this.len=Math.max(k?n:e,0);this.pos=k?d:p},getExtremes:function(){var a=this.isLog;return{min:a?f(this.lin2log(this.min)):this.min,max:a?f(this.lin2log(this.max)):
this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,g=b?this.lin2log(this.min):this.min,b=b?this.lin2log(this.max):this.max;null===a||-Infinity===a?a=g:Infinity===a?a=b:g>a?a=g:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){a=(I(a,0)-90*this.side+720)%360;return 15<a&&165>a?"right":195<a&&345>a?"left":"center"},tickSize:function(a){var b=this.options,g=b[a+"Length"],d=I(b[a+"Width"],"tick"===
a&&this.isXAxis?1:0);if(d&&g)return"inside"===b[a+"Position"]&&(g=-g),[g,d]},labelMetrics:function(){var a=this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&this.options.labels.style.fontSize,this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var a=this.options.labels,b=this.horiz,d=this.tickInterval,c=d,k=this.len/(((this.categories?1:0)+this.max-this.min)/d),n,p=a.rotation,l=this.labelMetrics(),u,B=Number.MAX_VALUE,t,h=function(a){a/=
k||1;a=1<a?Math.ceil(a):1;return f(a*d)};b?(t=!a.staggerLines&&!a.step&&(y(p)?[p]:k<I(a.autoRotationLimit,80)&&a.autoRotation))&&e(t,function(a){var b;if(a===p||a&&-90<=a&&90>=a)u=h(Math.abs(l.h/Math.sin(q*a))),b=u+Math.abs(a/360),b<B&&(B=b,n=a,c=u)}):a.step||(c=h(l.h));this.autoRotation=t;this.labelRotation=I(n,p);return c},getSlotWidth:function(){var a=this.chart,b=this.horiz,d=this.options.labels,c=Math.max(this.tickPositions.length-(this.categories?0:1),1),k=a.margin[3];return b&&2>(d.step||0)&&
!d.rotation&&(this.staggerLines||1)*this.len/c||!b&&(d.style&&parseInt(d.style.width,10)||k&&k-a.spacing[3]||.33*a.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,d=this.tickPositions,c=this.ticks,k=this.options.labels,n=k&&k.style||{},p=this.horiz,l=this.getSlotWidth(),u=Math.max(1,Math.round(l-2*(k.padding||5))),B={},f=this.labelMetrics(),t=k.style&&k.style.textOverflow,h,G,x=0,z;H(k.rotation)||(B.rotation=k.rotation||0);e(d,function(a){(a=c[a])&&a.label&&a.label.textPxLength>
x&&(x=a.label.textPxLength)});this.maxLabelLength=x;if(this.autoRotation)x>u&&x>f.h?B.rotation=this.labelRotation:this.labelRotation=0;else if(l&&(h=u,!t))for(G="clip",u=d.length;!p&&u--;)if(z=d[u],z=c[z].label)z.styles&&"ellipsis"===z.styles.textOverflow?z.css({textOverflow:"clip"}):z.textPxLength>l&&z.css({width:l+"px"}),z.getBBox().height>this.len/d.length-(f.h-f.f)&&(z.specificTextOverflow="ellipsis");B.rotation&&(h=x>.5*a.chartHeight?.33*a.chartHeight:x,t||(G="ellipsis"));if(this.labelAlign=
k.align||this.autoLabelAlign(this.labelRotation))B.align=this.labelAlign;e(d,function(a){var b=(a=c[a])&&a.label,g=n.width,d={};b&&(b.attr(B),h&&!g&&"nowrap"!==n.whiteSpace&&(h<b.textPxLength||"SPAN"===b.element.tagName)?(d.width=h,t||(d.textOverflow=b.specificTextOverflow||G),b.css(d)):b.styles&&b.styles.width&&!d.width&&!g&&b.css({width:null}),delete b.specificTextOverflow,a.rotation=B.rotation)});this.tickRotCorr=b.rotCorr(f.b,this.labelRotation||0,0!==this.side)},hasData:function(){return this.hasVisibleSeries||
y(this.min)&&y(this.max)&&this.tickPositions&&0<this.tickPositions.length},addTitle:function(a){var b=this.chart.renderer,g=this.horiz,d=this.opposite,c=this.options.title,k;this.axisTitle||((k=c.textAlign)||(k=(g?{low:"left",middle:"center",high:"right"}:{low:d?"right":"left",middle:"center",high:d?"left":"right"})[c.align]),this.axisTitle=b.text(c.text,0,0,c.useHTML).attr({zIndex:7,rotation:c.rotation||0,align:k}).addClass("highcharts-axis-title").css(t(c.style)).add(this.axisGroup),this.axisTitle.isNew=
!0);c.style.width||this.isRadial||this.axisTitle.css({width:this.len});this.axisTitle[a?"show":"hide"](!0)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():b[a]=new M(this,a)},getOffset:function(){var a=this,b=a.chart,d=b.renderer,c=a.options,k=a.tickPositions,n=a.ticks,p=a.horiz,u=a.side,B=b.inverted&&!a.isZAxis?[1,0,3,2][u]:u,f,t,h=0,G,z=0,H=c.title,F=c.labels,w=0,q=b.axisOffset,b=b.clipOffset,m=[-1,1,1,-1][u],M=c.className,r=a.axisParent,L=this.tickSize("tick");f=a.hasData();a.showAxis=
t=f||I(c.showEmpty,!0);a.staggerLines=a.horiz&&F.staggerLines;a.axisGroup||(a.gridGroup=d.g("grid").attr({zIndex:c.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(M||"")).add(r),a.axisGroup=d.g("axis").attr({zIndex:c.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(M||"")).add(r),a.labelGroup=d.g("axis-labels").attr({zIndex:F.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(M||"")).add(r));f||a.isLinked?(e(k,function(b,g){a.generateTick(b,
g)}),a.renderUnsquish(),a.reserveSpaceDefault=0===u||2===u||{1:"left",3:"right"}[u]===a.labelAlign,I(F.reserveSpace,"center"===a.labelAlign?!0:null,a.reserveSpaceDefault)&&e(k,function(a){w=Math.max(n[a].getLabelSize(),w)}),a.staggerLines&&(w*=a.staggerLines),a.labelOffset=w*(a.opposite?-1:1)):x(n,function(a,b){a.destroy();delete n[b]});H&&H.text&&!1!==H.enabled&&(a.addTitle(t),t&&!1!==H.reserveSpace&&(a.titleOffset=h=a.axisTitle.getBBox()[p?"height":"width"],G=H.offset,z=y(G)?0:I(H.margin,p?5:10)));
a.renderLine();a.offset=m*I(c.offset,q[u]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};d=0===u?-a.labelMetrics().h:2===u?a.tickRotCorr.y:0;z=Math.abs(w)+z;w&&(z=z-d+m*(p?I(F.y,a.tickRotCorr.y+8*m):F.x));a.axisTitleMargin=I(G,z);q[u]=Math.max(q[u],a.axisTitleMargin+h+m*a.offset,z,f&&k.length&&L?L[0]+m*a.offset:0);c=c.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);b[B]=Math.max(b[B],c);l(this,"afterGetOffset")},getLinePath:function(a){var b=this.chart,g=this.opposite,d=this.offset,c=this.horiz,k=this.left+
(g?this.width:0)+d,d=b.chartHeight-this.bottom-(g?this.height:0)+d;g&&(a*=-1);return b.renderer.crispLine(["M",c?this.left:k,c?d:this.top,"L",c?b.chartWidth-this.right:k,c?d:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,d=this.top,
c=this.len,k=this.options.title,n=a?b:d,e=this.opposite,p=this.offset,l=k.x||0,u=k.y||0,B=this.axisTitle,f=this.chart.renderer.fontMetrics(k.style&&k.style.fontSize,B),B=Math.max(B.getBBox(null,0).height-f.h-1,0),c={low:n+(a?0:c),middle:n+c/2,high:n+(a?c:0)}[k.align],b=(a?d+this.height:b)+(a?1:-1)*(e?-1:1)*this.axisTitleMargin+[-B,B,f.f,-B][this.side];return{x:a?c+l:b+(e?this.width:0)+p+l,y:a?b+u-(e?this.height:0)+p:c+u}},renderMinorTick:function(a){var b=this.chart.hasRendered&&p(this.oldMin),d=
this.minorTicks;d[a]||(d[a]=new M(this,a,"minor"));b&&d[a].isNew&&d[a].render(null,!0);d[a].render(null,!1,1)},renderTick:function(a,b){var d=this.isLinked,g=this.ticks,c=this.chart.hasRendered&&p(this.oldMin);if(!d||a>=this.min&&a<=this.max)g[a]||(g[a]=new M(this,a)),c&&g[a].isNew&&g[a].render(b,!0,.1),g[a].render(b)},render:function(){var b=this,d=b.chart,c=b.options,k=b.isLog,n=b.isLinked,u=b.tickPositions,f=b.axisTitle,t=b.ticks,h=b.minorTicks,G=b.alternateBands,z=c.stackLabels,H=c.alternateGridColor,
F=b.tickmarkOffset,w=b.axisLine,I=b.showAxis,m=D(d.renderer.globalAnimation),q,r;b.labelEdge.length=0;b.overlap=!1;e([t,h,G],function(a){x(a,function(a){a.isActive=!1})});if(b.hasData()||n)b.minorTickInterval&&!b.categories&&e(b.getMinorTickPositions(),function(a){b.renderMinorTick(a)}),u.length&&(e(u,function(a,d){b.renderTick(a,d)}),F&&(0===b.min||b.single)&&(t[-1]||(t[-1]=new M(b,-1,null,!0)),t[-1].render(-1))),H&&e(u,function(c,g){r=void 0!==u[g+1]?u[g+1]+F:b.max-F;0===g%2&&c<b.max&&r<=b.max+
(d.polar?-F:F)&&(G[c]||(G[c]=new a.PlotLineOrBand(b)),q=c+F,G[c].options={from:k?b.lin2log(q):q,to:k?b.lin2log(r):r,color:H},G[c].render(),G[c].isActive=!0)}),b._addedPlotLB||(e((c.plotLines||[]).concat(c.plotBands||[]),function(a){b.addPlotBandOrLine(a)}),b._addedPlotLB=!0);e([t,h,G],function(a){var b,c=[],g=m.duration;x(a,function(a,b){a.isActive||(a.render(b,!1,0),a.isActive=!1,c.push(b))});B(function(){for(b=c.length;b--;)a[c[b]]&&!a[c[b]].isActive&&(a[c[b]].destroy(),delete a[c[b]])},a!==G&&
d.hasRendered&&g?g:0)});w&&(w[w.isPlaced?"animate":"attr"]({d:this.getLinePath(w.strokeWidth())}),w.isPlaced=!0,w[I?"show":"hide"](!0));f&&I&&(c=b.getTitlePosition(),p(c.y)?(f[f.isNew?"attr":"animate"](c),f.isNew=!1):(f.attr("y",-9999),f.isNew=!0));z&&z.enabled&&b.renderStackTotals();b.isDirty=!1;l(this,"afterRender")},redraw:function(){this.visible&&(this.render(),e(this.plotLinesAndBands,function(a){a.render()}));e(this.series,function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),
destroy:function(a){var d=this,c=d.stacks,g=d.plotLinesAndBands,k;l(this,"destroy",{keepEvents:a});a||n(d);x(c,function(a,b){w(a);c[b]=null});e([d.ticks,d.minorTicks,d.alternateBands],function(a){w(a)});if(g)for(a=g.length;a--;)g[a].destroy();e("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" "),function(a){d[a]&&(d[a]=d[a].destroy())});for(k in d.plotLinesAndBandsGroups)d.plotLinesAndBandsGroups[k]=d.plotLinesAndBandsGroups[k].destroy();x(d,function(a,c){-1===
b(c,d.keepProps)&&delete d[c]})},drawCrosshair:function(a,b){var d,c=this.crosshair,g=I(c.snap,!0),k,n=this.cross;l(this,"drawCrosshair",{e:a,point:b});a||(a=this.cross&&this.cross.e);if(this.crosshair&&!1!==(y(b)||!g)){g?y(b)&&(k=I(b.crosshairPos,this.isXAxis?b.plotX:this.len-b.plotY)):k=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos);y(k)&&(d=this.getPlotLinePath(b&&(this.isXAxis?b.x:I(b.stackY,b.y)),null,null,null,k)||null);if(!y(d)){this.hideCrosshair();return}g=this.categories&&
!this.isRadial;n||(this.cross=n=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(g?"category ":"thin ")+c.className).attr({zIndex:I(c.zIndex,2)}).add(),n.attr({stroke:c.color||(g?h("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":I(c.width,1)}).css({"pointer-events":"none"}),c.dashStyle&&n.attr({dashstyle:c.dashStyle}));n.show().attr({d:d});g&&!c.width&&n.attr({"stroke-width":this.transA});this.cross.e=a}else this.hideCrosshair();l(this,"afterDrawCrosshair",
{e:a,point:b})},hideCrosshair:function(){this.cross&&this.cross.hide()}});return a.Axis=F}(K);(function(a){var C=a.Axis,D=a.getMagnitude,E=a.normalizeTickInterval,m=a.timeUnits;C.prototype.getTimeTicks=function(){return this.chart.time.getTimeTicks.apply(this.chart.time,arguments)};C.prototype.normalizeTimeTickInterval=function(a,f){var h=f||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],
["month",[1,2,3,4,6]],["year",null]];f=h[h.length-1];var y=m[f[0]],q=f[1],w;for(w=0;w<h.length&&!(f=h[w],y=m[f[0]],q=f[1],h[w+1]&&a<=(y*q[q.length-1]+m[h[w+1][0]])/2);w++);y===m.year&&a<5*y&&(q=[1,2,5]);a=E(a/y,q,"year"===f[0]?Math.max(D(a/y),1):1);return{unitRange:y,count:a,unitName:f[0]}}})(K);(function(a){var C=a.Axis,D=a.getMagnitude,E=a.map,m=a.normalizeTickInterval,h=a.pick;C.prototype.getLogTickPositions=function(a,r,y,q){var f=this.options,e=this.len,c=[];q||(this._minorAutoInterval=null);
if(.5<=a)a=Math.round(a),c=this.getLinearTickPositions(a,r,y);else if(.08<=a)for(var e=Math.floor(r),l,z,k,d,b,f=.3<a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];e<y+1&&!b;e++)for(z=f.length,l=0;l<z&&!b;l++)k=this.log2lin(this.lin2log(e)*f[l]),k>r&&(!q||d<=y)&&void 0!==d&&c.push(d),d>y&&(b=!0),d=k;else r=this.lin2log(r),y=this.lin2log(y),a=q?this.getMinorTickInterval():f.tickInterval,a=h("auto"===a?null:a,this._minorAutoInterval,f.tickPixelInterval/(q?5:1)*(y-r)/((q?e/this.tickPositions.length:
e)||1)),a=m(a,null,D(a)),c=E(this.getLinearTickPositions(a,r,y),this.log2lin),q||(this._minorAutoInterval=a/5);q||(this.tickInterval=a);return c};C.prototype.log2lin=function(a){return Math.log(a)/Math.LN10};C.prototype.lin2log=function(a){return Math.pow(10,a)}})(K);(function(a,C){var D=a.arrayMax,E=a.arrayMin,m=a.defined,h=a.destroyObjectProperties,f=a.each,r=a.erase,y=a.merge,q=a.pick;a.PlotLineOrBand=function(a,e){this.axis=a;e&&(this.options=e,this.id=e.id)};a.PlotLineOrBand.prototype={render:function(){var f=
this,e=f.axis,c=e.horiz,l=f.options,h=l.label,k=f.label,d=l.to,b=l.from,u=l.value,p=m(b)&&m(d),H=m(u),t=f.svgElem,r=!t,x=[],I=l.color,n=q(l.zIndex,0),G=l.events,x={"class":"highcharts-plot-"+(p?"band ":"line ")+(l.className||"")},B={},M=e.chart.renderer,F=p?"bands":"lines";e.isLog&&(b=e.log2lin(b),d=e.log2lin(d),u=e.log2lin(u));H?(x.stroke=I,x["stroke-width"]=l.width,l.dashStyle&&(x.dashstyle=l.dashStyle)):p&&(I&&(x.fill=I),l.borderWidth&&(x.stroke=l.borderColor,x["stroke-width"]=l.borderWidth));
B.zIndex=n;F+="-"+n;(I=e.plotLinesAndBandsGroups[F])||(e.plotLinesAndBandsGroups[F]=I=M.g("plot-"+F).attr(B).add());r&&(f.svgElem=t=M.path().attr(x).add(I));if(H)x=e.getPlotLinePath(u,t.strokeWidth());else if(p)x=e.getPlotBandPath(b,d,l);else return;r&&x&&x.length?(t.attr({d:x}),G&&a.objectEach(G,function(a,b){t.on(b,function(a){G[b].apply(f,[a])})})):t&&(x?(t.show(),t.animate({d:x})):(t.hide(),k&&(f.label=k=k.destroy())));h&&m(h.text)&&x&&x.length&&0<e.width&&0<e.height&&!x.isFlat?(h=y({align:c&&
p&&"center",x:c?!p&&4:10,verticalAlign:!c&&p&&"middle",y:c?p?16:10:p?6:-4,rotation:c&&!p&&90},h),this.renderLabel(h,x,p,n)):k&&k.hide();return f},renderLabel:function(a,e,c,l){var f=this.label,k=this.axis.chart.renderer;f||(f={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+(c?"band":"line")+"-label "+(a.className||"")},f.zIndex=l,this.label=f=k.text(a.text,0,0,a.useHTML).attr(f).add(),f.css(a.style));l=e.xBounds||[e[1],e[4],c?e[6]:e[1]];e=e.yBounds||[e[2],e[5],c?e[7]:e[2]];
c=E(l);k=E(e);f.align(a,!1,{x:c,y:k,width:D(l)-c,height:D(e)-k});f.show()},destroy:function(){r(this.axis.plotLinesAndBands,this);delete this.axis;h(this)}};a.extend(C.prototype,{getPlotBandPath:function(a,e){var c=this.getPlotLinePath(e,null,null,!0),l=this.getPlotLinePath(a,null,null,!0),f=[],k=this.horiz,d=1,b;a=a<this.min&&e<this.min||a>this.max&&e>this.max;if(l&&c)for(a&&(b=l.toString()===c.toString(),d=0),a=0;a<l.length;a+=6)k&&c[a+1]===l[a+1]?(c[a+1]+=d,c[a+4]+=d):k||c[a+2]!==l[a+2]||(c[a+
2]+=d,c[a+5]+=d),f.push("M",l[a+1],l[a+2],"L",l[a+4],l[a+5],c[a+4],c[a+5],c[a+1],c[a+2],"z"),f.isFlat=b;return f},addPlotBand:function(a){return this.addPlotBandOrLine(a,"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,"plotLines")},addPlotBandOrLine:function(f,e){var c=(new a.PlotLineOrBand(this,f)).render(),l=this.userOptions;c&&(e&&(l[e]=l[e]||[],l[e].push(f)),this.plotLinesAndBands.push(c));return c},removePlotBandOrLine:function(a){for(var e=this.plotLinesAndBands,c=this.options,
l=this.userOptions,h=e.length;h--;)e[h].id===a&&e[h].destroy();f([c.plotLines||[],l.plotLines||[],c.plotBands||[],l.plotBands||[]],function(c){for(h=c.length;h--;)c[h].id===a&&r(c,c[h])})},removePlotBand:function(a){this.removePlotBandOrLine(a)},removePlotLine:function(a){this.removePlotBandOrLine(a)}})})(K,V);(function(a){var C=a.doc,D=a.each,E=a.extend,m=a.format,h=a.isNumber,f=a.map,r=a.merge,y=a.pick,q=a.splat,w=a.syncTimeout,e=a.timeUnits;a.Tooltip=function(){this.init.apply(this,arguments)};
a.Tooltip.prototype={init:function(a,e){this.chart=a;this.options=e;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=e.split&&!a.inverted;this.shared=e.shared||this.split;this.outside=e.outside&&!this.split},cleanSplit:function(a){D(this.chart.series,function(c){var e=c&&c.tt;e&&(!e.isActive||a?c.tt=e.destroy():e.isActive=!1)})},getLabel:function(){var c=this.chart.renderer,e=this.options,f;this.label||(this.outside&&(this.container=f=a.doc.createElement("div"),f.className="highcharts-tooltip-container",
a.css(f,{position:"absolute",top:"1px",pointerEvents:e.style&&e.style.pointerEvents}),a.doc.body.appendChild(f),this.renderer=c=new a.Renderer(f,0,0)),this.split?this.label=c.g("tooltip"):(this.label=c.label("",0,0,e.shape||"callout",null,null,e.useHTML,null,"tooltip").attr({padding:e.padding,r:e.borderRadius}),this.label.attr({fill:e.backgroundColor,"stroke-width":e.borderWidth}).css(e.style).shadow(e.shadow)),this.outside&&(this.label.attr({x:this.distance,y:this.distance}),this.label.xSetter=function(a){f.style.left=
a+"px"},this.label.ySetter=function(a){f.style.top=a+"px"}),this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();r(!0,this.chart.options.tooltip.userOptions,a);this.init(this.chart,r(!0,this.options,a))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());this.renderer&&(this.renderer=this.renderer.destroy(),a.discardElement(this.container));a.clearTimeout(this.hideTimer);
a.clearTimeout(this.tooltipTimeout)},move:function(c,e,f,k){var d=this,b=d.now,u=!1!==d.options.animation&&!d.isHidden&&(1<Math.abs(c-b.x)||1<Math.abs(e-b.y)),p=d.followPointer||1<d.len;E(b,{x:u?(2*b.x+c)/3:c,y:u?(b.y+e)/2:e,anchorX:p?void 0:u?(2*b.anchorX+f)/3:f,anchorY:p?void 0:u?(b.anchorY+k)/2:k});d.getLabel().attr(b);u&&(a.clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){d&&d.move(c,e,f,k)},32))},hide:function(c){var e=this;a.clearTimeout(this.hideTimer);c=y(c,this.options.hideDelay,
500);this.isHidden||(this.hideTimer=w(function(){e.getLabel()[c?"fadeOut":"hide"]();e.isHidden=!0},c))},getAnchor:function(a,e){var c=this.chart,k=c.pointer,d=c.inverted,b=c.plotTop,u=c.plotLeft,p=0,l=0,t,h;a=q(a);this.followPointer&&e||k.followTouchMove&&e&&"touchmove"===e.type?(void 0===e.chartX&&(e=k.normalize(e)),a=[e.chartX-c.plotLeft,e.chartY-b]):a[0].tooltipPos?a=a[0].tooltipPos:(D(a,function(a){t=a.series.yAxis;h=a.series.xAxis;p+=a.plotX+(!d&&h?h.left-u:0);l+=(a.plotLow?(a.plotLow+a.plotHigh)/
2:a.plotY)+(!d&&t?t.top-b:0)}),p/=a.length,l/=a.length,a=[d?c.plotWidth-l:p,this.shared&&!d&&1<a.length&&e?e.chartY-b:d?c.plotHeight-p:l]);return f(a,Math.round)},getPosition:function(a,e,f){var c=this.chart,d=this.distance,b={},u=c.inverted&&f.h||0,p,l=this.outside,t=l?C.documentElement.clientWidth-2*d:c.chartWidth,h=l?Math.max(C.body.scrollHeight,C.documentElement.scrollHeight,C.body.offsetHeight,C.documentElement.offsetHeight,C.documentElement.clientHeight):c.chartHeight,x=c.pointer.chartPosition,
z=["y",h,e,(l?x.top-d:0)+f.plotY+c.plotTop,l?0:c.plotTop,l?h:c.plotTop+c.plotHeight],n=["x",t,a,(l?x.left-d:0)+f.plotX+c.plotLeft,l?0:c.plotLeft,l?t:c.plotLeft+c.plotWidth],G=!this.followPointer&&y(f.ttBelow,!c.inverted===!!f.negative),B=function(a,c,g,k,n,e){var p=g<k-d,f=k+d+g<c,B=k-d-g;k+=d;if(G&&f)b[a]=k;else if(!G&&p)b[a]=B;else if(p)b[a]=Math.min(e-g,0>B-u?B:B-u);else if(f)b[a]=Math.max(n,k+u+g>c?k:k+u);else return!1},q=function(a,c,g,k){var n;k<d||k>c-d?n=!1:b[a]=k<g/2?1:k>c-g/2?c-g-2:k-g/
2;return n},F=function(a){var b=z;z=n;n=b;p=a},g=function(){!1!==B.apply(0,z)?!1!==q.apply(0,n)||p||(F(!0),g()):p?b.x=b.y=0:(F(!0),g())};(c.inverted||1<this.len)&&F();g();return b},defaultFormatter:function(a){var c=this.points||q(this),e;e=[a.tooltipFooterHeaderFormatter(c[0])];e=e.concat(a.bodyFormatter(c));e.push(a.tooltipFooterHeaderFormatter(c[0],!0));return e},refresh:function(c,e){var f,k=this.options,d,b=c,u,p={},l=[];f=k.formatter||this.defaultFormatter;var p=this.shared,t;k.enabled&&(a.clearTimeout(this.hideTimer),
this.followPointer=q(b)[0].series.tooltipOptions.followPointer,u=this.getAnchor(b,e),e=u[0],d=u[1],!p||b.series&&b.series.noSharedTooltip?p=b.getLabelConfig():(D(b,function(a){a.setState("hover");l.push(a.getLabelConfig())}),p={x:b[0].category,y:b[0].y},p.points=l,b=b[0]),this.len=l.length,p=f.call(p,this),t=b.series,this.distance=y(t.tooltipOptions.distance,16),!1===p?this.hide():(f=this.getLabel(),this.isHidden&&f.attr({opacity:1}).show(),this.split?this.renderSplit(p,q(c)):(k.style.width||f.css({width:this.chart.spacingBox.width}),
f.attr({text:p&&p.join?p.join(""):p}),f.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+y(b.colorIndex,t.colorIndex)),f.attr({stroke:k.borderColor||b.color||t.color||"#666666"}),this.updatePosition({plotX:e,plotY:d,negative:b.negative,ttBelow:b.ttBelow,h:u[2]||0})),this.isHidden=!1))},renderSplit:function(c,e){var f=this,k=[],d=this.chart,b=d.renderer,u=!0,p=this.options,l=0,t=this.getLabel();a.isString(c)&&(c=[!1,c]);D(c.slice(0,e.length+1),function(a,c){if(!1!==a){c=e[c-1]||
{isHeader:!0,plotX:e[0].plotX};var h=c.series||f,n=h.tt,G=c.series||{},B="highcharts-color-"+y(c.colorIndex,G.colorIndex,"none");n||(h.tt=n=b.label(null,null,null,"callout",null,null,p.useHTML).addClass("highcharts-tooltip-box "+B).attr({padding:p.padding,r:p.borderRadius,fill:p.backgroundColor,stroke:p.borderColor||c.color||G.color||"#333333","stroke-width":p.borderWidth}).add(t));n.isActive=!0;n.attr({text:a});n.css(p.style).shadow(p.shadow);a=n.getBBox();G=a.width+n.strokeWidth();c.isHeader?(l=
a.height,G=Math.max(0,Math.min(c.plotX+d.plotLeft-G/2,d.chartWidth-G))):G=c.plotX+d.plotLeft-y(p.distance,16)-G;0>G&&(u=!1);a=(c.series&&c.series.yAxis&&c.series.yAxis.pos)+(c.plotY||0);a-=d.plotTop;k.push({target:c.isHeader?d.plotHeight+l:a,rank:c.isHeader?1:0,size:h.tt.getBBox().height+1,point:c,x:G,tt:n})}});this.cleanSplit();a.distribute(k,d.plotHeight+l);D(k,function(a){var b=a.point,c=b.series;a.tt.attr({visibility:void 0===a.pos?"hidden":"inherit",x:u||b.isHeader?a.x:b.plotX+d.plotLeft+y(p.distance,
16),y:a.pos+d.plotTop,anchorX:b.isHeader?b.plotX+d.plotLeft:b.plotX+c.xAxis.pos,anchorY:b.isHeader?a.pos+d.plotTop-15:b.plotY+c.yAxis.pos})})},updatePosition:function(a){var c=this.chart,e=this.getLabel(),k=(this.options.positioner||this.getPosition).call(this,e.width,e.height,a),d=a.plotX+c.plotLeft;a=a.plotY+c.plotTop;var b;this.outside&&(b=(this.options.borderWidth||0)+2*this.distance,this.renderer.setSize(e.width+b,e.height+b,!1),d+=c.pointer.chartPosition.left-k.x,a+=c.pointer.chartPosition.top-
k.y);this.move(Math.round(k.x),Math.round(k.y||0),d,a)},getDateFormat:function(a,f,h,k){var d=this.chart.time,b=d.dateFormat("%m-%d %H:%M:%S.%L",f),c,p,l={millisecond:15,second:12,minute:9,hour:6,day:3},t="millisecond";for(p in e){if(a===e.week&&+d.dateFormat("%w",f)===h&&"00:00:00.000"===b.substr(6)){p="week";break}if(e[p]>a){p=t;break}if(l[p]&&b.substr(l[p])!=="01-01 00:00:00.000".substr(l[p]))break;"week"!==p&&(t=p)}p&&(c=k[p]);return c},getXDateFormat:function(a,e,f){e=e.dateTimeLabelFormats;
var c=f&&f.closestPointRange;return(c?this.getDateFormat(c,a.x,f.options.startOfWeek,e):e.day)||e.year},tooltipFooterHeaderFormatter:function(a,e){e=e?"footer":"header";var c=a.series,k=c.tooltipOptions,d=k.xDateFormat,b=c.xAxis,f=b&&"datetime"===b.options.type&&h(a.key),p=k[e+"Format"];f&&!d&&(d=this.getXDateFormat(a,k,b));f&&d&&D(a.point&&a.point.tooltipDateKeys||["key"],function(a){p=p.replace("{point."+a+"}","{point."+a+":"+d+"}")});return m(p,{point:a,series:c},this.chart.time)},bodyFormatter:function(a){return f(a,
function(a){var c=a.series.tooltipOptions;return(c[(a.point.formatPrefix||"point")+"Formatter"]||a.point.tooltipFormatter).call(a.point,c[(a.point.formatPrefix||"point")+"Format"])})}}})(K);(function(a){var C=a.addEvent,D=a.attr,E=a.charts,m=a.color,h=a.css,f=a.defined,r=a.each,y=a.extend,q=a.find,w=a.fireEvent,e=a.isNumber,c=a.isObject,l=a.offset,z=a.pick,k=a.splat,d=a.Tooltip;a.Pointer=function(a,d){this.init(a,d)};a.Pointer.prototype={init:function(a,c){this.options=c;this.chart=a;this.runChartClick=
c.chart.events&&!!c.chart.events.click;this.pinchDown=[];this.lastValidTouch={};d&&(a.tooltip=new d(a,c.tooltip),this.followTouchMove=z(c.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var b=this.chart,d=b.options.chart,c=d.zoomType||"",b=b.inverted;/touch/.test(a.type)&&(c=z(d.pinchType,c));this.zoomX=a=/x/.test(c);this.zoomY=c=/y/.test(c);this.zoomHor=a&&!b||c&&b;this.zoomVert=c&&!b||a&&b;this.hasZoom=a||c},normalize:function(a,d){var b;b=a.touches?a.touches.length?a.touches.item(0):
a.changedTouches[0]:a;d||(this.chartPosition=d=l(this.chart.container));return y(a,{chartX:Math.round(b.pageX-d.left),chartY:Math.round(b.pageY-d.top)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};r(this.chart.axes,function(d){b[d.isXAxis?"xAxis":"yAxis"].push({axis:d,value:d.toValue(a[d.horiz?"chartX":"chartY"])})});return b},findNearestKDPoint:function(a,d,k){var b;r(a,function(a){var e=!(a.noSharedTooltip&&d)&&0>a.options.findNearestPointBy.indexOf("y");a=a.searchPoint(k,e);if((e=c(a,
!0))&&!(e=!c(b,!0)))var e=b.distX-a.distX,f=b.dist-a.dist,p=(a.series.group&&a.series.group.zIndex)-(b.series.group&&b.series.group.zIndex),e=0<(0!==e&&d?e:0!==f?f:0!==p?p:b.series.index>a.series.index?-1:1);e&&(b=a)});return b},getPointFromEvent:function(a){a=a.target;for(var b;a&&!b;)b=a.point,a=a.parentNode;return b},getChartCoordinatesFromPoint:function(a,d){var b=a.series,c=b.xAxis,b=b.yAxis,k=z(a.clientX,a.plotX),e=a.shapeArgs;if(c&&b)return d?{chartX:c.len+c.pos-k,chartY:b.len+b.pos-a.plotY}:
{chartX:k+c.pos,chartY:a.plotY+b.pos};if(e&&e.x&&e.y)return{chartX:e.x,chartY:e.y}},getHoverData:function(b,d,k,e,f,h,l){var p,n=[],u=l&&l.isBoosting;e=!(!e||!b);l=d&&!d.stickyTracking?[d]:a.grep(k,function(a){return a.visible&&!(!f&&a.directTouch)&&z(a.options.enableMouseTracking,!0)&&a.stickyTracking});d=(p=e?b:this.findNearestKDPoint(l,f,h))&&p.series;p&&(f&&!d.noSharedTooltip?(l=a.grep(k,function(a){return a.visible&&!(!f&&a.directTouch)&&z(a.options.enableMouseTracking,!0)&&!a.noSharedTooltip}),
r(l,function(a){var b=q(a.points,function(a){return a.x===p.x&&!a.isNull});c(b)&&(u&&(b=a.getPoint(b)),n.push(b))})):n.push(p));return{hoverPoint:p,hoverSeries:d,hoverPoints:n}},runPointActions:function(b,d){var c=this.chart,k=c.tooltip&&c.tooltip.options.enabled?c.tooltip:void 0,e=k?k.shared:!1,f=d||c.hoverPoint,l=f&&f.series||c.hoverSeries,l=this.getHoverData(f,l,c.series,!!d||l&&l.directTouch&&this.isDirectTouch,e,b,{isBoosting:c.isBoosting}),u,f=l.hoverPoint;u=l.hoverPoints;l=l.hoverSeries;d=
b&&"touchmove"===b.type?!0===this.followTouchMove:l&&l.tooltipOptions.followPointer;e=e&&l&&!l.noSharedTooltip;if(f&&(f!==c.hoverPoint||k&&k.isHidden)){r(c.hoverPoints||[],function(b){-1===a.inArray(b,u)&&b.setState()});r(u||[],function(a){a.setState("hover")});if(c.hoverSeries!==l)l.onMouseOver();c.hoverPoint&&c.hoverPoint.firePointEvent("mouseOut");if(!f.series)return;f.firePointEvent("mouseOver");c.hoverPoints=u;c.hoverPoint=f;k&&k.refresh(e?u:f,b)}else d&&k&&!k.isHidden&&(f=k.getAnchor([{}],b),
k.updatePosition({plotX:f[0],plotY:f[1]}));this.unDocMouseMove||(this.unDocMouseMove=C(c.container.ownerDocument,"mousemove",function(b){var d=E[a.hoverChartIndex];if(d)d.pointer.onDocumentMouseMove(b)}));r(c.axes,function(d){var c=z(d.crosshair.snap,!0),k=c?a.find(u,function(a){return a.series[d.coll]===d}):void 0;k||!c?d.drawCrosshair(b,k):d.hideCrosshair()})},reset:function(a,d){var b=this.chart,c=b.hoverSeries,e=b.hoverPoint,f=b.hoverPoints,l=b.tooltip,u=l&&l.shared?f:e;a&&u&&r(k(u),function(b){b.series.isCartesian&&
void 0===b.plotX&&(a=!1)});if(a)l&&u&&(l.refresh(u),l.shared&&f?r(f,function(a){a.setState(a.state,!0);a.series.xAxis.crosshair&&a.series.xAxis.drawCrosshair(null,a);a.series.yAxis.crosshair&&a.series.yAxis.drawCrosshair(null,a)}):e&&(e.setState(e.state,!0),r(b.axes,function(a){a.crosshair&&a.drawCrosshair(null,e)})));else{if(e)e.onMouseOut();f&&r(f,function(a){a.setState()});if(c)c.onMouseOut();l&&l.hide(d);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());r(b.axes,function(a){a.hideCrosshair()});
this.hoverX=b.hoverPoints=b.hoverPoint=null}},scaleGroups:function(a,d){var b=this.chart,c;r(b.series,function(k){c=a||k.getPlotBox();k.xAxis&&k.xAxis.zoomEnabled&&k.group&&(k.group.attr(c),k.markerGroup&&(k.markerGroup.attr(c),k.markerGroup.clip(d?b.clipRect:null)),k.dataLabelsGroup&&k.dataLabelsGroup.attr(c))});b.clipRect.attr(d||b.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=
this.chart,d=b.options.chart,c=a.chartX,k=a.chartY,e=this.zoomHor,f=this.zoomVert,l=b.plotLeft,n=b.plotTop,h=b.plotWidth,B=b.plotHeight,z,F=this.selectionMarker,g=this.mouseDownX,v=this.mouseDownY,q=d.panKey&&a[d.panKey+"Key"];F&&F.touch||(c<l?c=l:c>l+h&&(c=l+h),k<n?k=n:k>n+B&&(k=n+B),this.hasDragged=Math.sqrt(Math.pow(g-c,2)+Math.pow(v-k,2)),10<this.hasDragged&&(z=b.isInsidePlot(g-l,v-n),b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&z&&!q&&!F&&(this.selectionMarker=F=b.renderer.rect(l,n,e?1:h,
f?1:B,0).attr({fill:d.selectionMarkerFill||m("#335cad").setOpacity(.25).get(),"class":"highcharts-selection-marker",zIndex:7}).add()),F&&e&&(c-=g,F.attr({width:Math.abs(c),x:(0<c?0:c)+g})),F&&f&&(c=k-v,F.attr({height:Math.abs(c),y:(0<c?0:c)+v})),z&&!F&&d.panning&&b.pan(a,d.panning)))},drop:function(a){var b=this,d=this.chart,c=this.hasPinched;if(this.selectionMarker){var k={originalEvent:a,xAxis:[],yAxis:[]},l=this.selectionMarker,x=l.attr?l.attr("x"):l.x,z=l.attr?l.attr("y"):l.y,n=l.attr?l.attr("width"):
l.width,G=l.attr?l.attr("height"):l.height,B;if(this.hasDragged||c)r(d.axes,function(d){if(d.zoomEnabled&&f(d.min)&&(c||b[{xAxis:"zoomX",yAxis:"zoomY"}[d.coll]])){var e=d.horiz,g="touchend"===a.type?d.minPixelPadding:0,l=d.toValue((e?x:z)+g),e=d.toValue((e?x+n:z+G)-g);k[d.coll].push({axis:d,min:Math.min(l,e),max:Math.max(l,e)});B=!0}}),B&&w(d,"selection",k,function(a){d.zoom(y(a,c?{animation:!1}:null))});e(d.index)&&(this.selectionMarker=this.selectionMarker.destroy());c&&this.scaleGroups()}d&&e(d.index)&&
(h(d.container,{cursor:d._cursor}),d.cancelClick=10<this.hasDragged,d.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);2!==a.button&&(this.zoomOption(a),a.preventDefault&&a.preventDefault(),this.dragStart(a))},onDocumentMouseUp:function(b){E[a.hoverChartIndex]&&E[a.hoverChartIndex].pointer.drop(b)},onDocumentMouseMove:function(a){var b=this.chart,d=this.chartPosition;a=this.normalize(a,d);!d||this.inClass(a.target,"highcharts-tracker")||
b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(b){var d=E[a.hoverChartIndex];d&&(b.relatedTarget||b.toElement)&&(d.pointer.reset(),d.pointer.chartPosition=null)},onContainerMouseMove:function(b){var d=this.chart;f(a.hoverChartIndex)&&E[a.hoverChartIndex]&&E[a.hoverChartIndex].mouseIsDown||(a.hoverChartIndex=d.index);b=this.normalize(b);b.returnValue=!1;"mousedown"===d.mouseIsDown&&this.drag(b);!this.inClass(b.target,"highcharts-tracker")&&!d.isInsidePlot(b.chartX-
d.plotLeft,b.chartY-d.plotTop)||d.openMenu||this.runPointActions(b)},inClass:function(a,d){for(var b;a;){if(b=D(a,"class")){if(-1!==b.indexOf(d))return!0;if(-1!==b.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!b||!a||b.stickyTracking||this.inClass(a,"highcharts-tooltip")||this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},
onContainerClick:function(a){var b=this.chart,d=b.hoverPoint,c=b.plotLeft,k=b.plotTop;a=this.normalize(a);b.cancelClick||(d&&this.inClass(a.target,"highcharts-tracker")?(w(d.series,"click",y(a,{point:d})),b.hoverPoint&&d.firePointEvent("click",a)):(y(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-c,a.chartY-k)&&w(b,"click",a)))},setDOMEvents:function(){var b=this,d=b.chart.container,c=d.ownerDocument;d.onmousedown=function(a){b.onContainerMouseDown(a)};d.onmousemove=function(a){b.onContainerMouseMove(a)};
d.onclick=function(a){b.onContainerClick(a)};this.unbindContainerMouseLeave=C(d,"mouseleave",b.onContainerMouseLeave);a.unbindDocumentMouseUp||(a.unbindDocumentMouseUp=C(c,"mouseup",b.onDocumentMouseUp));a.hasTouch&&(d.ontouchstart=function(a){b.onContainerTouchStart(a)},d.ontouchmove=function(a){b.onContainerTouchMove(a)},a.unbindDocumentTouchEnd||(a.unbindDocumentTouchEnd=C(c,"touchend",b.onDocumentTouchEnd)))},destroy:function(){var b=this;b.unDocMouseMove&&b.unDocMouseMove();this.unbindContainerMouseLeave();
a.chartCount||(a.unbindDocumentMouseUp&&(a.unbindDocumentMouseUp=a.unbindDocumentMouseUp()),a.unbindDocumentTouchEnd&&(a.unbindDocumentTouchEnd=a.unbindDocumentTouchEnd()));clearInterval(b.tooltipTimeout);a.objectEach(b,function(a,d){b[d]=null})}}})(K);(function(a){var C=a.charts,D=a.each,E=a.extend,m=a.map,h=a.noop,f=a.pick;E(a.Pointer.prototype,{pinchTranslate:function(a,f,h,m,e,c){this.zoomHor&&this.pinchTranslateDirection(!0,a,f,h,m,e,c);this.zoomVert&&this.pinchTranslateDirection(!1,a,f,h,m,
e,c)},pinchTranslateDirection:function(a,f,h,m,e,c,l,z){var k=this.chart,d=a?"x":"y",b=a?"X":"Y",u="chart"+b,p=a?"width":"height",q=k["plot"+(a?"Left":"Top")],t,r,x=z||1,y=k.inverted,n=k.bounds[a?"h":"v"],G=1===f.length,B=f[0][u],M=h[0][u],F=!G&&f[1][u],g=!G&&h[1][u],v;h=function(){!G&&20<Math.abs(B-F)&&(x=z||Math.abs(M-g)/Math.abs(B-F));r=(q-M)/x+B;t=k["plot"+(a?"Width":"Height")]/x};h();f=r;f<n.min?(f=n.min,v=!0):f+t>n.max&&(f=n.max-t,v=!0);v?(M-=.8*(M-l[d][0]),G||(g-=.8*(g-l[d][1])),h()):l[d]=
[M,g];y||(c[d]=r-q,c[p]=t);c=y?1/x:x;e[p]=t;e[d]=f;m[y?a?"scaleY":"scaleX":"scale"+b]=x;m["translate"+b]=c*q+(M-c*B)},pinch:function(a){var r=this,q=r.chart,w=r.pinchDown,e=a.touches,c=e.length,l=r.lastValidTouch,z=r.hasZoom,k=r.selectionMarker,d={},b=1===c&&(r.inClass(a.target,"highcharts-tracker")&&q.runTrackerClick||r.runChartClick),u={};1<c&&(r.initiated=!0);z&&r.initiated&&!b&&a.preventDefault();m(e,function(a){return r.normalize(a)});"touchstart"===a.type?(D(e,function(a,b){w[b]={chartX:a.chartX,
chartY:a.chartY}}),l.x=[w[0].chartX,w[1]&&w[1].chartX],l.y=[w[0].chartY,w[1]&&w[1].chartY],D(q.axes,function(a){if(a.zoomEnabled){var b=q.bounds[a.horiz?"h":"v"],d=a.minPixelPadding,c=a.toPixels(f(a.options.min,a.dataMin)),k=a.toPixels(f(a.options.max,a.dataMax)),e=Math.max(c,k);b.min=Math.min(a.pos,Math.min(c,k)-d);b.max=Math.max(a.pos+a.len,e+d)}}),r.res=!0):r.followTouchMove&&1===c?this.runPointActions(r.normalize(a)):w.length&&(k||(r.selectionMarker=k=E({destroy:h,touch:!0},q.plotBox)),r.pinchTranslate(w,
e,d,k,u,l),r.hasPinched=z,r.scaleGroups(d,u),r.res&&(r.res=!1,this.reset(!1,0)))},touch:function(h,m){var q=this.chart,r,e;if(q.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=q.index;1===h.touches.length?(h=this.normalize(h),(e=q.isInsidePlot(h.chartX-q.plotLeft,h.chartY-q.plotTop))&&!q.openMenu?(m&&this.runPointActions(h),"touchmove"===h.type&&(m=this.pinchDown,r=m[0]?4<=Math.sqrt(Math.pow(m[0].chartX-h.chartX,2)+Math.pow(m[0].chartY-h.chartY,2)):!1),f(r,
!0)&&this.pinch(h)):m&&this.reset()):2===h.touches.length&&this.pinch(h)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(f){C[a.hoverChartIndex]&&C[a.hoverChartIndex].pointer.drop(f)}})})(K);(function(a){var C=a.addEvent,D=a.charts,E=a.css,m=a.doc,h=a.extend,f=a.noop,r=a.Pointer,y=a.removeEvent,q=a.win,w=a.wrap;if(!a.hasTouch&&(q.PointerEvent||q.MSPointerEvent)){var e={},c=!!q.PointerEvent,l=function(){var c=
[];c.item=function(a){return this[a]};a.objectEach(e,function(a){c.push({pageX:a.pageX,pageY:a.pageY,target:a.target})});return c},z=function(c,d,b,e){"touch"!==c.pointerType&&c.pointerType!==c.MSPOINTER_TYPE_TOUCH||!D[a.hoverChartIndex]||(e(c),e=D[a.hoverChartIndex].pointer,e[d]({type:b,target:c.currentTarget,preventDefault:f,touches:l()}))};h(r.prototype,{onContainerPointerDown:function(a){z(a,"onContainerTouchStart","touchstart",function(a){e[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},
onContainerPointerMove:function(a){z(a,"onContainerTouchMove","touchmove",function(a){e[a.pointerId]={pageX:a.pageX,pageY:a.pageY};e[a.pointerId].target||(e[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){z(a,"onDocumentTouchEnd","touchend",function(a){delete e[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,c?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,c?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(m,c?
"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});w(r.prototype,"init",function(a,d,b){a.call(this,d,b);this.hasZoom&&E(d.container,{"-ms-touch-action":"none","touch-action":"none"})});w(r.prototype,"setDOMEvents",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(C)});w(r.prototype,"destroy",function(a){this.batchMSEvents(y);a.call(this)})}})(K);(function(a){var C=a.addEvent,D=a.css,E=a.discardElement,m=a.defined,h=a.each,f=a.fireEvent,r=a.isFirefox,y=a.marginNames,
q=a.merge,w=a.pick,e=a.setAnimation,c=a.stableSort,l=a.win,z=a.wrap;a.Legend=function(a,d){this.init(a,d)};a.Legend.prototype={init:function(a,d){this.chart=a;this.setOptions(d);d.enabled&&(this.render(),C(this.chart,"endResize",function(){this.legend.positionCheckboxes()}),this.proximate?this.unchartrender=C(this.chart,"render",function(){this.legend.proximatePositions();this.legend.positionItems()}):this.unchartrender&&this.unchartrender())},setOptions:function(a){var d=w(a.padding,8);this.options=
a;this.itemStyle=a.itemStyle;this.itemHiddenStyle=q(this.itemStyle,a.itemHiddenStyle);this.itemMarginTop=a.itemMarginTop||0;this.padding=d;this.initialItemY=d-5;this.symbolWidth=w(a.symbolWidth,16);this.pages=[];this.proximate="proximate"===a.layout&&!this.chart.inverted},update:function(a,d){var b=this.chart;this.setOptions(q(!0,this.options,a));this.destroy();b.isDirtyLegend=b.isDirtyBox=!0;w(d,!0)&&b.redraw();f(this,"afterUpdate")},colorizeItem:function(a,d){a.legendGroup[d?"removeClass":"addClass"]("highcharts-legend-item-hidden");
var b=this.options,c=a.legendItem,k=a.legendLine,e=a.legendSymbol,l=this.itemHiddenStyle.color,b=d?b.itemStyle.color:l,h=d?a.color||l:l,x=a.options&&a.options.marker,z={fill:h};c&&c.css({fill:b,color:b});k&&k.attr({stroke:h});e&&(x&&e.isMarker&&(z=a.pointAttribs(),d||(z.stroke=z.fill=l)),e.attr(z));f(this,"afterColorizeItem",{item:a,visible:d})},positionItems:function(){h(this.allItems,this.positionItem,this);this.chart.isResizing||this.positionCheckboxes()},positionItem:function(a){var d=this.options,
b=d.symbolPadding,d=!d.rtl,c=a._legendItemPos,k=c[0],c=c[1],e=a.checkbox;if((a=a.legendGroup)&&a.element)a[m(a.translateY)?"animate":"attr"]({translateX:d?k:this.legendWidth-k-2*b-4,translateY:c});e&&(e.x=k,e.y=c)},destroyItem:function(a){var d=a.checkbox;h(["legendItem","legendLine","legendSymbol","legendGroup"],function(b){a[b]&&(a[b]=a[b].destroy())});d&&E(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}h(this.getAllItems(),function(c){h(["legendItem","legendGroup"],
a,c)});h("clipRect up down pager nav box title group".split(" "),a,this);this.display=null},positionCheckboxes:function(){var a=this.group&&this.group.alignAttr,c,b=this.clipHeight||this.legendHeight,e=this.titleHeight;a&&(c=a.translateY,h(this.allItems,function(d){var k=d.checkbox,f;k&&(f=c+e+k.y+(this.scrollOffset||0)+3,D(k,{left:a.translateX+d.checkboxOffset+k.x-20+"px",top:f+"px",display:f>c-6&&f<c+b-6?"":"none"}))},this))},renderTitle:function(){var a=this.options,c=this.padding,b=a.title,e=
0;b.text&&(this.title||(this.title=this.chart.renderer.label(b.text,c-3,c-4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}).css(b.style).add(this.group)),a=this.title.getBBox(),e=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:e}));this.titleHeight=e},setText:function(c){var d=this.options;c.legendItem.attr({text:d.labelFormat?a.format(d.labelFormat,c,this.chart.time):d.labelFormatter.call(c)})},renderItem:function(a){var c=this.chart,b=c.renderer,e=this.options,
k=this.symbolWidth,f=e.symbolPadding,l=this.itemStyle,h=this.itemHiddenStyle,x="horizontal"===e.layout?w(e.itemDistance,20):0,z=!e.rtl,n=a.legendItem,G=!a.series,B=!G&&a.series.drawLegendSymbol?a.series:a,m=B.options,m=this.createCheckboxForItem&&m&&m.showCheckbox,x=k+f+x+(m?20:0),F=e.useHTML,g=a.options.className;n||(a.legendGroup=b.g("legend-item").addClass("highcharts-"+B.type+"-series highcharts-color-"+a.colorIndex+(g?" "+g:"")+(G?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),
a.legendItem=n=b.text("",z?k+f:-f,this.baseline||0,F).css(q(a.visible?l:h)).attr({align:z?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(k=l.fontSize,this.fontMetrics=b.fontMetrics(k,n),this.baseline=this.fontMetrics.f+3+this.itemMarginTop,n.attr("y",this.baseline)),this.symbolHeight=e.symbolHeight||this.fontMetrics.f,B.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,n,F),m&&this.createCheckboxForItem(a));this.colorizeItem(a,a.visible);l.width||n.css({width:(e.itemWidth||
e.width||c.spacingBox.width)-x});this.setText(a);c=n.getBBox();a.itemWidth=a.checkboxOffset=e.itemWidth||a.legendItemWidth||c.width+x;this.maxItemWidth=Math.max(this.maxItemWidth,a.itemWidth);this.totalItemWidth+=a.itemWidth;this.itemHeight=a.itemHeight=Math.round(a.legendItemHeight||c.height||this.symbolHeight)},layoutItem:function(a){var c=this.options,b=this.padding,e="horizontal"===c.layout,k=a.itemHeight,f=c.itemMarginBottom||0,l=this.itemMarginTop,h=e?w(c.itemDistance,20):0,x=c.width,z=x||this.chart.spacingBox.width-
2*b-c.x,c=c.alignColumns&&this.totalItemWidth>z?this.maxItemWidth:a.itemWidth;e&&this.itemX-b+c>z&&(this.itemX=b,this.itemY+=l+this.lastLineHeight+f,this.lastLineHeight=0);this.lastItemY=l+this.itemY+f;this.lastLineHeight=Math.max(k,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];e?this.itemX+=c:(this.itemY+=l+k+f,this.lastLineHeight=k);this.offsetWidth=x||Math.max((e?this.itemX-b-(a.checkbox?0:h):c)+b,this.offsetWidth)},getAllItems:function(){var a=[];h(this.chart.series,function(c){var b=
c&&c.options;c&&w(b.showInLegend,m(b.linkedTo)?!1:void 0,!0)&&(a=a.concat(c.legendItems||("point"===b.legendType?c.data:c)))});f(this,"afterGetAllItems",{allItems:a});return a},getAlignment:function(){var a=this.options;return this.proximate?a.align.charAt(0)+"tv":a.floating?"":a.align.charAt(0)+a.verticalAlign.charAt(0)+a.layout.charAt(0)},adjustMargins:function(a,c){var b=this.chart,d=this.options,e=this.getAlignment();e&&h([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/],function(k,
f){k.test(e)&&!m(a[f])&&(b[y[f]]=Math.max(b[y[f]],b.legend[(f+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][f]*d[f%2?"x":"y"]+w(d.margin,12)+c[f]+(0===f&&void 0!==b.options.title.margin?b.titleOffset+b.options.title.margin:0)))})},proximatePositions:function(){var c=this.chart,d=[],b="left"===this.options.align;h(this.allItems,function(e){var k,f;k=b;e.xAxis&&e.points&&(e.xAxis.options.reversed&&(k=!k),k=a.find(k?e.points:e.points.slice(0).reverse(),function(b){return a.isNumber(b.plotY)}),f=e.legendGroup.getBBox().height,
d.push({target:e.visible?(k?k.plotY:e.xAxis.height)-.3*f:c.plotHeight,size:f,item:e}))},this);a.distribute(d,c.plotHeight);h(d,function(a){a.item._legendItemPos[1]=c.plotTop-c.spacing[0]+a.pos})},render:function(){var a=this.chart,d=a.renderer,b=this.group,e,f,l,t=this.box,z=this.options,x=this.padding;this.itemX=x;this.itemY=this.initialItemY;this.lastItemY=this.offsetWidth=0;b||(this.group=b=d.g("legend").attr({zIndex:7}).add(),this.contentGroup=d.g().attr({zIndex:1}).add(b),this.scrollGroup=d.g().add(this.contentGroup));
this.renderTitle();e=this.getAllItems();c(e,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});z.reversed&&e.reverse();this.allItems=e;this.display=f=!!e.length;this.itemHeight=this.totalItemWidth=this.maxItemWidth=this.lastLineHeight=0;h(e,this.renderItem,this);h(e,this.layoutItem,this);e=(z.width||this.offsetWidth)+x;l=this.lastItemY+this.lastLineHeight+this.titleHeight;l=this.handleOverflow(l);l+=x;t||(this.box=t=d.rect().addClass("highcharts-legend-box").attr({r:z.borderRadius}).add(b),
t.isNew=!0);t.attr({stroke:z.borderColor,"stroke-width":z.borderWidth||0,fill:z.backgroundColor||"none"}).shadow(z.shadow);0<e&&0<l&&(t[t.isNew?"attr":"animate"](t.crisp.call({},{x:0,y:0,width:e,height:l},t.strokeWidth())),t.isNew=!1);t[f?"show":"hide"]();this.legendWidth=e;this.legendHeight=l;f&&(d=a.spacingBox,/(lth|ct|rth)/.test(this.getAlignment())&&(d=q(d,{y:d.y+a.titleOffset+a.options.title.margin})),b.align(q(z,{width:e,height:l,verticalAlign:this.proximate?"top":z.verticalAlign}),!0,d));this.proximate||
this.positionItems()},handleOverflow:function(a){var c=this,b=this.chart,e=b.renderer,k=this.options,f=k.y,l=this.padding,b=b.spacingBox.height+("top"===k.verticalAlign?-f:f)-l,f=k.maxHeight,z,x=this.clipRect,m=k.navigation,n=w(m.animation,!0),G=m.arrowSize||12,B=this.nav,q=this.pages,F,g=this.allItems,v=function(a){"number"===typeof a?x.attr({height:a}):x&&(c.clipRect=x.destroy(),c.contentGroup.clip());c.contentGroup.div&&(c.contentGroup.div.style.clip=a?"rect("+l+"px,9999px,"+(l+a)+"px,0)":"auto")};
"horizontal"!==k.layout||"middle"===k.verticalAlign||k.floating||(b/=2);f&&(b=Math.min(b,f));q.length=0;a>b&&!1!==m.enabled?(this.clipHeight=z=Math.max(b-20-this.titleHeight-l,0),this.currentPage=w(this.currentPage,1),this.fullHeight=a,h(g,function(a,b){var c=a._legendItemPos[1],d=Math.round(a.legendItem.getBBox().height),e=q.length;if(!e||c-q[e-1]>z&&(F||c)!==q[e-1])q.push(F||c),e++;a.pageIx=e-1;F&&(g[b-1].pageIx=e-1);b===g.length-1&&c+d-q[e-1]>z&&(q.push(c),a.pageIx=e);c!==F&&(F=c)}),x||(x=c.clipRect=
e.clipRect(0,l,9999,0),c.contentGroup.clip(x)),v(z),B||(this.nav=B=e.g().attr({zIndex:1}).add(this.group),this.up=e.symbol("triangle",0,0,G,G).on("click",function(){c.scroll(-1,n)}).add(B),this.pager=e.text("",15,10).addClass("highcharts-legend-navigation").css(m.style).add(B),this.down=e.symbol("triangle-down",0,0,G,G).on("click",function(){c.scroll(1,n)}).add(B)),c.scroll(0),a=b):B&&(v(),this.nav=B.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a},scroll:function(a,c){var b=
this.pages,d=b.length;a=this.currentPage+a;var k=this.clipHeight,f=this.options.navigation,l=this.pager,h=this.padding;a>d&&(a=d);0<a&&(void 0!==c&&e(c,this.chart),this.nav.attr({translateX:h,translateY:k+this.padding+7+this.titleHeight,visibility:"visible"}),this.up.attr({"class":1===a?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),l.attr({text:a+"/"+d}),this.down.attr({x:18+this.pager.getBBox().width,"class":a===d?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),
this.up.attr({fill:1===a?f.inactiveColor:f.activeColor}).css({cursor:1===a?"default":"pointer"}),this.down.attr({fill:a===d?f.inactiveColor:f.activeColor}).css({cursor:a===d?"default":"pointer"}),this.scrollOffset=-b[a-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=a,this.positionCheckboxes())}};a.LegendSymbolMixin={drawRectangle:function(a,c){var b=a.symbolHeight,d=a.options.squareSymbol;c.legendSymbol=this.chart.renderer.rect(d?(a.symbolWidth-b)/2:
0,a.baseline-b+1,d?b:a.symbolWidth,b,w(a.options.symbolRadius,b/2)).addClass("highcharts-point").attr({zIndex:3}).add(c.legendGroup)},drawLineMarker:function(a){var c=this.options,b=c.marker,e=a.symbolWidth,k=a.symbolHeight,f=k/2,l=this.chart.renderer,h=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);var z;z={"stroke-width":c.lineWidth||0};c.dashStyle&&(z.dashstyle=c.dashStyle);this.legendLine=l.path(["M",0,a,"L",e,a]).addClass("highcharts-graph").attr(z).add(h);b&&!1!==b.enabled&&e&&
(c=Math.min(w(b.radius,f),f),0===this.symbol.indexOf("url")&&(b=q(b,{width:k,height:k}),c=0),this.legendSymbol=b=l.symbol(this.symbol,e/2-c,a-c,2*c,2*c,b).addClass("highcharts-point").add(h),b.isMarker=!0)}};(/Trident\/7\.0/.test(l.navigator.userAgent)||r)&&z(a.Legend.prototype,"positionItem",function(a,c){var b=this,d=function(){c._legendItemPos&&a.call(b,c)};d();setTimeout(d)})})(K);(function(a){var C=a.addEvent,D=a.animate,E=a.animObject,m=a.attr,h=a.doc,f=a.Axis,r=a.createElement,y=a.defaultOptions,
q=a.discardElement,w=a.charts,e=a.css,c=a.defined,l=a.each,z=a.extend,k=a.find,d=a.fireEvent,b=a.grep,u=a.isNumber,p=a.isObject,H=a.isString,t=a.Legend,L=a.marginNames,x=a.merge,I=a.objectEach,n=a.Pointer,G=a.pick,B=a.pInt,M=a.removeEvent,F=a.seriesTypes,g=a.splat,v=a.syncTimeout,P=a.win,Q=a.Chart=function(){this.getArgs.apply(this,arguments)};a.chart=function(a,b,c){return new Q(a,b,c)};z(Q.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(H(a[0])||a[0].nodeName)this.renderTo=
a.shift();this.init(a[0],a[1])},init:function(b,c){var g,e,k=b.series,f=b.plotOptions||{};d(this,"init",{args:arguments},function(){b.series=null;g=x(y,b);for(e in g.plotOptions)g.plotOptions[e].tooltip=f[e]&&x(f[e].tooltip)||void 0;g.tooltip.userOptions=b.chart&&b.chart.forExport&&b.tooltip.userOptions||b.tooltip;g.series=b.series=k;this.userOptions=b;var n=g.chart,l=n.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.labelCollectors=[];this.callback=c;this.isResizing=0;this.options=
g;this.axes=[];this.series=[];this.time=b.time&&a.keys(b.time).length?new a.Time(b.time):a.time;this.hasCartesianSeries=n.showAxes;var h=this;h.index=w.length;w.push(h);a.chartCount++;l&&I(l,function(a,b){C(h,b,a)});h.xAxis=[];h.yAxis=[];h.pointCount=h.colorCounter=h.symbolCounter=0;d(h,"afterInit");h.firstRender()})},initSeries:function(b){var c=this.options.chart;(c=F[b.type||c.type||c.defaultSeriesType])||a.error(17,!0);c=new c;c.init(this,b);return c},orderSeries:function(a){var b=this.series;
for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].getName())},isInsidePlot:function(a,b,c){var d=c?b:a;a=c?a:b;return 0<=d&&d<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(b){d(this,"beforeRedraw");var c=this.axes,g=this.series,e=this.pointer,f=this.legend,k=this.isDirtyLegend,n,h,B=this.hasCartesianSeries,G=this.isDirtyBox,v,p=this.renderer,t=p.isHidden(),x=[];this.setResponsive&&this.setResponsive(!1);a.setAnimation(b,this);t&&this.temporaryDisplay();this.layOutTitles();
for(b=g.length;b--;)if(v=g[b],v.options.stacking&&(n=!0,v.isDirty)){h=!0;break}if(h)for(b=g.length;b--;)v=g[b],v.options.stacking&&(v.isDirty=!0);l(g,function(a){a.isDirty&&"point"===a.options.legendType&&(a.updateTotals&&a.updateTotals(),k=!0);a.isDirtyData&&d(a,"updatedData")});k&&f.options.enabled&&(f.render(),this.isDirtyLegend=!1);n&&this.getStacks();B&&l(c,function(a){a.updateNames();a.setScale()});this.getMargins();B&&(l(c,function(a){a.isDirty&&(G=!0)}),l(c,function(a){var b=a.min+","+a.max;
a.extKey!==b&&(a.extKey=b,x.push(function(){d(a,"afterSetExtremes",z(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(G||n)&&a.redraw()}));G&&this.drawChartBox();d(this,"predraw");l(g,function(a){(G||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});e&&e.reset(!0);p.draw();d(this,"redraw");d(this,"render");t&&this.temporaryDisplay(!0);l(x,function(a){a.call()})},get:function(a){function b(b){return b.id===a||b.options&&b.options.id===a}var c,d=this.series,g;c=k(this.axes,b)||k(this.series,
b);for(g=0;!c&&g<d.length;g++)c=k(d[g].points||[],b);return c},getAxes:function(){var a=this,b=this.options,c=b.xAxis=g(b.xAxis||{}),b=b.yAxis=g(b.yAxis||{});d(this,"getAxes");l(c,function(a,b){a.index=b;a.isX=!0});l(b,function(a,b){a.index=b});c=c.concat(b);l(c,function(b){new f(a,b)});d(this,"afterGetAxes")},getSelectedPoints:function(){var a=[];l(this.series,function(c){a=a.concat(b(c.data||[],function(a){return a.selected}))});return a},getSelectedSeries:function(){return b(this.series,function(a){return a.selected})},
setTitle:function(a,b,c){var d=this,g=d.options,e;e=g.title=x({style:{color:"#333333",fontSize:g.isStock?"16px":"18px"}},g.title,a);g=g.subtitle=x({style:{color:"#666666"}},g.subtitle,b);l([["title",a,e],["subtitle",b,g]],function(a,b){var c=a[0],g=d[c],e=a[1];a=a[2];g&&e&&(d[c]=g=g.destroy());a&&!g&&(d[c]=d.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+c,zIndex:a.zIndex||4}).add(),d[c].update=function(a){d.setTitle(!b&&a,b&&a)},d[c].css(a.style))});d.layOutTitles(c)},
layOutTitles:function(a){var b=0,c,d=this.renderer,g=this.spacingBox;l(["title","subtitle"],function(a){var c=this[a],e=this.options[a];a="title"===a?-3:e.verticalAlign?0:b+2;var n;c&&(n=e.style.fontSize,n=d.fontMetrics(n,c).b,c.css({width:(e.width||g.width+e.widthAdjust)+"px"}).align(z({y:a+n},e),!1,"spacingBox"),e.floating||e.verticalAlign||(b=Math.ceil(b+c.getBBox(e.useHTML).height)))},this);c=this.titleOffset!==b;this.titleOffset=b;!this.isDirtyBox&&c&&(this.isDirtyBox=this.isDirtyLegend=c,this.hasRendered&&
G(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var b=this.options.chart,d=b.width,b=b.height,g=this.renderTo;c(d)||(this.containerWidth=a.getStyle(g,"width"));c(b)||(this.containerHeight=a.getStyle(g,"height"));this.chartWidth=Math.max(0,d||this.containerWidth||600);this.chartHeight=Math.max(0,a.relativeLength(b,this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))},temporaryDisplay:function(b){var c=this.renderTo;if(b)for(;c&&c.style;)c.hcOrigStyle&&(a.css(c,c.hcOrigStyle),
delete c.hcOrigStyle),c.hcOrigDetached&&(h.body.removeChild(c),c.hcOrigDetached=!1),c=c.parentNode;else for(;c&&c.style;){h.body.contains(c)||c.parentNode||(c.hcOrigDetached=!0,h.body.appendChild(c));if("none"===a.getStyle(c,"display",!1)||c.hcOricDetached)c.hcOrigStyle={display:c.style.display,height:c.style.height,overflow:c.style.overflow},b={display:"block",overflow:"hidden"},c!==this.renderTo&&(b.height=0),a.css(c,b),c.offsetWidth||c.style.setProperty("display","block","important");c=c.parentNode;
if(c===h.body)break}},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var b,c=this.options,g=c.chart,e,n;b=this.renderTo;var f=a.uniqueKey(),k;b||(this.renderTo=b=g.renderTo);H(b)&&(this.renderTo=b=h.getElementById(b));b||a.error(13,!0);e=B(m(b,"data-highcharts-chart"));u(e)&&w[e]&&w[e].hasRendered&&w[e].destroy();m(b,"data-highcharts-chart",this.index);b.innerHTML="";g.skipClone||b.offsetWidth||this.temporaryDisplay();this.getChartSize();
e=this.chartWidth;n=this.chartHeight;k=z({position:"relative",overflow:"hidden",width:e+"px",height:n+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},g.style);this.container=b=r("div",{id:f},k,b);this._cursor=b.style.cursor;this.renderer=new (a[g.renderer]||a.Renderer)(b,e,n,null,g.forExport,c.exporting&&c.exporting.allowHTML);this.setClassName(g.className);this.renderer.setStyle(g.style);this.renderer.chartIndex=this.index;d(this,"afterGetContainer")},
getMargins:function(a){var b=this.spacing,g=this.margin,e=this.titleOffset;this.resetMargins();e&&!c(g[0])&&(this.plotTop=Math.max(this.plotTop,e+this.options.title.margin+b[0]));this.legend&&this.legend.display&&this.legend.adjustMargins(g,b);d(this,"getMargins");a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],d=a.margin;a.hasCartesianSeries&&l(a.axes,function(a){a.visible&&a.getOffset()});l(L,function(g,e){c(d[e])||(a[g]+=b[e])});a.setChartSize()},reflow:function(b){var d=
this,g=d.options.chart,e=d.renderTo,n=c(g.width)&&c(g.height),k=g.width||a.getStyle(e,"width"),g=g.height||a.getStyle(e,"height"),e=b?b.target:P;if(!n&&!d.isPrinting&&k&&g&&(e===P||e===h)){if(k!==d.containerWidth||g!==d.containerHeight)a.clearTimeout(d.reflowTimeout),d.reflowTimeout=v(function(){d.container&&d.setSize(void 0,void 0,!1)},b?100:0);d.containerWidth=k;d.containerHeight=g}},setReflow:function(a){var b=this;!1===a||this.unbindReflow?!1===a&&this.unbindReflow&&(this.unbindReflow=this.unbindReflow()):
(this.unbindReflow=C(P,"resize",function(a){b.reflow(a)}),C(this,"destroy",this.unbindReflow))},setSize:function(b,c,g){var n=this,k=n.renderer;n.isResizing+=1;a.setAnimation(g,n);n.oldChartHeight=n.chartHeight;n.oldChartWidth=n.chartWidth;void 0!==b&&(n.options.chart.width=b);void 0!==c&&(n.options.chart.height=c);n.getChartSize();b=k.globalAnimation;(b?D:e)(n.container,{width:n.chartWidth+"px",height:n.chartHeight+"px"},b);n.setChartSize(!0);k.setSize(n.chartWidth,n.chartHeight,g);l(n.axes,function(a){a.isDirty=
!0;a.setScale()});n.isDirtyLegend=!0;n.isDirtyBox=!0;n.layOutTitles();n.getMargins();n.redraw(g);n.oldChartHeight=null;d(n,"resize");v(function(){n&&d(n,"endResize",null,function(){--n.isResizing})},E(b).duration)},setChartSize:function(a){var b=this.inverted,c=this.renderer,g=this.chartWidth,e=this.chartHeight,n=this.options.chart,k=this.spacing,f=this.clipOffset,h,B,G,v;this.plotLeft=h=Math.round(this.plotLeft);this.plotTop=B=Math.round(this.plotTop);this.plotWidth=G=Math.max(0,Math.round(g-h-this.marginRight));
this.plotHeight=v=Math.max(0,Math.round(e-B-this.marginBottom));this.plotSizeX=b?v:G;this.plotSizeY=b?G:v;this.plotBorderWidth=n.plotBorderWidth||0;this.spacingBox=c.spacingBox={x:k[3],y:k[0],width:g-k[3]-k[1],height:e-k[0]-k[2]};this.plotBox=c.plotBox={x:h,y:B,width:G,height:v};g=2*Math.floor(this.plotBorderWidth/2);b=Math.ceil(Math.max(g,f[3])/2);c=Math.ceil(Math.max(g,f[0])/2);this.clipBox={x:b,y:c,width:Math.floor(this.plotSizeX-Math.max(g,f[1])/2-b),height:Math.max(0,Math.floor(this.plotSizeY-
Math.max(g,f[2])/2-c))};a||l(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()});d(this,"afterSetChartSize",{skipAxes:a})},resetMargins:function(){var a=this,b=a.options.chart;l(["margin","spacing"],function(c){var d=b[c],g=p(d)?d:[d,d,d,d];l(["Top","Right","Bottom","Left"],function(d,e){a[c][e]=G(b[c+d],g[e])})});l(L,function(b,c){a[b]=G(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=this.chartWidth,
g=this.chartHeight,e=this.chartBackground,n=this.plotBackground,k=this.plotBorder,f,l=this.plotBGImage,h=a.backgroundColor,B=a.plotBackgroundColor,G=a.plotBackgroundImage,v,p=this.plotLeft,t=this.plotTop,z=this.plotWidth,x=this.plotHeight,F=this.plotBox,u=this.clipRect,m=this.clipBox,q="animate";e||(this.chartBackground=e=b.rect().addClass("highcharts-background").add(),q="attr");f=a.borderWidth||0;v=f+(a.shadow?8:0);h={fill:h||"none"};if(f||e["stroke-width"])h.stroke=a.borderColor,h["stroke-width"]=
f;e.attr(h).shadow(a.shadow);e[q]({x:v/2,y:v/2,width:c-v-f%2,height:g-v-f%2,r:a.borderRadius});q="animate";n||(q="attr",this.plotBackground=n=b.rect().addClass("highcharts-plot-background").add());n[q](F);n.attr({fill:B||"none"}).shadow(a.plotShadow);G&&(l?l.animate(F):this.plotBGImage=b.image(G,p,t,z,x).add());u?u.animate({width:m.width,height:m.height}):this.clipRect=b.clipRect(m);q="animate";k||(q="attr",this.plotBorder=k=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());k.attr({stroke:a.plotBorderColor,
"stroke-width":a.plotBorderWidth||0,fill:"none"});k[q](k.crisp({x:p,y:t,width:z,height:x},-k.strokeWidth()));this.isDirtyBox=!1;d(this,"afterDrawChartBox")},propFromSeries:function(){var a=this,b=a.options.chart,c,d=a.options.series,g,e;l(["inverted","angular","polar"],function(n){c=F[b.type||b.defaultSeriesType];e=b[n]||c&&c.prototype[n];for(g=d&&d.length;!e&&g--;)(c=F[d[g].type])&&c.prototype[n]&&(e=!0);a[n]=e})},linkSeries:function(){var a=this,b=a.series;l(b,function(a){a.linkedSeries.length=
0});l(b,function(b){var c=b.options.linkedTo;H(c)&&(c=":previous"===c?a.series[b.index-1]:a.get(c))&&c.linkedParent!==b&&(c.linkedSeries.push(b),b.linkedParent=c,b.visible=G(b.options.visible,c.options.visible,b.visible))});d(this,"afterLinkSeries")},renderSeries:function(){l(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;b.items&&l(b.items,function(c){var d=z(b.style,c.style),g=B(d.left)+a.plotLeft,e=B(d.top)+a.plotTop+12;delete d.left;delete d.top;
a.renderer.text(c.html,g,e).attr({zIndex:2}).css(d).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,d,g,e;this.setTitle();this.legend=new t(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;d=this.plotHeight=Math.max(this.plotHeight-21,0);l(a,function(a){a.setScale()});this.getAxisMargins();g=1.1<c/this.plotWidth;e=1.05<d/this.plotHeight;if(g||e)l(a,function(a){(a.horiz&&g||!a.horiz&&e)&&a.setTickInterval(!0)}),this.getMargins();
this.drawChartBox();this.hasCartesianSeries&&l(a,function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=this;a=x(!0,this.options.credits,a);a.enabled&&!this.credits&&(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&
(P.location.href=a.href)}).attr({align:a.position.align,zIndex:8}).css(a.style).add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var b=this,c=b.axes,g=b.series,e=b.container,n,k=e&&e.parentNode;d(b,"destroy");b.renderer.forExport?a.erase(w,b):w[b.index]=void 0;a.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");M(b);for(n=c.length;n--;)c[n]=c[n].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();
for(n=g.length;n--;)g[n]=g[n].destroy();l("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "),function(a){var c=b[a];c&&c.destroy&&(b[a]=c.destroy())});e&&(e.innerHTML="",M(e),k&&q(e));I(b,function(a,c){delete b[c]})},firstRender:function(){var a=this,b=a.options;if(!a.isReadyToRender||a.isReadyToRender()){a.getContainer();a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();
l(b.series||[],function(b){a.initSeries(b)});a.linkSeries();d(a,"beforeRender");n&&(a.pointer=new n(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();a.temporaryDisplay(!0)}},onload:function(){l([this.callback].concat(this.callbacks),function(a){a&&void 0!==this.index&&a.apply(this,[this])},this);d(this,"load");d(this,"render");c(this.index)&&this.setReflow(this.options.chart.reflow);this.onload=null}})})(K);(function(a){var C=a.addEvent,D=a.Chart,E=a.each;C(D,"afterSetChartSize",function(m){var h=
this.options.chart.scrollablePlotArea;(h=h&&h.minWidth)&&!this.renderer.forExport&&(this.scrollablePixels=h=Math.max(0,h-this.chartWidth))&&(this.plotWidth+=h,this.clipBox.width+=h,m.skipAxes||E(this.axes,function(f){1===f.side?f.getPlotLinePath=function(){var h=this.right,m;this.right=h-f.chart.scrollablePixels;m=a.Axis.prototype.getPlotLinePath.apply(this,arguments);this.right=h;return m}:(f.setAxisSize(),f.setAxisTranslation())}))});C(D,"render",function(){this.scrollablePixels?(this.setUpScrolling&&
this.setUpScrolling(),this.applyFixed()):this.fixedDiv&&this.applyFixed()});D.prototype.setUpScrolling=function(){this.scrollingContainer=a.createElement("div",{className:"highcharts-scrolling"},{overflowX:"auto",WebkitOverflowScrolling:"touch"},this.renderTo);this.innerContainer=a.createElement("div",{className:"highcharts-inner-container"},null,this.scrollingContainer);this.innerContainer.appendChild(this.container);this.setUpScrolling=null};D.prototype.applyFixed=function(){var m=this.container,
h,f,r=!this.fixedDiv;r&&(this.fixedDiv=a.createElement("div",{className:"highcharts-fixed"},{position:"absolute",overflow:"hidden",pointerEvents:"none",zIndex:2},null,!0),this.renderTo.insertBefore(this.fixedDiv,this.renderTo.firstChild),this.fixedRenderer=h=new a.Renderer(this.fixedDiv,0,0),this.scrollableMask=h.path().attr({fill:a.color(this.options.chart.backgroundColor||"#fff").setOpacity(.85).get(),zIndex:-1}).addClass("highcharts-scrollable-mask").add(),a.each([this.inverted?".highcharts-xaxis":
".highcharts-yaxis",this.inverted?".highcharts-xaxis-labels":".highcharts-yaxis-labels",".highcharts-contextbutton",".highcharts-credits",".highcharts-legend",".highcharts-subtitle",".highcharts-title",".highcharts-legend-checkbox"],function(f){a.each(m.querySelectorAll(f),function(a){(a.namespaceURI===h.SVG_NS?h.box:h.box.parentNode).appendChild(a);a.style.pointerEvents="auto"})}));this.fixedRenderer.setSize(this.chartWidth,this.chartHeight);f=this.chartWidth+this.scrollablePixels;a.stop(this.container);
this.container.style.width=f+"px";this.renderer.boxWrapper.attr({width:f,height:this.chartHeight,viewBox:[0,0,f,this.chartHeight].join(" ")});this.chartBackground.attr({width:f});r&&(f=this.options.chart.scrollablePlotArea,f.scrollPositionX&&(this.scrollingContainer.scrollLeft=this.scrollablePixels*f.scrollPositionX));r=this.axisOffset;f=this.plotTop-r[0]-1;var r=this.plotTop+this.plotHeight+r[2],y=this.plotLeft+this.plotWidth-this.scrollablePixels;this.scrollableMask.attr({d:this.scrollablePixels?
["M",0,f,"L",this.plotLeft-1,f,"L",this.plotLeft-1,r,"L",0,r,"Z","M",y,f,"L",this.chartWidth,f,"L",this.chartWidth,r,"L",y,r,"Z"]:["M",0,0]})}})(K);(function(a){var C,D=a.each,E=a.extend,m=a.erase,h=a.fireEvent,f=a.format,r=a.isArray,y=a.isNumber,q=a.pick,w=a.removeEvent;a.Point=C=function(){};a.Point.prototype={init:function(a,c,f){this.series=a;this.color=a.color;this.applyOptions(c,f);a.options.colorByPoint?(c=a.options.colors||a.chart.options.colors,this.color=this.color||c[a.colorCounter],c=
c.length,f=a.colorCounter,a.colorCounter++,a.colorCounter===c&&(a.colorCounter=0)):f=a.colorIndex;this.colorIndex=q(this.colorIndex,f);a.chart.pointCount++;h(this,"afterInit");return this},applyOptions:function(a,c){var e=this.series,f=e.options.pointValKey||e.pointValKey;a=C.prototype.optionsToObject.call(this,a);E(this,a);this.options=this.options?E(this.options,a):a;a.group&&delete this.group;f&&(this.y=this[f]);this.isNull=q(this.isValid&&!this.isValid(),null===this.x||!y(this.y,!0));this.selected&&
(this.state="select");"name"in this&&void 0===c&&e.xAxis&&e.xAxis.hasNames&&(this.x=e.xAxis.nameToX(this));void 0===this.x&&e&&(this.x=void 0===c?e.autoIncrement(this):c);return this},setNestedProperty:function(e,c,f){f=f.split(".");a.reduce(f,function(e,f,d,b){e[f]=b.length-1===d?c:a.isObject(e[f],!0)?e[f]:{};return e[f]},e);return e},optionsToObject:function(e){var c={},f=this.series,h=f.options.keys,k=h||f.pointArrayMap||["y"],d=k.length,b=0,u=0;if(y(e)||null===e)c[k[0]]=e;else if(r(e))for(!h&&
e.length>d&&(f=typeof e[0],"string"===f?c.name=e[0]:"number"===f&&(c.x=e[0]),b++);u<d;)h&&void 0===e[b]||(0<k[u].indexOf(".")?a.Point.prototype.setNestedProperty(c,e[b],k[u]):c[k[u]]=e[b]),b++,u++;else"object"===typeof e&&(c=e,e.dataLabels&&(f._hasPointLabels=!0),e.marker&&(f._hasPointMarkers=!0));return c},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?
" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var a=this.series,c=a.zones,a=a.zoneAxis||"y",f=0,h;for(h=c[f];this[a]>=h.value;)h=c[++f];this.nonZonedColor||(this.nonZonedColor=this.color);this.color=h&&h.color&&!this.options.color?h.color:this.nonZonedColor;return h},destroy:function(){var a=this.series.chart,c=a.hoverPoints,f;a.pointCount--;
c&&(this.setState(),m(c,this),c.length||(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)w(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);for(f in this)this[f]=null},destroyElements:function(){for(var a=["graphic","dataLabel","dataLabelUpper","connector","shadowGroup"],c,f=6;f--;)c=a[f],this[c]&&(this[c]=this[c].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||
this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var c=this.series,e=c.tooltipOptions,h=q(e.valueDecimals,""),k=e.valuePrefix||"",d=e.valueSuffix||"";D(c.pointArrayMap||["y"],function(b){b="{point."+b;if(k||d)a=a.replace(RegExp(b+"}","g"),k+b+"}"+d);a=a.replace(RegExp(b+"}","g"),b+":,."+h+"f}")});return f(a,{point:this,series:this.series},c.chart.time)},firePointEvent:function(a,c,f){var e=this,k=this.series.options;
(k.point.events[a]||e.options&&e.options.events&&e.options.events[a])&&this.importEvents();"click"===a&&k.allowPointSelect&&(f=function(a){e.select&&e.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});h(this,a,c,f)},visible:!0}})(K);(function(a){var C=a.addEvent,D=a.animObject,E=a.arrayMax,m=a.arrayMin,h=a.correctFloat,f=a.defaultOptions,r=a.defaultPlotOptions,y=a.defined,q=a.each,w=a.erase,e=a.extend,c=a.fireEvent,l=a.grep,z=a.isArray,k=a.isNumber,d=a.isString,b=a.merge,u=a.objectEach,p=a.pick,H=a.removeEvent,
t=a.splat,L=a.SVGElement,x=a.syncTimeout,I=a.win;a.Series=a.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",enabledThreshold:2,radius:4,states:{normal:{animation:!0},hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":a.numberFormat(this.y,
-1)},style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0,padding:5},cropThreshold:300,pointRange:0,softThreshold:!0,states:{normal:{animation:!0},hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x",
"y"],coll:"series",init:function(a,b){var d=this,n,f=a.series,g;d.chart=a;d.options=b=d.setOptions(b);d.linkedSeries=[];d.bindAxes();e(d,{name:b.name,state:"",visible:!1!==b.visible,selected:!0===b.selected});n=b.events;u(n,function(a,b){C(d,b,a)});if(n&&n.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;d.getColor();d.getSymbol();q(d.parallelArrays,function(a){d[a+"Data"]=[]});d.setData(b.data,!1);d.isCartesian&&(a.hasCartesianSeries=!0);f.length&&(g=
f[f.length-1]);d._i=p(g&&g._i,-1)+1;a.orderSeries(this.insert(f));c(this,"afterInit")},insert:function(a){var b=this.options.index,c;if(k(b)){for(c=a.length;c--;)if(b>=p(a[c].options.index,a[c]._i)){a.splice(c+1,0,this);break}-1===c&&a.unshift(this);c+=1}else a.push(this);return p(c,a.length-1)},bindAxes:function(){var b=this,c=b.options,d=b.chart,e;q(b.axisTypes||[],function(f){q(d[f],function(a){e=a.options;if(c[f]===e.index||void 0!==c[f]&&c[f]===e.id||void 0===c[f]&&0===e.index)b.insert(a.series),
b[f]=a,a.isDirty=!0});b[f]||b.optionalAxis===f||a.error(18,!0)})},updateParallelArrays:function(a,b){var c=a.series,d=arguments,e=k(b)?function(d){var g="y"===d&&c.toYData?c.toYData(a):a[d];c[d+"Data"][b]=g}:function(a){Array.prototype[b].apply(c[a+"Data"],Array.prototype.slice.call(d,2))};q(c.parallelArrays,e)},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,d=a.pointIntervalUnit,e=this.chart.time,b=p(b,a.pointStart,0);this.pointInterval=c=p(this.pointInterval,a.pointInterval,1);
d&&(a=new e.Date(b),"day"===d?e.set("Date",a,e.get("Date",a)+c):"month"===d?e.set("Month",a,e.get("Month",a)+c):"year"===d&&e.set("FullYear",a,e.get("FullYear",a)+c),c=a.getTime()-b);this.xIncrement=b+c;return b},setOptions:function(a){var d=this.chart,e=d.options,k=e.plotOptions,n=(d.userOptions||{}).plotOptions||{},g=k[this.type];this.userOptions=a;d=b(g,k.series,a);this.tooltipOptions=b(f.tooltip,f.plotOptions.series&&f.plotOptions.series.tooltip,f.plotOptions[this.type].tooltip,e.tooltip.userOptions,
k.series&&k.series.tooltip,k[this.type].tooltip,a.tooltip);this.stickyTracking=p(a.stickyTracking,n[this.type]&&n[this.type].stickyTracking,n.series&&n.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:d.stickyTracking);null===g.marker&&delete d.marker;this.zoneAxis=d.zoneAxis;a=this.zones=(d.zones||[]).slice();!d.negativeColor&&!d.negativeFillColor||d.zones||a.push({value:d[this.zoneAxis+"Threshold"]||d.threshold||0,className:"highcharts-negative",color:d.negativeColor,fillColor:d.negativeFillColor});
a.length&&y(a[a.length-1].value)&&a.push({color:this.color,fillColor:this.fillColor});c(this,"afterSetOptions",{options:d});return d},getName:function(){return this.name||"Series "+(this.index+1)},getCyclic:function(a,b,c){var d,e=this.chart,g=this.userOptions,f=a+"Index",k=a+"Counter",n=c?c.length:p(e.options.chart[a+"Count"],e[a+"Count"]);b||(d=p(g[f],g["_"+f]),y(d)||(e.series.length||(e[k]=0),g["_"+f]=d=e[k]%n,e[k]+=1),c&&(b=c[d]));void 0!==d&&(this[f]=d);this[a]=b},getColor:function(){this.options.colorByPoint?
this.options.color=null:this.getCyclic("color",this.options.color||r[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,updateData:function(b){var c=this.options,d=this.points,e=[],f,g,n,h=this.requireSorting;q(b,function(b){var g;g=a.defined(b)&&this.pointClass.prototype.optionsToObject.call({series:this},b).x;k(g)&&(g=a.inArray(g,this.xData,n),-1===g?
e.push(b):b!==c.data[g]?(d[g].update(b,!1,null,!1),d[g].touched=!0,h&&(n=g)):d[g]&&(d[g].touched=!0),f=!0)},this);if(f)for(b=d.length;b--;)g=d[b],g.touched||g.remove(!1),g.touched=!1;else if(b.length===d.length)q(b,function(a,b){d[b].update&&a!==c.data[b]&&d[b].update(a,!1,null,!1)});else return!1;q(e,function(a){this.addPoint(a,!1)},this);return!0},setData:function(b,c,e,f){var n=this,g=n.points,h=g&&g.length||0,l,B=n.options,G=n.chart,t=null,x=n.xAxis,u=B.turboThreshold,m=this.xData,r=this.yData,
w=(l=n.pointArrayMap)&&l.length,y;b=b||[];l=b.length;c=p(c,!0);!1!==f&&l&&h&&!n.cropped&&!n.hasGroupedData&&n.visible&&!n.isSeriesBoosting&&(y=this.updateData(b));if(!y){n.xIncrement=null;n.colorCounter=0;q(this.parallelArrays,function(a){n[a+"Data"].length=0});if(u&&l>u){for(e=0;null===t&&e<l;)t=b[e],e++;if(k(t))for(e=0;e<l;e++)m[e]=this.autoIncrement(),r[e]=b[e];else if(z(t))if(w)for(e=0;e<l;e++)t=b[e],m[e]=t[0],r[e]=t.slice(1,w+1);else for(e=0;e<l;e++)t=b[e],m[e]=t[0],r[e]=t[1];else a.error(12)}else for(e=
0;e<l;e++)void 0!==b[e]&&(t={series:n},n.pointClass.prototype.applyOptions.apply(t,[b[e]]),n.updateParallelArrays(t,e));r&&d(r[0])&&a.error(14,!0);n.data=[];n.options.data=n.userOptions.data=b;for(e=h;e--;)g[e]&&g[e].destroy&&g[e].destroy();x&&(x.minRange=x.userMinRange);n.isDirty=G.isDirtyBox=!0;n.isDirtyData=!!g;e=!1}"point"===B.legendType&&(this.processData(),this.generatePoints());c&&G.redraw(e)},processData:function(b){var c=this.xData,d=this.yData,e=c.length,f;f=0;var g,k,n=this.xAxis,h,l=this.options;
h=l.cropThreshold;var p=this.getExtremesFromAll||l.getExtremesFromAll,t=this.isCartesian,l=n&&n.val2lin,x=n&&n.isLog,u=this.requireSorting,m,z;if(t&&!this.isDirty&&!n.isDirty&&!this.yAxis.isDirty&&!b)return!1;n&&(b=n.getExtremes(),m=b.min,z=b.max);t&&this.sorted&&!p&&(!h||e>h||this.forceCrop)&&(c[e-1]<m||c[0]>z?(c=[],d=[]):this.yData&&(c[0]<m||c[e-1]>z)&&(f=this.cropData(this.xData,this.yData,m,z),c=f.xData,d=f.yData,f=f.start,g=!0));for(h=c.length||1;--h;)e=x?l(c[h])-l(c[h-1]):c[h]-c[h-1],0<e&&(void 0===
k||e<k)?k=e:0>e&&u&&(a.error(15),u=!1);this.cropped=g;this.cropStart=f;this.processedXData=c;this.processedYData=d;this.closestPointRange=k},cropData:function(a,b,c,d,e){var g=a.length,f=0,k=g,n;e=p(e,this.cropShoulder,1);for(n=0;n<g;n++)if(a[n]>=c){f=Math.max(0,n-e);break}for(c=n;c<g;c++)if(a[c]>d){k=c+e;break}return{xData:a.slice(f,k),yData:b.slice(f,k),start:f,end:k}},generatePoints:function(){var a=this.options,b=a.data,c=this.data,d,e=this.processedXData,g=this.processedYData,f=this.pointClass,
k=e.length,h=this.cropStart||0,l,p=this.hasGroupedData,a=a.keys,x,u=[],m;c||p||(c=[],c.length=b.length,c=this.data=c);a&&p&&(this.options.keys=!1);for(m=0;m<k;m++)l=h+m,p?(x=(new f).init(this,[e[m]].concat(t(g[m]))),x.dataGroup=this.groupMap[m]):(x=c[l])||void 0===b[l]||(c[l]=x=(new f).init(this,b[l],e[m])),x&&(x.index=l,u[m]=x);this.options.keys=a;if(c&&(k!==(d=c.length)||p))for(m=0;m<d;m++)m!==h||p||(m+=k),c[m]&&(c[m].destroyElements(),c[m].plotX=void 0);this.data=c;this.points=u},getExtremes:function(a){var b=
this.yAxis,c=this.processedXData,d,e=[],g=0;d=this.xAxis.getExtremes();var f=d.min,n=d.max,h,l,p=this.requireSorting?1:0,t,x;a=a||this.stackedYData||this.processedYData||[];d=a.length;for(x=0;x<d;x++)if(l=c[x],t=a[x],h=(k(t,!0)||z(t))&&(!b.positiveValuesOnly||t.length||0<t),l=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(c[x+p]||l)>=f&&(c[x-p]||l)<=n,h&&l)if(h=t.length)for(;h--;)"number"===typeof t[h]&&(e[g++]=t[h]);else e[g++]=t;this.dataMin=m(e);this.dataMax=E(e)},translate:function(){this.processedXData||
this.processData();this.generatePoints();var a=this.options,b=a.stacking,d=this.xAxis,e=d.categories,f=this.yAxis,g=this.points,l=g.length,t=!!this.modifyValue,x=a.pointPlacement,m="between"===x||k(x),u=a.threshold,z=a.startFromThreshold?u:0,q,r,w,I,H=Number.MAX_VALUE;"between"===x&&(x=.5);k(x)&&(x*=p(a.pointRange||d.pointRange));for(a=0;a<l;a++){var L=g[a],C=L.x,D=L.y;r=L.low;var E=b&&f.stacks[(this.negStacks&&D<(z?0:u)?"-":"")+this.stackKey],K;f.positiveValuesOnly&&null!==D&&0>=D&&(L.isNull=!0);
L.plotX=q=h(Math.min(Math.max(-1E5,d.translate(C,0,0,0,1,x,"flags"===this.type)),1E5));b&&this.visible&&!L.isNull&&E&&E[C]&&(I=this.getStackIndicator(I,C,this.index),K=E[C],D=K.points[I.key],r=D[0],D=D[1],r===z&&I.key===E[C].base&&(r=p(k(u)&&u,f.min)),f.positiveValuesOnly&&0>=r&&(r=null),L.total=L.stackTotal=K.total,L.percentage=K.total&&L.y/K.total*100,L.stackY=D,K.setOffset(this.pointXOffset||0,this.barW||0));L.yBottom=y(r)?Math.min(Math.max(-1E5,f.translate(r,0,1,0,1)),1E5):null;t&&(D=this.modifyValue(D,
L));L.plotY=r="number"===typeof D&&Infinity!==D?Math.min(Math.max(-1E5,f.translate(D,0,1,0,1)),1E5):void 0;L.isInside=void 0!==r&&0<=r&&r<=f.len&&0<=q&&q<=d.len;L.clientX=m?h(d.translate(C,0,0,0,1,x)):q;L.negative=L.y<(u||0);L.category=e&&void 0!==e[L.x]?e[L.x]:L.x;L.isNull||(void 0!==w&&(H=Math.min(H,Math.abs(q-w))),w=q);L.zone=this.zones.length&&L.getZone()}this.closestPointRangePx=H;c(this,"afterTranslate")},getValidPoints:function(a,b){var c=this.chart;return l(a||this.points||[],function(a){return b&&
!c.isInsidePlot(a.plotX,a.plotY,c.inverted)?!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,d=b.renderer,e=b.inverted,g=this.clipBox,f=g||b.clipBox,k=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,f.height,c.xAxis,c.yAxis].join(),n=b[k],h=b[k+"m"];n||(a&&(f.width=0,e&&(f.x=b.plotSizeX),b[k+"m"]=h=d.clipRect(e?b.plotSizeX+99:-99,e?-b.plotLeft:-b.plotTop,99,e?b.chartWidth:b.chartHeight)),b[k]=n=d.clipRect(f),n.count={length:0});a&&!n.count[this.index]&&(n.count[this.index]=
!0,n.count.length+=1);!1!==c.clip&&(this.group.clip(a||g?n:b.clipRect),this.markerGroup.clip(h),this.sharedClipKey=k);a||(n.count[this.index]&&(delete n.count[this.index],--n.count.length),0===n.count.length&&k&&b[k]&&(g||(b[k]=b[k].destroy()),b[k+"m"]&&(b[k+"m"]=b[k+"m"].destroy())))},animate:function(a){var b=this.chart,c=D(this.options.animation),d;a?this.setClip(c):(d=this.sharedClipKey,(a=b[d])&&a.animate({width:b.plotSizeX,x:0},c),b[d+"m"]&&b[d+"m"].animate({width:b.plotSizeX+99,x:0},c),this.animate=
null)},afterAnimate:function(){this.setClip();c(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=this.points,b=this.chart,c,d,e,g,f=this.options.marker,k,h,l,t=this[this.specialGroup]||this.markerGroup,x,m=p(f.enabled,this.xAxis.isRadial?!0:null,this.closestPointRangePx>=f.enabledThreshold*f.radius);if(!1!==f.enabled||this._hasPointMarkers)for(c=0;c<a.length;c++)d=a[c],g=d.graphic,k=d.marker||{},h=!!d.marker,e=m&&void 0===k.enabled||k.enabled,l=d.isInside,e&&!d.isNull?(e=
p(k.symbol,this.symbol),x=this.markerAttribs(d,d.selected&&"select"),g?g[l?"show":"hide"](!0).animate(x):l&&(0<x.width||d.hasImage)&&(d.graphic=g=b.renderer.symbol(e,x.x,x.y,x.width,x.height,h?k:f).add(t)),g&&g.attr(this.pointAttribs(d,d.selected&&"select")),g&&g.addClass(d.getClassName(),!0)):g&&(d.graphic=g.destroy())},markerAttribs:function(a,b){var c=this.options.marker,d=a.marker||{},e=d.symbol||c.symbol,g=p(d.radius,c.radius);b&&(c=c.states[b],b=d.states&&d.states[b],g=p(b&&b.radius,c&&c.radius,
g+(c&&c.radiusPlus||0)));a.hasImage=e&&0===e.indexOf("url");a.hasImage&&(g=0);a={x:Math.floor(a.plotX)-g,y:a.plotY-g};g&&(a.width=a.height=2*g);return a},pointAttribs:function(a,b){var c=this.options.marker,d=a&&a.options,e=d&&d.marker||{},g=this.color,f=d&&d.color,k=a&&a.color,d=p(e.lineWidth,c.lineWidth);a=a&&a.zone&&a.zone.color;g=f||a||k||g;a=e.fillColor||c.fillColor||g;g=e.lineColor||c.lineColor||g;b&&(c=c.states[b],b=e.states&&e.states[b]||{},d=p(b.lineWidth,c.lineWidth,d+p(b.lineWidthPlus,
c.lineWidthPlus,0)),a=b.fillColor||c.fillColor||a,g=b.lineColor||c.lineColor||g);return{stroke:g,"stroke-width":d,fill:a}},destroy:function(){var b=this,d=b.chart,e=/AppleWebKit\/533/.test(I.navigator.userAgent),f,k,g=b.data||[],h,l;c(b,"destroy");H(b);q(b.axisTypes||[],function(a){(l=b[a])&&l.series&&(w(l.series,b),l.isDirty=l.forceRedraw=!0)});b.legendItem&&b.chart.legend.destroyItem(b);for(k=g.length;k--;)(h=g[k])&&h.destroy&&h.destroy();b.points=null;a.clearTimeout(b.animationTimeout);u(b,function(a,
b){a instanceof L&&!a.survive&&(f=e&&"group"===b?"hide":"destroy",a[f]())});d.hoverSeries===b&&(d.hoverSeries=null);w(d.series,b);d.orderSeries();u(b,function(a,c){delete b[c]})},getGraphPath:function(a,b,c){var d=this,e=d.options,g=e.step,f,k=[],n=[],h;a=a||d.points;(f=a.reversed)&&a.reverse();(g={right:1,center:2}[g]||g&&3)&&f&&(g=4-g);!e.connectNulls||b||c||(a=this.getValidPoints(a));q(a,function(f,l){var p=f.plotX,t=f.plotY,x=a[l-1];(f.leftCliff||x&&x.rightCliff)&&!c&&(h=!0);f.isNull&&!y(b)&&
0<l?h=!e.connectNulls:f.isNull&&!b?h=!0:(0===l||h?l=["M",f.plotX,f.plotY]:d.getPointSpline?l=d.getPointSpline(a,f,l):g?(l=1===g?["L",x.plotX,t]:2===g?["L",(x.plotX+p)/2,x.plotY,"L",(x.plotX+p)/2,t]:["L",p,x.plotY],l.push("L",p,t)):l=["L",p,t],n.push(f.x),g&&(n.push(f.x),2===g&&n.push(f.x)),k.push.apply(k,l),h=!1)});k.xMap=n;return d.graphPath=k},drawGraph:function(){var a=this,b=this.options,c=(this.gappedPath||this.getGraphPath).call(this),d=[["graph","highcharts-graph",b.lineColor||this.color,b.dashStyle]],
d=a.getZonesGraphs(d);q(d,function(d,e){var g=d[0],f=a[g];f?(f.endX=a.preventGraphAnimation?null:c.xMap,f.animate({d:c})):c.length&&(a[g]=a.chart.renderer.path(c).addClass(d[1]).attr({zIndex:1}).add(a.group),f={stroke:d[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},d[3]?f.dashstyle=d[3]:"square"!==b.linecap&&(f["stroke-linecap"]=f["stroke-linejoin"]="round"),f=a[g].attr(f).shadow(2>e&&b.shadow));f&&(f.startX=c.xMap,f.isArea=c.isArea)})},getZonesGraphs:function(a){q(this.zones,function(b,
c){a.push(["zone-graph-"+c,"highcharts-graph highcharts-zone-graph-"+c+" "+(b.className||""),b.color||this.color,b.dashStyle||this.options.dashStyle])},this);return a},applyZones:function(){var a=this,b=this.chart,c=b.renderer,d=this.zones,e,g,f=this.clips||[],k,h=this.graph,l=this.area,t=Math.max(b.chartWidth,b.chartHeight),x=this[(this.zoneAxis||"y")+"Axis"],m,u,z=b.inverted,r,w,y,I,H=!1;d.length&&(h||l)&&x&&void 0!==x.min&&(u=x.reversed,r=x.horiz,h&&!this.showLine&&h.hide(),l&&l.hide(),m=x.getExtremes(),
q(d,function(d,n){e=u?r?b.plotWidth:0:r?0:x.toPixels(m.min);e=Math.min(Math.max(p(g,e),0),t);g=Math.min(Math.max(Math.round(x.toPixels(p(d.value,m.max),!0)),0),t);H&&(e=g=x.toPixels(m.max));w=Math.abs(e-g);y=Math.min(e,g);I=Math.max(e,g);x.isXAxis?(k={x:z?I:y,y:0,width:w,height:t},r||(k.x=b.plotHeight-k.x)):(k={x:0,y:z?I:y,width:t,height:w},r&&(k.y=b.plotWidth-k.y));z&&c.isVML&&(k=x.isXAxis?{x:0,y:u?y:I,height:k.width,width:b.chartWidth}:{x:k.y-b.plotLeft-b.spacingBox.x,y:0,width:k.height,height:b.chartHeight});
f[n]?f[n].animate(k):(f[n]=c.clipRect(k),h&&a["zone-graph-"+n].clip(f[n]),l&&a["zone-area-"+n].clip(f[n]));H=d.value>m.max;a.resetZones&&0===g&&(g=void 0)}),this.clips=f)},invertGroups:function(a){function b(){q(["group","markerGroup"],function(b){c[b]&&(d.renderer.isVML&&c[b].attr({width:c.yAxis.len,height:c.xAxis.len}),c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,d=c.chart,e;c.xAxis&&(e=C(d,"resize",b),C(c,"destroy",e),b(a),c.invertGroups=b)},plotGroup:function(a,
b,c,d,e){var g=this[a],f=!g;f&&(this[a]=g=this.chart.renderer.g().attr({zIndex:d||.1}).add(e));g.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(y(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||"")+(g.hasClass("highcharts-tracker")?" highcharts-tracker":""),!0);g.attr({visibility:c})[f?"attr":"animate"](this.getPlotBox());return g},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;a.inverted&&(b=c,
c=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,d,e=a.options,f=!!a.animate&&b.renderer.isSVG&&D(e.animation).duration,g=a.visible?"inherit":"hidden",k=e.zIndex,h=a.hasRendered,l=b.seriesGroup,p=b.inverted;d=a.plotGroup("group","series",g,k,l);a.markerGroup=a.plotGroup("markerGroup","markers",g,k,l);f&&a.animate(!0);d.inverted=a.isCartesian?p:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.drawDataLabels&&
a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(p);!1===e.clip||a.sharedClipKey||h||d.clip(b.clipRect);f&&a.animate();h||(a.animationTimeout=x(function(){a.afterAnimate()},f));a.isDirty=!1;a.hasRendered=!0;c(a,"afterRender")},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,c=this.group,d=this.xAxis,e=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:p(d&&
d.left,a.plotLeft),translateY:p(e&&e.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,d=this.yAxis,e=this.chart.inverted;return this.searchKDTree({clientX:e?c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:e?d.len-a.chartX+d.pos:a.chartY-d.pos},b)},buildKDTree:function(){function a(c,d,e){var g,f;if(f=c&&c.length)return g=b.kdAxisArray[d%e],c.sort(function(a,b){return a[g]-b[g]}),f=Math.floor(f/2),{point:c[f],
left:a(c.slice(0,f),d+1,e),right:a(c.slice(f+1),d+1,e)}}this.buildingKdTree=!0;var b=this,c=-1<b.options.findNearestPointBy.indexOf("y")?2:1;delete b.kdTree;x(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c);b.buildingKdTree=!1},b.options.kdNow?0:1)},searchKDTree:function(a,b){function c(a,b,k,h){var l=b.point,n=d.kdAxisArray[k%h],p,t,x=l;t=y(a[e])&&y(l[e])?Math.pow(a[e]-l[e],2):null;p=y(a[g])&&y(l[g])?Math.pow(a[g]-l[g],2):null;p=(t||0)+(p||0);l.dist=y(p)?Math.sqrt(p):Number.MAX_VALUE;
l.distX=y(t)?Math.sqrt(t):Number.MAX_VALUE;n=a[n]-l[n];p=0>n?"left":"right";t=0>n?"right":"left";b[p]&&(p=c(a,b[p],k+1,h),x=p[f]<x[f]?p:l);b[t]&&Math.sqrt(n*n)<x[f]&&(a=c(a,b[t],k+1,h),x=a[f]<x[f]?a:x);return x}var d=this,e=this.kdAxisArray[0],g=this.kdAxisArray[1],f=b?"distX":"dist";b=-1<d.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,b,b)}})})(K);(function(a){var C=a.Axis,D=a.Chart,E=a.correctFloat,m=a.defined,
h=a.destroyObjectProperties,f=a.each,r=a.format,y=a.objectEach,q=a.pick,w=a.Series;a.StackItem=function(a,c,f,h,k){var d=a.chart.inverted;this.axis=a;this.isNegative=f;this.options=c;this.x=h;this.total=null;this.points={};this.stack=k;this.rightCliff=this.leftCliff=0;this.alignOptions={align:c.align||(d?f?"left":"right":"center"),verticalAlign:c.verticalAlign||(d?"middle":f?"bottom":"top"),y:q(c.y,d?4:f?14:-6),x:q(c.x,d?f?-6:6:0)};this.textAlign=c.textAlign||(d?f?"right":"left":"center")};a.StackItem.prototype=
{destroy:function(){h(this,this.axis)},render:function(a){var c=this.axis.chart,e=this.options,f=e.format,f=f?r(f,this,c.time):e.formatter.call(this);this.label?this.label.attr({text:f,visibility:"hidden"}):this.label=c.renderer.text(f,null,null,e.useHTML).css(e.style).attr({align:this.textAlign,rotation:e.rotation,visibility:"hidden"}).add(a);this.label.labelrank=c.plotHeight},setOffset:function(a,c){var e=this.axis,f=e.chart,k=e.translate(e.usePercentage?100:this.total,0,0,0,1),d=e.translate(0),
d=m(k)&&Math.abs(k-d);a=f.xAxis[0].translate(this.x)+a;e=m(k)&&this.getStackBox(f,this,a,k,c,d,e);(c=this.label)&&e&&(c.align(this.alignOptions,null,e),e=c.alignAttr,c[!1===this.options.crop||f.isInsidePlot(e.x,e.y)?"show":"hide"](!0))},getStackBox:function(a,c,f,h,k,d,b){var e=c.axis.reversed,l=a.inverted;a=b.height+b.pos-(l?a.plotLeft:a.plotTop);c=c.isNegative&&!e||!c.isNegative&&e;return{x:l?c?h:h-d:f,y:l?a-f-k:c?a-h-d:a-h,width:l?d:k,height:l?k:d}}};D.prototype.getStacks=function(){var a=this;
f(a.yAxis,function(a){a.stacks&&a.hasVisibleSeries&&(a.oldStacks=a.stacks)});f(a.series,function(c){!c.options.stacking||!0!==c.visible&&!1!==a.options.chart.ignoreHiddenSeries||(c.stackKey=c.type+q(c.options.stack,""))})};C.prototype.buildStacks=function(){var a=this.series,c=q(this.options.reversedStacks,!0),f=a.length,h;if(!this.isXAxis){this.usePercentage=!1;for(h=f;h--;)a[c?h:f-h-1].setStackedPoints();for(h=0;h<f;h++)a[h].modifyStacks()}};C.prototype.renderStackTotals=function(){var a=this.chart,
c=a.renderer,f=this.stacks,h=this.stackTotalGroup;h||(this.stackTotalGroup=h=c.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());h.translate(a.plotLeft,a.plotTop);y(f,function(a){y(a,function(a){a.render(h)})})};C.prototype.resetStacks=function(){var a=this,c=a.stacks;a.isXAxis||y(c,function(c){y(c,function(e,f){e.touched<a.stacksTouched?(e.destroy(),delete c[f]):(e.total=null,e.cumulative=null)})})};C.prototype.cleanStacks=function(){var a;this.isXAxis||(this.oldStacks&&(a=this.stacks=
this.oldStacks),y(a,function(a){y(a,function(a){a.cumulative=a.total})}))};w.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var e=this.processedXData,c=this.processedYData,f=[],h=c.length,k=this.options,d=k.threshold,b=q(k.startFromThreshold&&d,0),u=k.stack,k=k.stacking,p=this.stackKey,r="-"+p,t=this.negStacks,w=this.yAxis,x=w.stacks,y=w.oldStacks,n,G,B,M,F,g,v;w.stacksTouched+=1;for(F=0;F<h;F++)g=e[F],v=c[F],
n=this.getStackIndicator(n,g,this.index),M=n.key,B=(G=t&&v<(b?0:d))?r:p,x[B]||(x[B]={}),x[B][g]||(y[B]&&y[B][g]?(x[B][g]=y[B][g],x[B][g].total=null):x[B][g]=new a.StackItem(w,w.options.stackLabels,G,g,u)),B=x[B][g],null!==v?(B.points[M]=B.points[this.index]=[q(B.cumulative,b)],m(B.cumulative)||(B.base=M),B.touched=w.stacksTouched,0<n.index&&!1===this.singleStacks&&(B.points[M][0]=B.points[this.index+","+g+",0"][0])):B.points[M]=B.points[this.index]=null,"percent"===k?(G=G?p:r,t&&x[G]&&x[G][g]?(G=
x[G][g],B.total=G.total=Math.max(G.total,B.total)+Math.abs(v)||0):B.total=E(B.total+(Math.abs(v)||0))):B.total=E(B.total+(v||0)),B.cumulative=q(B.cumulative,b)+(v||0),null!==v&&(B.points[M].push(B.cumulative),f[F]=B.cumulative);"percent"===k&&(w.usePercentage=!0);this.stackedYData=f;w.oldStacks={}}};w.prototype.modifyStacks=function(){var a=this,c=a.stackKey,h=a.yAxis.stacks,m=a.processedXData,k,d=a.options.stacking;a[d+"Stacker"]&&f([c,"-"+c],function(b){for(var c=m.length,e,f;c--;)if(e=m[c],k=a.getStackIndicator(k,
e,a.index,b),f=(e=h[b]&&h[b][e])&&e.points[k.key])a[d+"Stacker"](f,e,c)})};w.prototype.percentStacker=function(a,c,f){c=c.total?100/c.total:0;a[0]=E(a[0]*c);a[1]=E(a[1]*c);this.stackedYData[f]=a[1]};w.prototype.getStackIndicator=function(a,c,f,h){!m(a)||a.x!==c||h&&a.key!==h?a={x:c,index:0,key:h}:a.index++;a.key=[f,c,a.index].join();return a}})(K);(function(a){var C=a.addEvent,D=a.animate,E=a.Axis,m=a.createElement,h=a.css,f=a.defined,r=a.each,y=a.erase,q=a.extend,w=a.fireEvent,e=a.inArray,c=a.isNumber,
l=a.isObject,z=a.isArray,k=a.merge,d=a.objectEach,b=a.pick,u=a.Point,p=a.Series,H=a.seriesTypes,t=a.setAnimation,L=a.splat;q(a.Chart.prototype,{addSeries:function(a,c,d){var e,f=this;a&&(c=b(c,!0),w(f,"addSeries",{options:a},function(){e=f.initSeries(a);f.isDirtyLegend=!0;f.linkSeries();w(f,"afterAddSeries");c&&f.redraw(d)}));return e},addAxis:function(a,c,d,e){var f=c?"xAxis":"yAxis",h=this.options;a=k(a,{index:this[f].length,isX:c});c=new E(this,a);h[f]=L(h[f]||{});h[f].push(a);b(d,!0)&&this.redraw(e);
return c},showLoading:function(a){var b=this,c=b.options,d=b.loadingDiv,e=c.loading,f=function(){d&&h(d,{left:b.plotLeft+"px",top:b.plotTop+"px",width:b.plotWidth+"px",height:b.plotHeight+"px"})};d||(b.loadingDiv=d=m("div",{className:"highcharts-loading highcharts-loading-hidden"},null,b.container),b.loadingSpan=m("span",{className:"highcharts-loading-inner"},null,d),C(b,"redraw",f));d.className="highcharts-loading";b.loadingSpan.innerHTML=a||c.lang.loading;h(d,q(e.style,{zIndex:10}));h(b.loadingSpan,
e.labelStyle);b.loadingShown||(h(d,{opacity:0,display:""}),D(d,{opacity:e.style.opacity||.5},{duration:e.showDuration||0}));b.loadingShown=!0;f()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",D(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){h(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" "),update:function(a,h,l,p){var n=this,t={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},x=a.chart,g,m,u=[];w(n,"update",{options:a});if(x){k(!0,n.options.chart,x);"className"in x&&n.setClassName(x.className);"reflow"in x&&n.setReflow(x.reflow);if("inverted"in x||"polar"in x||"type"in x)n.propFromSeries(),g=!0;"alignTicks"in x&&(g=!0);d(x,function(a,b){-1!==
e("chart."+b,n.propsRequireUpdateSeries)&&(m=!0);-1!==e(b,n.propsRequireDirtyBox)&&(n.isDirtyBox=!0)});"style"in x&&n.renderer.setStyle(x.style)}a.colors&&(this.options.colors=a.colors);a.plotOptions&&k(!0,this.options.plotOptions,a.plotOptions);d(a,function(a,b){if(n[b]&&"function"===typeof n[b].update)n[b].update(a,!1);else if("function"===typeof n[t[b]])n[t[b]](a);"chart"!==b&&-1!==e(b,n.propsRequireUpdateSeries)&&(m=!0)});r("xAxis yAxis zAxis series colorAxis pane".split(" "),function(b){var c;
a[b]&&("series"===b&&(c=[],r(n[b],function(a,b){a.options.isInternal||c.push(b)})),r(L(a[b]),function(a,d){(d=f(a.id)&&n.get(a.id)||n[b][c?c[d]:d])&&d.coll===b&&(d.update(a,!1),l&&(d.touched=!0));if(!d&&l)if("series"===b)n.addSeries(a,!1).touched=!0;else if("xAxis"===b||"yAxis"===b)n.addAxis(a,"xAxis"===b,!1).touched=!0}),l&&r(n[b],function(a){a.touched||a.options.isInternal?delete a.touched:u.push(a)}))});r(u,function(a){a.remove(!1)});g&&r(n.axes,function(a){a.update({},!1)});m&&r(n.series,function(a){a.update({},
!1)});a.loading&&k(!0,n.options.loading,a.loading);g=x&&x.width;x=x&&x.height;c(g)&&g!==n.chartWidth||c(x)&&x!==n.chartHeight?n.setSize(g,x,p):b(h,!0)&&n.redraw(p);w(n,"afterUpdate",{options:a})},setSubtitle:function(a){this.setTitle(void 0,a)}});q(u.prototype,{update:function(a,c,d,e){function f(){k.applyOptions(a);null===k.y&&g&&(k.graphic=g.destroy());l(a,!0)&&(g&&g.element&&a&&a.marker&&void 0!==a.marker.symbol&&(k.graphic=g.destroy()),a&&a.dataLabels&&k.dataLabel&&(k.dataLabel=k.dataLabel.destroy()),
k.connector&&(k.connector=k.connector.destroy()));n=k.index;h.updateParallelArrays(k,n);t.data[n]=l(t.data[n],!0)||l(a,!0)?k.options:b(a,t.data[n]);h.isDirty=h.isDirtyData=!0;!h.fixedBox&&h.hasCartesianSeries&&(p.isDirtyBox=!0);"point"===t.legendType&&(p.isDirtyLegend=!0);c&&p.redraw(d)}var k=this,h=k.series,g=k.graphic,n,p=h.chart,t=h.options;c=b(c,!0);!1===e?f():k.firePointEvent("update",{options:a},f)},remove:function(a,b){this.series.removePoint(e(this,this.series.data),a,b)}});q(p.prototype,
{addPoint:function(a,c,d,e){var f=this.options,k=this.data,h=this.chart,g=this.xAxis,g=g&&g.hasNames&&g.names,n=f.data,l,p,t=this.xData,x,m;c=b(c,!0);l={series:this};this.pointClass.prototype.applyOptions.apply(l,[a]);m=l.x;x=t.length;if(this.requireSorting&&m<t[x-1])for(p=!0;x&&t[x-1]>m;)x--;this.updateParallelArrays(l,"splice",x,0,0);this.updateParallelArrays(l,x);g&&l.name&&(g[m]=l.name);n.splice(x,0,a);p&&(this.data.splice(x,0,null),this.processData());"point"===f.legendType&&this.generatePoints();
d&&(k[0]&&k[0].remove?k[0].remove(!1):(k.shift(),this.updateParallelArrays(l,"shift"),n.shift()));this.isDirtyData=this.isDirty=!0;c&&h.redraw(e)},removePoint:function(a,c,d){var e=this,f=e.data,k=f[a],h=e.points,g=e.chart,n=function(){h&&h.length===f.length&&h.splice(a,1);f.splice(a,1);e.options.data.splice(a,1);e.updateParallelArrays(k||{series:e},"splice",a,1);k&&k.destroy();e.isDirty=!0;e.isDirtyData=!0;c&&g.redraw()};t(d,g);c=b(c,!0);k?k.firePointEvent("remove",null,n):n()},remove:function(a,
c,d){function e(){f.destroy();k.isDirtyLegend=k.isDirtyBox=!0;k.linkSeries();b(a,!0)&&k.redraw(c)}var f=this,k=f.chart;!1!==d?w(f,"remove",null,e):e()},update:function(c,d){var f=this,h=f.chart,l=f.userOptions,p=f.oldType||f.type,t=c.type||l.type||h.options.chart.type,g=H[p].prototype,x,m=["group","markerGroup","dataLabelsGroup"],u=["navigatorSeries","baseSeries"],z=f.finishedAnimating&&{animation:!1},y=["data","name","turboThreshold"],I=a.keys(c),A=0<I.length;r(I,function(a){-1===e(a,y)&&(A=!1)});
if(A)c.data&&this.setData(c.data,!1),c.name&&this.setName(c.name,!1);else{u=m.concat(u);r(u,function(a){u[a]=f[a];delete f[a]});c=k(l,z,{index:f.index,pointStart:b(l.pointStart,f.xData[0])},{data:f.options.data},c);f.remove(!1,null,!1);for(x in g)f[x]=void 0;H[t||p]?q(f,H[t||p].prototype):a.error(17,!0);r(u,function(a){f[a]=u[a]});f.init(h,c);c.zIndex!==l.zIndex&&r(m,function(a){f[a]&&f[a].attr({zIndex:c.zIndex})});f.oldType=p;h.linkSeries()}w(this,"afterUpdate");b(d,!0)&&h.redraw(!1)},setName:function(a){this.name=
this.options.name=this.userOptions.name=a;this.chart.isDirtyLegend=!0}});q(E.prototype,{update:function(a,c){var e=this.chart,f=a&&a.events||{};a=k(this.userOptions,a);e.options[this.coll].indexOf&&(e.options[this.coll][e.options[this.coll].indexOf(this.userOptions)]=a);d(e.options[this.coll].events,function(a,b){"undefined"===typeof f[b]&&(f[b]=void 0)});this.destroy(!0);this.init(e,q(a,{events:f}));e.isDirtyBox=!0;b(c,!0)&&e.redraw()},remove:function(a){for(var c=this.chart,d=this.coll,e=this.series,
f=e.length;f--;)e[f]&&e[f].remove(!1);y(c.axes,this);y(c[d],this);z(c.options[d])?c.options[d].splice(this.options.index,1):delete c.options[d];r(c[d],function(a,b){a.options.index=a.userOptions.index=b});this.destroy();c.isDirtyBox=!0;b(a,!0)&&c.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})})(K);(function(a){var C=a.color,D=a.each,E=a.map,m=a.pick,h=a.Series,f=a.seriesType;f("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,
getStackPoints:function(f){var h=[],q=[],r=this.xAxis,e=this.yAxis,c=e.stacks[this.stackKey],l={},z=this.index,k=e.series,d=k.length,b,u=m(e.options.reversedStacks,!0)?1:-1,p;f=f||this.points;if(this.options.stacking){for(p=0;p<f.length;p++)f[p].leftNull=f[p].rightNull=null,l[f[p].x]=f[p];a.objectEach(c,function(a,b){null!==a.total&&q.push(b)});q.sort(function(a,b){return a-b});b=E(k,function(){return this.visible});D(q,function(a,f){var k=0,t,m;if(l[a]&&!l[a].isNull)h.push(l[a]),D([-1,1],function(e){var k=
1===e?"rightNull":"leftNull",h=0,n=c[q[f+e]];if(n)for(p=z;0<=p&&p<d;)t=n.points[p],t||(p===z?l[a][k]=!0:b[p]&&(m=c[a].points[p])&&(h-=m[1]-m[0])),p+=u;l[a][1===e?"rightCliff":"leftCliff"]=h});else{for(p=z;0<=p&&p<d;){if(t=c[a].points[p]){k=t[1];break}p+=u}k=e.translate(k,0,1,0,1);h.push({isNull:!0,plotX:r.translate(a,0,0,0,1),x:a,plotY:k,yBottom:k})}})}return h},getGraphPath:function(a){var f=h.prototype.getGraphPath,q=this.options,r=q.stacking,e=this.yAxis,c,l,z=[],k=[],d=this.index,b,u=e.stacks[this.stackKey],
p=q.threshold,H=e.getThreshold(q.threshold),t,q=q.connectNulls||"percent"===r,L=function(c,f,h){var l=a[c];c=r&&u[l.x].points[d];var n=l[h+"Null"]||0;h=l[h+"Cliff"]||0;var t,m,l=!0;h||n?(t=(n?c[0]:c[1])+h,m=c[0]+h,l=!!n):!r&&a[f]&&a[f].isNull&&(t=m=p);void 0!==t&&(k.push({plotX:b,plotY:null===t?H:e.getThreshold(t),isNull:l,isCliff:!0}),z.push({plotX:b,plotY:null===m?H:e.getThreshold(m),doCurve:!1}))};a=a||this.points;r&&(a=this.getStackPoints(a));for(c=0;c<a.length;c++)if(l=a[c].isNull,b=m(a[c].rectPlotX,
a[c].plotX),t=m(a[c].yBottom,H),!l||q)q||L(c,c-1,"left"),l&&!r&&q||(k.push(a[c]),z.push({x:c,plotX:b,plotY:t})),q||L(c,c+1,"right");c=f.call(this,k,!0,!0);z.reversed=!0;l=f.call(this,z,!0,!0);l.length&&(l[0]="L");l=c.concat(l);f=f.call(this,k,!1,q);l.xMap=c.xMap;this.areaPath=l;return f},drawGraph:function(){this.areaPath=[];h.prototype.drawGraph.apply(this);var a=this,f=this.areaPath,q=this.options,w=[["area","highcharts-area",this.color,q.fillColor]];D(this.zones,function(e,c){w.push(["zone-area-"+
c,"highcharts-area highcharts-zone-area-"+c+" "+e.className,e.color||a.color,e.fillColor||q.fillColor])});D(w,function(e){var c=e[0],h=a[c];h?(h.endX=a.preventGraphAnimation?null:f.xMap,h.animate({d:f})):(h=a[c]=a.chart.renderer.path(f).addClass(e[1]).attr({fill:m(e[3],C(e[2]).setOpacity(m(q.fillOpacity,.75)).get()),zIndex:0}).add(a.group),h.isArea=!0);h.startX=f.xMap;h.shiftUnit=q.step?2:1})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(K);(function(a){var C=a.pick;a=a.seriesType;a("spline",
"line",{},{getPointSpline:function(a,E,m){var h=E.plotX,f=E.plotY,r=a[m-1];m=a[m+1];var y,q,w,e;if(r&&!r.isNull&&!1!==r.doCurve&&!E.isCliff&&m&&!m.isNull&&!1!==m.doCurve&&!E.isCliff){a=r.plotY;w=m.plotX;m=m.plotY;var c=0;y=(1.5*h+r.plotX)/2.5;q=(1.5*f+a)/2.5;w=(1.5*h+w)/2.5;e=(1.5*f+m)/2.5;w!==y&&(c=(e-q)*(w-h)/(w-y)+f-e);q+=c;e+=c;q>a&&q>f?(q=Math.max(a,f),e=2*f-q):q<a&&q<f&&(q=Math.min(a,f),e=2*f-q);e>m&&e>f?(e=Math.max(m,f),q=2*f-e):e<m&&e<f&&(e=Math.min(m,f),q=2*f-e);E.rightContX=w;E.rightContY=
e}E=["C",C(r.rightContX,r.plotX),C(r.rightContY,r.plotY),C(y,h),C(q,f),h,f];r.rightContX=r.rightContY=null;return E}})})(K);(function(a){var C=a.seriesTypes.area.prototype,D=a.seriesType;D("areaspline","spline",a.defaultPlotOptions.area,{getStackPoints:C.getStackPoints,getGraphPath:C.getGraphPath,drawGraph:C.drawGraph,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(K);(function(a){var C=a.animObject,D=a.color,E=a.each,m=a.extend,h=a.isNumber,f=a.merge,r=a.pick,y=a.Series,q=a.seriesType,w=a.svg;
q("column","line",{borderRadius:0,crisp:!0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1},select:{color:"#cccccc",borderColor:"#000000"}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){y.prototype.init.apply(this,
arguments);var a=this,c=a.chart;c.hasRendered&&E(c.series,function(c){c.type===a.type&&(c.isDirty=!0)})},getColumnMetrics:function(){var a=this,c=a.options,f=a.xAxis,h=a.yAxis,k=f.options.reversedStacks,k=f.reversed&&!k||!f.reversed&&k,d,b={},m=0;!1===c.grouping?m=1:E(a.chart.series,function(c){var e=c.options,f=c.yAxis,k;c.type!==a.type||!c.visible&&a.chart.options.chart.ignoreHiddenSeries||h.len!==f.len||h.pos!==f.pos||(e.stacking?(d=c.stackKey,void 0===b[d]&&(b[d]=m++),k=b[d]):!1!==e.grouping&&
(k=m++),c.columnIndex=k)});var p=Math.min(Math.abs(f.transA)*(f.ordinalSlope||c.pointRange||f.closestPointRange||f.tickInterval||1),f.len),q=p*c.groupPadding,t=(p-2*q)/(m||1),c=Math.min(c.maxPointWidth||f.len,r(c.pointWidth,t*(1-2*c.pointPadding)));a.columnMetrics={width:c,offset:(t-c)/2+(q+((a.columnIndex||0)+(k?1:0))*t-p/2)*(k?-1:1)};return a.columnMetrics},crispCol:function(a,c,f,h){var e=this.chart,d=this.borderWidth,b=-(d%2?.5:0),d=d%2?.5:1;e.inverted&&e.renderer.isVML&&(d+=1);this.options.crisp&&
(f=Math.round(a+f)+b,a=Math.round(a)+b,f-=a);h=Math.round(c+h)+d;b=.5>=Math.abs(c)&&.5<h;c=Math.round(c)+d;h-=c;b&&h&&(--c,h+=1);return{x:a,y:c,width:f,height:h}},translate:function(){var a=this,c=a.chart,f=a.options,h=a.dense=2>a.closestPointRange*a.xAxis.transA,h=a.borderWidth=r(f.borderWidth,h?0:1),k=a.yAxis,d=f.threshold,b=a.translatedThreshold=k.getThreshold(d),m=r(f.minPointLength,5),p=a.getColumnMetrics(),q=p.width,t=a.barW=Math.max(q,1+2*h),w=a.pointXOffset=p.offset;c.inverted&&(b-=.5);f.pointPadding&&
(t=Math.ceil(t));y.prototype.translate.apply(a);E(a.points,function(e){var f=r(e.yBottom,b),h=999+Math.abs(f),h=Math.min(Math.max(-h,e.plotY),k.len+h),l=e.plotX+w,p=t,u=Math.min(h,f),x,g=Math.max(h,f)-u;m&&Math.abs(g)<m&&(g=m,x=!k.reversed&&!e.negative||k.reversed&&e.negative,e.y===d&&a.dataMax<=d&&k.min<d&&(x=!x),u=Math.abs(u-b)>m?f-m:b-(x?m:0));e.barX=l;e.pointWidth=q;e.tooltipPos=c.inverted?[k.len+k.pos-c.plotLeft-h,a.xAxis.len-l-p/2,g]:[l+p/2,h+k.pos-c.plotTop,g];e.shapeType="rect";e.shapeArgs=
a.crispCol.apply(a,e.isNull?[l,b,p,0]:[l,u,p,g])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(a,c){var e=this.options,h,k=this.pointAttrToOptions||{};h=k.stroke||"borderColor";var d=k["stroke-width"]||"borderWidth",b=a&&a.color||this.color,m=a&&a[h]||e[h]||this.color||b,p=a&&a[d]||e[d]||this[d]||0,k=e.dashStyle;a&&this.zones.length&&(b=a.getZone(),b=a.options.color||
b&&b.color||this.color);c&&(a=f(e.states[c],a.options.states&&a.options.states[c]||{}),c=a.brightness,b=a.color||void 0!==c&&D(b).brighten(a.brightness).get()||b,m=a[h]||m,p=a[d]||p,k=a.dashStyle||k);h={fill:b,stroke:m,"stroke-width":p};k&&(h.dashstyle=k);return h},drawPoints:function(){var a=this,c=this.chart,l=a.options,m=c.renderer,k=l.animationLimit||250,d;E(a.points,function(b){var e=b.graphic,p=e&&c.pointCount<k?"animate":"attr";if(h(b.plotY)&&null!==b.y){d=b.shapeArgs;if(e)e[p](f(d));else b.graphic=
e=m[b.shapeType](d).add(b.group||a.group);l.borderRadius&&e.attr({r:l.borderRadius});e[p](a.pointAttribs(b,b.selected&&"select")).shadow(l.shadow,null,l.stacking&&!l.borderRadius);e.addClass(b.getClassName(),!0)}else e&&(b.graphic=e.destroy())})},animate:function(a){var c=this,f=this.yAxis,e=c.options,k=this.chart.inverted,d={},b=k?"translateX":"translateY",h;w&&(a?(d.scaleY=.001,a=Math.min(f.pos+f.len,Math.max(f.pos,f.toPixels(e.threshold))),k?d.translateX=a-f.len:d.translateY=a,c.group.attr(d)):
(h=c.group.attr(b),c.group.animate({scaleY:1},m(C(c.options.animation),{step:function(a,e){d[b]=h+e.pos*(f.pos-h);c.group.attr(d)}})),c.animate=null))},remove:function(){var a=this,c=a.chart;c.hasRendered&&E(c.series,function(c){c.type===a.type&&(c.isDirty=!0)});y.prototype.remove.apply(a,arguments)}})})(K);(function(a){a=a.seriesType;a("bar","column",null,{inverted:!0})})(K);(function(a){var C=a.Series;a=a.seriesType;a("scatter","line",{lineWidth:0,findNearestPointBy:"xy",marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 0.85em"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',
pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&C.prototype.drawGraph.call(this)}})})(K);(function(a){var C=a.deg2rad,D=a.isNumber,E=a.pick,m=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,f=this.chart,r=2*(a.slicedOffset||0),y=f.plotWidth-2*r,
f=f.plotHeight-2*r,q=a.center,q=[E(q[0],"50%"),E(q[1],"50%"),a.size||"100%",a.innerSize||0],w=Math.min(y,f),e,c;for(e=0;4>e;++e)c=q[e],a=2>e||2===e&&/%$/.test(c),q[e]=m(c,[y,f,w,q[2]][e])+(a?r:0);q[3]>q[2]&&(q[3]=q[2]);return q},getStartAndEndRadians:function(a,f){a=D(a)?a:0;f=D(f)&&f>a&&360>f-a?f:a+360;return{start:C*(a+-90),end:C*(f+-90)}}}})(K);(function(a){var C=a.addEvent,D=a.CenteredSeriesMixin,E=a.defined,m=a.each,h=a.extend,f=D.getStartAndEndRadians,r=a.inArray,y=a.noop,q=a.pick,w=a.Point,
e=a.Series,c=a.seriesType,l=a.setAnimation;c("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{allowOverlap:!0,distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,states:{hover:{brightness:.1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,
trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:a.seriesTypes.column.prototype.pointAttribs,animate:function(a){var c=this,d=c.points,b=c.startAngleRad;a||(m(d,function(a){var d=a.graphic,f=a.shapeArgs;d&&(d.attr({r:a.startR||c.center[3]/2,start:b,end:b}),d.animate({r:f.r,start:f.start,end:f.end},c.options.animation))}),c.animate=null)},updateTotals:function(){var a,c=0,d=this.points,b=d.length,f,e=this.options.ignoreHiddenPoint;for(a=0;a<b;a++)f=d[a],c+=e&&!f.visible?0:f.isNull?
0:f.y;this.total=c;for(a=0;a<b;a++)f=d[a],f.percentage=0<c&&(f.visible||!e)?f.y/c*100:0,f.total=c},generatePoints:function(){e.prototype.generatePoints.call(this);this.updateTotals()},translate:function(a){this.generatePoints();var c=0,d=this.options,b=d.slicedOffset,e=b+(d.borderWidth||0),h,l,t,m=f(d.startAngle,d.endAngle),x=this.startAngleRad=m.start,m=(this.endAngleRad=m.end)-x,r=this.points,n,w=d.dataLabels.distance,d=d.ignoreHiddenPoint,z,y=r.length,F;a||(this.center=a=this.getCenter());this.getX=
function(b,c,d){t=Math.asin(Math.min((b-a[1])/(a[2]/2+d.labelDistance),1));return a[0]+(c?-1:1)*Math.cos(t)*(a[2]/2+d.labelDistance)};for(z=0;z<y;z++){F=r[z];F.labelDistance=q(F.options.dataLabels&&F.options.dataLabels.distance,w);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,F.labelDistance);h=x+c*m;if(!d||F.visible)c+=F.percentage/100;l=x+c*m;F.shapeType="arc";F.shapeArgs={x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*h)/1E3,end:Math.round(1E3*l)/1E3};t=(l+h)/2;t>1.5*Math.PI?
t-=2*Math.PI:t<-Math.PI/2&&(t+=2*Math.PI);F.slicedTranslation={translateX:Math.round(Math.cos(t)*b),translateY:Math.round(Math.sin(t)*b)};l=Math.cos(t)*a[2]/2;n=Math.sin(t)*a[2]/2;F.tooltipPos=[a[0]+.7*l,a[1]+.7*n];F.half=t<-Math.PI/2||t>Math.PI/2?1:0;F.angle=t;h=Math.min(e,F.labelDistance/5);F.labelPos=[a[0]+l+Math.cos(t)*F.labelDistance,a[1]+n+Math.sin(t)*F.labelDistance,a[0]+l+Math.cos(t)*h,a[1]+n+Math.sin(t)*h,a[0]+l,a[1]+n,0>F.labelDistance?"center":F.half?"right":"left",t]}},drawGraph:null,
drawPoints:function(){var a=this,c=a.chart.renderer,d,b,f,e,l=a.options.shadow;l&&!a.shadowGroup&&(a.shadowGroup=c.g("shadow").add(a.group));m(a.points,function(k){b=k.graphic;if(k.isNull)b&&(k.graphic=b.destroy());else{e=k.shapeArgs;d=k.getTranslate();var t=k.shadowGroup;l&&!t&&(t=k.shadowGroup=c.g("shadow").add(a.shadowGroup));t&&t.attr(d);f=a.pointAttribs(k,k.selected&&"select");b?b.setRadialReference(a.center).attr(f).animate(h(e,d)):(k.graphic=b=c[k.shapeType](e).setRadialReference(a.center).attr(d).add(a.group),
b.attr(f).attr({"stroke-linejoin":"round"}).shadow(l,t));b.attr({visibility:k.visible?"inherit":"hidden"});b.addClass(k.getClassName())}})},searchPoint:y,sortByAngle:function(a,c){a.sort(function(a,b){return void 0!==a.angle&&(b.angle-a.angle)*c})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,getCenter:D.getCenter,getSymbol:y},{init:function(){w.prototype.init.apply(this,arguments);var a=this,c;a.name=q(a.name,"Slice");c=function(c){a.slice("select"===c.type)};C(a,"select",c);C(a,"unselect",
c);return a},isValid:function(){return a.isNumber(this.y,!0)&&0<=this.y},setVisible:function(a,c){var d=this,b=d.series,f=b.chart,e=b.options.ignoreHiddenPoint;c=q(c,e);a!==d.visible&&(d.visible=d.options.visible=a=void 0===a?!d.visible:a,b.options.data[r(d,b.data)]=d.options,m(["graphic","dataLabel","connector","shadowGroup"],function(b){if(d[b])d[b][a?"show":"hide"](!0)}),d.legendItem&&f.legend.colorizeItem(d,a),a||"hover"!==d.state||d.setState(""),e&&(b.isDirty=!0),c&&f.redraw())},slice:function(a,
c,d){var b=this.series;l(d,b.chart);q(c,!0);this.sliced=this.options.sliced=E(a)?a:!this.sliced;b.options.data[r(this,b.data)]=this.options;this.graphic.animate(this.getTranslate());this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(a){var c=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(c.x,c.y,c.r+a,c.r+a,{innerR:this.shapeArgs.r-
1,start:c.start,end:c.end})}})})(K);(function(a){var C=a.addEvent,D=a.arrayMax,E=a.defined,m=a.each,h=a.extend,f=a.format,r=a.map,y=a.merge,q=a.noop,w=a.pick,e=a.relativeLength,c=a.Series,l=a.seriesTypes,z=a.some,k=a.stableSort;a.distribute=function(c,b,f){function d(a,b){return a.target-b.target}var e,h=!0,l=c,x=[],q;q=0;var n=l.reducedLen||b;for(e=c.length;e--;)q+=c[e].size;if(q>n){k(c,function(a,b){return(b.rank||0)-(a.rank||0)});for(q=e=0;q<=n;)q+=c[e].size,e++;x=c.splice(e-1,c.length)}k(c,d);
for(c=r(c,function(a){return{size:a.size,targets:[a.target],align:w(a.align,.5)}});h;){for(e=c.length;e--;)h=c[e],q=(Math.min.apply(0,h.targets)+Math.max.apply(0,h.targets))/2,h.pos=Math.min(Math.max(0,q-h.size*h.align),b-h.size);e=c.length;for(h=!1;e--;)0<e&&c[e-1].pos+c[e-1].size>c[e].pos&&(c[e-1].size+=c[e].size,c[e-1].targets=c[e-1].targets.concat(c[e].targets),c[e-1].align=.5,c[e-1].pos+c[e-1].size>b&&(c[e-1].pos=b-c[e-1].size),c.splice(e,1),h=!0)}l.push.apply(l,x);e=0;z(c,function(c){var d=
0;if(z(c.targets,function(){l[e].pos=c.pos+d;if(Math.abs(l[e].pos-l[e].target)>f)return m(l.slice(0,e+1),function(a){delete a.pos}),l.reducedLen=(l.reducedLen||b)-.1*b,l.reducedLen>.1*b&&a.distribute(l,b,f),!0;d+=l[e].size;e++}))return!0});k(l,d)};c.prototype.drawDataLabels=function(){function c(a,b){var c=b.filter;return c?(b=c.operator,a=a[c.property],c=c.value,"\x3e"===b&&a>c||"\x3c"===b&&a<c||"\x3e\x3d"===b&&a>=c||"\x3c\x3d"===b&&a<=c||"\x3d\x3d"===b&&a==c||"\x3d\x3d\x3d"===b&&a===c?!0:!1):!0}
var b=this,e=b.chart,k=b.options,h=k.dataLabels,l=b.points,q,x,r=b.hasRendered||0,n,z,B=w(h.defer,!!k.animation),D=e.renderer;if(h.enabled||b._hasPointLabels)b.dlProcessOptions&&b.dlProcessOptions(h),z=b.plotGroup("dataLabelsGroup","data-labels",B&&!r?"hidden":"visible",h.zIndex||6),B&&(z.attr({opacity:+r}),r||C(b,"afterAnimate",function(){b.visible&&z.show(!0);z[k.animation?"animate":"attr"]({opacity:1},{duration:200})})),x=h,m(l,function(d){var g,l=d.dataLabel,t,p,m=d.connector,u=!l,r;q=d.dlOptions||
d.options&&d.options.dataLabels;(g=w(q&&q.enabled,x.enabled)&&!d.isNull)&&(g=!0===c(d,q||h));g&&(h=y(x,q),t=d.getLabelConfig(),r=h[d.formatPrefix+"Format"]||h.format,n=E(r)?f(r,t,e.time):(h[d.formatPrefix+"Formatter"]||h.formatter).call(t,h),r=h.style,t=h.rotation,r.color=w(h.color,r.color,b.color,"#000000"),"contrast"===r.color&&(d.contrastColor=D.getContrast(d.color||b.color),r.color=h.inside||0>w(d.labelDistance,h.distance)||k.stacking?d.contrastColor:"#000000"),k.cursor&&(r.cursor=k.cursor),p=
{fill:h.backgroundColor,stroke:h.borderColor,"stroke-width":h.borderWidth,r:h.borderRadius||0,rotation:t,padding:h.padding,zIndex:1},a.objectEach(p,function(a,b){void 0===a&&delete p[b]}));!l||g&&E(n)?g&&E(n)&&(l?p.text=n:(l=d.dataLabel=t?D.text(n,0,-9999,h.useHTML).addClass("highcharts-data-label"):D.label(n,0,-9999,h.shape,null,null,h.useHTML,null,"data-label"),l.addClass(" highcharts-data-label-color-"+d.colorIndex+" "+(h.className||"")+(h.useHTML?" highcharts-tracker":""))),l.attr(p),l.css(r).shadow(h.shadow),
l.added||l.add(z),b.alignDataLabel(d,l,h,null,u)):(d.dataLabel=l=l.destroy(),m&&(d.connector=m.destroy()))});a.fireEvent(this,"afterDrawDataLabels")};c.prototype.alignDataLabel=function(a,b,c,e,f){var d=this.chart,k=d.inverted,l=w(a.dlBox&&a.dlBox.centerX,a.plotX,-9999),m=w(a.plotY,-9999),n=b.getBBox(),p,q=c.rotation,r=c.align,u=this.visible&&(a.series.forceDL||d.isInsidePlot(l,Math.round(m),k)||e&&d.isInsidePlot(l,k?e.x+1:e.y+e.height-1,k)),g="justify"===w(c.overflow,"justify");if(u&&(p=c.style.fontSize,
p=d.renderer.fontMetrics(p,b).b,e=h({x:k?this.yAxis.len-m:l,y:Math.round(k?this.xAxis.len-l:m),width:0,height:0},e),h(c,{width:n.width,height:n.height}),q?(g=!1,l=d.renderer.rotCorr(p,q),l={x:e.x+c.x+e.width/2+l.x,y:e.y+c.y+{top:0,middle:.5,bottom:1}[c.verticalAlign]*e.height},b[f?"attr":"animate"](l).attr({align:r}),m=(q+720)%360,m=180<m&&360>m,"left"===r?l.y-=m?n.height:0:"center"===r?(l.x-=n.width/2,l.y-=n.height/2):"right"===r&&(l.x-=n.width,l.y-=m?0:n.height),b.placed=!0,b.alignAttr=l):(b.align(c,
null,e),l=b.alignAttr),g&&0<=e.height?a.isLabelJustified=this.justifyDataLabel(b,c,l,n,e,f):w(c.crop,!0)&&(u=d.isInsidePlot(l.x,l.y)&&d.isInsidePlot(l.x+n.width,l.y+n.height)),c.shape&&!q))b[f?"attr":"animate"]({anchorX:k?d.plotWidth-a.plotY:a.plotX,anchorY:k?d.plotHeight-a.plotX:a.plotY});u||(b.attr({y:-9999}),b.placed=!1)};c.prototype.justifyDataLabel=function(a,b,c,e,f,k){var d=this.chart,h=b.align,l=b.verticalAlign,n,m,t=a.box?0:a.padding||0;n=c.x+t;0>n&&("right"===h?b.align="left":b.x=-n,m=!0);
n=c.x+e.width-t;n>d.plotWidth&&("left"===h?b.align="right":b.x=d.plotWidth-n,m=!0);n=c.y+t;0>n&&("bottom"===l?b.verticalAlign="top":b.y=-n,m=!0);n=c.y+e.height-t;n>d.plotHeight&&("top"===l?b.verticalAlign="bottom":b.y=d.plotHeight-n,m=!0);m&&(a.placed=!k,a.align(b,null,f));return m};l.pie&&(l.pie.prototype.drawDataLabels=function(){var d=this,b=d.data,e,f=d.chart,k=d.options.dataLabels,h=w(k.connectorPadding,10),l=w(k.connectorWidth,1),q=f.plotWidth,r=f.plotHeight,n=Math.round(f.chartWidth/3),y,z=
d.center,C=z[2]/2,F=z[1],g,v,K,Q,J=[[],[]],O,N,A,R,S=[0,0,0,0];d.visible&&(k.enabled||d._hasPointLabels)&&(m(b,function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),c.prototype.drawDataLabels.apply(d),m(b,function(a){a.dataLabel&&(a.visible?(J[a.half].push(a),a.dataLabel._pos=null,!E(k.style.width)&&!E(a.options.dataLabels&&a.options.dataLabels.style&&a.options.dataLabels.style.width)&&a.dataLabel.getBBox().width>
n&&(a.dataLabel.css({width:.7*n}),a.dataLabel.shortened=!0)):a.dataLabel=a.dataLabel.destroy())}),m(J,function(b,c){var l,n,t=b.length,p=[],x;if(t)for(d.sortByAngle(b,c-.5),0<d.maxLabelDistance&&(l=Math.max(0,F-C-d.maxLabelDistance),n=Math.min(F+C+d.maxLabelDistance,f.plotHeight),m(b,function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,F-C-a.labelDistance),a.bottom=Math.min(F+C+a.labelDistance,f.plotHeight),x=a.dataLabel.getBBox().height||21,a.distributeBox={target:a.labelPos[1]-a.top+x/
2,size:x,rank:a.y},p.push(a.distributeBox))}),l=n+x-l,a.distribute(p,l,l/5)),R=0;R<t;R++)e=b[R],K=e.labelPos,g=e.dataLabel,A=!1===e.visible?"hidden":"inherit",N=l=K[1],p&&E(e.distributeBox)&&(void 0===e.distributeBox.pos?A="hidden":(Q=e.distributeBox.size,N=e.top+e.distributeBox.pos)),delete e.positionIndex,O=k.justify?z[0]+(c?-1:1)*(C+e.labelDistance):d.getX(N<e.top+2||N>e.bottom-2?l:N,c,e),g._attr={visibility:A,align:K[6]},g._pos={x:O+k.x+({left:h,right:-h}[K[6]]||0),y:N+k.y-10},K.x=O,K.y=N,w(k.crop,
!0)&&(v=g.getBBox().width,l=null,O-v<h&&1===c?(l=Math.round(v-O+h),S[3]=Math.max(l,S[3])):O+v>q-h&&0===c&&(l=Math.round(O+v-q+h),S[1]=Math.max(l,S[1])),0>N-Q/2?S[0]=Math.max(Math.round(-N+Q/2),S[0]):N+Q/2>r&&(S[2]=Math.max(Math.round(N+Q/2-r),S[2])),g.sideOverflow=l)}),0===D(S)||this.verifyDataLabelOverflow(S))&&(this.placeDataLabels(),l&&m(this.points,function(a){var b;y=a.connector;if((g=a.dataLabel)&&g._pos&&a.visible&&0<a.labelDistance){A=g._attr.visibility;if(b=!y)a.connector=y=f.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+
a.colorIndex+(a.className?" "+a.className:"")).add(d.dataLabelsGroup),y.attr({"stroke-width":l,stroke:k.connectorColor||a.color||"#666666"});y[b?"attr":"animate"]({d:d.connectorPath(a.labelPos)});y.attr("visibility",A)}else y&&(a.connector=y.destroy())}))},l.pie.prototype.connectorPath=function(a){var b=a.x,c=a.y;return w(this.options.dataLabels.softConnector,!0)?["M",b+("left"===a[6]?5:-5),c,"C",b,c,2*a[2]-a[4],2*a[3]-a[5],a[2],a[3],"L",a[4],a[5]]:["M",b+("left"===a[6]?5:-5),c,"L",a[2],a[3],"L",
a[4],a[5]]},l.pie.prototype.placeDataLabels=function(){m(this.points,function(a){var b=a.dataLabel;b&&a.visible&&((a=b._pos)?(b.sideOverflow&&(b._attr.width=b.getBBox().width-b.sideOverflow,b.css({width:b._attr.width+"px",textOverflow:(this.options.dataLabels.style||{}).textOverflow||"ellipsis"}),b.shortened=!0),b.attr(b._attr),b[b.moved?"animate":"attr"](a),b.moved=!0):b&&b.attr({y:-9999}))},this)},l.pie.prototype.alignDataLabel=q,l.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,
c=this.options,d=c.center,f=c.minSize||80,k,h=null!==c.size;h||(null!==d[0]?k=Math.max(b[2]-Math.max(a[1],a[3]),f):(k=Math.max(b[2]-a[1]-a[3],f),b[0]+=(a[3]-a[1])/2),null!==d[1]?k=Math.max(Math.min(k,b[2]-Math.max(a[0],a[2])),f):(k=Math.max(Math.min(k,b[2]-a[0]-a[2]),f),b[1]+=(a[0]-a[2])/2),k<b[2]?(b[2]=k,b[3]=Math.min(e(c.innerSize||0,k),k),this.translate(b),this.drawDataLabels&&this.drawDataLabels()):h=!0);return h});l.column&&(l.column.prototype.alignDataLabel=function(a,b,e,f,k){var d=this.chart.inverted,
h=a.series,l=a.dlBox||a.shapeArgs,m=w(a.below,a.plotY>w(this.translatedThreshold,h.yAxis.len)),n=w(e.inside,!!this.options.stacking);l&&(f=y(l),0>f.y&&(f.height+=f.y,f.y=0),l=f.y+f.height-h.yAxis.len,0<l&&(f.height-=l),d&&(f={x:h.yAxis.len-f.y-f.height,y:h.xAxis.len-f.x-f.width,width:f.height,height:f.width}),n||(d?(f.x+=m?0:f.width,f.width=0):(f.y+=m?f.height:0,f.height=0)));e.align=w(e.align,!d||n?"center":m?"right":"left");e.verticalAlign=w(e.verticalAlign,d||n?"middle":m?"top":"bottom");c.prototype.alignDataLabel.call(this,
a,b,e,f,k);a.isLabelJustified&&a.contrastColor&&a.dataLabel.css({color:a.contrastColor})})})(K);(function(a){var C=a.Chart,D=a.each,E=a.objectEach,m=a.pick;a=a.addEvent;a(C,"render",function(){var a=[];D(this.labelCollectors||[],function(f){a=a.concat(f())});D(this.yAxis||[],function(f){f.options.stackLabels&&!f.options.stackLabels.allowOverlap&&E(f.stacks,function(f){E(f,function(f){a.push(f.label)})})});D(this.series||[],function(f){var h=f.options.dataLabels,y=f.dataLabelCollections||["dataLabel"];
(h.enabled||f._hasPointLabels)&&!h.allowOverlap&&f.visible&&D(y,function(h){D(f.points,function(f){f[h]&&(f[h].labelrank=m(f.labelrank,f.shapeArgs&&f.shapeArgs.height),a.push(f[h]))})})});this.hideOverlappingLabels(a)});C.prototype.hideOverlappingLabels=function(a){var f=a.length,h=this.renderer,m,q,w,e,c,l,z=function(a,c,b,e,f,h,l,m){return!(f>a+b||f+l<a||h>c+e||h+m<c)};w=function(a){var c,b,e,f=2*(a.box?0:a.padding||0);e=0;if(a&&(!a.alignAttr||a.placed))return c=a.alignAttr||{x:a.attr("x"),y:a.attr("y")},
b=a.parentGroup,a.width||(e=a.getBBox(),a.width=e.width,a.height=e.height,e=h.fontMetrics(null,a.element).h),{x:c.x+(b.translateX||0),y:c.y+(b.translateY||0)-e,width:a.width-f,height:a.height-f}};for(q=0;q<f;q++)if(m=a[q])m.oldOpacity=m.opacity,m.newOpacity=1,m.absoluteBox=w(m);a.sort(function(a,c){return(c.labelrank||0)-(a.labelrank||0)});for(q=0;q<f;q++)for(l=(w=a[q])&&w.absoluteBox,m=q+1;m<f;++m)if(c=(e=a[m])&&e.absoluteBox,l&&c&&w!==e&&0!==w.newOpacity&&0!==e.newOpacity&&(c=z(l.x,l.y,l.width,
l.height,c.x,c.y,c.width,c.height)))(w.labelrank<e.labelrank?w:e).newOpacity=0;D(a,function(a){var c,b;a&&(b=a.newOpacity,a.oldOpacity!==b&&(a.alignAttr&&a.placed?(b?a.show(!0):c=function(){a.hide()},a.alignAttr.opacity=b,a[a.isOld?"animate":"attr"](a.alignAttr,null,c)):a.attr({opacity:b})),a.isOld=!0)})}})(K);(function(a){var C=a.addEvent,D=a.Chart,E=a.createElement,m=a.css,h=a.defaultOptions,f=a.defaultPlotOptions,r=a.each,y=a.extend,q=a.fireEvent,w=a.hasTouch,e=a.inArray,c=a.isObject,l=a.Legend,
z=a.merge,k=a.pick,d=a.Point,b=a.Series,u=a.seriesTypes,p=a.svg,H;H=a.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart.pointer,c=function(a){var c=b.getPointFromEvent(a);void 0!==c&&(b.isDirectTouch=!0,c.onMouseOver(a))};r(a.points,function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&(a.dataLabel.div?a.dataLabel.div.point=a:a.dataLabel.element.point=a)});a._hasTracking||(r(a.trackerGroups,function(d){if(a[d]){a[d].addClass("highcharts-tracker").on("mouseover",c).on("mouseout",
function(a){b.onTrackerMouseOut(a)});if(w)a[d].on("touchstart",c);a.options.cursor&&a[d].css(m).css({cursor:a.options.cursor})}}),a._hasTracking=!0);q(this,"afterDrawTracker")},drawTrackerGraph:function(){var a=this,b=a.options,c=b.trackByArea,d=[].concat(c?a.areaPath:a.graphPath),e=d.length,f=a.chart,h=f.pointer,k=f.renderer,l=f.options.tooltip.snap,g=a.tracker,m,u=function(){if(f.hoverSeries!==a)a.onMouseOver()},y="rgba(192,192,192,"+(p?.0001:.002)+")";if(e&&!c)for(m=e+1;m--;)"M"===d[m]&&d.splice(m+
1,0,d[m+1]-l,d[m+2],"L"),(m&&"M"===d[m]||m===e)&&d.splice(m,0,"L",d[m-2]+l,d[m-1]);g?g.attr({d:d}):a.graph&&(a.tracker=k.path(d).attr({"stroke-linejoin":"round",visibility:a.visible?"visible":"hidden",stroke:y,fill:c?y:"none","stroke-width":a.graph.strokeWidth()+(c?0:2*l),zIndex:2}).add(a.group),r([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",u).on("mouseout",function(a){h.onTrackerMouseOut(a)});b.cursor&&a.css({cursor:b.cursor});if(w)a.on("touchstart",u)}));
q(this,"afterDrawTracker")}};u.column&&(u.column.prototype.drawTracker=H.drawTrackerPoint);u.pie&&(u.pie.prototype.drawTracker=H.drawTrackerPoint);u.scatter&&(u.scatter.prototype.drawTracker=H.drawTrackerPoint);y(l.prototype,{setItemEvents:function(a,b,c){var e=this,f=e.chart.renderer.boxWrapper,h="highcharts-legend-"+(a instanceof d?"point":"series")+"-active";(c?b:a.legendGroup).on("mouseover",function(){a.setState("hover");f.addClass(h);b.css(e.options.itemHoverStyle)}).on("mouseout",function(){b.css(z(a.visible?
e.itemStyle:e.itemHiddenStyle));f.removeClass(h);a.setState()}).on("click",function(b){var c=function(){a.setVisible&&a.setVisible()};f.removeClass(h);b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,c):q(a,"legendItemClick",b,c)})},createCheckboxForItem:function(a){a.checkbox=E("input",{type:"checkbox",className:"highcharts-legend-checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);C(a.checkbox,"click",function(b){q(a.series||
a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})}});h.legend.itemStyle.cursor="pointer";y(D.prototype,{showResetZoom:function(){function a(){b.zoomOut()}var b=this,c=h.lang,d=b.options.chart.resetZoomButton,e=d.theme,f=e.states,k="chart"===d.relativeTo?null:"plotBox";q(this,"beforeShowResetZoom",null,function(){b.resetZoomButton=b.renderer.button(c.resetZoom,null,null,a,e,f&&f.hover).attr({align:d.position.align,title:c.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(d.position,
!1,k)})},zoomOut:function(){q(this,"selection",{resetSelection:!0},this.zoom)},zoom:function(a){var b,d=this.pointer,e=!1,f;!a||a.resetSelection?(r(this.axes,function(a){b=a.zoom()}),d.initiated=!1):r(a.xAxis.concat(a.yAxis),function(a){var c=a.axis;d[c.isXAxis?"zoomX":"zoomY"]&&(b=c.zoom(a.min,a.max),c.displayBtn&&(e=!0))});f=this.resetZoomButton;e&&!f?this.showResetZoom():!e&&c(f)&&(this.resetZoomButton=f.destroy());b&&this.redraw(k(this.options.chart.animation,a&&a.animation,100>this.pointCount))},
pan:function(a,b){var c=this,d=c.hoverPoints,e;d&&r(d,function(a){a.setState()});r("xy"===b?[1,0]:[1],function(b){b=c[b?"xAxis":"yAxis"][0];var d=b.horiz,f=a[d?"chartX":"chartY"],d=d?"mouseDownX":"mouseDownY",h=c[d],g=(b.pointRange||0)/2,k=b.reversed&&!c.inverted||!b.reversed&&c.inverted?-1:1,l=b.getExtremes(),n=b.toValue(h-f,!0)+g*k,k=b.toValue(h+b.len-f,!0)-g*k,m=k<n,h=m?k:n,n=m?n:k,k=Math.min(l.dataMin,g?l.min:b.toValue(b.toPixels(l.min)-b.minPixelPadding)),g=Math.max(l.dataMax,g?l.max:b.toValue(b.toPixels(l.max)+
b.minPixelPadding)),m=k-h;0<m&&(n+=m,h=k);m=n-g;0<m&&(n=g,h-=m);b.series.length&&h!==l.min&&n!==l.max&&(b.setExtremes(h,n,!1,!1,{trigger:"pan"}),e=!0);c[d]=f});e&&c.redraw(!1);m(c.container,{cursor:"move"})}});y(d.prototype,{select:function(a,b){var c=this,d=c.series,f=d.chart;a=k(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},function(){c.selected=c.options.selected=a;d.options.data[e(c,d.data)]=c.options;c.setState(a&&"select");b||r(f.getSelectedPoints(),function(a){a.selected&&
a!==c&&(a.selected=a.options.selected=!1,d.options.data[e(a,d.data)]=a.options,a.setState(""),a.firePointEvent("unselect"))})})},onMouseOver:function(a){var b=this.series.chart,c=b.pointer;a=a?c.normalize(a):c.getChartCoordinatesFromPoint(this,b.inverted);c.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");r(a.hoverPoints||[],function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var b=this,
c=z(b.series.options.point,b.options).events;b.events=c;a.objectEach(c,function(a,c){C(b,c,a)});this.hasImportedEvents=!0}},setState:function(a,b){var c=Math.floor(this.plotX),d=this.plotY,e=this.series,h=e.options.states[a||"normal"]||{},l=f[e.type].marker&&e.options.marker,m=l&&!1===l.enabled,p=l&&l.states&&l.states[a||"normal"]||{},g=!1===p.enabled,t=e.stateMarkerGraphic,r=this.marker||{},u=e.chart,w=e.halo,z,C=l&&e.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===
h.enabled||a&&(g||m&&!1===p.enabled)||a&&r.states&&r.states[a]&&!1===r.states[a].enabled)){C&&(z=e.markerAttribs(this,a));if(this.graphic)this.state&&this.graphic.removeClass("highcharts-point-"+this.state),a&&this.graphic.addClass("highcharts-point-"+a),this.graphic.animate(e.pointAttribs(this,a),k(u.options.chart.animation,h.animation)),z&&this.graphic.animate(z,k(u.options.chart.animation,p.animation,l.animation)),t&&t.hide();else{if(a&&p){l=r.symbol||e.symbol;t&&t.currentSymbol!==l&&(t=t.destroy());
if(t)t[b?"animate":"attr"]({x:z.x,y:z.y});else l&&(e.stateMarkerGraphic=t=u.renderer.symbol(l,z.x,z.y,z.width,z.height).add(e.markerGroup),t.currentSymbol=l);t&&t.attr(e.pointAttribs(this,a))}t&&(t[a&&u.isInsidePlot(c,d,u.inverted)?"show":"hide"](),t.element.point=this)}(c=h.halo)&&c.size?(w||(e.halo=w=u.renderer.path().add((this.graphic||t).parentGroup)),w.show()[b?"animate":"attr"]({d:this.haloPath(c.size)}),w.attr({"class":"highcharts-halo highcharts-color-"+k(this.colorIndex,e.colorIndex)+(this.className?
" "+this.className:""),zIndex:-1}),w.point=this,w.attr(y({fill:this.color||e.color,"fill-opacity":c.opacity},c.attributes))):w&&w.point&&w.point.haloPath&&w.animate({d:w.point.haloPath(0)},null,w.hide);this.state=a;q(this,"afterSetState")}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});y(b.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&q(this,"mouseOver");
this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&q(this,"mouseOut");!c||this.stickyTracking||c.shared&&!this.noSharedTooltip||c.hide();this.setState()},setState:function(a){var b=this,c=b.options,d=b.graph,e=c.states,f=c.lineWidth,c=0;a=a||"";if(b.state!==a&&(r([b.group,b.markerGroup,b.dataLabelsGroup],function(c){c&&(b.state&&c.removeClass("highcharts-series-"+
b.state),a&&c.addClass("highcharts-series-"+a))}),b.state=a,!e[a]||!1!==e[a].enabled)&&(a&&(f=e[a].lineWidth||f+(e[a].lineWidthPlus||0)),d&&!d.dashstyle))for(f={"stroke-width":f},d.animate(f,k(e[a||"normal"]&&e[a||"normal"].animation,b.chart.options.chart.animation));b["zone-graph-"+c];)b["zone-graph-"+c].attr(f),c+=1},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,f,h=d.options.chart.ignoreHiddenSeries,k=c.visible;f=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!k:
a)?"show":"hide";r(["group","dataLabelsGroup","markerGroup","tracker","tt"],function(a){if(c[a])c[a][f]()});if(d.hoverSeries===c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&r(d.series,function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});r(c.linkedSeries,function(b){b.setVisible(a,!1)});h&&(d.isDirtyBox=!0);q(c,f);!1!==b&&d.redraw()},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=
a=void 0===a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);q(this,a?"select":"unselect")},drawTracker:H.drawTrackerGraph})})(K);(function(a){var C=a.Chart,D=a.each,E=a.inArray,m=a.isArray,h=a.isObject,f=a.pick,r=a.splat;C.prototype.setResponsive=function(f){var h=this.options.responsive,m=[],e=this.currentResponsive;h&&h.rules&&D(h.rules,function(c){void 0===c._id&&(c._id=a.uniqueKey());this.matchResponsiveRule(c,m,f)},this);var c=a.merge.apply(0,a.map(m,function(c){return a.find(h.rules,
function(a){return a._id===c}).chartOptions})),m=m.toString()||void 0;m!==(e&&e.ruleIds)&&(e&&this.update(e.undoOptions,f),m?(this.currentResponsive={ruleIds:m,mergedOptions:c,undoOptions:this.currentOptions(c)},this.update(c,f)):this.currentResponsive=void 0)};C.prototype.matchResponsiveRule=function(a,h){var m=a.condition;(m.callback||function(){return this.chartWidth<=f(m.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=f(m.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=f(m.minWidth,0)&&this.chartHeight>=
f(m.minHeight,0)}).call(this)&&h.push(a._id)};C.prototype.currentOptions=function(f){function q(e,c,f,w){var k;a.objectEach(e,function(a,b){if(!w&&-1<E(b,["series","xAxis","yAxis"]))for(a=r(a),f[b]=[],k=0;k<a.length;k++)c[b][k]&&(f[b][k]={},q(a[k],c[b][k],f[b][k],w+1));else h(a)?(f[b]=m(a)?[]:{},q(a,c[b]||{},f[b],w+1)):f[b]=c[b]||null})}var w={};q(f,this.options,w,0);return w}})(K);return K});


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(273);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony export (binding) */ __webpack_require__.d(exports, "defaultMenuRenderer", function() { return menuRenderer; });
/* harmony export (binding) */ __webpack_require__.d(exports, "AsyncCreatable", function() { return AsyncCreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(exports, "Creatable", function() { return CreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(exports, "Value", function() { return Value; });
/* harmony export (binding) */ __webpack_require__.d(exports, "Option", function() { return Option; });
/* harmony export (binding) */ __webpack_require__.d(exports, "Async", function() { return Async; });
/* harmony export (binding) */ __webpack_require__.d(exports, "defaultArrowRenderer", function() { return arrowRenderer; });
/* harmony export (binding) */ __webpack_require__.d(exports, "defaultClearRenderer", function() { return clearRenderer; });
/* harmony export (binding) */ __webpack_require__.d(exports, "defaultFilterOptions", function() { return filterOptions; });






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
			var pref = document.addEventListener ? '' : 'on';

			document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
			document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false,
						focusedOption: null
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen,
					focusedOption: null
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (!this.props.closeOnSelect) {
				return;
			}
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value,
							values: valueArray
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'div',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator,
			    showNewOptionAtTop = _props2.showNewOptionAtTop;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					if (showNewOptionAtTop) {
						filteredOptions.unshift(this._createPlaceholderOption);
					} else {
						filteredOptions.push(this._createPlaceholderOption);
					}
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
	showNewOptionAtTop: true
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Where to show prompt/placeholder option text.
	// true: new option prompt at top of list (default)
	// false: new option prompt at bottom of list
	showNewOptionAtTop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ exports["default"] = Select$1;


/***/ },
/* 838 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var _prodInvariant = __webpack_require__(113);

var invariant = __webpack_require__(7);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var PooledClass = __webpack_require__(839);
var ReactElement = __webpack_require__(100);

var emptyFunction = __webpack_require__(59);
var traverseAllChildren = __webpack_require__(849);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ReactElement = __webpack_require__(100);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _require = __webpack_require__(100),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(272);

module.exports = factory(isValidElement);

/***/ },
/* 843 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

module.exports = '15.6.2';

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _require = __webpack_require__(297),
    Component = _require.Component;

var _require2 = __webpack_require__(100),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(300);
var factory = __webpack_require__(676);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 845 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ },
/* 846 */
/***/ function(module, exports) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
'use strict';

var _prodInvariant = __webpack_require__(113);

var ReactElement = __webpack_require__(100);

var invariant = __webpack_require__(7);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _prodInvariant = __webpack_require__(113);

var ReactCurrentOwner = __webpack_require__(65);
var REACT_ELEMENT_TYPE = __webpack_require__(299);

var getIteratorFn = __webpack_require__(845);
var invariant = __webpack_require__(7);
var KeyEscapeUtils = __webpack_require__(838);
var warning = __webpack_require__(17);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(678);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./ButtonGroup.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./ButtonGroup.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(679);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Button.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Button.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(680);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Card.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Card.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(681);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Checkbox.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Checkbox.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(682);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./ColorPicker.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./ColorPicker.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(683);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./DateTimePicker.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./DateTimePicker.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(684);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Details.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Details.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(685);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Dialog.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Dialog.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(686);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./DropdownMenu.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./DropdownMenu.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(687);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Form.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Form.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(688);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./icon.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./icon.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(689);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./InputWithUnit.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./InputWithUnit.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(690);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Input.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Input.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(691);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./IntervalEditor.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./IntervalEditor.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(692);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./List.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./List.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(693);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./LoginDialog.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./LoginDialog.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(694);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./MultiSelect.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./MultiSelect.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(695);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./MultiSelector.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./MultiSelector.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(696);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Pager.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Pager.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(697);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Picker.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Picker.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(698);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Pin.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Pin.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(699);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Popup.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Popup.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(700);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./ProgressBar.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./ProgressBar.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(701);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Select.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Select.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(702);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Spinner.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Spinner.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(703);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Tabs.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Tabs.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(704);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./TextFilter.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./TextFilter.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(705);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Toast.css", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./Toast.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(707);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./CreatePOIDialog.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./CreatePOIDialog.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(708);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./CriticalValueNotificationConfigForm.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./CriticalValueNotificationConfigForm.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(709);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./CriticalValueNotifications.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./CriticalValueNotifications.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(710);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./NotificationConfigCard.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./NotificationConfigCard.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(711);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./Dashboard.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./Dashboard.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(712);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./RightContainer.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./RightContainer.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(713);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./Bubble.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./Bubble.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(714);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./ContextMenu.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./ContextMenu.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(715);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./MapButton.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./MapButton.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(716);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./Tooltip.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./Tooltip.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(717);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./VehicleBubble.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./VehicleBubble.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(718);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./CollaboratorCard.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./CollaboratorCard.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(719);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./POICollaborators.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./POICollaborators.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(720);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./ShareDialog.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./ShareDialog.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(721);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./NotificationConfigCard.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./NotificationConfigCard.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(722);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./POICrossingNotificationConfigForm.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./POICrossingNotificationConfigForm.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(723);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./POICrossingNotifications.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./POICrossingNotifications.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(724);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./Filter.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./Filter.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(725);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./POIList.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./POIList.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(726);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./Summary.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./Summary.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(727);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./POIProperties.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./POIProperties.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(728);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./UserContacts.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./UserContacts.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(729);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./UserNotifications.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./UserNotifications.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(730);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./UserPassword.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./UserPassword.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(731);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehicleActivityChart.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehicleActivityChart.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(732);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./SectionCard.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./SectionCard.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(733);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./Section.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./Section.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(734);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehicleActivityTimeline.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehicleActivityTimeline.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(735);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehicleActivity.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehicleActivity.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(736);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehicleHeatmap.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehicleHeatmap.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(737);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./Filter.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./Filter.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(738);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./Summary.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./Summary.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(739);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/postcss-loader/index.js!./Table.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/postcss-loader/index.js!./Table.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(740);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehicleList.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehicleList.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(741);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./StayCard.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./StayCard.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(742);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehiclePOICrossingsStays.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehiclePOICrossingsStays.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(743);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./SummaryCard.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./SummaryCard.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(744);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehiclePOICrossingsSummaries.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehiclePOICrossingsSummaries.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(745);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./CrossingCard.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./CrossingCard.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(746);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehiclePOICrossingsTimeline.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehiclePOICrossingsTimeline.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(747);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./POISelector.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!./POISelector.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(748);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehiclePOICrossings.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehiclePOICrossings.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {


var content = __webpack_require__(749);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehicleProperties.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!./VehicleProperties.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ },
/* 921 */
/***/ function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ },
/* 922 */
/***/ function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Réteg_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 24 24\" enable-background=\"new 0 0 24 24\" xml:space=\"preserve\"><g><g><rect x=\"16.4\" y=\"17.1\" width=\"1.1\" height=\"2.4\"></rect><polygon points=\"17.1,11.6 19.5,14 19.4,15.3 21.2,15.3 21.2,13.9 19.8,12.5 19.8,7 20.5,7 20.5,5.6 17.1,5.6 \"></polygon></g><path d=\"M15.9,12V4h1V2h-10v2h1v8l-2,2v2h5.2v6h1.6v-6h5.2v-2L15.9,12z\"></path></g></svg>"

/***/ },
/* 923 */
/***/ function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Réteg_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 500 500\" enable-background=\"new 0 0 500 500\" xml:space=\"preserve\"><g><circle fill=\"#F69EA6\" cx=\"250\" cy=\"250\" r=\"169\"></circle><path fill=\"#EF4750\" d=\"M250,429c-98.7,0-179-80.3-179-179c0-98.7,80.3-179,179-179c98.7,0,179,80.3,179,179 C429,348.7,348.7,429,250,429z M250,90.9c-87.7,0-159.1,71.4-159.1,159.1S162.3,409.1,250,409.1S409.1,337.7,409.1,250 S337.7,90.9,250,90.9z\"></path></g></svg>"

/***/ },
/* 924 */
/***/ function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Réteg_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 500 500\" enable-background=\"new 0 0 500 500\" xml:space=\"preserve\"><g><polygon fill=\"#F69FA6\" points=\"212.4,416.5 293.5,281 351.6,360.9 417.8,259.7 333.5,147.3 190.5,82.4 80,196.7 80,348.7 \"></polygon><path fill=\"#EF4750\" d=\"M216.1,429.6L70,354.8V192.6L188.2,70.4L340,139.3l90,120.1l-78,119.2l-57.7-79.4L216.1,429.6z M90,342.6 l118.6,60.7l84.2-140.5l58.4,80.4l54.4-83.2L327,155.4l-134.3-61L90,200.7V342.6z\"></path></g></svg>"

/***/ },
/* 925 */
/***/ function(module, exports) {

module.exports = "<svg version=\"1.0\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 131.3 131.3\" enable-background=\"new 0 0 131.3 131.3\" xml:space=\"preserve\"><g><path fill=\"#FFFFFF\" d=\"M25.5,131.3H0V95.4C7.7,108.7,18.2,122.4,25.5,131.3z M55.9,64.4c0-12.1-9.8-22-22-22c-12.1,0-22,9.8-22,22 c0,12.1,9.8,22,22,22C46.1,86.3,55.9,76.5,55.9,64.4z M131.3,0v131.3H42.4C55.2,115.7,77.9,85.5,77.9,68 c0-24.3-19.7-43.9-43.9-43.9c-13.7,0-25.9,6.3-33.9,16V0H131.3z\"></path></g></svg>"

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

__webpack_require__(306);

__webpack_require__(305);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Dashboard = __webpack_require__(304);

var _Dashboard2 = _interopRequireDefault(_Dashboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.onload = function () {
	_reactDom2.default.render(_react2.default.createElement(_Dashboard2.default, { ref: function ref(_ref) {
			return window.app = _ref;
		} }), document.querySelector("#appContainer"));
};

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// ../www/dashboard/bundle.js